function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _construct(Parent, args, Class) {
    if (_is_native_reflect_construct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _set_prototype_of(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _to_array(arr) {
    return _array_with_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrap_native_super = function wrapNativeSuper(Class) {
        if (Class === null || !_is_native_function(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _get_prototype_of(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _set_prototype_of(Wrapper, Class);
    };
    return _wrap_native_super(Class);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var _Math;
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  background: ",
        ";\n  backdrop-filter: blur(",
        ");\n  -webkit-backdrop-filter: blur(",
        ");\n  box-shadow: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  background: ",
        ";\n  box-shadow: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  &:focus-visible {\n    outline: none;\n    box-shadow:\n      0 0 0 2px ",
        ",\n      0 0 0 4px ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  &:focus-visible {\n    outline: none;\n    box-shadow:\n      0 0 0 2px ",
        ",\n      0 0 0 4px ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.5; }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  0%, 100% {\n    transform: translateY(-25%);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  50% {\n    transform: translateY(0);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  background: ",
        ";\n  backdrop-filter: ",
        ";\n  -webkit-backdrop-filter: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: ",
        ";\n  box-shadow: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  width: 15rem;\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  padding: ",
        ";\n  border-bottom: 1px solid ",
        ";\n  cursor: move;\n  user-select: none;\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  padding: ",
        ";\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  font-size: 0.75rem;\n  color: ",
        ";\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  padding: 0.375rem 0.5rem;\n  border-radius: 6px;\n  border: 1px solid\n    ",
        ";\n  background: ",
        ";\n  color: ",
        ";\n  font-size: 0.8125rem;\n\n  &:focus {\n    outline: none;\n    border-color: ",
        ";\n  }\n\n  /*\n   * A field that cannot be edited must LOOK like it. Before this, the Name field disabled by an\n   * unreadable register was pixel-identical to the editable Capacity and Rotation fields beside it,\n   * while the design-system Combobox one field down greyed out correctly — two renderings of one\n   * state in a single panel. The data-muted arm carries read-only (which stays in the tab order so\n   * assistive tech can reach the reason); :disabled carries the mid-write arm. Theme values, no\n   * literals — the Planner keeps its own theme layer by design.\n   *\n   * NB no backticks in this comment: it sits inside a template literal, and one would end the CSS.\n   */\n  &:disabled,\n  &[data-muted='true'] {\n    background: ",
        ";\n    color: ",
        ";\n    cursor: not-allowed;\n  }\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  color: ",
        ";\n  font-size: 0.75rem;\n  line-height: 1.3;\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n\n  p {\n    margin: 0;\n  }\n"
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  margin-top: calc(-1 * ",
        ");\n"
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n\n  p {\n    margin: 0;\n  }\n"
    ]);
    _templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: center;\n  gap: ",
        ";\n  flex-shrink: 0;\n"
    ]);
    _templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: flex-start;\n  gap: ",
        ";\n"
    ]);
    _templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-wrap: ",
        ";\n  align-items: center;\n  gap: ",
        " ",
        ";\n  padding: 0.625rem 0.75rem;\n  flex-shrink: 0;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n  flex: ",
        ";\n  min-width: 0;\n  overflow-x: auto;\n"
    ]);
    _templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n"
    ]);
    _templateObject25 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  min-width: 0;\n  max-width: 100%;\n"
    ]);
    _templateObject26 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  width: 9rem;\n  flex-shrink: 0;\n"
    ]);
    _templateObject27 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  max-width: 100%;\n  padding: ",
        ";\n  ",
        "\n  pointer-events: auto;\n"
    ]);
    _templateObject28 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n"
    ]);
    _templateObject29 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  visibility: hidden;\n  pointer-events: none;\n  width: max-content;\n"
    ]);
    _templateObject30 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    _templateObject31 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _tagged_template_literal([
        "\n  margin-left: ",
        ";\n  font-variant-numeric: tabular-nums;\n"
    ]);
    _templateObject32 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: ",
        ";\n  min-width: 100%;\n"
    ]);
    _templateObject33 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _tagged_template_literal([
        "\n  margin: 0 0 ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject34 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  overflow: hidden;\n  margin-top: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: ",
        ";\n  max-height: 60vh;\n  cursor: crosshair;\n"
    ]);
    _templateObject35 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  border: 2px dashed ",
        ";\n  background: ",
        ";\n  pointer-events: none;\n"
    ]);
    _templateObject36 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = _tagged_template_literal([
        "\n  margin-top: ",
        ";\n"
    ]);
    _templateObject37 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  /* Above everything, like a tooltip: it is a transient layer following the pointer. */\n  z-index: ",
        ";\n  pointer-events: none;\n  display: inline-flex;\n  align-items: center;\n  gap: ",
        ";\n  max-width: 200px;\n  padding: ",
        " ",
        ";\n  background: ",
        ";\n  border-radius: ",
        ";\n  box-shadow: ",
        ";\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject38 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = _tagged_template_literal([
        "\n  min-width: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject39 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = _tagged_template_literal([
        "\n  width: 300px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow-y: auto;\n  background: ",
        ";\n  border-right: 1px solid ",
        ";\n  padding: ",
        ";\n  box-sizing: border-box;\n\n  /* Inside the list panel (floor-plan-glass R4): the panel's glass is the surface, and it fills the\n     panel's body, which it scrolls. */\n  &[data-in-list-panel] {\n    width: auto;\n    flex: 1 1 0;\n    background: transparent;\n    border-right: 0;\n  }\n"
    ]);
    _templateObject40 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject41 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"
    ]);
    _templateObject42 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: center;\n  gap: ",
        ";\n  margin: 0;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  font-weight: ",
        ";\n  letter-spacing: ",
        ";\n  text-transform: uppercase;\n  color: ",
        ";\n"
    ]);
    _templateObject43 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject44 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = _tagged_template_literal([
        "\n  margin-top: ",
        ";\n"
    ]);
    _templateObject45 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject46 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: ",
        ";\n  pointer-events: none;\n"
    ]);
    _templateObject47 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: flex-end;\n"
    ]);
    _templateObject48 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  margin: ",
        " 0 ",
        " ",
        ";\n  padding: ",
        ";\n  border-radius: ",
        ";\n  background: ",
        ";\n  box-shadow: ",
        ";\n"
    ]);
    _templateObject49 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n\n  .label {\n    color: ",
        ";\n  }\n  .value {\n    font-weight: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject50 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: ",
        ";\n"
    ]);
    _templateObject51 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n"
    ]);
    _templateObject52 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = _tagged_template_literal([
        "\n  margin: 0;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject53 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n"
    ]);
    _templateObject54 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject55 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = _tagged_template_literal([
        "\n  margin: 0;\n  font-size: ",
        ";\n  line-height: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject56 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = _tagged_template_literal([
        "\n  margin: 0;\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject57 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = _tagged_template_literal([
        "\n  margin: 0;\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject58 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject59 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject60() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n"
    ]);
    _templateObject60 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject61() {
    var data = _tagged_template_literal([
        "\n  > [role='group'] {\n    flex-wrap: nowrap;\n  }\n\n  > [role='group'] > * {\n    flex: 1 1 0;\n    justify-content: center;\n  }\n"
    ]);
    _templateObject61 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject62() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  /* Sit just below the fullscreen button (top-right, 36px tall), leaving the\n     bottom-right corner free for host controls (e.g. onboarding's Next). */\n  top: calc(",
        " + 36px + ",
        ");\n  right: ",
        ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: calc(",
        " / 2);\n  padding: ",
        ";\n  ",
        "\n  z-index: ",
        ";\n"
    ]);
    _templateObject62 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject63() {
    var data = _tagged_template_literal([
        "\n  width: 32px;\n  height: 30px;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* Transparent at rest, so forced colours below can draw it without moving anything. */\n  border: 1px solid transparent;\n  border-radius: ",
        ";\n  color: ",
        ";\n  background: ",
        ";\n  box-shadow: ",
        ";\n  cursor: pointer;\n  transition:\n    background ",
        ",\n    color ",
        ";\n\n  &:hover:not([aria-disabled='true']) {\n    color: ",
        ";\n    background: ",
        ";\n  }\n\n  /*\n   * The token ring is a box-shadow, which forced colours removes. The TRANSPARENT outline beside it\n   * draws nothing in normal colours and is painted in the system colour in forced colours, so a\n   * keyboard user in high contrast still sees where focus is — without the armed state's rules\n   * below claiming the outline (that would trade one defect for another).\n   */\n  &:focus-visible {\n    outline: 2px solid transparent;\n    outline-offset: 1px;\n    box-shadow: ",
        ";\n  }\n\n  /*\n   * Unavailable: the GLYPH fades, never the button. Unavailable tools stay focusable\n   * (aria-disabled), so a faded button would fade its own focus ring with it — on Undo and Redo,\n   * the first two tabs of every arrival (review, 2026-10-13).\n   */\n  &[aria-disabled='true'] {\n    cursor: not-allowed;\n  }\n  &[aria-disabled='true'] > * {\n    opacity: 0.4;\n  }\n\n  /*\n   * The armed tool, for a sighted user whose operating system has thrown our colours away.\n   *\n   * Everything $active changes above is colour — exactly what Windows High Contrast overrides — so\n   * in forced colours the armed button and a disarmed one would be painted identically, and the only\n   * surviving signal would be aria-pressed, which reaches assistive technology and not a person\n   * looking at the screen. Two signals, both of which survive the substitution: Highlight /\n   * HighlightText, the conventional selected pair, and a DASHED border, since border style is one of\n   * the few things forced colours leaves alone. The border is 1px at rest too, so nothing moves.\n   *\n   * The system colours here must NOT be tokenised: the operating system substitutes them by\n   * definition, which is the whole reason for using them. The glyphs paint with currentColor, so\n   * they follow the text colour onto the highlight.\n   */\n  @media (forced-colors: active) {\n    border-color: ButtonText;\n    border-style: ",
        ";\n    background: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject63 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject64() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  padding: calc(",
        " / 2) 0;\n  text-align: center;\n  font-variant-numeric: tabular-nums;\n"
    ]);
    _templateObject64 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject65() {
    var data = _tagged_template_literal([
        "\n  width: 20px;\n  height: 1px;\n  background: ",
        ";\n  margin: calc(",
        " * 0.75) 0;\n\n  @media (forced-colors: active) {\n    background: ButtonText;\n  }\n"
    ]);
    _templateObject65 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject66() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  left: ",
        ";\n  bottom: ",
        ";\n  box-sizing: border-box;\n  max-width: calc(100% - ",
        " * 2);\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  column-gap: ",
        ";\n  row-gap: ",
        ";\n  padding: ",
        " ",
        ";\n  ",
        "\n  pointer-events: none;\n  z-index: ",
        ";\n"
    ]);
    _templateObject66 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject67() {
    var data = _tagged_template_literal([
        "\n  pointer-events: auto;\n"
    ]);
    _templateObject67 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject68() {
    var data = _tagged_template_literal([
        "\n  margin: ",
        ";\n"
    ]);
    _templateObject68 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject69() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject69 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject70() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject70 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject71() {
    var data = _tagged_template_literal([
        "\n      border-color: ",
        ";\n      background: ",
        ";\n    "
    ]);
    _templateObject71 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject72() {
    var data = _tagged_template_literal([
        "\n      border-color: ",
        ";\n      background: ",
        ";\n    "
    ]);
    _templateObject72 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject73() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  padding: ",
        ";\n  margin: ",
        ";\n  border-radius: 6px;\n  border: 1px solid ",
        ";\n  background: ",
        ";\n  cursor: grab;\n  transition: all ",
        ";\n\n  &:active {\n    cursor: grabbing;\n  }\n\n  &:hover {\n    border-color: ",
        ";\n    box-shadow: ",
        ";\n  }\n\n  /* The keyboard route to selecting a machine (planner-free-rotation). The tight ring rather than the\n     full ring because the card sits in a scrolling list, where the bloom would be clipped. */\n  &:focus-visible {\n    outline: none;\n    box-shadow: ",
        ";\n  }\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject73 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject74() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: ",
        ";\n  min-width: 0;\n"
    ]);
    _templateObject74 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject75() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject75 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject76() {
    var data = _tagged_template_literal([
        "\n  margin: ",
        ";\n  border-radius: ",
        ";\n  border: 1px solid ",
        ";\n  background: ",
        ";\n  overflow: hidden;\n"
    ]);
    _templateObject76 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject77() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  width: 100%;\n  padding: ",
        ";\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  text-align: left;\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject77 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject78() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject78 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject79() {
    var data = _tagged_template_literal([
        "\n  margin: ",
        ";\n"
    ]);
    _templateObject79 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject80() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  width: 100%;\n  padding: ",
        ";\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  text-align: left;\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject80 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject81() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject81 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject82() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  flex-shrink: 0;\n  color: ",
        ";\n  transition: transform ",
        ";\n  transform: rotate(",
        ");\n\n  svg {\n    width: 16px;\n    height: 16px;\n  }\n"
    ]);
    _templateObject82 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject83() {
    var data = _tagged_template_literal([
        "\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding-bottom: ",
        ";\n"
    ]);
    _templateObject83 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject84() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  flex-shrink: 0;\n  padding: ",
        ";\n"
    ]);
    _templateObject84 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject85() {
    var data = _tagged_template_literal([
        "\n  flex-shrink: 0;\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject85 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject86() {
    var data = _tagged_template_literal([
        "\n  flex: 1;\n  min-width: 0;\n"
    ]);
    _templateObject86 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject87() {
    var data = _tagged_template_literal([
        "\n  margin: 0;\n  padding: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject87 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject88() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n"
    ]);
    _templateObject88 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject89() {
    var data = _tagged_template_literal([
        "\n  flex: 1;\n  overflow-y: auto;\n  padding-bottom: ",
        ";\n"
    ]);
    _templateObject89 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject90() {
    var data = _tagged_template_literal([
        "\n  padding: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject90 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject91() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  padding: ",
        ";\n  margin: ",
        ";\n  border-radius: 6px;\n  border: 1px dashed ",
        ";\n  background: ",
        ";\n  cursor: grab;\n  transition: all ",
        ";\n\n  &:active {\n    cursor: grabbing;\n  }\n\n  &:hover {\n    border-style: solid;\n    border-color: ",
        ";\n    box-shadow: ",
        ";\n  }\n"
    ]);
    _templateObject91 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject92() {
    var data = _tagged_template_literal([
        "\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: ",
        " ",
        ";\n"
    ]);
    _templateObject92 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject93() {
    var data = _tagged_template_literal([
        "\n  margin: 0;\n  padding: ",
        " ",
        ";\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject93 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject94() {
    var data = _tagged_template_literal([
        "\n  flex-basis: 100%;\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject94 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject95() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  min-height: 0;\n  &:focus {\n    outline: none;\n  }\n"
    ]);
    _templateObject95 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject96() {
    var data = _tagged_template_literal([
        "\n  padding: ",
        " ",
        " 0;\n"
    ]);
    _templateObject96 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject97() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  min-height: 0;\n  &:focus {\n    outline: none;\n  }\n"
    ]);
    _templateObject97 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject98() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: ",
        ";\n  padding: ",
        " ",
        " 0;\n\n  .problems-only {\n    flex: none;\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject98 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject99() {
    var data = _tagged_template_literal([
        "\n  flex: 1 1 auto;\n  min-width: 0;\n  margin: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject99 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject100() {
    var data = _tagged_template_literal([
        "\n  margin: 0;\n  padding: ",
        " ",
        " 0;\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject100 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject101() {
    var data = _tagged_template_literal([
        "\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: ",
        " ",
        ";\n\n  /* While a row is dragged, the page's cursor (grabbing, or not-allowed off a target) wins over the\n     rows' own pointer: otherwise every row reads as pressable and a disallowed one gives no cue. */\n  &[data-dragging] .row-select,\n  &[data-dragging] .expander {\n    cursor: inherit;\n  }\n"
    ]);
    _templateObject101 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject102() {
    var data = _tagged_template_literal([
        "\n  margin: 0;\n  padding: ",
        " ",
        ";\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject102 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject103() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  margin-top: ",
        ";\n  padding: ",
        " ",
        ";\n  border-radius: ",
        ";\n  background: ",
        ";\n  box-shadow: ",
        ";\n"
    ]);
    _templateObject103 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject104() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject104 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject105() {
    var data = _tagged_template_literal([
        "\n  flex: 1;\n  min-width: 0;\n"
    ]);
    _templateObject105 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject106() {
    var data = _tagged_template_literal([
        "\n  font-weight: ",
        ";\n  font-variant-numeric: tabular-nums;\n  color: ",
        ";\n"
    ]);
    _templateObject106 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject107() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: ",
        ";\n"
    ]);
    _templateObject107 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject108() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: ",
        ";\n  min-height: 0;\n  overflow-y: auto;\n  padding: ",
        ";\n  &:focus {\n    outline: none;\n  }\n"
    ]);
    _templateObject108 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject109() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject109 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject110() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject110 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject111() {
    var data = _tagged_template_literal([
        "\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject111 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject112() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: ",
        ";\n  min-height: 0;\n  overflow-y: auto;\n  padding: ",
        ";\n"
    ]);
    _templateObject112 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject113() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject113 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject114() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: ",
        ";\n"
    ]);
    _templateObject114 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject115() {
    var data = _tagged_template_literal([
        "\n  width: 168px;\n"
    ]);
    _templateObject115 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject116() {
    var data = _tagged_template_literal([
        "\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject116 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject117() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject117 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject118() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject118 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject119() {
    var data = _tagged_template_literal([
        "\n  ",
        ";\n  color: ",
        ";\n  margin: 0;\n"
    ]);
    _templateObject119 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject120() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n  display: flex;\n  flex-direction: column;\n  width: 300px;\n  flex-shrink: 0;\n  height: 100%;\n  border-right: 1px solid ",
        ";\n  background: ",
        ";\n"
    ]);
    _templateObject120 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject121() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 0;\n  min-height: 0;\n"
    ]);
    _templateObject121 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject122() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  /* Horizontal inset matches the search box + category cards below (spacing[3])\n     so the tab switcher lines up with them. */\n  padding: ",
        ";\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject122 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject123() {
    var data = _tagged_template_literal([
        "\n  margin: 0;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject123 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject124() {
    var data = _tagged_template_literal([
        "\n  padding: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject124 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject125() {
    var data = _tagged_template_literal([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject125 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject126() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject126 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject127() {
    var data = _tagged_template_literal([
        "\n  padding: ",
        ";\n"
    ]);
    _templateObject127 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject128() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  ",
        ";\n  color: ",
        ";\n\n  p {\n    margin: 0;\n  }\n  .lead {\n    font-weight: ",
        ";\n  }\n  ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: ",
        ";\n  }\n  li {\n    display: flex;\n    align-items: center;\n    gap: ",
        ";\n  }\n  .name {\n    flex: 1;\n    font-weight: ",
        ";\n  }\n  .count {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject128 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject129() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  align-items: stretch;\n"
    ]);
    _templateObject129 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject130() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: flex-start;\n"
    ]);
    _templateObject130 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject131() {
    var data = _tagged_template_literal([
        "\n  color: ",
        ";\n  font-size: 0.75rem;\n  line-height: 1.3;\n"
    ]);
    _templateObject131 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject132() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n\n  p,\n  ul {\n    margin: 0;\n  }\n  ul {\n    padding-left: ",
        ";\n  }\n"
    ]);
    _templateObject132 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject133() {
    var data = _tagged_template_literal([
        "\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  padding: 0;\n\n  li {\n    display: grid;\n    grid-template-columns: auto 1fr auto;\n    align-items: center;\n    column-gap: ",
        ";\n    padding: ",
        " ",
        ";\n    border: 1px solid ",
        ";\n    border-radius: ",
        ";\n    background: ",
        ";\n    ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject133 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject134() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: center;\n  gap: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  white-space: nowrap;\n"
    ]);
    _templateObject134 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject135() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject135 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject136() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n\n  p,\n  ul {\n    margin: 0;\n  }\n"
    ]);
    _templateObject136 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject137() {
    var data = _tagged_template_literal([
        "\n  display: grid;\n  grid-template-columns: 100px minmax(0, 1fr) auto;\n  align-items: center;\n  column-gap: ",
        ";\n  min-height: ",
        ";\n"
    ]);
    _templateObject137 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject138() {
    var data = _tagged_template_literal([
        "\n  font: ",
        " ",
        " / ",
        "\n    ",
        ";\n  color: ",
        ";\n  white-space: nowrap;\n"
    ]);
    _templateObject138 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject139() {
    var data = _tagged_template_literal([
        "\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  white-space: nowrap;\n  overflow: hidden;\n\n  .bid {\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font: ",
        " ",
        " / ",
        "\n      ",
        ";\n    color: ",
        ';\n  }\n  /* cards.css .v.none: the "not set" statement, grey italic. */\n  .none {\n    font: italic ',
        " ",
        " / ",
        "\n      ",
        ";\n    color: ",
        ";\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n"
    ]);
    _templateObject139 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject140() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: flex-end;\n"
    ]);
    _templateObject140 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject141() {
    var data = _tagged_template_literal([
        "\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  border-radius: ",
        ";\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  overflow: hidden;\n"
    ]);
    _templateObject141 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject142() {
    var data = _tagged_template_literal([
        "\n  display: grid;\n  /* The 8 px dot's column and .issue's 9 px to the words: the canvas's geometry, no token. */\n  grid-template-columns: 8px minmax(0, 1fr);\n  column-gap: 9px;\n  row-gap: ",
        ";\n  padding: ",
        " ",
        ";\n  border-top: 1px solid ",
        ";\n\n  &:first-child {\n    border-top: 0;\n  }\n"
    ]);
    _templateObject142 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject143() {
    var data = _tagged_template_literal([
        "\n  width: 8px;\n  height: 8px;\n  margin-top: ",
        ";\n  border-radius: ",
        ";\n  background: ",
        ";\n"
    ]);
    _templateObject143 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject144() {
    var data = _tagged_template_literal([
        "\n  margin: 0;\n  min-width: 0;\n  font: ",
        " ",
        " / ",
        "\n    ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject144 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject145() {
    var data = _tagged_template_literal([
        "\n  font-weight: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject145 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject146() {
    var data = _tagged_template_literal([
        "\n  grid-column: 2;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    _templateObject146 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject147() {
    var data = _tagged_template_literal([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject147 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject148() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  color: ",
        ";\n"
    ]);
    _templateObject148 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject149() {
    var data = _tagged_template_literal([
        "\n  min-width: 0;\n"
    ]);
    _templateObject149 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject150() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject150 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject151() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n"
    ]);
    _templateObject151 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject152() {
    var data = _tagged_template_literal([
        "\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  font: ",
        " ",
        " / ",
        "\n    ",
        ";\n  color: ",
        ";\n\n  li {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n"
    ]);
    _templateObject152 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject153() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  left: 0;\n  top: 0;\n  z-index: ",
        ";\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  max-width: 260px;\n  box-sizing: border-box;\n  padding: ",
        " ",
        " ",
        " ",
        ";\n  border-radius: ",
        ";\n  background: ",
        ";\n  border: 1.5px solid ",
        ";\n  box-shadow:\n    0 0 ",
        " 3px ",
        ",\n    0 14px 30px rgba(",
        ", 0.3);\n  pointer-events: none;\n  transform-origin: 0 100%;\n"
    ]);
    _templateObject153 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject154() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n"
    ]);
    _templateObject154 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject155() {
    var data = _tagged_template_literal([
        "\n  ",
        ";\n  color: ",
        ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject155 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject156() {
    var data = _tagged_template_literal([
        "\n  ",
        ";\n  color: ",
        ";\n  white-space: nowrap;\n"
    ]);
    _templateObject156 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject157() {
    var data = _tagged_template_literal([
        "\n  html.",
        ", html.",
        " * {\n    cursor: copy !important;\n  }\n  html.",
        ", html.",
        " * {\n    cursor: no-drop !important;\n  }\n  html.",
        ", html.",
        " * {\n    cursor: grabbing !important;\n  }\n"
    ]);
    _templateObject157 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject158() {
    var data = _tagged_template_literal([
        "\n      position: fixed;\n      inset: 0;\n      z-index: 900;\n      height: 100vh;\n      background: ",
        ";\n    "
    ]);
    _templateObject158 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject159() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n\n  /* Faux fullscreen: cover the host app's chrome but stay in the normal DOM\n     so the canvas dialogs (portaled to body at z-index 1000) remain visible\n     and Esc keeps deselecting instead of exiting. */\n  ",
        "\n"
    ]);
    _templateObject159 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject160() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  gap: 0.5rem;\n  padding: 0.5rem;\n  flex-shrink: 0;\n"
    ]);
    _templateObject160 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject161() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: center;\n  gap: 0.375rem;\n  padding: 0.375rem 0.875rem;\n  border-radius: 8px;\n  border: 1px solid ",
        ";\n  background: ",
        ";\n  color: ",
        ";\n  font-size: 0.875rem;\n  cursor: pointer;\n\n  &:hover {\n    background: ",
        ";\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: default;\n  }\n"
    ]);
    _templateObject161 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject162() {
    var data = _tagged_template_literal([
        "\n  margin-left: auto;\n  padding: 0.375rem 0.75rem;\n  border-radius: 8px;\n  border: 1px solid ",
        ";\n  background: ",
        ";\n  color: ",
        ";\n  font-size: 0.875rem;\n  width: 14rem;\n\n  &:focus {\n    outline: none;\n    border-color: ",
        ";\n  }\n"
    ]);
    _templateObject162 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject163() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  flex: 1;\n  display: flex;\n  overflow: hidden;\n"
    ]);
    _templateObject163 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject164() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  z-index: ",
        ";\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  pointer-events: none;\n"
    ]);
    _templateObject164 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject165() {
    var data = _tagged_template_literal([
        "\n  &:empty {\n    display: none;\n  }\n"
    ]);
    _templateObject165 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject166() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  flex: 1;\n  display: flex;\n  overflow: hidden;\n"
    ]);
    _templateObject166 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject167() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  left: ",
        ";\n  bottom: ",
        ";\n  pointer-events: none;\n"
    ]);
    _templateObject167 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject168() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: ",
        ";\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-content: center;\n  pointer-events: none;\n  z-index: ",
        ";\n"
    ]);
    _templateObject168 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject169() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: ",
        ";\n  z-index: ",
        ";\n  pointer-events: none;\n"
    ]);
    _templateObject169 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject170() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    _templateObject170 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject171() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n  position: absolute;\n  top: ",
        ";\n  right: ",
        ";\n  width: 36px;\n  height: 36px;\n  border-radius: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: ",
        ";\n  border: 1px solid ",
        ";\n  background: transparent;\n  cursor: pointer;\n  z-index: ",
        ";\n  transition: all ",
        ";\n\n  &:hover {\n    ",
        "\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject171 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject172() {
    var data = _tagged_template_literal([
        "\n  color: ",
        ";\n  font-size: 0.75rem;\n  line-height: 1.3;\n"
    ]);
    _templateObject172 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject173() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: flex-start;\n"
    ]);
    _templateObject173 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject174() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  transform: translate(-50%, -50%);\n  width: ",
        "px;\n  height: ",
        "px;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  border: ",
        "px ",
        "\n    ",
        ";\n  background: ",
        ";\n  color: ",
        ";\n  font: ",
        " ",
        " / 1 ",
        ";\n  box-shadow: ",
        ";\n  cursor: grab;\n  touch-action: none;\n\n  &:active {\n    cursor: grabbing;\n  }\n\n  &:focus-visible {\n    outline: none;\n    box-shadow: ",
        ";\n  }\n"
    ]);
    _templateObject174 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject175() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  inset: 0;\n  overflow: hidden;\n  pointer-events: none;\n"
    ]);
    _templateObject175 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject176() {
    var data = _tagged_template_literal([
        '\n  position: absolute;\n  /* BELOW the other top-centre overlay, not on top of it: CalibrateBannerHost sits at\n     spacing[3], centred, and calibrate mode does not disable dropping — so both can be up at\n     once. This one renders last, so without the offset it would cover the instruction the\n     operator is mid-way through following ("Now click the second point"). */\n  top: calc(',
        " * 2 + 40px);\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: ",
        ";\n  max-width: min(560px, calc(100% - ",
        "));\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ';\n  /* Bounded as defence in depth. readErrorMessage no longer falls back to the raw response text\n     (match-dialog-resilience deleted that): a non-JSON body now yields "<fallback> (<status>)"\n     and the server\'s own sentence is capped at 300 characters. So what arrives here is already a\n     sentence, and this cap only ever meets a long but legitimate one. It is React-escaped\n     (Banner takes children), so this is legibility, not injection. */\n  max-height: 40vh;\n  overflow-y: auto;\n  pointer-events: none;\n\n  > * {\n    pointer-events: auto;\n  }\n'
    ]);
    _templateObject176 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject177() {
    var data = _tagged_template_literal([
        "\n  margin-top: ",
        ";\n"
    ]);
    _templateObject177 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject178() {
    var data = _tagged_template_literal([
        "\n  outline: none;\n"
    ]);
    _templateObject178 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject179() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  inset: 0;\n  z-index: ",
        ";\n  overflow: hidden;\n  pointer-events: none;\n"
    ]);
    _templateObject179 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject180() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  width: ",
        ";\n  height: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transform: translate(-50%, -50%);\n  color: ",
        ";\n  filter: drop-shadow(0 0 ",
        " ",
        ") drop-shadow(0 0 ",
        " ",
        ");\n"
    ]);
    _templateObject180 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject181() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  inset: 0;\n  overflow: hidden;\n  pointer-events: none;\n  user-select: none;\n"
    ]);
    _templateObject181 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject182() {
    var data = _tagged_template_literal([
        "\n    border-color: ",
        ";\n    border-style: ",
        ";\n    box-shadow: ",
        ";\n  "
    ]);
    _templateObject182 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject183() {
    var data = _tagged_template_literal([
        "\n      width: ",
        "px;\n      height: ",
        "px;\n      z-index: 2;\n    "
    ]);
    _templateObject183 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject184() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  left: 0;\n  top: 0;\n  box-sizing: border-box;\n  width: ",
        "px;\n  height: ",
        "px;\n  margin: 0;\n  padding: 0;\n  border-radius: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: ",
        ";\n  border-width: 2px;\n  color: ",
        ";\n  cursor: grab;\n  touch-action: none;\n  pointer-events: ",
        ";\n  z-index: 1;\n\n  /* One look, first match wins (PLAN_CAMERA_MARKER_LOOKS): drop target, selected, lit, unlinked on\n     Camera Feeds, other. The glyph keeps the camera's status in every look, so a selected, lit or\n     targeted unlinked camera still shows its work to do. */\n  ",
        "\n  ",
        "\n\n  &:focus-visible {\n    outline: none;\n    box-shadow: ",
        ";\n  }\n"
    ]);
    _templateObject184 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject185() {
    var data = _tagged_template_literal([
        "\n      background: ",
        ";\n      color: ",
        ";\n      cursor: grabbing;\n    "
    ]);
    _templateObject185 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject186() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  left: 0;\n  top: 0;\n  box-sizing: border-box;\n  width: ",
        "px;\n  height: ",
        "px;\n  margin: 0;\n  padding: 0;\n  border-radius: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: ",
        ";\n  border: 2px solid ",
        ";\n  color: ",
        ";\n  box-shadow: ",
        ";\n  cursor: grab;\n  touch-action: none;\n  pointer-events: ",
        ";\n  z-index: 3;\n\n  /* Card 24's .pc-h glyph, turned to the direction the handle moves; its 8 px size is Icon's own\n     `tl-plan-cam-handle` slot. */\n  && > span {\n    display: inline-flex;\n  }\n\n  &:hover {\n    box-shadow: ",
        ";\n  }\n\n  ",
        "\n\n  &:focus-visible {\n    outline: none;\n    box-shadow: ",
        ";\n  }\n"
    ], [
        "\n  position: absolute;\n  left: 0;\n  top: 0;\n  box-sizing: border-box;\n  width: ",
        "px;\n  height: ",
        "px;\n  margin: 0;\n  padding: 0;\n  border-radius: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: ",
        ";\n  border: 2px solid ",
        ";\n  color: ",
        ";\n  box-shadow: ",
        ";\n  cursor: grab;\n  touch-action: none;\n  pointer-events: ",
        ";\n  z-index: 3;\n\n  /* Card 24's .pc-h glyph, turned to the direction the handle moves; its 8 px size is Icon's own\n     \\`tl-plan-cam-handle\\` slot. */\n  && > span {\n    display: inline-flex;\n  }\n\n  &:hover {\n    box-shadow: ",
        ";\n  }\n\n  ",
        "\n\n  &:focus-visible {\n    outline: none;\n    box-shadow: ",
        ";\n  }\n"
    ]);
    _templateObject186 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject187() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  inset: 0;\n  overflow: hidden;\n  pointer-events: none;\n  user-select: none;\n"
    ]);
    _templateObject187 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject188() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  left: 0;\n  top: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: ",
        ";\n  max-width: 200px;\n  padding: ",
        " ",
        " ",
        " ",
        ";\n  border: 1px solid var(--plan-tag-border);\n  border-radius: ",
        ";\n  background: ",
        ";\n  box-shadow: ",
        ";\n  white-space: nowrap;\n\n  .plan-tag-name {\n    ",
        ";\n    color: ",
        ";\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n"
    ]);
    _templateObject188 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject189() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject189 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject190() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n  pointer-events: auto;\n  cursor: copy;\n\n  &:focus-visible {\n    outline: none;\n    box-shadow: ",
        ";\n  }\n"
    ]);
    _templateObject190 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject191() {
    var data = _tagged_template_literal([
        "\n  &:focus {\n    outline: none;\n  }\n\n  &:focus-visible {\n    outline: 2px solid transparent;\n    outline-offset: -2px;\n    box-shadow:\n      inset 0 0 0 1.5px ",
        ",\n      inset 0 0 0 2.5px ",
        ";\n  }\n"
    ]);
    _templateObject191 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject192() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  bottom: calc(",
        "px + ",
        ");\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: ",
        ";\n  max-width: min(560px, calc(100% - ",
        "));\n  pointer-events: none;\n\n  > * {\n    pointer-events: auto;\n  }\n"
    ]);
    _templateObject192 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject193() {
    var data = _tagged_template_literal([
        "\n  margin-top: ",
        ";\n"
    ]);
    _templateObject193 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject194() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  inset: 0;\n  overflow: hidden;\n  pointer-events: none;\n"
    ]);
    _templateObject194 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject195() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  flex: 1;\n  overflow: hidden;\n  background: ",
        ";\n  cursor: ",
        ";\n\n  /* The pane takes keyboard focus so the arrow keys can scroll the plan: see planPaneFocus.ts. */\n  ",
        "\n"
    ]);
    _templateObject195 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject196() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: ",
        ";\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: ",
        ";\n  padding: ",
        ";\n  border-radius: ",
        ";\n  background: #f59e0b;\n  color: #ffffff;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  box-shadow: ",
        ";\n  pointer-events: none;\n  white-space: nowrap;\n"
    ]);
    _templateObject196 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject197() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  inset: 0;\n  background: ",
        ";\n\n  /* Focusable so the arrow keys and + / - move the plan: see planPaneFocus.ts. */\n  ",
        "\n"
    ]);
    _templateObject197 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject198() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  box-sizing: border-box;\n  width: ",
        "px;\n  height: ",
        "px;\n  margin: ",
        "px 0 0 ",
        "px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: ",
        ";\n  border: ",
        " ",
        " ",
        ";\n  color: ",
        ";\n  pointer-events: none;\n"
    ]);
    _templateObject198 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject199() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  overflow: visible;\n"
    ]);
    _templateObject199 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject200() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  overflow: visible;\n"
    ]);
    _templateObject200 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject201() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  overflow: visible;\n"
    ]);
    _templateObject201 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject202() {
    var data = _tagged_template_literal([
        "\n  display: inline-block;\n  flex-shrink: 0;\n  width: 12px;\n  height: 8px;\n  box-sizing: border-box;\n  border-radius: ",
        ";\n  background: ",
        ";\n  border: 1.5px ",
        " ",
        ";\n"
    ]);
    _templateObject202 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject203() {
    var data = _tagged_template_literal([
        "\n          border: ",
        "px solid ",
        ";\n          box-shadow: 0 0 ",
        "px ",
        ";\n        "
    ]);
    _templateObject203 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject204() {
    var data = _tagged_template_literal([
        "\n          border-radius: 50%;\n          background: ",
        ";\n          border: ",
        "px solid ",
        ";\n        "
    ]);
    _templateObject204 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject205() {
    var data = _tagged_template_literal([
        "\n  display: inline-block;\n  flex-shrink: 0;\n  width: ",
        "px;\n  height: ",
        "px;\n  box-sizing: border-box;\n  ",
        "\n"
    ]);
    _templateObject205 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject206() {
    var data = _tagged_template_literal([
        "\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: ",
        ";\n  /* A row wraps whole entries rather than running past a narrow plan: beside Camera Feeds' docked\n     panel the strip can be narrower than the row (review, onboarding-status-colours-unseen). */\n  flex-wrap: ",
        ";\n  align-items: ",
        ";\n  gap: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n  white-space: nowrap;\n\n  li {\n    display: flex;\n    align-items: center;\n    gap: ",
        ";\n  }\n"
    ]);
    _templateObject206 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject207() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  padding: ",
        ";\n"
    ]);
    _templateObject207 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject208() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject208 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject209() {
    var data = _tagged_template_literal([
        "\n  min-width: 0;\n\n  input {\n    font-family: ",
        ";\n  }\n"
    ]);
    _templateObject209 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject210() {
    var data = _tagged_template_literal([
        "\n  display: grid;\n  grid-template-columns: ",
        "px minmax(0, 1fr);\n  column-gap: ",
        ";\n  align-items: center;\n  padding-bottom: ",
        ";\n"
    ]);
    _templateObject210 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject211() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject211 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject212() {
    var data = _tagged_template_literal([
        "\n  min-width: 0;\n"
    ]);
    _templateObject212 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject213() {
    var data = _tagged_template_literal([
        "\n  margin: 0;\n  font: ",
        "\n    ",
        " / ",
        " ",
        ";\n  color: ",
        ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject213 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject214() {
    var data = _tagged_template_literal([
        "\n  margin: 0;\n  font: ",
        " ",
        " / ",
        "\n    ",
        ";\n  color: ",
        ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject214 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject215() {
    var data = _tagged_template_literal([
        "\n  margin-top: ",
        ";\n  display: flex;\n  gap: ",
        ";\n"
    ]);
    _templateObject215 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject216() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject216 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject217() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: flex-end;\n  gap: ",
        ";\n"
    ]);
    _templateObject217 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject218() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject218 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject219() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n"
    ]);
    _templateObject219 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject220() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: ",
        ";\n  width: 100%;\n\n  > :first-child {\n    align-self: stretch;\n  }\n"
    ]);
    _templateObject220 = function _templateObject() {
        return data;
    };
    return data;
}
import { ARRIVED_MS, BID_MOVED, BLANK_DISPLAY_NAME_MESSAGE, CALCULATED, CANT_CHECK_LIVE, CANT_UNDO_DELETE, CAPACITY_NOT_BELOW_INSIDE, CAPACITY_REFUSED, CAPACITY_UNKNOWN_CONTENTS, CHECKING_LIVE, CapacityTag, DELETE_TAKES_CHANGED, DraggablePanel_default, HierarchyEntityRow, HierarchyTreeRows, ICON_DISC_ROW_SIZE, IconDisc_default, IdentifiedScoreCard, IdentifyPlanPicker, KIND_ICON, LIVE_FAILED, ListGroup_default, MODEL_PICKER_EXACT_MATCH, MODEL_PICKER_FILTER, MODEL_RETIRING_NOTE, MODEL_SOURCE_NOTES, MODEL_SQUARE_PX, ModelSquare, ORPHAN_NO_IDENTITY_NOTE, ORPHAN_REGISTER_NOTE, PEOPLE, PRODUCT_CHANGE_FAILED, READING_REGISTER, REGISTER_FAILED, REGISTER_LINK_ALL_PLACED, REGISTER_LINK_BUTTON_LABEL, REGISTER_LINK_COMBOBOX_LABEL, REGISTER_LINK_EMPTY_REGISTER, REGISTER_LINK_IDENTITY_NOT_CARRIED, REGISTER_LINK_MIRROR_NOTE, REGISTER_LINK_NO_MATCH, REGISTER_LINK_SEARCH_PLACEHOLDER, REGISTER_LINK_UNAVAILABLE_REASON, ROW_STATE_LOOK, ROW_STATE_ROLE, RowGrip, RowNote, SPACE_KINDS, SPACE_NAME_BLANK, STREAM_DRAG_TYPE, TagSwitcher_default, UNKNOWN_REGISTER_REASON, UNLINKED_CONFIRMATION_NOTE, UNLINK_BUTTON_LABEL, USE_CALCULATED, bidBecomes, buildHierarchyTree, changeKindTitle, createEdgeScroller, deleteMachineCopy, deleteSpaceCopy, drawingDisagrees, feedDragCardTransform, hermiteEase, kindChangedToast, kindGlyphName, kindTitle, liveKindLines, machineDeletedToast, modelPickerEmptyText, modelPickerNoteState, modelPickerRefusalTail, modelSourceNote, namesCatalogueProduct, prefersReducedMotion, productMakerLine, productName, registerLinkAccessibleName, registerLinkedNote, resolveItemRegisterState, spaceDeleteRefused, spaceDeletedToast, takesLines, tooDeepInside, unlinkAccessibleName, useConfirm, useModelPickerOptions, useRegionToast, useRowProductChange } from "./chunk-4ZRWSSCT.mjs";
import { visuallyHidden } from "./chunk-MLHALTYO.mjs";
// src/components/Planner/TwinPlanner.tsx
import { createPortal as createPortal3 } from "react-dom";
import { useCallback as useCallback19, useEffect as useEffect38, useId as useId6, useLayoutEffect as useLayoutEffect2, useMemo as useMemo25, useRef as useRef36, useState as useState40 } from "react";
import { ThemeProvider, css as css4 } from "styled-components";
import styled38 from "styled-components";
import { ArrowMaximize20Regular, ArrowMinimize20Regular, Save16Regular } from "@fluentui/react-icons";
import { Button as Button22, Combobox as Combobox2, Icon as Icon22, ListPanel, Note as Note3, Select as Select5, Switch as Switch3 } from "@repo/design-system";
import { getModelFiles } from "@repo/front-end-services";
import { useFloorplanStore as useFloorplanStore47, useEditorStore as useEditorStore38, useCameraCatalogStore, useEquipmentCatalogStore as useEquipmentCatalogStore21, registerReadState as registerReadState10, selectionOnFloorShown as selectionOnFloorShown8 } from "@repo/front-end-state";
import { flatShareFilename as flatShareFilename5, entityIdentityFor as entityIdentityFor5, entityIdentityKey as entityIdentityKey5, findDuplicateEntityCodes as findDuplicateEntityCodes2, findLatestDesign as findLatestDesign17, joinRegisterOntoPlan as joinRegisterOntoPlan4, normaliseRotation as normaliseRotation2, allowedLetterFor, checkTypedEntityCode, isCompleteWrongLetter, resolvePlanHierarchy as resolvePlanHierarchy8, resolvePlanParentage as resolvePlanParentage8, resolveMachineCapacity, withCapacityReview as withCapacityReview3, buildTwinNameIndex as buildTwinNameIndex5, twinNameEntryFor as twinNameEntryFor2, twinNameSignature as twinNameSignature2, isFloorLaunched } from "@repo/front-end-utils";
// src/components/Planner/styles/theme.ts
import { zIndex } from "@repo/design-tokens";
var theme = {
    colors: {
        brand: {
            50: "#E6F9FB",
            100: "#CCF3F7",
            200: "#99E7EF",
            300: "#66DBE7",
            400: "#33CFDF",
            500: "#00BBCC",
            600: "#009AA8",
            700: "#007A85",
            800: "#005A62",
            900: "#003A3F",
            DEFAULT: "#00BBCC"
        },
        brandHover: "#5FD8DF",
        neutral: {
            50: "#F9FAFB",
            100: "#F5F5F5",
            200: "#F0F1F4",
            300: "#E1E2EA",
            400: "#D9D9D9",
            500: "#9CA3AF",
            600: "#6B7280",
            700: "#424242",
            800: "#2A2D3C",
            900: "#242424"
        },
        error: {
            50: "#FEF2F2",
            100: "#FEE2E2",
            500: "#D13438",
            600: "#B91C1C",
            DEFAULT: "#D13438"
        },
        success: {
            50: "#F0FDF4",
            100: "#DCFCE7",
            500: "#107C10",
            600: "#0E6B0E",
            DEFAULT: "#107C10"
        },
        warning: {
            50: "#FFFBEB",
            100: "#FEF3C7",
            500: "#FFB900",
            600: "#D97706",
            DEFAULT: "#FFB900"
        },
        info: {
            50: "#EFF6FF",
            100: "#DBEAFE",
            500: "#0078D4",
            600: "#0060AA",
            DEFAULT: "#0078D4"
        },
        surface: {
            glass: "rgba(255, 255, 255, 0.6)",
            glassHover: "rgba(255, 255, 255, 0.8)",
            glassLight: "rgba(255, 255, 255, 0.15)",
            glassMedium: "rgba(255, 255, 255, 0.4)"
        },
        glow: {
            DEFAULT: "rgba(228, 255, 254, 1)",
            light: "rgba(228, 255, 254, 0.55)"
        },
        density: {
            low: "#EAFAFA",
            medium: "#D5F4F5",
            high: "#6CE7EF"
        },
        optionSelected: "#D5F4F5",
        white: "#FFFFFF",
        black: "#000000"
    },
    spacing: {
        px: "1px",
        0: "0px",
        0.5: "2px",
        1: "4px",
        1.5: "6px",
        2: "8px",
        2.5: "10px",
        3: "12px",
        3.5: "14px",
        4: "16px",
        4.5: "18px",
        5: "20px",
        6: "24px",
        7: "28px",
        8: "32px",
        9: "36px",
        10: "40px",
        11: "44px",
        12: "48px",
        13: "54px",
        14: "56px",
        15: "60px",
        16: "64px"
    },
    borderRadius: {
        none: "0px",
        DEFAULT: "8px",
        lg: "12px",
        full: "9999px",
        switch: "34px"
    },
    fontFamily: {
        sans: "'Inter', sans-serif"
    },
    fontSize: {
        xs: {
            size: "0.6875rem",
            lineHeight: "1rem"
        },
        sm: {
            size: "0.75rem",
            lineHeight: "1rem"
        },
        base: {
            size: "0.875rem",
            lineHeight: "1.5"
        },
        lg: {
            size: "1rem",
            lineHeight: "1.25rem"
        },
        xl: {
            size: "1.125rem",
            lineHeight: "1.5rem"
        },
        "2xl": {
            size: "1.5rem",
            lineHeight: "2rem"
        },
        "3xl": {
            size: "1.875rem",
            lineHeight: "2.25rem"
        },
        "4xl": {
            size: "2.25rem",
            lineHeight: "2.5rem"
        }
    },
    fontWeight: {
        normal: 400,
        medium: 500,
        semibold: 600,
        bold: 700
    },
    shadows: {
        sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
        DEFAULT: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)",
        lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)",
        glass: "0px 0px 11px 1px rgba(228, 255, 254, 0.55), 0px 3px 11px 0px rgba(0, 0, 0, 0.05)",
        glassHover: "0px 0px 15px 2px rgba(228, 255, 254, 0.7), 0px 4px 15px 0px rgba(0, 0, 0, 0.08)",
        panel: "0px 16px 40px 0px rgba(0, 0, 0, 0.15), 0px 4px 16px 0px rgba(0, 0, 0, 0.08)",
        card: "inset 0 1px 3px rgba(255, 255, 255, 0.3), inset 0 -3px 8px rgba(0, 0, 0, 0.1), 0 8px 16px rgba(0, 0, 0, 0.05)",
        cardSelected: "0px 0px 12px 2px rgba(228, 255, 254, 1), 0px 2px 5px rgba(0, 0, 0, 0.9)",
        cardHover: "0px 0px 12px 3px rgba(228, 255, 254, 1), 0px 2px 5px rgba(0, 0, 0, 0.7)",
        dropdown: "0px 2px 4px 0px rgba(0, 0, 0, 0.1)",
        dropdownMenu: "0px 4px 16px 0px rgba(0, 0, 0, 0.15)"
    },
    backdropBlur: {
        glass: "6px",
        panel: "50px",
        card: "12px"
    },
    transitions: {
        fast: "150ms",
        DEFAULT: "200ms",
        medium: "300ms",
        slow: "400ms"
    },
    easing: {
        DEFAULT: "ease",
        in: "ease-in",
        out: "ease-out",
        inOut: "ease-in-out"
    },
    /**
   * The layer ladder, now held ONCE in `@repo/design-tokens` rather than privately here.
   *
   * ⭐ SAME SEVEN STEPS, SAME SEVEN VALUES — this is a re-point, not a re-scale, so every
   * Planner surface keeps the exact number it had. What changes is reach: while the ladder
   * lived in this object, nothing outside the Planner could use it, and the rest of the repo
   * grew its own numbers instead (999, 9999, 999999, 2147483647). `BaseDropdown` is the one
   * that cost a user something. See the token's own header for the full account.
   */ zIndex: zIndex
};
var theme_default = theme;
// src/components/Planner/styles/mixins.ts
import { css, keyframes } from "styled-components";
var glassSurface = css(_templateObject(), function(param) {
    var theme2 = param.theme;
    return theme2.colors.surface.glass;
}, function(param) {
    var theme2 = param.theme;
    return theme2.backdropBlur.glass;
}, function(param) {
    var theme2 = param.theme;
    return theme2.backdropBlur.glass;
}, function(param) {
    var theme2 = param.theme;
    return theme2.shadows.glass;
});
var glassSurfaceHover = css(_templateObject1(), function(param) {
    var theme2 = param.theme;
    return theme2.colors.surface.glassHover;
}, function(param) {
    var theme2 = param.theme;
    return theme2.shadows.glassHover;
});
var focusRing = css(_templateObject2(), function(param) {
    var theme2 = param.theme;
    return theme2.colors.white;
}, function(param) {
    var theme2 = param.theme;
    return theme2.colors.brand[500];
});
var focusRingError = css(_templateObject3(), function(param) {
    var theme2 = param.theme;
    return theme2.colors.white;
}, function(param) {
    var theme2 = param.theme;
    return theme2.colors.error[500];
});
var truncateText = css(_templateObject4());
var spin = keyframes(_templateObject5());
var pulse = keyframes(_templateObject6());
var bounce = keyframes(_templateObject7());
var slideInRight = keyframes(_templateObject8());
// src/components/Planner/plannerCanvas/PlannerCanvas.tsx
import { createContext as createContext2, createElement, useContext as useContext2 } from "react";
// src/components/Planner/plannerCapabilities.ts
var EDIT = {
    full: {
        tools: {
            drawWall: true,
            drawSpace: true,
            camera: true,
            background: true,
            setScale: false,
            scaleUnderlay: false,
            viewRotation: true
        },
        mutableKinds: "all",
        // Turn, Widen and Reach, as on Camera Feeds: Floor Plan edits the same camera through the same
        // panel and handles (`unified-camera-panel`, R6).
        cameraControls: "all",
        floorStructure: true,
        allFloors: false
    },
    // `select` leaves every entity mutable — the admin plan editor's paused state relies on it (see
    // `PlannerToolset`). Not this resolver's to change.
    select: {
        tools: {
            drawWall: false,
            drawSpace: false,
            camera: false,
            background: false,
            setScale: false,
            scaleUnderlay: false,
            viewRotation: false
        },
        mutableKinds: "all",
        cameraControls: "turn",
        floorStructure: false,
        allFloors: false
    },
    cameras: {
        tools: {
            drawWall: false,
            drawSpace: false,
            camera: true,
            background: false,
            setScale: false,
            scaleUnderlay: false,
            viewRotation: false
        },
        mutableKinds: "cameras",
        cameraControls: "all",
        floorStructure: false,
        allFloors: false
    }
};
var ALIGN_FLOORS = {
    tools: {
        drawWall: false,
        drawSpace: false,
        camera: false,
        background: false,
        setScale: true,
        scaleUnderlay: true,
        viewRotation: true
    },
    mutableKinds: "none",
    cameraControls: "none",
    floorStructure: true,
    allFloors: true
};
var FULL_RENDERER_SUPPORT = Object.freeze({
    drawWalls: true,
    drawSpaces: true,
    cameras: true,
    underlays: true,
    buildFloors: true
});
var resolvePlannerCapabilities = function(toolset, planMode) {
    var support2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : FULL_RENDERER_SUPPORT;
    if (planMode === "align" && toolset === "full") return ALIGN_FLOORS;
    var _EDIT_toolset;
    var base2 = (_EDIT_toolset = EDIT[toolset]) !== null && _EDIT_toolset !== void 0 ? _EDIT_toolset : EDIT.select;
    if (support2 === FULL_RENDERER_SUPPORT) return base2;
    var byBase = NARROWED.get(support2);
    if (!byBase) {
        byBase = /* @__PURE__ */ new WeakMap();
        NARROWED.set(support2, byBase);
    }
    var cached = byBase.get(base2);
    if (cached) return cached;
    var narrowed = narrow(base2, support2);
    byBase.set(base2, narrowed);
    return narrowed;
};
var NARROWED = /* @__PURE__ */ new WeakMap();
var narrow = function(base2, support2) {
    return _object_spread_props(_object_spread({}, base2), {
        tools: _object_spread_props(_object_spread({}, base2.tools), {
            drawWall: base2.tools.drawWall && support2.drawWalls,
            drawSpace: base2.tools.drawSpace && support2.drawSpaces,
            camera: base2.tools.camera && support2.cameras,
            background: base2.tools.background && support2.underlays
        }),
        mutableKinds: base2.mutableKinds === "cameras" && !support2.cameras ? "nothing" : base2.mutableKinds,
        cameraControls: support2.cameras ? base2.cameraControls : "none"
    });
};
// src/components/Planner/plannerCanvas/rendererSupport.ts
import { createContext, useContext } from "react";
var PlannerRendererSupportContext = createContext(FULL_RENDERER_SUPPORT);
var usePlannerRendererSupport = function() {
    return useContext(PlannerRendererSupportContext);
};
// src/components/Planner/plannerCanvas/PlannerCanvas.tsx
import { jsx } from "react/jsx-runtime";
var warnedNoRenderer = false;
var NoRenderer = function() {
    if (!warnedNoRenderer) {
        warnedNoRenderer = true;
        console.error("[PlannerCanvas] no renderer provided");
    }
    return null;
};
var PlannerCanvasRendererContext = createContext2(NoRenderer);
var PlannerCanvasRendererProvider = function(param) {
    var renderer = param.renderer, tmp = param.support, support2 = tmp === void 0 ? FULL_RENDERER_SUPPORT : tmp, children = param.children;
    return /* @__PURE__ */ jsx(PlannerCanvasRendererContext.Provider, {
        value: renderer,
        children: /* @__PURE__ */ jsx(PlannerRendererSupportContext.Provider, {
            value: support2,
            children: children
        })
    });
};
var PlannerCanvas = function(props) {
    return createElement(useContext2(PlannerCanvasRendererContext), props);
};
// src/components/Planner/underlayImages.tsx
import { createContext as createContext3, useContext as useContext3, useEffect, useMemo, useSyncExternalStore } from "react";
import { useEditorStore } from "@repo/front-end-state";
var UnderlayImagesContext = createContext3(null);
var NO_UNDERLAYS = [];
var noopSubscribe = function() {
    return function() {};
};
function useUnderlayImages(underlays) {
    var images = useContext3(UnderlayImagesContext);
    var refOf = function(u) {
        return u.data ? void 0 : u.imageRef;
    };
    var refsKey = Array.from(new Set(underlays.map(refOf).filter(Boolean))).join("|");
    var _images_subscribe;
    var entriesKey = useSyncExternalStore((_images_subscribe = images === null || images === void 0 ? void 0 : images.subscribe) !== null && _images_subscribe !== void 0 ? _images_subscribe : noopSubscribe, function() {
        return images ? refsKey.split("|").filter(Boolean).map(function(ref) {
            var e = images.peek(ref);
            var _e_url;
            return e ? "".concat(e.status, ":").concat((_e_url = e.url) !== null && _e_url !== void 0 ? _e_url : "") : "";
        }).join("|") : "";
    });
    useEffect(function() {
        if (!images) return;
        refsKey.split("|").filter(Boolean).forEach(function(ref) {
            return images.ensure(ref);
        });
    }, [
        images,
        refsKey
    ]);
    var inputKey = underlays.map(function(u) {
        var _u_data, _u_data1;
        var _u_imageRef, _u_data_length, _u_data_slice;
        return "".concat(u.id, ":").concat((_u_imageRef = u.imageRef) !== null && _u_imageRef !== void 0 ? _u_imageRef : "", ":").concat((_u_data_length = (_u_data = u.data) === null || _u_data === void 0 ? void 0 : _u_data.length) !== null && _u_data_length !== void 0 ? _u_data_length : "", ":").concat((_u_data_slice = (_u_data1 = u.data) === null || _u_data1 === void 0 ? void 0 : _u_data1.slice(-16)) !== null && _u_data_slice !== void 0 ? _u_data_slice : "");
    }).join("|");
    return useMemo(function() {
        var views = {};
        underlays.forEach(function(u) {
            if (u.data) {
                views[u.id] = {
                    status: "ready",
                    src: u.data
                };
                return;
            }
            var ref = u.imageRef;
            if (!ref || !images) {
                views[u.id] = {
                    status: "failed"
                };
                return;
            }
            var entry = images.peek(ref);
            if (!entry) views[u.id] = {
                status: "loading"
            };
            else if (entry.status === "failed") views[u.id] = {
                status: "failed",
                retry: function() {
                    return images.retry(ref);
                }
            };
            else views[u.id] = {
                status: entry.status,
                src: entry.url
            };
        });
        return views;
    }, [
        images,
        inputKey,
        entriesKey
    ]);
}
function useUnderlayOnScreen(u) {
    var views = useUnderlayImages(u ? [
        u
    ] : NO_UNDERLAYS);
    var view = u ? views[u.id] : void 0;
    var decoded = useEditorStore(function(s) {
        return u ? s.decodedUnderlaySrcs[u.id] : void 0;
    });
    return (view === null || view === void 0 ? void 0 : view.status) === "ready" && !!view.src && decoded === view.src;
}
// src/components/Planner/hooks/useToolbarAnnouncement.ts
import { useCallback, useEffect as useEffect2, useRef, useState } from "react";
import { useEditorStore as useEditorStore2, useFloorplanStore } from "@repo/front-end-state";
// src/components/Planner/hooks/planHistoryAnnouncements.ts
var listeners = /* @__PURE__ */ new Set();
var onPlanHistoryAnnouncement = function(listener) {
    listeners.add(listener);
    return function() {
        listeners.delete(listener);
    };
};
var announcePlanSentence = function(sentence) {
    return listeners.forEach(function(listener) {
        return listener(sentence);
    });
};
var announcePlanHistory = function(sentence) {
    return announcePlanSentence(sentence);
};
var toolPrefix = null;
var prefixNextToolAnnouncement = function(sentence) {
    toolPrefix = sentence;
};
var takeToolAnnouncementPrefix = function() {
    var taken = toolPrefix;
    toolPrefix = null;
    return taken;
};
// src/components/Planner/hooks/useToolbarAnnouncement.ts
var ANNOUNCE_SETTLE_MS = 300;
var PLAN_QUIET_MS = ANNOUNCE_SETTLE_MS * 2;
var REPEAT_MARKER = "\u200B";
var useAnnouncer = function() {
    var _useState = _sliced_to_array(useState(""), 2), message = _useState[0], setMessage = _useState[1];
    var announce = useCallback(function(text2) {
        return setMessage(function(prev) {
            return prev === text2 ? text2 + REPEAT_MARKER : text2;
        });
    }, []);
    return [
        message,
        announce
    ];
};
var TOOL_ANNOUNCEMENTS = {
    select: "Select tool active",
    draw_space: "Draw space tool active",
    draw_wall: "Draw wall tool active",
    place_camera: "Place camera tool active, press Enter on the plan to place one at its centre",
    calibrate_scale: "Set scale tool active",
    scale_underlay: "Scale PDF tool active"
};
var PRECEDENCE = [
    "toolMode",
    "viewRotation",
    "zoom"
];
function changedKeys(from, to) {
    return PRECEDENCE.filter(function(key) {
        return from[key] !== to[key];
    });
}
function announcementFor(moved, now) {
    var winner = PRECEDENCE.find(function(key) {
        return moved.includes(key);
    });
    switch(winner){
        case "toolMode":
            return TOOL_ANNOUNCEMENTS[now.toolMode];
        case "viewRotation":
            return now.viewRotation === 0 ? "View rotation reset" : "View rotated ".concat(now.viewRotation, " degrees");
        case "zoom":
            return "Zoom ".concat(Math.round(now.zoom * 100), "%");
        default:
            return null;
    }
}
function useToolbarAnnouncement() {
    var toolMode = useEditorStore2(function(s) {
        return s.toolMode;
    });
    var viewRotation = useEditorStore2(function(s) {
        return s.viewRotation;
    });
    var zoom = useEditorStore2(function(s) {
        return s.zoom;
    });
    var planKey = useFloorplanStore(function(s) {
        var _s_layout_floors, _s_layout, _s_layout1;
        var floor = (_s_layout = s.layout) === null || _s_layout === void 0 ? void 0 : (_s_layout_floors = _s_layout.floors) === null || _s_layout_floors === void 0 ? void 0 : _s_layout_floors[s.activeFloorIndex];
        return floor ? "".concat((_s_layout1 = s.layout) === null || _s_layout1 === void 0 ? void 0 : _s_layout1.name, ":").concat(s.activeFloorIndex, ":").concat(floor.name) : null;
    });
    var _useAnnouncer = _sliced_to_array(useAnnouncer(), 2), announcement = _useAnnouncer[0], say = _useAnnouncer[1];
    useEffect2(function() {
        return onPlanHistoryAnnouncement(say);
    }, [
        say
    ]);
    var quiet = useRef("all");
    var seenPlan = useRef(false);
    useEffect2(function() {
        quiet.current = seenPlan.current ? "zoom" : "all";
        seenPlan.current = true;
        var lift = setTimeout(function() {
            quiet.current = null;
        }, PLAN_QUIET_MS);
        return function() {
            return clearTimeout(lift);
        };
    }, [
        planKey
    ]);
    var lastSeen = useRef(null);
    var moved = useRef(/* @__PURE__ */ new Set());
    useEffect2(function() {
        var next = {
            toolMode: toolMode,
            viewRotation: viewRotation,
            zoom: zoom
        };
        var previous = lastSeen.current;
        lastSeen.current = next;
        if (previous === null) return;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = changedKeys(previous, next)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                moved.current.add(key);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var timer = setTimeout(function() {
            var store = useEditorStore2.getState();
            var live = {
                toolMode: store.toolMode,
                viewRotation: store.viewRotation,
                zoom: store.zoom
            };
            var _lastSeen_current;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = changedKeys((_lastSeen_current = lastSeen.current) !== null && _lastSeen_current !== void 0 ? _lastSeen_current : live, live)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var key = _step.value;
                    moved.current.add(key);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            lastSeen.current = live;
            var movers = PRECEDENCE.filter(function(key) {
                return moved.current.has(key);
            });
            var settled = announcementFor(movers, live);
            var zoomOnly = moved.current.size === 1 && moved.current.has("zoom");
            moved.current.clear();
            var prefix = takeToolAnnouncementPrefix();
            if (settled === null) return;
            if (quiet.current === "all" || quiet.current === "zoom" && zoomOnly) return;
            say(prefix ? "".concat(prefix, " ").concat(settled) : settled);
        }, ANNOUNCE_SETTLE_MS);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        toolMode,
        viewRotation,
        zoom
    ]);
    return [
        announcement,
        say
    ];
}
// src/components/Planner/hooks/useLiveEntityIdentities.ts
import { useCallback as useCallback2, useEffect as useEffect3, useRef as useRef2, useState as useState2 } from "react";
import { dgqFetchTwinOutcome, MIDDLEWARE_REQUEST_TIMEOUT_MS } from "@repo/front-end-services";
import { isDgraphNamespaceError } from "@repo/front-end-utils";
var EMPTY = /* @__PURE__ */ new Set();
var collectBids = function(node, into) {
    if ((typeof node === "undefined" ? "undefined" : _type_of(node)) !== "object" || node === null) return;
    var record = node;
    if (typeof record.bID === "string" && record.bID !== "") into.add(record.bID);
    var children = record.children;
    if (!Array.isArray(children)) return;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var child = _step.value;
            collectBids(child, into);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};
var useLiveEntityIdentities = function(param) {
    var middlewareApi = param.middlewareApi, getAccessToken = param.getAccessToken, orgBid = param.orgBid, _param_orgPending = param.orgPending, orgPending = _param_orgPending === void 0 ? false : _param_orgPending, twinBid = param.twinBid, _param_enabled = param.enabled, enabled = _param_enabled === void 0 ? true : _param_enabled;
    var _useState2 = _sliced_to_array(useState2({
        status: "loading",
        bids: EMPTY
    }), 2), state = _useState2[0], setState = _useState2[1];
    var _useState21 = _sliced_to_array(useState2(0), 2), attempt = _useState21[0], setAttempt = _useState21[1];
    var runRef = useRef2(0);
    var retry = useCallback2(function() {
        setState({
            status: "loading",
            bids: EMPTY
        });
        setAttempt(function(n) {
            return n + 1;
        });
    }, []);
    useEffect3(function() {
        var run = ++runRef.current;
        if (!enabled || !twinBid) {
            setState({
                status: "idle",
                bids: EMPTY
            });
            return;
        }
        if (orgPending) {
            setState({
                status: "loading",
                bids: EMPTY
            });
            return;
        }
        if (!orgBid) {
            console.error("[useLiveEntityIdentities] no organisation for twin %s, so its live model could not be read; new equipment's identities are unverified", twinBid);
            setState({
                status: "failed",
                bids: EMPTY
            });
            return;
        }
        setState({
            status: "loading",
            bids: EMPTY
        });
        var controller = new AbortController();
        var timer = setTimeout(function() {
            return controller.abort();
        }, MIDDLEWARE_REQUEST_TIMEOUT_MS);
        var read = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                var namespaceAbsent, accessToken, outcome, bids, error, _e_response, e, _e_response_status, _e_message;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            namespaceAbsent = false;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                4,
                                5,
                                6
                            ]);
                            return [
                                4,
                                getAccessToken()
                            ];
                        case 2:
                            accessToken = _state.sent();
                            return [
                                4,
                                dgqFetchTwinOutcome(middlewareApi, accessToken, orgBid, twinBid, {
                                    signal: controller.signal,
                                    timeout: MIDDLEWARE_REQUEST_TIMEOUT_MS,
                                    onFailure: function(failure) {
                                        if (failure.namespaceAbsent) namespaceAbsent = true;
                                    }
                                })
                            ];
                        case 3:
                            outcome = _state.sent();
                            if (run !== runRef.current) return [
                                2
                            ];
                            if (outcome.status === "found") {
                                bids = /* @__PURE__ */ new Set();
                                collectBids(outcome.twin, bids);
                                setState({
                                    status: "ready",
                                    bids: bids
                                });
                                return [
                                    2
                                ];
                            }
                            if (outcome.status === "absent") {
                                setState({
                                    status: "ready",
                                    bids: EMPTY
                                });
                                return [
                                    2
                                ];
                            }
                            if (namespaceAbsent) {
                                setState({
                                    status: "ready",
                                    bids: EMPTY
                                });
                                return [
                                    2
                                ];
                            }
                            setState({
                                status: "failed",
                                bids: EMPTY
                            });
                            console.error("[useLiveEntityIdentities] could not read the live model for %s: %s", twinBid, outcome.error);
                            return [
                                3,
                                6
                            ];
                        case 4:
                            error = _state.sent();
                            if (run !== runRef.current) return [
                                2
                            ];
                            if (namespaceAbsent || isDgraphNamespaceError(error)) {
                                setState({
                                    status: "ready",
                                    bids: EMPTY
                                });
                                return [
                                    2
                                ];
                            }
                            setState({
                                status: "failed",
                                bids: EMPTY
                            });
                            e = error;
                            console.error("[useLiveEntityIdentities] could not read the live model for %s: %s %s", twinBid, (_e_response_status = e === null || e === void 0 ? void 0 : (_e_response = e.response) === null || _e_response === void 0 ? void 0 : _e_response.status) !== null && _e_response_status !== void 0 ? _e_response_status : "(no response)", (_e_message = e === null || e === void 0 ? void 0 : e.message) !== null && _e_message !== void 0 ? _e_message : "");
                            return [
                                3,
                                6
                            ];
                        case 5:
                            clearTimeout(timer);
                            return [
                                7
                            ];
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            });
            return function read() {
                return _ref.apply(this, arguments);
            };
        }();
        void read();
        return function() {
            runRef.current += 1;
            controller.abort();
            clearTimeout(timer);
        };
    }, [
        middlewareApi,
        getAccessToken,
        orgBid,
        orgPending,
        twinBid,
        enabled,
        attempt
    ]);
    return {
        status: state.status,
        bids: state.bids,
        verified: state.status === "ready" || state.status === "idle",
        retry: retry,
        retrying: state.status === "loading" && attempt > 0
    };
};
// src/components/Planner/hooks/useTwinOrgBid.ts
import { useEffect as useEffect4, useState as useState3 } from "react";
import { getOrganisations, getTwinById } from "@repo/front-end-services";
var useTwinOrgBid = function(param) {
    var middlewareApi = param.middlewareApi, getAccessToken = param.getAccessToken, twinBid = param.twinBid, _param_enabled = param.enabled, enabled = _param_enabled === void 0 ? true : _param_enabled;
    var _useState3 = _sliced_to_array(useState3({
        orgBid: void 0,
        pending: true
    }), 2), state = _useState3[0], setState = _useState3[1];
    useEffect4(function() {
        if (!enabled || !twinBid || !middlewareApi) {
            setState({
                orgBid: void 0,
                pending: false
            });
            return;
        }
        var cancelled = false;
        setState({
            orgBid: void 0,
            pending: true
        });
        void _async_to_generator(function() {
            var accessToken, twin, organisations, org, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            getAccessToken()
                        ];
                    case 1:
                        accessToken = _state.sent();
                        return [
                            4,
                            getTwinById(middlewareApi, accessToken, twinBid)
                        ];
                    case 2:
                        twin = _state.sent();
                        if (cancelled) return [
                            2
                        ];
                        if (!twin || twin.organisation_id == null) {
                            throw new Error(twin ? "twin ".concat(twinBid, " has no organisation on its record") : "no twin record for ".concat(twinBid));
                        }
                        return [
                            4,
                            getOrganisations(middlewareApi, accessToken)
                        ];
                    case 3:
                        organisations = _state.sent();
                        if (cancelled) return [
                            2
                        ];
                        org = organisations === null || organisations === void 0 ? void 0 : organisations.find(function(o) {
                            return o.id === twin.organisation_id;
                        });
                        if (!(org === null || org === void 0 ? void 0 : org.bid)) throw new Error("no organisation BID for org id ".concat(twin.organisation_id));
                        setState({
                            orgBid: org.bid,
                            pending: false
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        if (cancelled) return [
                            2
                        ];
                        setState({
                            orgBid: void 0,
                            pending: false
                        });
                        console.error("[useTwinOrgBid] could not resolve the organisation for twin %s, so its live model will not be read and new equipment's identities are unverified: %s", twinBid, _instanceof(error, Error) ? error.message : String(error));
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        })();
        return function() {
            cancelled = true;
        };
    }, [
        middlewareApi,
        getAccessToken,
        twinBid,
        enabled
    ]);
    return state;
};
// src/components/Planner/hooks/usePlanCapacity.ts
import { useEffect as useEffect5, useMemo as useMemo2 } from "react";
import { registerReadState, resolveRegisterScope, useEquipmentCatalogStore, useFloorplanStore as useFloorplanStore2 } from "@repo/front-end-state";
import { entityIdentityKey, joinRegisterOntoPlan, registerCapacityLookup, resolvePlanCapacity, sortCapacitySources } from "@repo/front-end-utils";
var useRegisterOnDisplay = function(twinId) {
    return useEquipmentCatalogStore(function(s) {
        var scope = resolveRegisterScope({
            twinId: twinId !== null && twinId !== void 0 ? twinId : void 0
        });
        return scope !== null && s.loadedKey === scope.key;
    });
};
var useMachinesKnown = function(twinId) {
    var readState = useEquipmentCatalogStore(function(s) {
        return registerReadState(s, {
            twinId: twinId !== null && twinId !== void 0 ? twinId : void 0
        });
    });
    var onDisplay = useRegisterOnDisplay(twinId);
    return onDisplay && (readState === "ready" || readState === "loading");
};
var useRegisterCapacityOf = function(twinId) {
    var rows = useEquipmentCatalogStore(function(s) {
        return s.registerRows;
    });
    var known = useMachinesKnown(twinId);
    return registerCapacityLookup(rows, known);
};
var joinedFor = function(layout, registerRows, twinBid, ready) {
    var _joinRegisterOntoPlan;
    return (_joinRegisterOntoPlan = joinRegisterOntoPlan(layout, registerRows, twinBid, {
        /*
   * THE REPAIR GATE, and it must be the READ STATE rather than `registerRows.length > 0`.
   * `loadRegisterAssets` deliberately keeps the previous rows when a refresh fails, so a
   * populated array is entirely compatible with `error` — gating on length would re-point
   * items against a register nobody successfully read.
   */ repairStaleLinks: ready
    })) !== null && _joinRegisterOntoPlan !== void 0 ? _joinRegisterOntoPlan : null;
};
var useJoinedLayout = function(twinBid, twinId) {
    var layout = useFloorplanStore2(function(s) {
        return s.layout;
    });
    var registerRows = useEquipmentCatalogStore(function(s) {
        return s.registerRows;
    });
    var ready = useEquipmentCatalogStore(function(s) {
        return registerReadState(s, {
            twinId: twinId !== null && twinId !== void 0 ? twinId : void 0
        }) === "ready";
    });
    return useMemo2(function() {
        return joinedFor(layout, registerRows, twinBid, ready);
    }, [
        layout,
        registerRows,
        twinBid,
        ready
    ]);
};
var planCapacityNow = function(twinBid, twinId, registerCapacityOf) {
    var catalog = useEquipmentCatalogStore.getState();
    var ready = registerReadState(catalog, {
        twinId: twinId !== null && twinId !== void 0 ? twinId : void 0
    }) === "ready";
    var joined2 = joinedFor(useFloorplanStore2.getState().layout, catalog.registerRows, twinBid, ready);
    return resolvePlanCapacity(joined2, registerCapacityOf);
};
var isSameTwinScope = function(storeScope, twinBid, layoutScope) {
    var twinKey = entityIdentityKey(twinBid);
    if (twinKey === "") return false;
    if (entityIdentityKey(storeScope) === twinKey) return true;
    return !!layoutScope && storeScope === layoutScope;
};
var useCapacitySort = function(twinBid, twinId, layoutScope) {
    var layout = useFloorplanStore2(function(s) {
        return s.layout;
    });
    var storeScope = useFloorplanStore2(function(s) {
        return s.twinBID;
    });
    var joined2 = useJoinedLayout(twinBid, twinId);
    var registerRows = useEquipmentCatalogStore(function(s) {
        return s.registerRows;
    });
    var ready = useEquipmentCatalogStore(function(s) {
        return registerReadState(s, {
            twinId: twinId !== null && twinId !== void 0 ? twinId : void 0
        }) === "ready";
    });
    var onDisplay = useRegisterOnDisplay(twinId);
    var inScope = isSameTwinScope(storeScope, twinBid, layoutScope);
    useEffect5(function() {
        if (!ready || !onDisplay || !inScope) return;
        var store = useFloorplanStore2.getState();
        if (store.layout !== layout) return;
        var sorted = sortCapacitySources(layout, registerCapacityLookup(registerRows, true), joined2 !== null && joined2 !== void 0 ? joined2 : layout);
        if (sorted) store.replaceLayout(sorted, {
            keepDirty: true
        });
    }, [
        layout,
        joined2,
        registerRows,
        ready,
        onDisplay,
        inScope
    ]);
};
// src/components/Planner/TwinPlanner.tsx
import { space as space24 } from "@repo/design-tokens";
// src/components/Planner/FloorTabs.tsx
import { useCallback as useCallback4, useEffect as useEffect8, useLayoutEffect, useRef as useRef6, useState as useState7 } from "react";
import { flushSync } from "react-dom";
import styled5 from "styled-components";
import { Button as Button4, Icon as Icon4, Menu, MenuItem, MenuLabel, MenuTrailingLabel, Tag } from "@repo/design-system";
import { space as space3, zIndex as zIndex2 } from "@repo/design-tokens";
import { useFloorplanStore as useFloorplanStore9 } from "@repo/front-end-state";
import { rovingIndexForKey } from "@repo/front-end-utils";
// src/components/Planner/smallGlass.ts
import { css as css2 } from "styled-components";
import { glass, radius, shadow, space } from "@repo/design-tokens";
var smallGlassCss = css2(_templateObject9(), glass.bgStrong, glass.blurXs, glass.blurXs, glass.border, radius.lg, shadow.glassSm);
var SMALL_GLASS_PADDING = space[1];
// src/components/Planner/floors/FloorActions.tsx
import { useRef as useRef5 } from "react";
import styled4 from "styled-components";
import { Button as Button3, Field as Field4, Input as Input3 } from "@repo/design-system";
import { space as space2 } from "@repo/design-tokens";
import { useFloorplanStore as useFloorplanStore8 } from "@repo/front-end-state";
// src/components/CompositeMeasures/icons.tsx
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var base = {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    style: {
        fill: "none"
    },
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": true,
    focusable: "false"
};
var PencilIcon = function(param) {
    var className = param.className;
    return /* @__PURE__ */ jsxs("svg", _object_spread_props(_object_spread({}, base), {
        className: className,
        children: [
            /* @__PURE__ */ jsx2("path", {
                d: "M13.5 3.5l3 3L7 16H4v-3z"
            }),
            /* @__PURE__ */ jsx2("path", {
                d: "M11.5 5.5l3 3"
            })
        ]
    }));
};
var BinIcon = function(param) {
    var className = param.className;
    return /* @__PURE__ */ jsx2("svg", _object_spread_props(_object_spread({}, base), {
        className: className,
        children: /* @__PURE__ */ jsx2("path", {
            d: "M4 6h12M8 6V4h4v2M6 6l.8 10h6.4L14 6M8.5 9v4.5M11.5 9v4.5"
        })
    }));
};
// src/components/Planner/propertiesPanelParts.tsx
import styled from "styled-components";
import { isEntityCapacity } from "@repo/front-end-utils";
var PropertiesPanelDraggable = styled(DraggablePanel_default)(_templateObject10());
var PropertiesDragHeader = styled.div(_templateObject11(), function(param) {
    var t = param.theme;
    return "".concat(t.spacing[2.5], " ").concat(t.spacing[4]);
}, function(param) {
    var t = param.theme;
    return t.colors.neutral[300];
});
var PropertiesBody = styled.div(_templateObject12(), function(param) {
    var t = param.theme;
    return t.spacing[4];
});
var PanelTitle = styled.div(_templateObject13(), function(param) {
    var t = param.theme;
    return t.colors.neutral[600];
});
var Field = styled.label(_templateObject14(), function(param) {
    var t = param.theme;
    return t.colors.neutral[700];
});
var FieldBlock = styled.div(_templateObject15());
var FieldInput = styled.input(_templateObject16(), function(param) {
    var t = param.theme, $invalid = param.$invalid;
    return $invalid ? t.colors.error.DEFAULT : t.colors.neutral[300];
}, function(param) {
    var t = param.theme;
    return t.colors.white;
}, function(param) {
    var t = param.theme, $invalid = param.$invalid;
    return $invalid ? t.colors.error.DEFAULT : t.colors.neutral[800];
}, function(param) {
    var t = param.theme, $invalid = param.$invalid;
    return $invalid ? t.colors.error.DEFAULT : t.colors.brand.DEFAULT;
}, function(param) {
    var t = param.theme;
    return t.colors.neutral[100];
}, function(param) {
    var t = param.theme;
    return t.colors.neutral[500];
});
var capacityFromInput = function(input) {
    if (input.validity.badInput) return null;
    if (input.value === "") return {
        capacity: void 0
    };
    var value = Number(input.value);
    return isEntityCapacity(value) ? {
        capacity: value
    } : null;
};
var FieldNote = styled.span(_templateObject17(), function(param) {
    var t = param.theme;
    return t.colors.neutral[600];
});
var takenNameMessage = function(offer) {
    return "Already used on this twin. ".concat(offer, " is free.");
};
var freeNameButtonLabel = function(offer) {
    return "Use ".concat(offer);
};
// src/components/Planner/floors/useFloorActions.tsx
import { createContext as createContext4, useCallback as useCallback3, useContext as useContext4, useEffect as useEffect7, useMemo as useMemo5, useRef as useRef4, useState as useState6 } from "react";
import { Icon as Icon3, useToast } from "@repo/design-system";
import { isFloorMove, useEditorStore as useEditorStore5, useEquipmentCatalogStore as useEquipmentCatalogStore3, useFloorplanStore as useFloorplanStore7 } from "@repo/front-end-state";
import { buildFloorRemovalRecord, buildTwinNameIndex as buildTwinNameIndex2, countFloorContents as countFloorContents2, findLatestDesign as findLatestDesign3, isNameTaken as isNameTaken2, nextFreeName as nextFreeName2 } from "@repo/front-end-utils";
// src/components/Planner/hooks/useKeyboardShortcuts.ts
import { useEffect as useEffect6 } from "react";
import { useEditorStore as useEditorStore4, selectionOnFloorShown } from "@repo/front-end-state";
import { useFloorplanStore as useFloorplanStore4 } from "@repo/front-end-state";
import { asArray, findLatestDesign, isLive, layoutCurrentDesigns, observersOnRemovedCamera, removeCameraFromLayout, wallRunPresent, withAlignStateFrom, withFloorOrderFrom } from "@repo/front-end-utils";
// src/components/Planner/shortcuts.ts
var SHORTCUTS = {
    select: {
        keys: [
            "v"
        ],
        aria: "V",
        hint: "V"
    },
    drawSpace: {
        keys: [
            "a"
        ],
        aria: "A",
        hint: "A"
    },
    drawWall: {
        keys: [
            "w"
        ],
        aria: "W",
        hint: "W"
    },
    placeCamera: {
        keys: [
            "c"
        ],
        aria: "C",
        hint: "C"
    },
    zoomIn: {
        keys: [
            "=",
            "+"
        ],
        aria: "=",
        hint: "+"
    },
    zoomOut: {
        keys: [
            "-"
        ],
        aria: "-",
        hint: "-"
    }
};
var HISTORY_SHORTCUTS = {
    undo: {
        keys: [
            "z"
        ],
        aria: "Control+Z Meta+Z",
        hint: "Ctrl+Z"
    },
    redo: {
        keys: [
            "z",
            "y"
        ],
        aria: "Control+Shift+Z Meta+Shift+Z Control+Y",
        hint: "Ctrl+Shift+Z"
    }
};
var matches = function(shortcut, key) {
    return shortcut.keys.includes(key);
};
var PDF_ROW_SHORTCUTS = {
    moveUp: {
        keys: [
            "ArrowUp"
        ],
        aria: "Alt+ArrowUp",
        hint: "Alt+\u2191"
    },
    moveDown: {
        keys: [
            "ArrowDown"
        ],
        aria: "Alt+ArrowDown",
        hint: "Alt+\u2193"
    },
    duplicate: {
        keys: [
            "d",
            "D"
        ],
        aria: "Control+D Meta+D",
        hint: "Ctrl+D"
    }
};
var FLOOR_ROW_SHORTCUTS = {
    moveUp: PDF_ROW_SHORTCUTS.moveUp,
    moveDown: PDF_ROW_SHORTCUTS.moveDown
};
var FLOOR_ROW_ARIA_KEYSHORTCUTS = Object.values(FLOOR_ROW_SHORTCUTS).map(function(s) {
    return s.aria;
}).join(" ");
var FLOOR_ROW_REORDER_HINT = "Drag or Alt+\u2191/\u2193 to reorder.";
var POSITION_ROW_SHORTCUTS = {
    nudge: {
        keys: [
            "ArrowUp",
            "ArrowDown",
            "ArrowLeft",
            "ArrowRight"
        ],
        aria: "ArrowUp ArrowDown ArrowLeft ArrowRight",
        hint: "arrows move 10 cm"
    },
    turn: {
        keys: [
            "[",
            "]",
            "{",
            "}"
        ],
        aria: "[ ] Shift+[ Shift+]",
        hint: "[ and ] turn 1\xB0, with Shift 15\xB0"
    }
};
var POSITION_ROW_ARIA_KEYSHORTCUTS = Object.values(POSITION_ROW_SHORTCUTS).map(function(s) {
    return s.aria;
}).join(" ");
var turnDirection = function(e) {
    return e.code === "BracketLeft" || e.key === "[" || e.key === "{" ? 1 : e.code === "BracketRight" || e.key === "]" || e.key === "}" ? -1 : null;
};
var PDF_ROW_ARIA_KEYSHORTCUTS = Object.values(PDF_ROW_SHORTCUTS).map(function(s) {
    return s.aria;
}).join(" ");
// src/components/Planner/canvas/wallRunActions.ts
import { useEditorStore as useEditorStore3, useFloorplanStore as useFloorplanStore3 } from "@repo/front-end-state";
import { wallRunPresentIds } from "@repo/front-end-utils";
function finishWallRun() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_beforeToolChange = _ref.beforeToolChange, beforeToolChange = _ref_beforeToolChange === void 0 ? false : _ref_beforeToolChange;
    var _useFloorplanStore3_getState_getActiveDesign;
    var editor = useEditorStore3.getState();
    var run = editor.wallRun;
    if (!run) return false;
    var _useFloorplanStore3_getState_getActiveDesign_walls;
    var walls2 = (_useFloorplanStore3_getState_getActiveDesign_walls = (_useFloorplanStore3_getState_getActiveDesign = useFloorplanStore3.getState().getActiveDesign()) === null || _useFloorplanStore3_getState_getActiveDesign === void 0 ? void 0 : _useFloorplanStore3_getState_getActiveDesign.walls) !== null && _useFloorplanStore3_getState_getActiveDesign_walls !== void 0 ? _useFloorplanStore3_getState_getActiveDesign_walls : [];
    var present = wallRunPresentIds(run, walls2);
    editor.setWallRun(null);
    if (present.length > 0) editor.selectEntity(present[present.length - 1]);
    var sentence = wallRunEndSentence(present.length);
    if (beforeToolChange) prefixNextToolAnnouncement(sentence);
    else announcePlanSentence(sentence);
    return true;
}
function wallRunEndSentence(drawn) {
    return drawn === 0 ? "Wall drawing cancelled." : "Walls finished: ".concat(drawn, " drawn.");
}
// src/components/Planner/hooks/useKeyboardShortcuts.ts
var historyScopeFor = function(mutableKinds) {
    return {
        // `'nothing'` (Camera Feeds under a renderer that cannot edit cameras) keeps the history off, as
        // `'cameras'` does, AND refuses every change, as `'none'` does.
        camerasOnly: mutableKinds === "cameras" || mutableKinds === "nothing",
        locked: mutableKinds === "none" || mutableKinds === "nothing"
    };
};
var restoreSnapshot = function(layout) {
    var _store_layout;
    var store = useFloorplanStore4.getState();
    var _store_layout_floors;
    store.replaceLayout(layout, sameFloors((_store_layout_floors = (_store_layout = store.layout) === null || _store_layout === void 0 ? void 0 : _store_layout.floors) !== null && _store_layout_floors !== void 0 ? _store_layout_floors : [], layout.floors) ? void 0 : {
        activeFloorIndex: store.activeFloorIndex
    });
    var lastFloor = Math.max(0, layout.floors.length - 1);
    if (store.activeFloorIndex > lastFloor) store.setActiveFloor(lastFloor);
};
var sameFloors = function(floors, next) {
    var ids = new Set(floors.map(function(f) {
        return f.id;
    }));
    return floors.length === next.length && next.every(function(f) {
        return ids.has(f.id);
    });
};
var applyStep = function(current2, step) {
    return step.scope === "align" ? withAlignStateFrom(current2, step.layout) : step.scope === "floorOrder" ? withFloorOrderFrom(current2, step.layout) : step.layout;
};
var mayTake = function(stack, param) {
    var camerasOnly = param.camerasOnly, locked = param.locked;
    if (camerasOnly) return false;
    var top = useEditorStore4.getState().topScope(stack);
    if (top === "baseline") return false;
    if (locked && top !== "align" && top !== "floorOrder") return false;
    return true;
};
var pendingWallStart = function(param) {
    var camerasOnly = param.camerasOnly, locked = param.locked;
    var _useFloorplanStore4_getState_getActiveDesign;
    if (camerasOnly || locked) return false;
    var run = useEditorStore4.getState().wallRun;
    if (!run) return false;
    var _useFloorplanStore4_getState_getActiveDesign_walls;
    var walls2 = (_useFloorplanStore4_getState_getActiveDesign_walls = (_useFloorplanStore4_getState_getActiveDesign = useFloorplanStore4.getState().getActiveDesign()) === null || _useFloorplanStore4_getState_getActiveDesign === void 0 ? void 0 : _useFloorplanStore4_getState_getActiveDesign.walls) !== null && _useFloorplanStore4_getState_getActiveDesign_walls !== void 0 ? _useFloorplanStore4_getState_getActiveDesign_walls : [];
    return wallRunPresent(run, walls2) === 0;
};
var canUndoPlan = function(scope) {
    return pendingWallStart(scope) || mayTake("undo", scope) && useEditorStore4.getState().undoStack.length > 0;
};
var canRedoPlan = function(scope) {
    return mayTake("redo", scope) && useEditorStore4.getState().redoStack.length > 0;
};
var undoPlan = function(scope) {
    if (pendingWallStart(scope)) {
        useEditorStore4.getState().setWallRun(null);
        announcePlanSentence(wallRunEndSentence(0));
        return true;
    }
    return undoPlanStep(scope);
};
var undoPlanStep = function(scope) {
    if (!mayTake("undo", scope)) return false;
    var layout = useFloorplanStore4.getState().layout;
    if (!layout) return false;
    var snapshot = useEditorStore4.getState().undo(layout);
    if (!snapshot) return false;
    restoreSnapshot(applyStep(layout, snapshot));
    announcePlanHistory("Undone.");
    return true;
};
var redoPlan = function(scope) {
    if (!mayTake("redo", scope)) return false;
    var layout = useFloorplanStore4.getState().layout;
    if (!layout) return false;
    if (useEditorStore4.getState().redoStack.length === 0) return false;
    var run = useEditorStore4.getState().wallRun;
    if (run && run.committed.length === 0) useEditorStore4.getState().setWallRun(null);
    var snapshot = useEditorStore4.getState().redo(layout);
    if (!snapshot) return false;
    restoreSnapshot(applyStep(layout, snapshot));
    announcePlanHistory("Redone.");
    return true;
};
var liveCount = function(layout, kind) {
    return layoutCurrentDesigns(layout).reduce(function(n, d) {
        return n + (kind === "cameras" ? asArray(d === null || d === void 0 ? void 0 : d.cameras) : asArray(d === null || d === void 0 ? void 0 : d.observers)).filter(isLive).length;
    }, 0);
};
var liveObserverCount = function(layout) {
    return liveCount(layout, "observers");
};
function planPlannerDeletion(ids, camerasOnly, floorIndex) {
    var layout = useFloorplanStore4.getState().layout;
    var design = deletionDesign(floorIndex);
    var isCamera = function(id) {
        var _design_cameras;
        return !!(design === null || design === void 0 ? void 0 : (_design_cameras = design.cameras) === null || _design_cameras === void 0 ? void 0 : _design_cameras.some(function(c) {
            return c.refid === id;
        }));
    };
    var acted = camerasOnly ? ids.filter(isCamera) : _to_consumable_array(ids);
    var cameraRefids = acted.filter(isCamera);
    var observers = [];
    var simulated = layout;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = cameraRefids[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var refid = _step.value;
            var _observers;
            (_observers = observers).push.apply(_observers, _to_consumable_array(observersOnRemovedCamera(simulated, refid)));
            simulated = removeCameraFromLayout(simulated, refid).layout;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var cameraObserverCount = observers.length;
    var targets = new Set(acted.filter(function(id) {
        return !isCamera(id) && !id.startsWith("wall-");
    }));
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = asArray(design === null || design === void 0 ? void 0 : design.observers).filter(isLive)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var o = _step1.value;
            if ((o.targetKind === "item" || o.targetKind === "surface") && targets.has(o.targetRefid) && !observers.includes(o)) observers.push(o);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return _object_spread({
        ids: acted,
        cameraRefids: cameraRefids,
        observers: observers,
        cameraObserverCount: cameraObserverCount
    }, floorIndex != null ? {
        floorIndex: floorIndex
    } : {});
}
var deletionDesign = function(floorIndex) {
    var _plan_layout;
    var plan = useFloorplanStore4.getState();
    if (floorIndex == null) return plan.getActiveDesign();
    var floor = (_plan_layout = plan.layout) === null || _plan_layout === void 0 ? void 0 : _plan_layout.floors[floorIndex];
    return floor ? findLatestDesign(floor.designs) : null;
};
var observerKey = function(o) {
    var _o_rtspEndpointId;
    return "".concat(o.refid, "\0").concat(o.targetRefid, "\0").concat((_o_rtspEndpointId = o.rtspEndpointId) !== null && _o_rtspEndpointId !== void 0 ? _o_rtspEndpointId : "");
};
var sameObserversRemoved = function(a, b) {
    if (a.observers.length !== b.observers.length) return false;
    var keys = function(r) {
        return r.observers.map(observerKey).sort();
    };
    var _ref = [
        keys(a),
        keys(b)
    ], x = _ref[0], y = _ref[1];
    return x.every(function(k, i) {
        return k === y[i];
    });
};
function applyPlannerDeletion(request, param) {
    var camerasOnly = param.camerasOnly, onObserversRemoved = param.onObserversRemoved, onCameraEdited = param.onCameraEdited, promote = param.promote;
    var floorplan = useFloorplanStore4.getState();
    var editor = useEditorStore4.getState();
    var design = deletionDesign(request.floorIndex);
    var on = request.floorIndex != null ? {
        floorIndex: request.floorIndex
    } : void 0;
    var before = floorplan.layout;
    var surfaceIds = request.ids.filter(function(id) {
        return !!(design === null || design === void 0 ? void 0 : design.surfaces.some(function(s) {
            return s.refid === id;
        }));
    });
    var promotion;
    if (surfaceIds.length > 0) {
        var removed = floorplan.removeSurfaces(surfaceIds, promote || on ? _object_spread({}, promote ? {
            promote: promote
        } : {}, on) : void 0);
        if (!removed.ok) return {
            refused: removed.message
        };
        promotion = removed.promotion;
    }
    if (!camerasOnly && (request.ids.some(function(id) {
        return !request.cameraRefids.includes(id);
    }) || request.observers.length > 0)) {
        if (before) editor.pushSnapshot(before);
    }
    var removedWall = false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = request.ids[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var id = _step.value;
            if (id.startsWith("wall-")) {
                floorplan.removeWall(id);
                removedWall = true;
            } else if (surfaceIds.includes(id)) {} else if (request.cameraRefids.includes(id)) {
                floorplan.removeCamera(id);
            } else {
                if (on) floorplan.removeItem(id, on);
                else floorplan.removeItem(id);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (removedWall && editor.wallRun) editor.setWallRun(null);
    editor.clearSelection();
    var after = useFloorplanStore4.getState().layout;
    if (liveObserverCount(after) < liveObserverCount(before)) {
        onObserversRemoved === null || onObserversRemoved === void 0 ? void 0 : onObserversRemoved();
    }
    if (liveCount(after, "cameras") < liveCount(before, "cameras")) {
        onCameraEdited === null || onCameraEdited === void 0 ? void 0 : onCameraEdited();
    }
    return {
        promotion: promotion
    };
}
function useKeyboardShortcuts() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_disableDrawWall = _ref.disableDrawWall, disableDrawWall = _ref_disableDrawWall === void 0 ? false : _ref_disableDrawWall, _ref_disableDrawSpace = _ref.disableDrawSpace, disableDrawSpace = _ref_disableDrawSpace === void 0 ? false : _ref_disableDrawSpace, _ref_disableCameraTool = _ref.disableCameraTool, disableCameraTool = _ref_disableCameraTool === void 0 ? false : _ref_disableCameraTool, _ref_mutableKinds = _ref.mutableKinds, mutableKinds = _ref_mutableKinds === void 0 ? "all" : _ref_mutableKinds, onConfirmDelete = _ref.onConfirmDelete, onObserversRemoved = _ref.onObserversRemoved, onCameraEdited = _ref.onCameraEdited, _ref_itemDeleteRequests = _ref.itemDeleteRequests, itemDeleteRequests = _ref_itemDeleteRequests === void 0 ? false : _ref_itemDeleteRequests;
    var _historyScopeFor = historyScopeFor(mutableKinds), camerasOnly = _historyScopeFor.camerasOnly, locked = _historyScopeFor.locked;
    var setToolMode = useEditorStore4(function(s) {
        return s.setToolMode;
    });
    var clearSelection = useEditorStore4(function(s) {
        return s.clearSelection;
    });
    var toggleGridSnap = useEditorStore4(function(s) {
        return s.toggleGridSnap;
    });
    var selectedEntityIds = useEditorStore4(selectionOnFloorShown);
    var zoom = useEditorStore4(function(s) {
        return s.zoom;
    });
    var setZoom = useEditorStore4(function(s) {
        return s.setZoom;
    });
    var updateItem = useFloorplanStore4(function(s) {
        return s.updateItem;
    });
    var updateCamera = useFloorplanStore4(function(s) {
        return s.updateCamera;
    });
    useEffect6(function() {
        var handleKeyDown = function(e) {
            var _target_closest, _target_closest1;
            var target = e.target;
            if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.tagName === "SELECT" || target.isContentEditable) {
                return;
            }
            if ((_target_closest = target.closest) === null || _target_closest === void 0 ? void 0 : _target_closest.call(target, '[role="dialog"]')) return;
            if ((_target_closest1 = target.closest) === null || _target_closest1 === void 0 ? void 0 : _target_closest1.call(target, '[role="combobox"], [role="listbox"], [data-planner-shortcuts="off"]')) return;
            var ctrl = e.ctrlKey || e.metaKey;
            var key = e.key.toLowerCase();
            if (ctrl && key === "z" && !e.shiftKey) {
                var scope = {
                    camerasOnly: camerasOnly,
                    locked: locked
                };
                if (!pendingWallStart(scope) && !mayTake("undo", scope)) return;
                e.preventDefault();
                undoPlan(scope);
                return;
            }
            if (ctrl && key === "z" && e.shiftKey || ctrl && key === "y") {
                var scope1 = {
                    camerasOnly: camerasOnly,
                    locked: locked
                };
                if (!mayTake("redo", scope1)) return;
                e.preventDefault();
                redoPlan(scope1);
                return;
            }
            if (e.key === "Delete" || e.key === "Backspace") {
                if (locked) return;
                if (useEditorStore4.getState().heldSelectionFloor !== null) return;
                if (itemDeleteRequests && !camerasOnly && selectedEntityIds.length > 0) {
                    var design = useFloorplanStore4.getState().getActiveDesign();
                    var isSpace = function(id) {
                        return !!(design === null || design === void 0 ? void 0 : design.surfaces.some(function(s) {
                            return s.refid === id && isLive(s);
                        }));
                    };
                    var _selectedEntityIds = _sliced_to_array(selectedEntityIds, 1), only = _selectedEntityIds[0];
                    if (selectedEntityIds.some(isSpace) || selectedEntityIds.length === 1 && !!(design === null || design === void 0 ? void 0 : design.items.some(function(i) {
                        return i.refid === only && isLive(i);
                    }))) {
                        useEditorStore4.getState().requestItemDelete(_to_consumable_array(selectedEntityIds));
                        return;
                    }
                }
                var request = planPlannerDeletion(selectedEntityIds, camerasOnly);
                if (request.cameraObserverCount > 0 && onConfirmDelete) {
                    onConfirmDelete(request);
                    return;
                }
                applyPlannerDeletion(request, {
                    camerasOnly: camerasOnly,
                    onObserversRemoved: onObserversRemoved,
                    onCameraEdited: onCameraEdited
                });
                return;
            }
            if (e.key === "Escape") {
                if (!finishWallRun({
                    beforeToolChange: true
                })) clearSelection();
                setToolMode("select");
                return;
            }
            if (matches(SHORTCUTS.select, e.key)) {
                setToolMode("select");
                return;
            }
            if (matches(SHORTCUTS.drawSpace, e.key) && !disableDrawSpace) {
                setToolMode("draw_space");
                clearSelection();
                return;
            }
            if (matches(SHORTCUTS.drawWall, e.key) && !disableDrawWall) {
                setToolMode("draw_wall");
                clearSelection();
                return;
            }
            if (matches(SHORTCUTS.placeCamera, e.key) && !ctrl && !disableCameraTool) {
                setToolMode("place_camera");
                clearSelection();
                return;
            }
            if (e.key === "g") {
                toggleGridSnap();
                return;
            }
            if (e.key === "r" && selectedEntityIds.length > 0) {
                if (locked) return;
                var _useEditorStore4_getState = useEditorStore4.getState(), storeOriginalPosition = _useEditorStore4_getState.storeOriginalPosition, markEntityModified = _useEditorStore4_getState.markEntityModified, pushSnapshot = _useEditorStore4_getState.pushSnapshot;
                var before = useFloorplanStore4.getState();
                var turnsSomething = selectedEntityIds.some(function(id) {
                    var _design_cameras;
                    var design = before.getActiveDesign();
                    return !camerasOnly && !!(design === null || design === void 0 ? void 0 : design.items.some(function(i) {
                        return i.refid === id;
                    })) || !!(design === null || design === void 0 ? void 0 : (_design_cameras = design.cameras) === null || _design_cameras === void 0 ? void 0 : _design_cameras.some(function(c) {
                        return c.refid === id;
                    }));
                });
                if (turnsSomething && before.layout && !camerasOnly) pushSnapshot(before.layout);
                var turnedCamera = false;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _loop = function() {
                        var id = _step.value;
                        var _design_cameras;
                        var design = useFloorplanStore4.getState().getActiveDesign();
                        var item = camerasOnly ? void 0 : design === null || design === void 0 ? void 0 : design.items.find(function(i) {
                            return i.refid === id;
                        });
                        if (item) {
                            storeOriginalPosition(id, item.x, item.y);
                            updateItem(id, {
                                rotation: (item.rotation + 90) % 360
                            });
                            markEntityModified(id);
                            return "continue";
                        }
                        var camera = design === null || design === void 0 ? void 0 : (_design_cameras = design.cameras) === null || _design_cameras === void 0 ? void 0 : _design_cameras.find(function(c) {
                            return c.refid === id;
                        });
                        if (camera) {
                            storeOriginalPosition(id, camera.x, camera.y);
                            updateCamera(id, {
                                rotation: (camera.rotation + 90) % 360
                            });
                            markEntityModified(id);
                            turnedCamera = true;
                        }
                    };
                    for(var _iterator = selectedEntityIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (turnedCamera) onCameraEdited === null || onCameraEdited === void 0 ? void 0 : onCameraEdited();
                return;
            }
            if (matches(SHORTCUTS.zoomIn, e.key)) {
                setZoom(zoom + 0.1);
                return;
            }
            if (matches(SHORTCUTS.zoomOut, e.key)) {
                setZoom(zoom - 0.1);
                return;
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return function() {
            return window.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        setToolMode,
        clearSelection,
        toggleGridSnap,
        selectedEntityIds,
        zoom,
        setZoom,
        updateItem,
        disableDrawWall,
        disableDrawSpace,
        disableCameraTool,
        camerasOnly,
        locked,
        updateCamera,
        onConfirmDelete,
        onObserversRemoved,
        onCameraEdited,
        itemDeleteRequests
    ]);
}
// src/components/Planner/floors/AddFloorDialog.tsx
import { useMemo as useMemo3, useRef as useRef3, useState as useState4 } from "react";
import styled2 from "styled-components";
import { Button, Field as Field2, Icon, Input, Modal, RadioCard, RadioGroup, Select } from "@repo/design-system";
import { inset } from "@repo/design-tokens";
import { useEquipmentCatalogStore as useEquipmentCatalogStore2, useFloorplanStore as useFloorplanStore5 } from "@repo/front-end-state";
import { buildTwinNameIndex, defaultFloorName, findLatestDesign as findLatestDesign2, isNameTaken, nameForNewcomer, nextFreeName } from "@repo/front-end-utils";
import { Fragment, jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var wallCount = function(floor) {
    var _floor_designs, _findLatestDesign2_walls;
    return ((_findLatestDesign2_walls = findLatestDesign2((_floor_designs = floor.designs) !== null && _floor_designs !== void 0 ? _floor_designs : []).walls) !== null && _findLatestDesign2_walls !== void 0 ? _findLatestDesign2_walls : []).length;
};
var walls = function(n) {
    return "".concat(n, " ").concat(n === 1 ? "wall" : "walls");
};
function AddFloorDialog(param) {
    var onClose = param.onClose, onAdd = param.onAdd;
    var layout = useFloorplanStore5(function(s) {
        return s.layout;
    });
    var registerRows = useEquipmentCatalogStore2(function(s) {
        return s.registerRows;
    });
    var floors = useMemo3(function() {
        var _layout_floors;
        return (_layout_floors = layout === null || layout === void 0 ? void 0 : layout.floors) !== null && _layout_floors !== void 0 ? _layout_floors : [];
    }, [
        layout
    ]);
    var index = useMemo3(function() {
        return buildTwinNameIndex(layout, registerRows);
    }, [
        layout,
        registerRows
    ]);
    var walled = floors.filter(function(f) {
        return wallCount(f) > 0;
    });
    var defaultSource = walled[walled.length - 1];
    var _useState4 = _sliced_to_array(useState4(defaultSource ? "footprint" : "blank"), 2), option = _useState4[0], setOption = _useState4[1];
    var _useState41 = _sliced_to_array(useState4(defaultSource === null || defaultSource === void 0 ? void 0 : defaultSource.id), 2), sourceId = _useState41[0], setSourceId = _useState41[1];
    var _useState42 = _sliced_to_array(useState4(function() {
        return nameForNewcomer(defaultFloorName(floors.length), "floor", index).name;
    }), 2), name = _useState42[0], setName = _useState42[1];
    var nameRef = useRef3(null);
    var trimmed2 = name.trim();
    var taken = trimmed2 !== "" && isNameTaken(trimmed2, index);
    var offer = taken ? nextFreeName(trimmed2, index) : null;
    var message = trimmed2 === "" ? "A floor needs a name." : offer ? takenNameMessage(offer) : void 0;
    var error = message ? /* @__PURE__ */ jsx3("span", {
        role: "alert",
        children: message
    }) : void 0;
    var canAdd = trimmed2 !== "" && !taken && (option === "blank" || sourceId !== void 0);
    var submit = function() {
        if (!canAdd) return;
        onAdd({
            name: trimmed2,
            source: option === "footprint" && sourceId !== void 0 ? {
                kind: "footprint",
                floorId: sourceId
            } : {
                kind: "blank"
            }
        });
    };
    return /* @__PURE__ */ jsx3(Modal, {
        open: true,
        onClose: onClose,
        title: "Add a floor",
        tone: "cyan",
        width: "md",
        icon: /* @__PURE__ */ jsx3(Icon, {
            name: "layer-group"
        }),
        actions: /* @__PURE__ */ jsxs2(Fragment, {
            children: [
                /* @__PURE__ */ jsx3(Button, {
                    type: "button",
                    variant: "frosted",
                    onClick: onClose,
                    children: "Cancel"
                }),
                /* @__PURE__ */ jsx3(Button, {
                    type: "button",
                    variant: "primary",
                    iconLeft: /* @__PURE__ */ jsx3(Icon, {
                        name: "plus"
                    }),
                    disabled: !canAdd,
                    onClick: submit,
                    children: "Add Floor"
                })
            ]
        }),
        children: /* @__PURE__ */ jsxs2(Body, {
            children: [
                /* @__PURE__ */ jsx3("p", {
                    children: "Name it and choose what it starts with. You can align it with the floor below at any time in Manage floors."
                }),
                /* @__PURE__ */ jsxs2(RadioGroup, {
                    label: "What the floor starts with",
                    variant: "card",
                    value: option,
                    onChange: function(v) {
                        return setOption(v === "footprint" ? "footprint" : "blank");
                    },
                    children: [
                        /* @__PURE__ */ jsx3(RadioCard, {
                            value: "footprint",
                            title: "Duplicate a footprint",
                            description: "Copies the walls only, no spaces or equipment, and places the new floor exactly over its source.",
                            disabled: walled.length === 0,
                            children: /* @__PURE__ */ jsx3(Select, {
                                ariaLabel: "Source floor",
                                size: "compact",
                                value: sourceId === void 0 ? void 0 : String(sourceId),
                                onChange: function(v) {
                                    return setSourceId(Number(v));
                                },
                                options: floors.map(function(f) {
                                    return {
                                        value: String(f.id),
                                        label: "".concat(f.name, " \xb7 ").concat(walls(wallCount(f))),
                                        icon: /* @__PURE__ */ jsx3(Icon, {
                                            name: "layer-group"
                                        }),
                                        // A floor with no walls has no footprint to copy.
                                        disabled: wallCount(f) === 0
                                    };
                                })
                            })
                        }),
                        /* @__PURE__ */ jsx3(RadioCard, {
                            value: "blank",
                            title: "Blank floor",
                            description: "An empty floor, positioned over the one below."
                        })
                    ]
                }),
                /* @__PURE__ */ jsx3(Field2, {
                    label: "Name",
                    helper: "Unique in the twin.",
                    error: error,
                    children: function(wiring) {
                        return /* @__PURE__ */ jsx3(Input, {
                            ref: nameRef,
                            id: wiring.id,
                            "aria-describedby": wiring["aria-describedby"],
                            "aria-invalid": wiring.invalid || void 0,
                            invalid: wiring.invalid,
                            value: name,
                            valid: trimmed2 !== "" && !taken,
                            validLabel: "Name is free",
                            onChange: function(e) {
                                return setName(e.target.value);
                            },
                            onKeyDown: function(e) {
                                if (e.key === "Enter") {
                                    e.preventDefault();
                                    submit();
                                }
                            }
                        });
                    }
                }),
                offer && /* @__PURE__ */ jsx3(OfferRow, {
                    children: /* @__PURE__ */ jsx3(Button, {
                        type: "button",
                        variant: "frosted",
                        size: "xs",
                        onClick: function() {
                            var _nameRef_current;
                            setName(offer);
                            (_nameRef_current = nameRef.current) === null || _nameRef_current === void 0 ? void 0 : _nameRef_current.focus();
                        },
                        children: freeNameButtonLabel(offer)
                    })
                })
            ]
        })
    });
}
var Body = styled2.div(_templateObject18(), inset[4]);
var OfferRow = styled2.div(_templateObject19(), inset[2]);
// src/components/Planner/floors/DeleteFloorDialog.tsx
import { useMemo as useMemo4, useState as useState5 } from "react";
import styled3 from "styled-components";
import { Button as Button2, Field as Field3, Icon as Icon2, Input as Input2, Modal as Modal2 } from "@repo/design-system";
import { inset as inset2 } from "@repo/design-tokens";
import { useFloorplanStore as useFloorplanStore6 } from "@repo/front-end-state";
import { countFloorContents, floorDeleteSentence } from "@repo/front-end-utils";
import { Fragment as Fragment2, jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var plural = function(n, one) {
    var many = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "".concat(one, "s");
    return "".concat(n, " ").concat(n === 1 ? one : many);
};
var deleteFloorCopy = function(name, counts, launched) {
    var phrase = floorDeleteSentence(counts);
    var lines = [
        phrase ? "Everything on it comes off when the twin is launched: ".concat(phrase, ". Their history stays in reports, but they stop counting.") : "Nothing is drawn on it."
    ];
    if (counts.composites > 0) lines.push("".concat(plural(counts.composites, "composite measure"), " ").concat(counts.composites === 1 ? "loses" : "lose", " parts of ").concat(counts.composites === 1 ? "its total" : "their totals", "."));
    if (counts.otherFloorObservers > 0) lines.push("Its cameras also take ".concat(plural(counts.otherFloorObservers, "camera region"), " drawn on their feeds on other floors."));
    if (launched === "unknown") lines.push("We could not check whether this floor is live, so it is treated as live.");
    return {
        title: "Delete ".concat(name, " from the live twin?"),
        lines: lines
    };
};
function DeleteFloorDialog(param) {
    var index = param.index, launched = param.launched, onKeep = param.onKeep, onDelete = param.onDelete, returnFocusTo = param.returnFocusTo;
    var _layout_floors_index;
    var layout = useFloorplanStore6(function(s) {
        return s.layout;
    });
    var _layout_floors_index_name;
    var name = ((_layout_floors_index_name = layout === null || layout === void 0 ? void 0 : (_layout_floors_index = layout.floors[index]) === null || _layout_floors_index === void 0 ? void 0 : _layout_floors_index.name) !== null && _layout_floors_index_name !== void 0 ? _layout_floors_index_name : "").trim();
    var _useState5 = _sliced_to_array(useState5(""), 2), typed = _useState5[0], setTyped = _useState5[1];
    var matches2 = name !== "" && typed.trim() === name;
    var counts = useMemo4(function() {
        return countFloorContents(layout, index);
    }, [
        layout,
        index
    ]);
    var copy = useMemo4(function() {
        return deleteFloorCopy(name, counts, launched);
    }, [
        name,
        counts,
        launched
    ]);
    return /* @__PURE__ */ jsx4(Modal2, {
        open: true,
        onClose: onKeep,
        returnFocusTo: returnFocusTo,
        title: copy.title,
        tone: "coral",
        width: "md",
        icon: /* @__PURE__ */ jsx4(Icon2, {
            name: "trash-can"
        }),
        actions: /* @__PURE__ */ jsxs3(Fragment2, {
            children: [
                /* @__PURE__ */ jsxs3(Button2, {
                    type: "button",
                    variant: "frosted",
                    autoFocus: true,
                    onClick: onKeep,
                    children: [
                        "Keep ",
                        name
                    ]
                }),
                /* @__PURE__ */ jsx4(Button2, {
                    type: "button",
                    variant: "destructive",
                    iconLeft: /* @__PURE__ */ jsx4(Icon2, {
                        name: "trash-can"
                    }),
                    disabled: !matches2,
                    onClick: function() {
                        if (matches2) onDelete();
                    },
                    children: "Delete Floor"
                })
            ]
        }),
        children: /* @__PURE__ */ jsxs3(Body2, {
            children: [
                copy.lines.map(function(line3) {
                    return /* @__PURE__ */ jsx4("p", {
                        children: line3
                    }, line3);
                }),
                /* @__PURE__ */ jsx4(Field3, {
                    label: "Type ".concat(name, " to confirm"),
                    helper: "The floor can be put back until the twin is launched.",
                    children: function(wiring) {
                        return /* @__PURE__ */ jsx4(Input2, {
                            id: wiring.id,
                            "aria-describedby": wiring["aria-describedby"],
                            value: typed,
                            valid: matches2,
                            validTone: "danger",
                            validLabel: "Name matches",
                            autoComplete: "off",
                            onChange: function(e) {
                                return setTyped(e.target.value);
                            },
                            onKeyDown: function(e) {
                                if (e.key === "Enter" && matches2) {
                                    e.preventDefault();
                                    onDelete();
                                }
                            }
                        });
                    }
                })
            ]
        })
    });
}
var Body2 = styled3.div(_templateObject20(), inset2[3]);
// src/components/Planner/floors/floorSentences.ts
var floorMovedSentence = function(name) {
    return "".concat(name, " moved.");
};
var floorRotatedSentence = function(name, degrees) {
    return "".concat(name, " rotated to ").concat(degrees, "\xb0.");
};
var floorMovedPlaceSentence = function(name, below) {
    return below ? "".concat(name, " moved. It now sits above ").concat(below, ".") : "".concat(name, " moved to the ground.");
};
var floorAlreadyGroundSentence = function(name) {
    return "".concat(name, " is already the ground floor.");
};
var floorAlreadyTopSentence = function(name) {
    return "".concat(name, " is already the top floor.");
};
var FLOOR_REORDER_SEARCHING_SENTENCE = "Clear the search to reorder floors.";
// src/components/Planner/floors/useFloorActions.tsx
import { jsx as jsx5, jsxs as jsxs4 } from "react/jsx-runtime";
var FloorActionsContext = createContext4(null);
var recordFloorStep = function() {
    var layout = useFloorplanStore7.getState().layout;
    if (layout) useEditorStore5.getState().pushSnapshot(layout);
};
var commitFloorRename = function(index, draft) {
    var _plan_layout;
    var name = draft.trim();
    var plan = useFloorplanStore7.getState();
    var floor = (_plan_layout = plan.layout) === null || _plan_layout === void 0 ? void 0 : _plan_layout.floors[index];
    var current2 = floor === null || floor === void 0 ? void 0 : floor.name;
    if (!name || !floor || current2 === void 0 || name === current2) return {
        renamed: false
    };
    var names = buildTwinNameIndex2(plan.layout, useEquipmentCatalogStore3.getState().registerRows);
    var self = {
        name: current2,
        kind: "floor",
        ref: {
            type: "floor",
            floorId: floor.id
        }
    };
    if (isNameTaken2(name, names, self)) {
        return {
            renamed: false,
            taken: {
                offer: nextFreeName2(name, names)
            }
        };
    }
    recordFloorStep();
    plan.renameFloor(index, name);
    return {
        renamed: true
    };
};
var commitFloorMove = function(from, to) {
    var _plan_layout, _useFloorplanStore7_getState_layout_floors_, _useFloorplanStore7_getState_layout;
    var plan = useFloorplanStore7.getState();
    var floors = (_plan_layout = plan.layout) === null || _plan_layout === void 0 ? void 0 : _plan_layout.floors;
    if (!floors || !isFloorMove(floors.length, from, to)) return null;
    var name = floors[from].name;
    useEditorStore5.getState().pushSnapshot(plan.layout, "floorOrder");
    plan.moveFloor(from, to);
    var below = (_useFloorplanStore7_getState_layout = useFloorplanStore7.getState().layout) === null || _useFloorplanStore7_getState_layout === void 0 ? void 0 : (_useFloorplanStore7_getState_layout_floors_ = _useFloorplanStore7_getState_layout.floors[to - 1]) === null || _useFloorplanStore7_getState_layout_floors_ === void 0 ? void 0 : _useFloorplanStore7_getState_layout_floors_.name;
    return {
        index: to,
        sentence: floorMovedPlaceSentence(name, below)
    };
};
var ToastBridge = function(param) {
    var into = param.into, region = param.region;
    var api = useToast();
    useEffect7(function() {
        into.current = region ? _object_spread_props(_object_spread({}, api), {
            show: function(options) {
                return api.show(_object_spread({
                    region: region
                }, options));
            }
        }) : api;
        return function() {
            into.current = null;
        };
    }, [
        api,
        into,
        region
    ]);
    return null;
};
var FloorActionsProvider = function(param) {
    var children = param.children, onObserversRemoved = param.onObserversRemoved, _param_floorDialogs = param.floorDialogs, floorDialogs = _param_floorDialogs === void 0 ? "classic" : _param_floorDialogs, floorLaunched = param.floorLaunched, toastRegion = param.toastRegion;
    var removeFloor = useFloorplanStore7(function(s) {
        return s.removeFloor;
    });
    var removeLaunchedFloor = useFloorplanStore7(function(s) {
        return s.removeLaunchedFloor;
    });
    var restoreFloor = useFloorplanStore7(function(s) {
        return s.restoreFloor;
    });
    var addFloor = useFloorplanStore7(function(s) {
        return s.addFloor;
    });
    var _useConfirm = useConfirm(), confirm = _useConfirm.confirm, dialog = _useConfirm.dialog;
    var toastRef = useRef4(null);
    var deleteOpenerRef = useRef4(null);
    var _useState6 = _sliced_to_array(useState6(null), 2), renaming = _useState6[0], setRenaming = _useState6[1];
    var renamingIndex = useFloorplanStore7(function(s) {
        var _s_layout;
        var _s_layout_floors_findIndex;
        return renaming ? (_s_layout_floors_findIndex = (_s_layout = s.layout) === null || _s_layout === void 0 ? void 0 : _s_layout.floors.findIndex(function(f) {
            return f.id === renaming.floorId;
        })) !== null && _s_layout_floors_findIndex !== void 0 ? _s_layout_floors_findIndex : -1 : -1;
    });
    var editing = useMemo5(function() {
        return renaming && renamingIndex >= 0 ? {
            index: renamingIndex,
            surface: renaming.surface
        } : null;
    }, [
        renaming,
        renamingIndex
    ]);
    var _useState61 = _sliced_to_array(useState6(""), 2), draftName = _useState61[0], setDraftNameState = _useState61[1];
    var _useState62 = _sliced_to_array(useState6(null), 2), renameOffer = _useState62[0], setRenameOffer = _useState62[1];
    var setDraftName = useCallback3(function(name) {
        setDraftNameState(name);
        setRenameOffer(null);
    }, []);
    var _useState63 = _sliced_to_array(useState6(null), 2), adding = _useState63[0], setAdding = _useState63[1];
    var _useState64 = _sliced_to_array(useState6(null), 2), deleting = _useState64[0], setDeleting = _useState64[1];
    var restoreRef = useRef4(void 0);
    var close = useCallback3(function() {
        setRenaming(null);
        setRenameOffer(null);
        var fn = restoreRef.current;
        restoreRef.current = void 0;
        if (fn) {
            setTimeout(function() {
                var active = document.activeElement;
                if (!active || active === document.body) fn();
            }, 0);
        }
    }, []);
    var startRename = useCallback3(function(index, surface11, restoreFocus) {
        var _useFloorplanStore7_getState_layout;
        var floor = (_useFloorplanStore7_getState_layout = useFloorplanStore7.getState().layout) === null || _useFloorplanStore7_getState_layout === void 0 ? void 0 : _useFloorplanStore7_getState_layout.floors[index];
        if (!floor) return;
        setRenaming({
            floorId: floor.id,
            surface: surface11
        });
        setDraftNameState(floor.name);
        setRenameOffer(null);
        restoreRef.current = restoreFocus;
    }, []);
    var commitRename = useCallback3(function() {
        if (!editing) return;
        var result = commitFloorRename(editing.index, draftName);
        if (!result.renamed && result.taken) {
            setRenameOffer(result.taken.offer);
            return;
        }
        close();
    }, [
        editing,
        draftName,
        close
    ]);
    var takeRenameOffer = useCallback3(function() {
        if (!editing || renameOffer === null) return;
        commitFloorRename(editing.index, renameOffer);
        close();
    }, [
        editing,
        renameOffer,
        close
    ]);
    var cancelRename = useCallback3(function() {
        if (!editing) return;
        close();
    }, [
        editing,
        close
    ]);
    var asFloorDelete = useCallback3(function(remove) {
        recordFloorStep();
        var before = liveObserverCount(useFloorplanStore7.getState().layout);
        var out = remove();
        if (liveObserverCount(useFloorplanStore7.getState().layout) < before) onObserversRemoved === null || onObserversRemoved === void 0 ? void 0 : onObserversRemoved();
        return out;
    }, [
        onObserversRemoved
    ]);
    var removeNow = useCallback3(function(index) {
        return asFloorDelete(function() {
            return removeFloor(index);
        });
    }, [
        asFloorDelete,
        removeFloor
    ]);
    var requestDelete = useCallback3(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(index) {
            var layout, _layout_floors, floors, floor, launched, record, name, _toastRef_current, lostElsewhere, ok;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        layout = useFloorplanStore7.getState().layout;
                        floors = (_layout_floors = layout === null || layout === void 0 ? void 0 : layout.floors) !== null && _layout_floors !== void 0 ? _layout_floors : [];
                        floor = floors[index];
                        if (!floor || floors.length <= 1) return [
                            2,
                            false
                        ];
                        if (floorDialogs === "page") {
                            launched = floorLaunched ? floorLaunched(floor) : "unknown";
                            if (launched === false) {
                                record = buildFloorRemovalRecord(layout, index);
                                removeNow(index);
                                name = floor.name;
                                if (record) {
                                    ;
                                    (_toastRef_current = toastRef.current) === null || _toastRef_current === void 0 ? void 0 : _toastRef_current.show({
                                        tone: "success",
                                        icon: /* @__PURE__ */ jsx5(Icon3, {
                                            name: "trash-can"
                                        }),
                                        title: "Deleted ".concat(name),
                                        inlineAction: {
                                            label: "Undo",
                                            onAction: function() {
                                                recordFloorStep();
                                                var result = restoreFloor(record);
                                                if (result && "blocked" in result) {
                                                    var _toastRef_current;
                                                    (_toastRef_current = toastRef.current) === null || _toastRef_current === void 0 ? void 0 : _toastRef_current.show({
                                                        tone: "error",
                                                        icon: /* @__PURE__ */ jsx5(Icon3, {
                                                            name: "triangle-exclamation"
                                                        }),
                                                        title: "".concat(name, " could not be put back"),
                                                        detail: "Something added since uses ".concat(result.blocked.length === 1 ? "one of its codes" : "".concat(result.blocked.length, " of its codes"), " (").concat(result.blocked.slice(0, 3).join(", "), ").")
                                                    });
                                                }
                                            }
                                        }
                                    });
                                }
                                return [
                                    2,
                                    {
                                        announcement: "".concat(name, " deleted.")
                                    }
                                ];
                            }
                            deleteOpenerRef.current = document.activeElement;
                            return [
                                2,
                                new Promise(function(resolve) {
                                    return setDeleting({
                                        index: index,
                                        launched: launched,
                                        resolve: resolve
                                    });
                                })
                            ];
                        }
                        lostElsewhere = countFloorContents2(layout, index).otherFloorObservers;
                        return [
                            4,
                            confirm({
                                title: "Delete floor",
                                message: 'Delete "'.concat(floor.name, '" and everything drawn on it? Composite measures that add up the floor or anything on it lose it too.') + (lostElsewhere > 0 ? " Its cameras also take ".concat(lostElsewhere, " camera region").concat(lostElsewhere === 1 ? "" : "s", " drawn on their feeds on other floors.") : "") + " This can't be undone.",
                                confirmLabel: "Delete",
                                danger: true
                            })
                        ];
                    case 1:
                        ok = _state.sent();
                        if (!ok) return [
                            2,
                            false
                        ];
                        removeNow(index);
                        return [
                            2,
                            {
                                announcement: "".concat(floor.name, " deleted.")
                            }
                        ];
                }
            });
        });
        return function(index) {
            return _ref.apply(this, arguments);
        };
    }(), [
        confirm,
        removeNow,
        floorDialogs,
        floorLaunched,
        restoreFloor
    ]);
    var keepDeleting = useCallback3(function() {
        deleting === null || deleting === void 0 ? void 0 : deleting.resolve(false);
        setDeleting(null);
    }, [
        deleting
    ]);
    var confirmDeleting = useCallback3(function() {
        var _useFloorplanStore7_getState_layout_floors_deleting_index, _useFloorplanStore7_getState_layout;
        if (!deleting) return;
        var _useFloorplanStore7_getState_layout_floors_deleting_index_name;
        var name = (_useFloorplanStore7_getState_layout_floors_deleting_index_name = (_useFloorplanStore7_getState_layout = useFloorplanStore7.getState().layout) === null || _useFloorplanStore7_getState_layout === void 0 ? void 0 : (_useFloorplanStore7_getState_layout_floors_deleting_index = _useFloorplanStore7_getState_layout.floors[deleting.index]) === null || _useFloorplanStore7_getState_layout_floors_deleting_index === void 0 ? void 0 : _useFloorplanStore7_getState_layout_floors_deleting_index.name) !== null && _useFloorplanStore7_getState_layout_floors_deleting_index_name !== void 0 ? _useFloorplanStore7_getState_layout_floors_deleting_index_name : "";
        var record = asFloorDelete(function() {
            return removeLaunchedFloor(deleting.index);
        });
        deleting.resolve(record ? {
            announcement: "".concat(name, " will be removed at Launch. It can be put back from the Launch step.")
        } : false);
        setDeleting(null);
    }, [
        deleting,
        removeLaunchedFloor,
        asFloorDelete
    ]);
    var requestAddFloor = useCallback3(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(onAdded) {
            var _useFloorplanStore7_getState_layout, _useFloorplanStore7_getState_layout1, _useFloorplanStore7_getState_layout_floors, floors, below, _findLatestDesign3_walls, belowWalls, copyWalls, _useFloorplanStore7_getState_layout_floors1, added;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (floorDialogs === "page") {
                            return [
                                2,
                                new Promise(function(resolve) {
                                    return setAdding({
                                        resolve: resolve
                                    });
                                })
                            ];
                        }
                        floors = (_useFloorplanStore7_getState_layout_floors = (_useFloorplanStore7_getState_layout = useFloorplanStore7.getState().layout) === null || _useFloorplanStore7_getState_layout === void 0 ? void 0 : _useFloorplanStore7_getState_layout.floors) !== null && _useFloorplanStore7_getState_layout_floors !== void 0 ? _useFloorplanStore7_getState_layout_floors : [];
                        below = floors[floors.length - 1];
                        belowWalls = below ? (_findLatestDesign3_walls = findLatestDesign3(below.designs).walls) !== null && _findLatestDesign3_walls !== void 0 ? _findLatestDesign3_walls : [] : [];
                        copyWalls = false;
                        if (!(belowWalls.length > 0)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            confirm({
                                title: "Copy walls?",
                                message: 'Copy the walls from "'.concat(below.name, '" onto the new floor? You can edit or delete them afterwards.'),
                                confirmLabel: "Copy walls",
                                cancelLabel: "Start blank"
                            })
                        ];
                    case 1:
                        copyWalls = _state.sent();
                        _state.label = 2;
                    case 2:
                        recordFloorStep();
                        addFloor(copyWalls && below ? {
                            source: {
                                kind: "walls",
                                floorId: below.id
                            }
                        } : {});
                        added = (_useFloorplanStore7_getState_layout_floors1 = (_useFloorplanStore7_getState_layout1 = useFloorplanStore7.getState().layout) === null || _useFloorplanStore7_getState_layout1 === void 0 ? void 0 : _useFloorplanStore7_getState_layout1.floors) !== null && _useFloorplanStore7_getState_layout_floors1 !== void 0 ? _useFloorplanStore7_getState_layout_floors1 : [];
                        if (added.length > 0) onAdded === null || onAdded === void 0 ? void 0 : onAdded(added.length - 1);
                        return [
                            2
                        ];
                }
            });
        });
        return function(onAdded) {
            return _ref.apply(this, arguments);
        };
    }(), [
        confirm,
        addFloor,
        floorDialogs
    ]);
    var api = useMemo5(function() {
        return {
            editing: editing,
            draftName: draftName,
            setDraftName: setDraftName,
            renameOffer: renameOffer,
            takeRenameOffer: takeRenameOffer,
            startRename: startRename,
            commitRename: commitRename,
            cancelRename: cancelRename,
            requestDelete: requestDelete,
            requestAddFloor: requestAddFloor
        };
    }, [
        editing,
        draftName,
        setDraftName,
        renameOffer,
        takeRenameOffer,
        startRename,
        commitRename,
        cancelRename,
        requestDelete,
        requestAddFloor
    ]);
    return /* @__PURE__ */ jsxs4(FloorActionsContext.Provider, {
        value: api,
        children: [
            children,
            dialog,
            floorDialogs === "page" && /* @__PURE__ */ jsx5(ToastBridge, {
                into: toastRef,
                region: toastRegion
            }),
            adding && /* @__PURE__ */ jsx5(AddFloorDialog, {
                onClose: function() {
                    adding.resolve();
                    setAdding(null);
                },
                onAdd: function(param) {
                    var name = param.name, source = param.source;
                    recordFloorStep();
                    addFloor({
                        name: name,
                        source: source
                    });
                    adding.resolve();
                    setAdding(null);
                }
            }),
            deleting && /* @__PURE__ */ jsx5(DeleteFloorDialog, {
                index: deleting.index,
                launched: deleting.launched,
                onKeep: keepDeleting,
                onDelete: confirmDeleting,
                returnFocusTo: deleteOpenerRef
            })
        ]
    });
};
var useFloorActions = function() {
    var api = useContext4(FloorActionsContext);
    if (!api) throw new Error("useFloorActions needs a FloorActionsProvider above it");
    return api;
};
var useHasFloorActions = function() {
    return useContext4(FloorActionsContext) !== null;
};
// src/components/Planner/floors/FloorActions.tsx
import { jsx as jsx6, jsxs as jsxs5 } from "react/jsx-runtime";
var FloorActions = function(param) {
    var index = param.index, surface11 = param.surface, onDeleted = param.onDeleted;
    var floor = useFloorplanStore8(function(s) {
        var _s_layout;
        return (_s_layout = s.layout) === null || _s_layout === void 0 ? void 0 : _s_layout.floors[index];
    });
    var floorCount = useFloorplanStore8(function(s) {
        var _s_layout;
        var _s_layout_floors_length;
        return (_s_layout_floors_length = (_s_layout = s.layout) === null || _s_layout === void 0 ? void 0 : _s_layout.floors.length) !== null && _s_layout_floors_length !== void 0 ? _s_layout_floors_length : 0;
    });
    var _useFloorActions = useFloorActions(), startRename = _useFloorActions.startRename, requestDelete = _useFloorActions.requestDelete;
    var renameRef = useRef5(null);
    if (!floor) return null;
    var name = floor.name;
    return /* @__PURE__ */ jsxs5(Actions, {
        children: [
            /* @__PURE__ */ jsx6(Button3, {
                ref: renameRef,
                iconOnly: true,
                variant: "ghost",
                size: "xs",
                "aria-label": "Rename ".concat(name),
                title: "Rename floor",
                iconLeft: /* @__PURE__ */ jsx6(PencilIcon, {}),
                onClick: function() {
                    return startRename(index, surface11, function() {
                        var _renameRef_current;
                        return (_renameRef_current = renameRef.current) === null || _renameRef_current === void 0 ? void 0 : _renameRef_current.focus();
                    });
                }
            }),
            floorCount > 1 && /* @__PURE__ */ jsx6(Button3, {
                iconOnly: true,
                variant: "ghost",
                size: "xs",
                "aria-label": "Delete ".concat(name),
                title: "Delete floor",
                iconLeft: /* @__PURE__ */ jsx6(BinIcon, {}),
                onClick: function() {
                    void requestDelete(index).then(function(outcome) {
                        if (outcome) onDeleted === null || onDeleted === void 0 ? void 0 : onDeleted(name, outcome.announcement);
                    });
                }
            })
        ]
    });
};
var Actions = styled4.span(_templateObject21(), space2[1]);
var FloorNameInput = function() {
    var _useFloorActions = useFloorActions(), draftName = _useFloorActions.draftName, setDraftName = _useFloorActions.setDraftName, commitRename = _useFloorActions.commitRename, cancelRename = _useFloorActions.cancelRename, renameOffer = _useFloorActions.renameOffer, takeRenameOffer = _useFloorActions.takeRenameOffer;
    return /* @__PURE__ */ jsxs5(RenameRow, {
        children: [
            /* @__PURE__ */ jsx6(Field4, {
                size: "compact",
                error: renameOffer ? /* @__PURE__ */ jsx6("span", {
                    role: "alert",
                    children: takenNameMessage(renameOffer)
                }) : void 0,
                children: function(wiring) {
                    return /* @__PURE__ */ jsx6(Input3, {
                        id: wiring.id,
                        "aria-describedby": wiring["aria-describedby"],
                        invalid: wiring.invalid,
                        size: "compact",
                        "aria-label": "Floor name",
                        autoFocus: true,
                        value: draftName,
                        onChange: function(e) {
                            return setDraftName(e.target.value);
                        },
                        onFocus: function(e) {
                            return e.target.select();
                        },
                        onBlur: function(e) {
                            if (_instanceof(e.relatedTarget, HTMLElement) && e.relatedTarget.dataset.floorOffer) return;
                            commitRename();
                        },
                        onKeyDown: function(e) {
                            if (e.key === "Enter") commitRename();
                            else if (e.key === "Escape") cancelRename();
                        }
                    });
                }
            }),
            renameOffer && /* @__PURE__ */ jsx6(Button3, {
                type: "button",
                variant: "frosted",
                size: "xs",
                "data-floor-offer": "",
                onClick: takeRenameOffer,
                children: freeNameButtonLabel(renameOffer)
            })
        ]
    });
};
var RenameRow = styled4.span(_templateObject22(), space2[1]);
// src/components/Planner/FloorTabs.tsx
import { Fragment as Fragment3, jsx as jsx7, jsxs as jsxs6 } from "react/jsx-runtime";
var FLOOR_SELECTOR_COMPACT_FROM = 4;
var cameraCountLabel = function(count) {
    return "".concat(count, " camera").concat(count === 1 ? "" : "s");
};
var floorWithCount = function(name, count) {
    var label = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : cameraCountLabel;
    return typeof count === "number" ? "".concat(name, ", ").concat(label(count)) : void 0;
};
var FloorTabs = function(props) {
    return props.look === "floating" ? props.editable ? /* @__PURE__ */ jsx7(FloatingEditableHost, _object_spread({}, props)) : /* @__PURE__ */ jsx7(FloorSelectorFloating, {
        counts: props.counts,
        countLabel: props.countLabel
    }) : /* @__PURE__ */ jsx7(FloorTabsStripHost, _object_spread({}, props));
};
var FloatingEditableHost = function(props) {
    return useHasFloorActions() ? /* @__PURE__ */ jsx7(FloorSelectorFloating, {
        counts: props.counts,
        editable: true,
        problemCounts: props.problemCounts,
        announcement: props.announcement
    }) : /* @__PURE__ */ jsx7(FloorActionsProvider, {
        children: /* @__PURE__ */ jsx7(FloorSelectorFloating, {
            counts: props.counts,
            editable: true,
            problemCounts: props.problemCounts,
            announcement: props.announcement
        })
    });
};
var FloorTabsStripHost = function(props) {
    return useHasFloorActions() ? /* @__PURE__ */ jsx7(FloorTabsStrip, _object_spread({}, props)) : /* @__PURE__ */ jsx7(FloorActionsProvider, {
        children: /* @__PURE__ */ jsx7(FloorTabsStrip, _object_spread({}, props))
    });
};
var FloorTabsStrip = function(param) {
    var _param_editable = param.editable, editable = _param_editable === void 0 ? true : _param_editable, trailing = param.trailing, announcement = param.announcement, counts = param.counts, problemCounts = param.problemCounts;
    var layout = useFloorplanStore9(function(s) {
        return s.layout;
    });
    var activeFloorIndex = useFloorplanStore9(function(s) {
        return s.activeFloorIndex;
    });
    var setActiveFloor = useFloorplanStore9(function(s) {
        return s.setActiveFloor;
    });
    var _useFloorActions = useFloorActions(), editing = _useFloorActions.editing, startRename = _useFloorActions.startRename, requestAddFloor = _useFloorActions.requestAddFloor;
    var tabRefs = useRef6(/* @__PURE__ */ new Map());
    var _useAnnouncer = _sliced_to_array(useAnnouncer(), 2), message = _useAnnouncer[0], announce = _useAnnouncer[1];
    useEffect8(function() {
        if (announcement) announce(announcement);
    }, [
        announcement,
        announce
    ]);
    if (!layout) return null;
    var floors = layout.floors;
    var renamingHere = (editing === null || editing === void 0 ? void 0 : editing.surface) === "strip" ? editing.index : null;
    var focusTab = function(index) {
        return function() {
            var _tabRefs_current_get;
            return (_tabRefs_current_get = tabRefs.current.get(index)) === null || _tabRefs_current_get === void 0 ? void 0 : _tabRefs_current_get.focus();
        };
    };
    var handleAddFloor = function() {
        return requestAddFloor(function(newIndex) {
            return startRename(newIndex, "strip", focusTab(newIndex));
        });
    };
    return /* @__PURE__ */ jsxs6(Fragment3, {
        children: [
            /* @__PURE__ */ jsxs6(Bar, {
                $wrap: !editable,
                children: [
                    /* @__PURE__ */ jsxs6(Scroll, {
                        $wrap: !editable,
                        children: [
                            /* @__PURE__ */ jsx7(TabsList, {
                                role: "group",
                                "aria-label": "Floors",
                                children: floors.map(function(floor, index) {
                                    var active = index === activeFloorIndex;
                                    var onArrow = function(e) {
                                        var _tabRefs_current_get;
                                        if (editable && (e.key === "ArrowUp" || e.key === "ArrowDown")) return;
                                        var next = rovingIndexForKey(e.key, index, floors.length);
                                        if (next < 0) return;
                                        e.preventDefault();
                                        flushSync(function() {
                                            return setActiveFloor(next);
                                        });
                                        (_tabRefs_current_get = tabRefs.current.get(next)) === null || _tabRefs_current_get === void 0 ? void 0 : _tabRefs_current_get.focus();
                                    };
                                    var errors = editable ? problemCounts === null || problemCounts === void 0 ? void 0 : problemCounts.get(floor.id) : void 0;
                                    var hasErrors = typeof errors === "number" && errors > 0;
                                    var count = editable ? hasErrors ? errors : void 0 : counts === null || counts === void 0 ? void 0 : counts[index];
                                    var label = !editable ? floorWithCount(floor.name, count) : hasErrors ? "".concat(floor.name, ", ").concat(errors, " error").concat(errors === 1 ? "" : "s") : void 0;
                                    return /* @__PURE__ */ jsx7(Tag, {
                                        ref: function(el) {
                                            if (el) tabRefs.current.set(index, el);
                                            else tabRefs.current.delete(index);
                                        },
                                        surface: "on-glass",
                                        toggle: true,
                                        active: active,
                                        tabIndex: active ? 0 : -1,
                                        count: count,
                                        "aria-label": label,
                                        onToggle: function() {
                                            return setActiveFloor(index);
                                        },
                                        onKeyDown: onArrow,
                                        children: floor.name
                                    }, floor.id);
                                })
                            }),
                            renamingHere !== null && /* @__PURE__ */ jsx7(RenameField, {
                                children: /* @__PURE__ */ jsx7(FloorNameInput, {})
                            }),
                            editable && /* @__PURE__ */ jsx7(FloorActions, {
                                index: activeFloorIndex,
                                surface: "strip",
                                onDeleted: function(_name, announcement2) {
                                    announce(announcement2);
                                    setTimeout(function() {
                                        var _tabRefs_current_get;
                                        var _useFloorplanStore9_getState = useFloorplanStore9.getState(), now = _useFloorplanStore9_getState.activeFloorIndex;
                                        (_tabRefs_current_get = tabRefs.current.get(now)) === null || _tabRefs_current_get === void 0 ? void 0 : _tabRefs_current_get.focus();
                                    }, 0);
                                }
                            }),
                            editable && // Frame 02's *+ Add Floor*: cyan-press text, no chrome — the text action's brand tone.
                            /* @__PURE__ */ jsx7(Button4, {
                                variant: "text",
                                tone: "brand",
                                size: "xs",
                                iconLeft: /* @__PURE__ */ jsx7(Icon4, {
                                    name: "plus",
                                    variant: "solid",
                                    size: "xs"
                                }),
                                onClick: function() {
                                    return void handleAddFloor();
                                },
                                children: "Add Floor"
                            })
                        ]
                    }),
                    trailing && /* @__PURE__ */ jsx7(Trailing, {
                        children: trailing
                    })
                ]
            }),
            /* @__PURE__ */ jsx7("span", {
                role: "status",
                "aria-live": "polite",
                "aria-atomic": "true",
                style: visuallyHidden,
                children: message
            })
        ]
    });
};
var Bar = styled5.div(_templateObject23(), function(p) {
    return p.$wrap ? "wrap" : "nowrap";
}, space3[2], space3[3], function(param) {
    var t = param.theme;
    return t.colors.neutral[200];
});
var Scroll = styled5.div(_templateObject24(), function(p) {
    return p.$wrap ? "1 0 auto" : "1";
});
var TabsList = styled5.div(_templateObject25());
var Trailing = styled5.div(_templateObject26());
var RenameField = styled5.span(_templateObject27());
var FloorSelectorFloating = function(param) {
    var given = param.counts, countLabel = param.countLabel, _param_editable = param.editable, editable = _param_editable === void 0 ? false : _param_editable, problemCounts = param.problemCounts, announcement = param.announcement;
    var counts = countLabel ? given === null || given === void 0 ? void 0 : given.map(function(n) {
        return n > 0 ? n : void 0;
    }) : given;
    var layout = useFloorplanStore9(function(s) {
        return s.layout;
    });
    var activeFloorIndex = useFloorplanStore9(function(s) {
        return s.activeFloorIndex;
    });
    var setActiveFloor = useFloorplanStore9(function(s) {
        return s.setActiveFloor;
    });
    var rootRef = useRef6(null);
    var measureRef = useRef6(null);
    var tabRefs = useRef6(/* @__PURE__ */ new Map());
    var _useState7 = _sliced_to_array(useState7(false), 2), overflows = _useState7[0], setOverflows = _useState7[1];
    var _useState71 = _sliced_to_array(useState7(false), 2), addRequested = _useState71[0], setAddRequested = _useState71[1];
    var _layout_floors_length;
    var floorCount = (_layout_floors_length = layout === null || layout === void 0 ? void 0 : layout.floors.length) !== null && _layout_floors_length !== void 0 ? _layout_floors_length : 0;
    var compact = floorCount >= FLOOR_SELECTOR_COMPACT_FROM || overflows;
    useLayoutEffect(function() {
        var _rootRef_current;
        var slot = (_rootRef_current = rootRef.current) === null || _rootRef_current === void 0 ? void 0 : _rootRef_current.parentElement;
        var pills2 = measureRef.current;
        if (!slot || !pills2) return void 0;
        var check = function() {
            return setOverflows(pills2.scrollWidth > slot.clientWidth);
        };
        check();
        if (typeof ResizeObserver === "undefined") return void 0;
        var frame = null;
        var observer = new ResizeObserver(function() {
            if (frame !== null) window.cancelAnimationFrame(frame);
            frame = window.requestAnimationFrame(function() {
                frame = null;
                check();
            });
        });
        observer.observe(slot);
        observer.observe(pills2);
        return function() {
            observer.disconnect();
            if (frame !== null) window.cancelAnimationFrame(frame);
        };
    }, [
        floorCount
    ]);
    if (!layout || floorCount === 0) return null;
    var floors = layout.floors;
    var countOf = function(floor, index) {
        if (!editable) return counts === null || counts === void 0 ? void 0 : counts[index];
        var errors = problemCounts === null || problemCounts === void 0 ? void 0 : problemCounts.get(floor.id);
        return typeof errors === "number" && errors > 0 ? errors : void 0;
    };
    var labelOf = function(floor, index) {
        if (!editable) return floorWithCount(floor.name, counts === null || counts === void 0 ? void 0 : counts[index], countLabel);
        var errors = countOf(floor, index);
        return errors ? "".concat(floor.name, ", ").concat(errors, " error").concat(errors === 1 ? "" : "s") : void 0;
    };
    var pills = function(measuring) {
        return floors.map(function(floor, index) {
            var active = index === activeFloorIndex;
            var onArrow = function(e) {
                var _tabRefs_current_get;
                var next = rovingIndexForKey(e.key, index, floors.length);
                if (next < 0) return;
                e.preventDefault();
                flushSync(function() {
                    return setActiveFloor(next);
                });
                (_tabRefs_current_get = tabRefs.current.get(next)) === null || _tabRefs_current_get === void 0 ? void 0 : _tabRefs_current_get.focus();
            };
            return /* @__PURE__ */ jsx7(Tag, {
                ref: measuring ? void 0 : function(el) {
                    if (el) tabRefs.current.set(index, el);
                    else tabRefs.current.delete(index);
                },
                surface: "on-glass",
                toggle: true,
                active: active,
                tabIndex: measuring ? -1 : active ? 0 : -1,
                count: countOf(floor, index),
                "aria-label": labelOf(floor, index),
                onToggle: function() {
                    return setActiveFloor(index);
                },
                onKeyDown: measuring ? void 0 : onArrow,
                children: floor.name
            }, floor.id);
        });
    };
    return(/*
     * The planner's window-level keys (Delete, Backspace, Escape, R, C) skip anything inside
     * `data-planner-shortcuts="off"` (`useKeyboardShortcuts`), so a key pressed on a floor or in the
     * floor menu never edits or deselects the plan behind it.
     */ /* @__PURE__ */ jsxs6(Floating, {
        ref: rootRef,
        "data-floor-selector": compact ? "compact" : "pills",
        "data-planner-shortcuts": "off",
        children: [
            /* @__PURE__ */ jsxs6(Measure, {
                ref: measureRef,
                "aria-hidden": "true",
                inert: true,
                children: [
                    /* @__PURE__ */ jsx7(FloatingPills, {
                        as: "div",
                        children: pills(true)
                    }),
                    editable && /* @__PURE__ */ jsxs6(Fragment3, {
                        children: [
                            /* @__PURE__ */ jsx7(FloorActions, {
                                index: activeFloorIndex,
                                surface: "strip"
                            }),
                            /* @__PURE__ */ jsx7(Button4, {
                                variant: "text",
                                tone: "brand",
                                size: "xs",
                                iconLeft: /* @__PURE__ */ jsx7(Icon4, {
                                    name: "plus",
                                    variant: "solid",
                                    size: "xs"
                                }),
                                children: "Add Floor"
                            })
                        ]
                    })
                ]
            }),
            compact ? /* @__PURE__ */ jsx7(FloorStepper, {
                floors: floors,
                counts: editable ? floors.map(function(f, i) {
                    return countOf(f, i);
                }) : counts,
                labelOf: function(index) {
                    return labelOf(floors[index], index);
                },
                active: activeFloorIndex,
                onChoose: setActiveFloor,
                onAddFloor: editable ? function() {
                    return setAddRequested(true);
                } : void 0
            }) : /* @__PURE__ */ jsx7(FloatingPills, {
                role: "group",
                "aria-label": "Floors",
                children: pills(false)
            }),
            editable && /* @__PURE__ */ jsx7(FloatingFloorEdits, {
                compact: compact,
                addRequested: addRequested,
                onAddHandled: function() {
                    return setAddRequested(false);
                },
                announcement: announcement,
                focusFloor: function() {
                    var _this, _rootRef_current, _rootRef_current1;
                    var _useFloorplanStore9_getState = useFloorplanStore9.getState(), now = _useFloorplanStore9_getState.activeFloorIndex;
                    var _tabRefs_current_get, _rootRef_current_querySelectorAll, _ref;
                    (_this = (_ref = (_tabRefs_current_get = tabRefs.current.get(now)) !== null && _tabRefs_current_get !== void 0 ? _tabRefs_current_get : (_rootRef_current = rootRef.current) === null || _rootRef_current === void 0 ? void 0 : _rootRef_current.querySelector("[data-floor-menu-trigger]")) !== null && _ref !== void 0 ? _ref : Array.from((_rootRef_current_querySelectorAll = (_rootRef_current1 = rootRef.current) === null || _rootRef_current1 === void 0 ? void 0 : _rootRef_current1.querySelectorAll("button")) !== null && _rootRef_current_querySelectorAll !== void 0 ? _rootRef_current_querySelectorAll : []).find(function(b) {
                        return !b.closest("[inert]");
                    })) === null || _this === void 0 ? void 0 : _this.focus();
                }
            })
        ]
    }));
};
var FloatingFloorEdits = function(param) {
    var compact = param.compact, addRequested = param.addRequested, onAddHandled = param.onAddHandled, announcement = param.announcement, focusFloor = param.focusFloor;
    var activeFloorIndex = useFloorplanStore9(function(s) {
        return s.activeFloorIndex;
    });
    var _useFloorActions = useFloorActions(), editing = _useFloorActions.editing, startRename = _useFloorActions.startRename, requestAddFloor = _useFloorActions.requestAddFloor;
    var _useAnnouncer = _sliced_to_array(useAnnouncer(), 2), message = _useAnnouncer[0], announce = _useAnnouncer[1];
    useEffect8(function() {
        if (announcement) announce(announcement);
    }, [
        announcement,
        announce
    ]);
    var addFloor = useCallback4(function() {
        return void requestAddFloor(function(newIndex) {
            return startRename(newIndex, "strip", focusFloor);
        }).then(function() {
            setTimeout(function() {
                var now = document.activeElement;
                if (!now || now === document.body) focusFloor();
            }, 0);
        });
    }, [
        requestAddFloor,
        startRename,
        focusFloor
    ]);
    useEffect8(function() {
        if (!addRequested) return;
        onAddHandled();
        addFloor();
    }, [
        addRequested,
        onAddHandled,
        addFloor
    ]);
    var renaming = (editing === null || editing === void 0 ? void 0 : editing.surface) === "strip";
    return /* @__PURE__ */ jsxs6(Fragment3, {
        children: [
            renaming && /* @__PURE__ */ jsx7(RenameField, {
                children: /* @__PURE__ */ jsx7(FloorNameInput, {})
            }),
            /* @__PURE__ */ jsx7(FloorActions, {
                index: activeFloorIndex,
                surface: "strip",
                onDeleted: function(_name, sentence) {
                    announce(sentence);
                    setTimeout(focusFloor, 0);
                }
            }),
            !compact && // Frame 01's *+ Add Floor*: the strip's text action, cyan-press, no chrome.
            /* @__PURE__ */ jsx7(Button4, {
                variant: "text",
                tone: "brand",
                size: "xs",
                iconLeft: /* @__PURE__ */ jsx7(Icon4, {
                    name: "plus",
                    variant: "solid",
                    size: "xs"
                }),
                onClick: addFloor,
                children: "Add Floor"
            }),
            /* @__PURE__ */ jsx7("span", {
                role: "status",
                "aria-live": "polite",
                "aria-atomic": "true",
                style: visuallyHidden,
                children: message
            })
        ]
    });
};
var ADD_FLOOR_ITEM = Number.MAX_SAFE_INTEGER;
var FloorStepper = function(param) {
    var floors = param.floors, counts = param.counts, active = param.active, onChoose = param.onChoose, onAddFloor = param.onAddFloor, labelOf = param.labelOf;
    var labelFor2 = function(index) {
        return labelOf ? labelOf(index) : floorWithCount(floors[index].name, counts === null || counts === void 0 ? void 0 : counts[index]);
    };
    var _useState7 = _sliced_to_array(useState7(false), 2), open = _useState7[0], setOpen = _useState7[1];
    var _useState71 = _sliced_to_array(useState7(active), 2), highlight = _useState71[0], setHighlight = _useState71[1];
    var triggerRef = useRef6(null);
    var menuRef = useRef6(null);
    var itemRefs = useRef6(/* @__PURE__ */ new Map());
    var current2 = floors[active];
    var count = counts === null || counts === void 0 ? void 0 : counts[active];
    var _useAnnouncer = _sliced_to_array(useAnnouncer(), 2), message = _useAnnouncer[0], announce = _useAnnouncer[1];
    var nameOf2 = function(index) {
        var _labelFor2;
        return (_labelFor2 = labelFor2(index)) !== null && _labelFor2 !== void 0 ? _labelFor2 : floors[index].name;
    };
    var step = function(by) {
        var _triggerRef_current;
        var next = active + by;
        if (next < 0 || next >= floors.length) return;
        onChoose(next);
        if (next === 0 || next === floors.length - 1) (_triggerRef_current = triggerRef.current) === null || _triggerRef_current === void 0 ? void 0 : _triggerRef_current.focus();
        else announce(nameOf2(next));
    };
    var topFirst = floors.map(function(floor, index) {
        return {
            floor: floor,
            index: index
        };
    }).reverse();
    var close = function(refocus) {
        var _triggerRef_current;
        setOpen(false);
        if (refocus) (_triggerRef_current = triggerRef.current) === null || _triggerRef_current === void 0 ? void 0 : _triggerRef_current.focus();
    };
    var choose = function(index) {
        onChoose(index);
        close(true);
    };
    var addFloor = function() {
        close(true);
        onAddFloor === null || onAddFloor === void 0 ? void 0 : onAddFloor();
    };
    useEffect8(function() {
        var _itemRefs_current_get;
        if (!open) return;
        setHighlight(active);
        (_itemRefs_current_get = itemRefs.current.get(active)) === null || _itemRefs_current_get === void 0 ? void 0 : _itemRefs_current_get.focus();
    }, [
        open
    ]);
    useEffect8(function() {
        if (!open) return void 0;
        var onDown = function(e) {
            var _menuRef_current, _triggerRef_current;
            var t = e.target;
            if (((_menuRef_current = menuRef.current) === null || _menuRef_current === void 0 ? void 0 : _menuRef_current.contains(t)) || ((_triggerRef_current = triggerRef.current) === null || _triggerRef_current === void 0 ? void 0 : _triggerRef_current.contains(t))) return;
            setOpen(false);
        };
        document.addEventListener("pointerdown", onDown);
        return function() {
            return document.removeEventListener("pointerdown", onDown);
        };
    }, [
        open
    ]);
    var onMenuKey = function(e) {
        var _itemRefs_current_get;
        var order = _to_consumable_array(topFirst.map(function(f) {
            return f.index;
        })).concat(_to_consumable_array(onAddFloor ? [
            ADD_FLOOR_ITEM
        ] : []));
        var at3 = order.indexOf(highlight);
        var next = -1;
        if (e.key === "ArrowDown") next = order[Math.min(order.length - 1, at3 + 1)];
        else if (e.key === "ArrowUp") next = order[Math.max(0, at3 - 1)];
        else if (e.key === "Home") next = order[0];
        else if (e.key === "End") next = order[order.length - 1];
        else if (e.key === "Escape") {
            e.preventDefault();
            close(true);
            return;
        } else if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            if (highlight === ADD_FLOOR_ITEM) addFloor();
            else choose(highlight);
            return;
        } else if (e.key === "Tab") {
            var _triggerRef_current;
            (_triggerRef_current = triggerRef.current) === null || _triggerRef_current === void 0 ? void 0 : _triggerRef_current.focus();
            setOpen(false);
            return;
        }
        if (next < 0 || next === void 0) return;
        e.preventDefault();
        setHighlight(next);
        (_itemRefs_current_get = itemRefs.current.get(next)) === null || _itemRefs_current_get === void 0 ? void 0 : _itemRefs_current_get.focus();
    };
    if (!current2) return null;
    return /* @__PURE__ */ jsxs6(Stepper, {
        children: [
            /* @__PURE__ */ jsx7(Button4, {
                variant: "frosted",
                size: "sm",
                iconOnly: true,
                circle: true,
                "aria-label": "Floor above",
                disabled: active >= floors.length - 1,
                onClick: function() {
                    return step(1);
                },
                iconLeft: /* @__PURE__ */ jsx7(Icon4, {
                    name: "chevron-up"
                })
            }),
            /* @__PURE__ */ jsxs6(Button4, {
                ref: triggerRef,
                "data-floor-menu-trigger": "",
                variant: "frosted",
                size: "sm",
                "aria-haspopup": "menu",
                "aria-expanded": open,
                "aria-label": "".concat(nameOf2(active), ", choose a floor"),
                iconLeft: /* @__PURE__ */ jsx7(Icon4, {
                    name: "layer-group"
                }),
                iconRight: /* @__PURE__ */ jsx7(Icon4, {
                    name: "chevron-down"
                }),
                onClick: function() {
                    return setOpen(function(o) {
                        return !o;
                    });
                },
                children: [
                    current2.name,
                    typeof count === "number" ? /* @__PURE__ */ jsx7(StepperCount, {
                        "aria-hidden": "true",
                        children: count
                    }) : null
                ]
            }),
            /* @__PURE__ */ jsx7(Button4, {
                variant: "frosted",
                size: "sm",
                iconOnly: true,
                circle: true,
                "aria-label": "Floor below",
                disabled: active <= 0,
                onClick: function() {
                    return step(-1);
                },
                iconLeft: /* @__PURE__ */ jsx7(Icon4, {
                    name: "chevron-down"
                })
            }),
            /* @__PURE__ */ jsx7("span", {
                role: "status",
                "aria-live": "polite",
                "aria-atomic": "true",
                style: visuallyHidden,
                children: message
            }),
            open ? /* @__PURE__ */ jsxs6(FloorMenu, {
                ref: menuRef,
                role: "menu",
                "aria-label": "Floors",
                belowTrigger: true,
                onKeyDown: onMenuKey,
                children: [
                    /* @__PURE__ */ jsx7(MenuLabel, {
                        children: "".concat(floors.length, " floors \xb7 top first")
                    }),
                    topFirst.map(function(param) {
                        var floor = param.floor, index = param.index;
                        var _labelFor2;
                        return /* @__PURE__ */ jsx7(MenuItem, {
                            ref: function(el) {
                                if (el) itemRefs.current.set(index, el);
                                else itemRefs.current.delete(index);
                            },
                            role: "menuitemradio",
                            "aria-checked": index === active,
                            tabIndex: -1,
                            selected: index === active,
                            highlighted: index === highlight,
                            icon: index === active ? /* @__PURE__ */ jsx7(Icon4, {
                                name: "check"
                            }) : void 0,
                            trailing: typeof (counts === null || counts === void 0 ? void 0 : counts[index]) === "number" ? /* @__PURE__ */ jsx7(MenuTrailingLabel, {
                                children: String(counts[index])
                            }) : void 0,
                            "aria-label": (_labelFor2 = labelFor2(index)) !== null && _labelFor2 !== void 0 ? _labelFor2 : floor.name,
                            onClick: function() {
                                return choose(index);
                            },
                            onPointerEnter: function() {
                                var _itemRefs_current_get;
                                setHighlight(index);
                                (_itemRefs_current_get = itemRefs.current.get(index)) === null || _itemRefs_current_get === void 0 ? void 0 : _itemRefs_current_get.focus();
                            },
                            children: floor.name
                        }, floor.id);
                    }),
                    onAddFloor && /* @__PURE__ */ jsx7(MenuItem, {
                        ref: function(el) {
                            if (el) itemRefs.current.set(ADD_FLOOR_ITEM, el);
                            else itemRefs.current.delete(ADD_FLOOR_ITEM);
                        },
                        role: "menuitem",
                        tabIndex: -1,
                        highlighted: highlight === ADD_FLOOR_ITEM,
                        icon: /* @__PURE__ */ jsx7(Icon4, {
                            name: "plus"
                        }),
                        onClick: addFloor,
                        onPointerEnter: function() {
                            var _itemRefs_current_get;
                            setHighlight(ADD_FLOOR_ITEM);
                            (_itemRefs_current_get = itemRefs.current.get(ADD_FLOOR_ITEM)) === null || _itemRefs_current_get === void 0 ? void 0 : _itemRefs_current_get.focus();
                        },
                        children: "Add Floor"
                    })
                ]
            }) : null
        ]
    });
};
var Floating = styled5.div(_templateObject28(), SMALL_GLASS_PADDING, smallGlassCss);
var FloatingPills = styled5.div(_templateObject29());
var Measure = styled5.div(_templateObject30());
var Stepper = styled5.div(_templateObject31(), space3[1]);
var StepperCount = styled5.span(_templateObject32(), space3[1]);
var FloorMenu = styled5(Menu)(_templateObject33(), zIndex2.dropdown);
// src/components/Planner/PlannerPlanChecks.tsx
import { useDeferredValue as useDeferredValue2 } from "react";
import { useFloorplanStore as useFloorplanStore11 } from "@repo/front-end-state";
// src/components/Planner/hooks/usePlanChecks.ts
import { createContext as createContext5, useContext as useContext5, useDeferredValue, useMemo as useMemo6 } from "react";
import { registerReadState as registerReadState2, useEquipmentCatalogStore as useEquipmentCatalogStore4, useFloorplanStore as useFloorplanStore10 } from "@repo/front-end-state";
import { buildIdentifyModel, buildPlanChecks } from "@repo/front-end-utils";
var usePlanChecks = function(param) {
    var twinBid = param.twinBid, twinId = param.twinId, layoutScope = param.layoutScope, liveIdentities = param.liveIdentities;
    var storeLayout = useDeferredValue(useFloorplanStore10(function(s) {
        return s.layout;
    }));
    var rows = useEquipmentCatalogStore4(function(s) {
        return s.registerRows;
    });
    var readState = useEquipmentCatalogStore4(function(s) {
        return registerReadState2(s, {
            twinId: twinId !== null && twinId !== void 0 ? twinId : void 0
        });
    });
    var layout = useMemo6(function() {
        return joinedFor(storeLayout, rows, twinBid, readState === "ready");
    }, [
        storeLayout,
        rows,
        twinBid,
        readState
    ]);
    var registerCapacityOf = useRegisterCapacityOf(twinId);
    var inScope = useFloorplanStore10(function(s) {
        return isSameTwinScope(s.twinBID, twinBid, layoutScope);
    });
    var identify = useMemo6(function() {
        try {
            return buildIdentifyModel(rows, {
                layout: layout
            });
        } catch (err) {
            console.warn("[planner] the identify model could not be built; no checks are shown", {
                message: _instanceof(err, Error) ? err.message : String(err)
            });
            return null;
        }
    }, [
        rows,
        layout
    ]);
    if (!identify || !inScope) return null;
    return buildPlanChecks({
        layout: layout,
        twinBid: twinBid !== null && twinBid !== void 0 ? twinBid : "",
        register: {
            rows: rows,
            readState: readState
        },
        registerCapacityOf: registerCapacityOf,
        identify: identify,
        live: liveIdentities,
        /*
     * What the conversion skipped when the plan was started from the live twin
     * (`floor-plan-page-start`, R11): kept on the plan, so the first Checks row survives a reload.
     * Read off the STORE's layout, not the joined one, so the register join can never drop it.
     */ skipped: storeLayout === null || storeLayout === void 0 ? void 0 : storeLayout.adoptionSkipped
    });
};
var planChecksReady = function(checks) {
    return !!checks && checks.known && !checks.failed && checks.registerKnown;
};
var floorErrorCounts = function(checks) {
    if (!planChecksReady(checks)) return void 0;
    var out = /* @__PURE__ */ new Map();
    checks.counts.byFloor.forEach(function(counts, floorId) {
        return out.set(floorId, counts.error);
    });
    return out;
};
var floorMarks = function(checks, floorId) {
    return planChecksReady(checks) && floorId != null ? checks.marks(floorId) : void 0;
};
var PlanChecksContext = createContext5(null);
var usePlanChecksContext = function() {
    return useContext5(PlanChecksContext);
};
var PlanChecksSettledContext = createContext5(true);
var usePlanChecksSettled = function() {
    return useContext5(PlanChecksSettledContext);
};
// src/components/Planner/PlannerPlanChecks.tsx
import { jsx as jsx8 } from "react/jsx-runtime";
function PlannerPlanChecks(_param) {
    var enabled = _param.enabled, children = _param.children, rest = _object_without_properties(_param, [
        "enabled",
        "children"
    ]);
    if (!enabled) {
        return /* @__PURE__ */ jsx8(PlanChecksContext.Provider, {
            value: null,
            children: children
        });
    }
    return /* @__PURE__ */ jsx8(LivePlanChecks, _object_spread_props(_object_spread({}, rest), {
        children: children
    }));
}
function LivePlanChecks(param) {
    var twinBid = param.twinBid, twinId = param.twinId, layoutScope = param.layoutScope, liveIdentities = param.liveIdentities, children = param.children;
    var checks = usePlanChecks({
        twinBid: twinBid,
        twinId: twinId,
        layoutScope: layoutScope,
        liveIdentities: liveIdentities
    });
    var live = useFloorplanStore11(function(s) {
        return s.layout;
    });
    var settled = useDeferredValue2(live) === live;
    return /* @__PURE__ */ jsx8(PlanChecksContext.Provider, {
        value: checks,
        children: /* @__PURE__ */ jsx8(PlanChecksSettledContext.Provider, {
            value: settled,
            children: children
        })
    });
}
// src/components/Planner/reshape/reshapeStore.ts
import { createContext as createContext6, useContext as useContext6, useSyncExternalStore as useSyncExternalStore2 } from "react";
var createReshapeStore = function() {
    var state = null;
    var modifier = false;
    var armed = null;
    var listeners2 = /* @__PURE__ */ new Set();
    var endListeners = /* @__PURE__ */ new Set();
    var notify = function() {
        return listeners2.forEach(function(l) {
            return l();
        });
    };
    return {
        getSnapshot: function() {
            return state;
        },
        subscribe: function(listener) {
            listeners2.add(listener);
            return function() {
                listeners2.delete(listener);
            };
        },
        set: function(next) {
            if (next === state) return;
            state = next;
            notify();
        },
        getModifier: function() {
            return modifier;
        },
        setModifier: function(held) {
            if (held === modifier) return;
            modifier = held;
            notify();
        },
        getArmed: function() {
            return armed;
        },
        setArmed: function(next) {
            if ((next === null || next === void 0 ? void 0 : next.refid) === (armed === null || armed === void 0 ? void 0 : armed.refid) && (next === null || next === void 0 ? void 0 : next.index) === (armed === null || armed === void 0 ? void 0 : armed.index)) return;
            armed = next;
            notify();
        },
        end: function(ended) {
            if (state !== null) {
                state = null;
                notify();
            }
            endListeners.forEach(function(l) {
                return l(ended);
            });
        },
        onEnded: function(listener) {
            endListeners.add(listener);
            return function() {
                endListeners.delete(listener);
            };
        }
    };
};
var ReshapeStoreContext = createContext6(null);
var useReshapeStore = function() {
    return useContext6(ReshapeStoreContext);
};
var NO_STATE = function() {
    return null;
};
var NO_SUBSCRIBE = function() {
    return function() {};
};
var NOT_HELD = function() {
    return false;
};
var useReshapeState = function(store) {
    var _store_subscribe, _store_getSnapshot, _store_getSnapshot1;
    return useSyncExternalStore2((_store_subscribe = store === null || store === void 0 ? void 0 : store.subscribe) !== null && _store_subscribe !== void 0 ? _store_subscribe : NO_SUBSCRIBE, (_store_getSnapshot = store === null || store === void 0 ? void 0 : store.getSnapshot) !== null && _store_getSnapshot !== void 0 ? _store_getSnapshot : NO_STATE, (_store_getSnapshot1 = store === null || store === void 0 ? void 0 : store.getSnapshot) !== null && _store_getSnapshot1 !== void 0 ? _store_getSnapshot1 : NO_STATE);
};
var useArmedEdge = function(store) {
    var _store_subscribe, _store_getArmed, _store_getArmed1;
    return useSyncExternalStore2((_store_subscribe = store === null || store === void 0 ? void 0 : store.subscribe) !== null && _store_subscribe !== void 0 ? _store_subscribe : NO_SUBSCRIBE, (_store_getArmed = store === null || store === void 0 ? void 0 : store.getArmed) !== null && _store_getArmed !== void 0 ? _store_getArmed : NO_STATE, (_store_getArmed1 = store === null || store === void 0 ? void 0 : store.getArmed) !== null && _store_getArmed1 !== void 0 ? _store_getArmed1 : NO_STATE);
};
var useReshapeModifier = function(store) {
    var _store_subscribe, _store_getModifier, _store_getModifier1;
    return useSyncExternalStore2((_store_subscribe = store === null || store === void 0 ? void 0 : store.subscribe) !== null && _store_subscribe !== void 0 ? _store_subscribe : NO_SUBSCRIBE, (_store_getModifier = store === null || store === void 0 ? void 0 : store.getModifier) !== null && _store_getModifier !== void 0 ? _store_getModifier : NOT_HELD, (_store_getModifier1 = store === null || store === void 0 ? void 0 : store.getModifier) !== null && _store_getModifier1 !== void 0 ? _store_getModifier1 : NOT_HELD);
};
// src/components/Planner/reshape/ReshapeReport.tsx
import { useEffect as useEffect9, useRef as useRef7 } from "react";
import { Icon as Icon6 } from "@repo/design-system";
import { useEditorStore as useEditorStore7, useFloorplanStore as useFloorplanStore14 } from "@repo/front-end-state";
import { findLatestDesign as findLatestDesign5 } from "@repo/front-end-utils";
// src/components/Planner/machineCard/guardedUndo.tsx
import { Icon as Icon5 } from "@repo/design-system";
import { useEditorStore as useEditorStore6, useFloorplanStore as useFloorplanStore12 } from "@repo/front-end-state";
import { jsx as jsx9 } from "react/jsx-runtime";
var guardedUndo = function(show) {
    var undoStack = useEditorStore6.getState().undoStack;
    var step = undoStack[undoStack.length - 1];
    var left = useFloorplanStore12.getState().layout;
    return function() {
        var now = useEditorStore6.getState().undoStack;
        if (!step || now[now.length - 1] !== step || useFloorplanStore12.getState().layout !== left) {
            show({
                tone: "warning",
                icon: /* @__PURE__ */ jsx9(Icon5, {
                    name: "triangle-exclamation"
                }),
                title: CANT_UNDO_DELETE
            });
            return;
        }
        undoPlanStep(historyScopeFor("all"));
    };
};
// src/components/Planner/reshape/reshapeImpact.ts
import { reparentFromDrawing } from "@repo/front-end-state";
import { itemDisplayName, resolvePlanParentage, surfaceName } from "@repo/front-end-utils";
var designAfterReshape = function(startDesign, refid, startPoly, latestPoly) {
    return reparentFromDrawing(_object_spread_props(_object_spread({}, startDesign), {
        surfaces: startDesign.surfaces.map(function(s) {
            return s.refid === refid ? _object_spread_props(_object_spread({}, s), {
                poly: latestPoly
            }) : s;
        })
    }), {
        surfaces: /* @__PURE__ */ new Set([
            refid
        ]),
        childrenOf: /* @__PURE__ */ new Set([
            refid
        ]),
        outlines: [
            startPoly,
            latestPoly
        ]
    });
};
var itemName = function(item) {
    return itemDisplayName(item).trim() || "Equipment";
};
var spaceName = function(surface11) {
    return surfaceName(surface11) || "Space";
};
var compareParentage = function(refid, before, after) {
    var was = resolvePlanParentage(before);
    var now = resolvePlanParentage(after);
    var names = /* @__PURE__ */ new Map();
    var _before_surfaces, _after_surfaces;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = _to_consumable_array((_before_surfaces = before.surfaces) !== null && _before_surfaces !== void 0 ? _before_surfaces : []).concat(_to_consumable_array((_after_surfaces = after.surfaces) !== null && _after_surfaces !== void 0 ? _after_surfaces : []))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var s = _step.value;
            if (s.refid && !names.has(s.refid)) names.set(s.refid, spaceName(s));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var entries = [];
    var _after_surfaces1;
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        var _loop = function() {
            var surface11 = _step1.value;
            var _was_surface, _now_surface;
            if (surface11._deleted) return "continue";
            var _before_surfaces;
            var old = ((_before_surfaces = before.surfaces) !== null && _before_surfaces !== void 0 ? _before_surfaces : []).find(function(s) {
                return s.refid === surface11.refid;
            });
            if (!old) return "continue";
            var _was_surface_effectiveParent;
            var from = (_was_surface_effectiveParent = (_was_surface = was.surface(surface11.refid)) === null || _was_surface === void 0 ? void 0 : _was_surface.effectiveParent) !== null && _was_surface_effectiveParent !== void 0 ? _was_surface_effectiveParent : null;
            var _now_surface_effectiveParent;
            var to = (_now_surface_effectiveParent = (_now_surface = now.surface(surface11.refid)) === null || _now_surface === void 0 ? void 0 : _now_surface.effectiveParent) !== null && _now_surface_effectiveParent !== void 0 ? _now_surface_effectiveParent : null;
            if (from === to) return "continue";
            entries.push({
                id: surface11.refid,
                name: spaceName(surface11),
                kind: "space",
                from: from,
                to: to,
                wasChosen: !!old.parentChosen
            });
        };
        for(var _iterator1 = ((_after_surfaces1 = after.surfaces) !== null && _after_surfaces1 !== void 0 ? _after_surfaces1 : [])[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_loop();
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    var _before_items;
    var oldItems = (_before_items = before.items) !== null && _before_items !== void 0 ? _before_items : [];
    var _after_items;
    ((_after_items = after.items) !== null && _after_items !== void 0 ? _after_items : []).forEach(function(item, i) {
        var _was_item, _now_item;
        var old = oldItems[i];
        if (!old || old.refid !== item.refid || item._deleted) return;
        var _was_item_effectiveParent;
        var from = (_was_item_effectiveParent = (_was_item = was.item(old)) === null || _was_item === void 0 ? void 0 : _was_item.effectiveParent) !== null && _was_item_effectiveParent !== void 0 ? _was_item_effectiveParent : null;
        var _now_item_effectiveParent;
        var to = (_now_item_effectiveParent = (_now_item = now.item(item)) === null || _now_item === void 0 ? void 0 : _now_item.effectiveParent) !== null && _now_item_effectiveParent !== void 0 ? _now_item_effectiveParent : null;
        if (from === to) return;
        entries.push({
            id: item.refid,
            name: itemName(item),
            kind: "machine",
            from: from,
            to: to,
            wasChosen: !!old.parentChosen
        });
    });
    return {
        refid: refid,
        entries: entries,
        after: after,
        nameOf: function(id) {
            var _names_get;
            return (_names_get = names.get(id)) !== null && _names_get !== void 0 ? _names_get : "Space";
        }
    };
};
var reshapeImpact = function(startDesign, refid, startPoly, latestPoly) {
    return compareParentage(refid, startDesign, designAfterReshape(startDesign, refid, startPoly, latestPoly));
};
var groupImpact = function(impact) {
    var groups = {
        joins: [],
        leavesToFloor: [],
        leavesToSpace: /* @__PURE__ */ new Map(),
        elsewhere: [],
        chosen: []
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = impact.entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var e = _step.value;
            if (e.wasChosen) groups.chosen.push(e);
            if (e.id === impact.refid && e.kind === "space") {
                groups.self = e;
            } else if (e.to === impact.refid) {
                groups.joins.push(e);
            } else if (e.from === impact.refid && e.to === null) {
                groups.leavesToFloor.push(e);
            } else if (e.from === impact.refid && e.to !== null) {
                var _groups_leavesToSpace_get;
                var list = (_groups_leavesToSpace_get = groups.leavesToSpace.get(e.to)) !== null && _groups_leavesToSpace_get !== void 0 ? _groups_leavesToSpace_get : [];
                list.push(e);
                groups.leavesToSpace.set(e.to, list);
            } else {
                groups.elsewhere.push(e);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return groups;
};
// src/components/Planner/reshape/reshapeCapacity.ts
import { registerReadState as registerReadState3, useEquipmentCatalogStore as useEquipmentCatalogStore5, useFloorplanStore as useFloorplanStore13 } from "@repo/front-end-state";
import { findLatestDesign as findLatestDesign4, resolvePlanCapacity as resolvePlanCapacity2 } from "@repo/front-end-utils";
var withDesign = function(layout, floorIndex, design) {
    var floor = layout.floors[floorIndex];
    var current2 = floor ? findLatestDesign4(floor.designs) : null;
    if (!floor || !current2) return layout;
    return _object_spread_props(_object_spread({}, layout), {
        floors: layout.floors.map(function(f, i) {
            return i === floorIndex ? _object_spread_props(_object_spread({}, f), {
                designs: f.designs.map(function(d) {
                    return d === current2 ? design : d;
                })
            }) : f;
        })
    });
};
var capacityWithDesign = function(param) {
    var design = param.design, floorIndex = param.floorIndex, refid = param.refid, twinBid = param.twinBid, twinId = param.twinId, registerCapacityOf = param.registerCapacityOf;
    var _layout_floors_floorIndex;
    var layout = useFloorplanStore13.getState().layout;
    if (!layout) return void 0;
    var catalog = useEquipmentCatalogStore5.getState();
    var ready = registerReadState3(catalog, {
        twinId: twinId !== null && twinId !== void 0 ? twinId : void 0
    }) === "ready";
    var joined2 = joinedFor(withDesign(layout, floorIndex, design), catalog.registerRows, twinBid, ready);
    var floorId = (_layout_floors_floorIndex = layout.floors[floorIndex]) === null || _layout_floors_floorIndex === void 0 ? void 0 : _layout_floors_floorIndex.id;
    return resolvePlanCapacity2(joined2, registerCapacityOf).surface(refid, floorId);
};
// src/components/Planner/reshape/reshapeText.ts
var LIST_LIMIT = 5;
var TOAST_CLAUSES = 3;
var plural2 = function(n, one, many) {
    return "".concat(n, " ").concat(n === 1 ? one : many);
};
var countNoun = function(entries) {
    var machines = entries.filter(function(e) {
        return e.kind === "machine";
    }).length;
    var spaces = entries.length - machines;
    var parts = [
        machines ? plural2(machines, "machine", "machines") : "",
        spaces ? plural2(spaces, "space", "spaces") : ""
    ].filter(Boolean);
    return parts.join(" and ");
};
var nameList = function(names) {
    var _names_;
    if (names.length <= 1) return (_names_ = names[0]) !== null && _names_ !== void 0 ? _names_ : "";
    if (names.length <= LIST_LIMIT) {
        return "".concat(names.slice(0, -1).join(", "), " and ").concat(names[names.length - 1]);
    }
    return "".concat(names.slice(0, LIST_LIMIT).join(", "), " and ").concat(names.length - LIST_LIMIT, " more");
};
var namesOf = function(entries) {
    return nameList(entries.map(function(e) {
        return e.name;
    }));
};
var edgeTipText = function(param) {
    var key = param.key, d = param.d, snapped = param.snapped, limited = param.limited;
    var metres = Math.round(Math.abs(d) * 100) / 100;
    var parts = [
        key,
        "edge ".concat(d < 0 ? "in" : "out", " ").concat(metres, " m"),
        snapped ? "on grid" : "free"
    ];
    if (limited) parts.push("can't go further");
    return parts.join(" \xB7 ");
};
var reshapeNoteSentences = function(impact) {
    var g = groupImpact(impact);
    var name = impact.nameOf(impact.refid);
    var out = [];
    if (g.leavesToFloor.length) {
        var one = g.leavesToFloor.length === 1;
        out.push("Letting go here leaves ".concat(countNoun(g.leavesToFloor), " outside ").concat(name, ": ").concat(namesOf(g.leavesToFloor), ". Nothing else contains ").concat(one ? "it" : "them", ", so ").concat(one ? "it" : "they", " would sit on the floor."));
    }
    g.leavesToSpace.forEach(function(entries, to) {
        out.push("".concat(namesOf(entries), " would move to ").concat(impact.nameOf(to), "."));
    });
    if (g.joins.length) {
        out.push("Letting go here brings ".concat(countNoun(g.joins), " into ").concat(name, ": ").concat(namesOf(g.joins), "."));
    }
    if (g.elsewhere.length) {
        out.push("".concat(countNoun(g.elsewhere), " elsewhere would be refiled: ").concat(namesOf(g.elsewhere), "."));
    }
    if (g.self) {
        out.push(g.self.to === null ? "".concat(name, " itself would sit on the floor.") : "".concat(name, " itself would move into ").concat(impact.nameOf(g.self.to), "."));
    }
    if (g.chosen.length) {
        var one1 = g.chosen.length === 1;
        out.push("".concat(namesOf(g.chosen), " ").concat(one1 ? "was" : "were", " placed by hand. Letting go hands ").concat(one1 ? "it" : "them", " back to the drawing."));
    }
    return out;
};
var capacityText = function(value) {
    return typeof value === "number" ? String(value) : "\u2014";
};
var reshapeToastText = function(impact, capacity) {
    if (!impact.entries.length) return null;
    var name = impact.nameOf(impact.refid);
    var byDestination = /* @__PURE__ */ new Map();
    var onFloor = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = impact.entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var e = _step.value;
            var _byDestination_get;
            if (e.to === null) onFloor.push(e);
            else byDestination.set(e.to, _to_consumable_array((_byDestination_get = byDestination.get(e.to)) !== null && _byDestination_get !== void 0 ? _byDestination_get : []).concat([
                e
            ]));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var destinations = Array.from(byDestination.keys()).sort(function(a, b) {
        return a === impact.refid ? -1 : b === impact.refid ? 1 : 0;
    });
    var clauses = destinations.map(function(to) {
        return "".concat(countNoun(byDestination.get(to)), " moved into ").concat(impact.nameOf(to));
    });
    if (onFloor.length) {
        clauses.push("".concat(countNoun(onFloor), " now ").concat(onFloor.length === 1 ? "sits" : "sit", " on the floor"));
    }
    var chosen = impact.entries.filter(function(e) {
        return e.wasChosen;
    }).length;
    var room = chosen ? TOAST_CLAUSES - 1 : TOAST_CLAUSES;
    var shown2 = clauses.slice(0, room);
    if (clauses.length > room) {
        var more = clauses.length - room;
        shown2.push("and ".concat(more, " more ").concat(more === 1 ? "change" : "changes"));
    }
    if (chosen) {
        shown2.push("".concat(chosen, " hand-placed ").concat(chosen === 1 ? "parent was" : "parents were", " replaced by the drawing"));
    }
    var capacityChanged = capacity && typeof capacity.before === "number" && typeof capacity.after === "number" && capacity.before !== capacity.after;
    var title = capacityChanged ? "Reshaped ".concat(name, " \xb7 Capacity ").concat(capacity.before, " → ").concat(capacity.after) : "Reshaped ".concat(name);
    return {
        title: title,
        sub: shown2.join(" \xB7 ")
    };
};
var EDGE_PUT_BACK = "Edge put back";
var movingEdgeOf = function(name) {
    return "Moving an edge of ".concat(name);
};
var edgeCannotGoFurther = function(name) {
    return "That edge of ".concat(name, " can't go any further");
};
// src/components/Planner/reshape/ReshapeReport.tsx
import { jsx as jsx10 } from "react/jsx-runtime";
var ReshapeReport = function(param) {
    var store = param.store, toastRegion = param.toastRegion, twinBid = param.twinBid, twinId = param.twinId;
    var show = useRegionToast(toastRegion);
    var registerCapacityOf = useRegisterCapacityOf(twinId);
    var latest = useRef7({
        show: show,
        registerCapacityOf: registerCapacityOf,
        twinBid: twinBid,
        twinId: twinId
    });
    latest.current = {
        show: show,
        registerCapacityOf: registerCapacityOf,
        twinBid: twinBid,
        twinId: twinId
    };
    useEffect9(function() {
        if (!store) return;
        return store.onEnded(function(ended) {
            var _plan_layout;
            if (!ended.committed) return;
            var stack = useEditorStore7.getState().undoStack;
            if (ended.step !== void 0 && stack[stack.length - 1] !== ended.step) return;
            var plan = useFloorplanStore14.getState();
            var floor = (_plan_layout = plan.layout) === null || _plan_layout === void 0 ? void 0 : _plan_layout.floors[ended.floorIndex];
            var now = floor ? findLatestDesign5(floor.designs) : null;
            if (!now) return;
            var impact = compareParentage(ended.refid, ended.startDesign, now);
            var _latest_current = latest.current, toast = _latest_current.show, capacityOf2 = _latest_current.registerCapacityOf, bid = _latest_current.twinBid, id = _latest_current.twinId;
            var ask = function(design) {
                return capacityWithDesign({
                    design: design,
                    floorIndex: ended.floorIndex,
                    refid: ended.refid,
                    twinBid: bid,
                    twinId: id,
                    registerCapacityOf: capacityOf2
                });
            };
            var before = ask(ended.startDesign);
            var after = ask(now);
            var text2 = reshapeToastText(impact, (before === null || before === void 0 ? void 0 : before.source) === "calculated" && (after === null || after === void 0 ? void 0 : after.source) === "calculated" ? {
                before: before.value,
                after: after.value
            } : void 0);
            if (!text2) return;
            var undo = guardedUndo(toast);
            toast({
                tone: "success",
                icon: /* @__PURE__ */ jsx10(Icon6, {
                    name: "draw-polygon"
                }),
                title: text2.title,
                sub: text2.sub,
                inlineAction: {
                    label: "Undo",
                    onAction: undo
                }
            });
        });
    }, [
        store
    ]);
    return null;
};
// src/components/Planner/hooks/plannerHover.tsx
import { createContext as createContext7, useContext as useContext7, useMemo as useMemo7, useState as useState8 } from "react";
import { jsx as jsx11 } from "react/jsx-runtime";
var PlannerHoverContext = createContext7(null);
var usePlannerHover = function() {
    return useContext7(PlannerHoverContext);
};
function PlannerHoverProvider(param) {
    var enabled = param.enabled, children = param.children;
    var _useState8 = _sliced_to_array(useState8(null), 2), hoveredId = _useState8[0], setHovered = _useState8[1];
    var value = useMemo7(function() {
        return enabled ? {
            hoveredId: hoveredId,
            setHovered: setHovered
        } : null;
    }, [
        enabled,
        hoveredId
    ]);
    return /* @__PURE__ */ jsx11(PlannerHoverContext.Provider, {
        value: value,
        children: children
    });
}
// src/components/Planner/align/AlignFloorsPanel.tsx
import { useEffect as useEffect14, useMemo as useMemo9, useRef as useRef13, useState as useState14 } from "react";
import styled10 from "styled-components";
import { Button as Button7, Icon as Icon9 } from "@repo/design-system";
import { fontMono as fontMono2, semantic as semantic5, space as space8, typeRole as typeRole5 } from "@repo/design-tokens";
import { useEditorStore as useEditorStore16, useFloorplanStore as useFloorplanStore24 } from "@repo/front-end-state";
import { findLatestDesign as findLatestDesign9, floorDrawState as floorDrawState3, floorOutlineCentre, floorPlaceLabel, placementOf as placementOf3, rotatePlacementAbout, roundToMm as roundToMm2, screenNudge as screenNudge2, stepRotation as stepRotation2 } from "@repo/front-end-utils";
// src/components/Planner/underlays/runPlacementEdit.ts
import { useEditorStore as useEditorStore8, useFloorplanStore as useFloorplanStore15 } from "@repo/front-end-state";
function runPlacementEdit(change) {
    var layout = useFloorplanStore15.getState().layout;
    if (!layout) return;
    useEditorStore8.getState().pushSnapshot(layout, "align");
    change();
}
// src/components/Planner/align/AlignPdfsSection.tsx
import { useEffect as useEffect12, useRef as useRef11, useState as useState12 } from "react";
import styled9 from "styled-components";
import { Button as Button6, Icon as Icon8, Input as Input4, Slider } from "@repo/design-system";
import { radius as radius4, semantic as semantic4, shadow as shadow3, space as space7, surface, typeRole as typeRole4 } from "@repo/design-tokens";
import { useEditorStore as useEditorStore15, useFloorplanStore as useFloorplanStore22 } from "@repo/front-end-state";
import { cleanUnderlayName, findLatestDesign as findLatestDesign8, moveInFloor, placementOf as placementOf2, roundToMm, screenNudge, stepRotation } from "@repo/front-end-utils";
// src/components/Planner/underlays/useSelectedUnderlay.ts
import { useEditorStore as useEditorStore10, useFloorplanStore as useFloorplanStore16 } from "@repo/front-end-state";
import { findLatestDesign as findLatestDesign6, floorDrawState } from "@repo/front-end-utils";
// src/components/Planner/align/useFloorVisibility.ts
import { useMemo as useMemo8 } from "react";
import { useEditorStore as useEditorStore9 } from "@repo/front-end-state";
var useFloorVisibility = function() {
    var hidden = useEditorStore9(function(s) {
        return s.hiddenFloorIds;
    });
    var shown2 = useEditorStore9(function(s) {
        return s.shownFloorIds;
    });
    return useMemo8(function() {
        return {
            hidden: hidden,
            shown: shown2
        };
    }, [
        hidden,
        shown2
    ]);
};
var floorVisibilityNow = function() {
    var _useEditorStore9_getState = useEditorStore9.getState(), hiddenFloorIds = _useEditorStore9_getState.hiddenFloorIds, shownFloorIds = _useEditorStore9_getState.shownFloorIds;
    return {
        hidden: hiddenFloorIds,
        shown: shownFloorIds
    };
};
// src/components/Planner/underlays/useSelectedUnderlay.ts
function useSelectedUnderlay() {
    var selectedId = useEditorStore10(function(s) {
        return s.selectedUnderlayId;
    });
    var visibility = useFloorVisibility();
    var activeFloorIndex = useFloorplanStore16(function(s) {
        return s.activeFloorIndex;
    });
    var floors = useFloorplanStore16(function(s) {
        var _s_layout;
        return (_s_layout = s.layout) === null || _s_layout === void 0 ? void 0 : _s_layout.floors;
    });
    return findUnderlay(floors, selectedId, {
        activeFloorIndex: activeFloorIndex,
        visibility: visibility
    });
}
function findUnderlay(floors, underlayId, view) {
    if (!floors || !underlayId) return null;
    for(var floorIndex = 0; floorIndex < floors.length; floorIndex++){
        var _findLatestDesign6_underlays, _findLatestDesign6;
        var floor = floors[floorIndex];
        var underlay = (_findLatestDesign6 = findLatestDesign6(floor.designs)) === null || _findLatestDesign6 === void 0 ? void 0 : (_findLatestDesign6_underlays = _findLatestDesign6.underlays) === null || _findLatestDesign6_underlays === void 0 ? void 0 : _findLatestDesign6_underlays.find(function(u) {
            return u.id === underlayId;
        });
        if (underlay) return {
            underlay: underlay,
            floorIndex: floorIndex,
            drawn: underlay.visible && (!view || floorDrawState(floors, floorIndex, view.activeFloorIndex, view.visibility) !== "hidden")
        };
    }
    return null;
}
// src/components/Planner/underlays/runUnderlayEdit.ts
import { useEditorStore as useEditorStore11, useFloorplanStore as useFloorplanStore17 } from "@repo/front-end-state";
function runUnderlayEdit(change) {
    var layout = useFloorplanStore17.getState().layout;
    if (!layout) return;
    useEditorStore11.getState().pushSnapshot(layout, "align");
    change();
}
// src/components/Planner/underlays/selectUnderlayOnFloor.ts
import { useEditorStore as useEditorStore12, useFloorplanStore as useFloorplanStore18 } from "@repo/front-end-state";
function selectUnderlayOnFloor(underlayId, floorIndex) {
    useFloorplanStore18.getState().setActiveFloor(floorIndex);
    useEditorStore12.getState().selectUnderlay(underlayId);
}
// src/components/Planner/underlays/usePdfImport.tsx
import { useCallback as useCallback6, useContext as useContext8, useRef as useRef9, useState as useState10 } from "react";
import { useEditorStore as useEditorStore13, useFloorplanStore as useFloorplanStore19 } from "@repo/front-end-state";
import { newUnderlay } from "@repo/front-end-utils";
// src/components/Planner/underlays/PdfImportDialog.tsx
import { useCallback as useCallback5, useEffect as useEffect10, useRef as useRef8, useState as useState9 } from "react";
import styled6 from "styled-components";
import { Banner, Button as Button5, Modal as Modal3 } from "@repo/design-system";
import { radius as radius2, rgba, semantic, space as space4, typeRole } from "@repo/design-tokens";
import { MIDDLEWARE_REQUEST_TIMEOUT_MS as MIDDLEWARE_REQUEST_TIMEOUT_MS2, UNDERLAY_IMPORT_MESSAGES } from "@repo/front-end-services";
import { underlayNameFromFile } from "@repo/front-end-utils";
import { Fragment as Fragment4, jsx as jsx12, jsxs as jsxs7 } from "react/jsx-runtime";
var MAX_RENDER_DIM = 2e3;
var OUTPUT_MIME = "image/jpeg";
var OUTPUT_QUALITY = 0.9;
var MIN_CROP_PX = 10;
var REFERENCE_ACCEPT = "application/pdf,image/png,image/jpeg,.pdf,.png,.jpg,.jpeg";
function referenceSourceOf(file) {
    if (file.type === "application/pdf") return "pdf";
    if (file.type === "image/png" || file.type === "image/jpeg") return "image";
    if (/\.pdf$/i.test(file.name)) return "pdf";
    if (/\.(png|jpe?g)$/i.test(file.name)) return "image";
    return null;
}
var MAX_IMAGE_BYTES = 50 * 1024 * 1024;
var MAX_IMAGE_PIXELS = 6e7;
var imageRefused = function(message) {
    return Object.assign(new Error(message), {
        refused: true
    });
};
var isImageRefused = function(err) {
    return _instanceof(err, Error) && err.refused === true;
};
var IMAGE_WORDING = Object.fromEntries(Object.values(UNDERLAY_IMPORT_MESSAGES).map(function(sentence) {
    return [
        sentence,
        sentence.replace("This PDF page", "This image").replace("the PDF", "the image").replace("The PDF", "The image")
    ];
}));
var imageWording = function(sentence) {
    var _IMAGE_WORDING_sentence;
    return (_IMAGE_WORDING_sentence = IMAGE_WORDING[sentence]) !== null && _IMAGE_WORDING_sentence !== void 0 ? _IMAGE_WORDING_sentence : sentence;
};
function renderImage(file) {
    return _renderImage.apply(this, arguments);
}
function _renderImage() {
    _renderImage = _async_to_generator(function(file) {
        var url, img, width, height, scale, canvas, ctx;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (file.size > MAX_IMAGE_BYTES) throw imageRefused("".concat(file.name, " is larger than ").concat(MAX_IMAGE_BYTES / 1024 / 1024, " MB. Save it smaller and try again."));
                    url = URL.createObjectURL(file);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        ,
                        3,
                        4
                    ]);
                    return [
                        4,
                        new Promise(function(resolve, reject) {
                            var el = new Image();
                            el.onload = function() {
                                return resolve(el);
                            };
                            el.onerror = function() {
                                return reject(new Error("the image could not be decoded"));
                            };
                            el.src = url;
                        })
                    ];
                case 2:
                    img = _state.sent();
                    width = img.naturalWidth || img.width;
                    height = img.naturalHeight || img.height;
                    if (!width || !height) throw new Error("the image has no size");
                    if (width * height > MAX_IMAGE_PIXELS) throw imageRefused("".concat(file.name, " is ").concat(width, " \xd7 ").concat(height, " pixels, too large to use as a reference. Save it smaller and try again."));
                    scale = Math.min(1, MAX_RENDER_DIM / width, MAX_RENDER_DIM / height);
                    canvas = document.createElement("canvas");
                    canvas.width = Math.max(1, Math.round(width * scale));
                    canvas.height = Math.max(1, Math.round(height * scale));
                    ctx = canvas.getContext("2d");
                    ctx.fillStyle = "#ffffff";
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                    return [
                        2,
                        canvas
                    ];
                case 3:
                    URL.revokeObjectURL(url);
                    return [
                        7
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _renderImage.apply(this, arguments);
}
var toJpeg = function(canvas) {
    return new Promise(function(resolve) {
        return canvas.toBlob(resolve, OUTPUT_MIME, OUTPUT_QUALITY);
    });
};
var PdfImportDialog = function(param) {
    var file = param.file, store = param.store, onImported = param.onImported, onCancel = param.onCancel, returnFocusTo = param.returnFocusTo;
    var containerRef = useRef8(null);
    var canvasRef = useRef8(null);
    var fullPageRef = useRef8(null);
    var _useState9 = _sliced_to_array(useState9({
        kind: "loading"
    }), 2), render = _useState9[0], setRender = _useState9[1];
    var _useState91 = _sliced_to_array(useState9({
        kind: "idle"
    }), 2), upload = _useState91[0], setUpload = _useState91[1];
    var uploadController = useRef8(null);
    var disposed = useRef8(false);
    var _useState92 = _sliced_to_array(useState9(null), 2), cropStart = _useState92[0], setCropStart = _useState92[1];
    var _useState93 = _sliced_to_array(useState9(null), 2), cropEnd = _useState93[0], setCropEnd = _useState93[1];
    var _useState94 = _sliced_to_array(useState9(false), 2), isDragging = _useState94[0], setIsDragging = _useState94[1];
    var source = referenceSourceOf(file);
    useEffect10(function() {
        if (source !== "image") return;
        var cancelled = false;
        renderImage(file).then(function(canvas) {
            if (!cancelled) setRender({
                kind: "ready",
                page: canvas
            });
        }, function(err) {
            console.warn("[planner] the file could not be read as an image", {
                file: file.name,
                message: _instanceof(err, Error) ? err.message : String(err)
            });
            if (cancelled) return;
            setRender(isImageRefused(err) ? {
                kind: "imageRefused",
                message: err.message
            } : {
                kind: "unreadableImage"
            });
        });
        return function() {
            cancelled = true;
        };
    }, [
        file,
        source
    ]);
    useEffect10(function() {
        if (source === null) setRender({
            kind: "wrongType"
        });
    }, [
        source
    ]);
    useEffect10(function() {
        if (source !== "pdf") return;
        var cancelled = false;
        var task = null;
        var release = function() {
            void (task === null || task === void 0 ? void 0 : task.destroy().catch(function() {
                return void 0;
            }));
            task = null;
        };
        _async_to_generator(function() {
            var pdfjsLib, loading, _, _tmp, pdf, page2, base2, scale, viewport, canvas, ctx, err;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            6,
                            7,
                            8
                        ]);
                        return [
                            4,
                            import("pdfjs-dist")
                        ];
                    case 1:
                        pdfjsLib = _state.sent();
                        pdfjsLib.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.mjs";
                        _ = pdfjsLib.getDocument;
                        _tmp = {};
                        return [
                            4,
                            file.arrayBuffer()
                        ];
                    case 2:
                        loading = _.apply(pdfjsLib, [
                            (_tmp.data = _state.sent(), _tmp)
                        ]);
                        task = loading;
                        return [
                            4,
                            loading.promise
                        ];
                    case 3:
                        pdf = _state.sent();
                        if (pdf.numPages < 1) {
                            console.warn("[planner] the PDF has no pages to import", {
                                file: file.name
                            });
                            if (!cancelled) setRender({
                                kind: "noPages"
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            pdf.getPage(1)
                        ];
                    case 4:
                        page2 = _state.sent();
                        base2 = page2.getViewport({
                            scale: 1
                        });
                        scale = Math.max(0.1, Math.min(2, MAX_RENDER_DIM / base2.width, MAX_RENDER_DIM / base2.height));
                        viewport = page2.getViewport({
                            scale: scale
                        });
                        canvas = document.createElement("canvas");
                        canvas.width = viewport.width;
                        canvas.height = viewport.height;
                        ctx = canvas.getContext("2d");
                        ctx.fillStyle = "#ffffff";
                        ctx.fillRect(0, 0, canvas.width, canvas.height);
                        return [
                            4,
                            page2.render({
                                canvasContext: ctx,
                                viewport: viewport,
                                canvas: canvas
                            }).promise
                        ];
                    case 5:
                        _state.sent();
                        if (!cancelled) setRender({
                            kind: "ready",
                            page: canvas
                        });
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        console.warn("[planner] the file could not be read as a PDF", {
                            file: file.name,
                            message: _instanceof(err, Error) ? err.message : String(err)
                        });
                        if (!cancelled) setRender({
                            kind: "unreadable"
                        });
                        return [
                            3,
                            8
                        ];
                    case 7:
                        release();
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        })();
        return function() {
            cancelled = true;
            release();
        };
    }, [
        file,
        source
    ]);
    useEffect10(function() {
        disposed.current = false;
        return function() {
            var _uploadController_current;
            disposed.current = true;
            (_uploadController_current = uploadController.current) === null || _uploadController_current === void 0 ? void 0 : _uploadController_current.abort();
        };
    }, []);
    var page = render.kind === "ready" ? render.page : null;
    useEffect10(function() {
        if (!page || !canvasRef.current || !containerRef.current) return;
        var canvas = canvasRef.current;
        var maxWidth = Math.min(containerRef.current.clientWidth || 800, 800);
        var displayWidth = Math.min(maxWidth, page.width);
        var displayHeight = displayWidth / (page.width / page.height);
        canvas.width = displayWidth;
        canvas.height = displayHeight;
        canvas.style.width = "".concat(displayWidth, "px");
        canvas.style.height = "".concat(displayHeight, "px");
        canvas.getContext("2d").drawImage(page, 0, 0, displayWidth, displayHeight);
    }, [
        page
    ]);
    var getMousePos = useCallback5(function(e) {
        var _canvasRef_current;
        var rect = (_canvasRef_current = canvasRef.current) === null || _canvasRef_current === void 0 ? void 0 : _canvasRef_current.getBoundingClientRect();
        return rect ? {
            x: e.clientX - rect.left,
            y: e.clientY - rect.top
        } : {
            x: 0,
            y: 0
        };
    }, []);
    var busy = upload.kind === "busy";
    var send = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(rendered) {
            var _uploadController_current, controller, timedOut, deadline, result;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (disposed.current) return [
                            2
                        ];
                        (_uploadController_current = uploadController.current) === null || _uploadController_current === void 0 ? void 0 : _uploadController_current.abort();
                        controller = new AbortController();
                        uploadController.current = controller;
                        timedOut = false;
                        deadline = setTimeout(function() {
                            timedOut = true;
                            controller.abort();
                        }, MIDDLEWARE_REQUEST_TIMEOUT_MS2);
                        setUpload({
                            kind: "busy"
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            Promise.race([
                                store(rendered.blob, controller.signal),
                                new Promise(function(resolve) {
                                    return controller.signal.addEventListener("abort", function() {
                                        return resolve({
                                            ok: false,
                                            message: UNDERLAY_IMPORT_MESSAGES.failed
                                        });
                                    });
                                })
                            ])
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        clearTimeout(deadline);
                        return [
                            7
                        ];
                    case 4:
                        if (disposed.current) return [
                            2
                        ];
                        if (timedOut) {
                            setUpload({
                                kind: "failed",
                                message: UNDERLAY_IMPORT_MESSAGES.failed,
                                page: rendered
                            });
                            return [
                                2
                            ];
                        }
                        if (controller.signal.aborted) return [
                            2
                        ];
                        if (result.ok) {
                            onImported({
                                imageRef: result.imageRef,
                                widthPx: rendered.widthPx,
                                heightPx: rendered.heightPx
                            });
                        } else {
                            setUpload({
                                kind: "failed",
                                message: result.message,
                                page: rendered
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function send(rendered) {
            return _ref.apply(this, arguments);
        };
    }();
    var cropRect = cropStart && cropEnd ? {
        left: Math.min(cropStart.x, cropEnd.x),
        top: Math.min(cropStart.y, cropEnd.y),
        width: Math.abs(cropEnd.x - cropStart.x),
        height: Math.abs(cropEnd.y - cropStart.y)
    } : null;
    var hasCrop = !!cropRect && cropRect.width >= MIN_CROP_PX && cropRect.height >= MIN_CROP_PX;
    var importPage = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(crop) {
            var displayScale, area, out, ctx, blob;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!page || !canvasRef.current || busy) return [
                            2
                        ];
                        setUpload({
                            kind: "busy"
                        });
                        displayScale = page.width / canvasRef.current.width;
                        area = crop && hasCrop && cropRect ? {
                            x: cropRect.left * displayScale,
                            y: cropRect.top * displayScale,
                            w: cropRect.width * displayScale,
                            h: cropRect.height * displayScale
                        } : {
                            x: 0,
                            y: 0,
                            w: page.width,
                            h: page.height
                        };
                        out = document.createElement("canvas");
                        out.width = Math.round(area.w);
                        out.height = Math.round(area.h);
                        ctx = out.getContext("2d");
                        ctx.fillStyle = "#ffffff";
                        ctx.fillRect(0, 0, out.width, out.height);
                        ctx.drawImage(page, area.x, area.y, area.w, area.h, 0, 0, out.width, out.height);
                        return [
                            4,
                            toJpeg(out)
                        ];
                    case 1:
                        blob = _state.sent();
                        if (disposed.current) return [
                            2
                        ];
                        if (!blob) {
                            setUpload({
                                kind: "failed",
                                message: UNDERLAY_IMPORT_MESSAGES.unsupported
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            send({
                                blob: blob,
                                widthPx: out.width,
                                heightPx: out.height
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function importPage(crop) {
            return _ref.apply(this, arguments);
        };
    }();
    var retry = function(rendered) {
        var _fullPageRef_current;
        (_fullPageRef_current = fullPageRef.current) === null || _fullPageRef_current === void 0 ? void 0 : _fullPageRef_current.focus();
        void send(rendered);
    };
    var cancel = function() {
        var _uploadController_current;
        (_uploadController_current = uploadController.current) === null || _uploadController_current === void 0 ? void 0 : _uploadController_current.abort();
        onCancel();
    };
    return /* @__PURE__ */ jsxs7(Modal3, {
        open: true,
        onClose: cancel,
        title: source === "image" ? "Import image" : "Import PDF",
        width: "xl",
        returnFocusTo: returnFocusTo,
        actions: /* @__PURE__ */ jsxs7(Fragment4, {
            children: [
                /* @__PURE__ */ jsx12(Button5, {
                    variant: "frosted",
                    size: "inline",
                    onClick: cancel,
                    children: "Cancel"
                }),
                /* @__PURE__ */ jsx12(Button5, {
                    ref: fullPageRef,
                    variant: "frosted",
                    size: "inline",
                    disabled: !page,
                    loading: busy,
                    onClick: function() {
                        return void importPage(false);
                    },
                    children: source === "image" ? "Use whole image" : "Use full page"
                }),
                /* @__PURE__ */ jsx12(Button5, {
                    variant: "primary",
                    size: "inline",
                    disabled: !page || !hasCrop,
                    loading: busy,
                    onClick: function() {
                        return void importPage(true);
                    },
                    children: "Crop and use"
                })
            ]
        }),
        children: [
            /* @__PURE__ */ jsx12(Help, {
                children: source === "image" ? "Drag over the image to crop the part of the floor plan you want, or use the whole image. It is added to the selected floor as a new reference." : "Drag over the page to crop the part of the floor plan you want, or use the full page. It is added to the selected floor as a new PDF."
            }),
            /* @__PURE__ */ jsx12("span", {
                role: "status",
                "aria-live": "polite",
                "aria-atomic": "true",
                style: visuallyHidden,
                children: render.kind === "loading" ? source === "image" ? "Loading the image\u2026" : "Loading the PDF\u2026" : busy ? "Uploading ".concat(underlayNameFromFile(file.name), "…") : ""
            }),
            render.kind === "loading" && /* @__PURE__ */ jsx12(Help, {
                "aria-hidden": true,
                children: source === "image" ? "Loading the image\u2026" : "Loading the PDF\u2026"
            }),
            render.kind === "wrongType" && /* @__PURE__ */ jsx12(Banner, {
                tone: "error",
                role: "alert",
                title: "".concat(file.name, " is not a PDF, PNG or JPEG.")
            }),
            render.kind === "imageRefused" && /* @__PURE__ */ jsx12(Banner, {
                tone: "error",
                role: "alert",
                title: render.message
            }),
            render.kind === "unreadableImage" && /* @__PURE__ */ jsx12(Banner, {
                tone: "error",
                role: "alert",
                title: "".concat(file.name, " could not be read as an image. Choose another file.")
            }),
            render.kind === "noPages" && /* @__PURE__ */ jsx12(Banner, {
                tone: "error",
                role: "alert",
                title: "This PDF has no pages to import."
            }),
            render.kind === "unreadable" && /* @__PURE__ */ jsx12(Banner, {
                tone: "error",
                role: "alert",
                title: "This file could not be read as a PDF. Choose another file."
            }),
            upload.kind === "failed" && /* @__PURE__ */ jsx12(Banner, {
                tone: "error",
                role: "alert",
                title: source === "image" ? imageWording(upload.message) : upload.message,
                "data-testid": "pdf-import-error",
                children: upload.page && /* @__PURE__ */ jsx12(RetryRow, {
                    children: /* @__PURE__ */ jsx12(Button5, {
                        variant: "ghost",
                        size: "xs",
                        onClick: function() {
                            return retry(upload.page);
                        },
                        children: "Try again"
                    })
                })
            }),
            /* @__PURE__ */ jsxs7(CanvasContainer, {
                ref: containerRef,
                onMouseDown: function(e) {
                    if (busy) return;
                    var pos = getMousePos(e);
                    setCropStart(pos);
                    setCropEnd(pos);
                    setIsDragging(true);
                },
                onMouseMove: function(e) {
                    if (isDragging) setCropEnd(getMousePos(e));
                },
                onMouseUp: function() {
                    return setIsDragging(false);
                },
                onMouseLeave: function() {
                    return setIsDragging(false);
                },
                children: [
                    /* @__PURE__ */ jsx12("canvas", {
                        ref: canvasRef,
                        "aria-label": "First page of ".concat(file.name),
                        role: "img"
                    }),
                    hasCrop && cropRect && /* @__PURE__ */ jsx12(CropOverlay, {
                        style: cropRect
                    })
                ]
            })
        ]
    });
};
var Help = styled6.p(_templateObject34(), space4[3], typeRole.body2.fontFamily, typeRole.body2.fontSize, typeRole.body2.lineHeight, semantic.text.secondary);
var CanvasContainer = styled6.div(_templateObject35(), space4[3], semantic.border.default, radius2.md);
var CropOverlay = styled6.div(_templateObject36(), semantic.interactive.accent, rgba(semantic.interactive.accent, 0.1));
var RetryRow = styled6.div(_templateObject37(), space4[2]);
// src/components/Planner/underlays/usePdfImport.tsx
import { Fragment as Fragment5, jsx as jsx13, jsxs as jsxs8 } from "react/jsx-runtime";
var importedSentence = function(underlay, target) {
    var _useFloorplanStore19_getState_layout_floors_find, _useFloorplanStore19_getState_layout;
    var floorName = (_useFloorplanStore19_getState_layout = useFloorplanStore19.getState().layout) === null || _useFloorplanStore19_getState_layout === void 0 ? void 0 : (_useFloorplanStore19_getState_layout_floors_find = _useFloorplanStore19_getState_layout.floors.find(function(f) {
        return f.id === target.floorId;
    })) === null || _useFloorplanStore19_getState_layout_floors_find === void 0 ? void 0 : _useFloorplanStore19_getState_layout_floors_find.name;
    return floorName ? "".concat(underlay.name, " imported to ").concat(floorName, ".") : "".concat(underlay.name, " imported.");
};
function usePdfImport() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, onImported = _ref.onImported, returnFocusTo = _ref.returnFocusTo;
    var host = useContext8(UnderlayImagesContext);
    var inputRef = useRef9(null);
    var targetRef = useRef9(null);
    var _useState10 = _sliced_to_array(useState10(null), 2), file = _useState10[0], setFile = _useState10[1];
    var openFile = useRef9(null);
    openFile.current = file;
    var choose = useCallback6(function(target) {
        var _inputRef_current;
        targetRef.current = target;
        (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.click();
    }, []);
    var close = useCallback6(function() {
        setFile(null);
        targetRef.current = null;
    }, []);
    var handleImported = useCallback6(function(param, importedFile) {
        var imageRef = param.imageRef, widthPx = param.widthPx, heightPx = param.heightPx;
        var _useFloorplanStore19_getState_layout;
        var target = targetRef.current;
        if (!target || importedFile !== openFile.current) return;
        var _referenceSourceOf;
        var underlay = newUnderlay({
            imageRef: imageRef,
            widthPx: widthPx,
            heightPx: heightPx,
            name: importedFile.name,
            // A PDF page or an image file (`floor-plan-page-build-floors` R17).
            source: (_referenceSourceOf = referenceSourceOf(importedFile)) !== null && _referenceSourceOf !== void 0 ? _referenceSourceOf : "pdf"
        });
        var _useFloorplanStore19_getState_layout_floors;
        var floors = (_useFloorplanStore19_getState_layout_floors = (_useFloorplanStore19_getState_layout = useFloorplanStore19.getState().layout) === null || _useFloorplanStore19_getState_layout === void 0 ? void 0 : _useFloorplanStore19_getState_layout.floors) !== null && _useFloorplanStore19_getState_layout_floors !== void 0 ? _useFloorplanStore19_getState_layout_floors : [];
        if (!floors.some(function(f) {
            return f.id === target.floorId;
        })) {
            close();
            return;
        }
        runUnderlayEdit(function() {
            return useFloorplanStore19.getState().addUnderlay(target.floorId, underlay);
        });
        useEditorStore13.getState().selectUnderlay(underlay.id);
        useEditorStore13.getState().setScalePromptUnderlay(underlay.id);
        onImported === null || onImported === void 0 ? void 0 : onImported(underlay, target);
        close();
    }, [
        onImported,
        close
    ]);
    var element = /* @__PURE__ */ jsxs8(Fragment5, {
        children: [
            /* @__PURE__ */ jsx13("input", {
                ref: inputRef,
                type: "file",
                accept: REFERENCE_ACCEPT,
                hidden: true,
                "data-testid": "pdf-import-input",
                onChange: function(e) {
                    var _e_target_files;
                    var _e_target_files_;
                    var chosen = (_e_target_files_ = (_e_target_files = e.target.files) === null || _e_target_files === void 0 ? void 0 : _e_target_files[0]) !== null && _e_target_files_ !== void 0 ? _e_target_files_ : null;
                    e.target.value = "";
                    if (chosen) setFile(chosen);
                }
            }),
            file && host && /* @__PURE__ */ jsx13(PdfImportDialog, {
                file: file,
                store: function(blob, signal) {
                    return host.store(blob, signal);
                },
                onImported: function(stored) {
                    return handleImported(stored, file);
                },
                onCancel: close,
                returnFocusTo: returnFocusTo
            })
        ]
    });
    return {
        canImport: !!(host === null || host === void 0 ? void 0 : host.canStore),
        choose: choose,
        element: element
    };
}
// src/components/Planner/underlays/useUnderlayToolReady.ts
var UNAVAILABLE = {
    set: "Select a visible PDF to set its scale",
    scale: "Select a visible PDF to scale it"
};
var READY = {
    set: function(name) {
        return "Set scale of ".concat(name, " — click two points on it, then enter the real-world distance in metres");
    },
    scale: function(name) {
        return "Scale ".concat(name, " — drag down on it to grow it, up to shrink it");
    }
};
function useUnderlayToolReady(underlayId, tool) {
    var selected2 = useSelectedUnderlay();
    var onScreen = useUnderlayOnScreen(selected2 === null || selected2 === void 0 ? void 0 : selected2.underlay);
    var mine = !!selected2 && (underlayId === null || selected2.underlay.id === underlayId);
    if (!mine || !selected2.drawn || !onScreen) return {
        ready: false,
        title: UNAVAILABLE[tool]
    };
    var _selected2_underlay = selected2.underlay, name = _selected2_underlay.name, locked = _selected2_underlay.locked;
    if (locked) return {
        ready: false,
        title: tool === "set" ? "Unlock ".concat(name, " to set its scale.") : "Unlock ".concat(name, " to scale it.")
    };
    return {
        ready: true,
        title: READY[tool](name)
    };
}
// src/components/Planner/underlays/useUnderlayView.ts
import { useEditorStore as useEditorStore14 } from "@repo/front-end-state";
function applyUnderlayPreview(underlay, preview) {
    if (!underlay || !preview || preview.underlayId !== underlay.id) return underlay;
    return _object_spread({}, underlay, preview.patch);
}
function useUnderlayView(underlay) {
    var id = underlay === null || underlay === void 0 ? void 0 : underlay.id;
    var preview = useEditorStore14(function(s) {
        var _s_underlayPreview;
        return id && ((_s_underlayPreview = s.underlayPreview) === null || _s_underlayPreview === void 0 ? void 0 : _s_underlayPreview.underlayId) === id ? s.underlayPreview : null;
    });
    return applyUnderlayPreview(underlay, preview);
}
// src/components/Planner/align/pdfRowActions.ts
import { useFloorplanStore as useFloorplanStore20 } from "@repo/front-end-state";
import { copyOfUnderlay, findLatestDesign as findLatestDesign7, floorDrawState as floorDrawState2, placementOf, reexpressUnderlay, stackPlace } from "@repo/front-end-utils";
var floorsNow = function() {
    var _useFloorplanStore20_getState_layout;
    return (_useFloorplanStore20_getState_layout = useFloorplanStore20.getState().layout) === null || _useFloorplanStore20_getState_layout === void 0 ? void 0 : _useFloorplanStore20_getState_layout.floors;
};
var listOf = function(floorIndex) {
    var _findLatestDesign7, _floorsNow_floorIndex, _floorsNow;
    var _floorsNow_floorIndex_designs, _findLatestDesign7_underlays;
    return (_findLatestDesign7_underlays = (_findLatestDesign7 = findLatestDesign7((_floorsNow_floorIndex_designs = (_floorsNow = floorsNow()) === null || _floorsNow === void 0 ? void 0 : (_floorsNow_floorIndex = _floorsNow[floorIndex]) === null || _floorsNow_floorIndex === void 0 ? void 0 : _floorsNow_floorIndex.designs) !== null && _floorsNow_floorIndex_designs !== void 0 ? _floorsNow_floorIndex_designs : [])) === null || _findLatestDesign7 === void 0 ? void 0 : _findLatestDesign7.underlays) !== null && _findLatestDesign7_underlays !== void 0 ? _findLatestDesign7_underlays : [];
};
function locate(underlayId) {
    var found = findUnderlay(floorsNow(), underlayId);
    if (!found) return null;
    var list = listOf(found.floorIndex);
    return _object_spread_props(_object_spread({}, found), {
        index: list.indexOf(found.underlay),
        list: list
    });
}
var floorIndexOf = function(floorId) {
    var _floorsNow;
    var _floorsNow_findIndex;
    return (_floorsNow_findIndex = (_floorsNow = floorsNow()) === null || _floorsNow === void 0 ? void 0 : _floorsNow.findIndex(function(f) {
        return f.id === floorId;
    })) !== null && _floorsNow_findIndex !== void 0 ? _floorsNow_findIndex : -1;
};
function placeOf(underlayId, floorIndex) {
    var list = listOf(floorIndex);
    var at3 = list.findIndex(function(u) {
        return u.id === underlayId;
    });
    return stackPlace(list.length - 1 - at3, list.length);
}
function hiddenNote(floorIndex) {
    var floors = floorsNow();
    var floor = floors === null || floors === void 0 ? void 0 : floors[floorIndex];
    var activeFloorIndex = useFloorplanStore20.getState().activeFloorIndex;
    return floors && floor && floorDrawState2(floors, floorIndex, activeFloorIndex, floorVisibilityNow()) === "hidden" ? " ".concat(floor.name, " is hidden.") : "";
}
function finish(underlayId, floorIndex, sentence, ctx) {
    selectUnderlayOnFloor(underlayId, floorIndex);
    ctx.announce(sentence + hiddenNote(floorIndex));
    ctx.focusName(underlayId);
}
function movePdf(underlayId, toFloorId, index, ctx) {
    var _floorsNow;
    var found = locate(underlayId);
    var toFloorIndex = floorIndexOf(toFloorId);
    var target = (_floorsNow = floorsNow()) === null || _floorsNow === void 0 ? void 0 : _floorsNow[toFloorIndex];
    if (!found || !target) return false;
    var sameFloor = found.floorIndex === toFloorIndex;
    var clamped = Math.max(0, Math.min(sameFloor ? found.list.length - 1 : listOf(toFloorIndex).length, Math.trunc(index)));
    if (sameFloor && clamped === found.index) return false;
    runUnderlayEdit(function() {
        return useFloorplanStore20.getState().moveUnderlay(underlayId, target.id, clamped);
    });
    var place2 = placeOf(underlayId, toFloorIndex);
    finish(underlayId, toFloorIndex, sameFloor ? "".concat(found.underlay.name, " moved to ").concat(place2, " on ").concat(target.name, ".") : "".concat(found.underlay.name, " moved to ").concat(target.name, ", ").concat(place2, "."), ctx);
    return true;
}
function copyPdf(underlayId, toFloorId, index, ctx) {
    var _floorsNow, _floorsNow1;
    var found = locate(underlayId);
    var toFloorIndex = floorIndexOf(toFloorId);
    var target = (_floorsNow = floorsNow()) === null || _floorsNow === void 0 ? void 0 : _floorsNow[toFloorIndex];
    if (!found || !target) return null;
    var copy = copyOfUnderlay(reexpressUnderlay(found.underlay, placementOf((_floorsNow1 = floorsNow()) === null || _floorsNow1 === void 0 ? void 0 : _floorsNow1[found.floorIndex]), placementOf(target)), listOf(toFloorIndex).map(function(u) {
        return u.name;
    }));
    runUnderlayEdit(function() {
        return useFloorplanStore20.getState().addUnderlay(target.id, copy, index);
    });
    finish(copy.id, toFloorIndex, "".concat(copy.name, " added to ").concat(target.name, ", ").concat(placeOf(copy.id, toFloorIndex), "."), ctx);
    return copy.id;
}
function duplicatePdf(underlayId, ctx) {
    var _floorsNow;
    var found = locate(underlayId);
    var floor = found && ((_floorsNow = floorsNow()) === null || _floorsNow === void 0 ? void 0 : _floorsNow[found.floorIndex]);
    return found && floor ? copyPdf(underlayId, floor.id, found.index + 1, ctx) : null;
}
function nudgePdf(underlayId, direction, ctx) {
    var found = locate(underlayId);
    var floors = floorsNow();
    if (!found || !floors) return;
    var floorIndex = found.floorIndex, index = found.index, list = found.list, underlay = found.underlay;
    if (direction === "up") {
        if (index < list.length - 1) movePdf(underlayId, floors[floorIndex].id, index + 1, ctx);
        else if (floorIndex < floors.length - 1) movePdf(underlayId, floors[floorIndex + 1].id, 0, ctx);
        else ctx.announce("".concat(underlay.name, " is already at the top of ").concat(floors[floorIndex].name, "."));
    } else {
        if (index > 0) movePdf(underlayId, floors[floorIndex].id, index - 1, ctx);
        else if (floorIndex > 0) movePdf(underlayId, floors[floorIndex - 1].id, listOf(floorIndex - 1).length, ctx);
        else ctx.announce("".concat(underlay.name, " is already at the bottom of ").concat(floors[floorIndex].name, "."));
    }
}
// src/components/Planner/align/PdfDragGhost.tsx
import { forwardRef } from "react";
import { createPortal } from "react-dom";
import styled7 from "styled-components";
import { Icon as Icon7 } from "@repo/design-system";
import { radius as radius3, semantic as semantic2, shadow as shadow2, space as space5, typeRole as typeRole2, zIndex as zIndex3 } from "@repo/design-tokens";
// src/components/Planner/align/usePdfRowDrag.ts
import { useCallback as useCallback7, useEffect as useEffect11, useRef as useRef10, useState as useState11 } from "react";
import { useFloorplanStore as useFloorplanStore21 } from "@repo/front-end-state";
// src/components/Planner/gestures/pressRule.ts
import { metersToPixels, underlayAtPoint } from "@repo/front-end-utils";
var PRESS_CLICK_TOLERANCE_PX = 5;
function isClickRelease(press, release) {
    if (!press) return true;
    return Math.hypot(release.clientX - press.clientX, release.clientY - press.clientY) <= PRESS_CLICK_TOLERANCE_PX;
}
function pressTargetAt(param) {
    var surface11 = param.surface, pointer = param.pointer, toolMode = param.toolMode, _param_underlays = param.underlays, underlays = _param_underlays === void 0 ? [] : _param_underlays;
    if (!pointer) return {
        kind: "empty"
    };
    var item = surface11.itemAt(pointer);
    if (item) return item;
    var grabbable = underlays.filter(function(d) {
        return !d.underlay.locked;
    });
    if (grabbable.length > 0 && underlayTakesPress(toolMode)) {
        var plan = surface11.planPointAt(pointer);
        var world = {
            x: metersToPixels(plan.x),
            y: metersToPixels(plan.y)
        };
        var hit = underlayAtPoint(grabbable, world);
        if (hit) return {
            kind: "underlay",
            underlayId: hit.underlay.id,
            floorIndex: hit.floorIndex
        };
    }
    return {
        kind: "empty"
    };
}
function underlayTakesPress(toolMode) {
    return toolMode === "select" || toolMode === "scale_underlay";
}
function pressPans(target, toolMode) {
    return target.kind === "empty" && (underlayTakesPress(toolMode) || toolMode === "calibrate_scale");
}
// src/components/Planner/gestures/dragEngine.ts
function domGesturePane(element) {
    return {
        element: element,
        pointAt: function(evt) {
            var _touch_changedTouches, _touch_touches;
            var touch = evt;
            var isTouch = touch.changedTouches !== void 0 || touch.touches !== void 0;
            var _touch_changedTouches_;
            var client = isTouch ? (_touch_changedTouches_ = (_touch_changedTouches = touch.changedTouches) === null || _touch_changedTouches === void 0 ? void 0 : _touch_changedTouches[0]) !== null && _touch_changedTouches_ !== void 0 ? _touch_changedTouches_ : (_touch_touches = touch.touches) === null || _touch_touches === void 0 ? void 0 : _touch_touches[0] : evt;
            if (!client) return null;
            var rect = element.getBoundingClientRect();
            return {
                x: client.clientX - rect.left,
                y: client.clientY - rect.top
            };
        }
    };
}
function swallowReleaseClick(afterNextMouseUp) {
    var timer;
    var swallow = function(evt) {
        evt.stopPropagation();
        evt.preventDefault();
        withdraw();
    };
    var expireSoon = function() {
        window.removeEventListener("mouseup", expireSoon, true);
        timer = setTimeout(withdraw, 0);
    };
    var withdraw = function() {
        if (timer !== void 0) clearTimeout(timer);
        window.removeEventListener("click", swallow, true);
        window.removeEventListener("mousedown", withdraw, true);
        window.removeEventListener("keydown", withdraw, true);
        window.removeEventListener("mouseup", expireSoon, true);
    };
    window.addEventListener("click", swallow, true);
    window.addEventListener("mousedown", withdraw, true);
    window.addEventListener("keydown", withdraw, true);
    if (afterNextMouseUp) window.addEventListener("mouseup", expireSoon, true);
    else expireSoon();
}
function startPaneGesture(gesture) {
    var _native_changedTouches_, _native_changedTouches;
    var native = gesture.native, onMove = gesture.onMove, onRelease = gesture.onRelease, onCancel = gesture.onCancel;
    var pane = "page" in gesture ? null : gesture.pane;
    var cursor = "page" in gesture ? void 0 : gesture.cursor;
    var claimClick = "page" in gesture ? void 0 : gesture.claimClick;
    var onModifiers = "page" in gesture ? gesture.onModifiers : void 0;
    var changedDom = false;
    var container = pane === null || pane === void 0 ? void 0 : pane.element;
    var _native_changedTouches__identifier;
    var touchId = (_native_changedTouches__identifier = (_native_changedTouches = native.changedTouches) === null || _native_changedTouches === void 0 ? void 0 : (_native_changedTouches_ = _native_changedTouches[0]) === null || _native_changedTouches_ === void 0 ? void 0 : _native_changedTouches_.identifier) !== null && _native_changedTouches__identifier !== void 0 ? _native_changedTouches__identifier : null;
    var setCursor2 = function(value) {
        if (container) container.style.cursor = value;
    };
    if (cursor) setCursor2(cursor);
    var pointerFor = function(evt) {
        if (!pane) {
            if (touchId === null) {
                var mouse = evt;
                return {
                    x: mouse.clientX,
                    y: mouse.clientY
                };
            }
            var _evt_touches;
            var finger = Array.from((_evt_touches = evt.touches) !== null && _evt_touches !== void 0 ? _evt_touches : []).find(function(t) {
                return t.identifier === touchId;
            });
            return finger ? {
                x: finger.clientX,
                y: finger.clientY
            } : null;
        }
        if (touchId === null) return pane.pointAt(evt);
        var _evt_touches1;
        var touch = Array.from((_evt_touches1 = evt.touches) !== null && _evt_touches1 !== void 0 ? _evt_touches1 : []).find(function(t) {
            return t.identifier === touchId;
        });
        if (!touch) return null;
        var rect = pane.element.getBoundingClientRect();
        return {
            x: touch.clientX - rect.left,
            y: touch.clientY - rect.top
        };
    };
    var isOurTouch = function(evt) {
        var _evt_changedTouches;
        return touchId === null || Array.from((_evt_changedTouches = evt.changedTouches) !== null && _evt_changedTouches !== void 0 ? _evt_changedTouches : []).some(function(t) {
            return t.identifier === touchId;
        });
    };
    var handleMove = function(evt) {
        if (touchId === null && evt.type === "mousemove" && (evt.buttons & 1) === 0) {
            release(false);
            return;
        }
        if (evt.type === "touchmove") evt.preventDefault();
        var pointer = pointerFor(evt);
        if (!pointer) return;
        if (onMove(pointer, evt) === true) {
            if (!pane) {
                changedDom = true;
                return;
            }
            claimClick === null || claimClick === void 0 ? void 0 : claimClick();
        }
    };
    var end = function() {
        cleanup();
        if (cursor) setCursor2("");
    };
    var release = function(seen, evt) {
        end();
        if (changedDom && seen) swallowReleaseClick(false);
        onRelease(seen ? evt : void 0);
    };
    var handleMouseUp = function(evt) {
        return release(true, evt);
    };
    var cancel = function(heldButton, reason) {
        end();
        if (changedDom && heldButton) swallowReleaseClick(true);
        onCancel(reason);
    };
    var handleBlur = function() {
        return cancel(false, "blur");
    };
    var handleTouchEnd = function(evt) {
        if (isOurTouch(evt)) release(true, evt);
    };
    var handleTouchCancel = function(evt) {
        if (isOurTouch(evt)) cancel(false, "touchcancel");
    };
    var handleKeyDown = function(evt) {
        evt.stopImmediatePropagation();
        if (evt.key !== "Escape") return;
        evt.preventDefault();
        cancel(touchId === null, "escape");
    };
    var handleShift = function(evt) {
        if (evt.type === "keyup") evt.stopImmediatePropagation();
        if (evt.key === "Shift") onModifiers === null || onModifiers === void 0 ? void 0 : onModifiers(evt.type === "keydown" || evt.shiftKey);
    };
    var cleanup = function() {
        window.removeEventListener("mousemove", handleMove);
        window.removeEventListener("touchmove", handleMove);
        window.removeEventListener("mouseup", handleMouseUp);
        window.removeEventListener("touchend", handleTouchEnd);
        window.removeEventListener("touchcancel", handleTouchCancel);
        window.removeEventListener("keydown", handleKeyDown, true);
        window.removeEventListener("keydown", handleShift, true);
        window.removeEventListener("keyup", handleShift, true);
        window.removeEventListener("blur", handleBlur);
    };
    window.addEventListener("mousemove", handleMove);
    window.addEventListener("touchmove", handleMove, {
        passive: false
    });
    window.addEventListener("mouseup", handleMouseUp);
    window.addEventListener("touchend", handleTouchEnd);
    window.addEventListener("touchcancel", handleTouchCancel);
    if (!pane) {
        window.addEventListener("keydown", handleShift, true);
        window.addEventListener("keyup", handleShift, true);
    }
    window.addEventListener("keydown", handleKeyDown, true);
    window.addEventListener("blur", handleBlur);
    return function() {
        cleanup();
        if (cursor) setCursor2("");
    };
}
// src/components/Planner/hooks/pointerGesture.ts
function startPointerGesture(gesture) {
    return startPaneGesture(gesture);
}
// src/components/Planner/align/pdfDrop.ts
var inside = function(b, x, y) {
    return x >= b.left && x <= b.right && y >= b.top && y <= b.bottom;
};
function resolvePdfDrop(param) {
    var section = param.section, _param_floorRows = param.floorRows, floorRows = _param_floorRows === void 0 ? [] : _param_floorRows, sourceFloorId = param.sourceFloorId, groups = param.groups, x = param.x, y = param.y, draggedId = param.draggedId, copy = param.copy;
    var row = floorRows.find(function(r) {
        return inside(r.box, x, y);
    });
    if (row) {
        var own = row.floorId === sourceFloorId;
        return {
            floorId: row.floorId,
            floorIndex: row.floorIndex,
            slot: 0,
            // The top of the stack, bottom-to-top: after a move off another floor the floor holds one
            // more; a copy adds one wherever it comes from.
            index: own && !copy ? Math.max(0, row.count - 1) : row.count,
            noop: own && !copy,
            onFloorRow: true
        };
    }
    if (!inside(section, x, y)) return null;
    var at3 = -1;
    for(var i = 0; i < groups.length; i++)if (groups[i].top <= y) at3 = i;
    if (at3 < 0) return null;
    var group = groups[at3];
    var rows = group.rows;
    var slot = rows.filter(function(r) {
        return (r.top + r.bottom) / 2 < y;
    }).length;
    var source = rows.findIndex(function(r) {
        return r.id === draggedId;
    });
    var ownSlot = source >= 0 && (slot === source || slot === source + 1);
    if (copy && ownSlot) slot = source;
    var counted = function(id) {
        return copy || id !== draggedId;
    };
    var ids = rows.map(function(r) {
        return r.id;
    });
    var _group_stack;
    var stack = (_group_stack = group.stack) !== null && _group_stack !== void 0 ? _group_stack : ids;
    var gap = slot < ids.length ? stack.indexOf(ids[slot]) : ids.length > 0 ? stack.indexOf(ids[ids.length - 1]) + 1 : 0;
    var k = stack.slice(0, Math.max(0, gap)).filter(counted).length;
    var m = stack.filter(counted).length;
    return {
        floorId: group.floorId,
        floorIndex: group.floorIndex,
        slot: slot,
        index: m - k,
        noop: !copy && ownSlot
    };
}
// src/components/Planner/align/usePdfRowDrag.ts
function usePdfRowDrag(param) {
    var sectionRef = param.sectionRef, context = param.context;
    var _useState11 = _sliced_to_array(useState11(null), 2), state = _useState11[0], setState = _useState11[1];
    var live = useRef10(null);
    var stop = useRef10(null);
    var contextRef = useRef10(context);
    contextRef.current = context;
    var ghostRef = useRef10(null);
    var shown2 = useRef10(null);
    var publish = function(next) {
        var _prev_drop, _next_drop, _prev_drop1, _next_drop1, _prev_drop2, _next_drop2;
        var prev = shown2.current;
        live.current = next;
        if (next && ghostRef.current) ghostRef.current.style.transform = ghostTransform(next.x, next.y);
        var redraw = !prev || !next || prev.copy !== next.copy || prev.markerTop !== next.markerTop || ((_prev_drop = prev.drop) === null || _prev_drop === void 0 ? void 0 : _prev_drop.floorId) !== ((_next_drop = next.drop) === null || _next_drop === void 0 ? void 0 : _next_drop.floorId) || ((_prev_drop1 = prev.drop) === null || _prev_drop1 === void 0 ? void 0 : _prev_drop1.slot) !== ((_next_drop1 = next.drop) === null || _next_drop1 === void 0 ? void 0 : _next_drop1.slot) || ((_prev_drop2 = prev.drop) === null || _prev_drop2 === void 0 ? void 0 : _prev_drop2.noop) !== ((_next_drop2 = next.drop) === null || _next_drop2 === void 0 ? void 0 : _next_drop2.noop);
        if (!redraw) return;
        shown2.current = next;
        setState(next);
    };
    var panelOf = function() {
        var _sectionRef_current;
        var _sectionRef_current_closest;
        return (_sectionRef_current_closest = (_sectionRef_current = sectionRef.current) === null || _sectionRef_current === void 0 ? void 0 : _sectionRef_current.closest("aside")) !== null && _sectionRef_current_closest !== void 0 ? _sectionRef_current_closest : null;
    };
    var measure = useCallback7(function() {
        var _panelOf, _panelOf1, _useFloorplanStore21_getState_layout_floors_drag_fromFloorIndex, _useFloorplanStore21_getState_layout;
        var drag = live.current;
        var section = sectionRef.current;
        if (!drag || !section) return null;
        var box = section.getBoundingClientRect();
        var panel = (_panelOf = panelOf()) === null || _panelOf === void 0 ? void 0 : _panelOf.getBoundingClientRect();
        var groupEls = Array.from(section.querySelectorAll("[data-pdf-group]"));
        var groups = groupEls.map(function(el) {
            return {
                floorId: Number(el.dataset.floorId),
                floorIndex: Number(el.dataset.floorIndex),
                top: el.getBoundingClientRect().top,
                rows: Array.from(el.querySelectorAll("[data-pdf-row]")).map(function(row) {
                    var r = row.getBoundingClientRect();
                    var _row_dataset_underlayId;
                    return {
                        id: (_row_dataset_underlayId = row.dataset.underlayId) !== null && _row_dataset_underlayId !== void 0 ? _row_dataset_underlayId : "",
                        top: r.top,
                        bottom: r.bottom
                    };
                }),
                // The floor's whole stack, when a search shows only some of its rows.
                stack: el.dataset.pdfStack ? JSON.parse(el.dataset.pdfStack) : void 0
            };
        });
        var _panelOf_querySelectorAll;
        var floorRows = Array.from((_panelOf_querySelectorAll = (_panelOf1 = panelOf()) === null || _panelOf1 === void 0 ? void 0 : _panelOf1.querySelectorAll("[data-floor-row]")) !== null && _panelOf_querySelectorAll !== void 0 ? _panelOf_querySelectorAll : []).flatMap(function(el) {
            var r = el.getBoundingClientRect();
            var _panel_top;
            var top = Math.max(r.top, (_panel_top = panel === null || panel === void 0 ? void 0 : panel.top) !== null && _panel_top !== void 0 ? _panel_top : r.top);
            var _panel_bottom;
            var bottom = Math.min(r.bottom, (_panel_bottom = panel === null || panel === void 0 ? void 0 : panel.bottom) !== null && _panel_bottom !== void 0 ? _panel_bottom : r.bottom);
            if (bottom <= top) return [];
            var _el_dataset_underlayCount;
            return [
                {
                    floorId: Number(el.dataset.floorRow),
                    floorIndex: Number(el.dataset.floorIndex),
                    count: Number((_el_dataset_underlayCount = el.dataset.underlayCount) !== null && _el_dataset_underlayCount !== void 0 ? _el_dataset_underlayCount : 0),
                    box: {
                        top: top,
                        bottom: bottom,
                        left: r.left,
                        right: r.right
                    }
                }
            ];
        });
        var sourceFloorId = (_useFloorplanStore21_getState_layout = useFloorplanStore21.getState().layout) === null || _useFloorplanStore21_getState_layout === void 0 ? void 0 : (_useFloorplanStore21_getState_layout_floors_drag_fromFloorIndex = _useFloorplanStore21_getState_layout.floors[drag.fromFloorIndex]) === null || _useFloorplanStore21_getState_layout_floors_drag_fromFloorIndex === void 0 ? void 0 : _useFloorplanStore21_getState_layout_floors_drag_fromFloorIndex.id;
        var _panel_top, _panel_bottom;
        var drop = resolvePdfDrop({
            floorRows: floorRows,
            sourceFloorId: sourceFloorId,
            section: {
                // Only the part of the section the panel shows takes a drop.
                top: Math.max(box.top, (_panel_top = panel === null || panel === void 0 ? void 0 : panel.top) !== null && _panel_top !== void 0 ? _panel_top : box.top),
                bottom: Math.min(box.bottom, (_panel_bottom = panel === null || panel === void 0 ? void 0 : panel.bottom) !== null && _panel_bottom !== void 0 ? _panel_bottom : box.bottom),
                left: box.left,
                right: box.right
            },
            groups: groups,
            x: drag.x,
            y: drag.y,
            draggedId: drag.underlayId,
            copy: drag.copy
        });
        publish(_object_spread_props(_object_spread({}, drag), {
            drop: drop,
            markerTop: drop ? markerTopFor(drop, groupEls, groups) : null
        }));
        return drop;
    }, [
        sectionRef
    ]);
    var _useState111 = _sliced_to_array(useState11(function() {
        return createEdgeScroller(function() {
            var drag = live.current;
            var panel = panelOf();
            return drag && panel ? {
                el: panel,
                y: drag.y
            } : null;
        }, function() {
            return measure();
        });
    }), 1), scroller = _useState111[0];
    var finish2 = function() {
        scroller.stop();
        stop.current = null;
        document.body.style.removeProperty("cursor");
        document.body.style.removeProperty("user-select");
        publish(null);
    };
    var onNameMouseDown = function(e, underlay, floorIndex) {
        if (e.button !== 0 || e.ctrlKey || e.metaKey || stop.current) return;
        var start = {
            clientX: e.clientX,
            clientY: e.clientY
        };
        var started = false;
        stop.current = startPointerGesture({
            native: e.nativeEvent,
            page: true,
            onModifiers: function(shift) {
                if (!live.current || live.current.copy === shift) return;
                live.current = _object_spread_props(_object_spread({}, live.current), {
                    copy: shift
                });
                document.body.style.cursor = shift ? "copy" : "grabbing";
                measure();
            },
            onMove: function(pointer, evt) {
                var _live_current, _live_current1;
                if (!started && isClickRelease(start, {
                    clientX: pointer.x,
                    clientY: pointer.y
                })) return false;
                var copy = evt.shiftKey === true;
                if (!started) {
                    started = true;
                    document.body.style.userSelect = "none";
                }
                document.body.style.cursor = copy ? "copy" : "grabbing";
                var _live_current_drop, _live_current_markerTop;
                live.current = {
                    underlayId: underlay.id,
                    name: underlay.name,
                    fromFloorIndex: floorIndex,
                    copy: copy,
                    x: pointer.x,
                    y: pointer.y,
                    drop: (_live_current_drop = (_live_current = live.current) === null || _live_current === void 0 ? void 0 : _live_current.drop) !== null && _live_current_drop !== void 0 ? _live_current_drop : null,
                    markerTop: (_live_current_markerTop = (_live_current1 = live.current) === null || _live_current1 === void 0 ? void 0 : _live_current1.markerTop) !== null && _live_current_markerTop !== void 0 ? _live_current_markerTop : null
                };
                measure();
                scroller.kick();
                return true;
            },
            onRelease: function(evt) {
                var at3 = evt;
                if (live.current && at3 && typeof at3.clientX === "number") live.current = _object_spread_props(_object_spread({}, live.current), {
                    x: at3.clientX,
                    y: at3.clientY
                });
                if (live.current) measure();
                var drag = live.current;
                finish2();
                if (!(drag === null || drag === void 0 ? void 0 : drag.drop) || drag.drop.noop) return;
                var ctx = contextRef.current;
                if (drag.copy) copyPdf(drag.underlayId, drag.drop.floorId, drag.drop.index, ctx);
                else movePdf(drag.underlayId, drag.drop.floorId, drag.drop.index, ctx);
            },
            onCancel: finish2
        });
    };
    useEffect11(function() {
        return function() {
            var _stop_current;
            (_stop_current = stop.current) === null || _stop_current === void 0 ? void 0 : _stop_current.call(stop);
            scroller.stop();
            document.body.style.removeProperty("cursor");
            document.body.style.removeProperty("user-select");
        };
    }, []);
    return {
        drag: state,
        onNameMouseDown: onNameMouseDown,
        ghostRef: ghostRef
    };
}
function markerTopFor(drop, groupEls, groups) {
    if (drop.noop || drop.onFloorRow) return null;
    var at3 = groups.findIndex(function(g) {
        return g.floorId === drop.floorId;
    });
    var el = groupEls[at3];
    var group = groups[at3];
    if (!el || !group) return null;
    var top = group.top;
    var rows = group.rows;
    if (rows.length === 0) {
        var _el_querySelector;
        var empty = (_el_querySelector = el.querySelector("[data-pdf-empty]")) === null || _el_querySelector === void 0 ? void 0 : _el_querySelector.getBoundingClientRect();
        return (empty ? empty.top - 2 : el.getBoundingClientRect().bottom) - top;
    }
    if (drop.slot === 0) return rows[0].top - top - 2;
    if (drop.slot >= rows.length) return rows[rows.length - 1].bottom - top + 1;
    return (rows[drop.slot - 1].bottom + rows[drop.slot].top) / 2 - top - 1;
}
var GHOST_OFFSET_PX = 12;
var ghostTransform = function(x, y) {
    return "translate(".concat(x + GHOST_OFFSET_PX, "px, ").concat(y + GHOST_OFFSET_PX, "px)");
};
// src/components/Planner/align/PdfDragGhost.tsx
import { jsx as jsx14, jsxs as jsxs9 } from "react/jsx-runtime";
var PdfDragGhost = forwardRef(function(param, ref) {
    var name = param.name, copy = param.copy, x = param.x, y = param.y;
    return createPortal(/* @__PURE__ */ jsxs9(Pill, {
        ref: ref,
        "aria-hidden": "true",
        "data-testid": "pdf-drag-ghost",
        "data-copy": copy || void 0,
        style: {
            transform: ghostTransform(x, y)
        },
        children: [
            /* @__PURE__ */ jsx14(Name, {
                children: name
            }),
            copy && /* @__PURE__ */ jsx14(Icon7, {
                name: "copy",
                size: "sm"
            })
        ]
    }), document.body);
});
PdfDragGhost.displayName = "PdfDragGhost";
var Pill = styled7.div(_templateObject38(), zIndex3.tooltip, space5[1], space5[1], space5[2], semantic2.surface.card, radius3.md, shadow2.glassSm, semantic2.text.primary, typeRole2.caption1Strong.fontFamily, typeRole2.caption1Strong.fontSize, typeRole2.caption1Strong.lineHeight, typeRole2.caption1Strong.fontWeight);
var Name = styled7.span(_templateObject39());
// src/components/Planner/align/panelParts.ts
import styled8 from "styled-components";
import { fontMono, semantic as semantic3, space as space6, tracking, typeRole as typeRole3 } from "@repo/design-tokens";
var Panel = styled8.aside(_templateObject40(), semantic3.surface.card, semantic3.border.default, space6[3]);
var Section = styled8.section(_templateObject41(), space6[2]);
var Heading = styled8.div(_templateObject42());
var MicroHeading = styled8.h3(_templateObject43(), space6[2], fontMono, typeRole3.caption2.fontSize, typeRole3.caption2.lineHeight, typeRole3.caption2Strong.fontWeight, tracking.label, semantic3.text.muted);
var Rows = styled8.div(_templateObject44(), space6[1]);
// src/components/Planner/align/AlignPdfsSection.tsx
import { Fragment as Fragment6, jsx as jsx15, jsxs as jsxs10 } from "react/jsx-runtime";
var percent = function(v) {
    return "".concat(v, " %");
};
var scaleLine = function(u) {
    if (!u.scale || u.scale <= 0) return "not set";
    if (u.scaleFromM && u.scaleFromM > 0) return "set from ".concat(u.scaleFromM.toFixed(1), " m");
    return "".concat((u.widthPx / u.scale).toFixed(1), " m wide");
};
var referenceSubLine = function(u) {
    return [
        u.source === "image" ? null : "Page 1",
        "".concat(Math.round(u.opacity * 100), " %"),
        u.locked ? "locked" : null
    ].filter(Boolean).join(" \xB7 ");
};
var AlignPdfsSection = function(param) {
    var announce = param.announce, onDropFloor = param.onDropFloor, _param_query = param.query, query = _param_query === void 0 ? "" : _param_query;
    var _findLatestDesign8, _drag_drop;
    var floors = useFloorplanStore22(function(s) {
        var _s_layout;
        return (_s_layout = s.layout) === null || _s_layout === void 0 ? void 0 : _s_layout.floors;
    });
    var activeFloorIndex = useFloorplanStore22(function(s) {
        return s.activeFloorIndex;
    });
    var selectedId = useEditorStore15(function(s) {
        return s.selectedUnderlayId;
    });
    var _useState12 = _sliced_to_array(useState12(null), 2), renaming = _useState12[0], setRenaming = _useState12[1];
    var nameRefs = useRef11(/* @__PURE__ */ new Map());
    var addRef = useRef11(null);
    var groupRef = useRef11(null);
    var floor = floors === null || floors === void 0 ? void 0 : floors[activeFloorIndex];
    var _floor_designs, _findLatestDesign8_underlays;
    var underlays = _to_consumable_array((_findLatestDesign8_underlays = (_findLatestDesign8 = findLatestDesign8((_floor_designs = floor === null || floor === void 0 ? void 0 : floor.designs) !== null && _floor_designs !== void 0 ? _floor_designs : [])) === null || _findLatestDesign8 === void 0 ? void 0 : _findLatestDesign8.underlays) !== null && _findLatestDesign8_underlays !== void 0 ? _findLatestDesign8_underlays : NO_UNDERLAYS).reverse();
    var views = useUnderlayImages(underlays);
    var needle = query.trim().toLowerCase();
    var shown2 = needle ? underlays.filter(function(u) {
        return u.name.toLowerCase().includes(needle);
    }) : underlays;
    var pdfImport = usePdfImport({
        onImported: function(u, target) {
            return announce(importedSentence(u, target));
        }
    });
    var failedKey = underlays.filter(function(u) {
        var _views_u_id;
        return ((_views_u_id = views[u.id]) === null || _views_u_id === void 0 ? void 0 : _views_u_id.status) === "failed";
    }).map(function(u) {
        return u.id;
    }).join("|");
    var saidFailed = useRef11(/* @__PURE__ */ new Set());
    useEffect12(function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = underlays[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var u = _step.value;
                var _views_u_id, _views_u_id1;
                if (((_views_u_id = views[u.id]) === null || _views_u_id === void 0 ? void 0 : _views_u_id.status) === "failed" && !saidFailed.current.has(u.id)) {
                    saidFailed.current.add(u.id);
                    announce("".concat(u.name, " could not be loaded."));
                } else if (((_views_u_id1 = views[u.id]) === null || _views_u_id1 === void 0 ? void 0 : _views_u_id1.status) !== "failed") {
                    saidFailed.current.delete(u.id);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }, [
        failedKey
    ]);
    var rowContext = {
        announce: announce,
        // After the render that moved or added the row — a keyed move can drop focus.
        focusName: function(id) {
            return setTimeout(function() {
                var _nameRefs_current_get;
                return (_nameRefs_current_get = nameRefs.current.get(id)) === null || _nameRefs_current_get === void 0 ? void 0 : _nameRefs_current_get.focus();
            }, 0);
        }
    };
    var sectionRef = useRef11(null);
    var _usePdfRowDrag = usePdfRowDrag({
        sectionRef: sectionRef,
        context: rowContext
    }), drag = _usePdfRowDrag.drag, onNameMouseDown = _usePdfRowDrag.onNameMouseDown, ghostRef = _usePdfRowDrag.ghostRef;
    var dropFloorId = (drag === null || drag === void 0 ? void 0 : (_drag_drop = drag.drop) === null || _drag_drop === void 0 ? void 0 : _drag_drop.onFloorRow) && !drag.drop.noop ? drag.drop.floorId : null;
    useEffect12(function() {
        return onDropFloor === null || onDropFloor === void 0 ? void 0 : onDropFloor(dropFloorId);
    }, [
        dropFloorId,
        onDropFloor
    ]);
    useEffect12(function() {
        var _useFloorplanStore22_getState_layout;
        if (!selectedId) return;
        var found = findUnderlay((_useFloorplanStore22_getState_layout = useFloorplanStore22.getState().layout) === null || _useFloorplanStore22_getState_layout === void 0 ? void 0 : _useFloorplanStore22_getState_layout.floors, selectedId);
        if (found && found.floorIndex !== activeFloorIndex) useEditorStore15.getState().selectUnderlay(null);
    }, [
        activeFloorIndex,
        selectedId
    ]);
    if (!floors || !floor) return null;
    var store = function() {
        return useFloorplanStore22.getState();
    };
    var select = function(id) {
        return selectUnderlayOnFloor(id, activeFloorIndex);
    };
    var remove = function(u) {
        var at3 = shown2.findIndex(function(x) {
            return x.id === u.id;
        });
        var _shown2_;
        var next = (_shown2_ = shown2[at3 + 1]) !== null && _shown2_ !== void 0 ? _shown2_ : shown2[at3 - 1];
        runUnderlayEdit(function() {
            return store().removeUnderlay(u.id);
        });
        if (useEditorStore15.getState().selectedUnderlayId === u.id) useEditorStore15.getState().selectUnderlay(null);
        announce("".concat(u.name, " deleted. Press Ctrl+Z to undo."));
        setTimeout(function() {
            var _this;
            var _addRef_current;
            (_this = next ? nameRefs.current.get(next.id) : (_addRef_current = addRef.current) !== null && _addRef_current !== void 0 ? _addRef_current : groupRef.current) === null || _this === void 0 ? void 0 : _this.focus();
        }, 0);
    };
    var toggleLock = function(u) {
        runUnderlayEdit(function() {
            return store().updateUnderlay(u.id, {
                locked: !u.locked
            });
        });
        announce("".concat(u.name, " ").concat(u.locked ? "unlocked" : "locked", "."));
    };
    var setVisible = function(u) {
        runUnderlayEdit(function() {
            return store().setUnderlaysVisible([
                u.id
            ], !u.visible);
        });
        announce("".concat(u.name, " ").concat(u.visible ? "hidden" : "shown", "."));
    };
    var onNameKeyDown = function(e, u) {
        var act = null;
        if (e.altKey && !e.ctrlKey && !e.metaKey && matches(PDF_ROW_SHORTCUTS.moveUp, e.key)) act = function() {
            return nudgePdf(u.id, "up", rowContext);
        };
        else if (e.altKey && !e.ctrlKey && !e.metaKey && matches(PDF_ROW_SHORTCUTS.moveDown, e.key)) act = function() {
            return nudgePdf(u.id, "down", rowContext);
        };
        else if ((e.ctrlKey || e.metaKey) && !e.altKey && matches(PDF_ROW_SHORTCUTS.duplicate, e.key)) act = function() {
            return duplicatePdf(u.id, rowContext);
        };
        else if (u.id === selectedId && e.key === "Escape") act = function() {
            return useEditorStore15.getState().selectUnderlay(null);
        };
        else if (u.id === selectedId && !e.altKey && !e.ctrlKey && !e.metaKey) act = positionByKey(e, u);
        if (!act) return;
        e.preventDefault();
        e.stopPropagation();
        act();
    };
    var positionByKey = function(e, u) {
        var nudge = matches(POSITION_ROW_SHORTCUTS.nudge, e.key);
        var direction = nudge ? null : turnDirection(e);
        if (!nudge && direction === null) return null;
        if (u.locked) return function() {
            return announce("".concat(u.name, " is locked. Unlock it to move it."));
        };
        if (nudge || direction === null) {
            var move = screenNudge(e.key, useEditorStore15.getState().viewRotation);
            if (!move) return null;
            var local = moveInFloor(move, placementOf2(floor));
            return function() {
                runUnderlayEdit(function() {
                    return store().updateUnderlay(u.id, {
                        x: roundToMm(u.x + local.x),
                        y: roundToMm(u.y + local.y)
                    });
                });
                announce("".concat(u.name, " moved."));
            };
        }
        var angle = stepRotation(u.rotation, direction, e.shiftKey);
        return function() {
            runUnderlayEdit(function() {
                return store().updateUnderlay(u.id, {
                    rotation: angle
                });
            });
            announce("".concat(u.name, " rotated to ").concat(angle, "\xb0."));
        };
    };
    var commitRename = function(u, value) {
        setRenaming(null);
        var clean = cleanUnderlayName(value);
        if (clean && clean !== u.name) {
            runUnderlayEdit(function() {
                return store().renameUnderlay(u.id, clean);
            });
            announce("".concat(u.name, " renamed to ").concat(clean, "."));
        }
        var at3 = shown2.findIndex(function(x) {
            return x.id === u.id;
        });
        var _shown2_;
        var next = (_shown2_ = shown2[at3 + 1]) !== null && _shown2_ !== void 0 ? _shown2_ : shown2[at3 - 1];
        setTimeout(function() {
            var _this;
            var row = nameRefs.current.get(u.id);
            var _addRef_current;
            (_this = row !== null && row !== void 0 ? row : next ? nameRefs.current.get(next.id) : (_addRef_current = addRef.current) !== null && _addRef_current !== void 0 ? _addRef_current : groupRef.current) === null || _this === void 0 ? void 0 : _this.focus();
        }, 0);
    };
    return /* @__PURE__ */ jsxs10(ReferencesSection, {
        ref: sectionRef,
        "aria-labelledby": "build-references-heading",
        children: [
            /* @__PURE__ */ jsx15(Heading, {
                children: /* @__PURE__ */ jsxs10(MicroHeading, {
                    id: "build-references-heading",
                    children: [
                        /* @__PURE__ */ jsx15(Icon8, {
                            name: "file-image",
                            size: "xs"
                        }),
                        "References \xB7 ",
                        floor.name
                    ]
                })
            }),
            /* @__PURE__ */ jsxs10(Group, {
                ref: groupRef,
                tabIndex: -1,
                role: "group",
                "aria-label": "".concat(floor.name, " references"),
                "data-pdf-group": "",
                "data-floor-id": floor.id,
                "data-floor-index": activeFloorIndex,
                "data-pdf-stack": needle ? JSON.stringify(underlays.map(function(u) {
                    return u.id;
                })) : void 0,
                children: [
                    (drag === null || drag === void 0 ? void 0 : drag.drop) && !drag.drop.onFloorRow && drag.markerTop !== null && /* @__PURE__ */ jsx15(DropMarker, {
                        "aria-hidden": "true",
                        "data-testid": "pdf-drop-marker",
                        style: {
                            top: drag.markerTop
                        }
                    }),
                    underlays.length === 0 ? /* @__PURE__ */ jsxs10(Empty, {
                        "data-pdf-empty": "",
                        children: [
                            "No references on ",
                            floor.name,
                            " yet."
                        ]
                    }) : shown2.length === 0 ? /* @__PURE__ */ jsxs10(Empty, {
                        "data-pdf-empty": "",
                        children: [
                            "No references on ",
                            floor.name,
                            " match \u201C",
                            query.trim(),
                            "\u201D."
                        ]
                    }) : /* @__PURE__ */ jsx15(Rows, {
                        children: shown2.map(function(u) {
                            var _views_u_id, _views_u_id1;
                            var selected2 = u.id === selectedId;
                            var status = (_views_u_id = views[u.id]) === null || _views_u_id === void 0 ? void 0 : _views_u_id.status;
                            var sub = status === "loading" ? "Loading\u2026" : status === "missing" ? "Not in storage" : status === "failed" ? "Could not be loaded" : referenceSubLine(u);
                            return /* @__PURE__ */ jsxs10("div", {
                                children: [
                                    /* @__PURE__ */ jsx15(HierarchyEntityRow, {
                                        look: "disc",
                                        glyphShape: "square",
                                        refid: "reference-".concat(u.id),
                                        kind: "reference",
                                        glyph: u.source === "image" ? "file-image" : "file-pdf",
                                        label: u.name,
                                        labelMuted: !u.visible,
                                        selected: selected2,
                                        current: selected2,
                                        dragging: (drag === null || drag === void 0 ? void 0 : drag.underlayId) === u.id && !drag.copy,
                                        sub: status === "failed" ? /* @__PURE__ */ jsx15(RowNote, {
                                            state: "error",
                                            children: sub
                                        }) : sub,
                                        editing: renaming === u.id ? /* @__PURE__ */ jsx15(Input4, {
                                            size: "compact",
                                            "aria-label": "Reference name",
                                            autoFocus: true,
                                            defaultValue: u.name,
                                            onFocus: function(e) {
                                                return e.target.select();
                                            },
                                            onBlur: function(e) {
                                                return commitRename(u, e.target.value);
                                            },
                                            onKeyDown: function(e) {
                                                if (e.key === "Enter") commitRename(u, e.currentTarget.value);
                                                else if (e.key === "Escape") {
                                                    setRenaming(null);
                                                    setTimeout(function() {
                                                        var _nameRefs_current_get;
                                                        return (_nameRefs_current_get = nameRefs.current.get(u.id)) === null || _nameRefs_current_get === void 0 ? void 0 : _nameRefs_current_get.focus();
                                                    }, 0);
                                                }
                                            }
                                        }) : void 0,
                                        buttonRef: function(el) {
                                            if (el) nameRefs.current.set(u.id, el);
                                            else nameRefs.current.delete(u.id);
                                        },
                                        buttonProps: {
                                            "aria-keyshortcuts": selected2 ? "".concat(PDF_ROW_ARIA_KEYSHORTCUTS, " ").concat(POSITION_ROW_ARIA_KEYSHORTCUTS) : PDF_ROW_ARIA_KEYSHORTCUTS,
                                            title: selected2 ? SELECTED_NAME_TITLE : NAME_TITLE,
                                            onKeyDown: function(e) {
                                                return onNameKeyDown(e, u);
                                            },
                                            onMouseDown: function(e) {
                                                return onNameMouseDown(e, u, activeFloorIndex);
                                            }
                                        },
                                        rowAttributes: {
                                            "data-testid": "pdf-row-".concat(u.id),
                                            "data-pdf-row": "",
                                            "data-underlay-id": u.id
                                        },
                                        actions: /* @__PURE__ */ jsxs10(Fragment6, {
                                            children: [
                                                /* @__PURE__ */ jsx15(Button6, {
                                                    iconOnly: true,
                                                    variant: "ghost",
                                                    size: "xs",
                                                    "aria-label": u.locked ? "Unlock ".concat(u.name) : "Lock ".concat(u.name),
                                                    title: u.locked ? "Unlock ".concat(u.name) : "Lock ".concat(u.name),
                                                    iconLeft: /* @__PURE__ */ jsx15(Icon8, {
                                                        name: u.locked ? "lock" : "lock-open",
                                                        variant: "solid",
                                                        size: "xs"
                                                    }),
                                                    onClick: function() {
                                                        return toggleLock(u);
                                                    }
                                                }),
                                                /* @__PURE__ */ jsx15(Button6, {
                                                    iconOnly: true,
                                                    variant: "ghost",
                                                    size: "xs",
                                                    "aria-label": u.visible ? "Hide ".concat(u.name) : "Show ".concat(u.name),
                                                    title: u.visible ? "Hide ".concat(u.name) : "Show ".concat(u.name),
                                                    iconLeft: /* @__PURE__ */ jsx15(Icon8, {
                                                        name: u.visible ? "eye" : "eye-slash",
                                                        size: "xs"
                                                    }),
                                                    onClick: function() {
                                                        return setVisible(u);
                                                    }
                                                })
                                            ]
                                        }),
                                        onSelect: function() {
                                            return select(u.id);
                                        }
                                    }),
                                    status === "failed" && ((_views_u_id1 = views[u.id]) === null || _views_u_id1 === void 0 ? void 0 : _views_u_id1.retry) && /* @__PURE__ */ jsx15(RetryRow2, {
                                        children: /* @__PURE__ */ jsx15(Button6, {
                                            variant: "ghost",
                                            size: "xs",
                                            "aria-label": "Retry loading ".concat(u.name),
                                            onClick: function() {
                                                var _views_u_id_retry, _views_u_id;
                                                return (_views_u_id = views[u.id]) === null || _views_u_id === void 0 ? void 0 : (_views_u_id_retry = _views_u_id.retry) === null || _views_u_id_retry === void 0 ? void 0 : _views_u_id_retry.call(_views_u_id);
                                            },
                                            children: "Retry"
                                        })
                                    }),
                                    selected2 && /* @__PURE__ */ jsx15(OpenReference, {
                                        underlay: u,
                                        onClose: function() {
                                            useEditorStore15.getState().selectUnderlay(null);
                                            setTimeout(function() {
                                                var _nameRefs_current_get;
                                                return (_nameRefs_current_get = nameRefs.current.get(u.id)) === null || _nameRefs_current_get === void 0 ? void 0 : _nameRefs_current_get.focus();
                                            }, 0);
                                        },
                                        onRename: function() {
                                            return setRenaming(u.id);
                                        },
                                        onDelete: function() {
                                            return remove(u);
                                        },
                                        onToggleLock: function() {
                                            return toggleLock(u);
                                        }
                                    })
                                ]
                            }, u.id);
                        })
                    })
                ]
            }),
            pdfImport.canImport && /* @__PURE__ */ jsx15(AddRow, {
                children: /* @__PURE__ */ jsx15(Button6, {
                    ref: addRef,
                    variant: "ghost",
                    size: "sm",
                    iconLeft: /* @__PURE__ */ jsx15(Icon8, {
                        name: "plus",
                        variant: "solid",
                        size: "xs"
                    }),
                    "aria-label": "Add a reference (PDF or image) to ".concat(floor.name),
                    onClick: function() {
                        return pdfImport.choose({
                            kind: "floor",
                            floorId: floor.id
                        });
                    },
                    children: "Add Reference \xB7 PDF or image"
                })
            }),
            pdfImport.element,
            drag && /* @__PURE__ */ jsx15(PdfDragGhost, {
                ref: ghostRef,
                name: drag.name,
                copy: drag.copy,
                x: drag.x,
                y: drag.y
            })
        ]
    });
};
function OpenReference(param) {
    var stored = param.underlay, onClose = param.onClose, onRename = param.onRename, onDelete = param.onDelete, onToggleLock = param.onToggleLock;
    var _useUnderlayView;
    var shown2 = (_useUnderlayView = useUnderlayView(stored)) !== null && _useUnderlayView !== void 0 ? _useUnderlayView : stored;
    var setScale = useUnderlayToolReady(stored.id, "set");
    var previewFor = useRef11(null);
    useEffect12(function() {
        return function() {
            var _useEditorStore15_getState_underlayPreview;
            var id = previewFor.current;
            previewFor.current = null;
            if (id && ((_useEditorStore15_getState_underlayPreview = useEditorStore15.getState().underlayPreview) === null || _useEditorStore15_getState_underlayPreview === void 0 ? void 0 : _useEditorStore15_getState_underlayPreview.underlayId) === id) useEditorStore15.getState().setUnderlayPreview(null);
        };
    }, [
        stored.id
    ]);
    var preview = function(opacity) {
        var editor = useEditorStore15.getState();
        if (opacity === stored.opacity) {
            previewFor.current = null;
            editor.setUnderlayPreview(null);
            return;
        }
        previewFor.current = stored.id;
        editor.setUnderlayPreview({
            underlayId: stored.id,
            patch: {
                opacity: opacity
            }
        });
    };
    var commit = function(opacity) {
        previewFor.current = null;
        useEditorStore15.getState().setUnderlayPreview(null);
        if (opacity === stored.opacity) return;
        runUnderlayEdit(function() {
            return useFloorplanStore22.getState().updateUnderlay(stored.id, {
                opacity: opacity
            });
        });
    };
    return /* @__PURE__ */ jsxs10(Editor, {
        role: "group",
        "aria-label": "".concat(stored.name, " settings"),
        "data-planner-shortcuts": "off",
        onKeyDown: function(e) {
            if (e.key !== "Escape") return;
            e.stopPropagation();
            onClose();
        },
        children: [
            /* @__PURE__ */ jsx15(Slider, {
                label: "Opacity",
                surface: "on-glass",
                size: "sm",
                min: 5,
                max: 100,
                step: 5,
                value: Math.round(shown2.opacity * 100),
                format: percent,
                onChange: function(v) {
                    return preview(v / 100);
                },
                onCommit: function(v) {
                    return commit(v / 100);
                }
            }, stored.id),
            /* @__PURE__ */ jsxs10(ScaleLine, {
                children: [
                    /* @__PURE__ */ jsx15(Icon8, {
                        name: "ruler",
                        variant: "solid",
                        size: "xs"
                    }),
                    /* @__PURE__ */ jsx15("span", {
                        className: "label",
                        children: "Scale"
                    }),
                    /* @__PURE__ */ jsx15("span", {
                        className: "value",
                        children: scaleLine(shown2)
                    })
                ]
            }),
            /* @__PURE__ */ jsxs10(Actions2, {
                children: [
                    /* @__PURE__ */ jsx15(Button6, {
                        variant: "frosted",
                        size: "sm",
                        iconLeft: /* @__PURE__ */ jsx15(Icon8, {
                            name: "ruler",
                            variant: "solid",
                            size: "xs"
                        }),
                        "aria-disabled": !setScale.ready,
                        title: setScale.title,
                        onClick: function() {
                            if (setScale.ready) useEditorStore15.getState().setToolMode("calibrate_scale");
                        },
                        children: "Set Scale"
                    }),
                    /* @__PURE__ */ jsx15(Button6, {
                        variant: "frosted",
                        size: "sm",
                        iconLeft: /* @__PURE__ */ jsx15(Icon8, {
                            name: stored.locked ? "lock" : "lock-open",
                            variant: "solid",
                            size: "xs"
                        }),
                        onClick: onToggleLock,
                        children: stored.locked ? "Unlock" : "Lock"
                    }),
                    /* @__PURE__ */ jsx15(Button6, {
                        variant: "ghost",
                        size: "sm",
                        "aria-label": "Rename ".concat(stored.name),
                        onClick: onRename,
                        children: "Rename"
                    }),
                    /* @__PURE__ */ jsx15(Button6, {
                        variant: "ghost",
                        size: "sm",
                        "aria-label": "Delete ".concat(stored.name),
                        title: "Delete \u2014 undo with Ctrl+Z",
                        onClick: onDelete,
                        children: "Delete"
                    })
                ]
            })
        ]
    });
}
var NAME_TITLE = "Drag to restack, or onto a floor in the list above to move it there. Shift-drag to copy. Alt+↑/↓ moves, ".concat(PDF_ROW_SHORTCUTS.duplicate.hint, " copies.");
var SELECTED_NAME_TITLE = "".concat(NAME_TITLE, " ").concat(POSITION_ROW_SHORTCUTS.nudge.hint, ", ").concat(POSITION_ROW_SHORTCUTS.turn.hint, ".");
var ReferencesSection = styled9(Section)(_templateObject45(), space7[4]);
var Group = styled9.div(_templateObject46(), space7[1]);
var DropMarker = styled9.div(_templateObject47(), semantic4.interactive.accent);
var RetryRow2 = styled9.div(_templateObject48());
var Editor = styled9.div(_templateObject49(), space7[2], space7[1], space7[2], space7[6], space7[3], radius4.md, surface[0], shadow3.glassSm);
var ScaleLine = styled9.div(_templateObject50(), space7[2], typeRole4.caption1.fontFamily, typeRole4.caption1.fontSize, typeRole4.caption1.lineHeight, semantic4.text.muted, semantic4.text.secondary, typeRole4.caption1Strong.fontWeight, semantic4.text.primary);
var Actions2 = styled9.div(_templateObject51(), space7[2]);
var AddRow = styled9.div(_templateObject52());
var Empty = styled9.p(_templateObject53(), typeRole4.caption1.fontFamily, typeRole4.caption1.fontSize, typeRole4.caption1.lineHeight, semantic4.text.muted);
// src/components/Planner/align/useFloorRowDrag.ts
import { useEffect as useEffect13, useRef as useRef12, useState as useState13 } from "react";
import { useFloorplanStore as useFloorplanStore23 } from "@repo/front-end-state";
// src/components/Planner/align/floorDrop.ts
function floorDropIndex(rowRects, pointerY, fromIndex) {
    var slot = rowRects.filter(function(r) {
        return (r.top + r.bottom) / 2 < pointerY;
    }).length;
    if (slot === fromIndex || slot === fromIndex + 1) return {
        index: fromIndex,
        markerTop: null
    };
    return {
        index: slot > fromIndex ? slot - 1 : slot,
        markerTop: markerTopAt(rowRects, slot)
    };
}
function markerTopAt(rows, slot) {
    if (slot === 0) return rows[0].top - 2;
    if (slot >= rows.length) return rows[rows.length - 1].bottom + 1;
    return (rows[slot - 1].bottom + rows[slot].top) / 2 - 1;
}
// src/components/Planner/align/useFloorRowDrag.ts
function useFloorRowDrag(param) {
    var listRef = param.listRef, searching = param.searching, announce = param.announce;
    var _useState13 = _sliced_to_array(useState13(null), 2), state = _useState13[0], setState = _useState13[1];
    var live = useRef12(null);
    var stop = useRef12(null);
    var shown2 = useRef12(null);
    var publish = function(next) {
        var prev = shown2.current;
        if ((prev === null || prev === void 0 ? void 0 : prev.floorId) === (next === null || next === void 0 ? void 0 : next.floorId) && (prev === null || prev === void 0 ? void 0 : prev.markerTop) === (next === null || next === void 0 ? void 0 : next.markerTop)) return;
        shown2.current = next;
        setState(next);
    };
    var panelOf = function() {
        var _listRef_current;
        var _listRef_current_closest;
        return (_listRef_current_closest = (_listRef_current = listRef.current) === null || _listRef_current === void 0 ? void 0 : _listRef_current.closest("aside")) !== null && _listRef_current_closest !== void 0 ? _listRef_current_closest : null;
    };
    var measure = function() {
        var _useFloorplanStore23_getState_layout, _panelOf;
        var drag = live.current;
        var list = listRef.current;
        if (!drag || !list) return null;
        var _useFloorplanStore23_getState_layout_floors;
        var floors = (_useFloorplanStore23_getState_layout_floors = (_useFloorplanStore23_getState_layout = useFloorplanStore23.getState().layout) === null || _useFloorplanStore23_getState_layout === void 0 ? void 0 : _useFloorplanStore23_getState_layout.floors) !== null && _useFloorplanStore23_getState_layout_floors !== void 0 ? _useFloorplanStore23_getState_layout_floors : [];
        var from = floors.findIndex(function(f) {
            return f.id === drag.floorId;
        });
        var box = list.getBoundingClientRect();
        var panel = (_panelOf = panelOf()) === null || _panelOf === void 0 ? void 0 : _panelOf.getBoundingClientRect();
        var _panel_top, _panel_bottom;
        var over = drag.x >= box.left && drag.x <= box.right && drag.y >= Math.max(box.top, (_panel_top = panel === null || panel === void 0 ? void 0 : panel.top) !== null && _panel_top !== void 0 ? _panel_top : box.top) && drag.y <= Math.min(box.bottom, (_panel_bottom = panel === null || panel === void 0 ? void 0 : panel.bottom) !== null && _panel_bottom !== void 0 ? _panel_bottom : box.bottom);
        if (from < 0 || !over) {
            publish({
                floorId: drag.floorId,
                markerTop: null
            });
            return null;
        }
        var rows = Array.from(list.querySelectorAll("[data-floor-row]")).map(function(el) {
            return el.getBoundingClientRect();
        });
        var drop = floorDropIndex(rows, drag.y, from);
        publish({
            floorId: drag.floorId,
            markerTop: drop.markerTop === null ? null : drop.markerTop - box.top
        });
        return drop.index === from ? null : {
            from: from,
            to: drop.index
        };
    };
    var measureRef = useRef12(measure);
    measureRef.current = measure;
    var _useState131 = _sliced_to_array(useState13(function() {
        return createEdgeScroller(function() {
            var panel = panelOf();
            return live.current && panel ? {
                el: panel,
                y: live.current.y
            } : null;
        }, function() {
            return measureRef.current();
        });
    }), 1), scroller = _useState131[0];
    var finish2 = function() {
        scroller.stop();
        stop.current = null;
        live.current = null;
        document.body.style.removeProperty("cursor");
        document.body.style.removeProperty("user-select");
        publish(null);
    };
    var onNameMouseDown = function(e, floorId) {
        var _useFloorplanStore23_getState_layout;
        if (e.button !== 0 || e.ctrlKey || e.metaKey || stop.current) return;
        var _useFloorplanStore23_getState_layout_floors_length;
        if (((_useFloorplanStore23_getState_layout_floors_length = (_useFloorplanStore23_getState_layout = useFloorplanStore23.getState().layout) === null || _useFloorplanStore23_getState_layout === void 0 ? void 0 : _useFloorplanStore23_getState_layout.floors.length) !== null && _useFloorplanStore23_getState_layout_floors_length !== void 0 ? _useFloorplanStore23_getState_layout_floors_length : 0) <= 1) return;
        var start = {
            clientX: e.clientX,
            clientY: e.clientY
        };
        var travelled = false;
        stop.current = startPointerGesture({
            native: e.nativeEvent,
            page: true,
            onMove: function(pointer) {
                if (!travelled && isClickRelease(start, {
                    clientX: pointer.x,
                    clientY: pointer.y
                })) return false;
                if (searching) {
                    if (!travelled) announce(FLOOR_REORDER_SEARCHING_SENTENCE);
                    travelled = true;
                    return true;
                }
                if (!travelled) document.body.style.userSelect = "none";
                travelled = true;
                document.body.style.cursor = "grabbing";
                live.current = {
                    floorId: floorId,
                    x: pointer.x,
                    y: pointer.y
                };
                measure();
                scroller.kick();
                return true;
            },
            onRelease: function(evt) {
                var at3 = evt;
                if (live.current && at3 && typeof at3.clientX === "number") live.current = _object_spread_props(_object_spread({}, live.current), {
                    x: at3.clientX,
                    y: at3.clientY
                });
                var drop = measure();
                finish2();
                if (!drop) return;
                var moved = commitFloorMove(drop.from, drop.to);
                if (moved) announce(moved.sentence);
            },
            onCancel: finish2
        });
    };
    useEffect13(function() {
        return function() {
            var _stop_current;
            (_stop_current = stop.current) === null || _stop_current === void 0 ? void 0 : _stop_current.call(stop);
            scroller.stop();
            document.body.style.removeProperty("cursor");
            document.body.style.removeProperty("user-select");
        };
    }, []);
    return {
        drag: state,
        onNameMouseDown: onNameMouseDown
    };
}
// src/components/Planner/planMachineFootprints.ts
import { createContext as createContext8, useContext as useContext9 } from "react";
var NO_PLAN_MACHINE_FOOTPRINTS = function() {
    return void 0;
};
var PlanMachineFootprintsContext = createContext8(NO_PLAN_MACHINE_FOOTPRINTS);
var PlanMachineFootprintsProvider = PlanMachineFootprintsContext.Provider;
var usePlanMachineFootprints = function() {
    return useContext9(PlanMachineFootprintsContext);
};
// src/components/Planner/align/AlignFloorsPanel.tsx
import { Fragment as Fragment7, jsx as jsx16, jsxs as jsxs11 } from "react/jsx-runtime";
var PANEL_TABS = [
    {
        value: "floors",
        text: "Floors and references"
    }
];
var SUB_LINE = {
    selected: "Selected \xB7 move or rotate",
    below: "Shown faint as the reference",
    other: "Shown faint",
    hidden: "Hidden"
};
var DEFAULT_ONLY = {
    hidden: [],
    shown: []
};
var SEARCH_SETTLE_MS = 500;
var AlignFloorsPanel = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, listPanelHeader = _ref.listPanelHeader, _ref_query = _ref.query, query = _ref_query === void 0 ? "" : _ref_query;
    var _findLatestDesign9;
    var floors = useFloorplanStore24(function(s) {
        var _s_layout;
        var _s_layout_floors;
        return (_s_layout_floors = (_s_layout = s.layout) === null || _s_layout === void 0 ? void 0 : _s_layout.floors) !== null && _s_layout_floors !== void 0 ? _s_layout_floors : NO_FLOORS;
    });
    var activeFloorIndex = useFloorplanStore24(function(s) {
        return s.activeFloorIndex;
    });
    var setActiveFloor = useFloorplanStore24(function(s) {
        return s.setActiveFloor;
    });
    var visibility = useFloorVisibility();
    var setFloorVisible = useEditorStore16(function(s) {
        return s.setFloorVisible;
    });
    var setAllFloorsVisible = useEditorStore16(function(s) {
        return s.setAllFloorsVisible;
    });
    var _useAnnouncer = _sliced_to_array(useAnnouncer(), 2), message = _useAnnouncer[0], announce = _useAnnouncer[1];
    var footprintOf = usePlanMachineFootprints();
    var _useState14 = _sliced_to_array(useState14(null), 2), dropFloorId = _useState14[0], setDropFloorId = _useState14[1];
    var states = useMemo9(function() {
        return floors.map(function(_, index) {
            return floorDrawState3(floors, index, activeFloorIndex, visibility);
        });
    }, [
        floors,
        activeFloorIndex,
        visibility
    ]);
    var anyVisible = states.some(function(s) {
        return s !== "hidden";
    });
    var needle = query.trim().toLowerCase();
    var rowsRef = useRef13(null);
    var _useFloorRowDrag = useFloorRowDrag({
        listRef: rowsRef,
        searching: !!needle,
        announce: announce
    }), drag = _useFloorRowDrag.drag, onNameMouseDown = _useFloorRowDrag.onNameMouseDown;
    var floorShown = function(floor) {
        return !needle || floor.name.toLowerCase().includes(needle);
    };
    var activeFloor = floors[activeFloorIndex];
    var _activeFloor_designs, _findLatestDesign9_underlays;
    var activeUnderlays = (_findLatestDesign9_underlays = (_findLatestDesign9 = findLatestDesign9((_activeFloor_designs = activeFloor === null || activeFloor === void 0 ? void 0 : activeFloor.designs) !== null && _activeFloor_designs !== void 0 ? _activeFloor_designs : [])) === null || _findLatestDesign9 === void 0 ? void 0 : _findLatestDesign9.underlays) !== null && _findLatestDesign9_underlays !== void 0 ? _findLatestDesign9_underlays : NO_UNDERLAYS;
    var shownFloorCount = floors.filter(floorShown).length;
    var shownReferenceCount = needle ? activeUnderlays.filter(function(u) {
        return u.name.toLowerCase().includes(needle);
    }).length : activeUnderlays.length;
    var announceRef = useRef13(announce);
    announceRef.current = announce;
    useEffect14(function() {
        if (!needle) return void 0;
        var timer = window.setTimeout(function() {
            announceRef.current("".concat(shownFloorCount, " floor").concat(shownFloorCount === 1 ? "" : "s", " and ").concat(shownReferenceCount, " reference").concat(shownReferenceCount === 1 ? "" : "s", " shown"));
        }, SEARCH_SETTLE_MS);
        return function() {
            return window.clearTimeout(timer);
        };
    }, [
        needle,
        shownFloorCount,
        shownReferenceCount
    ]);
    var otherDrawn = useMemo9(function() {
        return floors.flatMap(function(floor, index) {
            var _findLatestDesign9;
            var _findLatestDesign9_underlays;
            return index !== activeFloorIndex && states[index] !== "hidden" ? ((_findLatestDesign9_underlays = (_findLatestDesign9 = findLatestDesign9(floor.designs)) === null || _findLatestDesign9 === void 0 ? void 0 : _findLatestDesign9.underlays) !== null && _findLatestDesign9_underlays !== void 0 ? _findLatestDesign9_underlays : NO_UNDERLAYS).filter(function(u) {
                return u.visible;
            }) : NO_UNDERLAYS;
        });
    }, [
        floors,
        activeFloorIndex,
        states
    ]);
    var views = useUnderlayImages(otherDrawn);
    var failedOn = function(floor) {
        var _findLatestDesign9;
        var _findLatestDesign9_underlays;
        return ((_findLatestDesign9_underlays = (_findLatestDesign9 = findLatestDesign9(floor.designs)) === null || _findLatestDesign9 === void 0 ? void 0 : _findLatestDesign9.underlays) !== null && _findLatestDesign9_underlays !== void 0 ? _findLatestDesign9_underlays : NO_UNDERLAYS).some(function(u) {
            var _views_u_id, _views_u_id1;
            return ((_views_u_id = views[u.id]) === null || _views_u_id === void 0 ? void 0 : _views_u_id.status) === "failed" || ((_views_u_id1 = views[u.id]) === null || _views_u_id1 === void 0 ? void 0 : _views_u_id1.status) === "missing";
        });
    };
    var _activeFloor_name;
    return /* @__PURE__ */ jsxs11(Panel, {
        "aria-label": "Floors and references",
        "data-in-list-panel": listPanelHeader ? "" : void 0,
        children: [
            listPanelHeader ? /* @__PURE__ */ jsxs11(ListHead, {
                children: [
                    /* @__PURE__ */ jsxs11("div", {
                        children: [
                            /* @__PURE__ */ jsx16(ListTitle, {
                                children: "Floors and references"
                            }),
                            /* @__PURE__ */ jsxs11(ListCounts, {
                                children: [
                                    floors.length,
                                    " floor",
                                    floors.length === 1 ? "" : "s",
                                    " \xB7 ",
                                    activeUnderlays.length,
                                    " ",
                                    "reference",
                                    activeUnderlays.length === 1 ? "" : "s",
                                    " on ",
                                    (_activeFloor_name = activeFloor === null || activeFloor === void 0 ? void 0 : activeFloor.name) !== null && _activeFloor_name !== void 0 ? _activeFloor_name : "\u2014"
                                ]
                            })
                        ]
                    }),
                    /* @__PURE__ */ jsx16(Button7, {
                        variant: "text",
                        tone: "brand",
                        size: "xs",
                        iconLeft: /* @__PURE__ */ jsx16(Icon9, {
                            name: "plus",
                            variant: "solid",
                            size: "xs"
                        }),
                        onClick: listPanelHeader.onAddFloor,
                        children: "Add Floor"
                    })
                ]
            }) : /* @__PURE__ */ jsx16(TabRow, {
                children: /* @__PURE__ */ jsx16(TagSwitcher_default, {
                    label: "Manage floors view",
                    size: "default",
                    options: PANEL_TABS,
                    selectedValue: "floors"
                })
            }),
            /* @__PURE__ */ jsxs11(Section, {
                "aria-labelledby": "build-floors-heading",
                children: [
                    /* @__PURE__ */ jsxs11(Heading, {
                        children: [
                            /* @__PURE__ */ jsxs11(MicroHeading, {
                                id: "build-floors-heading",
                                children: [
                                    /* @__PURE__ */ jsx16(Icon9, {
                                        name: "layer-group",
                                        variant: "solid",
                                        size: "xs"
                                    }),
                                    "Floors"
                                ]
                            }),
                            /* @__PURE__ */ jsx16(Button7, {
                                iconOnly: true,
                                variant: "ghost",
                                size: "xs",
                                "aria-label": anyVisible ? "Hide all floors" : "Show all floors",
                                title: anyVisible ? "Hide all floors" : "Show all floors",
                                iconLeft: /* @__PURE__ */ jsx16(Icon9, {
                                    name: anyVisible ? "eye" : "eye-slash",
                                    size: "xs"
                                }),
                                onClick: function() {
                                    setAllFloorsVisible(!anyVisible, floors.map(function(f) {
                                        return f.id;
                                    }));
                                    announce(anyVisible ? "All floors hidden." : "All floors shown.");
                                }
                            })
                        ]
                    }),
                    shownFloorCount === 0 && /* @__PURE__ */ jsxs11(NoMatch, {
                        "data-floors-no-match": "",
                        children: [
                            "No floors match \u201C",
                            query.trim(),
                            "\u201D."
                        ]
                    }),
                    /* @__PURE__ */ jsxs11(RowsGroup, {
                        ref: rowsRef,
                        children: [
                            drag && drag.markerTop !== null && /* @__PURE__ */ jsx16(DropMarker, {
                                "aria-hidden": "true",
                                "data-testid": "floor-drop-marker",
                                style: {
                                    top: drag.markerTop
                                }
                            }),
                            /* @__PURE__ */ jsx16(Rows, {
                                children: floors.map(function(floor, index) {
                                    var _findLatestDesign9_underlays, _findLatestDesign9;
                                    if (!floorShown(floor)) return null;
                                    var state = states[index];
                                    var selected2 = index === activeFloorIndex;
                                    var hidden = state === "hidden";
                                    var drawnByDefault = floorDrawState3(floors, index, activeFloorIndex, DEFAULT_ONLY) !== "hidden";
                                    var failed = !selected2 && !hidden && failedOn(floor);
                                    var _findLatestDesign9_underlays_length;
                                    return /* @__PURE__ */ jsx16(HierarchyEntityRow, {
                                        look: "disc",
                                        refid: "floor-".concat(floor.id),
                                        kind: "floor",
                                        label: floor.name,
                                        selected: selected2,
                                        current: selected2,
                                        className: dropFloorId === floor.id ? "drop-target" : void 0,
                                        dragging: (drag === null || drag === void 0 ? void 0 : drag.floorId) === floor.id,
                                        sub: failed ? /* @__PURE__ */ jsxs11(RowNote, {
                                            state: "error",
                                            children: [
                                                SUB_LINE[state],
                                                " \xB7 a reference could not be loaded"
                                            ]
                                        }) : SUB_LINE[state],
                                        trailing: /* @__PURE__ */ jsx16(Place, {
                                            children: hidden ? // Shown, not read: the row already says *Hidden*.
                                            /* @__PURE__ */ jsx16("span", {
                                                "aria-hidden": "true",
                                                children: "\u2014"
                                            }) : /* @__PURE__ */ jsxs11(Fragment7, {
                                                children: [
                                                    /* @__PURE__ */ jsx16("span", {
                                                        style: visuallyHidden,
                                                        children: "Offset and angle "
                                                    }),
                                                    floorPlaceLabel(floor.placement)
                                                ]
                                            })
                                        }),
                                        actions: /* @__PURE__ */ jsx16(Button7, {
                                            iconOnly: true,
                                            variant: "ghost",
                                            size: "xs",
                                            "aria-label": hidden ? "Show ".concat(floor.name) : "Hide ".concat(floor.name),
                                            title: hidden ? "Show ".concat(floor.name) : "Hide ".concat(floor.name),
                                            iconLeft: /* @__PURE__ */ jsx16(Icon9, {
                                                name: hidden ? "eye-slash" : "eye",
                                                size: "xs"
                                            }),
                                            onClick: function() {
                                                setFloorVisible(floor.id, hidden, drawnByDefault);
                                                announce("".concat(floor.name, " ").concat(hidden ? "shown" : "hidden", "."));
                                            }
                                        }),
                                        buttonProps: {
                                            "aria-keyshortcuts": selected2 ? "".concat(FLOOR_ROW_ARIA_KEYSHORTCUTS, " ").concat(POSITION_ROW_ARIA_KEYSHORTCUTS) : FLOOR_ROW_ARIA_KEYSHORTCUTS,
                                            title: selected2 ? "".concat(floor.name, ": ").concat(POSITION_ROW_SHORTCUTS.nudge.hint, ", ").concat(POSITION_ROW_SHORTCUTS.turn.hint, ". ").concat(FLOOR_ROW_REORDER_HINT) : "Select ".concat(floor.name, ". ").concat(FLOOR_ROW_REORDER_HINT),
                                            onKeyDown: function(e) {
                                                if (moveFloorByKey(e, floor, index, !!needle, announce)) return;
                                                if (selected2) positionFloorByKey(e, floor, announce, footprintOf);
                                            },
                                            onMouseDown: function(e) {
                                                return onNameMouseDown(e, floor.id);
                                            }
                                        },
                                        rowAttributes: {
                                            "data-floor-row": floor.id,
                                            "data-floor-index": index,
                                            "data-underlay-count": (_findLatestDesign9_underlays_length = (_findLatestDesign9 = findLatestDesign9(floor.designs)) === null || _findLatestDesign9 === void 0 ? void 0 : (_findLatestDesign9_underlays = _findLatestDesign9.underlays) === null || _findLatestDesign9_underlays === void 0 ? void 0 : _findLatestDesign9_underlays.length) !== null && _findLatestDesign9_underlays_length !== void 0 ? _findLatestDesign9_underlays_length : 0
                                        },
                                        onSelect: function() {
                                            return setActiveFloor(index);
                                        }
                                    }, floor.id);
                                })
                            })
                        ]
                    })
                ]
            }),
            /* @__PURE__ */ jsx16(AlignPdfsSection, {
                announce: announce,
                onDropFloor: setDropFloorId,
                query: query
            }),
            /* @__PURE__ */ jsx16("span", {
                role: "status",
                "aria-live": "polite",
                "aria-atomic": "true",
                style: visuallyHidden,
                children: message
            })
        ]
    });
};
function moveFloorByKey(e, floor, index, searching, announce) {
    if (!e.altKey || e.ctrlKey || e.metaKey) return false;
    var up = matches(FLOOR_ROW_SHORTCUTS.moveUp, e.key);
    if (!up && !matches(FLOOR_ROW_SHORTCUTS.moveDown, e.key)) return false;
    e.preventDefault();
    if (searching) {
        announce(FLOOR_REORDER_SEARCHING_SENTENCE);
        return true;
    }
    var moved = commitFloorMove(index, up ? index - 1 : index + 1);
    var _moved_sentence;
    announce((_moved_sentence = moved === null || moved === void 0 ? void 0 : moved.sentence) !== null && _moved_sentence !== void 0 ? _moved_sentence : up ? floorAlreadyGroundSentence(floor.name) : floorAlreadyTopSentence(floor.name));
    return true;
}
function positionFloorByKey(e, floor, announce, footprintOf) {
    if (e.ctrlKey || e.metaKey || e.altKey) return;
    var start = placementOf3(floor);
    if (matches(POSITION_ROW_SHORTCUTS.nudge, e.key)) {
        var move = screenNudge2(e.key, useEditorStore16.getState().viewRotation);
        if (!move) return;
        e.preventDefault();
        var write = _object_spread_props(_object_spread({}, start), {
            x: roundToMm2(start.x + move.x),
            y: roundToMm2(start.y + move.y)
        });
        runPlacementEdit(function() {
            return useFloorplanStore24.getState().setFloorPlacement(floor.id, write);
        });
        announce(floorMovedSentence(floor.name));
        return;
    }
    var direction = turnDirection(e);
    if (!direction) return;
    e.preventDefault();
    var angle = stepRotation2(start.rotation, direction, e.shiftKey);
    var pivot = floorOutlineCentre(findLatestDesign9(floor.designs), footprintOf);
    var turned = rotatePlacementAbout(start, pivot, angle);
    runPlacementEdit(function() {
        return useFloorplanStore24.getState().setFloorPlacement(floor.id, {
            x: roundToMm2(turned.x),
            y: roundToMm2(turned.y),
            rotation: angle
        });
    });
    announce(floorRotatedSentence(floor.name, angle));
}
var NO_FLOORS = [];
var RowsGroup = styled10.div(_templateObject54());
var ListHead = styled10.div(_templateObject55(), space8[2], space8[3]);
var ListTitle = styled10.h3(_templateObject56(), typeRole5.subtitle2.fontSize, typeRole5.subtitle2.lineHeight, typeRole5.subtitle2.fontWeight, semantic5.text.primary);
var ListCounts = styled10.p(_templateObject57(), typeRole5.caption1.fontSize, typeRole5.caption1.lineHeight, semantic5.text.secondary);
var NoMatch = styled10.p(_templateObject58(), typeRole5.caption1.fontSize, typeRole5.caption1.lineHeight, semantic5.text.muted);
var TabRow = styled10.div(_templateObject59(), space8[3]);
var Place = styled10.span(_templateObject60(), fontMono2, typeRole5.caption2.fontSize, typeRole5.caption2.lineHeight, semantic5.text.secondary);
// src/components/Planner/floors/FloorDetailsPanel.tsx
import { useId, useRef as useRef14, useState as useState15 } from "react";
import { Button as Button8 } from "@repo/design-system";
import { useEditorStore as useEditorStore17, useFloorplanStore as useFloorplanStore25 } from "@repo/front-end-state";
import { floorLaunchBid, floorTargetRefid, withCapacityReview } from "@repo/front-end-utils";
import { Fragment as Fragment8, jsx as jsx17, jsxs as jsxs12 } from "react/jsx-runtime";
function FloorDetailsPanel(param) {
    var boundsRef = param.boundsRef, twinBid = param.twinBid, twinId = param.twinId;
    var selectedFloorId = useEditorStore17(function(s) {
        return s.selectedFloorId;
    });
    var floors = useFloorplanStore25(function(s) {
        var _s_layout;
        return (_s_layout = s.layout) === null || _s_layout === void 0 ? void 0 : _s_layout.floors;
    });
    var _useState15 = _sliced_to_array(useState15(false), 2), isHeaderHovered = _useState15[0], setIsHeaderHovered = _useState15[1];
    if (selectedFloorId === null || !floors) return null;
    var index = floors.findIndex(function(f) {
        return (f === null || f === void 0 ? void 0 : f.id) === selectedFloorId;
    });
    var floor = index < 0 ? void 0 : floors[index];
    if (!floor) return null;
    return /* @__PURE__ */ jsx17(PropertiesPanelDraggable, {
        boundsRef: boundsRef,
        isHeaderHovered: isHeaderHovered,
        headerElement: /* @__PURE__ */ jsx17(PropertiesDragHeader, {
            onMouseEnter: function() {
                return setIsHeaderHovered(true);
            },
            onMouseLeave: function() {
                return setIsHeaderHovered(false);
            },
            children: /* @__PURE__ */ jsx17(PanelTitle, {
                children: "Floor"
            })
        }),
        children: /* @__PURE__ */ jsx17(FloorFields, {
            index: index,
            twinBid: twinBid,
            twinId: twinId
        }, floor.id)
    });
}
function FloorFields(param) {
    var index = param.index, twinBid = param.twinBid, twinId = param.twinId;
    var floor = useFloorplanStore25(function(s) {
        var _s_layout;
        return (_s_layout = s.layout) === null || _s_layout === void 0 ? void 0 : _s_layout.floors[index];
    });
    var setFloorCapacity = useFloorplanStore25(function(s) {
        return s.setFloorCapacity;
    });
    var registerCapacityOf = useRegisterCapacityOf(twinId);
    var _useState15 = _sliced_to_array(useState15(null), 2), nameDraft = _useState15[0], setNameDraft = _useState15[1];
    var _useState151 = _sliced_to_array(useState15(null), 2), nameOffer = _useState151[0], setNameOffer = _useState151[1];
    var bidNoteId = useId();
    var nameErrorId = useId();
    var nameRef = useRef14(null);
    if (!floor) return null;
    var commitName = function() {
        var draft = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : nameDraft;
        if (draft === null) return;
        var result = commitFloorRename(index, draft);
        if (!result.renamed && result.taken) {
            setNameOffer(result.taken.offer);
            return;
        }
        setNameOffer(null);
        setNameDraft(null);
    };
    var onEscape = function(e) {
        if (e.key !== "Escape") return;
        e.preventDefault();
        if (nameDraft !== null) {
            setNameDraft(null);
            setNameOffer(null);
            return;
        }
        var row = document.querySelector('[data-plan-hierarchy] [data-refid="'.concat(floorTargetRefid(floor.id), '"] button.row-select'));
        useEditorStore17.getState().clearSelection();
        row === null || row === void 0 ? void 0 : row.focus();
    };
    var _floor_capacity;
    return(// Keys typed here never reach the planner's shortcuts, as in every properties panel.
    /* @__PURE__ */ jsxs12(PropertiesBody, {
        role: "group",
        "aria-label": "Floor",
        "data-floor-details": "",
        "data-planner-shortcuts": "off",
        children: [
            /* @__PURE__ */ jsxs12(FieldBlock, {
                children: [
                    /* @__PURE__ */ jsxs12(Field, {
                        children: [
                            "Name",
                            /* @__PURE__ */ jsx17(FieldInput, {
                                ref: nameRef,
                                type: "text",
                                value: nameDraft !== null && nameDraft !== void 0 ? nameDraft : floor.name,
                                placeholder: "e.g. Ground Floor",
                                "aria-invalid": nameOffer ? true : void 0,
                                "aria-describedby": nameOffer ? nameErrorId : void 0,
                                onChange: function(e) {
                                    setNameDraft(e.target.value);
                                    setNameOffer(null);
                                },
                                onBlur: function(e) {
                                    if (_instanceof(e.relatedTarget, HTMLElement) && e.relatedTarget.dataset.floorOffer) return;
                                    commitName();
                                },
                                onKeyDown: function(e) {
                                    if (e.key === "Enter") {
                                        e.preventDefault();
                                        commitName();
                                        return;
                                    }
                                    onEscape(e);
                                }
                            })
                        ]
                    }),
                    nameOffer && /* @__PURE__ */ jsxs12(Fragment8, {
                        children: [
                            /* @__PURE__ */ jsx17(FieldNote, {
                                id: nameErrorId,
                                role: "alert",
                                children: takenNameMessage(nameOffer)
                            }),
                            /* @__PURE__ */ jsx17("span", {
                                children: /* @__PURE__ */ jsx17(Button8, {
                                    type: "button",
                                    variant: "ghost",
                                    size: "xs",
                                    "data-floor-offer": "",
                                    onClick: function() {
                                        var _nameRef_current;
                                        commitName(nameOffer);
                                        (_nameRef_current = nameRef.current) === null || _nameRef_current === void 0 ? void 0 : _nameRef_current.focus();
                                    },
                                    children: freeNameButtonLabel(nameOffer)
                                })
                            })
                        ]
                    })
                ]
            }),
            /* @__PURE__ */ jsxs12(FieldBlock, {
                children: [
                    /* @__PURE__ */ jsxs12(Field, {
                        children: [
                            "BID",
                            /* @__PURE__ */ jsx17(FieldInput, {
                                type: "text",
                                value: twinBid ? floorLaunchBid(twinBid, floor.id) : "Assigned at launch",
                                readOnly: true,
                                "aria-readonly": "true",
                                "data-muted": "true",
                                "aria-describedby": bidNoteId,
                                onKeyDown: onEscape
                            })
                        ]
                    }),
                    /* @__PURE__ */ jsx17(FieldNote, {
                        id: bidNoteId,
                        children: "Set from the floor's number; it can't be edited."
                    })
                ]
            }),
            /* @__PURE__ */ jsxs12(Field, {
                children: [
                    "Capacity",
                    /* @__PURE__ */ jsx17(FieldInput, {
                        type: "number",
                        min: 0,
                        step: 1,
                        value: (_floor_capacity = floor.capacity) !== null && _floor_capacity !== void 0 ? _floor_capacity : "",
                        placeholder: "0",
                        onFocus: recordFloorStep,
                        onKeyDown: onEscape,
                        onChange: function(e) {
                            var _planCapacityNow_floor;
                            var next = capacityFromInput(e.target);
                            if (!next) return;
                            var capacityReviewedContents = withCapacityReview(next.capacity, (_planCapacityNow_floor = planCapacityNow(twinBid, twinId, registerCapacityOf).floor(floor.id)) === null || _planCapacityNow_floor === void 0 ? void 0 : _planCapacityNow_floor.contents).capacityReviewedContents;
                            setFloorCapacity(index, next.capacity, capacityReviewedContents);
                        }
                    })
                ]
            })
        ]
    }));
}
// src/components/Planner/align/PlanModeSwitch.tsx
import { useEffect as useEffect15, useRef as useRef15, useState as useState16 } from "react";
import { PLAN_MODE_DESCRIPTION, useEditorStore as useEditorStore18, useFloorplanStore as useFloorplanStore26 } from "@repo/front-end-state";
import styled11 from "styled-components";
import { jsx as jsx18 } from "react/jsx-runtime";
var PLAN_MODE_OPTIONS = [
    {
        value: "edit",
        text: "Edit floor",
        title: PLAN_MODE_DESCRIPTION.edit
    },
    {
        value: "align",
        text: "Manage floors",
        title: PLAN_MODE_DESCRIPTION.align
    }
];
var PlanModeSwitch = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_fullWidth = _ref.fullWidth, fullWidth = _ref_fullWidth === void 0 ? false : _ref_fullWidth, _ref_iconsOnly = _ref.iconsOnly, iconsOnly = _ref_iconsOnly === void 0 ? false : _ref_iconsOnly;
    var planMode = useEditorStore18(function(s) {
        return s.planMode;
    });
    var setPlanMode = useEditorStore18(function(s) {
        return s.setPlanMode;
    });
    var options = fullWidth || iconsOnly ? PLAN_MODE_OPTIONS.map(function(o) {
        return _object_spread(_object_spread_props(_object_spread({}, o), {
            icon: PLAN_MODE_ICON[o.value]
        }), iconsOnly ? {
            text: "",
            ariaLabel: o.text
        } : {});
    }) : PLAN_MODE_OPTIONS;
    var switcher = /* @__PURE__ */ jsx18(TagSwitcher_default, {
        label: "Plan mode",
        size: fullWidth ? "roomy" : "default",
        options: options,
        selectedValue: planMode,
        onChange: function(value) {
            return setPlanMode(value);
        }
    });
    return fullWidth ? /* @__PURE__ */ jsx18(FullWidth, {
        children: switcher
    }) : switcher;
};
var PLAN_MODE_ICON = {
    edit: "pen-ruler",
    align: "layer-group"
};
var FullWidth = styled11.div(_templateObject61());
var usePlanModeAnnouncement = function(offered) {
    var planMode = useEditorStore18(function(s) {
        return s.planMode;
    });
    var _useState16 = _sliced_to_array(useState16(""), 2), message = _useState16[0], setMessage = _useState16[1];
    var previous = useRef15(planMode);
    useEffect15(function() {
        var _layout_floors_activeFloorIndex;
        if (previous.current === planMode) return;
        previous.current = planMode;
        if (!offered) return;
        var _useFloorplanStore26_getState = useFloorplanStore26.getState(), layout = _useFloorplanStore26_getState.layout, activeFloorIndex = _useFloorplanStore26_getState.activeFloorIndex;
        var _layout_floors, _layout_floors_activeFloorIndex_name;
        setMessage(planMode === "align" ? buildFloorsSentence((_layout_floors = layout === null || layout === void 0 ? void 0 : layout.floors) !== null && _layout_floors !== void 0 ? _layout_floors : [], activeFloorIndex) : "Edit floor: ".concat((_layout_floors_activeFloorIndex_name = layout === null || layout === void 0 ? void 0 : (_layout_floors_activeFloorIndex = layout.floors[activeFloorIndex]) === null || _layout_floors_activeFloorIndex === void 0 ? void 0 : _layout_floors_activeFloorIndex.name) !== null && _layout_floors_activeFloorIndex_name !== void 0 ? _layout_floors_activeFloorIndex_name : "the selected floor", "."));
    }, [
        planMode,
        offered
    ]);
    return message;
};
var buildFloorsSentence = function(floors, activeFloorIndex) {
    var _floors_activeFloorIndex;
    var _floors_activeFloorIndex_name;
    var floor = (_floors_activeFloorIndex_name = (_floors_activeFloorIndex = floors[activeFloorIndex]) === null || _floors_activeFloorIndex === void 0 ? void 0 : _floors_activeFloorIndex.name) !== null && _floors_activeFloorIndex_name !== void 0 ? _floors_activeFloorIndex_name : "the selected floor";
    return activeFloorIndex > 0 ? "Manage floors: line up ".concat(floor, " against the floor below. Drawing tools are off.") : "Manage floors: ".concat(floor, " is the bottom floor. Drawing tools are off.");
};
// src/components/Planner/hooks/useHeldFloorAnnouncement.ts
import { useEffect as useEffect16, useRef as useRef16 } from "react";
import { useEditorStore as useEditorStore19, useFloorplanStore as useFloorplanStore27 } from "@repo/front-end-state";
import { findLatestDesign as findLatestDesign10, isLive as isLive2 } from "@repo/front-end-utils";
var heldFloorSentence = function() {
    var _shown2_name, _name, _this;
    var _useEditorStore19_getState = useEditorStore19.getState(), heldSelectionFloor = _useEditorStore19_getState.heldSelectionFloor, selectedEntityIds = _useEditorStore19_getState.selectedEntityIds;
    var _useFloorplanStore27_getState = useFloorplanStore27.getState(), layout = _useFloorplanStore27_getState.layout, activeFloorIndex = _useFloorplanStore27_getState.activeFloorIndex;
    if (heldSelectionFloor === null || selectedEntityIds.length !== 1 || !layout) return null;
    var shown2 = layout.floors[activeFloorIndex];
    var heldFloor = layout.floors[heldSelectionFloor];
    if (!shown2 || !heldFloor) return null;
    var design = findLatestDesign10(heldFloor.designs);
    var _selectedEntityIds = _sliced_to_array(selectedEntityIds, 1), id = _selectedEntityIds[0];
    var item = design.items.find(function(i) {
        return i.refid === id && isLive2(i);
    });
    var surface11 = item ? void 0 : design.surfaces.find(function(s) {
        return s.refid === id && isLive2(s);
    });
    if (!item && !surface11) return null;
    var floorName = ((_shown2_name = shown2.name) === null || _shown2_name === void 0 ? void 0 : _shown2_name.trim()) || "Floor ".concat(activeFloorIndex + 1);
    var itemName2 = ((_this = item !== null && item !== void 0 ? item : surface11) === null || _this === void 0 ? void 0 : (_name = _this.name) === null || _name === void 0 ? void 0 : _name.trim()) || (item ? "machine" : "space");
    return "Showing ".concat(floorName, ". The ").concat(itemName2, " card stays open.");
};
var useHeldFloorAnnouncement = function() {
    var shown2 = useEditorStore19(function(s) {
        return s.heldFloorShown;
    });
    var atMount = useRef16(shown2);
    useEffect16(function() {
        if (!shown2 || shown2 === atMount.current) return;
        var sentence = heldFloorSentence();
        if (sentence) announcePlanSentence(sentence);
    }, [
        shown2
    ]);
    useEffect16(function() {
        return function() {
            if (useEditorStore19.getState().heldSelectionFloor !== null) {
                useEditorStore19.getState().clearSelection();
            }
        };
    }, []);
};
// src/components/Planner/canvas/CanvasControls.tsx
import { forwardRef as forwardRef2, useRef as useRef17 } from "react";
import { Icon as Icon10 } from "@repo/design-system";
import styled12 from "styled-components";
import { brand, focus, fontMono as fontMono3, ink, line, radius as radius5, space as space9, typeScale, weight } from "@repo/design-tokens";
import { useEditorStore as useEditorStore20, useFloorplanStore as useFloorplanStore28 } from "@repo/front-end-state";
import { Fragment as Fragment9, jsx as jsx19, jsxs as jsxs13 } from "react/jsx-runtime";
var RAIL_CLEARANCE = function(theme2) {
    return "calc(".concat(theme2.spacing[4], " + 32px + 2 * ").concat(space9[1], " + 2px)");
};
var StyledControlsWrapper = styled12.div(_templateObject62(), function(param) {
    var theme2 = param.theme;
    return theme2.spacing[2];
}, function(param) {
    var theme2 = param.theme;
    return theme2.spacing[1];
}, function(param) {
    var theme2 = param.theme;
    return theme2.spacing[4];
}, space9[1], SMALL_GLASS_PADDING, smallGlassCss, function(param) {
    var theme2 = param.theme;
    return theme2.zIndex.sticky;
});
var StyledControlButton = styled12.button(_templateObject63(), radius5.controlSm, function(param) {
    var $active = param.$active;
    return $active ? ink[1] : ink[2];
}, function(param) {
    var $active = param.$active;
    return $active ? brand.frost : "transparent";
}, function(param) {
    var $active = param.$active;
    return $active ? "0 0 8px ".concat(brand.frostGlow) : "none";
}, function(param) {
    var theme2 = param.theme;
    return theme2.transitions.fast;
}, function(param) {
    var theme2 = param.theme;
    return theme2.transitions.fast;
}, ink[1], function(param) {
    var $active = param.$active;
    return $active ? brand.frost : brand.frostGlow;
}, focus.ring, function(param) {
    var $active = param.$active;
    return $active ? "dashed" : "solid";
}, function(param) {
    var $active = param.$active;
    return $active ? "Highlight" : "transparent";
}, function(param) {
    var $active = param.$active;
    return $active ? "HighlightText" : "ButtonText";
});
var ControlButton = forwardRef2(function(_param, ref) {
    var active = _param.active, rest = _object_without_properties(_param, [
        "active"
    ]);
    return /* @__PURE__ */ jsx19(StyledControlButton, _object_spread_props(_object_spread({}, rest), {
        ref: ref,
        $active: active,
        "aria-pressed": active
    }));
});
ControlButton.displayName = "ControlButton";
var keepFocus = function(e) {
    return e.preventDefault();
};
var InfoLabel = styled12.div(_templateObject64(), fontMono3, typeScale.caption2.fontSize, typeScale.caption2.lineHeight, weight.medium, ink[3], space9[1]);
var Separator = styled12.div(_templateObject65(), line[1], space9[1]);
var PdfToolButton = function(param) {
    var tool = param.tool, label = param.label, children = param.children;
    var toolMode = useEditorStore20(function(s) {
        return s.toolMode;
    });
    var setToolMode = useEditorStore20(function(s) {
        return s.setToolMode;
    });
    var _useUnderlayToolReady = useUnderlayToolReady(null, tool === "calibrate_scale" ? "set" : "scale"), ready = _useUnderlayToolReady.ready, title = _useUnderlayToolReady.title;
    return /* @__PURE__ */ jsx19(ControlButton, {
        active: toolMode === tool,
        "aria-disabled": !ready,
        onClick: function() {
            if (ready) setToolMode(tool);
        },
        "aria-label": label,
        title: title,
        children: children
    });
};
var SetScaleButton = function() {
    return /* @__PURE__ */ jsx19(PdfToolButton, {
        tool: "calibrate_scale",
        label: "Set scale",
        children: /* @__PURE__ */ jsx19(Icon10, {
            name: "ruler",
            variant: "solid",
            size: "xs"
        })
    });
};
var ScalePdfButton = function() {
    return /* @__PURE__ */ jsx19(PdfToolButton, {
        tool: "scale_underlay",
        label: "Scale PDF",
        children: /* @__PURE__ */ jsx19(Icon10, {
            name: "expand",
            variant: "solid",
            size: "xs"
        })
    });
};
var HistoryButtons = function(param) {
    var capabilities = param.capabilities;
    var scope = historyScopeFor(capabilities.mutableKinds);
    var canUndo = useEditorStore20(function() {
        return canUndoPlan(scope);
    });
    var canRedo = useEditorStore20(function() {
        return canRedoPlan(scope);
    });
    return /* @__PURE__ */ jsxs13(Fragment9, {
        children: [
            /* @__PURE__ */ jsx19(ControlButton, {
                "aria-disabled": !canUndo,
                onMouseDown: keepFocus,
                onClick: function() {
                    if (canUndo) undoPlan(scope);
                },
                "aria-label": "Undo",
                "aria-keyshortcuts": HISTORY_SHORTCUTS.undo.aria,
                title: canUndo ? "Undo (".concat(HISTORY_SHORTCUTS.undo.hint, ")") : "Nothing to undo",
                children: /* @__PURE__ */ jsx19(Icon10, {
                    name: "rotate-left",
                    variant: "solid",
                    size: "xs"
                })
            }),
            /* @__PURE__ */ jsx19(ControlButton, {
                "aria-disabled": !canRedo,
                onMouseDown: keepFocus,
                onClick: function() {
                    if (canRedo) redoPlan(scope);
                },
                "aria-label": "Redo",
                "aria-keyshortcuts": HISTORY_SHORTCUTS.redo.aria,
                title: canRedo ? "Redo (".concat(HISTORY_SHORTCUTS.redo.hint, ")") : "Nothing to redo",
                children: /* @__PURE__ */ jsx19(Icon10, {
                    name: "rotate-right",
                    variant: "solid",
                    size: "xs"
                })
            })
        ]
    });
};
var AddReferenceButton = function(param) {
    var pdfImport = param.pdfImport, buttonRef = param.buttonRef;
    var floorId = useFloorplanStore28(function(s) {
        var _s_layout_floors_s_activeFloorIndex, _s_layout;
        return (_s_layout = s.layout) === null || _s_layout === void 0 ? void 0 : (_s_layout_floors_s_activeFloorIndex = _s_layout.floors[s.activeFloorIndex]) === null || _s_layout_floors_s_activeFloorIndex === void 0 ? void 0 : _s_layout_floors_s_activeFloorIndex.id;
    });
    var floorName = useFloorplanStore28(function(s) {
        var _s_layout_floors_s_activeFloorIndex, _s_layout;
        return (_s_layout = s.layout) === null || _s_layout === void 0 ? void 0 : (_s_layout_floors_s_activeFloorIndex = _s_layout.floors[s.activeFloorIndex]) === null || _s_layout_floors_s_activeFloorIndex === void 0 ? void 0 : _s_layout_floors_s_activeFloorIndex.name;
    });
    if (!pdfImport.canImport || floorId == null) return null;
    return /* @__PURE__ */ jsx19(ControlButton, {
        ref: buttonRef,
        onClick: function() {
            return pdfImport.choose({
                kind: "floor",
                floorId: floorId
            });
        },
        "aria-label": "Add reference",
        title: "Add a reference plan (PDF or image) to ".concat(floorName),
        children: /* @__PURE__ */ jsx19(Icon10, {
            name: "file-image",
            size: "xs"
        })
    });
};
var CanvasControls = function(param) {
    var onFitToScreen = param.onFitToScreen, _param_toolset = param.toolset, toolset = _param_toolset === void 0 ? "full" : _param_toolset, capabilities = param.capabilities, _param_referenceOffered = param.referenceOffered, referenceOffered = _param_referenceOffered === void 0 ? false : _param_referenceOffered, inset12 = param.inset;
    var support2 = usePlannerRendererSupport();
    var caps = capabilities !== null && capabilities !== void 0 ? capabilities : resolvePlannerCapabilities(toolset, "edit", support2);
    var tools = caps.tools;
    var showCameraTool = tools.camera;
    var showHistory = !historyScopeFor(caps.mutableKinds).camerasOnly;
    var zoom = useEditorStore20(function(s) {
        return s.zoom;
    });
    var setZoom = useEditorStore20(function(s) {
        return s.setZoom;
    });
    var viewRotation = useEditorStore20(function(s) {
        return s.viewRotation;
    });
    var rotateViewCW = useEditorStore20(function(s) {
        return s.rotateViewCW;
    });
    var rotateViewCCW = useEditorStore20(function(s) {
        return s.rotateViewCCW;
    });
    var toolMode = useEditorStore20(function(s) {
        return s.toolMode;
    });
    var setToolMode = useEditorStore20(function(s) {
        return s.setToolMode;
    });
    var clearSelection = useEditorStore20(function(s) {
        return s.clearSelection;
    });
    var _useToolbarAnnouncement = _sliced_to_array(useToolbarAnnouncement(), 2), announcement = _useToolbarAnnouncement[0], announce = _useToolbarAnnouncement[1];
    var referenceRef = useRef17(null);
    var pdfImport = usePdfImport({
        onImported: function(u, target) {
            return announce(importedSentence(u, target));
        },
        returnFocusTo: referenceRef
    });
    var handleRotateCW = function() {
        rotateViewCW();
        setTimeout(function() {
            return onFitToScreen === null || onFitToScreen === void 0 ? void 0 : onFitToScreen();
        }, 0);
    };
    var handleRotateCCW = function() {
        rotateViewCCW();
        setTimeout(function() {
            return onFitToScreen === null || onFitToScreen === void 0 ? void 0 : onFitToScreen();
        }, 0);
    };
    return /* @__PURE__ */ jsxs13(Fragment9, {
        children: [
            /* @__PURE__ */ jsxs13(StyledControlsWrapper, {
                role: "toolbar",
                "aria-label": "Canvas tools",
                style: inset12 ? {
                    top: inset12.top,
                    right: inset12.right
                } : void 0,
                children: [
                    /* @__PURE__ */ jsx19(ControlButton, {
                        active: toolMode === "select",
                        onClick: function() {
                            return setToolMode("select");
                        },
                        "aria-label": "Select tool",
                        "aria-keyshortcuts": SHORTCUTS.select.aria,
                        title: "Select tool (".concat(SHORTCUTS.select.hint, ")"),
                        children: /* @__PURE__ */ jsx19(Icon10, {
                            name: "arrow-pointer",
                            variant: "solid",
                            size: "xs"
                        })
                    }),
                    tools.drawWall && /* @__PURE__ */ jsx19(ControlButton, {
                        active: toolMode === "draw_wall",
                        onClick: function() {
                            setToolMode("draw_wall");
                            clearSelection();
                        },
                        "aria-label": "Draw wall",
                        "aria-keyshortcuts": SHORTCUTS.drawWall.aria,
                        title: "Draw wall (".concat(SHORTCUTS.drawWall.hint, ") — click to add corners, right-click to finish; hold Shift to turn off snapping"),
                        children: /* @__PURE__ */ jsx19(Icon10, {
                            name: "pen-ruler",
                            variant: "solid",
                            size: "xs"
                        })
                    }),
                    tools.drawSpace && /* @__PURE__ */ jsx19(ControlButton, {
                        active: toolMode === "draw_space",
                        onClick: function() {
                            setToolMode("draw_space");
                            clearSelection();
                        },
                        "aria-label": "Draw space",
                        "aria-keyshortcuts": SHORTCUTS.drawSpace.aria,
                        title: "Draw space (".concat(SHORTCUTS.drawSpace.hint, ")"),
                        children: /* @__PURE__ */ jsx19(Icon10, {
                            name: "draw-polygon",
                            variant: "solid",
                            size: "xs"
                        })
                    }),
                    showCameraTool && /* @__PURE__ */ jsx19(ControlButton, {
                        active: toolMode === "place_camera",
                        onClick: function() {
                            setToolMode("place_camera");
                            clearSelection();
                        },
                        "aria-label": "Place camera",
                        "aria-keyshortcuts": SHORTCUTS.placeCamera.aria,
                        title: "Place camera (".concat(SHORTCUTS.placeCamera.hint, ") — click the plan, or press Enter on it, to add a camera"),
                        children: /* @__PURE__ */ jsx19(Icon10, {
                            name: "video",
                            size: "xs"
                        })
                    }),
                    referenceOffered && (tools.background || caps.allFloors) && /* @__PURE__ */ jsx19(AddReferenceButton, {
                        pdfImport: pdfImport,
                        buttonRef: referenceRef
                    }),
                    tools.setScale && /* @__PURE__ */ jsx19(SetScaleButton, {}),
                    tools.scaleUnderlay && /* @__PURE__ */ jsx19(ScalePdfButton, {}),
                    /* @__PURE__ */ jsx19(Separator, {}),
                    /* @__PURE__ */ jsx19(ControlButton, {
                        onClick: function() {
                            return setZoom(zoom + 0.2);
                        },
                        "aria-label": "Zoom in",
                        "aria-keyshortcuts": SHORTCUTS.zoomIn.aria,
                        title: "Zoom in (".concat(SHORTCUTS.zoomIn.hint, ")"),
                        children: /* @__PURE__ */ jsx19(Icon10, {
                            name: "magnifying-glass-plus",
                            variant: "solid",
                            size: "xs"
                        })
                    }),
                    /* @__PURE__ */ jsxs13(InfoLabel, {
                        children: [
                            Math.round(zoom * 100),
                            "%"
                        ]
                    }),
                    /* @__PURE__ */ jsx19(ControlButton, {
                        onClick: function() {
                            return setZoom(zoom - 0.2);
                        },
                        "aria-label": "Zoom out",
                        "aria-keyshortcuts": SHORTCUTS.zoomOut.aria,
                        title: "Zoom out (".concat(SHORTCUTS.zoomOut.hint, ")"),
                        children: /* @__PURE__ */ jsx19(Icon10, {
                            name: "magnifying-glass-minus",
                            variant: "solid",
                            size: "xs"
                        })
                    }),
                    /* @__PURE__ */ jsx19(ControlButton, {
                        onClick: onFitToScreen !== null && onFitToScreen !== void 0 ? onFitToScreen : function() {
                            return setZoom(1);
                        },
                        "aria-label": "Fit to screen",
                        title: "Fit to screen \u2014 zoom and centre so the whole plan fits",
                        children: /* @__PURE__ */ jsx19(Icon10, {
                            name: "crosshairs",
                            variant: "solid",
                            size: "xs"
                        })
                    }),
                    showHistory && /* @__PURE__ */ jsxs13(Fragment9, {
                        children: [
                            /* @__PURE__ */ jsx19(Separator, {}),
                            /* @__PURE__ */ jsx19(HistoryButtons, {
                                capabilities: caps
                            })
                        ]
                    }),
                    tools.viewRotation && /* @__PURE__ */ jsxs13(Fragment9, {
                        children: [
                            /* @__PURE__ */ jsx19(Separator, {}),
                            /* @__PURE__ */ jsx19(ControlButton, {
                                onClick: handleRotateCCW,
                                "aria-label": "Rotate view counter-clockwise",
                                title: "Rotate view counter-clockwise \u2014 turns the plan 90\xB0 and re-fits it",
                                children: /* @__PURE__ */ jsx19(Icon10, {
                                    name: "arrow-rotate-left",
                                    variant: "solid",
                                    size: "xs"
                                })
                            }),
                            viewRotation !== 0 && /* @__PURE__ */ jsxs13(InfoLabel, {
                                children: [
                                    viewRotation,
                                    "\xB0"
                                ]
                            }),
                            /* @__PURE__ */ jsx19(ControlButton, {
                                onClick: handleRotateCW,
                                "aria-label": "Rotate view clockwise",
                                title: "Rotate view clockwise \u2014 turns the plan 90\xB0 and re-fits it",
                                children: /* @__PURE__ */ jsx19(Icon10, {
                                    name: "arrow-rotate-right",
                                    variant: "solid",
                                    size: "xs"
                                })
                            })
                        ]
                    })
                ]
            }),
            /* @__PURE__ */ jsx19("span", {
                role: "status",
                "aria-live": "polite",
                "aria-atomic": "true",
                style: visuallyHidden,
                children: announcement
            }),
            pdfImport.element
        ]
    });
};
// src/components/Planner/PlanLegendBar.tsx
import styled13 from "styled-components";
import { Switch } from "@repo/design-system";
import { space as space10 } from "@repo/design-tokens";
import { jsx as jsx20, jsxs as jsxs14 } from "react/jsx-runtime";
var Bar2 = styled13.div(_templateObject66(), space10[3], space10[3], space10[3], space10[3], space10[1], SMALL_GLASS_PADDING, space10[2], smallGlassCss, function(param) {
    var theme2 = param.theme;
    return theme2.zIndex.sticky;
});
var SwitchHost = styled13.div(_templateObject67());
var PlanLegendBar = function(param) {
    var children = param.children, showMap = param.showMap, style = param.style, className = param.className, testId = param["data-testid"];
    return /* @__PURE__ */ jsxs14(Bar2, {
        "data-testid": testId,
        "data-floating-legend": "",
        style: style,
        className: className,
        children: [
            children,
            showMap && /* @__PURE__ */ jsx20(SwitchHost, {
                children: /* @__PURE__ */ jsx20(Switch, {
                    surface: "on-glass",
                    checked: showMap.checked,
                    onChange: function(e) {
                        return showMap.onChange(e.target.checked);
                    },
                    children: "Show map"
                })
            })
        ]
    });
};
// src/components/Planner/sidebar/EquipmentSidebar.tsx
import { useCallback as useCallback14, useEffect as useEffect26, useId as useId2, useState as useState26 } from "react";
import styled26 from "styled-components";
import { Button as Button12, Tabs } from "@repo/design-system";
import { useEquipmentCatalogStore as useEquipmentCatalogStore12, registerReadState as registerReadState4 } from "@repo/front-end-state";
// src/components/Planner/sidebar/EquipmentSearch.tsx
import { useEffect as useEffect17, useState as useState17 } from "react";
import { useEquipmentCatalogStore as useEquipmentCatalogStore6 } from "@repo/front-end-state";
import styled14 from "styled-components";
import { Search } from "@repo/design-system";
import { jsx as jsx21 } from "react/jsx-runtime";
var SidebarSearchSlot = styled14.div(_templateObject68(), function(param) {
    var t = param.theme;
    return t.spacing[3];
});
function EquipmentSearch() {
    var _useState17 = _sliced_to_array(useState17(""), 2), q = _useState17[0], setQ = _useState17[1];
    var setSearchQuery = useEquipmentCatalogStore6(function(s) {
        return s.setSearchQuery;
    });
    useEffect17(function() {
        var t = setTimeout(function() {
            return setSearchQuery(q);
        }, 300);
        return function() {
            return clearTimeout(t);
        };
    }, [
        q,
        setSearchQuery
    ]);
    return /* @__PURE__ */ jsx21(SidebarSearchSlot, {
        children: /* @__PURE__ */ jsx21(Search, {
            size: "sm",
            "aria-label": "Search assets",
            placeholder: "Search assets...",
            value: q,
            onChange: setQ
        })
    });
}
// src/components/Planner/sidebar/EquipmentCategoryList.tsx
import { useEffect as useEffect18, useMemo as useMemo11, useRef as useRef18, useState as useState18 } from "react";
import styled18 from "styled-components";
import { ChevronRight24Regular } from "@fluentui/react-icons";
import { useEquipmentCatalogStore as useEquipmentCatalogStore7, useEditorStore as useEditorStore22, NO_PRODUCT_LINE, siteAssetGroupKeys, selectionOnFloorShown as selectionOnFloorShown3 } from "@repo/front-end-state";
import { assetSidebarKey, NO_CATALOGUE_MATCH_GROUP as NO_CATALOGUE_MATCH_GROUP2 } from "@repo/front-end-utils";
import { Select as Select2 } from "@repo/design-system";
// src/components/Planner/hooks/usePlacedIdentityForAsset.ts
import { useContext as useContext10, useMemo as useMemo10 } from "react";
import { useFloorplanStore as useFloorplanStore29 } from "@repo/front-end-state";
import { placementIndexFor, placementStateFor } from "@repo/front-end-utils";
import { normaliseAssetUid } from "@repo/frontend-types";
// src/components/Planner/hooks/plannerLayoutContext.ts
import { createContext as createContext9 } from "react";
var PlannerLayoutContext = createContext9(null);
// src/components/Planner/hooks/usePlacedIdentityForAsset.ts
var usePlacedIdentityForAsset = function(assetUid) {
    var layout = usePlanLayout();
    return useMemo10(function() {
        var _placementIndexFor;
        var uid = normaliseAssetUid(assetUid);
        if (!uid) return void 0;
        return (_placementIndexFor = placementIndexFor(layout)) === null || _placementIndexFor === void 0 ? void 0 : _placementIndexFor.byAssetUid.get(uid);
    }, [
        layout,
        assetUid
    ]);
};
var useAssetUidForPlacedIdentity = function(identity) {
    var layout = usePlanLayout();
    return useMemo10(function() {
        var _placementIndexFor;
        if (!identity) return void 0;
        return (_placementIndexFor = placementIndexFor(layout)) === null || _placementIndexFor === void 0 ? void 0 : _placementIndexFor.byRefid.get(identity);
    }, [
        layout,
        identity
    ]);
};
var usePlanLayout = function() {
    var joined2 = useContext10(PlannerLayoutContext);
    var stored = useFloorplanStore29(function(s) {
        return s.layout;
    });
    return joined2 !== null && joined2 !== void 0 ? joined2 : stored;
};
var usePlanPlacementState = function(assetUid) {
    var layout = usePlanLayout();
    return useMemo10(function() {
        return placementStateFor(placementIndexFor(layout), assetUid);
    }, [
        layout,
        assetUid
    ]);
};
// src/components/Planner/sidebar/EquipmentCard.tsx
import styled16, { css as css3 } from "styled-components";
import { Tag as Tag2 } from "@repo/design-system";
import { focus as focus2 } from "@repo/design-tokens";
import { useEditorStore as useEditorStore21, selectionOnFloorShown as selectionOnFloorShown2 } from "@repo/front-end-state";
import { ASSET_COVERAGE_LABEL } from "@repo/front-end-utils";
// src/components/Planner/sidebar/cardText.ts
import styled15 from "styled-components";
var ProductName = styled15.div(_templateObject69(), truncateText, function(param) {
    var t = param.theme;
    return t.fontSize.sm.size;
}, function(param) {
    var t = param.theme;
    return t.fontWeight.semibold;
}, function(param) {
    var t = param.theme;
    return t.colors.neutral[800];
});
var ProductMeta = styled15.div(_templateObject70(), truncateText, function(param) {
    var t = param.theme;
    return t.fontSize.xs.size;
}, function(param) {
    var t = param.theme;
    return t.colors.neutral[600];
});
// src/components/Planner/sidebar/equipmentCardLabels.ts
import { NO_CATALOGUE_MATCH_GROUP } from "@repo/front-end-utils";
function productWithLine(product, productLine) {
    var _product_trim;
    var p = (_product_trim = product === null || product === void 0 ? void 0 : product.trim()) !== null && _product_trim !== void 0 ? _product_trim : "";
    var _productLine_trim;
    var rawLine = (_productLine_trim = productLine === null || productLine === void 0 ? void 0 : productLine.trim()) !== null && _productLine_trim !== void 0 ? _productLine_trim : "";
    var line3 = rawLine.toLowerCase() === p.toLowerCase() ? "" : rawLine;
    return [
        p,
        line3
    ].filter(Boolean).join(" - ");
}
function assetProductLine(asset, name) {
    var _asset_model_name;
    var _asset_model_name_trim;
    var product = (_asset_model_name_trim = (_asset_model_name = asset.model_name) === null || _asset_model_name === void 0 ? void 0 : _asset_model_name.trim()) !== null && _asset_model_name_trim !== void 0 ? _asset_model_name_trim : "";
    var echoesName = asset.manufacturer_name === NO_CATALOGUE_MATCH_GROUP && product.toLowerCase() === name.trim().toLowerCase();
    return productWithLine(echoesName ? "" : product, asset.product_line);
}
function equipmentCardLabels(asset) {
    var _asset_asset_name;
    var name = (_asset_asset_name = asset.asset_name) === null || _asset_asset_name === void 0 ? void 0 : _asset_asset_name.trim();
    if (!name) return {
        title: asset.model_name,
        detail: asset.product_line
    };
    return {
        title: name,
        detail: assetProductLine(asset, name)
    };
}
// src/components/Planner/sidebar/EquipmentCard.tsx
import { jsx as jsx22, jsxs as jsxs15 } from "react/jsx-runtime";
var Card = styled16.div(_templateObject73(), function(param) {
    var t = param.theme;
    return t.spacing[0.5];
}, function(param) {
    var t = param.theme;
    return "".concat(t.spacing[2], " ").concat(t.spacing[2.5]);
}, function(param) {
    var t = param.theme;
    return "0 ".concat(t.spacing[2], " ").concat(t.spacing[1.5]);
}, function(param) {
    var t = param.theme;
    return t.colors.neutral[300];
}, function(param) {
    var t = param.theme;
    return t.colors.white;
}, function(param) {
    var t = param.theme;
    return t.transitions.fast;
}, function(param) {
    var t = param.theme;
    return t.colors.brand[400];
}, function(param) {
    var t = param.theme;
    return t.shadows.sm;
}, focus2.tight, function(param) {
    var $variant = param.$variant, t = param.theme;
    return $variant === "selected" && css3(_templateObject71(), t.colors.success[500], t.colors.success[50]);
}, function(param) {
    var $variant = param.$variant, t = param.theme;
    return $variant === "modified" && css3(_templateObject72(), t.colors.info[500], t.colors.info[50]);
});
var CardFooter = styled16.div(_templateObject74(), function(param) {
    var t = param.theme;
    return t.spacing[2];
});
var AssetBid = styled16.div(_templateObject75(), truncateText, function(param) {
    var t = param.theme;
    return t.fontSize.xs.size;
}, function(param) {
    var t = param.theme;
    return t.colors.neutral[500];
});
function EquipmentCard(param) {
    var asset = param.asset;
    var selectedEntityIds = useEditorStore21(selectionOnFloorShown2);
    var modifiedEntityIds = useEditorStore21(function(s) {
        return s.modifiedEntityIds;
    });
    var selectEntity = useEditorStore21(function(s) {
        return s.selectEntity;
    });
    var highlightEntity = useEditorStore21(function(s) {
        return s.highlightEntity;
    });
    var placedIdentity = usePlacedIdentityForAsset(asset.asset_uid);
    var canvasIdentity = placedIdentity !== null && placedIdentity !== void 0 ? placedIdentity : asset.entity_bid;
    var labels = equipmentCardLabels(asset);
    var placementState = usePlanPlacementState(asset.asset_uid);
    var variant = selectedEntityIds.includes(canvasIdentity) ? "selected" : modifiedEntityIds.has(canvasIdentity) ? "modified" : "default";
    var select = function() {
        selectEntity(canvasIdentity);
        highlightEntity(canvasIdentity);
    };
    var onDragStart = function(e) {
        e.dataTransfer.setData("application/json", JSON.stringify({
            refid: asset.entity_bid,
            product: asset.model_name,
            productLine: asset.product_line,
            manufacturer: asset.manufacturer_name,
            model: asset.model_file,
            // Register identity + effective capacity, so the dropped item can be
            // traced back to its `twin_asset` row. Both absent for catalogue rows.
            assetUid: asset.asset_uid,
            capacity: asset.capacity,
            /*
         * The asset's entity code, when its register row already has one
         * (`asset-register-adopt-existing`, ruling O7).
         *
         * This is the hop that makes adoption work end to end: the code reaches
         * `FloorPlannerItem.entityCode`, `stampEntityCodes` leaves it alone (it fills blanks
         * only), and `convertPlanToTwin` reproduces it VERBATIM as the entity BID (R18, it is the
         * full BID) — the customer's
         * ORIGINAL BID. Absent for every row whose code has not been minted, which is every row
         * that has not been placed, and for catalogue and Library cards.
         */ entityCode: asset.entity_code
        }));
        e.dataTransfer.effectAllowed = "copyMove";
    };
    var _ref;
    return /* @__PURE__ */ jsxs15(Card, {
        $variant: variant,
        draggable: true,
        onDragStart: onDragStart,
        "data-entity-bid": asset.entity_bid,
        title: asset.manufacturer_name,
        role: "button",
        tabIndex: 0,
        "aria-pressed": variant === "selected",
        onClick: select,
        onKeyDown: function(e) {
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                select();
            }
        },
        children: [
            /* @__PURE__ */ jsx22(ProductName, {
                title: labels.title,
                children: labels.title
            }),
            /* @__PURE__ */ jsx22(ProductMeta, {
                title: labels.detail || void 0,
                children: labels.detail
            }),
            /* @__PURE__ */ jsxs15(CardFooter, {
                children: [
                    /* @__PURE__ */ jsx22(AssetBid, {
                        children: (_ref = placedIdentity !== null && placedIdentity !== void 0 ? placedIdentity : asset.entity_code) !== null && _ref !== void 0 ? _ref : asset.entity_bid
                    }),
                    asset.asset_uid != null && placementState === "unplaced" && /* @__PURE__ */ jsx22(Tag2, {
                        surface: "on-solid",
                        tone: "neutral",
                        size: "dense",
                        children: ASSET_COVERAGE_LABEL["not-on-plan"]
                    })
                ]
            })
        ]
    });
}
// src/components/Planner/sidebar/placementGroups.ts
import { ASSET_COVERAGE_LABEL as ASSET_COVERAGE_LABEL2 } from "@repo/front-end-utils";
var PLACEMENT_GROUP_ORDER = [
    "unplaced",
    "placed",
    "unknown"
];
var placementGroupHeading = function(key) {
    return key === "unplaced" ? ASSET_COVERAGE_LABEL2["not-on-plan"] : key === "placed" ? "On plan" : "Plan not loaded yet";
};
var PLAN_NOT_LOADED_NOTE = "The floor plan hasn't loaded, so these can't be sorted yet.";
function groupByPlacement(groups, index) {
    var buckets = {
        unplaced: [],
        placed: [],
        unknown: []
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = groups[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var group = _step.value;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = group.productLines[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var line3 = _step1.value;
                    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        for(var _iterator2 = line3.assets[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            var asset = _step2.value;
                            buckets[placementStateFor(index, asset.asset_uid)].push(asset);
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                _iterator2.return();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return PLACEMENT_GROUP_ORDER.filter(function(key) {
        return buckets[key].length > 0;
    }).map(function(key) {
        return {
            key: key,
            assets: buckets[key]
        };
    });
}
// src/components/Planner/sidebar/accordion.ts
import styled17 from "styled-components";
var SectionCard = styled17.div(_templateObject76(), function(param) {
    var t = param.theme;
    return "0 ".concat(t.spacing[3], " ").concat(t.spacing[2]);
}, function(param) {
    var t = param.theme;
    return t.borderRadius.DEFAULT;
}, function(param) {
    var t = param.theme;
    return t.colors.neutral[300];
}, function(param) {
    var t = param.theme;
    return t.colors.neutral[50];
});
var SectionHeader = styled17.button(_templateObject77(), function(param) {
    var t = param.theme;
    return t.spacing[1.5];
}, function(param) {
    var t = param.theme;
    return "".concat(t.spacing[2], " ").concat(t.spacing[2.5]);
}, function(param) {
    var t = param.theme;
    return t.colors.neutral[100];
});
var ManufacturerName = styled17.span(_templateObject78(), truncateText, function(param) {
    var t = param.theme;
    return t.fontSize.sm.size;
}, function(param) {
    var t = param.theme;
    return t.fontWeight.semibold;
}, function(param) {
    var t = param.theme;
    return t.colors.neutral[800];
});
var ProductLineCard = styled17.div(_templateObject79(), function(param) {
    var t = param.theme;
    return "0 ".concat(t.spacing[2], " ").concat(t.spacing[1.5]);
});
var ProductLineHeader = styled17.button(_templateObject80(), function(param) {
    var t = param.theme;
    return t.spacing[1.5];
}, function(param) {
    var t = param.theme;
    return "".concat(t.spacing[1.5], " ").concat(t.spacing[2]);
}, function(param) {
    var t = param.theme;
    return t.colors.neutral[100];
});
var ProductLineName = styled17.span(_templateObject81(), truncateText, function(param) {
    var t = param.theme;
    return t.fontSize.xs.size;
}, function(param) {
    var t = param.theme;
    return t.fontWeight.medium;
}, function(param) {
    var t = param.theme;
    return t.colors.neutral[700];
});
var ChevronIcon = styled17.span(_templateObject82(), function(param) {
    var t = param.theme;
    return t.colors.neutral[500];
}, function(param) {
    var t = param.theme;
    return t.transitions.fast;
}, function(param) {
    var $expanded = param.$expanded;
    return $expanded ? "90deg" : "0deg";
});
var toggleExpanded = function(setter) {
    return function(key) {
        return setter(function(p) {
            var n = new Set(p);
            if (n.has(key)) n.delete(key);
            else n.add(key);
            return n;
        });
    };
};
// src/components/Planner/sidebar/EquipmentCategoryList.tsx
import { Fragment as Fragment10, jsx as jsx23, jsxs as jsxs16 } from "react/jsx-runtime";
var ListWrapper = styled18.div(_templateObject83(), function(param) {
    var t = param.theme;
    return t.spacing[4];
});
var ControlRow = styled18.div(_templateObject84(), function(param) {
    var t = param.theme;
    return t.spacing[2];
}, function(param) {
    var t = param.theme;
    return "0 ".concat(t.spacing[3], " ").concat(t.spacing[2]);
});
var GroupByLabel = styled18.span(_templateObject85(), function(param) {
    var t = param.theme;
    return t.fontSize.xs.size;
}, function(param) {
    var t = param.theme;
    return t.colors.neutral[600];
});
var SelectSlot = styled18.div(_templateObject86());
var GROUP_BY_LABEL_ID = "planner-sidebar-group-by-label";
var GROUP_BY_OPTIONS = [
    {
        value: "manufacturer",
        label: "Manufacturer"
    },
    {
        value: "placement",
        label: "Plan status"
    }
];
var PLAN_NOT_LOADED_NOTE_ID = "planner-sidebar-plan-not-loaded-note";
var GROUP_BY_ANNOUNCEMENT = {
    manufacturer: "Grouped by manufacturer",
    placement: "Grouped by plan status"
};
var GroupNote = styled18.p(_templateObject87(), function(param) {
    var t = param.theme;
    return "0 ".concat(t.spacing[2.5], " ").concat(t.spacing[1.5]);
}, function(param) {
    var t = param.theme;
    return t.fontSize.xs.size;
}, function(param) {
    var t = param.theme;
    return t.colors.neutral[600];
});
var NO_MATCH_NOTE = "Grouped by the text in your own file, not our catalogue.";
var NO_BRAND_SUB_HEADING = "No brand given";
var NO_MATCH_NOTE_ID = "planner-sidebar-no-catalogue-match-note";
function EquipmentCategoryList() {
    var emptyNote = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).emptyNote;
    var grouped = useEquipmentCatalogStore7(function(s) {
        return s.filteredGrouped;
    });
    var getAssetByBid = useEquipmentCatalogStore7(function(s) {
        return s.getAssetByBid;
    });
    var selectedIds = useEditorStore22(selectionOnFloorShown3);
    var selectedIdentity = selectedIds.length ? selectedIds[0] : void 0;
    var placedAssetUid = useAssetUidForPlacedIdentity(selectedIdentity);
    var selectedAsset = useMemo11(function() {
        if (!selectedIdentity) return void 0;
        var direct = getAssetByBid(selectedIdentity);
        if (direct) return direct;
        if (!placedAssetUid) return void 0;
        var rowId = Number(placedAssetUid);
        if (!Number.isSafeInteger(rowId)) return void 0;
        return getAssetByBid(assetSidebarKey(rowId));
    }, [
        selectedIdentity,
        placedAssetUid,
        getAssetByBid
    ]);
    var _useState18 = _sliced_to_array(useState18(/* @__PURE__ */ new Set()), 2), expandedGroups = _useState18[0], setExpandedGroups = _useState18[1];
    var _useState181 = _sliced_to_array(useState18(/* @__PURE__ */ new Set()), 2), expandedLines = _useState181[0], setExpandedLines = _useState181[1];
    var _useState182 = _sliced_to_array(useState18("manufacturer"), 2), groupBy = _useState182[0], setGroupBy = _useState182[1];
    var _useState183 = _sliced_to_array(useState18(/* @__PURE__ */ new Set()), 2), expandedStatus = _useState183[0], setExpandedStatus = _useState183[1];
    var _useState184 = _sliced_to_array(useState18(""), 2), announcement = _useState184[0], setAnnouncement = _useState184[1];
    var placementIndex = placementIndexFor(usePlanLayout());
    var statusGroups = useMemo11(function() {
        return groupBy === "placement" ? groupByPlacement(grouped, placementIndex) : [];
    }, [
        groupBy,
        grouped,
        placementIndex
    ]);
    var selectedStatusKey = useMemo11(function() {
        return selectedAsset ? placementStateFor(placementIndex, selectedAsset.asset_uid) : void 0;
    }, [
        selectedAsset,
        placementIndex
    ]);
    useEffect18(function() {
        var asset = selectedAsset;
        if (!asset) return;
        if (groupBy !== "manufacturer") return;
        var _siteAssetGroupKeys = siteAssetGroupKeys(asset), manufacturer = _siteAssetGroupKeys.manufacturer, productLine = _siteAssetGroupKeys.productLine;
        setExpandedGroups(function(p) {
            return p.has(manufacturer) ? p : new Set(p).add(manufacturer);
        });
        setExpandedLines(function(p) {
            var lineKey = "".concat(manufacturer, "::").concat(productLine);
            return p.has(lineKey) ? p : new Set(p).add(lineKey);
        });
    }, [
        selectedAsset,
        groupBy
    ]);
    var statusOpenedFor = useRef18(null);
    useEffect18(function() {
        if (!selectedAsset) {
            statusOpenedFor.current = null;
            return;
        }
        if (groupBy !== "placement" || !selectedStatusKey) return;
        if (statusOpenedFor.current === selectedAsset.entity_bid) return;
        if (selectedStatusKey !== "unknown") statusOpenedFor.current = selectedAsset.entity_bid;
        setExpandedStatus(function(p) {
            return p.has(selectedStatusKey) ? p : new Set(p).add(selectedStatusKey);
        });
    }, [
        selectedAsset,
        selectedStatusKey,
        groupBy
    ]);
    var scrolledFor = useRef18(null);
    useEffect18(function() {
        var asset = selectedAsset;
        if (!asset) {
            scrolledFor.current = null;
            return;
        }
        if (groupBy === "placement") {
            if (!selectedStatusKey || !expandedStatus.has(selectedStatusKey)) return;
        } else {
            var _siteAssetGroupKeys = siteAssetGroupKeys(asset), manufacturer = _siteAssetGroupKeys.manufacturer, productLine = _siteAssetGroupKeys.productLine;
            if (!expandedGroups.has(manufacturer)) return;
            if (!expandedLines.has("".concat(manufacturer, "::").concat(productLine))) return;
        }
        if (scrolledFor.current === asset.entity_bid) return;
        var card = document.querySelector('[data-entity-bid="'.concat(asset.entity_bid, '"]'));
        if (!card) return;
        scrolledFor.current = asset.entity_bid;
        card.scrollIntoView({
            behavior: "smooth",
            block: "nearest"
        });
    }, [
        selectedAsset,
        expandedGroups,
        expandedLines,
        grouped,
        groupBy,
        selectedStatusKey,
        expandedStatus
    ]);
    var changeGroupBy = function(value) {
        var next = value === "placement" ? "placement" : "manufacturer";
        if (next === groupBy) return;
        setGroupBy(next);
        if (next === "placement") setExpandedStatus(function(p) {
            return new Set(p).add("unplaced");
        });
        scrolledFor.current = null;
        statusOpenedFor.current = null;
        setAnnouncement(GROUP_BY_ANNOUNCEMENT[next]);
    };
    return /* @__PURE__ */ jsxs16(Fragment10, {
        children: [
            /* @__PURE__ */ jsxs16(ControlRow, {
                children: [
                    /* @__PURE__ */ jsx23(GroupByLabel, {
                        id: GROUP_BY_LABEL_ID,
                        children: "Group by"
                    }),
                    /* @__PURE__ */ jsx23(SelectSlot, {
                        children: /* @__PURE__ */ jsx23(Select2, {
                            options: GROUP_BY_OPTIONS,
                            value: groupBy,
                            onChange: changeGroupBy,
                            size: "sm",
                            onGlass: true,
                            ariaLabelledBy: GROUP_BY_LABEL_ID
                        })
                    })
                ]
            }),
            /* @__PURE__ */ jsx23("span", {
                "aria-live": "polite",
                style: visuallyHidden,
                children: announcement
            }),
            emptyNote,
            groupBy === "placement" ? /* @__PURE__ */ jsx23(ListWrapper, {
                children: statusGroups.map(function(group) {
                    var open = expandedStatus.has(group.key);
                    var isUnknown = group.key === "unknown";
                    return /* @__PURE__ */ jsxs16(SectionCard, {
                        children: [
                            /* @__PURE__ */ jsxs16(SectionHeader, {
                                onClick: function() {
                                    return toggleExpanded(setExpandedStatus)(group.key);
                                },
                                "aria-expanded": open,
                                "aria-describedby": open && isUnknown ? PLAN_NOT_LOADED_NOTE_ID : void 0,
                                children: [
                                    /* @__PURE__ */ jsx23(ChevronIcon, {
                                        $expanded: open,
                                        children: /* @__PURE__ */ jsx23(ChevronRight24Regular, {})
                                    }),
                                    /* @__PURE__ */ jsx23(ManufacturerName, {
                                        children: "".concat(placementGroupHeading(group.key), " (").concat(group.assets.length, ")")
                                    })
                                ]
                            }),
                            open && isUnknown && /* @__PURE__ */ jsx23(GroupNote, {
                                id: PLAN_NOT_LOADED_NOTE_ID,
                                children: PLAN_NOT_LOADED_NOTE
                            }),
                            open && group.assets.map(function(a) {
                                return /* @__PURE__ */ jsx23(EquipmentCard, {
                                    asset: a
                                }, a.entity_bid);
                            })
                        ]
                    }, group.key);
                })
            }) : /* @__PURE__ */ jsx23(ListWrapper, {
                children: grouped.map(function(group) {
                    var open = expandedGroups.has(group.manufacturer);
                    var isNoMatchGroup = group.manufacturer === NO_CATALOGUE_MATCH_GROUP2;
                    return /* @__PURE__ */ jsxs16(SectionCard, {
                        children: [
                            /* @__PURE__ */ jsxs16(SectionHeader, {
                                onClick: function() {
                                    return toggleExpanded(setExpandedGroups)(group.manufacturer);
                                },
                                "aria-expanded": open,
                                "aria-describedby": open && isNoMatchGroup ? NO_MATCH_NOTE_ID : void 0,
                                children: [
                                    /* @__PURE__ */ jsx23(ChevronIcon, {
                                        $expanded: open,
                                        children: /* @__PURE__ */ jsx23(ChevronRight24Regular, {})
                                    }),
                                    /* @__PURE__ */ jsx23(ManufacturerName, {
                                        children: group.manufacturer
                                    })
                                ]
                            }),
                            open && isNoMatchGroup && /* @__PURE__ */ jsx23(GroupNote, {
                                id: NO_MATCH_NOTE_ID,
                                children: NO_MATCH_NOTE
                            }),
                            open && group.productLines.map(function(pl) {
                                var lineKey = "".concat(group.manufacturer, "::").concat(pl.productLine);
                                var lineOpen = expandedLines.has(lineKey);
                                return /* @__PURE__ */ jsxs16(ProductLineCard, {
                                    children: [
                                        /* @__PURE__ */ jsxs16(ProductLineHeader, {
                                            onClick: function() {
                                                return toggleExpanded(setExpandedLines)(lineKey);
                                            },
                                            "aria-expanded": lineOpen,
                                            children: [
                                                /* @__PURE__ */ jsx23(ChevronIcon, {
                                                    $expanded: lineOpen,
                                                    children: /* @__PURE__ */ jsx23(ChevronRight24Regular, {})
                                                }),
                                                /* @__PURE__ */ jsx23(ProductLineName, {
                                                    children: isNoMatchGroup && pl.productLine === NO_PRODUCT_LINE ? NO_BRAND_SUB_HEADING : pl.productLine
                                                })
                                            ]
                                        }),
                                        lineOpen && pl.assets.map(function(a) {
                                            return /* @__PURE__ */ jsx23(EquipmentCard, {
                                                asset: a
                                            }, a.entity_bid);
                                        })
                                    ]
                                }, pl.productLine);
                            })
                        ]
                    }, group.manufacturer);
                })
            })
        ]
    });
}
// src/components/Planner/sidebar/LibraryBrowser.tsx
import { memo, useEffect as useEffect19, useMemo as useMemo12, useState as useState19 } from "react";
import styled19 from "styled-components";
import { Search as Search2 } from "@repo/design-system";
import { ChevronRight24Regular as ChevronRight24Regular2 } from "@fluentui/react-icons";
import { groupSiteAssets, useManufacturerCatalogStore } from "@repo/front-end-state";
import { GENERIC_GROUP, catalogueDisplayNames, flatShareFilename, toDisplayManufacturer } from "@repo/front-end-utils";
// src/components/Planner/equipmentDrag.ts
import React2, { createContext as createContext10, useContext as useContext11, useSyncExternalStore as useSyncExternalStore3 } from "react";
var IDLE = {
    drag: null,
    hint: null
};
var sameHint = function(a, b) {
    return a === b || !!a && !!b && a.floor === b.floor && (a.floor || b.floor || a.refid === b.refid && a.name === b.name);
};
var createEquipmentDragStore = function() {
    var state = IDLE;
    var target = null;
    var carryHost = null;
    var listeners2 = /* @__PURE__ */ new Set();
    var emit = function(next) {
        state = next;
        listeners2.forEach(function(l) {
            return l();
        });
    };
    return {
        get: function() {
            return state;
        },
        begin: function(drag) {
            return emit({
                drag: drag,
                hint: null
            });
        },
        setHint: function(hint) {
            if (!state.drag || sameHint(state.hint, hint)) return;
            emit(_object_spread_props(_object_spread({}, state), {
                hint: hint
            }));
        },
        end: function() {
            if (state !== IDLE) emit(IDLE);
        },
        subscribe: function(listener) {
            listeners2.add(listener);
            return function() {
                listeners2.delete(listener);
            };
        },
        setTarget: function(next) {
            target = next;
        },
        getTarget: function() {
            return target;
        },
        setCarryHost: function(next) {
            carryHost = next;
        },
        getCarryHost: function() {
            return carryHost;
        }
    };
};
var EquipmentDragContext = createContext10(null);
var useEquipmentDragStore = function() {
    return useContext11(EquipmentDragContext);
};
var NO_STATE2 = function() {
    return IDLE;
};
var NO_SUBSCRIBE2 = function() {
    return function() {
        return void 0;
    };
};
var useEquipmentDragState = function(store) {
    var _store_subscribe, _store_get, _store_get1;
    return useSyncExternalStore3((_store_subscribe = store === null || store === void 0 ? void 0 : store.subscribe) !== null && _store_subscribe !== void 0 ? _store_subscribe : NO_SUBSCRIBE2, (_store_get = store === null || store === void 0 ? void 0 : store.get) !== null && _store_get !== void 0 ? _store_get : NO_STATE2, (_store_get1 = store === null || store === void 0 ? void 0 : store.get) !== null && _store_get1 !== void 0 ? _store_get1 : NO_STATE2);
};
var blankNode = null;
var blankDragImage = function() {
    if (typeof document === "undefined") return null;
    if (blankNode && blankNode.isConnected) return blankNode;
    var node = document.createElement("div");
    node.setAttribute("aria-hidden", "true");
    node.setAttribute("data-equipment-drag-image", "");
    Object.assign(node.style, {
        position: "fixed",
        top: "0",
        left: "-10000px",
        width: "1px",
        height: "1px",
        background: "transparent",
        pointerEvents: "none"
    });
    document.body.appendChild(node);
    blankNode = node;
    return node;
};
var beginEquipmentDrag = function(e, store, drag) {
    if (!store) return;
    var node = blankDragImage();
    if (node && typeof e.dataTransfer.setDragImage === "function") {
        e.dataTransfer.setDragImage(node, 0, 0);
    }
    store.begin(_object_spread_props(_object_spread({}, drag), {
        via: "browser",
        start: {
            x: e.clientX,
            y: e.clientY
        }
    }));
};
var isCarriedDrag = function(store, drag) {
    return (drag === null || drag === void 0 ? void 0 : drag.via) === "pointer" && (store === null || store === void 0 ? void 0 : store.getCarryHost()) != null;
};
var NOT_ACTIVE = function() {
    return false;
};
var useEquipmentDragRowKey = function(store) {
    var rowKey = function() {
        var _store_get_drag;
        var _store_get_drag_rowKey;
        return (_store_get_drag_rowKey = store === null || store === void 0 ? void 0 : (_store_get_drag = store.get().drag) === null || _store_get_drag === void 0 ? void 0 : _store_get_drag.rowKey) !== null && _store_get_drag_rowKey !== void 0 ? _store_get_drag_rowKey : null;
    };
    var none = function() {
        return null;
    };
    var _store_subscribe;
    return useSyncExternalStore3((_store_subscribe = store === null || store === void 0 ? void 0 : store.subscribe) !== null && _store_subscribe !== void 0 ? _store_subscribe : NO_SUBSCRIBE2, store ? rowKey : none, store ? rowKey : none);
};
var useEndEquipmentDragOnDrop = function(store) {
    React2.useEffect(function() {
        if (!store) return void 0;
        var end = function() {
            return store.end();
        };
        document.addEventListener("drop", end, true);
        document.addEventListener("dragend", end, true);
        return function() {
            document.removeEventListener("drop", end, true);
            document.removeEventListener("dragend", end, true);
        };
    }, [
        store
    ]);
};
var useEquipmentDragActive = function(store) {
    var active = function() {
        return (store === null || store === void 0 ? void 0 : store.get().drag) != null;
    };
    var _store_subscribe;
    return useSyncExternalStore3((_store_subscribe = store === null || store === void 0 ? void 0 : store.subscribe) !== null && _store_subscribe !== void 0 ? _store_subscribe : NO_SUBSCRIBE2, store ? active : NOT_ACTIVE, store ? active : NOT_ACTIVE);
};
// src/components/Planner/equipmentPointerDrag.ts
import React3 from "react";
var DRAG_DISTANCE = 3;
var POINTER_DRAG_COPY_CLASS = "tl-equipment-drag-copy";
var POINTER_DRAG_NO_DROP_CLASS = "tl-equipment-drag-no-drop";
var POINTER_DRAG_CARRYING_CLASS = "tl-equipment-carrying";
var controllers = /* @__PURE__ */ new WeakMap();
var admitted = function(e) {
    return (e.pointerType === "mouse" || e.pointerType === "pen") && e.isPrimary && e.button === 0;
};
var useEquipmentPointerSource = function(store) {
    return React3.useMemo(function() {
        return {
            onPointerDown: function(e, describe) {
                var _controllers_get;
                if (!store) return;
                if (!admitted(e)) return;
                (_controllers_get = controllers.get(store)) === null || _controllers_get === void 0 ? void 0 : _controllers_get.press(e, describe);
            },
            /**
     * Call first in the source's `onDragStart`; `true` means it was cancelled and the handler
     * returns at once, before any `setData` (R3). A touch press never got this far, so its
     * `dragstart` runs the browser drag as today.
     */ guardDragStart: function(e) {
                var _controllers_get;
                if (!store || !((_controllers_get = controllers.get(store)) === null || _controllers_get === void 0 ? void 0 : _controllers_get.owns())) return false;
                e.preventDefault();
                return true;
            }
        };
    }, [
        store
    ]);
};
var wholePixel = Math.trunc;
var setCursor = function(over) {
    var carried = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var html = document.documentElement;
    html.classList.toggle(POINTER_DRAG_COPY_CLASS, !carried && over === true);
    html.classList.toggle(POINTER_DRAG_NO_DROP_CLASS, !carried && over === false);
    html.classList.toggle(POINTER_DRAG_CARRYING_CLASS, carried && over !== null);
};
var attachEquipmentPointerDrag = function(store, captureNode) {
    var pending = null;
    var active = null;
    var overTarget = function(x, y) {
        var target = store.getTarget();
        if (!target) return false;
        var hit = document.elementFromPoint(x, y);
        return !!hit && target.element.contains(hit);
    };
    var track = function() {
        if (!active) return;
        var over = overTarget(active.x, active.y);
        var target = store.getTarget();
        if (over) target === null || target === void 0 ? void 0 : target.preview(wholePixel(active.x), wholePixel(active.y), active.shift);
        else if (active.over) target === null || target === void 0 ? void 0 : target.clear();
        active.over = over;
        setCursor(over, active.host !== null);
    };
    var onMove = function(e) {
        if (active) {
            if (e.pointerId !== active.pointerId) return;
            active.x = e.clientX;
            active.y = e.clientY;
            var _e_shiftKey;
            active.shift = (_e_shiftKey = e.shiftKey) !== null && _e_shiftKey !== void 0 ? _e_shiftKey : false;
            track();
            return;
        }
        if (!pending || e.pointerId !== pending.pointerId) return;
        if ((e.buttons & 1) === 0) {
            cancel();
            return;
        }
        if (Math.hypot(e.clientX - pending.x, e.clientY - pending.y) > DRAG_DISTANCE) begin(e);
    };
    var begin = function(e) {
        var _active_host;
        var press = pending;
        pending = null;
        var _press_describe = press.describe(), payload = _press_describe.payload, drag = _press_describe.drag;
        try {
            captureNode.setPointerCapture(press.pointerId);
        } catch (e) {
            stopListening();
            return;
        }
        var _e_shiftKey;
        active = {
            pointerId: press.pointerId,
            payload: payload,
            x: e.clientX,
            y: e.clientY,
            shift: (_e_shiftKey = e.shiftKey) !== null && _e_shiftKey !== void 0 ? _e_shiftKey : false,
            over: false,
            host: store.getCarryHost()
        };
        var begun = _object_spread_props(_object_spread({}, drag), {
            via: "pointer",
            start: {
                x: e.clientX,
                y: e.clientY
            }
        });
        store.begin(begun);
        (_active_host = active.host) === null || _active_host === void 0 ? void 0 : _active_host.begin(begun, {
            x: e.clientX,
            y: e.clientY
        });
        captureNode.addEventListener("lostpointercapture", onLostCapture);
        window.addEventListener("keydown", onKey, true);
        window.addEventListener("keyup", onKey, true);
        window.addEventListener("wheel", onWheel, {
            capture: true,
            passive: false
        });
        document.addEventListener("selectstart", onSelectStart, true);
        track();
    };
    var onUp = function(e) {
        if (pending && e.pointerId === pending.pointerId) {
            pending = null;
            stopListening();
            return;
        }
        if (!active || e.pointerId !== active.pointerId) return;
        var payload = active.payload, host = active.host;
        var x = e.clientX;
        var y = e.clientY;
        var _e_shiftKey;
        var shift = (_e_shiftKey = e.shiftKey) !== null && _e_shiftKey !== void 0 ? _e_shiftKey : false;
        var over = overTarget(x, y);
        var target = store.getTarget();
        finish2(null, true);
        if (over && target) {
            var _target_landing;
            var px = wholePixel(x);
            var py = wholePixel(y);
            var settled = target.place(payload, px, py, shift).catch(target.report);
            var _target_landing1;
            host === null || host === void 0 ? void 0 : host.release({
                clientX: x,
                clientY: y,
                landing: (_target_landing1 = (_target_landing = target.landing) === null || _target_landing === void 0 ? void 0 : _target_landing.call(target, px, py, shift)) !== null && _target_landing1 !== void 0 ? _target_landing1 : null,
                settled: settled
            });
        } else {
            host === null || host === void 0 ? void 0 : host.cancel();
        }
    };
    var cancel = function() {
        if (pending) {
            pending = null;
            stopListening();
        }
        if (active) finish2();
    };
    var onPointerCancel = function(e) {
        var _this;
        if (e.pointerId === ((_this = active !== null && active !== void 0 ? active : pending) === null || _this === void 0 ? void 0 : _this.pointerId)) cancel();
    };
    var onLostCapture = function() {
        if (active) cancel();
    };
    var onKey = function(e) {
        if (!active) return;
        e.stopImmediatePropagation();
        e.preventDefault();
        if (e.key === "Escape") {
            if (e.type === "keydown") finish2(active.pointerId);
            return;
        }
        if (e.key === "Shift") {
            active.shift = e.shiftKey;
            track();
        }
    };
    var onWheel = function(e) {
        e.preventDefault();
        e.stopPropagation();
    };
    var onSelectStart = function(e) {
        return e.preventDefault();
    };
    var disarmClick = null;
    var swallowClick = function(untilReleaseOf) {
        disarmClick === null || disarmClick === void 0 ? void 0 : disarmClick();
        var swallow = function(e) {
            e.preventDefault();
            e.stopPropagation();
            disarm();
        };
        var released = function(e) {
            if (e.pointerId !== untilReleaseOf) return;
            window.removeEventListener("pointerup", released, true);
            window.setTimeout(disarm, 0);
        };
        var disarm = function() {
            window.removeEventListener("click", swallow, true);
            window.removeEventListener("pointerup", released, true);
            window.removeEventListener("pointerdown", disarm, true);
            window.removeEventListener("blur", disarm);
            if (disarmClick === disarm) disarmClick = null;
        };
        window.addEventListener("click", swallow, true);
        if (untilReleaseOf === null) {
            window.setTimeout(disarm, 0);
        } else {
            window.addEventListener("pointerup", released, true);
            window.addEventListener("pointerdown", disarm, true);
            window.addEventListener("blur", disarm);
        }
        disarmClick = disarm;
    };
    var listen = function() {
        window.addEventListener("pointermove", onMove, true);
        window.addEventListener("pointerup", onUp, true);
        window.addEventListener("pointercancel", onPointerCancel, true);
        window.addEventListener("blur", cancel);
    };
    var stopListening = function() {
        window.removeEventListener("pointermove", onMove, true);
        window.removeEventListener("pointerup", onUp, true);
        window.removeEventListener("pointercancel", onPointerCancel, true);
        captureNode.removeEventListener("lostpointercapture", onLostCapture);
        window.removeEventListener("keydown", onKey, true);
        window.removeEventListener("keyup", onKey, true);
        window.removeEventListener("wheel", onWheel, true);
        document.removeEventListener("selectstart", onSelectStart, true);
        window.removeEventListener("blur", cancel);
    };
    var finish2 = function() {
        var holdClicksFor = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, released = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var _ended_host;
        var ended = active;
        active = null;
        stopListening();
        setCursor(null);
        if (ended && !released) (_ended_host = ended.host) === null || _ended_host === void 0 ? void 0 : _ended_host.cancel();
        if (ended) {
            var _store_getTarget;
            swallowClick(holdClicksFor);
            try {
                var _captureNode_hasPointerCapture;
                if ((_captureNode_hasPointerCapture = captureNode.hasPointerCapture) === null || _captureNode_hasPointerCapture === void 0 ? void 0 : _captureNode_hasPointerCapture.call(captureNode, ended.pointerId)) {
                    captureNode.releasePointerCapture(ended.pointerId);
                }
            } catch (e) {}
            (_store_getTarget = store.getTarget()) === null || _store_getTarget === void 0 ? void 0 : _store_getTarget.clear();
        }
        store.end();
    };
    controllers.set(store, {
        press: function(e, describe) {
            if (active) return;
            stopListening();
            pending = {
                pointerId: e.pointerId,
                x: e.clientX,
                y: e.clientY,
                describe: describe
            };
            listen();
        },
        owns: function() {
            return pending !== null || active !== null;
        }
    });
    return function() {
        cancel();
        disarmClick === null || disarmClick === void 0 ? void 0 : disarmClick();
        if (controllers.get(store)) controllers.delete(store);
    };
};
// src/components/Planner/sidebar/LibraryBrowser.tsx
import { Fragment as Fragment11, jsx as jsx24, jsxs as jsxs17 } from "react/jsx-runtime";
var LIBRARY_READ_FAILED_MESSAGE = "The equipment library could not be loaded. Try again shortly.";
var Wrapper = styled19.div(_templateObject88());
var Results = styled19.div(_templateObject89(), function(param) {
    var t = param.theme;
    return t.spacing[4];
});
var StatusMessage = styled19.div(_templateObject90(), function(param) {
    var t = param.theme;
    return "".concat(t.spacing[3], " ").concat(t.spacing[4]);
}, function(param) {
    var t = param.theme;
    return t.fontSize.sm.size;
}, function(param) {
    var t = param.theme;
    return t.colors.neutral[600];
});
var Card2 = styled19.div(_templateObject91(), function(param) {
    var t = param.theme;
    return t.spacing[0.5];
}, function(param) {
    var t = param.theme;
    return "".concat(t.spacing[2], " ").concat(t.spacing[2.5]);
}, function(param) {
    var t = param.theme;
    return "0 ".concat(t.spacing[2], " ").concat(t.spacing[1.5]);
}, function(param) {
    var t = param.theme;
    return t.colors.neutral[400];
}, function(param) {
    var t = param.theme;
    return t.colors.white;
}, function(param) {
    var t = param.theme;
    return t.transitions.fast;
}, function(param) {
    var t = param.theme;
    return t.colors.brand[400];
}, function(param) {
    var t = param.theme;
    return t.shadows.sm;
});
var LIBRARY_SEARCH_RESULT_CAP = 300;
var labelFor = function(labels, a) {
    var _labels_get;
    return (_labels_get = labels.get(a.entity_bid)) !== null && _labels_get !== void 0 ? _labels_get : a.model_name;
};
var matchesQuery = function(a, label, q) {
    var _a_equipment_type, _a_equipment_subcategory, _a_sku, /*
 * `equipment_variation` — the FINEST level of the taxonomy, and the one almost every product
 * actually sits at (4,547 of 4,827 staging rows). It was missing beside the three columns above
 * for the same reason they each were once: the column reached `v_manufacturer_products` and
 * nothing here was told. So "leg press" found nothing in the Library while the match picker
 * two screens away narrowed on it — the same defect in adjacent code, fixed here rather than
 * filed (`match-review-filters`).
 */ _a_equipment_variation;
    var _a_equipment_type_toLowerCase_includes, _a_equipment_subcategory_toLowerCase_includes, _a_sku_toLowerCase_includes, _a_equipment_variation_toLowerCase_includes;
    return label.toLowerCase().includes(q) || a.manufacturer_name.toLowerCase().includes(q) || a.product_line.toLowerCase().includes(q) || ((_a_equipment_type_toLowerCase_includes = (_a_equipment_type = a.equipment_type) === null || _a_equipment_type === void 0 ? void 0 : _a_equipment_type.toLowerCase().includes(q)) !== null && _a_equipment_type_toLowerCase_includes !== void 0 ? _a_equipment_type_toLowerCase_includes : false) || ((_a_equipment_subcategory_toLowerCase_includes = (_a_equipment_subcategory = a.equipment_subcategory) === null || _a_equipment_subcategory === void 0 ? void 0 : _a_equipment_subcategory.toLowerCase().includes(q)) !== null && _a_equipment_subcategory_toLowerCase_includes !== void 0 ? _a_equipment_subcategory_toLowerCase_includes : false) || ((_a_sku_toLowerCase_includes = (_a_sku = a.sku) === null || _a_sku === void 0 ? void 0 : _a_sku.toLowerCase().includes(q)) !== null && _a_sku_toLowerCase_includes !== void 0 ? _a_sku_toLowerCase_includes : false) || ((_a_equipment_variation_toLowerCase_includes = (_a_equipment_variation = a.equipment_variation) === null || _a_equipment_variation === void 0 ? void 0 : _a_equipment_variation.toLowerCase().includes(q)) !== null && _a_equipment_variation_toLowerCase_includes !== void 0 ? _a_equipment_variation_toLowerCase_includes : false);
};
var libraryCardPayload = function(asset) {
    return JSON.stringify({
        product: asset.model_name,
        productLine: asset.product_line,
        manufacturer: asset.manufacturer_name,
        referenceId: asset.reference_id
    });
};
var LibraryCard = memo(function LibraryCard2(param) {
    var asset = param.asset, label = param.label;
    var dragStore = useEquipmentDragStore();
    var pointer = useEquipmentPointerSource(dragStore);
    var describe = function() {
        var _flatShareFilename;
        return {
            payload: libraryCardPayload(asset),
            drag: {
                title: label,
                glyph: kindGlyphName("item"),
                moving: false,
                // The catalogue's model, which a placement of this product gets (`floor-plan-machine-carry`).
                model: (_flatShareFilename = flatShareFilename(asset.model_file)) !== null && _flatShareFilename !== void 0 ? _flatShareFilename : void 0
            }
        };
    };
    return /* @__PURE__ */ jsxs17(Card2, {
        draggable: true,
        title: "".concat(asset.manufacturer_name, " \xb7 ").concat(label),
        onPointerDown: function(e) {
            return pointer.onPointerDown(e, describe);
        },
        onDragEnd: function() {
            return dragStore === null || dragStore === void 0 ? void 0 : dragStore.end();
        },
        onDragStart: function(e) {
            if (pointer.guardDragStart(e)) return;
            var _describe = describe(), payload = _describe.payload, drag = _describe.drag;
            e.dataTransfer.setData("application/json", payload);
            e.dataTransfer.effectAllowed = "copy";
            beginEquipmentDrag(e, dragStore, drag);
        },
        children: [
            /* @__PURE__ */ jsx24(ProductName, {
                children: label
            }),
            asset.product_line ? /* @__PURE__ */ jsx24(ProductMeta, {
                children: asset.product_line
            }) : null
        ]
    });
});
function LibraryBrowser(param) {
    var apiBaseUrl = param.apiBaseUrl, getAccessToken = param.getAccessToken;
    var catalog = useManufacturerCatalogStore(function(s) {
        return s.rows;
    });
    var status = useManufacturerCatalogStore(function(s) {
        return s.status;
    });
    var loadCatalog = useManufacturerCatalogStore(function(s) {
        return s.load;
    });
    var isLoading = status === "loading";
    var error = status === "error" ? LIBRARY_READ_FAILED_MESSAGE : null;
    var _useState19 = _sliced_to_array(useState19(""), 2), query = _useState19[0], setQuery = _useState19[1];
    var _useState191 = _sliced_to_array(useState19(/* @__PURE__ */ new Set()), 2), expandedGroups = _useState191[0], setExpandedGroups = _useState191[1];
    var _useState192 = _sliced_to_array(useState19(/* @__PURE__ */ new Set()), 2), expandedLines = _useState192[0], setExpandedLines = _useState192[1];
    useEffect19(function() {
        if (!getAccessToken) return;
        void loadCatalog(apiBaseUrl, getAccessToken);
    }, [
        apiBaseUrl,
        getAccessToken,
        loadCatalog
    ]);
    var q = query.trim().toLowerCase();
    var _useMemo12 = useMemo12(function() {
        var projected = catalog.map(function(a) {
            return _object_spread_props(_object_spread({}, a), {
                manufacturer_name: toDisplayManufacturer(a.manufacturer_name)
            });
        });
        return {
            rows: projected,
            labels: catalogueDisplayNames(projected.map(function(r) {
                return {
                    id: r.entity_bid,
                    product: r.model_name,
                    manufacturer: r.manufacturer_name,
                    productLine: r.product_line,
                    equipmentType: r.equipment_type,
                    equipmentSubcategory: r.equipment_subcategory,
                    sku: r.sku
                };
            }))
        };
    }, [
        catalog
    ]), visible = _useMemo12.rows, labels = _useMemo12.labels;
    var _useMemo121 = useMemo12(function() {
        var matched = q ? visible.filter(function(a) {
            return matchesQuery(a, labelFor(labels, a), q);
        }) : visible;
        var grouped = groupSiteAssets(matched);
        var i = grouped.findIndex(function(g) {
            return g.manufacturer === GENERIC_GROUP;
        });
        var ordered = i <= 0 ? grouped : [
            grouped[i]
        ].concat(_to_consumable_array(grouped.slice(0, i)), _to_consumable_array(grouped.slice(i + 1)));
        if (!q || matched.length <= LIBRARY_SEARCH_RESULT_CAP) {
            return {
                groups: ordered,
                matchCount: matched.length,
                shownCount: matched.length
            };
        }
        var budget = LIBRARY_SEARCH_RESULT_CAP;
        var capped = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = ordered[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var group = _step.value;
                if (budget <= 0) break;
                var productLines = [];
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = group.productLines[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var pl = _step1.value;
                        if (budget <= 0) break;
                        var assets = pl.assets.slice(0, budget);
                        budget -= assets.length;
                        if (assets.length > 0) productLines.push(_object_spread_props(_object_spread({}, pl), {
                            assets: assets
                        }));
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                if (productLines.length > 0) capped.push(_object_spread_props(_object_spread({}, group), {
                    productLines: productLines
                }));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return {
            groups: capped,
            matchCount: matched.length,
            shownCount: LIBRARY_SEARCH_RESULT_CAP
        };
    }, [
        labels,
        visible,
        q
    ]), groups = _useMemo121.groups, matchCount = _useMemo121.matchCount, shownCount = _useMemo121.shownCount;
    var forceExpand = q.length > 0;
    return /* @__PURE__ */ jsxs17(Wrapper, {
        children: [
            /* @__PURE__ */ jsx24(SidebarSearchSlot, {
                children: /* @__PURE__ */ jsx24(Search2, {
                    size: "sm",
                    "aria-label": "Search the library",
                    placeholder: "Search the library...",
                    value: query,
                    onChange: setQuery
                })
            }),
            /* @__PURE__ */ jsx24(Results, {
                children: isLoading ? /* @__PURE__ */ jsx24(StatusMessage, {
                    children: "Loading library\u2026"
                }) : error ? /* @__PURE__ */ jsx24(StatusMessage, {
                    children: error
                }) : groups.length === 0 ? /* @__PURE__ */ jsx24(StatusMessage, {
                    children: q ? "No matches." : "The library is empty."
                }) : /* @__PURE__ */ jsxs17(Fragment11, {
                    children: [
                        matchCount > shownCount && /*
       * The TRUE match count, not the rendered one. A cap that quietly showed 300 of 4,000
       * would be the same lie as a search that quietly did not look at the SKU — the
       * operator has to know their query is too broad to answer.
       */ /* @__PURE__ */ jsxs17(StatusMessage, {
                            role: "status",
                            children: [
                                "Showing ",
                                shownCount.toLocaleString(),
                                " of ",
                                matchCount.toLocaleString(),
                                " matches \u2014 refine your search."
                            ]
                        }),
                        groups.map(function(group) {
                            var open = forceExpand || expandedGroups.has(group.manufacturer);
                            return /* @__PURE__ */ jsxs17(SectionCard, {
                                children: [
                                    /* @__PURE__ */ jsxs17(SectionHeader, {
                                        onClick: function() {
                                            return toggleExpanded(setExpandedGroups)(group.manufacturer);
                                        },
                                        "aria-expanded": open,
                                        children: [
                                            /* @__PURE__ */ jsx24(ChevronIcon, {
                                                $expanded: open,
                                                children: /* @__PURE__ */ jsx24(ChevronRight24Regular2, {})
                                            }),
                                            /* @__PURE__ */ jsx24(ManufacturerName, {
                                                children: group.manufacturer
                                            })
                                        ]
                                    }),
                                    open && (group.manufacturer === GENERIC_GROUP ? /*
             * Generic renders FLAT — no product-line level (Rob, 2026-08-29, seeing it
             * rendered). Generic equipment has no product line: all 170 rows, from both
             * sources, carry an empty one, so a product-line level here can only ever be
             * a single `No Product Line` header standing between the operator and the
             * list. It is a group of products, and it reads as one.
             *
             * Derived from the heading, not carried on the group. The deleted
             * `LibraryGroup.isGeneric` flag was SET by a bespoke construction path that
             * built the Generic group by hand — which is what produced two sections
             * sharing a React key. The group is still built by `groupSiteAssets` like every
             * other; only its presentation differs, and only here.
             */ group.productLines.flatMap(function(pl) {
                                        return pl.assets;
                                    }).sort(function(x, y) {
                                        return labelFor(labels, x).localeCompare(labelFor(labels, y));
                                    }).map(function(a) {
                                        return /* @__PURE__ */ jsx24(LibraryCard, {
                                            asset: a,
                                            label: labelFor(labels, a)
                                        }, a.entity_bid);
                                    }) : group.productLines.map(function(pl) {
                                        var lineKey = "".concat(group.manufacturer, "::").concat(pl.productLine);
                                        var lineOpen = forceExpand || expandedLines.has(lineKey);
                                        return /* @__PURE__ */ jsxs17(ProductLineCard, {
                                            children: [
                                                /* @__PURE__ */ jsxs17(ProductLineHeader, {
                                                    onClick: function() {
                                                        return toggleExpanded(setExpandedLines)(lineKey);
                                                    },
                                                    "aria-expanded": lineOpen,
                                                    children: [
                                                        /* @__PURE__ */ jsx24(ChevronIcon, {
                                                            $expanded: lineOpen,
                                                            children: /* @__PURE__ */ jsx24(ChevronRight24Regular2, {})
                                                        }),
                                                        /* @__PURE__ */ jsx24(ProductLineName, {
                                                            children: pl.productLine
                                                        })
                                                    ]
                                                }),
                                                lineOpen && pl.assets.map(function(a) {
                                                    return /* @__PURE__ */ jsx24(LibraryCard, {
                                                        asset: a,
                                                        label: labelFor(labels, a)
                                                    }, a.entity_bid);
                                                })
                                            ]
                                        }, pl.productLine);
                                    }))
                                ]
                            }, group.manufacturer);
                        })
                    ]
                })
            })
        ]
    });
}
// src/components/Planner/sidebar/PlanCapacityHierarchy.tsx
import { useCallback as useCallback9, useContext as useContext13, useMemo as useMemo14, useRef as useRef20 } from "react";
import styled21 from "styled-components";
import { Banner as Banner2, Button as Button9, Dot } from "@repo/design-system";
import { semantic as semantic7, space as space12, typeRole as typeRole7 } from "@repo/design-tokens";
import { useEquipmentCatalogStore as useEquipmentCatalogStore8 } from "@repo/front-end-state";
// src/components/Planner/sidebar/PlanHierarchy.tsx
import { useCallback as useCallback8, useContext as useContext12, useEffect as useEffect20, useMemo as useMemo13, useRef as useRef19, useState as useState20 } from "react";
import styled20 from "styled-components";
import { semantic as semantic6, space as space11, typeRole as typeRole6 } from "@repo/design-tokens";
import { selectEntityOnFloor, useEditorStore as useEditorStore23, useFloorplanStore as useFloorplanStore30, selectionOnFloorShown as selectionOnFloorShown4 } from "@repo/front-end-state";
import { asArray as asArray2, floorIdFromTargetRefid, floorTargetRefid as floorTargetRefid2, isLive as isLive3, itemDisplayName as itemDisplayName2, layoutCurrentDesigns as layoutCurrentDesigns2, resolvePlanParentage as resolvePlanParentage2, surfaceDisplayName } from "@repo/front-end-utils";
import { jsx as jsx25, jsxs as jsxs18 } from "react/jsx-runtime";
var PLAN_LABELS = {
    surface: surfaceDisplayName,
    item: itemDisplayName2
};
var liveEntities = function(design) {
    return {
        surfaces: asArray2(design === null || design === void 0 ? void 0 : design.surfaces).filter(isLive3),
        items: asArray2(design === null || design === void 0 ? void 0 : design.items).filter(isLive3)
    };
};
var hierarchySignature = function(layout) {
    if (!layout) return null;
    var designs = layoutCurrentDesigns2(layout);
    return asArray2(layout.floors).map(function(floor, index) {
        var _liveEntities = liveEntities(designs[index]), surfaces = _liveEntities.surfaces, items = _liveEntities.items;
        var parentage = resolvePlanParentage2(designs[index]);
        var _floor_name;
        return [
            "".concat(floor === null || floor === void 0 ? void 0 : floor.id, "\x01").concat((_floor_name = floor === null || floor === void 0 ? void 0 : floor.name) !== null && _floor_name !== void 0 ? _floor_name : "")
        ].concat(_to_consumable_array(surfaces.map(function(s) {
            var _parentage_surface;
            var _parentage_surface_effectiveParent, _s_entityCode;
            return [
                s.refid,
                (_parentage_surface_effectiveParent = (_parentage_surface = parentage.surface(s.refid)) === null || _parentage_surface === void 0 ? void 0 : _parentage_surface.effectiveParent) !== null && _parentage_surface_effectiveParent !== void 0 ? _parentage_surface_effectiveParent : "",
                surfaceDisplayName(s),
                (_s_entityCode = s.entityCode) !== null && _s_entityCode !== void 0 ? _s_entityCode : ""
            ].join("");
        })), [
            ""
        ], _to_consumable_array(items.map(function(i) {
            var _parentage_item;
            var _parentage_item_effectiveParent, _i_entityCode;
            return [
                i.refid,
                (_parentage_item_effectiveParent = (_parentage_item = parentage.item(i)) === null || _parentage_item === void 0 ? void 0 : _parentage_item.effectiveParent) !== null && _parentage_item_effectiveParent !== void 0 ? _parentage_item_effectiveParent : "",
                itemDisplayName2(i),
                (_i_entityCode = i.entityCode) !== null && _i_entityCode !== void 0 ? _i_entityCode : ""
            ].join("");
        }))).join("");
    }).join("");
};
var collectOpenable = function(nodes, into) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var node = _step.value;
            if (node.kind !== "item") into.push(node.refid);
            collectOpenable(node.children, into);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return into;
};
var collectFloorOf = function(nodes, index, into) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var node = _step.value;
            into.set(node.refid, index);
            collectFloorOf(node.children, index, into);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};
function usePlanRowSelect(floors, floorOf2, announce) {
    var floorsRef = useRef19(floors);
    floorsRef.current = floors;
    var floorOfRef = useRef19(floorOf2);
    floorOfRef.current = floorOf2;
    return useCallback8(function(refid, kind) {
        var index = floorOfRef.current.get(refid);
        var sayFloor = function() {
            var _floorsRef_current;
            var floor = (_floorsRef_current = floorsRef.current) === null || _floorsRef_current === void 0 ? void 0 : _floorsRef_current.find(function(f) {
                return f.index === index;
            });
            if (floor) announce("Showing ".concat(floor.node.label));
        };
        if (kind === "floor") {
            var plan = useFloorplanStore30.getState();
            if (index !== void 0 && index !== plan.activeFloorIndex) {
                plan.setActiveFloor(index);
                sayFloor();
            }
            var floorId = floorIdFromTargetRefid(refid);
            if (floorId === null) useEditorStore23.getState().clearSelection();
            else useEditorStore23.getState().selectFloor(floorId);
            return;
        }
        if (selectEntityOnFloor(refid, index)) sayFloor();
    }, [
        announce
    ]);
}
function PlanHierarchy(param) {
    var rowSlots = param.rowSlots, rowSlotsFor = param.rowSlotsFor;
    var _floors_find;
    var layout = useContext12(PlannerLayoutContext);
    var activeFloorIndex = useFloorplanStore30(function(s) {
        return s.activeFloorIndex;
    });
    var selectedEntityIds = useEditorStore23(selectionOnFloorShown4);
    var selectedFloorId = useEditorStore23(function(s) {
        return s.selectedFloorId;
    });
    var _useAnnouncer = _sliced_to_array(useAnnouncer(), 2), said = _useAnnouncer[0], announce = _useAnnouncer[1];
    useEffect20(function() {
        return function() {
            return useEditorStore23.getState().selectFloor(null);
        };
    }, []);
    var signature = hierarchySignature(layout);
    var layoutRef = useRef19(layout);
    layoutRef.current = layout;
    var floors = useMemo13(function() {
        var plan = layoutRef.current;
        if (!plan) return null;
        var designs = layoutCurrentDesigns2(plan);
        return asArray2(plan.floors).flatMap(function(floor, index) {
            if (!floor) return [];
            var _liveEntities = liveEntities(designs[index]), surfaces = _liveEntities.surfaces, items = _liveEntities.items;
            return [
                {
                    index: index,
                    node: {
                        refid: floorTargetRefid2(floor.id),
                        kind: "floor",
                        label: floor.name,
                        children: buildHierarchyTree(surfaces, items, PLAN_LABELS, resolvePlanParentage2(designs[index]))
                    }
                }
            ];
        });
    }, [
        signature
    ]);
    var _useMemo13 = useMemo13(function() {
        var floorOf3 = /* @__PURE__ */ new Map();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = (floors !== null && floors !== void 0 ? floors : [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var floor = _step.value;
                floorOf3.set(floor.node.refid, floor.index);
                collectFloorOf(floor.node.children, floor.index, floorOf3);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return {
            openable: collectOpenable((floors !== null && floors !== void 0 ? floors : []).map(function(f) {
                return f.node;
            }), []),
            floorOf: floorOf3
        };
    }, [
        floors
    ]), openable = _useMemo13.openable, floorOf2 = _useMemo13.floorOf;
    var _useState20 = _sliced_to_array(useState20(function() {
        return /* @__PURE__ */ new Set();
    }), 2), collapsed = _useState20[0], setCollapsed = _useState20[1];
    var expanded = useMemo13(function() {
        return new Set(openable.filter(function(id) {
            return !collapsed.has(id);
        }));
    }, [
        openable,
        collapsed
    ]);
    var toggle = useCallback8(function(refid) {
        return setCollapsed(function(prev) {
            var next = new Set(prev);
            if (next.has(refid)) next.delete(refid);
            else next.add(refid);
            return next;
        });
    }, []);
    var fromTree = useMemo13(function() {
        return rowSlotsFor && floors ? rowSlotsFor(floors.map(function(floor) {
            return floor.node;
        })) : void 0;
    }, [
        floors,
        rowSlotsFor
    ]);
    var slots = fromTree !== null && fromTree !== void 0 ? fromTree : rowSlots;
    var selectedIds = useMemo13(function() {
        return new Set(selectedFloorId === null ? selectedEntityIds : _to_consumable_array(selectedEntityIds).concat([
            floorTargetRefid2(selectedFloorId)
        ]));
    }, [
        selectedEntityIds,
        selectedFloorId
    ]);
    var _floors_find_node_refid;
    var activeFloorRefid = (_floors_find_node_refid = floors === null || floors === void 0 ? void 0 : (_floors_find = floors.find(function(floor) {
        return floor.index === activeFloorIndex;
    })) === null || _floors_find === void 0 ? void 0 : _floors_find.node.refid) !== null && _floors_find_node_refid !== void 0 ? _floors_find_node_refid : null;
    var select = usePlanRowSelect(floors, floorOf2, announce);
    if (!floors) {
        return /* @__PURE__ */ jsx25(Wrapper2, {
            children: /* @__PURE__ */ jsx25(Message, {
                children: "Plan not loaded yet"
            })
        });
    }
    var nothingPlaced = floors.every(function(floor) {
        return floor.node.children.length === 0;
    });
    return /* @__PURE__ */ jsxs18(Wrapper2, {
        "data-plan-hierarchy": "",
        children: [
            floors.length > 0 && /* @__PURE__ */ jsx25(HierarchyTreeRows, {
                nodes: floors.map(function(floor) {
                    return floor.node;
                }),
                depth: 0,
                expanded: expanded,
                selectedIds: selectedIds,
                currentId: activeFloorRefid,
                rowSlots: slots,
                announceSelected: true,
                onToggle: toggle,
                onSelect: select
            }),
            nothingPlaced && /* @__PURE__ */ jsx25(Message, {
                children: "Nothing placed yet"
            }),
            /* @__PURE__ */ jsx25("span", {
                role: "status",
                "aria-live": "polite",
                "aria-atomic": "true",
                style: visuallyHidden,
                children: said
            })
        ]
    });
}
var Wrapper2 = styled20.div(_templateObject92(), space11[2], space11[3]);
var Message = styled20.p(_templateObject93(), space11[2], space11[1], typeRole6.caption1, semantic6.text.secondary);
// src/components/Planner/sidebar/planCapacity.ts
import { asArray as asArray3, floorTargetRefid as floorTargetRefid3, layoutCurrentDesigns as layoutCurrentDesigns3, registerCapacityLookup as registerCapacityLookup2, resolvePlanCapacity as resolvePlanCapacity3 } from "@repo/front-end-utils";
var planCapacityLookup = function(layout, registerRows, machinesKnown) {
    var capacity = resolvePlanCapacity3(layout, registerCapacityLookup2(registerRows, machinesKnown));
    var areas = /* @__PURE__ */ new Map();
    var machines = /* @__PURE__ */ new Map();
    if (layout) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = layoutCurrentDesigns3(layout)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var design = _step.value;
                var _liveEntities = liveEntities(design), surfaces = _liveEntities.surfaces, items = _liveEntities.items;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = surfaces[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var surface11 = _step1.value;
                        if (!areas.has(surface11.refid)) areas.set(surface11.refid, capacity.surface(surface11.refid));
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                try {
                    for(var _iterator2 = items[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                        var item = _step2.value;
                        var _capacity_item;
                        if (!machines.has(item.refid)) machines.set(item.refid, (_capacity_item = capacity.item(item)) === null || _capacity_item === void 0 ? void 0 : _capacity_item.value);
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                            _iterator2.return();
                        }
                    } finally{
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    var floors = /* @__PURE__ */ new Map();
    var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
    try {
        for(var _iterator3 = asArray3(layout === null || layout === void 0 ? void 0 : layout.floors)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
            var floor = _step3.value;
            if (floor) floors.set(floorTargetRefid3(floor.id), capacity.floor(floor.id));
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                _iterator3.return();
            }
        } finally{
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }
    return {
        areas: areas,
        machines: machines,
        floors: floors
    };
};
var rowBalance = function(resolved, hasChildren) {
    var own = resolved === null || resolved === void 0 ? void 0 : resolved.value;
    if (own === "unknown") return {
        kind: "unread"
    };
    if (own === void 0 || !hasChildren) return {
        kind: "none",
        own: own
    };
    var contents = resolved === null || resolved === void 0 ? void 0 : resolved.contents;
    if (contents === void 0) return {
        kind: "none",
        own: own
    };
    if (contents === "unknown") return {
        kind: "unknown",
        own: own
    };
    if (resolved && resolved.missing > 0) {
        return {
            kind: "incomplete",
            own: own,
            missing: resolved.missing
        };
    }
    if ((resolved === null || resolved === void 0 ? void 0 : resolved.source) === "calculated" || own === contents) {
        return {
            kind: "equal",
            own: own,
            contents: contents
        };
    }
    return own < contents ? {
        kind: "under",
        own: own,
        contents: contents
    } : {
        kind: "over",
        own: own,
        contents: contents
    };
};
var keyOf = function(resolved) {
    var _resolved_contents;
    return resolved ? [
        resolved.value,
        resolved.source,
        (_resolved_contents = resolved.contents) !== null && _resolved_contents !== void 0 ? _resolved_contents : "",
        resolved.missing
    ].join(":") : "";
};
var capacitySignature = function(lookup, wording) {
    return [
        wording
    ].concat(_to_consumable_array(Array.from(lookup.floors, function(param) {
        var _param = _sliced_to_array(param, 2), refid = _param[0], resolved = _param[1];
        return "".concat(refid, "=").concat(keyOf(resolved));
    })), [
        ""
    ], _to_consumable_array(Array.from(lookup.areas, function(param) {
        var _param = _sliced_to_array(param, 2), refid = _param[0], resolved = _param[1];
        return "".concat(refid, "=").concat(keyOf(resolved));
    })), [
        ""
    ], _to_consumable_array(Array.from(lookup.machines, function(param) {
        var _param = _sliced_to_array(param, 2), refid = _param[0], value = _param[1];
        return "".concat(refid, "=").concat(value !== null && value !== void 0 ? value : "");
    }))).join("");
};
// src/components/Planner/sidebar/PlanCapacityHierarchy.tsx
import { Fragment as Fragment12, jsx as jsx26, jsxs as jsxs19 } from "react/jsx-runtime";
var WORD = {
    under: "Under",
    over: "Over",
    equal: "Equal to contents"
};
var CAPACITY_BALANCE_DOT = {
    under: semantic7.status.roles.problem.mark,
    over: semantic7.status.roles.information.mark
};
var EMPTY2 = {
    slotKey: ""
};
var parentSlots = function(balance, readState) {
    if (balance.kind === "unread") return unknownSlots(readState);
    if (balance.kind === "none") {
        return typeof balance.own === "number" ? {
            details: /* @__PURE__ */ jsxs19(CapacityLine, {
                children: [
                    "Capacity ",
                    balance.own
                ]
            }),
            slotKey: "area|none|".concat(balance.own)
        } : EMPTY2;
    }
    return balancedSlots(balance, readState);
};
var balancedSlots = function(balance, readState) {
    var capacity = "Capacity ".concat(balance.own);
    var word = balance.kind in WORD ? WORD[balance.kind] : void 0;
    var dot = balance.kind in WORD ? CAPACITY_BALANCE_DOT[balance.kind] : void 0;
    var line3;
    switch(balance.kind){
        case "under":
        case "over":
            line3 = /* @__PURE__ */ jsxs19(Fragment12, {
                children: [
                    capacity,
                    " \xB7 ",
                    word,
                    ": contents total ",
                    balance.contents
                ]
            });
            break;
        case "equal":
            line3 = /* @__PURE__ */ jsxs19(Fragment12, {
                children: [
                    capacity,
                    " \xB7 ",
                    word
                ]
            });
            break;
        case "incomplete":
            line3 = "".concat(capacity, " \xb7 ").concat(balance.missing, " without capacity");
            break;
        case "unknown":
            line3 = readState === "loading" ? "".concat(capacity, " \xb7 Checking machine capacities") : "".concat(capacity, " \xb7 Machine capacities unavailable");
            break;
    }
    var marker = dot && word ? /* @__PURE__ */ jsx26(Dot, {
        className: "kind-dot",
        label: word,
        labelHidden: true,
        color: dot
    }) : void 0;
    var contents = "contents" in balance ? balance.contents : "";
    var missing = "missing" in balance ? balance.missing : "";
    return {
        marker: marker,
        details: /* @__PURE__ */ jsx26(CapacityLine, {
            children: line3
        }),
        slotKey: [
            "area",
            balance.kind,
            balance.own,
            contents,
            missing,
            readState
        ].join("|")
    };
};
var unknownSlots = function(readState) {
    var line3 = readState === "loading" ? "Checking machine capacities" : "Machine capacities unavailable";
    return {
        details: /* @__PURE__ */ jsx26(CapacityLine, {
            children: line3
        }),
        slotKey: "area|unknown|".concat(readState)
    };
};
var machineSlots = function(value) {
    return typeof value === "number" ? {
        details: /* @__PURE__ */ jsxs19(CapacityLine, {
            children: [
                "Capacity ",
                value
            ]
        }),
        slotKey: "item|".concat(value)
    } : EMPTY2;
};
function RegisterCapacityBanner(param) {
    var readState = param.readState, onRetry = param.onRetry, focusOnRetry = param.focusOnRetry;
    var retry = useCallback9(function() {
        var _focusOnRetry_current;
        (_focusOnRetry_current = focusOnRetry.current) === null || _focusOnRetry_current === void 0 ? void 0 : _focusOnRetry_current.focus();
        onRetry();
    }, [
        focusOnRetry,
        onRetry
    ]);
    return useMemo14(function() {
        return readState === "error" ? /* @__PURE__ */ jsx26(BannerSlot, {
            children: /* @__PURE__ */ jsxs19(Banner2, {
                tone: "error",
                title: "Can't read the asset register.",
                children: [
                    "Machine capacities aren't shown.",
                    " ",
                    /* @__PURE__ */ jsx26(Button9, {
                        variant: "ghost",
                        size: "xs",
                        onClick: retry,
                        "aria-label": "Try again: read the asset register",
                        children: "Try again"
                    })
                ]
            })
        }) : null;
    }, [
        readState,
        retry
    ]);
}
function PlanCapacityHierarchy(param) {
    var readState = param.readState, machinesKnown = param.machinesKnown, onRetry = param.onRetry;
    var layout = useContext13(PlannerLayoutContext);
    var registerRows = useEquipmentCatalogStore8(function(s) {
        return s.registerRows;
    });
    var lookup = planCapacityLookup(layout, registerRows, machinesKnown);
    var signature = capacitySignature(lookup, readState);
    var lookupRef = useRef20(lookup);
    lookupRef.current = lookup;
    var rowSlotsFor = useCallback9(function() {
        var current2 = lookupRef.current;
        return function(node) {
            var hasChildren = node.children.length > 0;
            if (node.kind === "surface") {
                return parentSlots(rowBalance(current2.areas.get(node.refid), hasChildren), readState);
            }
            if (node.kind === "floor") {
                return parentSlots(rowBalance(current2.floors.get(node.refid), hasChildren), readState);
            }
            return machineSlots(current2.machines.get(node.refid));
        };
    }, // Keyed on what the rows show — `signature` carries the read state too, which is the only
    // other thing `parentSlots` reads.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        signature
    ]);
    var regionRef = useRef20(null);
    var banner = /* @__PURE__ */ jsx26(RegisterCapacityBanner, {
        readState: readState,
        onRetry: onRetry,
        focusOnRetry: regionRef
    });
    return /* @__PURE__ */ jsxs19(Region, {
        ref: regionRef,
        tabIndex: -1,
        role: "group",
        "aria-label": "Plan hierarchy",
        children: [
            banner,
            /* @__PURE__ */ jsx26(PlanHierarchy, {
                rowSlotsFor: rowSlotsFor
            })
        ]
    });
}
var CapacityLine = styled21.span(_templateObject94(), typeRole7.caption1, semantic7.text.secondary);
var Region = styled21.div(_templateObject95());
var BannerSlot = styled21.div(_templateObject96(), space12[2], space12[3]);
// src/components/Planner/sidebar/PlanStepHierarchy.tsx
import { useCallback as useCallback11, useContext as useContext14, useEffect as useEffect22, useMemo as useMemo15, useRef as useRef22, useState as useState22 } from "react";
import styled22 from "styled-components";
import { Switch as Switch2 } from "@repo/design-system";
import { semantic as semantic8, space as space13, typeRole as typeRole8 } from "@repo/design-tokens";
import { useEditorStore as useEditorStore25, useEquipmentCatalogStore as useEquipmentCatalogStore9, useFloorplanStore as useFloorplanStore33, selectionOnFloorShown as selectionOnFloorShown5 } from "@repo/front-end-state";
import { asArray as asArray5, entityIdentityFor, floorTargetRefid as floorTargetRefid5, layoutCurrentDesigns as layoutCurrentDesigns5, resolvePlanHierarchy as resolvePlanHierarchy2, resolvePlanParentage as resolvePlanParentage4 } from "@repo/front-end-utils";
// src/components/Planner/sidebar/useTreeParentDrag.ts
import { useCallback as useCallback10, useEffect as useEffect21, useRef as useRef21, useState as useState21 } from "react";
import { useFloorplanStore as useFloorplanStore32 } from "@repo/front-end-state";
import { asArray as asArray4, floorIdFromTargetRefid as floorIdFromTargetRefid2, floorTargetRefid as floorTargetRefid4, isLive as isLive5, itemDisplayName as itemDisplayName3, layoutCurrentDesigns as layoutCurrentDesigns4, resolvePlanHierarchy, resolvePlanParentage as resolvePlanParentage3, surfaceDisplayName as surfaceDisplayName3 } from "@repo/front-end-utils";
// src/components/Planner/hooks/useParentChoice.ts
import { useEditorStore as useEditorStore24, useFloorplanStore as useFloorplanStore31 } from "@repo/front-end-state";
var pushUndoStep = function() {
    var layout = useFloorplanStore31.getState().layout;
    if (layout) useEditorStore24.getState().pushSnapshot(layout);
};
var writeParentFields = function(entity, fields) {
    var store = useFloorplanStore31.getState();
    var on = {
        floorIndex: entity.floorIndex
    };
    if (entity.surface) {
        store.updateSurface(entity.surface.refid, {
            parentSurfaceBid: fields.parent,
            parentChosen: fields.parentChosen,
            parentKeptOver: fields.parentKeptOver
        }, on);
        useEditorStore24.getState().markEntityModified(entity.surface.refid);
    } else if (entity.item) {
        store.updateItem(entity.item.refid, {
            parentSpaceBid: fields.parent,
            parentChosen: fields.parentChosen,
            parentKeptOver: fields.parentKeptOver
        }, on);
        useEditorStore24.getState().markEntityModified(entity.item.refid);
    }
};
var chooseParentFor = function(entity, param) {
    var value = param.value, current2 = param.current;
    if (value === (current2 !== null && current2 !== void 0 ? current2 : "")) return false;
    pushUndoStep();
    writeParentFields(entity, {
        parent: value || void 0,
        parentChosen: true,
        parentKeptOver: void 0
    });
    return true;
};
var restoreDrawnParentFor = function(entity, drawn) {
    pushUndoStep();
    writeParentFields(entity, {
        parent: drawn !== null && drawn !== void 0 ? drawn : void 0,
        parentChosen: void 0,
        parentKeptOver: void 0
    });
};
var keepChosenFor = function(entity, drawn) {
    var _entity_surface, _entity_item;
    pushUndoStep();
    var store = useFloorplanStore31.getState();
    var on = {
        floorIndex: entity.floorIndex
    };
    if (entity.surface) store.updateSurface(entity.surface.refid, {
        parentKeptOver: drawn
    }, on);
    else if (entity.item) store.updateItem(entity.item.refid, {
        parentKeptOver: drawn
    }, on);
    var _entity_surface_refid;
    var refid = (_entity_surface_refid = (_entity_surface = entity.surface) === null || _entity_surface === void 0 ? void 0 : _entity_surface.refid) !== null && _entity_surface_refid !== void 0 ? _entity_surface_refid : (_entity_item = entity.item) === null || _entity_item === void 0 ? void 0 : _entity_item.refid;
    if (refid) useEditorStore24.getState().markEntityModified(refid);
};
var useParentChoice = function(param) {
    var surface11 = param.surface, item = param.item, selectionKey = param.selectionKey, floorIndex = param.floorIndex;
    var updateSurface = useFloorplanStore31(function(s) {
        return s.updateSurface;
    });
    var updateItem = useFloorplanStore31(function(s) {
        return s.updateItem;
    });
    var markEntityModified = useEditorStore24(function(s) {
        return s.markEntityModified;
    });
    return function(param) {
        var value = param.value, current2 = param.current, snapshot = param.snapshot;
        if (value === (current2 !== null && current2 !== void 0 ? current2 : "")) return;
        snapshot();
        if (surface11) {
            updateSurface(surface11.refid, {
                parentSurfaceBid: value || void 0,
                parentChosen: true,
                parentKeptOver: void 0
            }, {
                floorIndex: floorIndex
            });
        } else if (item) {
            updateItem(item.refid, {
                parentSpaceBid: value || void 0,
                parentChosen: true,
                parentKeptOver: void 0
            }, {
                floorIndex: floorIndex
            });
        }
        if (selectionKey) markEntityModified(selectionKey);
    };
};
// src/components/Planner/parentChoices.ts
import { isLive as isLive4, kindOfLetter, letterOfCode, surfaceDisplayName as surfaceDisplayName2 } from "@repo/front-end-utils";
var parentChoices = function(param) {
    var design = param.design, floorName = param.floorName, parentage = param.parentage, hierarchy = param.hierarchy, surface11 = param.surface, item = param.item, _param_keepKind = param.keepKind, keepKind = _param_keepKind === void 0 ? false : _param_keepKind;
    var parentAnswer = surface11 ? parentage === null || parentage === void 0 ? void 0 : parentage.surface(surface11.refid) : item ? parentage === null || parentage === void 0 ? void 0 : parentage.item(item) : void 0;
    var seenRefids = /* @__PURE__ */ new Set();
    var _design_surfaces;
    var parentCandidates = ((_design_surfaces = design === null || design === void 0 ? void 0 : design.surfaces) !== null && _design_surfaces !== void 0 ? _design_surfaces : []).filter(function(s) {
        if (!isLive4(s) || !s.refid || seenRefids.has(s.refid)) return false;
        seenRefids.add(s.refid);
        return true;
    });
    var descendants = /* @__PURE__ */ new Set();
    if (surface11 && parentage) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = parentCandidates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var candidate = _step.value;
                var _parentage_surface;
                var _parentage_surface_effectiveParent;
                var cursor = (_parentage_surface_effectiveParent = (_parentage_surface = parentage.surface(candidate.refid)) === null || _parentage_surface === void 0 ? void 0 : _parentage_surface.effectiveParent) !== null && _parentage_surface_effectiveParent !== void 0 ? _parentage_surface_effectiveParent : null;
                while(cursor !== null){
                    var _parentage_surface1;
                    if (cursor === surface11.refid) {
                        descendants.add(candidate.refid);
                        break;
                    }
                    var _parentage_surface_effectiveParent1;
                    cursor = (_parentage_surface_effectiveParent1 = (_parentage_surface1 = parentage.surface(cursor)) === null || _parentage_surface1 === void 0 ? void 0 : _parentage_surface1.effectiveParent) !== null && _parentage_surface_effectiveParent1 !== void 0 ? _parentage_surface_effectiveParent1 : null;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    var parentLabels = /* @__PURE__ */ new Map();
    {
        var counts = /* @__PURE__ */ new Map();
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = parentCandidates[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var s = _step1.value;
                var name = surfaceDisplayName2(s);
                var _counts_get;
                counts.set(name, ((_counts_get = counts.get(name)) !== null && _counts_get !== void 0 ? _counts_get : 0) + 1);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        var seenNames = /* @__PURE__ */ new Map();
        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
        try {
            for(var _iterator2 = parentCandidates[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                var s1 = _step2.value;
                var name1 = surfaceDisplayName2(s1);
                var _seenNames_get;
                var nth = ((_seenNames_get = seenNames.get(name1)) !== null && _seenNames_get !== void 0 ? _seenNames_get : 0) + 1;
                seenNames.set(name1, nth);
                var _counts_get1;
                parentLabels.set(s1.refid, ((_counts_get1 = counts.get(name1)) !== null && _counts_get1 !== void 0 ? _counts_get1 : 0) > 1 ? "".concat(name1, " (").concat(s1.entityCode || nth, ")") : name1);
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                    _iterator2.return();
                }
            } finally{
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
    }
    var parentName2 = function(refid) {
        var _parentLabels_get;
        return refid === null ? "the floor" : (_parentLabels_get = parentLabels.get(refid)) !== null && _parentLabels_get !== void 0 ? _parentLabels_get : refid;
    };
    var kindOf2 = function(refid) {
        var answer = hierarchy === null || hierarchy === void 0 ? void 0 : hierarchy.surface(refid);
        var _answer_kind;
        return answer ? (_answer_kind = answer.kind) !== null && _answer_kind !== void 0 ? _answer_kind : answer.placeKind : null;
    };
    var ownLetter = keepKind && surface11 ? letterOfCode(surface11.entityCode) : null;
    var ownKind = ownLetter === null ? void 0 : kindOfLetter(ownLetter);
    var parentKindNeeded = ownLetter === null ? void 0 : ownKind === "zone" ? "floor" : ownKind === "section" ? "zone" : ownKind === "area" ? "section" : "none";
    var _parentAnswer_effectiveParent;
    var currentParent = (_parentAnswer_effectiveParent = parentAnswer === null || parentAnswer === void 0 ? void 0 : parentAnswer.effectiveParent) !== null && _parentAnswer_effectiveParent !== void 0 ? _parentAnswer_effectiveParent : null;
    var offersFloor = parentKindNeeded === void 0 ? !item || currentParent === null : parentKindNeeded === "floor" || currentParent === null;
    var parentOptions = _to_consumable_array(offersFloor ? [
        {
            value: "",
            label: "Floor — ".concat(floorName || "this floor")
        }
    ] : []).concat(_to_consumable_array(parentCandidates.filter(function(s) {
        return s.refid !== (surface11 === null || surface11 === void 0 ? void 0 : surface11.refid) && !descendants.has(s.refid);
    }).filter(function(s) {
        return !surface11 || s.refid === (parentAnswer === null || parentAnswer === void 0 ? void 0 : parentAnswer.effectiveParent) || (parentKindNeeded === void 0 ? kindOf2(s.refid) === "zone" || kindOf2(s.refid) === "section" : kindOf2(s.refid) === parentKindNeeded);
    }).map(function(s) {
        var kind = kindOf2(s.refid);
        return {
            value: s.refid,
            label: kind ? "".concat(parentName2(s.refid), " \xb7 ").concat(kind) : parentName2(s.refid)
        };
    })));
    var _parentAnswer_effectiveParent1, _parentAnswer_disagrees, _parentAnswer_spatialParent;
    return {
        current: (_parentAnswer_effectiveParent1 = parentAnswer === null || parentAnswer === void 0 ? void 0 : parentAnswer.effectiveParent) !== null && _parentAnswer_effectiveParent1 !== void 0 ? _parentAnswer_effectiveParent1 : null,
        disagrees: (_parentAnswer_disagrees = parentAnswer === null || parentAnswer === void 0 ? void 0 : parentAnswer.disagrees) !== null && _parentAnswer_disagrees !== void 0 ? _parentAnswer_disagrees : false,
        spatialParent: (_parentAnswer_spatialParent = parentAnswer === null || parentAnswer === void 0 ? void 0 : parentAnswer.spatialParent) !== null && _parentAnswer_spatialParent !== void 0 ? _parentAnswer_spatialParent : null,
        options: parentOptions,
        nameOf: parentName2
    };
};
// src/components/Planner/sidebar/hierarchyText.ts
var HIERARCHY_SHORT_WORDS = {
    "capacity-below-contents": function(check) {
        return check.fix.type === "capacity" && typeof check.fix.contents === "number" ? "less than ".concat(check.fix.contents) : "less than contents";
    },
    "capacity-contents-changed": function() {
        return "contents changed";
    },
    "parent-chosen-differs": function() {
        return "chosen parent";
    },
    "equipment-on-floor": function() {
        return "on the floor";
    },
    "machine-not-in-register": function() {
        return "not in register";
    },
    "machine-register-row-gone": function() {
        return "register row gone";
    },
    "capacity-missing": function() {
        return "no capacity";
    },
    "too-deep": function() {
        return "inside an area";
    },
    "letter-mismatch": function() {
        return "wrong letter";
    },
    "invalid-letter": function() {
        return "wrong letter";
    },
    "duplicate-bid": function() {
        return "BID repeated";
    },
    "duplicate-name": function() {
        return "name repeated";
    },
    "space-empty": function() {
        return "empty";
    }
};
var shortWordsFor = function(check) {
    var _HIERARCHY_SHORT_WORDS_check_code;
    var _HIERARCHY_SHORT_WORDS_check_code1;
    return (_HIERARCHY_SHORT_WORDS_check_code1 = (_HIERARCHY_SHORT_WORDS_check_code = HIERARCHY_SHORT_WORDS[check.code]) === null || _HIERARCHY_SHORT_WORDS_check_code === void 0 ? void 0 : _HIERARCHY_SHORT_WORDS_check_code.call(HIERARCHY_SHORT_WORDS, check)) !== null && _HIERARCHY_SHORT_WORDS_check_code1 !== void 0 ? _HIERARCHY_SHORT_WORDS_check_code1 : check.sentence;
};
var IDENTIFY_WORDS = "identify";
var CHOSEN_BY_HAND_WORDS = "chosen by hand";
var BID_AT_LAUNCH = "BID at Launch";
var treeHeader = function(floorName) {
    return "".concat(floorName, " \xb7 by kind, then name");
};
var PROBLEMS_ONLY = "Problems only";
var CHECKING_PLAN = "Checking the plan\u2026";
var CHECKS_UNAVAILABLE = "Checks are unavailable";
var CHECKING_CAPACITIES = "Checking machine capacities";
var noProblemsOn = function(floorName) {
    return "No problems on ".concat(floorName);
};
var showingProblems = function(floorName, on) {
    return on ? "Showing problems only on ".concat(floorName) : "Showing everything on ".concat(floorName);
};
var filedIn = function(name, parent) {
    return parent === null ? "".concat(name, " filed on the floor, chosen by hand") : "".concat(name, " filed in ").concat(parent, ", chosen by hand");
};
var cantGoThere = function(name) {
    return "".concat(name, " can't go there");
};
var noLongerOnPlan = function(name) {
    return "".concat(name, " is no longer on the plan");
};
// src/components/Planner/sidebar/useTreeParentDrag.ts
var startFor = function(refid) {
    var _useFloorplanStore32_getState = useFloorplanStore32.getState(), layout = _useFloorplanStore32_getState.layout, activeFloorIndex = _useFloorplanStore32_getState.activeFloorIndex;
    if (!layout) return null;
    var floor = asArray4(layout.floors)[activeFloorIndex];
    var design = layoutCurrentDesigns4(layout)[activeFloorIndex];
    if (!floor || !design) return null;
    var surface11 = asArray4(design.surfaces).find(function(s) {
        return s.refid === refid && isLive5(s);
    });
    var item = surface11 ? void 0 : asArray4(design.items).find(function(i) {
        return i.refid === refid && isLive5(i);
    });
    if (!surface11 && !item) return null;
    var choices = parentChoices({
        design: design,
        floorName: floor.name,
        parentage: resolvePlanParentage3(design),
        hierarchy: resolvePlanHierarchy(design),
        surface: surface11 !== null && surface11 !== void 0 ? surface11 : null,
        item: item !== null && item !== void 0 ? item : null,
        keepKind: true
    });
    var floorRow = floorTargetRefid4(floor.id);
    var allowed = new Set(choices.options.filter(function(o) {
        var _choices_current;
        return o.value !== ((_choices_current = choices.current) !== null && _choices_current !== void 0 ? _choices_current : "");
    }).map(function(o) {
        return o.value === "" ? floorRow : o.value;
    }));
    return {
        entity: surface11 ? {
            surface: surface11
        } : {
            item: item
        },
        name: surface11 ? surfaceDisplayName3(surface11) : itemDisplayName3(item),
        current: choices.current,
        allowed: allowed,
        floorRow: floorRow,
        nameOf: choices.nameOf
    };
};
var rowOf = function(target, within) {
    var _target_closest;
    if (!_instanceof(target, Element) || !(within === null || within === void 0 ? void 0 : within.contains(target))) return null;
    var _target_closest_dataset_refid;
    return (_target_closest_dataset_refid = (_target_closest = target.closest("[data-refid]")) === null || _target_closest === void 0 ? void 0 : _target_closest.dataset.refid) !== null && _target_closest_dataset_refid !== void 0 ? _target_closest_dataset_refid : null;
};
var rowUnder = function(evt, within) {
    return rowOf(evt === null || evt === void 0 ? void 0 : evt.target, within);
};
var rowAt = function(x, y, within) {
    return typeof document.elementFromPoint === "function" ? rowOf(document.elementFromPoint(x, y), within) : null;
};
function useTreeParentDrag(param) {
    var scrollRef = param.scrollRef, announce = param.announce;
    var _useState21 = _sliced_to_array(useState21(null), 2), state = _useState21[0], setState = _useState21[1];
    var live = useRef21(null);
    var stop = useRef21(null);
    var announceRef = useRef21(announce);
    announceRef.current = announce;
    var publish = function(next) {
        var prev = live.current;
        live.current = next;
        if (!next) {
            if (prev) setState(null);
            return;
        }
        document.body.style.cursor = next.over ? "grabbing" : "not-allowed";
        if (!prev || prev.over !== next.over || prev.refid !== next.refid) {
            setState({
                refid: next.refid,
                over: next.over
            });
        }
    };
    var _useState211 = _sliced_to_array(useState21(function() {
        return createEdgeScroller(function() {
            var drag = live.current;
            var el = scrollRef.current;
            return drag && el ? {
                el: el,
                y: drag.y
            } : null;
        }, // Each scroll frame moves the rows under a still pointer: mark what is under it now.
        function() {
            var drag = live.current;
            if (!drag) return;
            var under = rowAt(drag.x, drag.y, scrollRef.current);
            publish(_object_spread_props(_object_spread({}, drag), {
                over: under && drag.allowed.has(under) ? under : null
            }));
        });
    }), 1), scroller = _useState211[0];
    var finish2 = useCallback10(function() {
        scroller.stop();
        stop.current = null;
        document.body.style.removeProperty("cursor");
        document.body.style.removeProperty("user-select");
        publish(null);
    }, [
        scroller
    ]);
    var onMouseDown = function(e) {
        if (e.button !== 0 || e.ctrlKey || e.metaKey || stop.current) return;
        var refid = rowUnder(e.nativeEvent, scrollRef.current);
        if (!refid || floorIdFromTargetRefid2(refid) !== null) return;
        var from = {
            clientX: e.clientX,
            clientY: e.clientY
        };
        var begun = null;
        stop.current = startPointerGesture({
            native: e.nativeEvent,
            page: true,
            onMove: function(pointer, evt) {
                if (!begun && isClickRelease(from, {
                    clientX: pointer.x,
                    clientY: pointer.y
                })) return false;
                if (!begun) {
                    begun = startFor(refid);
                    if (!begun) return false;
                    document.body.style.userSelect = "none";
                }
                var under = rowUnder(evt, scrollRef.current);
                publish({
                    refid: refid,
                    over: under && begun.allowed.has(under) ? under : null,
                    allowed: begun.allowed,
                    x: pointer.x,
                    y: pointer.y
                });
                scroller.kick();
                return true;
            },
            onRelease: function(evt) {
                var _live_current;
                var start = begun;
                var _live_current_over;
                var under = evt ? rowUnder(evt, scrollRef.current) : (_live_current_over = (_live_current = live.current) === null || _live_current === void 0 ? void 0 : _live_current.over) !== null && _live_current_over !== void 0 ? _live_current_over : null;
                finish2();
                if (!start) return;
                var now = startFor(refid);
                if (!now) {
                    announceRef.current(noLongerOnPlan(start.name));
                    return;
                }
                if (!under || !start.allowed.has(under) || !now.allowed.has(under)) {
                    announceRef.current(cantGoThere(now.name));
                    return;
                }
                var value = under === now.floorRow ? "" : under;
                if (chooseParentFor(now.entity, {
                    value: value,
                    current: now.current
                })) {
                    announceRef.current(filedIn(now.name, value === "" ? null : now.nameOf(value)));
                }
            },
            onCancel: finish2
        });
    };
    useEffect21(function() {
        return function() {
            var _stop_current;
            (_stop_current = stop.current) === null || _stop_current === void 0 ? void 0 : _stop_current.call(stop);
            scroller.stop();
            document.body.style.removeProperty("cursor");
            document.body.style.removeProperty("user-select");
        };
    }, [
        scroller
    ]);
    return {
        drag: state,
        onMouseDown: onMouseDown
    };
}
// src/components/Planner/sidebar/PlanStepHierarchy.tsx
import { Fragment as Fragment13, jsx as jsx27, jsxs as jsxs20 } from "react/jsx-runtime";
var KIND_RANK = {
    zone: 0,
    section: 1,
    area: 2,
    none: 3,
    item: 4
};
var capacityOf = function(resolved, checks) {
    if (!resolved || resolved.value === "unknown") return void 0;
    var tone = checks.some(function(c) {
        return c.code === "capacity-below-contents";
    }) ? "error" : checks.some(function(c) {
        return c.code === "capacity-contents-changed";
    }) ? "warn" : "neutral";
    var source = resolved.source === "hand" ? "hand" : resolved.source === "calculated" ? "calculated" : "product";
    var _resolved_value;
    return {
        value: (_resolved_value = resolved.value) !== null && _resolved_value !== void 0 ? _resolved_value : null,
        source: source,
        tone: tone
    };
};
var machineCapacityOf = function(value) {
    if (value === "unknown" || value === void 0) return void 0;
    return {
        value: value,
        source: "product",
        tone: "neutral"
    };
};
var forcedWords = function(entity, own) {
    if (!entity.parentChosen) return void 0;
    var differs = own.findIndex(function(c) {
        return c.code === "parent-chosen-differs";
    });
    if (differs === -1) return CHOSEN_BY_HAND_WORDS;
    return differs === 0 ? void 0 : shortWordsFor(own[differs]);
};
var modelStateOf = function(checks) {
    return (checks === null || checks === void 0 ? void 0 : checks.failed) ? "failed" : (checks === null || checks === void 0 ? void 0 : checks.known) ? "ready" : "pending";
};
var rowFactsFor = function(floorRefid, floorId, design, checks, lookup) {
    var facts = /* @__PURE__ */ new Map();
    var ready = modelStateOf(checks) === "ready" && checks !== null;
    var marks = ready ? checks.marks(floorId) : void 0;
    var checksOf = function(entity, ref) {
        return ready ? checks.checksFor(floorId, entity, ref) : [];
    };
    var _liveEntities = liveEntities(design), surfaces = _liveEntities.surfaces, items = _liveEntities.items;
    var hierarchy = design ? resolvePlanHierarchy2(design) : null;
    var floorChecks = checksOf("floor", String(floorId));
    facts.set(floorRefid, _object_spread_props(_object_spread({}, ready ? {
        problem: floorChecks.length > 0,
        plainWords: floorChecks.length ? shortWordsFor(floorChecks[0]) : void 0
    } : {}), {
        capacity: capacityOf(lookup.floors.get(floorRefid), floorChecks)
    }));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = surfaces[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var s = _step.value;
            var _marks_spaces;
            if (facts.has(s.refid)) continue;
            var own = checksOf("surface", s.refid);
            var mark = marks === null || marks === void 0 ? void 0 : (_marks_spaces = marks.spaces) === null || _marks_spaces === void 0 ? void 0 : _marks_spaces.get(s.refid);
            var answer = hierarchy === null || hierarchy === void 0 ? void 0 : hierarchy.surface(s.refid);
            var _answer_kind;
            facts.set(s.refid, _object_spread_props(_object_spread({
                kind: answer ? (_answer_kind = answer.kind) !== null && _answer_kind !== void 0 ? _answer_kind : answer.placeKind : null
            }, ready ? {
                state: mark !== null && mark !== void 0 ? mark : "ok",
                words: own.length ? shortWordsFor(own[0]) : void 0
            } : {}), {
                plainWords: forcedWords(s, own),
                capacity: capacityOf(lookup.areas.get(s.refid), own)
            }));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = items[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var i = _step1.value;
            var _marks_machines;
            if (facts.has(i.refid)) continue;
            var own1 = checksOf("item", i.refid);
            var mark1 = marks === null || marks === void 0 ? void 0 : (_marks_machines = marks.machines) === null || _marks_machines === void 0 ? void 0 : _marks_machines.get(i.refid);
            facts.set(i.refid, _object_spread_props(_object_spread({}, ready ? {
                state: mark1 !== null && mark1 !== void 0 ? mark1 : "ok",
                words: own1.length ? shortWordsFor(own1[0]) : mark1 === "identify" ? IDENTIFY_WORDS : void 0
            } : {}), {
                plainWords: forcedWords(i, own1),
                capacity: machineCapacityOf(lookup.machines.get(i.refid))
            }));
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return facts;
};
var factsKey = function(facts) {
    return Array.from(facts, function(param) {
        var _param = _sliced_to_array(param, 2), refid = _param[0], f = _param[1];
        var _f_state, _f_words, _f_plainWords, _f_kind;
        return [
            refid,
            (_f_state = f.state) !== null && _f_state !== void 0 ? _f_state : "",
            (_f_words = f.words) !== null && _f_words !== void 0 ? _f_words : "",
            (_f_plainWords = f.plainWords) !== null && _f_plainWords !== void 0 ? _f_plainWords : "",
            f.problem ? "1" : "",
            (_f_kind = f.kind) !== null && _f_kind !== void 0 ? _f_kind : "",
            f.capacity ? "".concat(f.capacity.value, ":").concat(f.capacity.source, ":").concat(f.capacity.tone) : ""
        ].join("");
    }).join("");
};
var isProblem = function(state) {
    return state === "error" || state === "check" || state === "identify";
};
var keepProblems = function(nodes, stateOf) {
    return nodes.flatMap(function(node) {
        var children = keepProblems(node.children, stateOf);
        return isProblem(stateOf(node.refid)) || children.length > 0 ? [
            _object_spread_props(_object_spread({}, node), {
                children: children
            })
        ] : [];
    });
};
function PlanStepHierarchy(param) {
    var twinBid = param.twinBid, readState = param.readState, machinesKnown = param.machinesKnown, onRetry = param.onRetry, problemsOnly = param.problemsOnly, onProblemsOnlyChange = param.onProblemsOnlyChange;
    var _factsRef_current_get;
    var layout = useContext14(PlannerLayoutContext);
    var activeFloorIndex = useFloorplanStore33(function(s) {
        return s.activeFloorIndex;
    });
    var selectedEntityIds = useEditorStore25(selectionOnFloorShown5);
    var selectedFloorId = useEditorStore25(function(s) {
        return s.selectedFloorId;
    });
    var registerRows = useEquipmentCatalogStore9(function(s) {
        return s.registerRows;
    });
    var checks = usePlanChecksContext();
    var settled = usePlanChecksSettled();
    var hover = usePlannerHover();
    var _useAnnouncer = _sliced_to_array(useAnnouncer(), 2), said = _useAnnouncer[0], announce = _useAnnouncer[1];
    var treeRef = useRef22(null);
    var _useTreeParentDrag = useTreeParentDrag({
        scrollRef: treeRef,
        announce: announce
    }), drag = _useTreeParentDrag.drag, onMouseDown = _useTreeParentDrag.onMouseDown;
    var modelState = modelStateOf(checks);
    useEffect22(function() {
        return function() {
            return useEditorStore25.getState().selectFloor(null);
        };
    }, []);
    var floor = layout ? asArray5(layout.floors)[activeFloorIndex] : void 0;
    var design = layout ? layoutCurrentDesigns5(layout)[activeFloorIndex] : void 0;
    var floorRefid = floor ? floorTargetRefid5(floor.id) : "";
    var filtering = problemsOnly && modelState === "ready";
    var lookup = planCapacityLookup(layout, registerRows, machinesKnown);
    var facts = floor && design !== void 0 ? rowFactsFor(floorRefid, floor.id, design, checks, lookup) : /* @__PURE__ */ new Map();
    var _hierarchySignature;
    var signature = [
        (_hierarchySignature = hierarchySignature(layout)) !== null && _hierarchySignature !== void 0 ? _hierarchySignature : "",
        activeFloorIndex,
        capacitySignature(lookup, readState),
        factsKey(facts),
        twinBid !== null && twinBid !== void 0 ? twinBid : "",
        filtering ? "p" : ""
    ].join("");
    var layoutRef = useRef22(layout);
    layoutRef.current = layout;
    var factsRef = useRef22(facts);
    factsRef.current = facts;
    var tree = useMemo15(function() {
        var plan = layoutRef.current;
        if (!plan) return null;
        var floors = asArray5(plan.floors);
        var here = floors[activeFloorIndex];
        if (!here) return null;
        var floorDesign = layoutCurrentDesigns5(plan)[activeFloorIndex];
        var _liveEntities = liveEntities(floorDesign), surfaces = _liveEntities.surfaces, items = _liveEntities.items;
        var rankOf = function(node) {
            var _factsRef_current_get;
            if (node.kind === "item") return KIND_RANK.item;
            var kind = (_factsRef_current_get = factsRef.current.get(node.refid)) === null || _factsRef_current_get === void 0 ? void 0 : _factsRef_current_get.kind;
            return kind ? KIND_RANK[kind] : KIND_RANK.none;
        };
        var byKind = function(nodes) {
            return nodes.map(function(node, at3) {
                return {
                    node: node,
                    at: at3,
                    rank: rankOf(node)
                };
            }).sort(function(a, b) {
                return a.rank - b.rank || a.at - b.at;
            }).map(function(param) {
                var node = param.node;
                return _object_spread_props(_object_spread({}, node), {
                    code: node.kind === "floor" ? node.code : entityIdentityFor(twinBid, node.code) || BID_AT_LAUNCH,
                    children: byKind(node.children)
                });
            });
        };
        var root = {
            refid: floorTargetRefid5(here.id),
            kind: "floor",
            label: here.name,
            children: byKind(buildHierarchyTree(surfaces, items, PLAN_LABELS, floorDesign ? resolvePlanParentage4(floorDesign) : void 0))
        };
        var shown2 = filtering ? _object_spread_props(_object_spread({}, root), {
            children: keepProblems(root.children, function(refid) {
                var _factsRef_current_get;
                return (_factsRef_current_get = factsRef.current.get(refid)) === null || _factsRef_current_get === void 0 ? void 0 : _factsRef_current_get.state;
            })
        }) : root;
        return {
            index: activeFloorIndex,
            node: shown2
        };
    }, [
        signature
    ]);
    var _useMemo15 = useMemo15(function() {
        var floorOf3 = /* @__PURE__ */ new Map();
        if (tree) {
            floorOf3.set(tree.node.refid, tree.index);
            collectFloorOf(tree.node.children, tree.index, floorOf3);
        }
        return {
            openable: tree ? collectOpenable([
                tree.node
            ], []) : [],
            floorOf: floorOf3
        };
    }, [
        tree
    ]), openable = _useMemo15.openable, floorOf2 = _useMemo15.floorOf;
    var _useState22 = _sliced_to_array(useState22(function() {
        return /* @__PURE__ */ new Set();
    }), 2), collapsed = _useState22[0], setCollapsed = _useState22[1];
    var expanded = useMemo15(function() {
        return new Set(openable.filter(function(id) {
            return !collapsed.has(id);
        }));
    }, [
        openable,
        collapsed
    ]);
    var toggle = useCallback11(function(refid) {
        return setCollapsed(function(prev) {
            var next = new Set(prev);
            if (next.has(refid)) next.delete(refid);
            else next.add(refid);
            return next;
        });
    }, []);
    var select = usePlanRowSelect(tree ? [
        tree
    ] : null, floorOf2, announce);
    var selectedIds = useMemo15(function() {
        return new Set(selectedFloorId === null ? selectedEntityIds : _to_consumable_array(selectedEntityIds).concat([
            floorTargetRefid5(selectedFloorId)
        ]));
    }, [
        selectedEntityIds,
        selectedFloorId
    ]);
    var rowSlots = useCallback11(function(node) {
        var _factsRef_current_get;
        var f = (_factsRef_current_get = factsRef.current.get(node.refid)) !== null && _factsRef_current_get !== void 0 ? _factsRef_current_get : {};
        var _f_kind;
        var glyph = node.kind === "floor" ? "layer-group" : node.kind === "surface" ? KIND_ICON[(_f_kind = f.kind) !== null && _f_kind !== void 0 ? _f_kind : "area"] : void 0;
        var sub = f.words || f.plainWords ? /* @__PURE__ */ jsxs20(Fragment13, {
            children: [
                f.words && f.state && /* @__PURE__ */ jsx27(RowNote, {
                    state: f.state,
                    children: f.words
                }),
                f.words && f.plainWords ? " " : null,
                f.plainWords
            ]
        }) : void 0;
        var trailing = f.capacity ? /* @__PURE__ */ jsx27(CapacityTag, {
            value: f.capacity.value,
            source: f.capacity.source,
            tone: f.capacity.tone
        }) : void 0;
        var dragging = (drag === null || drag === void 0 ? void 0 : drag.refid) === node.refid;
        var target = drag !== null && drag.over === node.refid;
        var _f_state, _f_words, _f_plainWords;
        return _object_spread_props(_object_spread({
            glyph: glyph,
            state: f.state,
            sub: sub,
            trailing: trailing
        }, dragging ? {
            dragging: true
        } : {}, target ? {
            dropTarget: true
        } : {}), {
            slotKey: [
                glyph !== null && glyph !== void 0 ? glyph : "",
                (_f_state = f.state) !== null && _f_state !== void 0 ? _f_state : "",
                (_f_words = f.words) !== null && _f_words !== void 0 ? _f_words : "",
                (_f_plainWords = f.plainWords) !== null && _f_plainWords !== void 0 ? _f_plainWords : "",
                f.capacity ? "".concat(f.capacity.value, ":").concat(f.capacity.source, ":").concat(f.capacity.tone) : ""
            ].join("|")
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- rebuilt with the tree (R10) and the drag
    [
        tree,
        drag
    ]);
    var onMouseOver = useCallback11(function(e) {
        if (!hover || drag) return;
        var row = e.target.closest("[data-refid]");
        var _row_dataset_refid;
        var id = (_row_dataset_refid = row === null || row === void 0 ? void 0 : row.dataset.refid) !== null && _row_dataset_refid !== void 0 ? _row_dataset_refid : null;
        var refid = id === floorRefid ? null : id;
        if (refid !== hover.hoveredId) hover.setHovered(refid);
    }, [
        hover,
        floorRefid,
        drag
    ]);
    var onMouseLeave = useCallback11(function() {
        return hover === null || hover === void 0 ? void 0 : hover.setHovered(null);
    }, [
        hover
    ]);
    var regionRef = useRef22(null);
    var switchHelp = modelState === "failed" ? CHECKS_UNAVAILABLE : modelState === "pending" ? CHECKING_PLAN : null;
    if (!layout) {
        return /* @__PURE__ */ jsx27(Region2, {
            children: /* @__PURE__ */ jsx27(Message2, {
                children: "Plan not loaded yet"
            })
        });
    }
    if (!tree) {
        return /* @__PURE__ */ jsx27(Region2, {
            children: /* @__PURE__ */ jsx27(Message2, {
                children: "Nothing placed yet"
            })
        });
    }
    var floorName = tree.node.label;
    var empty = tree.node.children.length === 0;
    var nothingPlaced = !filtering && empty;
    var nothingWrong = filtering && settled && empty && !!(checks === null || checks === void 0 ? void 0 : checks.registerKnown) && !((_factsRef_current_get = factsRef.current.get(tree.node.refid)) === null || _factsRef_current_get === void 0 ? void 0 : _factsRef_current_get.problem);
    var _hover_hoveredId;
    return /* @__PURE__ */ jsxs20(Region2, {
        ref: regionRef,
        tabIndex: -1,
        role: "group",
        "aria-label": "Plan hierarchy",
        children: [
            /* @__PURE__ */ jsx27(RegisterCapacityBanner, {
                readState: readState,
                onRetry: onRetry,
                focusOnRetry: regionRef
            }),
            /* @__PURE__ */ jsxs20(Header, {
                children: [
                    /* @__PURE__ */ jsx27(HeaderLine, {
                        title: treeHeader(floorName),
                        children: treeHeader(floorName)
                    }),
                    /* @__PURE__ */ jsx27(Switch2, {
                        className: "problems-only",
                        surface: "on-solid",
                        checked: problemsOnly,
                        disabled: !problemsOnly && (modelState !== "ready" || empty),
                        description: switchHelp !== null && switchHelp !== void 0 ? switchHelp : void 0,
                        onChange: function(e) {
                            onProblemsOnlyChange(e.target.checked);
                            announce(showingProblems(floorName, e.target.checked));
                        },
                        children: PROBLEMS_ONLY
                    })
                ]
            }),
            readState === "loading" && /* @__PURE__ */ jsx27(Helper, {
                children: CHECKING_CAPACITIES
            }),
            /* @__PURE__ */ jsxs20(Tree, {
                ref: treeRef,
                "data-plan-hierarchy": "",
                onMouseOver: onMouseOver,
                onMouseLeave: onMouseLeave,
                onMouseDown: onMouseDown,
                "data-dragging": drag ? "" : void 0,
                children: [
                    /* @__PURE__ */ jsx27(HierarchyTreeRows, {
                        nodes: [
                            tree.node
                        ],
                        depth: 0,
                        expanded: expanded,
                        selectedIds: selectedIds,
                        currentId: tree.node.refid,
                        hoveredId: (_hover_hoveredId = hover === null || hover === void 0 ? void 0 : hover.hoveredId) !== null && _hover_hoveredId !== void 0 ? _hover_hoveredId : null,
                        rowSlots: rowSlots,
                        look: "disc",
                        guides: true,
                        codePlacement: "sub",
                        announceSelected: true,
                        onToggle: toggle,
                        onSelect: select
                    }),
                    nothingPlaced && /* @__PURE__ */ jsx27(Message2, {
                        children: "Nothing placed yet"
                    }),
                    nothingWrong && /* @__PURE__ */ jsx27(Message2, {
                        children: noProblemsOn(floorName)
                    })
                ]
            }),
            /* @__PURE__ */ jsx27("span", {
                role: "status",
                "aria-live": "polite",
                "aria-atomic": "true",
                style: visuallyHidden,
                children: said
            })
        ]
    });
}
var Region2 = styled22.div(_templateObject97());
var Header = styled22.div(_templateObject98(), space13[2], space13[2], space13[3]);
var HeaderLine = styled22.p(_templateObject99(), typeRole8.caption1, semantic8.text.secondary);
var Helper = styled22.p(_templateObject100(), space13[1], space13[3], typeRole8.caption1, semantic8.text.secondary);
var Tree = styled22.div(_templateObject101(), space13[2], space13[3]);
var Message2 = styled22.p(_templateObject102(), space13[2], space13[1], typeRole8.caption1, semantic8.text.secondary);
// src/components/Planner/sidebar/PlanChecksPanel.tsx
import { useCallback as useCallback12, useEffect as useEffect24, useMemo as useMemo16, useRef as useRef24, useState as useState24 } from "react";
import styled24 from "styled-components";
import { EmptyPane, FilterChipGroup, Icon as Icon12, Note, Progress } from "@repo/design-system";
import { ink as ink3, space as space15, typeRole as typeRole10 } from "@repo/design-tokens";
import { useEditorStore as useEditorStore28, useEquipmentCatalogStore as useEquipmentCatalogStore10, useFloorplanStore as useFloorplanStore36, selectionOnFloorShown as selectionOnFloorShown6 } from "@repo/front-end-state";
import { flatShareFilename as flatShareFilename2, opensIdentifyCard } from "@repo/front-end-utils";
// src/components/Planner/sidebar/registerCardPayload.ts
var registerCardPayload = function(asset) {
    return {
        refid: asset.entity_bid,
        product: asset.model_name,
        productLine: asset.product_line,
        manufacturer: asset.manufacturer_name,
        model: asset.model_file,
        assetUid: asset.asset_uid,
        capacity: asset.capacity,
        entityCode: asset.entity_code
    };
};
// src/components/Planner/sidebar/CapacityFixInset.tsx
import { useEffect as useEffect23, useRef as useRef23, useState as useState23 } from "react";
import styled23 from "styled-components";
import { Button as Button10, Field as Field5, Icon as Icon11, Input as Input5 } from "@repo/design-system";
import { ink as ink2, inset as inset3, radius as radius6, shadow as shadow4, space as space14, surface as surface2, typeRole as typeRole9, weight as weight2 } from "@repo/design-tokens";
// src/components/Planner/sidebar/checksPanelModel.ts
import { useEditorStore as useEditorStore26, useFloorplanStore as useFloorplanStore34 } from "@repo/front-end-state";
import { IDENTITY_STATE_LABELS, MAX_ENTITY_CAPACITY, asArray as asArray6, findLatestDesign as findLatestDesign11, isEntityCapacity as isEntityCapacity2, withCapacityReview as withCapacityReview2 } from "@repo/front-end-utils";
import { semantic as semantic9 } from "@repo/design-tokens";
var CHECK_KIND_ORDER = [
    "error",
    "check",
    "identify",
    "place"
];
var groupToneOf = function(state) {
    var tone = semantic9.status.roles[ROW_STATE_ROLE[state]].tagTone;
    if (tone === null) throw new Error('Checks: row state "'.concat(state, '" has a role with no Tag tone'));
    return tone;
};
var CHECK_KIND_LOOK = {
    error: {
        title: "Errors",
        tone: groupToneOf("error"),
        state: "error",
        hint: "Deepest first",
        shown: "errors"
    },
    check: {
        title: "To check",
        tone: groupToneOf("check"),
        state: "check",
        shown: "to check"
    },
    identify: {
        title: "Identify",
        tone: groupToneOf("identify"),
        state: "identify",
        hint: "Grouped by what the customer wrote",
        shown: "to identify"
    },
    place: {
        title: "To place",
        tone: groupToneOf("place"),
        state: "place",
        shown: "to place"
    }
};
var REGISTER_KINDS = /* @__PURE__ */ new Set([
    "identify",
    "place"
]);
var knownKinds = function(checks) {
    return CHECK_KIND_ORDER.filter(function(kind) {
        return checks.registerKnown || !REGISTER_KINDS.has(kind);
    });
};
var checksToDo = function(checks) {
    return (checks === null || checks === void 0 ? void 0 : checks.known) ? knownKinds(checks).reduce(function(sum, kind) {
        return sum + checks.counts.twin[kind];
    }, 0) : 0;
};
var pressedInForce = function(checks, pressed) {
    return pressed && knownKinds(checks).includes(pressed) ? pressed : null;
};
var checkChips = function(checks, pressed) {
    return knownKinds(checks).map(function(kind) {
        return {
            key: kind,
            label: CHECK_KIND_LOOK[kind].title,
            count: checks.counts.twin[kind],
            dot: ROW_STATE_LOOK[CHECK_KIND_LOOK[kind].state].fill,
            active: pressed === kind
        };
    });
};
var toggleChip = function(pressed, key) {
    return pressed === key ? null : key;
};
var checkGroups = function(checks, pressed) {
    var groups = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = knownKinds(checks)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var kind = _step.value;
            if (pressed && pressed !== kind) continue;
            var rows = kind === "error" ? checks.errors.map(function(check) {
                return {
                    type: "check",
                    key: check.id,
                    check: check
                };
            }) : kind === "check" ? checks.toCheck.map(function(check) {
                return {
                    type: "check",
                    key: check.id,
                    check: check
                };
            }) : kind === "place" ? checks.toPlace.map(function(check) {
                return {
                    type: "check",
                    key: check.id,
                    check: check
                };
            }) : checks.identify.map(function(group) {
                return {
                    type: "group",
                    key: "identify:".concat(group.key),
                    group: group
                };
            });
            if (rows.length === 0) continue;
            groups.push({
                kind: kind,
                rows: rows,
                count: checks.counts.twin[kind]
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return groups;
};
var groupLabel = function(group) {
    return "“".concat(group.label, "” \xd7 ").concat(group.rowIds.length);
};
var groupSentence = function(group) {
    var _group_written_manufacturer;
    var _IDENTITY_STATE_LABELS_group_state;
    var state = (_IDENTITY_STATE_LABELS_group_state = IDENTITY_STATE_LABELS[group.state]) !== null && _IDENTITY_STATE_LABELS_group_state !== void 0 ? _IDENTITY_STATE_LABELS_group_state : "To identify";
    var maker = (_group_written_manufacturer = group.written.manufacturer) === null || _group_written_manufacturer === void 0 ? void 0 : _group_written_manufacturer.trim();
    return maker ? "".concat(state, " \xb7 written as ").concat(maker) : "".concat(state, " \xb7 no manufacturer written");
};
var floorIndexOf2 = function(layout, floorId) {
    return floorId == null ? -1 : layout.floors.findIndex(function(f) {
        return f.id === floorId;
    });
};
var currentDesign = function(floor) {
    return floor ? findLatestDesign11(asArray6(floor.designs)) : void 0;
};
var refidsOnFloor = function(layout, index) {
    var _currentDesign;
    return new Set(asArray6((_currentDesign = currentDesign(layout.floors[index])) === null || _currentDesign === void 0 ? void 0 : _currentDesign.items).map(function(item) {
        return item.refid;
    }));
};
var pressAction = function(row, checks, layout, activeFloorIndex) {
    if (!layout) return {
        type: "none"
    };
    if (row.type === "group") {
        var _loop = function(i) {
            var onFloor = refidsOnFloor(layout, i);
            var count = refids.filter(function(id) {
                return onFloor.has(id);
            }).length;
            if (i === activeFloorIndex && count > 0) {
                best = i;
                return "break";
            }
            if (count > bestCount) {
                best = i;
                bestCount = count;
            }
        };
        var refids = _to_consumable_array(checks.refidsOfGroup(row.group.key));
        if (refids.length === 0) return {
            type: "none"
        };
        var best = -1;
        var bestCount = 0;
        for(var i = 0; i < layout.floors.length; i += 1){
            var _ret = _loop(i);
            if (_ret === "break") break;
        }
        if (best < 0) return {
            type: "none"
        };
        var onBest = refidsOnFloor(layout, best);
        return {
            type: "group",
            floorIndex: best,
            refids: refids.filter(function(id) {
                return onBest.has(id);
            })
        };
    }
    var check = row.check;
    var floorIndex = floorIndexOf2(layout, check.floorId);
    if (check.entity === "item" || check.entity === "surface") {
        return floorIndex < 0 ? {
            type: "none"
        } : {
            type: "entity",
            floorIndex: floorIndex,
            ref: check.ref
        };
    }
    if (check.entity === "floor") {
        var index = floorIndexOf2(layout, Number(check.ref));
        return index < 0 ? {
            type: "none"
        } : {
            type: "floor",
            floorIndex: index
        };
    }
    return {
        type: "none"
    };
};
var runPressAction = function(action) {
    if (action.type === "none") return;
    var plan = useFloorplanStore34.getState();
    if (plan.activeFloorIndex !== action.floorIndex) plan.setActiveFloor(action.floorIndex);
    var editor = useEditorStore26.getState();
    if (action.type === "entity") {
        editor.selectEntity(action.ref);
        editor.frameEntities([
            action.ref
        ]);
    } else {
        editor.clearSelection();
        if (action.type === "group") editor.frameEntities(action.refids);
    }
};
var capacityWrite = function(check, layout) {
    if (!layout) return null;
    if (check.entity === "twin") return {
        entity: "twin"
    };
    if (check.entity === "floor") {
        var floorIndex = floorIndexOf2(layout, Number(check.ref));
        return floorIndex < 0 ? null : {
            entity: "floor",
            floorIndex: floorIndex
        };
    }
    if (check.entity === "surface") {
        var floorIndex1 = floorIndexOf2(layout, check.floorId);
        return floorIndex1 < 0 ? null : {
            entity: "surface",
            floorIndex: floorIndex1,
            refid: check.ref
        };
    }
    return null;
};
var storedStamp = function(target, layout) {
    var _currentDesign;
    if (target.entity === "twin") {
        return {
            capacity: layout.capacity,
            reviewed: layout.capacityReviewedContents
        };
    }
    var floor = layout.floors[target.floorIndex];
    if (target.entity === "floor") {
        return {
            capacity: floor === null || floor === void 0 ? void 0 : floor.capacity,
            reviewed: floor === null || floor === void 0 ? void 0 : floor.capacityReviewedContents
        };
    }
    var surface11 = asArray6((_currentDesign = currentDesign(floor)) === null || _currentDesign === void 0 ? void 0 : _currentDesign.surfaces).find(function(s) {
        return s.refid === target.refid;
    });
    return {
        capacity: surface11 === null || surface11 === void 0 ? void 0 : surface11.capacity,
        reviewed: surface11 === null || surface11 === void 0 ? void 0 : surface11.capacityReviewedContents
    };
};
var storedCapacity = function(target, layout) {
    return storedStamp(target, layout).capacity;
};
var applyCapacity = function(target, capacity, contents) {
    var plan = useFloorplanStore34.getState();
    var layout = plan.layout;
    if (!layout) return "refused";
    if (capacity !== void 0 && !isEntityCapacity2(capacity)) return "refused";
    var stamped = withCapacityReview2(capacity, contents);
    var now = storedStamp(target, layout);
    if (now.capacity === stamped.capacity && now.reviewed === stamped.capacityReviewedContents) {
        return "unchanged";
    }
    useEditorStore26.getState().pushSnapshot(layout);
    if (target.entity === "twin") {
        plan.setTwinCapacity(stamped.capacity, stamped.capacityReviewedContents);
        return "changed";
    }
    if (target.entity === "floor") {
        plan.setFloorCapacity(target.floorIndex, stamped.capacity, stamped.capacityReviewedContents);
        return "changed";
    }
    if (target.inPlace) {
        useFloorplanStore34.getState().updateSurface(target.refid, stamped, {
            floorIndex: target.floorIndex
        });
        return "changed";
    }
    if (plan.activeFloorIndex !== target.floorIndex) plan.setActiveFloor(target.floorIndex);
    useFloorplanStore34.getState().updateSurface(target.refid, stamped);
    return "changed";
};
var capacityRefusal = function(typed, contents) {
    var value = Number(typed.trim());
    if (typed.trim() === "" || !Number.isInteger(value) || value < 1) return "Enter a whole number.";
    if (!isEntityCapacity2(value)) {
        return "Capacity can't be more than ".concat(MAX_ENTITY_CAPACITY.toLocaleString("en-GB"), ".");
    }
    if (contents !== "unknown" && value < contents) {
        return "Capacity can't be less than the contents (".concat(contents, ").");
    }
    return null;
};
var placeFacts = function(row) {
    var parts = [
        row === null || row === void 0 ? void 0 : row.manufacturer,
        row === null || row === void 0 ? void 0 : row.product
    ].map(function(part) {
        return typeof part === "string" ? part.trim() : "";
    }).filter(Boolean);
    return parts.length > 0 ? parts.join(" \xB7 ") : null;
};
// src/components/Planner/sidebar/CapacityFixInset.tsx
import { jsx as jsx28, jsxs as jsxs21 } from "react/jsx-runtime";
var Card3 = styled23.div(_templateObject103(), space14[2], space14[1], inset3[3], space14[3], radius6.lg, surface2[0], shadow4.glassSm);
var Fact = styled23.div(_templateObject104(), space14[2], typeRole9.caption1, ink2[2]);
var FactWords = styled23.span(_templateObject105());
var FactNumber = styled23.span(_templateObject106(), weight2.semibold, function(param) {
    var $ink = param.$ink;
    return $ink !== null && $ink !== void 0 ? $ink : ink2[1];
});
var Actions3 = styled23.div(_templateObject107(), space14[2]);
var shown = function(n) {
    return typeof n === "number" ? String(n) : "\u2013";
};
function CapacityFixInset(param) {
    var state = param.state, current2 = param.current, calculated = param.calculated, contents = param.contents, keep = param.keep, onApply = param.onApply, onRefused = param.onRefused, _param_pending = param.pending, pending = _param_pending === void 0 ? false : _param_pending;
    var _useState23 = _sliced_to_array(useState23(false), 2), editing = _useState23[0], setEditing = _useState23[1];
    var _useState231 = _sliced_to_array(useState23(""), 2), typed = _useState231[0], setTyped = _useState231[1];
    var _useState232 = _sliced_to_array(useState23(null), 2), refusal = _useState232[0], setRefusal = _useState232[1];
    var inputRef = useRef23(null);
    var setByHandRef = useRef23(null);
    var wasEditing = useRef23(false);
    useEffect23(function() {
        var _inputRef_current, _setByHandRef_current;
        if (editing) (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
        else if (wasEditing.current) (_setByHandRef_current = setByHandRef.current) === null || _setByHandRef_current === void 0 ? void 0 : _setByHandRef_current.focus();
        wasEditing.current = editing;
    }, [
        editing
    ]);
    var open = function() {
        setTyped(current2 === void 0 ? "" : String(current2));
        setRefusal(null);
        setEditing(true);
    };
    var cancel = function() {
        setRefusal(null);
        setEditing(false);
    };
    var set = function() {
        var reason = capacityRefusal(typed, contents);
        if (reason) {
            var _inputRef_current;
            setRefusal(reason);
            onRefused(reason);
            (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
            return;
        }
        onApply(Number(typed.trim()));
    };
    if (editing) {
        return /* @__PURE__ */ jsxs21(Card3, {
            children: [
                /* @__PURE__ */ jsx28(Field5, {
                    label: "Capacity",
                    error: refusal !== null && refusal !== void 0 ? refusal : void 0,
                    children: function(wiring) {
                        return /* @__PURE__ */ jsx28(Input5, _object_spread_props(_object_spread({}, wiring), {
                            ref: inputRef,
                            type: "number",
                            inputMode: "numeric",
                            min: 1,
                            step: 1,
                            value: typed,
                            onChange: function(e) {
                                setTyped(e.target.value);
                                if (refusal) setRefusal(null);
                            },
                            onKeyDown: function(e) {
                                if (e.key === "Enter") {
                                    e.preventDefault();
                                    set();
                                } else if (e.key === "Escape") {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    cancel();
                                }
                            }
                        }));
                    }
                }),
                /* @__PURE__ */ jsxs21(Actions3, {
                    children: [
                        /* @__PURE__ */ jsx28(Button10, {
                            type: "button",
                            variant: "primary",
                            size: "sm",
                            disabled: pending,
                            onClick: set,
                            children: "Set"
                        }),
                        /* @__PURE__ */ jsx28(Button10, {
                            type: "button",
                            variant: "secondary",
                            size: "sm",
                            onClick: cancel,
                            children: "Cancel"
                        })
                    ]
                })
            ]
        });
    }
    var capacityInk = ROW_STATE_LOOK[state].ink;
    return /* @__PURE__ */ jsxs21(Card3, {
        children: [
            /* @__PURE__ */ jsxs21(Fact, {
                children: [
                    /* @__PURE__ */ jsx28(Icon11, {
                        name: "hand",
                        variant: "regular",
                        size: "sm"
                    }),
                    /* @__PURE__ */ jsx28(FactWords, {
                        children: "Capacity, set by hand"
                    }),
                    /* @__PURE__ */ jsx28(FactNumber, {
                        $ink: capacityInk,
                        children: shown(current2)
                    })
                ]
            }),
            /* @__PURE__ */ jsxs21(Fact, {
                children: [
                    /* @__PURE__ */ jsx28(Icon11, {
                        name: "calculator",
                        size: "sm"
                    }),
                    /* @__PURE__ */ jsx28(FactWords, {
                        children: "Contents"
                    }),
                    /* @__PURE__ */ jsx28(FactNumber, {
                        children: shown(contents)
                    })
                ]
            }),
            /* @__PURE__ */ jsxs21(Actions3, {
                children: [
                    keep && current2 !== void 0 && /* @__PURE__ */ jsx28(Button10, {
                        type: "button",
                        variant: "secondary",
                        size: "sm",
                        disabled: pending,
                        onClick: function() {
                            return onApply(current2);
                        },
                        children: "Keep ".concat(current2)
                    }),
                    /* @__PURE__ */ jsx28(Button10, {
                        type: "button",
                        variant: "primary",
                        size: "sm",
                        iconLeft: /* @__PURE__ */ jsx28(Icon11, {
                            name: "calculator",
                            size: "sm"
                        }),
                        disabled: pending,
                        onClick: function() {
                            return onApply(void 0);
                        },
                        children: typeof calculated === "number" ? "Use Calculated \xb7 ".concat(calculated) : "Use Calculated"
                    }),
                    /* @__PURE__ */ jsx28(Button10, {
                        type: "button",
                        variant: "secondary",
                        size: "sm",
                        ref: setByHandRef,
                        iconLeft: /* @__PURE__ */ jsx28(Icon11, {
                            name: "hand",
                            variant: "regular",
                            size: "sm"
                        }),
                        onClick: open,
                        children: "Set by Hand\u2026"
                    })
                ]
            })
        ]
    });
}
// src/components/Planner/itemCard/holderLink.ts
import { flyToOnPlan, useEditorStore as useEditorStore27, useFloorplanStore as useFloorplanStore35 } from "@repo/front-end-state";
import { CHECK_SENTENCES, entityWorldCentre, findLatestDesign as findLatestDesign12 } from "@repo/front-end-utils";
// src/components/Planner/itemCard/itemCardText.ts
var LEVEL_WORDS = {
    error: "Error",
    check: "To check",
    identify: "Identify"
};
var ISSUED_AT_LAUNCH = "Issued at Launch";
var copyBidLabel = function(bid) {
    return "Copy BID ".concat(bid);
};
var copiedBid = function(bid) {
    return "Copied ".concat(bid);
};
var COPY_FAILED = "Couldn't copy the BID";
var issueCountTag = function(n) {
    return n === 0 ? "No issues" : n === 1 ? "1 issue" : "".concat(n, " issues");
};
var CHECKING = "Checking\u2026";
var CHECKS_UNAVAILABLE2 = "Checks unavailable";
var SAVED = "Saved";
var NAME_MUST_BE_UNIQUE = "The name must be unique in this twin";
var showingHolderSentence = function(name) {
    return "Showing ".concat(name, ".");
};
var holderGoneSentence = function(name) {
    return "".concat(name, " is no longer on the plan.");
};
var issuesListName = function(n, name) {
    return "".concat(n === 1 ? "1 issue" : "".concat(n, " issues"), " on ").concat(name);
};
var IDENTIFY_SENTENCES = {
    to_identify: "No product yet",
    to_confirm: "Product guessed, not confirmed",
    generic: "Generic product, exact model unknown"
};
var parentDiffersSentence = function(drawnName) {
    return drawnName === null ? "The drawing puts it on the floor" : "The drawing puts it in ".concat(drawnName);
};
var contentsChangedSentence = function(capacity, reviewed, contents, fallback) {
    return typeof capacity === "number" && typeof reviewed === "number" && typeof contents === "number" ? "".concat(capacity, " set by hand; what's inside went ").concat(reviewed, " to ").concat(contents) : fallback;
};
var LINK_TO_REGISTER_ROW = "Link to a register row";
var LINK_PLACEHOLDER = "Name, customer ID or source ID";
var ADD_TO_REGISTER = "Add to Register";
var RENAME = "Rename";
var keepLabel = function(what) {
    return "Keep ".concat(what);
};
var USE_THE_DRAWING = "Use the drawing";
var useCalculatedFixLabel = function(contents) {
    return contents === null ? "Use calculated" : "Use calculated \xb7 ".concat(contents);
};
var CHANGE_PARENT = "Change parent";
var SET_BY_HAND = "Set by hand";
var IDENTIFY = "Identify";
var reissueBidLabel = function(kind) {
    return "Issue ".concat(kind === "area" ? "an" : "a", " ").concat(kindTitle(kind), " BID");
};
var CHANGE_KIND = "Change kind";
var CONFIRM = "Confirm";
var CHANGE_PRODUCT = "Change product";
var CHOSEN_BY_HAND_HELP = "Chosen by hand.";
var NOTHING_INSIDE = "Nothing inside";
var insideToggleLabel = function(open, phrase, name) {
    return "".concat(open ? "Hide" : "Show", " the ").concat(phrase, " inside ").concat(name);
};
var NOT_SET = "Not set";
var BY_HAND = "by hand";
// src/components/Planner/itemCard/holderLink.ts
var PREFIX = {
    "duplicate-name": CHECK_SENTENCES.duplicateNamePrefix,
    "duplicate-bid": CHECK_SENTENCES.duplicateBidPrefix
};
var onPlan = function(holder) {
    return (holder.entity === "item" || holder.entity === "surface") && typeof holder.floorIndex === "number";
};
var linkableHolder = function(check) {
    var prefix = PREFIX[check.code];
    var holders = check.holders;
    if (!prefix || !holders || holders.length !== 1) return null;
    var _holders = _sliced_to_array(holders, 1), holder = _holders[0];
    var name = holder.name.trim();
    if (!onPlan(holder) || name === "") return null;
    if (check.sentence !== "".concat(prefix, " ").concat(holder.name)) return null;
    return {
        prefix: prefix,
        name: holder.name,
        ref: holder.ref,
        floorIndex: holder.floorIndex
    };
};
var holderLabel = function(name) {
    return "Show ".concat(name, " on the plan");
};
var floorToShow = function(holder) {
    var _plan_layout_floors, _plan_layout;
    var plan = useFloorplanStore35.getState();
    var shown2 = (_plan_layout = plan.layout) === null || _plan_layout === void 0 ? void 0 : (_plan_layout_floors = _plan_layout.floors) === null || _plan_layout_floors === void 0 ? void 0 : _plan_layout_floors[plan.activeFloorIndex];
    return shown2 && entityWorldCentre(findLatestDesign12(shown2.designs), holder.ref) ? plan.activeFloorIndex : holder.floorIndex;
};
var showHolder = function(holder) {
    var outcome = flyToOnPlan(holder.ref, {
        floorIndex: floorToShow(holder),
        glow: true
    });
    if (!outcome.moved) return holderGoneSentence(holder.name);
    if (outcome.switched && useEditorStore27.getState().heldSelectionFloor !== null) return null;
    return showingHolderSentence(holder.name);
};
// src/components/Planner/itemCard/HolderButton.tsx
import { Button as Button11 } from "@repo/design-system";
import { jsx as jsx29 } from "react/jsx-runtime";
var HolderButton = function(param) {
    var holder = param.holder, onPress = param.onPress;
    return /* @__PURE__ */ jsx29(Button11, {
        type: "button",
        variant: "text",
        size: "inline",
        "aria-label": holderLabel(holder.name),
        "data-holder": holder.ref,
        onClick: onPress,
        children: holder.name
    });
};
// src/components/Planner/sidebar/PlanChecksPanel.tsx
import { Fragment as Fragment14, jsx as jsx30, jsxs as jsxs22 } from "react/jsx-runtime";
var Region3 = styled24.div(_templateObject108(), space15[3], space15[3]);
var Groups = styled24.div(_templateObject109(), space15[2]);
var Rows2 = styled24.div(_templateObject110());
var Reading = styled24.span(_templateObject111(), typeRole10.caption1, ink3[2]);
var rowKind = function(check) {
    return check.entity === "item" || check.entity === "register" ? "item" : check.entity === "surface" ? "surface" : "floor";
};
var hoverRef = function(row) {
    return row.type === "check" && (row.check.entity === "item" || row.check.entity === "surface") ? row.check.ref : null;
};
var plural3 = function(n, one, many) {
    return "".concat(n, " ").concat(n === 1 ? one : many);
};
function PlanChecksPanel() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, onIdentifyGroup = _ref.onIdentifyGroup, _ref_identifyOpenKey = _ref.identifyOpenKey, identifyOpenKey = _ref_identifyOpenKey === void 0 ? null : _ref_identifyOpenKey;
    var checks = usePlanChecksContext();
    var hover = usePlannerHover();
    var settled = usePlanChecksSettled();
    var settledRef = useRef24(settled);
    settledRef.current = settled;
    var hoverSources = useRef24({
        pointer: null,
        focus: null
    });
    var hoverFrom = function(source, ref) {
        hoverSources.current = _object_spread_props(_object_spread({}, hoverSources.current), _define_property({}, source, ref));
        var _hoverSources_current_pointer;
        hover === null || hover === void 0 ? void 0 : hover.setHovered((_hoverSources_current_pointer = hoverSources.current.pointer) !== null && _hoverSources_current_pointer !== void 0 ? _hoverSources_current_pointer : hoverSources.current.focus);
    };
    var selectedIds = useEditorStore28(selectionOnFloorShown6);
    var activeFloorId = useFloorplanStore36(function(s) {
        var _s_layout_floors_s_activeFloorIndex, _s_layout;
        var _s_layout_floors_s_activeFloorIndex_id;
        return (_s_layout_floors_s_activeFloorIndex_id = (_s_layout = s.layout) === null || _s_layout === void 0 ? void 0 : (_s_layout_floors_s_activeFloorIndex = _s_layout.floors[s.activeFloorIndex]) === null || _s_layout_floors_s_activeFloorIndex === void 0 ? void 0 : _s_layout_floors_s_activeFloorIndex.id) !== null && _s_layout_floors_s_activeFloorIndex_id !== void 0 ? _s_layout_floors_s_activeFloorIndex_id : null;
    });
    var registerRows = useEquipmentCatalogStore10(function(s) {
        return s.registerRows;
    });
    var siteAssets = useEquipmentCatalogStore10(function(s) {
        return s.siteAssets;
    });
    var dragStore = useEquipmentDragStore();
    var draggingKey = useEquipmentDragRowKey(dragStore);
    var pointer = useEquipmentPointerSource(dragStore);
    var _useState24 = _sliced_to_array(useState24(null), 2), pressedChip = _useState24[0], setPressed = _useState24[1];
    var _useState241 = _sliced_to_array(useState24(null), 2), openInset = _useState241[0], setOpenInset = _useState241[1];
    var _useState242 = _sliced_to_array(useState24({
        n: 0,
        text: ""
    }), 2), said = _useState242[0], setSaid = _useState242[1];
    var say = useCallback12(function(text2) {
        return setSaid(function(prev) {
            return {
                n: prev.n + 1,
                text: text2
            };
        });
    }, []);
    var regionRef = useRef24(null);
    var pending = useRef24(null);
    var pressed = checks ? pressedInForce(checks, pressedChip) : null;
    var groups = useMemo16(function() {
        return checks ? checkGroups(checks, pressed) : [];
    }, [
        checks,
        pressed
    ]);
    var chips = useMemo16(function() {
        return checks ? checkChips(checks, pressed) : [];
    }, [
        checks,
        pressed
    ]);
    var assetsById = useMemo16(function() {
        return new Map(registerRows.map(function(asset) {
            return [
                asset.id,
                asset
            ];
        }));
    }, [
        registerRows
    ]);
    var sidebarByUid = useMemo16(function() {
        return new Map(siteAssets.flatMap(function(a) {
            return a.asset_uid ? [
                [
                    a.asset_uid,
                    a
                ]
            ] : [];
        }));
    }, [
        siteAssets
    ]);
    var latest = useRef24({
        checks: checks,
        groups: groups,
        onIdentifyGroup: onIdentifyGroup
    });
    latest.current = {
        checks: checks,
        groups: groups,
        onIdentifyGroup: onIdentifyGroup
    };
    var findRow = function(key) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = latest.current.groups[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var group = _step.value;
                var index = group.rows.findIndex(function(r) {
                    return r.key === key;
                });
                if (index >= 0) return {
                    row: group.rows[index],
                    group: group,
                    index: index
                };
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return null;
    };
    var press = useCallback12(function(key) {
        var model = latest.current.checks;
        var found = findRow(key);
        if (!model || !found) return;
        var row = found.row;
        var plan = useFloorplanStore36.getState();
        runPressAction(pressAction(row, model, plan.layout, plan.activeFloorIndex));
        if (row.type === "group" && opensIdentifyCard(row.group.state)) {
            var _latest_current_onIdentifyGroup, _latest_current;
            (_latest_current_onIdentifyGroup = (_latest_current = latest.current).onIdentifyGroup) === null || _latest_current_onIdentifyGroup === void 0 ? void 0 : _latest_current_onIdentifyGroup.call(_latest_current, row.group);
        }
        var opens = row.type === "check" && row.check.fix.type === "capacity";
        setOpenInset(opens ? key : null);
        if (opens) say("Fix options below.");
    }, []);
    var toggle = function(key) {
        var next = toggleChip(pressed, key);
        setPressed(next);
        if (!checks) return;
        say(next ? "Showing ".concat(CHECK_KIND_LOOK[next].shown, ", ").concat(checks.counts.twin[next], ".") : "Showing everything.");
    };
    var fix = function(key, check, capacity, kind) {
        if (check.fix.type !== "capacity") return;
        var layout = useFloorplanStore36.getState().layout;
        var target = capacityWrite(check, layout);
        if (!target || !layout) return;
        if (!settledRef.current) {
            say("The plan is still updating. Try again in a moment.");
            return;
        }
        var before = storedCapacity(target, layout);
        var found = findRow(key);
        hoverSources.current = {
            pointer: null,
            focus: null
        };
        hover === null || hover === void 0 ? void 0 : hover.setHovered(null);
        setOpenInset(null);
        var outcome = applyCapacity(target, capacity, check.fix.contents);
        if (outcome === "refused") {
            say("The capacity could not be changed.");
            return;
        }
        if (outcome === "unchanged") {
            say(capacity === void 0 ? "Capacity already calculated." : "Capacity ".concat(capacity, " kept."));
            return;
        }
        var words = capacity === void 0 ? "Capacity set to calculated".concat(typeof check.fix.calculated === "number" ? ", ".concat(check.fix.calculated) : "", ".") : capacity === before ? "Capacity ".concat(capacity, " kept.") : "Capacity set to ".concat(capacity, ".");
        var _found_index;
        pending.current = {
            kind: kind,
            index: (_found_index = found === null || found === void 0 ? void 0 : found.index) !== null && _found_index !== void 0 ? _found_index : 0,
            words: words
        };
    };
    useEffect24(function() {
        var p = pending.current;
        if (!p || !checks || !settled) return;
        pending.current = null;
        say("".concat(p.words, " ").concat(plural3(checks.counts.twin.error, "error", "errors"), " left."));
        var region = regionRef.current;
        if (!region) return;
        var group = region.querySelector('[data-check-group="'.concat(p.kind, '"]'));
        var rows = group ? Array.from(group.querySelectorAll("button.row-select")) : [];
        var _rows_Math_min, _ref, _ref1;
        var target = (_ref1 = (_ref = (_rows_Math_min = rows[Math.min(p.index, rows.length - 1)]) !== null && _rows_Math_min !== void 0 ? _rows_Math_min : group === null || group === void 0 ? void 0 : group.querySelector("button")) !== null && _ref !== void 0 ? _ref : region.querySelector("[data-check-chips] button")) !== null && _ref1 !== void 0 ? _ref1 : region;
        target.focus();
    }, [
        checks,
        settled,
        say
    ]);
    if (checks === null || checks === void 0 ? void 0 : checks.failed) {
        return /* @__PURE__ */ jsx30(Region3, {
            children: /* @__PURE__ */ jsx30(Note, {
                tone: "error",
                children: "The checks could not be worked out for this plan."
            })
        });
    }
    if (!checks || !checks.known) {
        return /* @__PURE__ */ jsxs22(Region3, {
            children: [
                /* @__PURE__ */ jsx30(Progress, {
                    label: "Reading the plan\u2026"
                }),
                /* @__PURE__ */ jsx30(Reading, {
                    "aria-hidden": "true",
                    children: "Reading the plan\u2026"
                })
            ]
        });
    }
    var total = chips.reduce(function(sum, chip) {
        return sum + chip.count;
    }, 0);
    var layoutNow = openInset ? useFloorplanStore36.getState().layout : null;
    var blurOut = function(event) {
        if (!event.currentTarget.contains(event.relatedTarget)) hoverFrom("focus", null);
    };
    return /* @__PURE__ */ jsxs22(Region3, {
        ref: regionRef,
        tabIndex: -1,
        "data-plan-checks": "",
        children: [
            checks.registerKnown && /* @__PURE__ */ jsx30(IdentifiedScoreCard, {
                score: checks.score,
                headingLevel: 3,
                surface: "on-glass"
            }),
            !checks.registerKnown && /* @__PURE__ */ jsx30(Note, {
                tone: "butter",
                children: "The register could not be read, so machine and identify checks are not shown."
            }),
            total === 0 ? // An all-clear is a claim, made only where every check could be made (R3.7). With the
            // register unread and no plan-only problem, the note above is all there is to say.
            checks.registerKnown ? /* @__PURE__ */ jsx30(EmptyPane, {
                icon: /* @__PURE__ */ jsx30(Icon12, {
                    name: "circle-check"
                }),
                title: "Nothing to check.",
                headingLevel: 3
            }) : null : /* @__PURE__ */ jsxs22(Fragment14, {
                children: [
                    /* @__PURE__ */ jsx30("div", {
                        "data-check-chips": "",
                        children: /* @__PURE__ */ jsx30(FilterChipGroup, {
                            label: "Show",
                            caption: "hidden",
                            chips: chips,
                            onToggle: toggle
                        })
                    }),
                    /* @__PURE__ */ jsx30(Groups, {
                        children: groups.map(function(group) {
                            var look = CHECK_KIND_LOOK[group.kind];
                            return /* @__PURE__ */ jsx30("div", {
                                "data-check-group": group.kind,
                                children: /* @__PURE__ */ jsx30(ListGroup_default, {
                                    id: "plan-checks-".concat(group.kind),
                                    title: look.title,
                                    tone: look.tone,
                                    count: group.count,
                                    hint: look.hint,
                                    defaultOpen: true,
                                    children: /* @__PURE__ */ jsx30(Rows2, {
                                        children: group.rows.map(function(row) {
                                            var ref = hoverRef(row);
                                            var hovered = !!ref && (hover === null || hover === void 0 ? void 0 : hover.hoveredId) === ref;
                                            if (row.type === "group") {
                                                return /* @__PURE__ */ jsx30(HierarchyEntityRow, {
                                                    refid: row.key,
                                                    kind: "item",
                                                    look: "disc",
                                                    glyph: "industry",
                                                    state: "identify",
                                                    label: groupLabel(row.group),
                                                    sub: /* @__PURE__ */ jsx30(RowNote, {
                                                        state: "identify",
                                                        children: groupSentence(row.group)
                                                    }),
                                                    trailing: plural3(row.group.rowIds.length, "machine", "machines"),
                                                    selected: identifyOpenKey === row.group.key,
                                                    current: identifyOpenKey === row.group.key,
                                                    slotKey: "".concat(row.key, "|").concat(row.group.rowIds.length, "|").concat(row.group.state),
                                                    onSelect: function() {
                                                        return press(row.key);
                                                    }
                                                }, row.key);
                                            }
                                            var check = row.check;
                                            var notOnPlan = check.entity === "register";
                                            var facts = notOnPlan && check.fix.type === "place" ? placeFacts(assetsById.get(check.fix.assetId)) : null;
                                            var sentence = facts !== null && facts !== void 0 ? facts : check.sentence;
                                            var holder = facts ? null : linkableHolder(check);
                                            var selected2 = !!ref && check.floorId === activeFloorId && selectedIds.includes(check.ref);
                                            var state = look.state;
                                            var target = openInset === row.key && check.fix.type === "capacity" ? capacityWrite(check, layoutNow) : null;
                                            var placeAsset = notOnPlan && check.fix.type === "place" ? sidebarByUid.get(String(check.fix.assetId)) : void 0;
                                            var _placeAsset_asset_uid;
                                            var placeKey = (_placeAsset_asset_uid = placeAsset === null || placeAsset === void 0 ? void 0 : placeAsset.asset_uid) !== null && _placeAsset_asset_uid !== void 0 ? _placeAsset_asset_uid : null;
                                            var describe = placeAsset ? function() {
                                                var _flatShareFilename2;
                                                return {
                                                    payload: JSON.stringify(registerCardPayload(placeAsset)),
                                                    drag: {
                                                        title: check.name || placeAsset.model_name || "Unnamed machine",
                                                        glyph: kindGlyphName("item"),
                                                        moving: false,
                                                        rowKey: placeKey !== null && placeKey !== void 0 ? placeKey : void 0,
                                                        model: (_flatShareFilename2 = flatShareFilename2(placeAsset.model_file)) !== null && _flatShareFilename2 !== void 0 ? _flatShareFilename2 : void 0
                                                    }
                                                };
                                            } : null;
                                            var dragProps = describe ? {
                                                draggable: true,
                                                onPointerDown: function(e) {
                                                    return pointer.onPointerDown(e, describe);
                                                },
                                                onDragStart: function(e) {
                                                    if (pointer.guardDragStart(e)) return;
                                                    var _describe = describe(), payload = _describe.payload, drag = _describe.drag;
                                                    e.dataTransfer.setData("application/json", payload);
                                                    e.dataTransfer.effectAllowed = "copyMove";
                                                    beginEquipmentDrag(e, dragStore, drag);
                                                },
                                                // The document-level end clears a drag whose row has left the list
                                                // (placed); this covers a cancelled drag while the row is still here.
                                                onDragEnd: function() {
                                                    return dragStore === null || dragStore === void 0 ? void 0 : dragStore.end();
                                                }
                                            } : void 0;
                                            return /* @__PURE__ */ jsx30("div", _object_spread_props(_object_spread({
                                                onPointerEnter: ref ? function() {
                                                    return hoverFrom("pointer", ref);
                                                } : void 0,
                                                onPointerLeave: ref ? function() {
                                                    return hoverFrom("pointer", null);
                                                } : void 0,
                                                onFocus: ref ? function(e) {
                                                    return hoverFrom("focus", e.target.closest(".row-sub-action") ? null : ref);
                                                } : void 0,
                                                onBlur: ref ? blurOut : void 0
                                            }, dragProps), {
                                                children: /* @__PURE__ */ jsx30(HierarchyEntityRow, {
                                                    refid: row.key,
                                                    kind: rowKind(check),
                                                    look: "disc",
                                                    glyph: check.entity === "twin" ? "building" : void 0,
                                                    state: state,
                                                    label: check.name || (check.entity === "twin" ? "This twin" : ""),
                                                    sub: /* @__PURE__ */ jsx30(RowNote, {
                                                        state: state,
                                                        children: holder ? holder.prefix : sentence
                                                    }),
                                                    subSpoken: holder ? sentence : void 0,
                                                    subAction: holder ? /* @__PURE__ */ jsx30(HolderButton, {
                                                        holder: holder,
                                                        onPress: function() {
                                                            var said2 = showHolder(holder);
                                                            if (said2) say(said2);
                                                        }
                                                    }) : void 0,
                                                    code: check.bid || void 0,
                                                    codePlacement: "trailing",
                                                    trailing: facts ? "Not on plan" : void 0,
                                                    pressable: !notOnPlan,
                                                    leading: placeAsset ? /* @__PURE__ */ jsx30(RowGrip, {}) : void 0,
                                                    dragging: placeKey !== null && draggingKey === placeKey,
                                                    selected: selected2,
                                                    hovered: hovered,
                                                    announceSelected: true,
                                                    slotKey: "".concat(check.id, "|").concat(sentence, "|").concat(check.bid, "|").concat(holder ? "".concat(holder.ref, ":").concat(holder.floorIndex) : ""),
                                                    inset: target && layoutNow && check.fix.type === "capacity" ? /* @__PURE__ */ jsx30(CapacityFixInset, {
                                                        state: state === "check" ? "check" : "error",
                                                        current: storedCapacity(target, layoutNow),
                                                        calculated: check.fix.calculated,
                                                        contents: check.fix.contents,
                                                        keep: check.fix.keep,
                                                        onApply: function(capacity) {
                                                            return fix(row.key, check, capacity, group.kind);
                                                        },
                                                        onRefused: say,
                                                        pending: !settled
                                                    }) : void 0,
                                                    onSelect: function() {
                                                        return press(row.key);
                                                    }
                                                })
                                            }), row.key);
                                        })
                                    })
                                })
                            }, group.kind);
                        })
                    })
                ]
            }),
            /* @__PURE__ */ jsx30("div", {
                role: "status",
                "aria-live": "polite",
                style: visuallyHidden,
                children: /* @__PURE__ */ jsx30("span", {
                    children: said.text
                }, said.n)
            })
        ]
    });
}
// src/components/Planner/sidebar/AssetRowsList.tsx
import React4, { useCallback as useCallback13, useEffect as useEffect25, useMemo as useMemo17, useRef as useRef25, useState as useState25 } from "react";
import styled25 from "styled-components";
import { FilterChipGroup as FilterChipGroup2, Select as Select3, Tag as Tag3 } from "@repo/design-system";
import { ink as ink4, semantic as semantic10, space as space16, typeRole as typeRole11 } from "@repo/design-tokens";
import { useEditorStore as useEditorStore29, useEquipmentCatalogStore as useEquipmentCatalogStore11, selectionOnFloorShown as selectionOnFloorShown7 } from "@repo/front-end-state";
import { flatShareFilename as flatShareFilename3, isKeptOffPlan } from "@repo/front-end-utils";
// src/components/Planner/sidebar/assetChips.ts
var assetChipCounts = function(entries, index) {
    if (!index) return {
        notOnPlan: null,
        onPlan: null,
        all: entries.length
    };
    var notOnPlan = 0;
    var onPlan2 = 0;
    entries.forEach(function(entry) {
        var state = placementStateFor(index, entry.asset_uid);
        if (state === "unplaced") notOnPlan += 1;
        else if (state === "placed") onPlan2 += 1;
    });
    return {
        notOnPlan: notOnPlan,
        onPlan: onPlan2,
        all: entries.length
    };
};
var filterByChip = function(entries, index, chip) {
    if (chip === "all") return entries;
    if (!index) return [];
    var want = chip === "not-on-plan" ? "unplaced" : "placed";
    return entries.filter(function(entry) {
        return placementStateFor(index, entry.asset_uid) === want;
    });
};
var openingChip = function(counts) {
    return counts.notOnPlan !== null && counts.notOnPlan > 0 ? "not-on-plan" : "all";
};
// src/components/Planner/sidebar/assetsLibraryText.ts
var ASSET_CHIP_LABEL = {
    "not-on-plan": "Not on plan",
    "on-plan": "On plan",
    all: "All"
};
var ASSET_CHIP_EMPTY = {
    "not-on-plan": "Everything in the register is on the plan.",
    "on-plan": "Nothing from the register is on the plan yet."
};
var ASSET_CHIP_EMPTY_KEPT_OFF = {
    "not-on-plan": "Everything in the register is on the plan or kept off it.",
    "on-plan": "Nothing from the register is on the plan yet.",
    all: "Everything in the register is kept off the plan."
};
var assetRowsAnnouncement = function(chip, count) {
    return "".concat(chip, ": ").concat(count, " ").concat(count === 1 ? "row" : "rows");
};
var FLOOR_WARNING = "No zone here yet: it will sit on the floor";
var dragCardSub = function(moving, hint) {
    if (hint === null) return "Drop on the plan to place";
    var verb = moving ? "Drop to move" : "Drop to place";
    return hint.floor ? "".concat(verb, " \xb7 files into nothing yet") : "".concat(verb, " \xb7 files into ").concat(hint.name);
};
var plural4 = function(n, one, many) {
    return "".concat(n, " ").concat(n === 1 ? one : many);
};
var KIND_PLURAL = {
    zone: [
        "zone",
        "zones"
    ],
    section: [
        "section",
        "sections"
    ],
    area: [
        "area",
        "areas"
    ]
};
var capitalised = function(word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
};
var spaceDrawnTitle = function(kind) {
    return "".concat(capitalised(kind !== null && kind !== void 0 ? kind : "space"), " drawn \xb7 code at Launch");
};
var capacityPhrase = function(value, missing) {
    return value === "unknown" ? "capacity not known yet" : value === void 0 ? "capacity not set" : missing > 0 ? "capacity ".concat(value, " + ").concat(missing, " not set") : // A space just drawn has no stored number, so its capacity is always the calculated
    // sum; frame 09's *, calculated* is left out so the line fits the toast (see above).
    "capacity ".concat(value);
};
var spaceDrawnSub = function(filed, capacity) {
    var parts = [];
    if (filed.machines > 0) parts.push(plural4(filed.machines, "machine", "machines"));
    var byKind = /* @__PURE__ */ new Map();
    filed.spaces.forEach(function(s) {
        var _s_kind;
        var k = (_s_kind = s.kind) !== null && _s_kind !== void 0 ? _s_kind : "space";
        var _byKind_get;
        byKind.set(k, ((_byKind_get = byKind.get(k)) !== null && _byKind_get !== void 0 ? _byKind_get : 0) + 1);
    });
    byKind.forEach(function(n, kind) {
        var _KIND_PLURAL_kind;
        var words = (_KIND_PLURAL_kind = KIND_PLURAL[kind]) !== null && _KIND_PLURAL_kind !== void 0 ? _KIND_PLURAL_kind : [
            "space",
            "spaces"
        ];
        parts.push(plural4(n, words[0], words[1]));
    });
    if (parts.length === 0) return "Nothing inside yet \xb7 ".concat(capacity);
    var what = parts.length === 1 ? parts[0] : "".concat(parts.slice(0, -1).join(", "), " and ").concat(parts[parts.length - 1]);
    return "".concat(what, " filed \xb7 ").concat(capacity);
};
var LIBRARY_DROP_REGISTER_NOT_READY = "The Asset Register hasn't loaded yet, so this drop could duplicate a row. Try again once it has loaded.";
var LIBRARY_DROP_REGISTER_UNREADABLE = "The Asset Register couldn't be read, so this drop could duplicate a row. Press Try again on the assets tab, then drop.";
// src/components/Planner/sidebar/AssetRowsList.tsx
import { jsx as jsx31, jsxs as jsxs23 } from "react/jsx-runtime";
var ASSET_ROWS_OPEN_LIMIT = 60;
var Region4 = styled25.div(_templateObject112(), space16[3], space16[3]);
var Controls = styled25.div(_templateObject113(), space16[2]);
var GroupByRow = styled25.div(_templateObject114(), space16[2]);
var GroupBySlot = styled25.div(_templateObject115());
var GroupByLabel2 = styled25.span(_templateObject116(), typeRole11.caption1, ink4[3]);
var Groups2 = styled25.div(_templateObject117(), space16[2]);
var Rows3 = styled25.div(_templateObject118());
var Empty2 = styled25.p(_templateObject119(), typeRole11.body2, ink4[2]);
var GROUP_BY_LABEL_ID2 = "planner-assets-group-by-label";
var GROUP_BY_OPTIONS2 = [
    {
        value: "manufacturer",
        label: "By manufacturer"
    },
    {
        value: "placement",
        label: "By plan status"
    }
];
var collator = new Intl.Collator(void 0, {
    numeric: true,
    sensitivity: "base"
});
var natural = function(a, b) {
    return collator.compare(a, b);
};
var byProductThenName = function(nameOf2) {
    return function(a, b) {
        var _a_model_name, _b_model_name;
        return natural((_a_model_name = a.model_name) !== null && _a_model_name !== void 0 ? _a_model_name : "", (_b_model_name = b.model_name) !== null && _b_model_name !== void 0 ? _b_model_name : "") || natural(nameOf2(a), nameOf2(b));
    };
};
var rowSub = function(asset, name) {
    var parts = [
        // Under the row's own name, so an unmatched row's echo of that name is dropped.
        assetProductLine(asset, name),
        // Already trimmed, blank ones dropped, by `registerToSidebarEntries`.
        asset.customer_asset_identifier || asset.source_asset_id
    ].filter(function(part) {
        return !!part;
    });
    return parts.length ? parts.join(" \xB7 ") : void 0;
};
var rowKeyOf = function(asset) {
    var _asset_asset_uid;
    return (_asset_asset_uid = asset.asset_uid) !== null && _asset_asset_uid !== void 0 ? _asset_asset_uid : asset.entity_bid;
};
var AssetRow = React4.memo(function AssetRow2(param) {
    var asset = param.asset, name = param.name, placedIdentity = param.placedIdentity, placement = param.placement, selected2 = param.selected, dragging = param.dragging;
    var selectEntity = useEditorStore29(function(s) {
        return s.selectEntity;
    });
    var highlightEntity = useEditorStore29(function(s) {
        return s.highlightEntity;
    });
    var dragStore = useEquipmentDragStore();
    var placed = placement === "placed";
    var identity = useRef25(placedIdentity !== null && placedIdentity !== void 0 ? placedIdentity : asset.entity_bid);
    identity.current = placedIdentity !== null && placedIdentity !== void 0 ? placedIdentity : asset.entity_bid;
    var onSelect = useCallback13(function() {
        selectEntity(identity.current);
        highlightEntity(identity.current);
    }, [
        selectEntity,
        highlightEntity
    ]);
    var pointer = useEquipmentPointerSource(dragStore);
    var buttonProps = useMemo17(function() {
        var describe = function() {
            var _flatShareFilename3;
            return {
                payload: JSON.stringify(registerCardPayload(asset)),
                drag: {
                    title: name,
                    glyph: kindGlyphName("item"),
                    moving: placed,
                    rowKey: rowKeyOf(asset),
                    // The model placement draws it with (`floor-plan-machine-carry`), for the carry.
                    model: (_flatShareFilename3 = flatShareFilename3(asset.model_file)) !== null && _flatShareFilename3 !== void 0 ? _flatShareFilename3 : void 0
                }
            };
        };
        return {
            draggable: true,
            onPointerDown: function(e) {
                return pointer.onPointerDown(e, describe);
            },
            onDragStart: function(e) {
                if (pointer.guardDragStart(e)) return;
                var _describe = describe(), payload = _describe.payload, drag2 = _describe.drag;
                e.dataTransfer.setData("application/json", payload);
                e.dataTransfer.effectAllowed = "copyMove";
                beginEquipmentDrag(e, dragStore, drag2);
            },
            // The document-level end (`useEndEquipmentDragOnDrop`) is what clears a drag whose row has
            // left the list; this covers a cancelled drag (Escape) while the row is still here.
            onDragEnd: function() {
                return dragStore === null || dragStore === void 0 ? void 0 : dragStore.end();
            }
        };
    }, [
        asset,
        dragStore,
        name,
        placed,
        pointer
    ]);
    var drag = useRef25(buttonProps);
    drag.current = buttonProps;
    var grip = useMemo17(function() {
        return /* @__PURE__ */ jsx31(RowGrip, {
            draggable: true,
            onPointerDown: function(e) {
                return drag.current.onPointerDown(e);
            },
            onDragStart: function(e) {
                return drag.current.onDragStart(e);
            },
            onDragEnd: function() {
                return drag.current.onDragEnd();
            }
        });
    }, []);
    var sub = rowSub(asset, name);
    return /* @__PURE__ */ jsx31("div", {
        "data-entity-bid": asset.entity_bid,
        children: /* @__PURE__ */ jsx31(HierarchyEntityRow, {
            refid: asset.entity_bid,
            kind: "item",
            look: "disc",
            leading: grip,
            label: name,
            sub: sub,
            trailing: placement === "unplaced" ? /* @__PURE__ */ jsx31(Tag3, {
                surface: "on-glass",
                tone: semantic10.status.roles.workToDo.tagTone,
                children: ASSET_CHIP_LABEL["not-on-plan"]
            }) : placed ? /* @__PURE__ */ jsx31("span", {
                style: visuallyHidden,
                children: ", on plan"
            }) : void 0,
            selected: selected2,
            announceSelected: true,
            dragging: dragging,
            slotKey: "".concat(sub !== null && sub !== void 0 ? sub : "", "|").concat(placement),
            onSelect: onSelect,
            buttonProps: buttonProps
        })
    });
});
function AssetRowsList() {
    var siteAssets = useEquipmentCatalogStore11(function(s) {
        return s.siteAssets;
    });
    var grouped = useEquipmentCatalogStore11(function(s) {
        return s.grouped;
    });
    var registerRows = useEquipmentCatalogStore11(function(s) {
        return s.registerRows;
    });
    var selectedIds = useEditorStore29(selectionOnFloorShown7);
    var draggingKey = useEquipmentDragRowKey(useEquipmentDragStore());
    var index = placementIndexFor(usePlanLayout());
    var keptOffUids = useMemo17(function() {
        var uids = /* @__PURE__ */ new Set();
        registerRows.forEach(function(row) {
            if (isKeptOffPlan(row)) uids.add(String(row.id));
        });
        return uids;
    }, [
        registerRows
    ]);
    var offered = useMemo17(function() {
        return keptOffUids.size === 0 ? siteAssets : siteAssets.filter(function(asset) {
            return !asset.asset_uid || !keptOffUids.has(asset.asset_uid) || placementStateFor(index, asset.asset_uid) === "placed";
        });
    }, [
        siteAssets,
        keptOffUids,
        index
    ]);
    var counts = useMemo17(function() {
        return assetChipCounts(offered, index);
    }, [
        offered,
        index
    ]);
    var _useState25 = _sliced_to_array(useState25(null), 2), chip = _useState25[0], setChip = _useState25[1];
    var opening = useRef25(null);
    if (opening.current === null && counts.notOnPlan !== null) opening.current = openingChip(counts);
    var _ref;
    var active = counts.notOnPlan === null ? "all" : (_ref = chip !== null && chip !== void 0 ? chip : opening.current) !== null && _ref !== void 0 ? _ref : "all";
    var _useState251 = _sliced_to_array(useState25("manufacturer"), 2), groupBy = _useState251[0], setGroupBy = _useState251[1];
    var _useState252 = _sliced_to_array(useState25(""), 2), announcement = _useState252[0], setAnnouncement = _useState252[1];
    var visible = useMemo17(function() {
        return filterByChip(offered, index, active);
    }, [
        offered,
        index,
        active
    ]);
    var shown2 = useMemo17(function() {
        return active === "all" && offered === siteAssets ? null : new Set(visible.map(function(a) {
            return a.entity_bid;
        }));
    }, [
        active,
        visible,
        offered,
        siteAssets
    ]);
    var nameOf2 = useMemo17(function() {
        var byUid = /* @__PURE__ */ new Map();
        registerRows.forEach(function(row) {
            var name = (row.asset_name || row.name || "").trim();
            if (name) byUid.set(String(row.id), name);
        });
        return function(asset) {
            var _asset_model_name;
            return asset.asset_uid && byUid.get(asset.asset_uid) || ((_asset_model_name = asset.model_name) === null || _asset_model_name === void 0 ? void 0 : _asset_model_name.trim()) || "Unnamed machine";
        };
    }, [
        registerRows
    ]);
    var sortedGroups = useMemo17(function() {
        return grouped.map(function(group) {
            return {
                key: group.manufacturer,
                title: group.manufacturer,
                assets: group.productLines.reduce(function(acc, line3) {
                    return acc.concat(line3.assets);
                }, []).sort(byProductThenName(nameOf2))
            };
        });
    }, [
        grouped,
        nameOf2
    ]);
    var groups = useMemo17(function() {
        var isShown = function(a) {
            return !shown2 || shown2.has(a.entity_bid);
        };
        if (groupBy === "placement") {
            var buckets = groupByPlacement([
                {
                    manufacturer: "",
                    productLines: sortedGroups.map(function(g) {
                        return {
                            productLine: g.key,
                            assets: g.assets
                        };
                    })
                }
            ], index);
            return buckets.map(function(group) {
                return {
                    key: group.key,
                    title: placementGroupHeading(group.key),
                    assets: group.assets.filter(isShown)
                };
            }).filter(function(group) {
                return group.assets.length > 0;
            });
        }
        return sortedGroups.map(function(group) {
            return _object_spread_props(_object_spread({}, group), {
                assets: group.assets.filter(isShown)
            });
        }).filter(function(group) {
            return group.assets.length > 0;
        });
    }, [
        groupBy,
        sortedGroups,
        index,
        shown2
    ]);
    var openFor = useRef25(null);
    var view = "".concat(active, "|").concat(groupBy);
    if (!openFor.current || openFor.current.view !== view) {
        openFor.current = {
            view: view,
            open: visible.length <= ASSET_ROWS_OPEN_LIMIT
        };
    }
    var startOpen = openFor.current.open;
    var chips = useMemo17(function() {
        var all = {
            key: "all",
            label: ASSET_CHIP_LABEL.all,
            count: counts.all,
            active: active === "all",
            "aria-label": "".concat(ASSET_CHIP_LABEL.all, ", ").concat(counts.all)
        };
        if (counts.notOnPlan === null || counts.onPlan === null) return [
            all
        ];
        return [
            {
                key: "not-on-plan",
                label: ASSET_CHIP_LABEL["not-on-plan"],
                count: counts.notOnPlan,
                dot: semantic10.status.roles.workToDo.mark,
                active: active === "not-on-plan",
                "aria-label": "".concat(ASSET_CHIP_LABEL["not-on-plan"], ", ").concat(counts.notOnPlan)
            },
            {
                key: "on-plan",
                label: ASSET_CHIP_LABEL["on-plan"],
                count: counts.onPlan,
                active: active === "on-plan",
                "aria-label": "".concat(ASSET_CHIP_LABEL["on-plan"], ", ").concat(counts.onPlan)
            },
            all
        ];
    }, [
        counts,
        active
    ]);
    var toggle = useCallback13(function(key) {
        if (key === active) return;
        setChip(key);
        var _ref;
        var shownCount = (_ref = key === "all" ? counts.all : key === "not-on-plan" ? counts.notOnPlan : counts.onPlan) !== null && _ref !== void 0 ? _ref : 0;
        setAnnouncement(assetRowsAnnouncement(ASSET_CHIP_LABEL[key], shownCount));
    }, [
        active,
        counts
    ]);
    var selected2 = useMemo17(function() {
        return new Set(selectedIds);
    }, [
        selectedIds
    ]);
    var _useState253 = _sliced_to_array(useState25({
        view: view,
        open: {}
    }), 2), opened = _useState253[0], setOpened = _useState253[1];
    var openOf = function(key) {
        var _ref;
        return (_ref = opened.view === view ? opened.open[key] : void 0) !== null && _ref !== void 0 ? _ref : startOpen;
    };
    var setOpen = useCallback13(function(key, open) {
        return setOpened(function(prev) {
            return {
                view: view,
                open: _object_spread_props(_object_spread({}, prev.view === view ? prev.open : {}), _define_property({}, key, open))
            };
        });
    }, [
        view
    ]);
    var regionRef = useRef25(null);
    var revealed = useRef25(null);
    var _selectedIds_;
    var firstSelected = (_selectedIds_ = selectedIds[0]) !== null && _selectedIds_ !== void 0 ? _selectedIds_ : null;
    useEffect25(function() {
        if (!firstSelected) {
            revealed.current = null;
            return;
        }
        if (firstSelected === revealed.current) return;
        var identityOf = function(asset2) {
            var _ref;
            return (_ref = asset2.asset_uid ? index === null || index === void 0 ? void 0 : index.byAssetUid.get(asset2.asset_uid) : void 0) !== null && _ref !== void 0 ? _ref : asset2.entity_bid;
        };
        var group = groups.find(function(g) {
            return g.assets.some(function(a) {
                return identityOf(a) === firstSelected;
            });
        });
        var asset = group === null || group === void 0 ? void 0 : group.assets.find(function(a) {
            return identityOf(a) === firstSelected;
        });
        if (!group || !asset) return;
        revealed.current = firstSelected;
        if (!openOf(group.key)) setOpen(group.key, true);
        var frame = requestAnimationFrame(function() {
            var _regionRef_current;
            (_regionRef_current = regionRef.current) === null || _regionRef_current === void 0 ? void 0 : _regionRef_current.querySelectorAll("[data-entity-bid]").forEach(function(row) {
                var _row_scrollIntoView;
                if (row.dataset.entityBid === asset.entity_bid) (_row_scrollIntoView = row.scrollIntoView) === null || _row_scrollIntoView === void 0 ? void 0 : _row_scrollIntoView.call(row, {
                    block: "nearest"
                });
            });
        });
        return function() {
            return cancelAnimationFrame(frame);
        };
    }, [
        firstSelected,
        groups,
        index,
        setOpen
    ]);
    return /* @__PURE__ */ jsxs23(Region4, {
        "data-assets-rows": "",
        ref: regionRef,
        children: [
            /* @__PURE__ */ jsxs23(Controls, {
                children: [
                    /* @__PURE__ */ jsx31(FilterChipGroup2, {
                        label: "Placement",
                        caption: "hidden",
                        chips: chips,
                        onToggle: toggle
                    }),
                    /* @__PURE__ */ jsxs23(GroupByRow, {
                        children: [
                            /* @__PURE__ */ jsx31(GroupByLabel2, {
                                id: GROUP_BY_LABEL_ID2,
                                style: visuallyHidden,
                                children: "Group by"
                            }),
                            /* @__PURE__ */ jsx31(GroupBySlot, {
                                children: /* @__PURE__ */ jsx31(Select3, {
                                    options: GROUP_BY_OPTIONS2,
                                    value: groupBy,
                                    onChange: function(value) {
                                        return setGroupBy(value === "placement" ? "placement" : "manufacturer");
                                    },
                                    size: "sm",
                                    onGlass: true,
                                    ariaLabelledBy: GROUP_BY_LABEL_ID2
                                })
                            })
                        ]
                    })
                ]
            }),
            /* @__PURE__ */ jsx31("span", {
                role: "status",
                style: visuallyHidden,
                children: announcement
            }),
            visible.length === 0 ? /* @__PURE__ */ jsx31(Empty2, {
                children: offered.length < siteAssets.length ? ASSET_CHIP_EMPTY_KEPT_OFF[active] : active === "all" ? "" : ASSET_CHIP_EMPTY[active]
            }) : /* @__PURE__ */ jsx31(Groups2, {
                children: groups.map(function(group) {
                    return /* @__PURE__ */ jsx31(ListGroup_default, {
                        id: "plan-assets-".concat(groupBy, "-").concat(group.key.replace(/[^A-Za-z0-9_-]/g, "-")),
                        title: group.title,
                        count: group.assets.length,
                        open: openOf(group.key),
                        onOpenChange: function(open) {
                            return setOpen(group.key, open);
                        },
                        children: /* @__PURE__ */ jsx31(Rows3, {
                            children: group.assets.map(function(asset) {
                                var uid = asset.asset_uid;
                                var placedIdentity = uid ? index === null || index === void 0 ? void 0 : index.byAssetUid.get(uid) : void 0;
                                var identity = placedIdentity !== null && placedIdentity !== void 0 ? placedIdentity : asset.entity_bid;
                                return /* @__PURE__ */ jsx31(AssetRow, {
                                    asset: asset,
                                    name: nameOf2(asset),
                                    placedIdentity: placedIdentity,
                                    placement: placementStateFor(index, uid),
                                    selected: selected2.has(identity),
                                    dragging: draggingKey !== null && draggingKey === rowKeyOf(asset)
                                }, asset.entity_bid);
                            })
                        })
                    }, group.key);
                })
            }, "".concat(view, "|").concat(startOpen ? "open" : "shut"))
        ]
    });
}
// src/components/Planner/sidebar/EquipmentSidebar.tsx
import { Fragment as Fragment15, jsx as jsx32, jsxs as jsxs24 } from "react/jsx-runtime";
var SidebarWrapper = styled26.aside(_templateObject120(), glassSurface, function(param) {
    var t = param.theme;
    return t.colors.neutral[300];
}, function(param) {
    var t = param.theme;
    return t.colors.surface.glass;
});
var FramedBody = styled26.div(_templateObject121());
var SidebarHeader = styled26.div(_templateObject122(), function(param) {
    var t = param.theme;
    return t.spacing[2.5];
}, function(param) {
    var t = param.theme;
    return "".concat(t.spacing[4], " ").concat(t.spacing[3]);
}, function(param) {
    var t = param.theme;
    return t.colors.neutral[300];
});
var HeaderTitle = styled26.h2(_templateObject123(), function(param) {
    var t = param.theme;
    return t.fontSize.lg.size;
}, function(param) {
    var t = param.theme;
    return t.fontWeight.semibold;
}, function(param) {
    var t = param.theme;
    return t.colors.neutral[800];
});
var Message3 = styled26.div(_templateObject124(), function(param) {
    var t = param.theme;
    return "".concat(t.spacing[3], " ").concat(t.spacing[4]);
}, function(param) {
    var t = param.theme;
    return t.fontSize.sm.size;
}, function(param) {
    var t = param.theme;
    return t.colors.neutral[600];
});
var ErrorMessage = styled26(Message3)(_templateObject125(), function(param) {
    var t = param.theme;
    return t.colors.error[600];
});
var AlertRegion = styled26.div(_templateObject126());
var RetryRow3 = styled26.div(_templateObject127(), function(param) {
    var t = param.theme;
    return "0 ".concat(t.spacing[4], " ").concat(t.spacing[3]);
});
var MODE_OPTIONS = [
    {
        value: "assets",
        text: "Your Assets"
    },
    {
        value: "library",
        text: "Library"
    },
    {
        value: "hierarchy",
        text: "Hierarchy"
    }
];
var CHECKS_MODE_OPTIONS = [
    {
        value: "checks",
        text: "Checks"
    },
    {
        value: "assets",
        text: "Assets"
    },
    {
        value: "library",
        text: "Library"
    },
    {
        value: "hierarchy",
        text: "Hierarchy"
    }
];
function EquipmentSidebar(param) {
    var apiBaseUrl = param.apiBaseUrl, getAccessToken = param.getAccessToken, twinId = param.twinId, twinBid = param.twinBid, _param_stepHierarchy = param.stepHierarchy, stepHierarchy = _param_stepHierarchy === void 0 ? false : _param_stepHierarchy, _param_showSearch = param.showSearch, showSearch = _param_showSearch === void 0 ? true : _param_showSearch, _param_showChecks = param.showChecks, showChecks = _param_showChecks === void 0 ? false : _param_showChecks, initialMode = param.initialMode, onModeChange = param.onModeChange, onIdentifyGroup = param.onIdentifyGroup, identifyOpenKey = param.identifyOpenKey, _param_assetsLook = param.assetsLook, assetsLook = _param_assetsLook === void 0 ? "classic" : _param_assetsLook, _param_tabsLook = param.tabsLook, tabsLook = _param_tabsLook === void 0 ? "switcher" : _param_tabsLook, _param_tabsLabel = param.tabsLabel, tabsLabel = _param_tabsLabel === void 0 ? "Floor plan lists" : _param_tabsLabel, frame = param.frame;
    var panelId = "".concat(useId2(), "panel");
    var error = useEquipmentCatalogStore12(function(s) {
        return s.error;
    });
    var siteAssets = useEquipmentCatalogStore12(function(s) {
        return s.siteAssets;
    });
    var searchQuery = useEquipmentCatalogStore12(function(s) {
        return s.searchQuery;
    });
    var filteredGrouped = useEquipmentCatalogStore12(function(s) {
        return s.filteredGrouped;
    });
    var loadRegisterAssets = useEquipmentCatalogStore12(function(s) {
        return s.loadRegisterAssets;
    });
    var readState = useEquipmentCatalogStore12(function(s) {
        return registerReadState4(s, {
            twinId: twinId !== null && twinId !== void 0 ? twinId : void 0
        });
    });
    var machinesKnown = useMachinesKnown(twinId);
    var _useState26 = _sliced_to_array(useState26(false), 2), problemsOnly = _useState26[0], setProblemsOnly = _useState26[1];
    var _useState261 = _sliced_to_array(useState26(function() {
        return initialMode && (initialMode !== "checks" || showChecks) ? initialMode : showChecks ? "checks" : "assets";
    }), 2), mode = _useState261[0], setMode = _useState261[1];
    var retryRead = useCallback14(function() {
        if (!getAccessToken) return;
        void loadRegisterAssets(apiBaseUrl, getAccessToken, {
            twinId: twinId !== null && twinId !== void 0 ? twinId : void 0
        });
    }, [
        apiBaseUrl,
        getAccessToken,
        twinId,
        loadRegisterAssets
    ]);
    useEffect26(function() {
        retryRead();
    }, [
        retryRead
    ]);
    var noMatches = readState === "ready" && siteAssets.length > 0 && searchQuery.trim() !== "" && filteredGrouped.length === 0;
    var options = showChecks ? CHECKS_MODE_OPTIONS : MODE_OPTIONS;
    var chooseMode = function(value) {
        setMode(value);
        onModeChange === null || onModeChange === void 0 ? void 0 : onModeChange(value);
    };
    var tabs = tabsLook === "top-tabs" ? /* @__PURE__ */ jsx32(Tabs, {
        "aria-label": tabsLabel,
        tabs: options.map(function(o) {
            return {
                id: o.value,
                label: o.text,
                panelId: panelId
            };
        }),
        value: mode,
        onChange: chooseMode
    }) : /* @__PURE__ */ jsx32(TagSwitcher_default, {
        label: "Inventory view",
        options: options,
        selectedValue: mode,
        onChange: chooseMode
    });
    var body = mode === "checks" ? /* @__PURE__ */ jsx32(PlanChecksPanel, {
        onIdentifyGroup: onIdentifyGroup,
        identifyOpenKey: identifyOpenKey
    }) : mode === "assets" ? /* @__PURE__ */ jsxs24(Fragment15, {
        children: [
            showSearch && /* @__PURE__ */ jsx32(EquipmentSearch, {}),
            /* @__PURE__ */ jsx32("div", {
                role: "status",
                style: visuallyHidden,
                children: noMatches ? "No matches." : ""
            }),
            readState === "no-twin" ? /* @__PURE__ */ jsx32(Message3, {
                children: "Select a twin to view assets"
            }) : readState === "loading" ? /* @__PURE__ */ jsx32(Message3, {
                children: "Loading asset register\u2026"
            }) : readState === "error" ? /*
       * `role="alert"` because this arm REPLACES the whole asset list asynchronously. The
       * wizard's half of the same failure goes through the design-system `Table`, which
       * renders its error as `role="alert"` and so announces it; without this the two
       * surfaces this feature exists to unify would behave differently for assistive tech,
       * and a screen-reader operator would simply be told the list had gone away. The
       * sentence itself carries the severity in words, so the failure is not signalled by
       * colour alone (WCAG 1.4.1).
       */ /*
                    `role="alert"` wraps BOTH the sentence and the remedy, not just the sentence.
      
                    An alert announces only its own subtree, so with the button outside it a
                    screen-reader operator was told the equipment list had gone away and nothing about
                    the control that brings it back — and the reload advice this replaced was at least
                    announced with the message. They would fall back to the reload, which on this surface
                    discards an unsaved floor plan: the exact harm the control exists to prevent. Raised
                    by the frontend reviewer.
                  */ /* @__PURE__ */ jsxs24(AlertRegion, {
                role: "alert",
                children: [
                    /* @__PURE__ */ jsx32(ErrorMessage, {
                        children: error
                    }),
                    /* @__PURE__ */ jsx32(RetryRow3, {
                        children: /* @__PURE__ */ jsx32(Button12, {
                            variant: "ghost",
                            size: "xs",
                            onClick: retryRead,
                            "aria-label": "Try again: read the asset register",
                            children: "Try again"
                        })
                    })
                ]
            }) : siteAssets.length === 0 ? /* @__PURE__ */ jsx32(Message3, {
                children: "No assets in this twin's register"
            }) : assetsLook === "rows" ? // The Floor Plan step's rows (`floor-plan-page-assets-library`): the whole register,
            // filtered by placement chips. That step has no search box of its own.
            /* @__PURE__ */ jsx32(AssetRowsList, {}) : /*
       * A search that matches nothing says so, in the Library tab's words, rather than leaving
       * a blank panel (`floor-plan-page-search`, R7 — the backlog's "Your Assets has no no
       * matches state"). A status, so the outcome of typing is spoken. Inside the list, under
       * its Group by control, which stays usable while nothing matches.
       */ /* @__PURE__ */ jsx32(EquipmentCategoryList, {
                emptyNote: noMatches ? /* @__PURE__ */ jsx32(Message3, {
                    children: "No matches."
                }) : void 0
            })
        ]
    }) : mode === "library" ? /* @__PURE__ */ jsx32(LibraryBrowser, {
        apiBaseUrl: apiBaseUrl,
        getAccessToken: getAccessToken
    }) : stepHierarchy ? // The Floor Plan step's tree (`floor-plan-page-space-card-hierarchy`, R1): Checks' marks and
    // words, no balance lines. Admin keeps the capacity tree below.
    /* @__PURE__ */ jsx32(PlanStepHierarchy, {
        twinBid: twinBid,
        readState: readState,
        machinesKnown: machinesKnown,
        onRetry: retryRead,
        problemsOnly: problemsOnly,
        onProblemsOnlyChange: setProblemsOnly
    }) : /* @__PURE__ */ jsx32(PlanCapacityHierarchy, {
        readState: readState,
        machinesKnown: machinesKnown,
        onRetry: retryRead
    });
    if (frame) {
        var _options_find;
        var _options_find_text;
        var panel = tabsLook === "top-tabs" ? {
            id: panelId,
            role: "tabpanel",
            "aria-label": (_options_find_text = (_options_find = options.find(function(o) {
                return o.value === mode;
            })) === null || _options_find === void 0 ? void 0 : _options_find.text) !== null && _options_find_text !== void 0 ? _options_find_text : options[0].text
        } : {};
        return /* @__PURE__ */ jsx32(Fragment15, {
            children: frame({
                tabs: tabs,
                body: /* @__PURE__ */ jsx32(FramedBody, _object_spread_props(_object_spread({}, panel), {
                    children: body
                }))
            })
        });
    }
    return /* @__PURE__ */ jsxs24(SidebarWrapper, {
        children: [
            /* @__PURE__ */ jsxs24(SidebarHeader, {
                children: [
                    /* @__PURE__ */ jsx32(HeaderTitle, {
                        children: "Inventory"
                    }),
                    tabs
                ]
            }),
            body
        ]
    });
}
// src/components/Planner/CameraDeleteWarning.tsx
import styled27 from "styled-components";
import { semantic as semantic11, space as space17, typeRole as typeRole12, weight as weight3 } from "@repo/design-tokens";
import { Button as Button13, Icon as Icon13, Modal as Modal4 } from "@repo/design-system";
import { asArray as asArray7, cameraDisplayName, entityNamesByRefid, floorIdFromTargetRefid as floorIdFromTargetRefid3, isLive as isLive6, layoutCurrentDesigns as layoutCurrentDesigns6 } from "@repo/front-end-utils";
import { useFloorplanStore as useFloorplanStore37 } from "@repo/front-end-state";
import { Fragment as Fragment16, jsx as jsx33, jsxs as jsxs25 } from "react/jsx-runtime";
var plural5 = function(n, word) {
    return "".concat(n, " ").concat(word).concat(n === 1 ? "" : "s");
};
var cameraName = function(layout, refid) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = layoutCurrentDesigns6(layout)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var design = _step.value;
            var live = asArray7(design === null || design === void 0 ? void 0 : design.cameras).filter(isLive6);
            var index = live.findIndex(function(c) {
                return c.refid === refid;
            });
            if (index >= 0) return cameraDisplayName(live[index], index);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return "Camera";
};
var watchedRows = function(layout, request) {
    var names = entityNamesByRefid(layout);
    var codes = /* @__PURE__ */ new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = layoutCurrentDesigns6(layout)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var design = _step.value;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = _to_consumable_array(asArray7(design === null || design === void 0 ? void 0 : design.surfaces)).concat(_to_consumable_array(asArray7(design === null || design === void 0 ? void 0 : design.items)))[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var e = _step1.value;
                    if (isLive6(e) && e.refid && e.entityCode) codes.set(e.refid, e.entityCode);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var floorNames = new Map(asArray7(layout === null || layout === void 0 ? void 0 : layout.floors).map(function(f) {
        return [
            f === null || f === void 0 ? void 0 : f.id,
            f === null || f === void 0 ? void 0 : f.name
        ];
    }));
    var counts = /* @__PURE__ */ new Map();
    var _counts_get;
    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
    try {
        for(var _iterator2 = request.observers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var o = _step2.value;
            counts.set(o.targetRefid, ((_counts_get = counts.get(o.targetRefid)) !== null && _counts_get !== void 0 ? _counts_get : 0) + 1);
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
            }
        } finally{
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
    return Array.from(counts).map(function(param) {
        var _param = _sliced_to_array(param, 2), refid = _param[0], count = _param[1];
        var floorId = floorIdFromTargetRefid3(refid);
        if (floorId != null) {
            var _floorNames_get;
            return {
                key: refid,
                label: "Whole floor: ".concat((_floorNames_get = floorNames.get(floorId)) !== null && _floorNames_get !== void 0 ? _floorNames_get : refid),
                count: count
            };
        }
        var name = names.get(refid);
        var code = codes.get(refid);
        var label = !name || name === code ? code !== null && code !== void 0 ? code : refid : code ? "".concat(name, " (").concat(code, ")") : name;
        return {
            key: refid,
            label: label,
            count: count
        };
    }).sort(function(a, b) {
        return a.label.localeCompare(b.label, void 0, {
            numeric: true
        });
    });
};
var cameraDeletedSentence = function(layout, request) {
    var cameras = request.cameraRefids.map(function(refid) {
        return cameraName(layout, refid);
    });
    var n = request.observers.length;
    var what = request.ids.length > cameras.length ? plural5(request.ids.length, "item") : cameras.length === 1 ? cameras[0] : plural5(cameras.length, "camera");
    return n === 0 ? "Deleted ".concat(what, ".") : "Deleted ".concat(what, " and ").concat(plural5(n, "observer"), ".");
};
var cameraDeleteCopy = function(layout, request, undoable) {
    var cameras = request.cameraRefids.map(function(refid) {
        return cameraName(layout, refid);
    });
    var n = request.observers.length;
    var one = cameras.length === 1;
    var mixed = request.ids.length > cameras.length;
    var title = mixed ? "Delete ".concat(plural5(request.ids.length, "item"), " and ").concat(plural5(n, "observer"), "?") : one ? "Delete ".concat(cameras[0], " and its ").concat(plural5(n, "observer"), "?") : "Delete ".concat(cameras.length, " cameras and their ").concat(plural5(n, "observer"), "?");
    var lead = (mixed ? "These regions are drawn on the selected cameras\u2019 feeds or on the selected areas and machines, and will be deleted with them." : one ? "These regions are drawn on its feed and will be deleted with it." : "These regions are drawn on their feeds and will be deleted with them.") + (undoable ? " Ctrl+Z brings them back." : " This can't be undone.");
    return {
        title: title,
        lead: lead,
        rows: watchedRows(layout, request)
    };
};
function CameraDeleteWarning(param) {
    var request = param.request, undoable = param.undoable, onCancel = param.onCancel, onConfirm = param.onConfirm, returnFocusTo = param.returnFocusTo;
    var layout = useFloorplanStore37(function(s) {
        return s.layout;
    });
    var copy = cameraDeleteCopy(layout, request, undoable);
    return /* @__PURE__ */ jsx33(Modal4, {
        open: true,
        onClose: onCancel,
        returnFocusTo: returnFocusTo,
        title: copy.title,
        tone: "coral",
        width: "md",
        icon: /* @__PURE__ */ jsx33(Icon13, {
            name: "video-slash"
        }),
        actions: /* @__PURE__ */ jsxs25(Fragment16, {
            children: [
                /* @__PURE__ */ jsx33(Button13, {
                    type: "button",
                    variant: "frosted",
                    autoFocus: true,
                    onClick: onCancel,
                    children: "Cancel"
                }),
                /* @__PURE__ */ jsx33(Button13, {
                    type: "button",
                    variant: "destructive",
                    iconLeft: /* @__PURE__ */ jsx33(Icon13, {
                        name: "trash-can"
                    }),
                    onClick: onConfirm,
                    children: "Delete"
                })
            ]
        }),
        children: /* @__PURE__ */ jsxs25(WarningBody, {
            children: [
                /* @__PURE__ */ jsx33("p", {
                    className: "lead",
                    children: copy.lead
                }),
                /* @__PURE__ */ jsx33("ul", {
                    children: copy.rows.map(function(row) {
                        return /* @__PURE__ */ jsxs25("li", {
                            children: [
                                /* @__PURE__ */ jsx33(Icon13, {
                                    name: "draw-polygon"
                                }),
                                /* @__PURE__ */ jsx33("span", {
                                    className: "name",
                                    children: row.label
                                }),
                                /* @__PURE__ */ jsx33("span", {
                                    className: "count",
                                    children: plural5(row.count, "region")
                                })
                            ]
                        }, row.key);
                    })
                })
            ]
        })
    });
}
var WarningBody = styled27.div(_templateObject128(), space17[2], typeRole12.body1, semantic11.text.primary, weight3.medium, space17[1], space17[2], weight3.semibold, semantic11.text.secondary);
// src/components/Planner/useRegisterPlanSync.ts
import { useEffect as useEffect27 } from "react";
import { registerReadState as registerReadState5, useEquipmentCatalogStore as useEquipmentCatalogStore13, useFloorplanStore as useFloorplanStore38 } from "@repo/front-end-state";
import { entityIdentityKey as entityIdentityKey2, joinRegisterOntoPlan as joinRegisterOntoPlan2, mirrorRegisterOntoPlan, mirrorRegisterThroughJoin, registerRowsForMirror } from "@repo/front-end-utils";
var useRegisterPlanSync = function(param) {
    var twinBid = param.twinBid, twinId = param.twinId, layoutScope = param.layoutScope;
    var registerRows = useEquipmentCatalogStore13(function(s) {
        return s.registerRows;
    });
    useEffect27(function() {
        var mirrorRows = registerRowsForMirror(registerRows);
        var apply = function() {
            var register = useEquipmentCatalogStore13.getState();
            if (register.registerRows !== registerRows) return;
            var _useFloorplanStore38_getState = useFloorplanStore38.getState(), layout = _useFloorplanStore38_getState.layout, replaceLayout = _useFloorplanStore38_getState.replaceLayout, storeScope = _useFloorplanStore38_getState.twinBID;
            var twinKey = entityIdentityKey2(twinBid);
            var repairStaleLinks = registerReadState5(register, {
                twinId: twinId !== null && twinId !== void 0 ? twinId : void 0
            }) === "ready";
            if (twinKey !== "" && layoutScope && storeScope === layoutScope && entityIdentityKey2(storeScope) !== twinKey) {
                var synced2 = mirrorRegisterThroughJoin(mirrorRegisterOntoPlan(layout, mirrorRows), registerRows, mirrorRows, twinBid, {
                    repairStaleLinks: repairStaleLinks
                });
                if (synced2 && synced2 !== layout) replaceLayout(synced2, {
                    keepDirty: true
                });
                return;
            }
            var joined2 = twinKey !== "" && entityIdentityKey2(storeScope) === twinKey ? joinRegisterOntoPlan2(layout, registerRows, twinBid, {
                /*
         * THE REPAIR GATE, and the one thing about it that is not obvious: this must be the
         * READ STATE, never `registerRows.length > 0`.
         *
         * `loadRegisterAssets` deliberately does not clear `registerRows` when a refresh
         * fails ("a failed refresh after a successful write" — its own comment), so a
         * populated rows array is entirely compatible with `error`. Gating on length would
         * therefore re-point items against a register nobody successfully read, using
         * whatever the last good read happened to leave behind. `registerReadState` is the
         * single rule for this question and already answers `loading` for the window before
         * the load is even issued, which length cannot see at all.
         *
         * Read from `getState()` inside `apply`, like `storeScope` above and for the same
         * reason: a transition mid-gesture is seen on the very next pass. Deliberately NOT
         * added to the effect's dependency array — that would tear down and re-subscribe the
         * layout listener on every loading → ready transition, which is the churn this
         * imperative subscription exists to avoid.
         */ repairStaleLinks: repairStaleLinks
            }) : layout;
            var synced = mirrorRegisterOntoPlan(joined2, mirrorRows);
            if (synced && synced !== layout) replaceLayout(synced);
        };
        var unsubscribe = useFloorplanStore38.subscribe(function(s) {
            return s.layout;
        }, apply);
        apply();
        return unsubscribe;
    }, [
        registerRows,
        twinBid,
        twinId,
        layoutScope
    ]);
};
// src/components/Planner/hooks/useItemRegisterWrite.ts
import { useRef as useRef26, useState as useState27 } from "react";
import { useEditorStore as useEditorStore30, useEquipmentCatalogStore as useEquipmentCatalogStore14, RegisterWriteRefused } from "@repo/front-end-state";
import { isOutcomeUnconfirmed } from "@repo/front-end-services";
var registerWriteMessage = function(error) {
    if (_instanceof(error, RegisterWriteTwinChanged)) {
        return "The selected twin changed before this was sent, so it was not saved.";
    }
    if (_instanceof(error, RegisterWriteRefused)) {
        return error.reason === "no-twin-context" ? "Select a twin before editing an asset\u2019s name or 3D model." : "The selected twin changed while this was saving. The change was saved against the twin you were editing, and is not shown here.";
    }
    var name = _instanceof(error, Error) ? error.name : "";
    if (name === "TimeoutError" || name === "AbortError") {
        return "The request timed out. The change may already have been saved \u2014 reopen the plan to check before trying again.";
    }
    return _instanceof(error, Error) && error.message ? error.message : "The change could not be saved.";
};
var rowWrites = /* @__PURE__ */ new Map();
var queueRowWrite = function(rowId, run) {
    var _rowWrites_get;
    var next = ((_rowWrites_get = rowWrites.get(rowId)) !== null && _rowWrites_get !== void 0 ? _rowWrites_get : Promise.resolve()).then(run, run);
    var settled = next.then(function() {
        return void 0;
    }, function() {
        return void 0;
    });
    rowWrites.set(rowId, settled);
    void settled.then(function() {
        if (rowWrites.get(rowId) === settled) rowWrites.delete(rowId);
    });
    return next;
};
var RegisterWritePreconditionFailed = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(RegisterWritePreconditionFailed, Error1);
    function RegisterWritePreconditionFailed() {
        _class_call_check(this, RegisterWritePreconditionFailed);
        return _call_super(this, RegisterWritePreconditionFailed, arguments);
    }
    return RegisterWritePreconditionFailed;
}(_wrap_native_super(Error));
var RegisterWriteTwinChanged = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(RegisterWriteTwinChanged, Error1);
    function RegisterWriteTwinChanged() {
        _class_call_check(this, RegisterWriteTwinChanged);
        return _call_super(this, RegisterWriteTwinChanged, arguments);
    }
    return RegisterWriteTwinChanged;
}(_wrap_native_super(Error));
function useItemRegisterWrite(param) {
    var item = param.item, row = param.row, selectionKey = param.selectionKey;
    var updateRegisterAsset = useEquipmentCatalogStore14(function(s) {
        return s.updateRegisterAsset;
    });
    var markEntityModified = useEditorStore30(function(s) {
        return s.markEntityModified;
    });
    var _useState27 = _sliced_to_array(useState27(null), 2), writeFailure = _useState27[0], setWriteFailureState = _useState27[1];
    var lastFailure = useRef26(null);
    var setWriteFailure = function(next) {
        lastFailure.current = next ? {
            field: next.field,
            message: next.message,
            unknownOutcome: next.unknownOutcome
        } : null;
        setWriteFailureState(next);
    };
    var _useState271 = _sliced_to_array(useState27(null), 2), writingFor = _useState271[0], setWritingFor = _useState271[1];
    var writeInFlight = useRef26(false);
    var failure = writeFailure && writeFailure.refid === selectionKey ? _object_spread({
        field: writeFailure.field,
        message: writeFailure.message
    }, writeFailure.unknownOutcome ? {
        unknownOutcome: true
    } : {}) : null;
    var isWriting = writingFor !== null && writingFor === selectionKey;
    var write = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(field, fields, options) {
            var forRefid, _useEquipmentCatalogStore14_getState_registerContext, rowId, twinId, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!row || !item) return [
                            2,
                            false
                        ];
                        forRefid = item.refid;
                        writeInFlight.current = true;
                        setWritingFor(forRefid);
                        setWriteFailure(null);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        rowId = row.id;
                        twinId = (_useEquipmentCatalogStore14_getState_registerContext = useEquipmentCatalogStore14.getState().registerContext) === null || _useEquipmentCatalogStore14_getState_registerContext === void 0 ? void 0 : _useEquipmentCatalogStore14_getState_registerContext.twinId;
                        return [
                            4,
                            queueRowWrite(rowId, function() {
                                var _useEquipmentCatalogStore14_getState_registerContext;
                                if (((_useEquipmentCatalogStore14_getState_registerContext = useEquipmentCatalogStore14.getState().registerContext) === null || _useEquipmentCatalogStore14_getState_registerContext === void 0 ? void 0 : _useEquipmentCatalogStore14_getState_registerContext.twinId) !== twinId) {
                                    throw new RegisterWriteTwinChanged();
                                }
                                if ((options === null || options === void 0 ? void 0 : options.precondition) && !options.precondition()) {
                                    throw new RegisterWritePreconditionFailed();
                                }
                                return updateRegisterAsset(rowId, fields);
                            })
                        ];
                    case 2:
                        _state.sent();
                        markEntityModified(forRefid);
                        return [
                            2,
                            true
                        ];
                    case 3:
                        error = _state.sent();
                        if (_instanceof(error, RegisterWritePreconditionFailed)) return [
                            2,
                            false
                        ];
                        setWriteFailure({
                            refid: forRefid,
                            field: field,
                            message: registerWriteMessage(error),
                            unknownOutcome: isOutcomeUnconfirmed(error)
                        });
                        return [
                            2,
                            false
                        ];
                    case 4:
                        writeInFlight.current = false;
                        setWritingFor(function(current2) {
                            return current2 === forRefid ? null : current2;
                        });
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function write(field, fields, options) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        write: write,
        failure: failure,
        fail: function(field, message) {
            var _item_refid;
            return setWriteFailure({
                refid: (_item_refid = item === null || item === void 0 ? void 0 : item.refid) !== null && _item_refid !== void 0 ? _item_refid : "",
                field: field,
                message: message
            });
        },
        clearFailure: function() {
            return setWriteFailure(null);
        },
        isWriting: isWriting,
        inFlight: writeInFlight,
        lastFailure: lastFailure
    };
}
// src/components/Planner/hooks/useItemNameCommit.ts
import { useState as useState28 } from "react";
import { isNameTaken as isNameTaken3, nextFreeName as nextFreeName3 } from "@repo/front-end-utils";
function useItemNameCommit(param) {
    var entity = param.entity, itemRegister = param.itemRegister, nameIndex = param.nameIndex, nameSelf = param.nameSelf, selectionKey = param.selectionKey, registerWrite = param.registerWrite;
    var _entity_name;
    var registerBackedRow = itemRegister.kind === "backed" ? itemRegister.row : null;
    var _registerBackedRow_asset_name;
    var storedDisplayName = (_registerBackedRow_asset_name = registerBackedRow === null || registerBackedRow === void 0 ? void 0 : registerBackedRow.asset_name) !== null && _registerBackedRow_asset_name !== void 0 ? _registerBackedRow_asset_name : "";
    var _useState28 = _sliced_to_array(useState28(null), 2), nameDraft = _useState28[0], setNameDraft = _useState28[1];
    var _useState281 = _sliced_to_array(useState28(null), 2), draftFor = _useState281[0], setDraftFor = _useState281[1];
    if (draftFor !== selectionKey) {
        setDraftFor(selectionKey);
        if (nameDraft !== null) setNameDraft(null);
    }
    var writeError = registerWrite.failure;
    var nameWriteError = (writeError === null || writeError === void 0 ? void 0 : writeError.field) === "name" ? writeError.message : null;
    var backedOffer = nameWriteError && nameDraft !== null && isNameTaken3(nameDraft.trim(), nameIndex, nameSelf) ? nextFreeName3(nameDraft.trim(), nameIndex) : null;
    var _entity_name_trim;
    var unbackedName = (_entity_name_trim = entity === null || entity === void 0 ? void 0 : (_entity_name = entity.name) === null || _entity_name === void 0 ? void 0 : _entity_name.trim()) !== null && _entity_name_trim !== void 0 ? _entity_name_trim : "";
    var unbackedOffer = entity && itemRegister.kind !== "backed" && itemRegister.kind !== "unknown" && unbackedName !== "" && isNameTaken3(unbackedName, nameIndex, nameSelf) ? nextFreeName3(unbackedName, nameIndex) : null;
    var commitDisplayName = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(value) {
            var draft, next;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (registerWrite.inFlight.current) return [
                            2
                        ];
                        draft = value !== null && value !== void 0 ? value : nameDraft;
                        if (!registerBackedRow || draft === null) return [
                            2
                        ];
                        next = draft.trim();
                        if (next === "") {
                            registerWrite.fail("name", BLANK_DISPLAY_NAME_MESSAGE);
                            return [
                                2
                            ];
                        }
                        if (next === registerBackedRow.asset_name) {
                            setNameDraft(null);
                            registerWrite.clearFailure();
                            return [
                                2
                            ];
                        }
                        if (isNameTaken3(next, nameIndex, nameSelf)) {
                            registerWrite.fail("name", takenNameMessage(nextFreeName3(next, nameIndex)));
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            registerWrite.write("name", {
                                asset_name: next
                            })
                        ];
                    case 1:
                        if (_state.sent()) setNameDraft(null);
                        return [
                            2
                        ];
                }
            });
        });
        return function commitDisplayName(value) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        draft: nameDraft,
        setDraft: setNameDraft,
        storedName: storedDisplayName,
        commit: commitDisplayName,
        nameWriteError: nameWriteError,
        backedOffer: backedOffer,
        unbackedOffer: unbackedOffer
    };
}
// src/components/Planner/hooks/useRegisterLink.ts
import { useMemo as useMemo18, useState as useState29 } from "react";
import { useEditorStore as useEditorStore31, useFloorplanStore as useFloorplanStore39 } from "@repo/front-end-state";
import { entityIdentityKey as entityIdentityKey3 } from "@repo/front-end-utils";
// src/components/Planner/registerLinkCandidates.ts
import { asArray as asArray8, entityIdentityFor as entityIdentityFor2, findDuplicateEntityCodes, isKeptOffPlan as isKeptOffPlan2, toDisplayManufacturer as toDisplayManufacturer2 } from "@repo/front-end-utils";
import { normaliseAssetUid as normaliseAssetUid2 } from "@repo/frontend-types";
var keptOff = function(row) {
    var _row_match_status, _row_manufacturer, _row_match_proposal;
    return isKeptOffPlan2({
        keep_off_plan: row.keep_off_plan === true,
        match_status: (_row_match_status = row.match_status) !== null && _row_match_status !== void 0 ? _row_match_status : "",
        reference_id: row.reference_id == null ? null : String(row.reference_id),
        manufacturer: (_row_manufacturer = row.manufacturer) !== null && _row_manufacturer !== void 0 ? _row_manufacturer : null,
        match_proposal: (_row_match_proposal = row.match_proposal) !== null && _row_match_proposal !== void 0 ? _row_match_proposal : null
    });
};
var trimmed = function(value) {
    return typeof value === "string" ? value.trim() : "";
};
var productLabel = function(row) {
    var product = trimmed(row.product);
    if (product === "") return void 0;
    var manufacturer = trimmed(row.manufacturer);
    return manufacturer === "" ? product : "".concat(toDisplayManufacturer2(manufacturer), " ").concat(product);
};
var candidateMeta = function(row) {
    var parts = [];
    var product = productLabel(row);
    if (product !== void 0) parts.push(product);
    var code = trimmed(row.entity_code);
    if (code !== "") parts.push(code);
    return parts.length === 0 ? void 0 : parts.join(" \xB7 ");
};
var registerLinkCandidates = function(rows, layout, twinBid) {
    var _placementIndexFor;
    var claimed = (_placementIndexFor = placementIndexFor(layout)) === null || _placementIndexFor === void 0 ? void 0 : _placementIndexFor.byAssetUid;
    var prefix = twinBid !== null && twinBid !== void 0 ? twinBid : "";
    var identitiesInUse = findDuplicateEntityCodes(layout, twinBid).inUse;
    var candidates2 = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = asArray8(rows)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var row = _step.value;
            if (!row) continue;
            var assetUid = normaliseAssetUid2(row.id);
            if (assetUid === void 0) continue;
            if (claimed === null || claimed === void 0 ? void 0 : claimed.has(assetUid)) continue;
            if (keptOff(row)) continue;
            var label = trimmed(row.asset_name) || trimmed(row.name);
            var entityCode = trimmed(row.entity_code);
            var identity = entityCode === "" ? "" : entityIdentityFor2(prefix, entityCode);
            candidates2.push({
                assetUid: assetUid,
                /*
       * Never blank. A nameless option is unfindable in a searchable list of 200-7,000 rows, and
       * the register's own list already falls back this way (`displayName` in
       * `AssetRegisterList`). The id is the last resort rather than an empty string.
       */ label: label === "" ? "Register row ".concat(row.id) : label,
                meta: candidateMeta(row),
                entityCode: entityCode === "" ? void 0 : entityCode,
                identityContested: identity !== "" && identitiesInUse.has(identity),
                customerId: trimmed(row.customer_asset_identifier) || void 0,
                sourceId: trimmed(row.source_asset_id) || void 0,
                product: productLabel(row)
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return candidates2;
};
var linkCandidateMatches = function(candidate, text2) {
    var needle = text2.trim().toLowerCase();
    if (needle === "") return true;
    return [
        candidate.label,
        candidate.customerId,
        candidate.sourceId
    ].some(function(value) {
        return !!value && value.toLowerCase().includes(needle);
    });
};
var unplacedRowForProduct = function(rows, layout, referenceId) {
    var product = referenceId === null || referenceId === void 0 ? "" : String(referenceId).trim();
    if (product === "") return null;
    var index = placementIndexFor(layout);
    if (!index) return null;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = asArray8(rows)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var row = _step.value;
            if (!row || row.keep_off_plan === true) continue;
            if (row.reference_id === null || row.reference_id === void 0) continue;
            if (String(row.reference_id).trim() !== product) continue;
            var assetUid = normaliseAssetUid2(row.id);
            if (assetUid === void 0 || index.byAssetUid.has(assetUid)) continue;
            return row;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
};
// src/components/Planner/hooks/useRegisterLink.ts
function useRegisterLink(param) {
    var item = param.item, itemRegister = param.itemRegister, registerRead = param.registerRead, registerRows = param.registerRows, layout = param.layout, twinBid = param.twinBid, selectionKey = param.selectionKey, floorIndex = param.floorIndex;
    var updateItem = useFloorplanStore39(function(s) {
        return s.updateItem;
    });
    var markEntityModified = useEditorStore31(function(s) {
        return s.markEntityModified;
    });
    var canOfferRegisterLink = item !== null && (itemRegister.kind === "orphan" || itemRegister.kind === "legacy" && registerRead === "ready");
    var linkCandidates = useMemo18(function() {
        return canOfferRegisterLink ? registerLinkCandidates(registerRows, layout, twinBid) : [];
    }, [
        canOfferRegisterLink,
        registerRows,
        layout,
        twinBid
    ]);
    var _useState29 = _sliced_to_array(useState29(null), 2), unlinkedRefid = _useState29[0], setUnlinkedRefid = _useState29[1];
    var _useState291 = _sliced_to_array(useState29(null), 2), linkedNote = _useState291[0], setLinkedNote = _useState291[1];
    var _useState292 = _sliced_to_array(useState29(null), 2), notesFor = _useState292[0], setNotesFor = _useState292[1];
    if (notesFor !== selectionKey) {
        setNotesFor(selectionKey);
        if (unlinkedRefid !== null) setUnlinkedRefid(null);
        if (linkedNote !== null) setLinkedNote(null);
    }
    var linkToRegisterRow = function(chosen) {
        if (!item) return false;
        var itemHasIdentity = entityIdentityKey3(item.entityCode) !== "";
        var carryIdentity = !itemHasIdentity && chosen.entityCode !== void 0 && !chosen.identityContested;
        updateItem(item.refid, _object_spread({
            assetUid: chosen.assetUid
        }, carryIdentity ? {
            entityCode: chosen.entityCode
        } : {}), {
            floorIndex: floorIndex
        });
        markEntityModified(item.refid);
        var contested = !itemHasIdentity && chosen.entityCode !== void 0 && chosen.identityContested;
        setLinkedNote({
            refid: item.refid,
            text: contested ? "".concat(registerLinkedNote(chosen.label), " ").concat(REGISTER_LINK_IDENTITY_NOT_CARRIED) : registerLinkedNote(chosen.label)
        });
        setUnlinkedRefid(null);
        return true;
    };
    var unlink = function() {
        if (!item) return;
        updateItem(item.refid, {
            assetUid: void 0
        }, {
            floorIndex: floorIndex
        });
        markEntityModified(item.refid);
        setUnlinkedRefid(item.refid);
    };
    var announcement = linkedNote !== null && linkedNote.refid === selectionKey ? linkedNote.text : unlinkedRefid !== null && unlinkedRefid === selectionKey ? UNLINKED_CONFIRMATION_NOTE : "";
    return {
        canOffer: canOfferRegisterLink,
        candidates: linkCandidates,
        link: linkToRegisterRow,
        unlink: unlink,
        announcement: announcement
    };
}
// src/components/Planner/RegisterLinkPicker.tsx
import { useEffect as useEffect28, useId as useId3, useMemo as useMemo19, useRef as useRef27, useState as useState30 } from "react";
import styled28 from "styled-components";
import { Button as Button14, Combobox } from "@repo/design-system";
import { jsx as jsx34, jsxs as jsxs26 } from "react/jsx-runtime";
var PickerBlock = styled28.div(_templateObject129());
var RevealRow = styled28.div(_templateObject130());
var MirrorNote = styled28.span(_templateObject131(), function(param) {
    var t = param.theme;
    return t.colors.neutral[600];
});
function RegisterLinkPicker(param) {
    var candidates2 = param.candidates, registerIsEmpty = param.registerIsEmpty, itemName2 = param.itemName, onChoose = param.onChoose;
    var _useState30 = _sliced_to_array(useState30(false), 2), open = _useState30[0], setOpen = _useState30[1];
    var mirrorNoteId = useId3();
    var revealRef = useRef27(null);
    var panelRef = useRef27(null);
    var options = useMemo19(function() {
        return candidates2.map(function(c) {
            return {
                value: c.assetUid,
                label: c.label,
                meta: c.meta
            };
        });
    }, [
        candidates2
    ]);
    useEffect28(function() {
        var _panelRef_current_querySelector, _panelRef_current;
        if (!open) return;
        (_panelRef_current = panelRef.current) === null || _panelRef_current === void 0 ? void 0 : (_panelRef_current_querySelector = _panelRef_current.querySelector("input")) === null || _panelRef_current_querySelector === void 0 ? void 0 : _panelRef_current_querySelector.focus();
    }, [
        open
    ]);
    var close = function() {
        var _revealRef_current;
        setOpen(false);
        (_revealRef_current = revealRef.current) === null || _revealRef_current === void 0 ? void 0 : _revealRef_current.focus();
    };
    return /* @__PURE__ */ jsxs26(PickerBlock, {
        onKeyDown: function(e) {
            if (e.key === "Escape" && !e.defaultPrevented && open) close();
        },
        children: [
            /* @__PURE__ */ jsx34(RevealRow, {
                children: /* @__PURE__ */ jsx34(Button14, {
                    ref: revealRef,
                    variant: "ghost",
                    size: "xs",
                    "aria-label": registerLinkAccessibleName(itemName2),
                    "aria-expanded": open,
                    onClick: function() {
                        return open ? close() : setOpen(true);
                    },
                    children: REGISTER_LINK_BUTTON_LABEL
                })
            }),
            open && /* @__PURE__ */ jsxs26("div", {
                ref: panelRef,
                children: [
                    /* @__PURE__ */ jsx34(MirrorNote, {
                        id: mirrorNoteId,
                        children: REGISTER_LINK_MIRROR_NOTE
                    }),
                    /* @__PURE__ */ jsx34(Combobox, {
                        maxResults: 50,
                        capText: function(shown2, total) {
                            return "Showing ".concat(shown2, " of ").concat(total, " — keep typing to narrow");
                        },
                        "aria-label": REGISTER_LINK_COMBOBOX_LABEL,
                        "aria-describedby": mirrorNoteId,
                        options: options,
                        value: void 0,
                        placeholder: REGISTER_LINK_SEARCH_PLACEHOLDER,
                        emptyText: candidates2.length === 0 ? registerIsEmpty ? REGISTER_LINK_EMPTY_REGISTER : REGISTER_LINK_ALL_PLACED : REGISTER_LINK_NO_MATCH,
                        commitOnClose: false,
                        onChange: function(next) {
                            if (next === null) return;
                            var chosen = candidates2.find(function(c) {
                                return c.assetUid === next;
                            });
                            if (!chosen) return;
                            onChoose(chosen);
                            setOpen(false);
                        }
                    })
                ]
            })
        ]
    });
}
// src/components/Planner/hooks/useCameraEdited.tsx
import { createContext as createContext11, useCallback as useCallback15, useContext as useContext15, useRef as useRef28 } from "react";
import { jsx as jsx35 } from "react/jsx-runtime";
var CameraEditedContext = createContext11(void 0);
var CameraEditedProvider = function(param) {
    var onCameraEdited = param.onCameraEdited, children = param.children;
    var latest = useRef28(onCameraEdited);
    latest.current = onCameraEdited;
    var report = useCallback15(function() {
        var _latest_current;
        return (_latest_current = latest.current) === null || _latest_current === void 0 ? void 0 : _latest_current.call(latest);
    }, []);
    return /* @__PURE__ */ jsx35(CameraEditedContext.Provider, {
        value: report,
        children: children
    });
};
var NOTHING = function() {
    return void 0;
};
var useCameraEdited = function() {
    var _useContext15;
    return (_useContext15 = useContext15(CameraEditedContext)) !== null && _useContext15 !== void 0 ? _useContext15 : NOTHING;
};
// src/components/Planner/PlannerJoinedLayout.tsx
import { jsx as jsx36 } from "react/jsx-runtime";
function PlannerJoinedLayout(param) {
    var twinBid = param.twinBid, twinId = param.twinId, children = param.children;
    var joined2 = useJoinedLayout(twinBid, twinId);
    return /* @__PURE__ */ jsx36(PlannerLayoutContext.Provider, {
        value: joined2,
        children: children
    });
}
// src/components/Planner/machineCard/MachineDeleteFlow.tsx
import { useEffect as useEffect30, useMemo as useMemo20, useRef as useRef30, useState as useState32 } from "react";
import styled29 from "styled-components";
import { Button as Button15, Icon as Icon14, Modal as Modal5, Tag as Tag4 } from "@repo/design-system";
import { fontMono as fontMono4, glass as glass2, inset as inset4, radius as radius7, semantic as semantic12, space as space18, typeRole as typeRole13, typeScale as typeScale2, weight as weight4 } from "@repo/design-tokens";
import { registerReadState as registerReadState8, useEditorStore as useEditorStore34, useEquipmentCatalogStore as useEquipmentCatalogStore18, useFloorplanStore as useFloorplanStore43 } from "@repo/front-end-state";
import { deleteMachineSummary, findLatestDesign as findLatestDesign15, isLive as isLive9, resolveItemRegisterState as resolveItemRegisterState2 } from "@repo/front-end-utils";
// src/components/Planner/spaceCard/spaceDeletion.ts
import { planSurfaceRemoval, registerReadState as registerReadState7, useEquipmentCatalogStore as useEquipmentCatalogStore17, useFloorplanStore as useFloorplanStore42 } from "@repo/front-end-state";
import { deleteSpaceSummary, findLatestDesign as findLatestDesign14, isLive as isLive8, resolvePlanHierarchy as resolvePlanHierarchy3, resolvePlanParentage as resolvePlanParentage5 } from "@repo/front-end-utils";
// src/components/Planner/hooks/usePlanDrops.ts
import { useCallback as useCallback16, useEffect as useEffect29, useRef as useRef29, useState as useState31 } from "react";
import { useFloorplanStore as useFloorplanStore41 } from "@repo/front-end-state";
import { useEditorStore as useEditorStore33 } from "@repo/front-end-state";
import { useEquipmentCatalogStore as useEquipmentCatalogStore16, RegisterWriteRefused as RegisterWriteRefused2, registerReadState as registerReadState6 } from "@repo/front-end-state";
import { entityIdentityFor as entityIdentityFor3, snapPlannerPoint } from "@repo/front-end-utils";
import { findLatestDesign as findLatestDesign13, layoutCurrentDesigns as layoutCurrentDesigns7, asArray as asArray9, isLive as isLive7 } from "@repo/front-end-utils";
import { nameForNewcomer as nameForNewcomer2, resolveItemBaseName } from "@repo/front-end-utils";
import { highWaterMarkFor, mintEntityBid, reservedRegisterIdentities } from "@repo/front-end-utils";
import { normaliseAssetUid as normaliseAssetUid5 } from "@repo/frontend-types";
// src/components/Planner/hooks/dropPayload.ts
import { normaliseAssetUid as normaliseAssetUid3 } from "@repo/frontend-types";
import { flatShareFilename as flatShareFilename4 } from "@repo/front-end-utils";
var MAX_TEXT_LENGTH = 255;
var optionalString = function(value) {
    if (typeof value !== "string") return void 0;
    var trimmed2 = value.trim();
    return trimmed2 === "" ? void 0 : trimmed2;
};
var boundedLabel = function(value) {
    var label = optionalString(value);
    if (label === void 0) return void 0;
    return label.length > MAX_TEXT_LENGTH ? void 0 : label;
};
var finiteNumber = function(value) {
    return typeof value === "number" && Number.isFinite(value) ? value : void 0;
};
var MAX_ENTITY_CODE_LENGTH = 64;
var entityCodeToken = function(value) {
    var code = optionalString(value);
    if (code === void 0) return void 0;
    if (code.length > MAX_ENTITY_CODE_LENGTH) return void 0;
    if (/[\s\u0000-\u001f\u007f]/.test(code)) return void 0;
    return code;
};
var readDropPayload = function(raw) {
    var parsed;
    try {
        parsed = JSON.parse(raw);
    } catch (e) {
        return null;
    }
    if ((typeof parsed === "undefined" ? "undefined" : _type_of(parsed)) !== "object" || parsed === null || Array.isArray(parsed)) return null;
    var data = parsed;
    var payload = {
        product: boundedLabel(data.product),
        productLine: boundedLabel(data.productLine),
        manufacturer: boundedLabel(data.manufacturer),
        referenceId: boundedLabel(data.referenceId),
        assetUid: normaliseAssetUid3(data.assetUid),
        entityCode: entityCodeToken(data.entityCode),
        capacity: finiteNumber(data.capacity),
        model: flatShareFilename4(data.model)
    };
    var refid = boundedLabel(data.refid);
    var named2 = refid !== void 0 || payload.product !== void 0 || payload.productLine !== void 0 || payload.manufacturer !== void 0 || payload.referenceId !== void 0 || payload.entityCode !== void 0 || payload.model !== null;
    if (!named2) {
        console.warn("[readDropPayload] refused a drag payload that names nothing placeable; keys offered:", Object.keys(data).join(", ") || "(none)");
        return null;
    }
    return _object_spread({}, payload, refid === void 0 ? {} : {
        refid: refid
    });
};
var summariseKeys = function(data) {
    var keys = Object.keys(data);
    if (keys.length === 0) return "(none)";
    var shown2 = keys.slice(0, 10).map(function(k) {
        return k.slice(0, 40).replace(/[\r\n\u0000-\u001f]/g, "?");
    });
    return keys.length > 10 ? "".concat(shown2.join(", "), " (+").concat(keys.length - 10, " more)") : shown2.join(", ");
};
var streamEndpointId = function(value) {
    return typeof value === "number" && Number.isInteger(value) ? value : null;
};
var readDrop = function(dataTransfer) {
    var rawStream = dataTransfer.getData(STREAM_DRAG_TYPE);
    if (rawStream) {
        var parsed;
        try {
            parsed = JSON.parse(rawStream);
        } catch (e) {
            parsed = void 0;
        }
        if ((typeof parsed === "undefined" ? "undefined" : _type_of(parsed)) === "object" && parsed !== null && !Array.isArray(parsed)) {
            var data = parsed;
            if ("rtspEndpointId" in data) {
                var rtspEndpointId = streamEndpointId(data.rtspEndpointId);
                if (rtspEndpointId === null) {
                    console.warn("[readDrop] refused a stream drag payload with no usable rtspEndpointId; keys offered:", summariseKeys(data));
                    return null;
                }
                return {
                    stream: {
                        rtspEndpointId: rtspEndpointId
                    }
                };
            }
        }
    }
    var item = readDropPayload(dataTransfer.getData("application/json"));
    return item ? {
        item: item
    } : null;
};
// src/components/Planner/hooks/cameraHitTest.ts
import { pixelsToMeters } from "@repo/front-end-utils";
// src/components/Planner/canvas/cameraMarker.ts
var CAMERA_MARKER_SIZE_PX = 22;
var CAMERA_MARKER_SELECTED_SIZE_PX = 26;
var CAMERA_HIT_RADIUS_SCREEN_PX = CAMERA_MARKER_SELECTED_SIZE_PX / 2;
// src/components/Planner/hooks/cameraHitTest.ts
var cameraHitRadiusM = function(zoom) {
    return pixelsToMeters(CAMERA_HIT_RADIUS_SCREEN_PX / Math.max(zoom, 0.01));
};
var cameraAtPoint = function(cameras, point, zoom) {
    var radius13 = cameraHitRadiusM(zoom);
    var best = null;
    var bestDistance = Number.POSITIVE_INFINITY;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = cameras[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var camera = _step.value;
            var distance2 = Math.hypot(camera.x - point.x, camera.y - point.y);
            if (distance2 <= radius13 && distance2 < bestDistance) {
                best = camera;
                bestDistance = distance2;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return best;
};
// src/components/Planner/canvas/cameraIdentity.ts
import { coveragePatch } from "@repo/front-end-utils";
var mintCameraRefid = function() {
    return "CAM-".concat(Date.now().toString(36).toUpperCase(), "-").concat(Math.random().toString(36).slice(2, 6).toUpperCase());
};
var newCameraShape = function(x, y) {
    var rotation = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    return _object_spread({
        x: x,
        y: y,
        rotation: rotation
    }, coveragePatch("wide"));
};
var newCameraAt = function(x, y) {
    return _object_spread({
        refid: mintCameraRefid()
    }, newCameraShape(x, y));
};
// src/components/Planner/canvas/planCameraGeometry.ts
import { angleDiff, CAMERA_COVERAGE_PRESETS, CAMERA_DISTANCE_MIN, effectiveCoverage, normaliseRotation, PIXELS_PER_METER, snapRotationDrag } from "@repo/front-end-utils";
var TURN_HANDLE_REACH_FRACTION = 0.42;
var TURN_HANDLE_MIN_SCREEN_PX = 28;
var REACH_HANDLE_MIN_SCREEN_PX = 56;
var WIDEN_SNAP_DEG = 3;
var WIDEN_MIN_DEG = 1;
var WIDEN_MAX_DEG = 359;
var NUDGE_M = 1;
var KEY_TURN_DEG = 5;
var WIDEN_MARKS = CAMERA_COVERAGE_PRESETS.filter(function(p) {
    return p.fovAngle < 360;
}).map(function(p) {
    return {
        label: p.label,
        fovAngle: p.fovAngle
    };
});
var toRad = function(deg) {
    return deg * Math.PI / 180;
};
var along = function(origin, deg, distance2) {
    return {
        x: origin.x + Math.cos(toRad(deg)) * distance2,
        y: origin.y + Math.sin(toRad(deg)) * distance2
    };
};
var bearing = function(from, to) {
    return Math.atan2(to.y - from.y, to.x - from.x) * 180 / Math.PI;
};
var handlePositions = function(camera, zoom) {
    var _effectiveCoverage = effectiveCoverage(camera), fovAngle = _effectiveCoverage.fovAngle, detectionDistance = _effectiveCoverage.detectionDistance;
    var origin = {
        x: camera.x,
        y: camera.y
    };
    var perScreenPx = 1 / (Math.max(zoom, 0.01) * PIXELS_PER_METER);
    var reachDrawn = Math.max(detectionDistance, REACH_HANDLE_MIN_SCREEN_PX * perScreenPx);
    var full = fovAngle >= 360;
    return {
        turn: full ? null : along(origin, camera.rotation, Math.max(TURN_HANDLE_REACH_FRACTION * detectionDistance, TURN_HANDLE_MIN_SCREEN_PX * perScreenPx)),
        widen: full ? null : along(origin, camera.rotation + fovAngle / 2, reachDrawn),
        reach: along(origin, camera.rotation, reachDrawn)
    };
};
var dragHandleValue = function(camera, kind, press, pointer) {
    var _effectiveCoverage = effectiveCoverage(camera), fovAngle = _effectiveCoverage.fovAngle, detectionDistance = _effectiveCoverage.detectionDistance;
    if (kind === "reach") {
        var travel = Math.hypot(pointer.x - camera.x, pointer.y - camera.y) - Math.hypot(press.x - camera.x, press.y - camera.y);
        return {
            detectionDistance: Math.max(CAMERA_DISTANCE_MIN, Math.round(detectionDistance + travel))
        };
    }
    var turned = bearing(camera, pointer) - bearing(camera, press);
    if (kind === "turn") {
        return {
            rotation: snapRotationDrag(camera.rotation + turned)
        };
    }
    return {
        fovAngle: widenFromPointer(camera, along(camera, camera.rotation + fovAngle / 2 + turned, 1))
    };
};
var SIDE_LABEL_FLIP_EDGE_PX = 160;
var sideLabelPlacement = function(anchorX, paneWidth, preferred) {
    var room = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : SIDE_LABEL_FLIP_EDGE_PX;
    if (preferred === "right") return anchorX > paneWidth - room ? "left" : "right";
    return anchorX < room ? "right" : "left";
};
var DROP_LABEL_ROOM_PX = 11 + 7 + 200;
var FACING_CENTRE_MIN_M = 0.5;
var facingPlanCentre = function(point, bounds) {
    if (!bounds) return 0;
    var centre = {
        x: (bounds.minX + bounds.maxX) / 2,
        y: (bounds.minY + bounds.maxY) / 2
    };
    if (Math.hypot(centre.x - point.x, centre.y - point.y) < FACING_CENTRE_MIN_M) return 0;
    return normaliseRotation(Math.round(bearing(point, centre)));
};
var widenFromPointer = function(camera, pointer) {
    var raw = Math.round(2 * angleDiff(bearing(camera, pointer), camera.rotation));
    var clamped = Math.min(WIDEN_MAX_DEG, Math.max(WIDEN_MIN_DEG, raw));
    var mark = WIDEN_MARKS.find(function(m) {
        return Math.abs(clamped - m.fovAngle) <= WIDEN_SNAP_DEG;
    });
    return mark ? mark.fovAngle : clamped;
};
var turnByKey = function(rotation, clockwiseOnScreen) {
    return normaliseRotation(rotation + (clockwiseOnScreen ? -KEY_TURN_DEG : KEY_TURN_DEG));
};
var turnReadout = function(rotation) {
    return "".concat(Math.round(normaliseRotation(rotation)) % 360, "\xb0");
};
var widenReadout = function(fovAngle) {
    var mark = WIDEN_MARKS.find(function(m) {
        return m.fovAngle === fovAngle;
    });
    return mark ? "".concat(mark.label, " \xb7 ").concat(fovAngle, "\xb0") : "".concat(fovAngle, "\xb0");
};
var reachReadout = function(detectionDistance) {
    return "".concat(detectionDistance, " m");
};
var cameraHasStream = function(camera) {
    return camera.rtspEndpointId != null;
};
var coneLook = function(camera, state) {
    if (state.selectedIds.includes(camera.refid)) return "selected";
    if (state.litRefid != null && camera.refid === state.litRefid) return "lit";
    if (!cameraHasStream(camera)) return "noStream";
    return "other";
};
var LAYER = {
    other: 0,
    noStream: 1,
    lit: 1,
    selected: 2
};
var orderCones = function(cameras, state) {
    return cameras.map(function(camera, index) {
        return {
            camera: camera,
            look: coneLook(camera, state),
            index: index
        };
    }).sort(function(a, b) {
        return LAYER[a.look] - LAYER[b.look] || a.index - b.index;
    }).map(function(param) {
        var camera = param.camera, look = param.look;
        return {
            camera: camera,
            look: look
        };
    });
};
// src/components/Planner/twinNameIndex.ts
import { useEditorStore as useEditorStore32, useEquipmentCatalogStore as useEquipmentCatalogStore15, useFloorplanStore as useFloorplanStore40 } from "@repo/front-end-state";
import { buildTwinNameIndex as buildTwinNameIndex3, joinRegisterOntoPlan as joinRegisterOntoPlan3, nameKey, renameInLayout } from "@repo/front-end-utils";
import { normaliseAssetUid as normaliseAssetUid4 } from "@repo/frontend-types";
var currentTwinNameIndex = function(twinBid) {
    var _useFloorplanStore40_getState = useFloorplanStore40.getState(), layout = _useFloorplanStore40_getState.layout, scope = _useFloorplanStore40_getState.twinBID;
    var registerRows = useEquipmentCatalogStore15.getState().registerRows;
    var index = buildTwinNameIndex3(joinRegisterOntoPlan3(layout, registerRows, twinBid), registerRows);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Array.from(pendingNewcomers.values())[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entry = _step.value;
            if (entry.scope !== (scope !== null && scope !== void 0 ? scope : null)) continue;
            var key = nameKey(entry.name);
            var list = index.byKey.get(key);
            if (list) list.push(entry);
            else index.byKey.set(key, [
                entry
            ]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return index;
};
var pendingNewcomers = /* @__PURE__ */ new Map();
var pendingSeq = 0;
function reserveNewcomerName(name) {
    pendingSeq += 1;
    var marker = "pending:".concat(pendingSeq);
    var _useFloorplanStore40_getState_twinBID;
    var entry = {
        scope: (_useFloorplanStore40_getState_twinBID = useFloorplanStore40.getState().twinBID) !== null && _useFloorplanStore40_getState_twinBID !== void 0 ? _useFloorplanStore40_getState_twinBID : null,
        name: name,
        kind: "machine",
        ref: {
            type: "item",
            refid: marker
        }
    };
    pendingNewcomers.set(marker, entry);
    return {
        release: function() {
            pendingNewcomers.delete(marker);
        },
        takeRename: function() {
            var to = entry.renameTo;
            entry.renameTo = void 0;
            return to;
        }
    };
}
function applyHolderRename(renameHolder) {
    if (!renameHolder) return;
    var entry = renameHolder.entry, to = renameHolder.to;
    var ref = entry.ref;
    if (ref.type === "item" && pendingNewcomers.has(ref.refid)) {
        var pending = pendingNewcomers.get(ref.refid);
        pending.renameTo = to;
        pending.name = to;
        return;
    }
    var catalog = useEquipmentCatalogStore15.getState();
    var row = ref.type === "register" ? catalog.registerRows.find(function(r) {
        return r.id === ref.assetId;
    }) : entry.assetUid !== void 0 ? catalog.registerRows.find(function(r) {
        return normaliseAssetUid4(r.id) === entry.assetUid;
    }) : void 0;
    if (row) renameRegisterRow(row.id, to);
    else {
        if (ref.type !== "item" && ref.type !== "surface") return;
        var _useFloorplanStore40_getState = useFloorplanStore40.getState(), layout = _useFloorplanStore40_getState.layout, replaceLayout = _useFloorplanStore40_getState.replaceLayout;
        if (!layout) return;
        var next = renameInLayout(layout, ref, to);
        if (next === layout) return;
        replaceLayout(next);
        useEditorStore32.getState().markEntityModified(ref.refid);
    }
}
function renameRegisterRow(assetId, to) {
    useEquipmentCatalogStore15.getState().updateRegisterAsset(assetId, {
        asset_name: to
    }).catch(function(error) {
        var _useEquipmentCatalogStore15_getState_registerContext;
        var failure = error;
        console.warn("[unique-names] first-copy rename failed", {
            twinId: (_useEquipmentCatalogStore15_getState_registerContext = useEquipmentCatalogStore15.getState().registerContext) === null || _useEquipmentCatalogStore15_getState_registerContext === void 0 ? void 0 : _useEquipmentCatalogStore15_getState_registerContext.twinId,
            assetId: assetId,
            to: to,
            status: failure === null || failure === void 0 ? void 0 : failure.status,
            reason: failure === null || failure === void 0 ? void 0 : failure.reason,
            name: failure === null || failure === void 0 ? void 0 : failure.name,
            message: failure === null || failure === void 0 ? void 0 : failure.message
        });
    });
}
// src/components/Planner/canvas/streamDropPreview.ts
import { useSyncExternalStore as useSyncExternalStore4 } from "react";
var isDeferredClaim = function(result) {
    return (typeof result === "undefined" ? "undefined" : _type_of(result)) === "object" && result !== null && result.deferred === true;
};
var isReplace = function(check) {
    return !!check && "replaceFrom" in check;
};
var isRefused = function(check) {
    return !!check && "refusal" in check;
};
var hasStream = function(camera) {
    return camera.rtspEndpointId != null;
};
var nearestLinkTarget = function(cameras, point, refused) {
    var best = null;
    var bestDistance = Number.POSITIVE_INFINITY;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = cameras[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var camera = _step.value;
            if (hasStream(camera) || refused(camera.refid)) continue;
            var distance2 = Math.hypot(camera.x - point.x, camera.y - point.y);
            if (distance2 < bestDistance) {
                best = camera;
                bestDistance = distance2;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return best;
};
var streamDropHint = function(param) {
    var streamLabel = param.streamLabel, streamId = param.streamId, target = param.target, check = param.check;
    if (check && "refusal" in check) {
        return {
            tone: "coral",
            icon: "circle-exclamation",
            text: check.refusal
        };
    }
    if (isReplace(check)) {
        return {
            tone: "butter",
            icon: "arrow-right-arrow-left",
            text: "Drop to replace ".concat(check.replaceFrom, " with ").concat(streamLabel)
        };
    }
    var releaseFrom = check && "releaseFrom" in check ? check.releaseFrom : null;
    if (!target) {
        return releaseFrom ? {
            tone: "butter",
            icon: "plus",
            text: "Drop to move ".concat(streamLabel, " here from ").concat(releaseFrom)
        } : {
            tone: "butter",
            icon: "plus",
            text: "Drop to place a camera for ".concat(streamLabel)
        };
    }
    if (target.camera.rtspEndpointId === streamId) {
        return {
            text: "".concat(target.name, " already shows ").concat(streamLabel)
        };
    }
    return releaseFrom ? {
        tone: "butter",
        icon: "link",
        text: "Drop to move ".concat(streamLabel, " to ").concat(target.name)
    } : {
        tone: "butter",
        icon: "link",
        text: "Drop to link ".concat(streamLabel, " to ").concat(target.name)
    };
};
var samePoint = function(a, b) {
    return a === b || !!a && !!b && a.pane.x === b.pane.x && a.pane.y === b.pane.y && a.raw.x === b.raw.x && a.raw.y === b.raw.y && a.snapped.x === b.snapped.x && a.snapped.y === b.snapped.y;
};
var createStreamDragPointStore = function() {
    var current2 = null;
    var listeners2 = /* @__PURE__ */ new Set();
    return {
        get: function() {
            return current2;
        },
        set: function(next) {
            if (samePoint(current2, next)) return;
            current2 = next;
            listeners2.forEach(function(l) {
                return l();
            });
        },
        subscribe: function(listener) {
            listeners2.add(listener);
            return function() {
                return listeners2.delete(listener);
            };
        }
    };
};
var useStreamDragPoint = function(store) {
    return useSyncExternalStore4(store.subscribe, store.get, store.get);
};
var CHECK_THREW = "threw";
var safeClaimCheck = function(check, endpointId, targetRefid, onThrow) {
    if (!check) return void 0;
    try {
        return check(endpointId, targetRefid);
    } catch (error) {
        onThrow(error);
        return CHECK_THREW;
    }
};
var streamDropAnswer = function(param) {
    var point = param.point, drag = param.drag, cameras = param.cameras, check = param.check, hit = param.hit, shape = param.shape, nameOf2 = param.nameOf, onThrow = param.onThrow;
    var ask = function(refid) {
        return safeClaimCheck(check, drag.rtspEndpointId, refid, onThrow);
    };
    var target = hit(cameras, point.raw);
    var _target_refid;
    var targetCheck = ask((_target_refid = target === null || target === void 0 ? void 0 : target.refid) !== null && _target_refid !== void 0 ? _target_refid : null);
    if (targetCheck === CHECK_THREW) return {
        target: target,
        hint: null,
        link: null,
        preview: null,
        replace: false
    };
    var hint = streamDropHint({
        streamLabel: drag.label,
        streamId: drag.rtspEndpointId,
        target: target ? {
            camera: target,
            name: nameOf2(target.refid)
        } : null,
        check: targetCheck
    });
    var threw = false;
    var link = nearestLinkTarget(cameras, point.snapped, function(refid) {
        var answer = ask(refid);
        if (answer === CHECK_THREW) threw = true;
        return answer === CHECK_THREW || isRefused(answer);
    });
    if (threw) return {
        target: target,
        hint: null,
        link: null,
        preview: null,
        replace: false
    };
    var places = !target && !isRefused(targetCheck);
    return {
        target: target,
        hint: hint,
        link: link && link.refid !== (target === null || target === void 0 ? void 0 : target.refid) ? link : null,
        preview: places ? shape(point.snapped) : null,
        replace: !!target && isReplace(targetCheck)
    };
};
// src/components/Planner/hooks/usePlanDrops.ts
var ADDED_NOT_PLACED = "Added to the register, not placed";
var currentActiveFloorCameras = function() {
    var _layout_floors_activeFloorIndex;
    var _useFloorplanStore41_getState = useFloorplanStore41.getState(), layout = _useFloorplanStore41_getState.layout, activeFloorIndex = _useFloorplanStore41_getState.activeFloorIndex;
    var design = findLatestDesign13(asArray9(layout === null || layout === void 0 ? void 0 : (_layout_floors_activeFloorIndex = layout.floors[activeFloorIndex]) === null || _layout_floors_activeFloorIndex === void 0 ? void 0 : _layout_floors_activeFloorIndex.designs));
    return asArray9(design === null || design === void 0 ? void 0 : design.cameras).filter(function(c) {
        return !c._deleted;
    });
};
var currentPlacedEntityCodes = function(twinBid) {
    var designs = layoutCurrentDesigns7(useFloorplanStore41.getState().layout);
    var codes = /* @__PURE__ */ new Set();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = designs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var design = _step.value;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = _to_consumable_array(asArray9(design === null || design === void 0 ? void 0 : design.items)).concat(_to_consumable_array(asArray9(design === null || design === void 0 ? void 0 : design.surfaces)))[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var entry = _step1.value;
                    if (!isLive7(entry)) continue;
                    var code = entityIdentityFor3(twinBid, entry.entityCode);
                    if (code) codes.add(code);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return codes;
};
var currentHighWaterMark = function(twinBid, liveEntityBids) {
    var _register_registerContext;
    var register = useEquipmentCatalogStore16.getState();
    var registerVerified = registerReadState6(register, {
        twinId: (_register_registerContext = register.registerContext) === null || _register_registerContext === void 0 ? void 0 : _register_registerContext.twinId
    }) === "ready";
    return {
        mark: highWaterMarkFor(useFloorplanStore41.getState().layout, liveEntityBids, reservedRegisterIdentities(register.registerRows, twinBid), twinBid),
        registerVerified: registerVerified
    };
};
var EMPTY_BIDS = /* @__PURE__ */ new Set();
var IDLE2 = {
    kind: "idle"
};
var PENDING = {
    kind: "pending"
};
var captureDropTarget = function() {
    var _layout_floors_activeFloorIndex, _layout_floors;
    var _useFloorplanStore41_getState = useFloorplanStore41.getState(), layout = _useFloorplanStore41_getState.layout, activeFloorIndex = _useFloorplanStore41_getState.activeFloorIndex, twinBID = _useFloorplanStore41_getState.twinBID;
    return {
        twinBID: twinBID,
        floorId: layout === null || layout === void 0 ? void 0 : (_layout_floors = layout.floors) === null || _layout_floors === void 0 ? void 0 : (_layout_floors_activeFloorIndex = _layout_floors[activeFloorIndex]) === null || _layout_floors_activeFloorIndex === void 0 ? void 0 : _layout_floors_activeFloorIndex.id,
        layoutId: layout === null || layout === void 0 ? void 0 : layout.id
    };
};
var resolveDropTarget = function(target) {
    var _useFloorplanStore41_getState = useFloorplanStore41.getState(), layout = _useFloorplanStore41_getState.layout, activeFloorIndex = _useFloorplanStore41_getState.activeFloorIndex, twinBID = _useFloorplanStore41_getState.twinBID;
    if (twinBID !== target.twinBID || !layout) return {
        kind: "gone"
    };
    if (layout.id !== void 0 && target.layoutId !== void 0 && layout.id !== target.layoutId) {
        return {
            kind: "gone"
        };
    }
    if (target.floorId === void 0) return {
        kind: "gone"
    };
    var floors = asArray9(layout.floors);
    if (floors.filter(function(floor) {
        return (floor === null || floor === void 0 ? void 0 : floor.id) === target.floorId;
    }).length !== 1) return {
        kind: "gone"
    };
    var index = floors.findIndex(function(floor) {
        return (floor === null || floor === void 0 ? void 0 : floor.id) === target.floorId;
    });
    if (index !== activeFloorIndex) return {
        kind: "moved"
    };
    var active = floors[index];
    var designs = asArray9(active.designs);
    var design = findLatestDesign13(designs);
    if (designs.indexOf(design) === -1) return {
        kind: "unusable"
    };
    return {
        kind: "ok",
        layout: layout,
        design: design
    };
};
var targetChangeMessage = function(name, kind, createdThisDrop) {
    var lead = createdThisDrop ? "“".concat(name, "” was added to the Asset Register, but ") : "“".concat(name, "” is in the Asset Register, but ");
    var cause = {
        moved: "you moved to a different floor before it could be placed. Drag it from Your Assets when you are back on the floor you want.",
        /*
     * Worded for all THREE causes that reach it, not only the obvious one (Copilot, round 1).
     * `gone` covers a deleted floor — but also a floor whose identity could not be established,
     * and one whose id is ambiguous because two floors share it. In those last two the floor is
     * still on screen, so "no longer part of the plan" is wrong and "drag it again" is refused
     * identically every time. "Could not be found" is true of all three, and reloading the plan
     * is the step that actually changes the outcome for the two identity cases.
     */ gone: "the floor it was dropped on could not be found in the plan. Reload the plan, or pick another floor, then drag it from Your Assets.",
        unusable: "that floor has no plan drawing to place it onto. Reload the plan, or try another floor, then drag it from Your Assets."
    }[kind];
    return lead + cause;
};
var postCommitMessage = function(name) {
    return "“".concat(name, "” was added to the Asset Register, but the server's reply could not be read, so it could not be placed or traced. Check the Equipment list before dragging it again.");
};
var registerNameFor = function(assetUid, fallback) {
    var _registerRowFor;
    var _registerRowFor_asset_name;
    return (_registerRowFor_asset_name = (_registerRowFor = registerRowFor(assetUid)) === null || _registerRowFor === void 0 ? void 0 : _registerRowFor.asset_name) !== null && _registerRowFor_asset_name !== void 0 ? _registerRowFor_asset_name : fallback;
};
var registerRowFor = function(assetUid) {
    return assetUid ? useEquipmentCatalogStore16.getState().registerRows.find(function(r) {
        return normaliseAssetUid5(r.id) === assetUid;
    }) : void 0;
};
var placementFailureMessage = function(error, name) {
    if (_instanceof(error, RegisterWriteRefused2)) {
        return error.message;
    }
    var timedOut = (typeof error === "undefined" ? "undefined" : _type_of(error)) === "object" && error !== null && "name" in error && (error.name === "TimeoutError" || error.name === "AbortError");
    if (timedOut) {
        return "Could not add “".concat(name, "” to the Asset Register — the request timed out. The asset may already have been added, so check the Equipment list before dragging it again.");
    }
    var full = _instanceof(error, Error) && error.message ? error.message.trim() : "";
    var raw = !full ? "the request failed" : full.length > 200 ? "".concat(full.slice(0, 200), "…") : full;
    var reason = raw.endsWith(".") && !raw.endsWith("..") ? raw.slice(0, -1) : raw;
    return "Could not add “".concat(name, "” to the Asset Register — ").concat(reason, ".");
};
function usePlanDrops(param) {
    var surfaceRef = param.surfaceRef, twinBid = param.twinBid, _param_liveEntityBids = param.// `EMPTY_BIDS`, a module constant, rather than an inline `new Set()` — a fresh Set per render
    // would change identity on every render and defeat the `useCallback` dependency below.
    liveEntityBids, liveEntityBids = _param_liveEntityBids === void 0 ? EMPTY_BIDS : _param_liveEntityBids, _param_identitiesVerified = param.identitiesVerified, identitiesVerified = _param_identitiesVerified === void 0 ? true : _param_identitiesVerified, onStreamClaim = param.onStreamClaim, onStreamLinked = param.onStreamLinked, onCameraEdited = param.onCameraEdited, _param_facingBounds = param.facingBounds, facingBounds = _param_facingBounds === void 0 ? null : _param_facingBounds, _param_activeStreamDrag = param.activeStreamDrag, activeStreamDrag = _param_activeStreamDrag === void 0 ? null : _param_activeStreamDrag, _param_activeEquipmentDrag = param.activeEquipmentDrag, activeEquipmentDrag = _param_activeEquipmentDrag === void 0 ? false : _param_activeEquipmentDrag;
    var addItem = useFloorplanStore41(function(s) {
        return s.addItem;
    });
    var updateItem = useFloorplanStore41(function(s) {
        return s.updateItem;
    });
    var addCamera = useFloorplanStore41(function(s) {
        return s.addCamera;
    });
    var selectEntity = useEditorStore33(function(s) {
        return s.selectEntity;
    });
    var markEntityModified = useEditorStore33(function(s) {
        return s.markEntityModified;
    });
    var storeOriginalPosition = useEditorStore33(function(s) {
        return s.storeOriginalPosition;
    });
    var pushSnapshot = useEditorStore33(function(s) {
        return s.pushSnapshot;
    });
    var gridSnap = useEditorStore33(function(s) {
        return s.gridSnap;
    });
    var gridSize = useEditorStore33(function(s) {
        return s.gridSize;
    });
    var createRegisterAsset = useEquipmentCatalogStore16(function(s) {
        return s.createRegisterAsset;
    });
    var recordUnverifiedMint = useFloorplanStore41(function(s) {
        return s.recordUnverifiedMint;
    });
    var _useState31 = _sliced_to_array(useState31(IDLE2), 2), dropStatus = _useState31[0], setDropStatus = _useState31[1];
    var pendingCreates = useRef29(0);
    var clearDropStatus = useCallback16(function() {
        return setDropStatus(pendingCreates.current > 0 ? PENDING : IDLE2);
    }, []);
    var dropPointAt = useCallback16(function(surface11, clientX, clientY, free) {
        var raw = surface11.clientToPlan(clientX, clientY);
        var snapped = snapPlannerPoint(raw, {
            gridSnap: gridSnap,
            gridSizeCm: gridSize,
            free: free
        });
        return {
            raw: raw,
            snapped: snapped
        };
    }, [
        gridSnap,
        gridSize
    ]);
    var _useState311 = _sliced_to_array(useState31(createStreamDragPointStore), 1), streamDragPointStore = _useState311[0];
    var pendingPoint = useRef29(null);
    var pointFrame = useRef29(null);
    var clearStreamDragPoint = useCallback16(function() {
        if (pointFrame.current !== null) cancelAnimationFrame(pointFrame.current);
        pointFrame.current = null;
        pendingPoint.current = null;
        streamDragPointStore.set(null);
    }, [
        streamDragPointStore
    ]);
    useEffect29(function() {
        if (!activeStreamDrag) clearStreamDragPoint();
    }, [
        activeStreamDrag,
        clearStreamDragPoint
    ]);
    useEffect29(function() {
        return clearStreamDragPoint;
    }, [
        clearStreamDragPoint
    ]);
    var _useState312 = _sliced_to_array(useState31(createStreamDragPointStore), 1), equipmentDragPointStore = _useState312[0];
    var pendingEquipmentPoint = useRef29(null);
    var equipmentFrame = useRef29(null);
    var clearEquipmentDragPoint = useCallback16(function() {
        if (equipmentFrame.current !== null) cancelAnimationFrame(equipmentFrame.current);
        equipmentFrame.current = null;
        pendingEquipmentPoint.current = null;
        equipmentDragPointStore.set(null);
    }, [
        equipmentDragPointStore
    ]);
    useEffect29(function() {
        if (!activeEquipmentDrag) clearEquipmentDragPoint();
    }, [
        activeEquipmentDrag,
        clearEquipmentDragPoint
    ]);
    useEffect29(function() {
        return clearEquipmentDragPoint;
    }, [
        clearEquipmentDragPoint
    ]);
    var previewEquipmentAt = useCallback16(function(clientX, clientY, free) {
        pendingEquipmentPoint.current = {
            clientX: clientX,
            clientY: clientY,
            free: free
        };
        if (equipmentFrame.current !== null) return;
        equipmentFrame.current = requestAnimationFrame(function() {
            equipmentFrame.current = null;
            var pending = pendingEquipmentPoint.current;
            var surface11 = surfaceRef.current;
            if (!pending || !surface11) return;
            var _dropPointAt = dropPointAt(surface11, pending.clientX, pending.clientY, pending.free), raw = _dropPointAt.raw, snapped = _dropPointAt.snapped;
            var pane = surface11.planToPane(snapped);
            equipmentDragPointStore.set({
                pane: pane,
                raw: raw,
                snapped: snapped
            });
        });
    }, [
        dropPointAt,
        surfaceRef,
        equipmentDragPointStore
    ]);
    var equipmentLandingAt = useCallback16(function(clientX, clientY, free) {
        var surface11 = surfaceRef.current;
        return surface11 ? dropPointAt(surface11, clientX, clientY, free).snapped : null;
    }, [
        dropPointAt,
        surfaceRef
    ]);
    var handleDragOver = useCallback16(function(e) {
        e.preventDefault();
        e.dataTransfer.dropEffect = "copy";
        var _e_dataTransfer_types;
        var types = Array.from((_e_dataTransfer_types = e.dataTransfer.types) !== null && _e_dataTransfer_types !== void 0 ? _e_dataTransfer_types : []);
        if (activeEquipmentDrag && types.includes("application/json")) {
            previewEquipmentAt(e.clientX, e.clientY, e.shiftKey);
            return;
        }
        if (!activeStreamDrag || !types.includes(STREAM_DRAG_TYPE)) {
            return;
        }
        pendingPoint.current = {
            clientX: e.clientX,
            clientY: e.clientY,
            free: e.shiftKey
        };
        if (pointFrame.current !== null) return;
        pointFrame.current = requestAnimationFrame(function() {
            pointFrame.current = null;
            var pending = pendingPoint.current;
            var surface11 = surfaceRef.current;
            if (!pending || !surface11) return;
            var _dropPointAt = dropPointAt(surface11, pending.clientX, pending.clientY, pending.free), raw = _dropPointAt.raw, snapped = _dropPointAt.snapped;
            var pane = surface11.clientToPane(pending.clientX, pending.clientY);
            streamDragPointStore.set({
                pane: pane,
                raw: raw,
                snapped: snapped
            });
        });
    }, [
        activeStreamDrag,
        activeEquipmentDrag,
        previewEquipmentAt,
        dropPointAt,
        surfaceRef,
        streamDragPointStore
    ]);
    var handleDragLeave = useCallback16(function(e) {
        var box = e.currentTarget.getBoundingClientRect();
        var inside2 = e.clientX > box.left && e.clientX < box.right && e.clientY > box.top && e.clientY < box.bottom;
        if (inside2) return;
        clearStreamDragPoint();
        clearEquipmentDragPoint();
    }, [
        clearStreamDragPoint,
        clearEquipmentDragPoint
    ]);
    var placeDrop = useCallback16(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(drop, clientX, clientY, shiftKey) {
            var surface11, point, _point_raw, rawX, rawY, _point_snapped, x, y, rtspEndpointId, hit, refid, layoutBeforeClaim, claim, refusal, payload, _register_registerContext, register, readState, _register_registerContext1, waiting, waitingUid, entry, reused, baseName, newcomer, defaultName, targetAtDrop, placementName, modelFile, assetUid, capacity, placedCodes, droppedIdentity, entityCode, createdThisDrop, committed, reservation, created, createdUid, _created_asset_name, _created_asset_name1, handedName, _created_capacity, error, target, liveItems, _ref, existingItem, identity, resolved, registerVerified, highWaterMark, outcome, newItem;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        surface11 = surfaceRef.current;
                        if (!surface11) return [
                            2
                        ];
                        if (!drop) return [
                            2
                        ];
                        point = dropPointAt(surface11, clientX, clientY, shiftKey);
                        _point_raw = point.raw, rawX = _point_raw.x, rawY = _point_raw.y;
                        _point_snapped = point.snapped, x = _point_snapped.x, y = _point_snapped.y;
                        if ("stream" in drop) {
                            if (!onStreamClaim || !onStreamLinked) {
                                if (onStreamClaim || onStreamLinked) {
                                    console.error("[usePlanDrops] a camera feed was dropped but only one of onStreamClaim / onStreamLinked is supplied, so nothing was placed. They are a pair. Missing:", onStreamClaim ? "onStreamLinked" : "onStreamClaim");
                                }
                                return [
                                    2
                                ];
                            }
                            rtspEndpointId = drop.stream.rtspEndpointId;
                            hit = cameraAtPoint(currentActiveFloorCameras(), {
                                x: rawX,
                                y: rawY
                            }, surface11.zoom());
                            refid = hit ? hit.refid : mintCameraRefid();
                            layoutBeforeClaim = useFloorplanStore41.getState().layout;
                            claim = onStreamClaim(rtspEndpointId, hit ? hit.refid : null);
                            if (isDeferredClaim(claim)) {
                                setDropStatus(function(current2) {
                                    return current2.kind === "error" ? pendingCreates.current > 0 ? PENDING : IDLE2 : current2;
                                });
                                return [
                                    2
                                ];
                            }
                            refusal = claim;
                            if (refusal) {
                                setDropStatus({
                                    kind: "error",
                                    message: refusal
                                });
                                return [
                                    2
                                ];
                            }
                            if (!hit) {
                                if (layoutBeforeClaim) pushSnapshot(layoutBeforeClaim);
                                addCamera(_object_spread({
                                    refid: refid
                                }, newCameraShape(x, y, facingPlanCentre({
                                    x: x,
                                    y: y
                                }, facingBounds))));
                            }
                            setDropStatus(function(current2) {
                                return current2.kind === "error" ? pendingCreates.current > 0 ? PENDING : IDLE2 : current2;
                            });
                            markEntityModified(refid);
                            selectEntity(refid);
                            onStreamLinked(rtspEndpointId, refid, hit ? "linked" : "placed");
                            onCameraEdited === null || onCameraEdited === void 0 ? void 0 : onCameraEdited();
                            return [
                                2
                            ];
                        }
                        payload = drop.item;
                        if (!payload.assetUid && payload.referenceId) {
                            ;
                            register = useEquipmentCatalogStore16.getState();
                            readState = registerReadState6(register, {
                                twinId: (_register_registerContext = register.registerContext) === null || _register_registerContext === void 0 ? void 0 : _register_registerContext.twinId
                            });
                            if (readState === "loading" || readState === "error") {
                                ;
                                console.warn("[library-drop] refused: register not ready", {
                                    readState: readState,
                                    twinId: (_register_registerContext1 = register.registerContext) === null || _register_registerContext1 === void 0 ? void 0 : _register_registerContext1.twinId,
                                    referenceId: payload.referenceId,
                                    error: register.error
                                });
                                setDropStatus({
                                    kind: "error",
                                    message: readState === "error" ? LIBRARY_DROP_REGISTER_UNREADABLE : LIBRARY_DROP_REGISTER_NOT_READY
                                });
                                return [
                                    2
                                ];
                            }
                            if (readState === "ready") {
                                waiting = unplacedRowForProduct(register.registerRows, joinedFor(useFloorplanStore41.getState().layout, register.registerRows, twinBid, true), payload.referenceId);
                                waitingUid = waiting ? normaliseAssetUid5(waiting.id) : void 0;
                                entry = waitingUid ? register.siteAssets.find(function(a) {
                                    return a.asset_uid === waitingUid;
                                }) : void 0;
                                reused = entry ? readDropPayload(JSON.stringify(registerCardPayload(entry))) : null;
                                if (reused && reused.assetUid === waitingUid) {
                                    console.info("[library-drop] placed a waiting register row", {
                                        referenceId: payload.referenceId,
                                        assetUid: waitingUid
                                    });
                                    payload = reused;
                                } else if (waitingUid) {
                                    console.warn("[library-drop] waiting register row not reusable; creating a row", {
                                        referenceId: payload.referenceId,
                                        waitingUid: waitingUid,
                                        hasEntry: !!entry,
                                        parsed: !!reused
                                    });
                                }
                            }
                        }
                        baseName = resolveItemBaseName({
                            product: payload.product,
                            productLine: payload.productLine,
                            manufacturer: payload.manufacturer
                        });
                        newcomer = nameForNewcomer2(baseName, "machine", currentTwinNameIndex(twinBid));
                        defaultName = newcomer.name;
                        targetAtDrop = captureDropTarget();
                        setDropStatus(function(current2) {
                            return current2.kind === "error" ? pendingCreates.current > 0 ? PENDING : IDLE2 : current2;
                        });
                        placementName = payload.assetUid ? registerNameFor(payload.assetUid, defaultName) : defaultName;
                        modelFile = payload.model;
                        assetUid = payload.assetUid;
                        capacity = payload.capacity;
                        placedCodes = currentPlacedEntityCodes(twinBid);
                        droppedIdentity = entityIdentityFor3(twinBid, payload.entityCode);
                        entityCode = droppedIdentity && !placedCodes.has(droppedIdentity) ? payload.entityCode : void 0;
                        createdThisDrop = false;
                        if (!!assetUid) return [
                            3,
                            5
                        ];
                        createdThisDrop = true;
                        setDropStatus(PENDING);
                        committed = false;
                        reservation = reserveNewcomerName(newcomer.name);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        pendingCreates.current += 1;
                        return [
                            4,
                            createRegisterAsset({
                                name: defaultName,
                                referenceId: payload.referenceId
                            })
                        ];
                    case 2:
                        created = _state.sent();
                        committed = true;
                        applyHolderRename(newcomer.renameHolder);
                        createdUid = normaliseAssetUid5(created.id);
                        if (!createdUid) {
                            ;
                            setDropStatus({
                                kind: "error",
                                title: ADDED_NOT_PLACED,
                                message: postCommitMessage((_created_asset_name = created.asset_name) !== null && _created_asset_name !== void 0 ? _created_asset_name : defaultName)
                            });
                            return [
                                2
                            ];
                        }
                        assetUid = createdUid;
                        placementName = (_created_asset_name1 = created.asset_name) !== null && _created_asset_name1 !== void 0 ? _created_asset_name1 : // The name this drop chose and RESERVED before the POST (`reserveNewcomerName`), so no
                        // overlapping drop of the same product can have taken it in the meantime. Re-deriving
                        // here would find this drop's own reservation and skip to the next number.
                        defaultName;
                        handedName = reservation.takeRename();
                        if (handedName) {
                            renameRegisterRow(created.id, handedName);
                            placementName = handedName;
                        }
                        modelFile = flatShareFilename4(created.model_3d);
                        capacity = (_created_capacity = created.capacity) !== null && _created_capacity !== void 0 ? _created_capacity : void 0;
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        setDropStatus(committed ? {
                            kind: "error",
                            title: ADDED_NOT_PLACED,
                            message: postCommitMessage(defaultName)
                        } : {
                            kind: "error",
                            message: placementFailureMessage(error, defaultName)
                        });
                        return [
                            2
                        ];
                    case 4:
                        pendingCreates.current -= 1;
                        reservation.release();
                        setDropStatus(function(current2) {
                            return current2.kind === "error" || pendingCreates.current > 0 ? current2 : IDLE2;
                        });
                        return [
                            7
                        ];
                    case 5:
                        target = resolveDropTarget(targetAtDrop);
                        if (target.kind !== "ok") {
                            setDropStatus({
                                kind: "error",
                                title: ADDED_NOT_PLACED,
                                message: targetChangeMessage(// The register's name for the asset, not the plan label. On the create path these are
                                // the same thing; on a re-drag `placementName` is a label the register has never held.
                                registerNameFor(assetUid, placementName), target.kind, createdThisDrop)
                            });
                            return [
                                2
                            ];
                        }
                        liveItems = asArray9(target.design.items).filter(isLive7);
                        existingItem = (_ref = assetUid ? liveItems.find(function(i) {
                            return normaliseAssetUid5(i.assetUid) === assetUid;
                        }) : void 0) !== null && _ref !== void 0 ? _ref : !createdThisDrop && payload.refid !== void 0 ? liveItems.find(function(i) {
                            return i.refid === payload.refid;
                        }) : void 0;
                        if (!existingItem) {
                            identity = entityCode ? entityIdentityFor3(twinBid, entityCode) : void 0;
                            resolved = identity;
                            registerVerified = true;
                            if (!resolved) {
                                highWaterMark = currentHighWaterMark(twinBid, liveEntityBids);
                                registerVerified = highWaterMark.registerVerified;
                                outcome = mintEntityBid(twinBid, "E", highWaterMark.mark);
                                if (!outcome.ok) {
                                    setDropStatus(_object_spread_props(_object_spread({
                                        kind: "error"
                                    }, createdThisDrop ? {
                                        title: ADDED_NOT_PLACED
                                    } : {}), {
                                        message: outcome.message
                                    }));
                                    return [
                                        2
                                    ];
                                }
                                resolved = outcome.bid;
                                if (!identitiesVerified || !registerVerified) recordUnverifiedMint(resolved);
                            }
                            pushSnapshot(target.layout);
                            newItem = _object_spread({
                                refid: resolved,
                                /*
           * The same value, deliberately. `stampEntityCodes` fills BLANK codes only, so a code
           * placed here survives untouched and `convertPlanToTwin` reproduces it verbatim as the
           * entity BID (R18) — the BID the customer and BI already use, rather than a fresh one.
           *
           * Two fields rather than one because `refid` exists on CAMERAS too, which are not dGraph
           * entities and have no BID, so it cannot simply become "the BID". Making the two equal
           * for items gets the whole behavioural outcome with no rename and no change to the many
           * readers of either — and it is guarded rather than trusted: the middleware's plan-write
           * check verifies both uniqueness and agreement.
           */ entityCode: resolved,
                                x: x,
                                y: y,
                                z: 0,
                                name: placementName,
                                rotation: 0,
                                modelFile: modelFile
                            }, assetUid ? {
                                assetUid: assetUid
                            } : {}, capacity != null ? {
                                capacity: capacity
                            } : {});
                            addItem(newItem);
                            markEntityModified(resolved);
                            return [
                                2
                            ];
                        }
                        pushSnapshot(target.layout);
                        storeOriginalPosition(existingItem.refid, existingItem.x, existingItem.y);
                        updateItem(existingItem.refid, {
                            x: x,
                            y: y
                        });
                        markEntityModified(existingItem.refid);
                        return [
                            2
                        ];
                }
            });
        });
        return function(drop, clientX, clientY, shiftKey) {
            return _ref.apply(this, arguments);
        };
    }(), [
        surfaceRef,
        addItem,
        updateItem,
        markEntityModified,
        storeOriginalPosition,
        pushSnapshot,
        gridSnap,
        gridSize,
        createRegisterAsset,
        // The live-model BID set is an input to every mint (FR4), so a set that arrives after the
        // read settles must rebuild this handler — otherwise a drop taken from a stale closure
        // computes its mark without it.
        liveEntityBids,
        identitiesVerified,
        recordUnverifiedMint,
        addCamera,
        selectEntity,
        onStreamClaim,
        onStreamLinked,
        onCameraEdited,
        facingBounds,
        dropPointAt,
        // Swept in (review round 1): `twinBid` was read by `currentPlacedEntityCodes` and
        // `entityIdentityFor` above but was NOT a dependency, so a twin switch that did not remount
        // the canvas left this handler folding identities through the previous twin's BID. The
        // duplicate-code guard would then compare against the wrong identity set and let a
        // duplicate `entityCode` onto the plan — two entities minted with one BID at Go Live, one
        // silently collapsing into the other, which is exactly what that guard exists to prevent.
        twinBid
    ]);
    var handleDrop = useCallback16(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(e) {
            var drop;
            return _ts_generator(this, function(_state) {
                e.preventDefault();
                clearStreamDragPoint();
                clearEquipmentDragPoint();
                if (!surfaceRef.current) return [
                    2
                ];
                drop = readDrop(e.dataTransfer);
                return [
                    2,
                    placeDrop(drop, e.clientX, e.clientY, e.shiftKey)
                ];
            });
        });
        return function(e) {
            return _ref.apply(this, arguments);
        };
    }(), [
        clearStreamDragPoint,
        clearEquipmentDragPoint,
        surfaceRef,
        placeDrop
    ]);
    var placeEquipmentPayload = useCallback16(function(payload, clientX, clientY, shiftKey) {
        clearEquipmentDragPoint();
        var drop = readDrop({
            getData: function(type) {
                return type === "application/json" ? payload : "";
            }
        });
        return placeDrop(drop, clientX, clientY, shiftKey);
    }, [
        clearEquipmentDragPoint,
        placeDrop
    ]);
    var reportDropFailure = useCallback16(function(error) {
        setDropStatus({
            kind: "error",
            message: "Something went wrong placing that item — ".concat(_instanceof(error, Error) && error.message ? error.message : "the drop could not complete", ". Check the Equipment list before dragging it again.")
        });
    }, []);
    return {
        handleDragOver: handleDragOver,
        handleDragLeave: handleDragLeave,
        /** Where a stream dragged over the pane would land, while one is (`camera-feeds-page-plan-drop`). */ streamDragPointStore: streamDragPointStore,
        /** Where a machine dragged over the pane would land, while one is (`floor-plan-page-assets-library`). */ equipmentDragPointStore: equipmentDragPointStore,
        handleDrop: handleDrop,
        /** Preview a machine at a client point, once per frame — the browser drag's and the pointer drag's. */ previewEquipmentAt: previewEquipmentAt,
        clearEquipmentDragPoint: clearEquipmentDragPoint,
        /** Place a machine payload from the pointer drag, through the same path as `handleDrop`. */ placeEquipmentPayload: placeEquipmentPayload,
        equipmentLandingAt: equipmentLandingAt,
        reportDropFailure: reportDropFailure,
        /** What the canvas should say about the drop in progress — see `DropStatusBanner`. */ dropStatus: dropStatus,
        clearDropStatus: clearDropStatus
    };
}
// src/components/Planner/machineCard/machineCardText.ts
import { entityIdentityFor as entityIdentityFor4, entityIdentityKey as entityIdentityKey4 } from "@repo/front-end-utils";
var ADD_TO_REGISTER_HELPER = "Creates its row now from this machine\u2019s name, BID and 3D model. Pick its product under Identify.";
var NOT_ON_PLAN = "Not on plan";
var linkGroupLabel = function(count) {
    return "".concat(NOT_ON_PLAN, " \xb7 ").concat(count, " ").concat(count === 1 ? "row" : "rows");
};
var LINK_EMPTY = "No register rows are free to link.";
var readingRegisterNote = function(read) {
    return read === "error" ? "The Asset Register could not be read, so we can\u2019t tell whether this machine has a row. Use Try again in the sidebar." : read === "no-twin" ? "Select a twin to see whether this machine has a register row." : "Reading the Asset Register\u2026";
};
var displayBid = function(twinBid, code) {
    return entityIdentityKey4(code) ? entityIdentityFor4(twinBid !== null && twinBid !== void 0 ? twinBid : "", code !== null && code !== void 0 ? code : "") : "";
};
var NO_PRODUCT_YET = "No product yet";
var LINK_OR_ADD_FIRST = "Link or add its register row first";
var PRODUCT_NOT_IN_CATALOGUE = "Product not in the catalogue";
var NEEDS_REGISTER_ROW = "Needs a register row";
var FROM_PRODUCT = "from product";
var MACHINE_CAPACITY_HELP = "Changes the capacity for this item only. Not recommended.";
var productCapacityLabel = function(capacity) {
    return typeof capacity === "number" ? "Use product \xb7 ".concat(capacity) : "Use product";
};
var productCapacityFailed = function(reason) {
    return "Couldn't use the product's capacity: ".concat(reason);
};
var CAPACITY_MAYBE_SAVED = "The capacity may not have been saved. Check it, then try again.";
var EDIT_CUSTOMER_ID = "Edit customer asset ID";
var EDIT_SOURCE_ID = "Edit source asset ID";
var CUSTOMER_ID_HELP = "Unique identifier - usually from an asset management system";
var SOURCE_ID_HELP = "Secondary identifier - if needed";
// src/components/Planner/spaceCard/spaceDeletion.ts
var current = function(on) {
    var _useFloorplanStore42_getState = useFloorplanStore42.getState(), layout = _useFloorplanStore42_getState.layout, activeFloorIndex = _useFloorplanStore42_getState.activeFloorIndex;
    var floorIndex = on !== null && on !== void 0 ? on : activeFloorIndex;
    var floor = layout === null || layout === void 0 ? void 0 : layout.floors[floorIndex];
    return {
        layout: layout,
        design: floor ? findLatestDesign14(floor.designs) : null,
        floorIndex: floorIndex
    };
};
var mintInputs = function(twinBid, twinId, live, launched) {
    var _catalog_registerContext;
    var noTwin = !twinBid || twinBid.trim() === "";
    if (!noTwin && (live === null || live === void 0 ? void 0 : live.status) !== "ready") {
        return {
            ok: false,
            unread: "live",
            failed: (live === null || live === void 0 ? void 0 : live.status) === "failed"
        };
    }
    var bids = (live === null || live === void 0 ? void 0 : live.status) === "ready" ? live.bids : /* @__PURE__ */ new Set();
    var _currentHighWaterMark = currentHighWaterMark(twinBid, bids), mark = _currentHighWaterMark.mark, registerVerified = _currentHighWaterMark.registerVerified;
    var catalog = useEquipmentCatalogStore17.getState();
    var read = twinId != null ? registerReadState7(catalog, {
        twinId: twinId
    }) : registerReadState7(catalog, {
        twinId: (_catalog_registerContext = catalog.registerContext) === null || _catalog_registerContext === void 0 ? void 0 : _catalog_registerContext.twinId
    });
    if (!registerVerified || read !== "ready") {
        return {
            ok: false,
            unread: "register",
            failed: read === "error"
        };
    }
    return {
        ok: true,
        inputs: {
            twinBid: twinBid,
            mark: mark,
            launched: launched
        }
    };
};
var worstOf = function(values) {
    return values.includes(true) ? true : values.includes("unknown") ? "unknown" : false;
};
var named = function(name, fallback) {
    return (name === null || name === void 0 ? void 0 : name.trim()) || fallback;
};
var planSpaceDeletion = function(param) {
    var ids = param.ids, twinBid = param.twinBid, twinId = param.twinId, live = param.live, checks = param.checks, registerCapacityOf = param.registerCapacityOf, on = param.floorIndex;
    var _layout_floors_floorIndex, _parentage_surface, _resolvePlanHierarchy3_surface;
    var _current = current(on), layout = _current.layout, current_ = _current.design, floorIndex = _current.floorIndex;
    if (!layout || !current_) return null;
    var surfaces = current_.surfaces.filter(isLive8);
    var spaces = ids.filter(function(id) {
        return surfaces.some(function(s) {
            return s.refid === id;
        });
    });
    if (spaces.length === 0) return null;
    var byRefid = new Map(surfaces.map(function(s) {
        return [
            s.refid,
            s
        ];
    }));
    var names = spaces.map(function(id) {
        var _byRefid_get;
        return named((_byRefid_get = byRefid.get(id)) === null || _byRefid_get === void 0 ? void 0 : _byRefid_get.name, "Space");
    });
    var itemIds = new Set(ids.filter(function(id) {
        return !spaces.includes(id) && current_.items.some(function(i) {
            return i.refid === id && isLive8(i);
        });
    }));
    var deletedItems = current_.items.filter(function(i) {
        return isLive8(i) && itemIds.has(i.refid);
    });
    var design = itemIds.size > 0 ? _object_spread_props(_object_spread({}, current_), {
        items: current_.items.filter(function(i) {
            return !itemIds.has(i.refid);
        })
    }) : current_;
    var launchedOf = function(entity) {
        return displayBid(twinBid, entity.entityCode) === "" ? false : checks ? checks.launched(entity) : "unknown";
    };
    var minted = mintInputs(twinBid, twinId, live, launchedOf);
    var inputs = minted.ok ? minted.inputs : {
        twinBid: twinBid,
        mark: {},
        launched: launchedOf
    };
    var planned = planSurfaceRemoval(design, spaces, inputs);
    if (!planned.ok) {
        console.error("[delete-promotion] no BID left to issue, delete refused", {
            twinBid: twinBid,
            spaces: spaces,
            reason: planned.reason
        });
        return {
            kind: "refused",
            message: planned.message
        };
    }
    if (!("recodes" in planned)) return null;
    var promotion = planned;
    if (!minted.ok && promotion.recodes.length > 0) {
        if (minted.failed) {
            console.warn(minted.unread === "live" ? "[delete-promotion] live read unavailable, delete refused" : "[delete-promotion] register read unavailable, delete refused", {
                twinBid: twinBid,
                spaces: spaces
            });
        }
        return {
            kind: "refused",
            message: spaceDeleteRefused(names[0], minted.unread, minted.failed)
        };
    }
    var launched = worstOf(_to_consumable_array(spaces.map(function(id) {
        var _byRefid_get;
        return launchedOf((_byRefid_get = byRefid.get(id)) !== null && _byRefid_get !== void 0 ? _byRefid_get : {
            refid: id
        });
    })).concat(_to_consumable_array(promotion.recodes.map(function(r) {
        return r.live;
    })), _to_consumable_array(deletedItems.map(function(i) {
        return launchedOf(i);
    }))));
    var deletion = planPlannerDeletion(ids, false, on);
    var cameraRegions = deletion.cameraObserverCount;
    var floors = layout.floors;
    var floorOf2 = function(o) {
        return floors.findIndex(function(f) {
            var _findLatestDesign14_observers;
            return (_findLatestDesign14_observers = findLatestDesign14(f.designs).observers) === null || _findLatestDesign14_observers === void 0 ? void 0 : _findLatestDesign14_observers.includes(o);
        });
    };
    var removedRegions = deletion.observers.map(function(o) {
        var _o_targetKind, _o_targetRefid, _o_rtspEndpointId;
        return "".concat(floorOf2(o), ":").concat(o.refid, ":").concat((_o_targetKind = o.targetKind) !== null && _o_targetKind !== void 0 ? _o_targetKind : "", ":").concat((_o_targetRefid = o.targetRefid) !== null && _o_targetRefid !== void 0 ? _o_targetRefid : "", ":").concat((_o_rtspEndpointId = o.rtspEndpointId) !== null && _o_rtspEndpointId !== void 0 ? _o_rtspEndpointId : "");
    });
    var floorName = named((_layout_floors_floorIndex = layout.floors[floorIndex]) === null || _layout_floors_floorIndex === void 0 ? void 0 : _layout_floors_floorIndex.name, "the floor");
    var after = new Map(promotion.design.surfaces.map(function(s) {
        return [
            s.refid,
            s
        ];
    }));
    var nameAfter = function(refid) {
        var _after_get;
        return named((_after_get = after.get(refid)) === null || _after_get === void 0 ? void 0 : _after_get.name, "a space");
    };
    var where = function(parent2) {
        return parent2 === null ? "on ".concat(floorName) : "in ".concat(nameAfter(parent2));
    };
    var recodes = promotion.recodes.map(function(r) {
        return _object_spread_props(_object_spread({}, r), {
            where: where(r.parentRefid)
        });
    });
    var unnumbered = promotion.moved.filter(function(m) {
        return !m.recoded;
    }).map(function(m) {
        return _object_spread_props(_object_spread({}, m), {
            where: where(m.parentRefid)
        });
    });
    var moves = /* @__PURE__ */ new Map();
    promotion.machineMoves.forEach(function(m) {
        var _moves_get;
        return moves.set(m.to, ((_moves_get = moves.get(m.to)) !== null && _moves_get !== void 0 ? _moves_get : 0) + 1);
    });
    var parentage = resolvePlanParentage5(design);
    var _parentage_surface_effectiveParent;
    var parent = (_parentage_surface_effectiveParent = (_parentage_surface = parentage.surface(spaces[0])) === null || _parentage_surface === void 0 ? void 0 : _parentage_surface.effectiveParent) !== null && _parentage_surface_effectiveParent !== void 0 ? _parentage_surface_effectiveParent : null;
    var capacity = null;
    if (parent !== null && !spaces.includes(parent)) {
        var ask = function(d) {
            return capacityWithDesign({
                design: d,
                floorIndex: floorIndex,
                refid: parent,
                twinBid: twinBid,
                twinId: twinId,
                registerCapacityOf: registerCapacityOf
            });
        };
        var before = ask(current_);
        var afterCapacity = ask(promotion.design);
        if ((before === null || before === void 0 ? void 0 : before.source) === "calculated" && typeof before.value === "number" && typeof (afterCapacity === null || afterCapacity === void 0 ? void 0 : afterCapacity.value) === "number") {
            capacity = {
                parent: nameAfter(parent),
                before: before.value,
                after: afterCapacity.value
            };
        }
    }
    var summary = deleteSpaceSummary(layout, current_, /* @__PURE__ */ new Set(_to_consumable_array(spaces).concat(_to_consumable_array(Array.from(itemIds)))), promotion.recodes, new Set(deletion.observers));
    var deleted = new Set(spaces);
    var hadContents = surfaces.some(function(s) {
        var _parentage_surface;
        var _parentage_surface_effectiveParent;
        return deleted.has((_parentage_surface_effectiveParent = (_parentage_surface = parentage.surface(s.refid)) === null || _parentage_surface === void 0 ? void 0 : _parentage_surface.effectiveParent) !== null && _parentage_surface_effectiveParent !== void 0 ? _parentage_surface_effectiveParent : "");
    }) || design.items.some(function(i) {
        var _parentage_item;
        var _parentage_item_effectiveParent;
        return isLive8(i) && deleted.has((_parentage_item_effectiveParent = (_parentage_item = parentage.item(i)) === null || _parentage_item === void 0 ? void 0 : _parentage_item.effectiveParent) !== null && _parentage_item_effectiveParent !== void 0 ? _parentage_item_effectiveParent : "");
    });
    var copy = deleteSpaceCopy({
        names: names,
        total: ids.length,
        launched: launched,
        cameraRegions: cameraRegions,
        recodes: recodes,
        unnumbered: unnumbered,
        otherSpaces: names.slice(1),
        deletedMachines: deletedItems.map(function(i) {
            return {
                refid: i.refid,
                name: named(i.name, "Machine"),
                bid: displayBid(twinBid, i.entityCode)
            };
        }),
        machineStays: promotion.machineStays.map(function(m) {
            return {
                refid: m.refid,
                name: nameAfter(m.refid),
                count: m.count
            };
        }),
        machineMoves: Array.from(moves, function(param) {
            var _param = _sliced_to_array(param, 2), to = _param[0], count = _param[1];
            return {
                toRefid: to,
                to: to === null ? null : nameAfter(to),
                count: count
            };
        }),
        capacity: capacity,
        lost: summary.lost,
        follow: summary.follow,
        chosenReplaced: promotion.chosenReplaced
    });
    var _resolvePlanHierarchy3_surface_kind;
    return {
        kind: "ready",
        ids: ids,
        spaces: spaces,
        names: names,
        kindLabel: spaces.length === 1 ? kindTitle((_resolvePlanHierarchy3_surface_kind = (_resolvePlanHierarchy3_surface = resolvePlanHierarchy3(design).surface(spaces[0])) === null || _resolvePlanHierarchy3_surface === void 0 ? void 0 : _resolvePlanHierarchy3_surface.kind) !== null && _resolvePlanHierarchy3_surface_kind !== void 0 ? _resolvePlanHierarchy3_surface_kind : null) : null,
        hadContents: hadContents,
        inputs: inputs,
        promotion: promotion,
        launched: launched,
        cameraRegions: cameraRegions,
        copy: copy,
        /*
     * R15: everything the operator was shown — the title, the sentences and every row as written —
     * plus the refs behind the counts, so a confirm deletes only what the dialog listed.
     */ key: JSON.stringify([
            copy.title,
            copy.lines,
            copy.rows,
            summary.key,
            removedRegions
        ])
    };
};
// src/components/Planner/machineCard/MachineDeleteFlow.tsx
import { Fragment as Fragment17, jsx as jsx37, jsxs as jsxs27 } from "react/jsx-runtime";
var Body3 = styled29.div(_templateObject132(), inset4[3], inset4[4]);
var Rows4 = styled29.ul(_templateObject133(), space18[2], space18[3], space18[2], space18[3], glass2.border, radius7.md, glass2.bg, typeRole13.caption1Strong, semantic12.text.primary);
var Trail = styled29.span(_templateObject134(), space18[1], fontMono4, typeScale2.captionCompact.fontSize, typeScale2.captionCompact.lineHeight, weight4.medium, semantic12.text.muted);
var hasRegisterRow = function(refid, twinBid, twinId, on) {
    var _useFloorplanStore43_getState = useFloorplanStore43.getState(), layout = _useFloorplanStore43_getState.layout, activeFloorIndex = _useFloorplanStore43_getState.activeFloorIndex;
    var catalog = useEquipmentCatalogStore18.getState();
    var read = registerReadState8(catalog, {
        twinId: twinId !== null && twinId !== void 0 ? twinId : void 0
    });
    var joined2 = joinedFor(layout, catalog.registerRows, twinBid, read === "ready");
    var floor = joined2 === null || joined2 === void 0 ? void 0 : joined2.floors[on !== null && on !== void 0 ? on : activeFloorIndex];
    var item = floor ? findLatestDesign15(floor.designs).items.find(function(i) {
        return i.refid === refid;
    }) : null;
    return !!item && resolveItemRegisterState2(item, catalog.registerRows, read).kind === "backed";
};
var currentSummary = function(refid, on) {
    var _useFloorplanStore43_getState = useFloorplanStore43.getState(), layout = _useFloorplanStore43_getState.layout, activeFloorIndex = _useFloorplanStore43_getState.activeFloorIndex;
    var floor = layout === null || layout === void 0 ? void 0 : layout.floors[on !== null && on !== void 0 ? on : activeFloorIndex];
    return deleteMachineSummary(layout, floor ? findLatestDesign15(floor.designs) : null, refid);
};
var MachineDeleteFlow = function(param) {
    var twinBid = param.twinBid, twinId = param.twinId, toastRegion = param.toastRegion, onObserversRemoved = param.onObserversRemoved, live = param.live;
    var checks = usePlanChecksContext();
    var checksRef = useRef30(checks);
    checksRef.current = checks;
    var liveRef = useRef30(live);
    liveRef.current = live;
    var registerCapacityOf = useRegisterCapacityOf(twinId);
    var capacityRef = useRef30(registerCapacityOf);
    capacityRef.current = registerCapacityOf;
    var show = useRegionToast(toastRegion);
    var onCameraEdited = useCameraEdited();
    var request = useEditorStore34(function(s) {
        return s.itemDeleteRequest;
    });
    var _useState32 = _sliced_to_array(useState32(null), 2), pending = _useState32[0], setPending = _useState32[1];
    var origin = useRef30(null);
    var returnFocusTo = useMemo20(function() {
        return {
            get current () {
                var _origin_current;
                if ((_origin_current = origin.current) === null || _origin_current === void 0 ? void 0 : _origin_current.isConnected) return origin.current;
                return document.querySelector("[data-plan-pane]");
            }
        };
    }, []);
    var planSpaces = function(ids, on) {
        return planSpaceDeletion({
            ids: ids,
            twinBid: twinBid,
            twinId: twinId,
            live: liveRef.current,
            checks: checksRef.current,
            registerCapacityOf: capacityRef.current,
            floorIndex: on
        });
    };
    var announceDeleted = function(toast) {
        var undo = guardedUndo(show);
        show(_object_spread_props(_object_spread({}, toast), {
            icon: /* @__PURE__ */ jsx37(Icon14, {
                name: "trash-can"
            }),
            inlineAction: {
                label: "Undo",
                onAction: undo
            }
        }));
    };
    var deleteMachineNow = function(refid, name, on) {
        var hadRow = hasRegisterRow(refid, twinBid, twinId, on);
        var plan2 = planPlannerDeletion([
            refid
        ], false, on);
        if (plan2.ids.length === 0) return;
        applyPlannerDeletion(plan2, {
            camerasOnly: false,
            onObserversRemoved: onObserversRemoved
        });
        announceDeleted(machineDeletedToast(name, hadRow));
    };
    var deleteSpacesNow = function(plan2, on) {
        var request2 = planPlannerDeletion(plan2.ids, false, on);
        if (request2.ids.length === 0) return;
        var done = applyPlannerDeletion(request2, {
            camerasOnly: false,
            onObserversRemoved: onObserversRemoved,
            onCameraEdited: onCameraEdited,
            promote: plan2.inputs
        });
        if (done.refused !== void 0) {
            show({
                tone: "error",
                icon: /* @__PURE__ */ jsx37(Icon14, {
                    name: "circle-exclamation"
                }),
                title: done.refused
            });
            return;
        }
        announceDeleted(spaceDeletedToast(plan2.names.length === 1 ? plan2.names[0] : "".concat(plan2.names.length, " spaces"), plan2.hadContents, plan2.promotion));
    };
    var nowRef = useRef30({
        deleteMachineNow: deleteMachineNow,
        deleteSpacesNow: deleteSpacesNow
    });
    nowRef.current = {
        deleteMachineNow: deleteMachineNow,
        deleteSpacesNow: deleteSpacesNow
    };
    useEffect30(function() {
        var _item_name;
        if (!request) return;
        useEditorStore34.getState().clearItemDeleteRequest();
        var ids = request.refids && request.refids.length > 0 ? request.refids : [
            request.refid
        ];
        var remember = function() {
            var active = document.activeElement;
            origin.current = _instanceof(active, HTMLElement) && active !== document.body ? active : null;
        };
        var on = request.floorIndex;
        var plan2 = planSpaces(ids, on);
        if ((plan2 === null || plan2 === void 0 ? void 0 : plan2.kind) === "refused") {
            show({
                tone: "error",
                icon: /* @__PURE__ */ jsx37(Icon14, {
                    name: "circle-exclamation"
                }),
                title: plan2.message
            });
            return;
        }
        if (plan2) {
            if (plan2.launched === false && plan2.cameraRegions === 0) {
                nowRef.current.deleteSpacesNow(plan2, on);
                return;
            }
            remember();
            setPending({
                what: "space",
                plan: plan2,
                floorIndex: on
            });
            return;
        }
        var _useFloorplanStore43_getState = useFloorplanStore43.getState(), layout = _useFloorplanStore43_getState.layout, activeFloorIndex = _useFloorplanStore43_getState.activeFloorIndex;
        var floor = layout === null || layout === void 0 ? void 0 : layout.floors[on !== null && on !== void 0 ? on : activeFloorIndex];
        var design = floor ? findLatestDesign15(floor.designs) : null;
        var item = design === null || design === void 0 ? void 0 : design.items.find(function(i) {
            return i.refid === ids[0] && isLive9(i);
        });
        if (!item || !design) return;
        var name = ((_item_name = item.name) === null || _item_name === void 0 ? void 0 : _item_name.trim()) || "Machine";
        var bid = displayBid(twinBid, item.entityCode);
        var launched = bid === "" ? false : checksRef.current ? checksRef.current.launched(item) : "unknown";
        if (launched === false) {
            nowRef.current.deleteMachineNow(item.refid, name, on);
            return;
        }
        remember();
        setPending({
            what: "machine",
            refid: item.refid,
            name: name,
            bid: bid,
            launched: launched,
            summary: deleteMachineSummary(layout, design, item.refid),
            floorIndex: on
        });
    }, [
        request
    ]);
    var previewKey = (pending === null || pending === void 0 ? void 0 : pending.what) === "space" ? JSON.stringify([
        pending.plan.spaces,
        pending.plan.promotion.recodes.map(function(r) {
            return r.refid;
        })
    ]) : null;
    useEffect30(function() {
        if ((pending === null || pending === void 0 ? void 0 : pending.what) !== "space") return void 0;
        useEditorStore34.getState().setDeletePreview({
            deleting: pending.plan.spaces,
            changing: pending.plan.promotion.recodes.map(function(r) {
                return r.refid;
            })
        });
        return function() {
            return useEditorStore34.getState().setDeletePreview(null);
        };
    }, [
        previewKey
    ]);
    if (!pending) return null;
    var keep = function() {
        return setPending(null);
    };
    if (pending.what === "machine") {
        var copy = deleteMachineCopy(pending);
        var confirm2 = function() {
            var now = currentSummary(pending.refid, pending.floorIndex);
            if (now.refs.join("|") !== pending.summary.refs.join("|")) {
                setPending(_object_spread_props(_object_spread({}, pending), {
                    summary: now,
                    changed: true
                }));
                return;
            }
            setPending(null);
            deleteMachineNow(pending.refid, pending.name, pending.floorIndex);
        };
        return /* @__PURE__ */ jsx37(Modal5, {
            open: true,
            onClose: keep,
            returnFocusTo: returnFocusTo,
            title: copy.title,
            tone: "coral",
            width: "md",
            icon: /* @__PURE__ */ jsx37(Icon14, {
                name: "trash-can"
            }),
            actions: /* @__PURE__ */ jsxs27(Fragment17, {
                children: [
                    /* @__PURE__ */ jsx37(Button15, {
                        type: "button",
                        variant: "frosted",
                        autoFocus: true,
                        onClick: keep,
                        children: "Keep"
                    }),
                    /* @__PURE__ */ jsx37(Button15, {
                        type: "button",
                        variant: "destructive",
                        iconLeft: /* @__PURE__ */ jsx37(Icon14, {
                            name: "trash-can"
                        }),
                        onClick: confirm2,
                        children: "Delete"
                    })
                ]
            }),
            children: /* @__PURE__ */ jsxs27(Body3, {
                children: [
                    copy.lines.map(function(line3) {
                        return /* @__PURE__ */ jsx37("p", {
                            children: line3
                        }, line3);
                    }),
                    copy.takes.length > 0 ? /* @__PURE__ */ jsx37("ul", {
                        children: copy.takes.map(function(line3) {
                            return /* @__PURE__ */ jsx37("li", {
                                children: line3
                            }, line3);
                        })
                    }) : /* @__PURE__ */ jsx37("p", {
                        children: "Nothing else uses it."
                    }),
                    pending.changed && /* @__PURE__ */ jsx37("p", {
                        role: "alert",
                        children: DELETE_TAKES_CHANGED
                    }),
                    pending.launched === "unknown" && /* @__PURE__ */ jsx37("p", {
                        children: CANT_CHECK_LIVE
                    })
                ]
            })
        });
    }
    var plan = pending.plan;
    var confirm = function() {
        var now = planSpaces(plan.ids, pending.floorIndex);
        if (!now || now.kind === "refused") {
            setPending(null);
            if ((now === null || now === void 0 ? void 0 : now.kind) === "refused") {
                show({
                    tone: "error",
                    icon: /* @__PURE__ */ jsx37(Icon14, {
                        name: "circle-exclamation"
                    }),
                    title: now.message
                });
            } else {
                console.warn("[delete-promotion] confirm found the spaces gone, nothing deleted", {
                    spaces: plan.spaces
                });
                show({
                    tone: "info",
                    icon: /* @__PURE__ */ jsx37(Icon14, {
                        name: "circle-info"
                    }),
                    title: "".concat(plan.names[0], " is no longer on the plan, so nothing was deleted.")
                });
            }
            return;
        }
        if (now.key !== plan.key) {
            setPending({
                what: "space",
                plan: now,
                changed: true,
                floorIndex: pending.floorIndex
            });
            return;
        }
        setPending(null);
        deleteSpacesNow(now, pending.floorIndex);
    };
    var single = plan.ids.length === 1;
    return /* @__PURE__ */ jsx37(Modal5, {
        open: true,
        onClose: keep,
        returnFocusTo: returnFocusTo,
        title: plan.copy.title,
        tone: "coral",
        width: "md",
        icon: /* @__PURE__ */ jsx37(Icon14, {
            name: "trash-can"
        }),
        actions: /* @__PURE__ */ jsxs27(Fragment17, {
            children: [
                /* @__PURE__ */ jsx37(Button15, {
                    type: "button",
                    variant: "frosted",
                    autoFocus: true,
                    onClick: keep,
                    children: single ? "Keep ".concat(plan.names[0]) : "Keep them"
                }),
                /* @__PURE__ */ jsx37(Button15, {
                    type: "button",
                    variant: "destructive",
                    iconLeft: /* @__PURE__ */ jsx37(Icon14, {
                        name: "trash-can"
                    }),
                    onClick: confirm,
                    children: single && plan.kindLabel ? "Delete ".concat(plan.kindLabel) : "Delete"
                })
            ]
        }),
        children: /* @__PURE__ */ jsxs27(Body3, {
            children: [
                plan.copy.lines.map(function(line3) {
                    return /* @__PURE__ */ jsx37("p", {
                        children: line3
                    }, line3);
                }),
                plan.copy.rows.length > 0 ? /* @__PURE__ */ jsx37(Rows4, {
                    role: "list",
                    children: plan.copy.rows.map(function(row) {
                        return /* @__PURE__ */ jsxs27("li", {
                            children: [
                                /* @__PURE__ */ jsx37(Icon14, {
                                    name: row.icon
                                }),
                                /* @__PURE__ */ jsx37("span", {
                                    children: row.text
                                }),
                                row.bids ? /* @__PURE__ */ jsxs27(Trail, {
                                    children: [
                                        row.bids.from,
                                        /* @__PURE__ */ jsx37("span", {
                                            "aria-hidden": "true",
                                            children: "\u2192"
                                        }),
                                        /* @__PURE__ */ jsx37("span", {
                                            style: visuallyHidden,
                                            children: " to "
                                        }),
                                        /* @__PURE__ */ jsx37(Tag4, {
                                            surface: "on-solid",
                                            tone: "butter",
                                            size: "dense",
                                            children: row.bids.to
                                        })
                                    ]
                                }) : row.note ? /* @__PURE__ */ jsx37(Trail, {
                                    children: row.note
                                }) : /* @__PURE__ */ jsx37("span", {})
                            ]
                        }, row.key);
                    })
                }) : /* @__PURE__ */ jsx37("p", {
                    children: "Nothing else uses it."
                }),
                pending.changed && /* @__PURE__ */ jsx37("p", {
                    role: "alert",
                    children: DELETE_TAKES_CHANGED
                })
            ]
        })
    });
};
// src/components/Planner/spaceCard/SpaceCard.tsx
import { useCallback as useCallback18, useEffect as useEffect35, useId as useId5, useMemo as useMemo24, useRef as useRef34, useState as useState39 } from "react";
import styled36 from "styled-components";
import { Button as Button21, DockedCard, Icon as Icon19, Note as Note2, OverrideRows } from "@repo/design-system";
import { fontSans as fontSans4, ink as ink8, space as space22, typeScale as typeScale6, weight as weight7 } from "@repo/design-tokens";
import { registerReadState as registerReadState9, useEditorStore as useEditorStore37, useEquipmentCatalogStore as useEquipmentCatalogStore20, useFloorplanStore as useFloorplanStore45 } from "@repo/front-end-state";
import { isNameTaken as isNameTaken5, nextFreeName as nextFreeName5, recordCodeChange } from "@repo/front-end-utils";
// src/components/Planner/spaceCard/useSpaceCardModel.ts
import { useMemo as useMemo21, useRef as useRef31 } from "react";
import { useEditorStore as useEditorStore36, useEquipmentCatalogStore as useEquipmentCatalogStore19 } from "@repo/front-end-state";
// src/components/Planner/hooks/useCardFloorIndex.ts
import { useEditorStore as useEditorStore35, useFloorplanStore as useFloorplanStore44 } from "@repo/front-end-state";
var useCardFloorIndex = function() {
    var held = useEditorStore35(function(s) {
        return s.heldSelectionFloor;
    });
    var shown2 = useFloorplanStore44(function(s) {
        return s.activeFloorIndex;
    });
    return held !== null && held !== void 0 ? held : shown2;
};
// src/components/Planner/spaceCard/useSpaceCardModel.ts
import { buildTwinNameIndex as buildTwinNameIndex4, findLatestDesign as findLatestDesign16, isLive as isLive10, resolvePlanCapacity as resolvePlanCapacity4, resolvePlanHierarchy as resolvePlanHierarchy4, resolvePlanParentage as resolvePlanParentage6, twinNameEntryFor, twinNameSignature } from "@repo/front-end-utils";
function useSpaceCardModel(twinBid, twinId) {
    var layout = useJoinedLayout(twinBid, twinId);
    var floorIndex = useCardFloorIndex();
    var selectedIds = useEditorStore36(function(s) {
        return s.selectedEntityIds;
    });
    var registerRows = useEquipmentCatalogStore19(function(s) {
        return s.registerRows;
    });
    var registerCapacityOf = useRegisterCapacityOf(twinId);
    var selectedId = selectedIds.length === 1 ? selectedIds[0] : null;
    var floor = layout === null || layout === void 0 ? void 0 : layout.floors[floorIndex];
    var design = floor ? findLatestDesign16(floor.designs) : null;
    var _design_surfaces_find;
    var surface11 = selectedId && design ? (_design_surfaces_find = design.surfaces.find(function(s) {
        return s.refid === selectedId && isLive10(s);
    })) !== null && _design_surfaces_find !== void 0 ? _design_surfaces_find : null : null;
    var hierarchy = surface11 && design ? resolvePlanHierarchy4(design) : null;
    var parentage = surface11 && design ? resolvePlanParentage6(design) : null;
    var answer = surface11 ? hierarchy === null || hierarchy === void 0 ? void 0 : hierarchy.surface(surface11.refid) : void 0;
    var parentName2 = null;
    if (surface11 && parentage && design) {
        var _parentage_surface, _parent_name;
        var _parentage_surface_effectiveParent;
        var parentRefid = (_parentage_surface_effectiveParent = (_parentage_surface = parentage.surface(surface11.refid)) === null || _parentage_surface === void 0 ? void 0 : _parentage_surface.effectiveParent) !== null && _parentage_surface_effectiveParent !== void 0 ? _parentage_surface_effectiveParent : null;
        var parent = parentRefid ? design.surfaces.find(function(s) {
            return s.refid === parentRefid;
        }) : void 0;
        if (parent) parentName2 = ((_parent_name = parent.name) === null || _parent_name === void 0 ? void 0 : _parent_name.trim()) || "Space";
    }
    var _surface11_refid;
    var surfaceRefid = (_surface11_refid = surface11 === null || surface11 === void 0 ? void 0 : surface11.refid) !== null && _surface11_refid !== void 0 ? _surface11_refid : null;
    var _floor_id;
    var floorId = (_floor_id = floor === null || floor === void 0 ? void 0 : floor.id) !== null && _floor_id !== void 0 ? _floor_id : null;
    var capacity = useMemo21(function() {
        return surfaceRefid && layout && floorId !== null ? resolvePlanCapacity4(layout, registerCapacityOf).surface(surfaceRefid, floorId) : void 0;
    }, [
        surfaceRefid,
        layout,
        floorId,
        registerCapacityOf
    ]);
    var nameSignature = useMemo21(function() {
        return twinNameSignature(layout);
    }, [
        layout
    ]);
    var layoutForNames = useRef31(layout);
    layoutForNames.current = layout;
    var nameIndex = useMemo21(function() {
        return buildTwinNameIndex4(layoutForNames.current, registerRows);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- geometry-only layout writes must not rebuild the register half
    [
        nameSignature,
        registerRows
    ]);
    var _floor_id1, _floor_name;
    return {
        surface: surface11,
        layout: layout,
        design: design,
        floorIndex: floorIndex,
        floorId: (_floor_id1 = floor === null || floor === void 0 ? void 0 : floor.id) !== null && _floor_id1 !== void 0 ? _floor_id1 : null,
        floorName: (_floor_name = floor === null || floor === void 0 ? void 0 : floor.name) !== null && _floor_name !== void 0 ? _floor_name : null,
        hierarchy: hierarchy,
        answer: answer,
        parentage: parentage,
        parentName: parentName2,
        capacity: capacity,
        nameIndex: nameIndex,
        nameSelf: surface11 ? twinNameEntryFor(surface11, "space") : void 0,
        bid: surface11 ? displayBid(twinBid, surface11.entityCode) : "",
        selectionKey: surface11 ? selectedId : null
    };
}
// src/components/Planner/spaceCard/SpaceCapacityField.tsx
import { useEffect as useEffect31, useRef as useRef32, useState as useState33 } from "react";
import styled30 from "styled-components";
import { Input as Input6 } from "@repo/design-system";
import { fontSans, ink as ink5, typeScale as typeScale3 } from "@repo/design-tokens";
import { jsx as jsx38 } from "react/jsx-runtime";
var CAPACITY_ROW = "capacity";
var Unit = styled30.span(_templateObject135(), fontSans, typeScale3.caption1.fontSize, ink5[3]);
function useSpaceCapacityRow(param) {
    var target = param.target, capacity = param.capacity, selectionKey = param.selectionKey, preview = param.preview, editing = param.editing, onEditingChange = param.onEditingChange, announce = param.announce, helpId = param.helpId, container = param.container;
    var _preview_before, _preview_after;
    var contents = (capacity === null || capacity === void 0 ? void 0 : capacity.contents) === void 0 ? "unknown" : capacity.contents;
    var handSet = (capacity === null || capacity === void 0 ? void 0 : capacity.source) === "hand";
    var shown2 = capacity === null || capacity === void 0 ? void 0 : capacity.value;
    var _useState33 = _sliced_to_array(useState33(null), 2), draft = _useState33[0], setDraft = _useState33[1];
    var _useState331 = _sliced_to_array(useState33(null), 2), refusal = _useState331[0], setRefusal = _useState331[1];
    var fieldRef = useRef32(null);
    var focusNext = useRef32(null);
    var closing = useRef32(false);
    useEffect31(function() {
        var what = focusNext.current;
        if (!what) return;
        focusNext.current = null;
        if (what === "select") {
            var _fieldRef_current, _fieldRef_current1;
            (_fieldRef_current = fieldRef.current) === null || _fieldRef_current === void 0 ? void 0 : _fieldRef_current.focus();
            (_fieldRef_current1 = fieldRef.current) === null || _fieldRef_current1 === void 0 ? void 0 : _fieldRef_current1.select();
        } else {
            var _container_current_querySelector, _container_current;
            (_container_current = container.current) === null || _container_current === void 0 ? void 0 : (_container_current_querySelector = _container_current.querySelector('button[data-override-row="'.concat(CAPACITY_ROW, '"]'))) === null || _container_current_querySelector === void 0 ? void 0 : _container_current_querySelector.focus();
        }
    });
    var currentDraft = (draft === null || draft === void 0 ? void 0 : draft.key) === selectionKey ? draft : null;
    var currentRefusal = (refusal === null || refusal === void 0 ? void 0 : refusal.key) === selectionKey ? refusal : null;
    var close = function(refocus) {
        closing.current = true;
        if (refocus) focusNext.current = "action";
        setDraft(null);
        setRefusal(null);
        onEditingChange(false);
    };
    var open = function() {
        closing.current = false;
        focusNext.current = "select";
        setDraft({
            key: selectionKey,
            value: typeof shown2 === "number" ? String(shown2) : "",
            typed: false
        });
        setRefusal(null);
        onEditingChange(true);
    };
    var write = function(value2, refocus) {
        var outcome = applyCapacity(target, value2, contents);
        if (outcome === "refused") {
            setRefusal({
                key: selectionKey,
                text: CAPACITY_REFUSED,
                below: false
            });
            announce.alert(CAPACITY_REFUSED);
            return;
        }
        close(refocus);
        if (outcome === "changed") announce.polite(SAVED);
    };
    var commit = function(how) {
        if (!editing || currentDraft === null || closing.current) return;
        if (!currentDraft.typed) {
            close(how === "enter");
            return;
        }
        var typed = currentDraft.value.trim();
        var zeroOnEmpty = typed === "0" && contents === 0;
        var refused = zeroOnEmpty ? null : capacityRefusal(currentDraft.value, contents);
        if (refused) {
            var n = Number(typed);
            var below = typed !== "" && Number.isInteger(n) && typeof contents === "number" && n < contents;
            setRefusal({
                key: selectionKey,
                text: refused,
                below: below
            });
            announce.alert(refused);
            return;
        }
        write(Number(typed), how === "enter");
    };
    if (editing && currentDraft) {
        var typed = currentDraft.value.trim();
        var typedNumber = Number(typed);
        var typedBelow = typed !== "" && Number.isFinite(typedNumber) && typeof contents === "number" && typedNumber < contents;
        var otherRefusal = currentRefusal && !currentRefusal.below ? currentRefusal : null;
        var help = otherRefusal ? {
            text: otherRefusal.text,
            tone: "error",
            id: helpId
        } : contents === "unknown" ? {
            text: CAPACITY_UNKNOWN_CONTENTS,
            tone: "neutral",
            id: helpId
        } : {
            text: CAPACITY_NOT_BELOW_INSIDE,
            tone: typedBelow || (currentRefusal === null || currentRefusal === void 0 ? void 0 : currentRefusal.below) ? "error" : "neutral",
            id: helpId
        };
        return {
            id: CAPACITY_ROW,
            label: "Capacity",
            help: help,
            editing: /* @__PURE__ */ jsx38(Input6, {
                ref: fieldRef,
                size: "sm",
                "aria-label": "Capacity",
                "aria-describedby": helpId,
                inputMode: "numeric",
                value: currentDraft.value,
                invalid: help.tone === "error",
                trail: /* @__PURE__ */ jsx38(Unit, {
                    "aria-hidden": "true",
                    children: PEOPLE
                }),
                onChange: function(e) {
                    setDraft({
                        key: selectionKey,
                        value: e.target.value,
                        typed: true
                    });
                    if (currentRefusal) setRefusal(null);
                },
                onBlur: function() {
                    return commit("blur");
                },
                onKeyDown: function(e) {
                    if (e.key === "Enter") {
                        e.preventDefault();
                        commit("enter");
                    } else if (e.key === "Escape") {
                        e.preventDefault();
                        e.stopPropagation();
                        close(true);
                    }
                }
            })
        };
    }
    var number = typeof shown2 === "number" ? shown2 : null;
    var before = capacityText(preview === null || preview === void 0 ? void 0 : (_preview_before = preview.before) === null || _preview_before === void 0 ? void 0 : _preview_before.value);
    var after = capacityText(preview === null || preview === void 0 ? void 0 : (_preview_after = preview.after) === null || _preview_after === void 0 ? void 0 : _preview_after.value);
    var value = preview ? before === after ? after : "".concat(before, " → ").concat(after) : number !== null ? String(number) : shown2 === "unknown" ? capacityText(shown2) : NOT_SET;
    return {
        id: CAPACITY_ROW,
        label: "Capacity",
        value: value,
        muted: !preview && number === null,
        source: !preview && number === null ? void 0 : handSet ? BY_HAND : CALCULATED,
        action: handSet ? {
            label: USE_CALCULATED,
            icon: "calculator",
            "aria-label": USE_CALCULATED,
            disabled: !!preview,
            onAction: function() {
                return write(void 0, true);
            }
        } : {
            label: SET_BY_HAND,
            icon: "hand",
            "aria-label": SET_BY_HAND,
            disabled: !!preview,
            onAction: open
        }
    };
}
// src/components/Planner/reshape/useReshapePreview.ts
import { useEffect as useEffect32, useState as useState34 } from "react";
var impacts = /* @__PURE__ */ new WeakMap();
var impactOf = function(state) {
    var impact = impacts.get(state);
    if (!impact) {
        impact = reshapeImpact(state.startDesign, state.refid, state.startPoly, state.latestPoly);
        impacts.set(state, impact);
    }
    return impact;
};
var nextFrame = function(run) {
    if (typeof requestAnimationFrame === "function") {
        var id2 = requestAnimationFrame(run);
        return function() {
            return cancelAnimationFrame(id2);
        };
    }
    var id = setTimeout(run, 16);
    return function() {
        return clearTimeout(id);
    };
};
var useReshapePreview = function(store) {
    var _useState34 = _sliced_to_array(useState34(null), 2), preview = _useState34[0], setPreview = _useState34[1];
    useEffect32(function() {
        if (!store) {
            setPreview(null);
            return;
        }
        var cancel = null;
        var read = function() {
            cancel = null;
            var state = store.getSnapshot();
            setPreview(function(prev) {
                return (prev === null || prev === void 0 ? void 0 : prev.state) === state ? prev : state ? {
                    state: state,
                    impact: impactOf(state)
                } : null;
            });
        };
        read();
        var off = store.subscribe(function() {
            if (!store.getSnapshot()) {
                cancel === null || cancel === void 0 ? void 0 : cancel();
                read();
                return;
            }
            if (!cancel) cancel = nextFrame(read);
        });
        return function() {
            off();
            cancel === null || cancel === void 0 ? void 0 : cancel();
        };
    }, [
        store
    ]);
    return preview;
};
// src/components/Planner/spaceCard/ChangeKindModal.tsx
import { useEffect as useEffect33, useMemo as useMemo22, useState as useState35 } from "react";
import styled31 from "styled-components";
import { Button as Button16, Icon as Icon15, Modal as Modal6, Radio, RadioGroup as RadioGroup2 } from "@repo/design-system";
import { space as space19 } from "@repo/design-tokens";
import { deleteMachineSummary as deleteMachineSummary2, originalIdentityOf } from "@repo/front-end-utils";
// src/components/Planner/spaceCard/changeKind.ts
import { KIND_LETTER, mintEntityBid as mintEntityBid2, resolvePlanHierarchy as resolvePlanHierarchy5 } from "@repo/front-end-utils";
var nextSpaceCode = function(twinBid, kind, liveBids) {
    return mintEntityBid2(twinBid, KIND_LETTER[kind], currentHighWaterMark(twinBid, liveBids).mark);
};
var newlyTooDeep = function(design, refid, code) {
    if (!design) return 0;
    var tooDeep = function(d) {
        return new Set(resolvePlanHierarchy5(d).problems.filter(function(p) {
            return p.code === "too-deep" && p.entity === "surface";
        }).map(function(p) {
            return p.refid;
        }));
    };
    var before = tooDeep(design);
    var after = tooDeep(_object_spread_props(_object_spread({}, design), {
        surfaces: design.surfaces.map(function(s) {
            return s.refid === refid ? _object_spread_props(_object_spread({}, s), {
                entityCode: code
            }) : s;
        })
    }));
    var n = 0;
    after.forEach(function(r) {
        if (!before.has(r)) n += 1;
    });
    return n;
};
// src/components/Planner/spaceCard/ChangeKindModal.tsx
import { Fragment as Fragment18, jsx as jsx39, jsxs as jsxs28 } from "react/jsx-runtime";
var Body4 = styled31.div(_templateObject136(), space19[3]);
var ChangeKindModal = function(param) {
    var name = param.name, refid = param.refid, code = param.code, answer = param.answer, twinBid = param.twinBid, layout = param.layout, design = param.design, liveBids = param.liveBids, launched = param.launched, blocked = param.blocked, initialKind = param.initialKind, returnFocusTo = param.returnFocusTo, onCancel = param.onCancel, onConfirm = param.onConfirm;
    var _answer_kind;
    var from = (_answer_kind = answer === null || answer === void 0 ? void 0 : answer.kind) !== null && _answer_kind !== void 0 ? _answer_kind : null;
    var choices = SPACE_KINDS.filter(function(k) {
        return k !== from;
    });
    var _useState35 = _sliced_to_array(useState35(initialKind && choices.includes(initialKind) ? initialKind : choices[0]), 2), chosen = _useState35[0], setChosen = _useState35[1];
    var _useState351 = _sliced_to_array(useState35(0), 2), mintRound = _useState351[0], setMintRound = _useState351[1];
    var _useState352 = _sliced_to_array(useState35(false), 2), moved = _useState352[0], setMoved = _useState352[1];
    var outcome = useMemo22(function() {
        return nextSpaceCode(twinBid, chosen, liveBids);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- mintRound re-mints after a moved confirm
    [
        twinBid,
        chosen,
        liveBids,
        mintRound
    ]);
    var confirm = function() {
        if (blocked || !outcome.ok) return;
        var fresh = nextSpaceCode(twinBid, chosen, liveBids);
        if (!fresh.ok || fresh.bid !== outcome.bid) {
            setMoved(true);
            setMintRound(function(n) {
                return n + 1;
            });
            return;
        }
        onConfirm(chosen, fresh.bid);
    };
    useEffect33(function() {
        if (!outcome.ok) console.warn("[space-card] mint exhausted", {
            twinBid: twinBid,
            kind: chosen
        });
    }, [
        outcome,
        twinBid,
        chosen
    ]);
    var newBid = outcome.ok ? displayBid(twinBid, outcome.bid) : "";
    var deeper = useMemo22(function() {
        return outcome.ok ? newlyTooDeep(design, refid, outcome.bid) : 0;
    }, [
        design,
        refid,
        outcome
    ]);
    var live = launched !== false;
    var _originalIdentityOf;
    var oldBid = displayBid(twinBid, (_originalIdentityOf = originalIdentityOf(layout, refid)) !== null && _originalIdentityOf !== void 0 ? _originalIdentityOf : code);
    var takes = useMemo22(function() {
        return live ? takesLines(deleteMachineSummary2(layout, design, refid)) : [];
    }, [
        live,
        layout,
        design,
        refid
    ]);
    return /* @__PURE__ */ jsx39(Modal6, {
        open: true,
        onClose: onCancel,
        returnFocusTo: returnFocusTo,
        title: changeKindTitle(name, from, chosen),
        tone: live ? "coral" : "butter",
        width: "md",
        icon: /* @__PURE__ */ jsx39(Icon15, {
            name: "object-group"
        }),
        actions: /* @__PURE__ */ jsxs28(Fragment18, {
            children: [
                /* @__PURE__ */ jsx39(Button16, {
                    type: "button",
                    variant: "frosted",
                    autoFocus: true,
                    onClick: onCancel,
                    children: "Cancel"
                }),
                /* @__PURE__ */ jsx39(Button16, {
                    type: "button",
                    variant: live ? "destructive" : "primary",
                    disabled: !outcome.ok || !!blocked,
                    onClick: confirm,
                    children: "Change to ".concat(kindTitle(chosen))
                })
            ]
        }),
        children: /* @__PURE__ */ jsxs28(Body4, {
            children: [
                live && outcome.ok && /* @__PURE__ */ jsxs28(Fragment18, {
                    children: [
                        liveKindLines({
                            name: name,
                            oldBid: oldBid,
                            newBid: newBid,
                            chosen: chosen,
                            launched: launched === true ? true : "unknown"
                        }).map(function(line3) {
                            return /* @__PURE__ */ jsx39("p", {
                                children: line3
                            }, line3);
                        }),
                        takes.length > 0 ? /* @__PURE__ */ jsx39("ul", {
                            children: takes.map(function(line3) {
                                return /* @__PURE__ */ jsx39("li", {
                                    children: line3
                                }, line3);
                            })
                        }) : /* @__PURE__ */ jsx39("p", {
                            children: "Nothing else uses it."
                        }),
                        launched === "unknown" && /* @__PURE__ */ jsx39("p", {
                            children: CANT_CHECK_LIVE
                        })
                    ]
                }),
                /* @__PURE__ */ jsx39(RadioGroup2, {
                    label: "New kind",
                    value: chosen,
                    surface: "on-solid",
                    onChange: function(value) {
                        var next = choices.find(function(k) {
                            return k === value;
                        });
                        if (next) {
                            setChosen(next);
                            setMoved(false);
                        }
                    },
                    children: choices.map(function(kind) {
                        return /* @__PURE__ */ jsx39(Radio, {
                            value: kind,
                            children: kindTitle(kind)
                        }, kind);
                    })
                }),
                outcome.ok ? /* @__PURE__ */ jsx39("p", {
                    children: bidBecomes(newBid)
                }) : /* @__PURE__ */ jsx39("p", {
                    role: "alert",
                    children: outcome.message
                }),
                moved && outcome.ok && /* @__PURE__ */ jsx39("p", {
                    role: "alert",
                    children: BID_MOVED
                }),
                blocked && /* @__PURE__ */ jsx39("p", {
                    role: "alert",
                    children: blocked
                }),
                outcome.ok && (answer === null || answer === void 0 ? void 0 : answer.placeKind) && chosen !== answer.placeKind && /* @__PURE__ */ jsx39("p", {
                    children: drawingDisagrees(answer.placeKind)
                }),
                deeper > 0 && /* @__PURE__ */ jsx39("p", {
                    children: tooDeepInside(deeper, chosen)
                })
            ]
        })
    });
};
// src/components/Planner/itemCard/BidRow.tsx
import styled32 from "styled-components";
import { Button as Button17, Icon as Icon16, Tag as Tag5 } from "@repo/design-system";
import { controlHeight, fontMono as fontMono5, fontSans as fontSans2, ink as ink6, space as space20, typeScale as typeScale4, weight as weight5 } from "@repo/design-tokens";
import { Fragment as Fragment19, jsx as jsx40, jsxs as jsxs29 } from "react/jsx-runtime";
var bidRowTag = function(param) {
    var hasModel = param.hasModel, held = param.held, failed = param.failed, count = param.count;
    return !hasModel ? null : failed ? {
        kind: "unavailable"
    } : held === "never" ? {
        kind: "checking"
    } : {
        kind: "count",
        n: count
    };
};
var Row = styled32.div(_templateObject137(), space20[2], controlHeight.md);
var Label = styled32.span(_templateObject138(), weight5.regular, typeScale4.caption1.fontSize, typeScale4.caption1.lineHeight, fontSans2, ink6[3]);
var Value = styled32.span(_templateObject139(), space20[1], weight5.regular, typeScale4.caption1.fontSize, typeScale4.caption1.lineHeight, fontMono5, ink6[1], weight5.regular, typeScale4.body1.fontSize, typeScale4.body1.lineHeight, fontSans2, ink6[3]);
var TagCell = styled32.span(_templateObject140());
var BidRow = function(param) {
    var bid = param.bid, tag = param.tag, announce = param.announce, copyRef = param.copyRef;
    var copy = function() {
        var refused = function() {
            console.warn("[BidRow] clipboard write refused");
            announce(COPY_FAILED);
        };
        try {
            var _navigator_clipboard;
            var write = (_navigator_clipboard = navigator.clipboard) === null || _navigator_clipboard === void 0 ? void 0 : _navigator_clipboard.writeText(bid);
            if (!write) {
                refused();
                return;
            }
            write.then(function() {
                return announce(copiedBid(bid));
            }, refused);
        } catch (e) {
            refused();
        }
    };
    return /* @__PURE__ */ jsxs29(Row, {
        "data-testid": "bid-row",
        children: [
            /* @__PURE__ */ jsx40(Label, {
                children: "BID"
            }),
            /* @__PURE__ */ jsx40(Value, {
                children: bid ? /* @__PURE__ */ jsxs29(Fragment19, {
                    children: [
                        /* @__PURE__ */ jsx40("span", {
                            className: "bid",
                            title: bid,
                            children: bid
                        }),
                        /* @__PURE__ */ jsx40(Button17, {
                            ref: copyRef,
                            type: "button",
                            variant: "text",
                            size: "xs",
                            iconOnly: true,
                            circle: true,
                            "aria-label": copyBidLabel(bid),
                            iconLeft: /* @__PURE__ */ jsx40(Icon16, {
                                name: "copy",
                                size: "xs"
                            }),
                            onClick: copy
                        })
                    ]
                }) : /* @__PURE__ */ jsx40("span", {
                    className: "none",
                    children: ISSUED_AT_LAUNCH
                })
            }),
            /* @__PURE__ */ jsxs29(TagCell, {
                children: [
                    (tag === null || tag === void 0 ? void 0 : tag.kind) === "count" && (tag.n === 0 ? /* @__PURE__ */ jsx40(Tag5, {
                        surface: "on-solid",
                        size: "xs",
                        tone: "mint",
                        icon: /* @__PURE__ */ jsx40(Icon16, {
                            name: "circle-check",
                            size: "xs"
                        }),
                        children: issueCountTag(0)
                    }) : /* @__PURE__ */ jsx40(Tag5, {
                        surface: "on-solid",
                        size: "xs",
                        tone: "error",
                        icon: /* @__PURE__ */ jsx40(Icon16, {
                            name: "circle-exclamation",
                            size: "xs"
                        }),
                        children: issueCountTag(tag.n)
                    })),
                    (tag === null || tag === void 0 ? void 0 : tag.kind) === "checking" && /* @__PURE__ */ jsx40(Tag5, {
                        surface: "on-solid",
                        size: "xs",
                        tone: "neutral",
                        children: CHECKING
                    }),
                    (tag === null || tag === void 0 ? void 0 : tag.kind) === "unavailable" && /* @__PURE__ */ jsx40(Tag5, {
                        surface: "on-solid",
                        size: "xs",
                        tone: "neutral",
                        children: CHECKS_UNAVAILABLE2
                    })
                ]
            })
        ]
    });
};
// src/components/Planner/itemCard/ItemIssues.tsx
import React8 from "react";
import styled33 from "styled-components";
import { Button as Button18, Icon as Icon17 } from "@repo/design-system";
import { fontSans as fontSans3, ink as ink7, inset as inset5, line as line2, radius as radius8, rgba as rgba2, semanticColor, space as space21, surface as surface3, typeScale as typeScale5, weight as weight6 } from "@repo/design-tokens";
import { Fragment as Fragment20, jsx as jsx41, jsxs as jsxs30 } from "react/jsx-runtime";
var FIX_GLYPH = {
    "link-or-add": "plus",
    rename: "pen",
    "keep-parent": "check",
    "keep-capacity": "check",
    "confirm-product": "check",
    "use-drawing": "arrow-rotate-left",
    "use-calculated": "calculator",
    "reissue-bid": "rotate-left",
    "change-product": "magnifying-glass",
    "set-capacity": "hand",
    "change-kind": "shapes",
    "change-parent": "pen",
    identify: "magnifying-glass"
};
var List = styled33.ul(_templateObject141(), radius8.lg, rgba2(surface3[0], 0.6), rgba2(semanticColor.error, 0.28));
var Entry = styled33.li(_templateObject142(), inset5[2], space21[2], inset5[3], line2[4]);
var Dot2 = styled33.span(_templateObject143(), space21[1], radius8.pill, function(param) {
    var $fill = param.$fill;
    return $fill;
});
var Words = styled33.p(_templateObject144(), weight6.regular, typeScale5.caption1.fontSize, typeScale5.caption1.lineHeight, fontSans3, ink7[1]);
var Level = styled33.span(_templateObject145(), weight6.semibold, function(param) {
    var $ink = param.$ink;
    return $ink;
});
var Fixes = styled33.div(_templateObject146(), inset5[2]);
var ItemIssues = function(param) {
    var lines = param.lines, name = param.name, onFix = param.onFix, renderLinkOrAdd = param.renderLinkOrAdd, fixState = param.fixState, listRef = param.listRef, onShowHolder = param.onShowHolder;
    if (lines.length === 0) return null;
    return /* @__PURE__ */ jsx41(List, {
        ref: listRef,
        "aria-label": issuesListName(lines.length, name),
        "data-testid": "item-issues",
        children: lines.map(function(entry) {
            var look = ROW_STATE_LOOK[entry.kind];
            return /* @__PURE__ */ jsxs30(Entry, {
                "data-issue": entry.key,
                children: [
                    /* @__PURE__ */ jsx41(Dot2, {
                        $fill: look.fill,
                        "aria-hidden": "true"
                    }),
                    /* @__PURE__ */ jsxs30(Words, {
                        children: [
                            /* @__PURE__ */ jsx41(Level, {
                                $ink: look.ink,
                                children: entry.words
                            }),
                            entry.holder && onShowHolder ? /* @__PURE__ */ jsxs30(Fragment20, {
                                children: [
                                    /* @__PURE__ */ jsx41("span", {
                                        "aria-hidden": "true",
                                        children: " \xb7 ".concat(entry.holder.prefix, " ")
                                    }),
                                    /* @__PURE__ */ jsx41("span", {
                                        style: visuallyHidden,
                                        children: " \xb7 ".concat(entry.sentence, ", ")
                                    }),
                                    /* @__PURE__ */ jsx41(HolderButton, {
                                        holder: entry.holder,
                                        onPress: function() {
                                            return entry.holder && onShowHolder(entry.holder, entry);
                                        }
                                    })
                                ]
                            }) : " \xb7 ".concat(entry.sentence)
                        ]
                    }),
                    entry.fixes.length > 0 && /* @__PURE__ */ jsx41(Fixes, {
                        children: entry.fixes.map(function(fix, i) {
                            if (fix.kind === "link-or-add" && renderLinkOrAdd) {
                                return /* @__PURE__ */ jsx41(React8.Fragment, {
                                    children: renderLinkOrAdd(fix, entry)
                                }, fix.kind);
                            }
                            var state = fixState === null || fixState === void 0 ? void 0 : fixState(fix, entry);
                            var first = i === 0;
                            var brandChip = fix.kind === "link-or-add";
                            return /* @__PURE__ */ jsx41(Button18, {
                                type: "button",
                                size: "xs",
                                variant: first || brandChip ? "frosted" : "text",
                                tone: first && !brandChip ? void 0 : "brand",
                                iconLeft: /* @__PURE__ */ jsx41(Icon17, {
                                    name: FIX_GLYPH[fix.kind],
                                    size: "xs"
                                }),
                                "data-fix": fix.kind,
                                "data-issue": entry.key,
                                disabled: state === null || state === void 0 ? void 0 : state.disabled,
                                loading: state === null || state === void 0 ? void 0 : state.loading,
                                "aria-describedby": state === null || state === void 0 ? void 0 : state.describedBy,
                                onClick: function() {
                                    return onFix(fix, entry);
                                },
                                children: fix.label
                            }, fix.kind);
                        })
                    })
                ]
            }, entry.key);
        })
    });
};
var entriesOf = function(list) {
    return list ? Array.from(list.querySelectorAll(":scope > [data-issue]")) : [];
};
var issueKeysAfter = function(list, key) {
    var keys = entriesOf(list).map(function(e) {
        var _e_dataset_issue;
        return (_e_dataset_issue = e.dataset.issue) !== null && _e_dataset_issue !== void 0 ? _e_dataset_issue : "";
    });
    var at3 = keys.indexOf(key);
    return at3 < 0 ? [] : keys.slice(at3 + 1);
};
var firstFixAfter = function(list, next) {
    var byKey = new Map(entriesOf(list).map(function(e) {
        return [
            e.dataset.issue,
            e
        ];
    }));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = next[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            var _byKey_get;
            var fix = (_byKey_get = byKey.get(key)) === null || _byKey_get === void 0 ? void 0 : _byKey_get.querySelector("button:not([disabled])");
            if (fix) return fix;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
};
// src/components/Planner/itemCard/NameEditor.tsx
import { useEffect as useEffect34, useId as useId4, useRef as useRef33, useState as useState36 } from "react";
import styled34 from "styled-components";
import { Button as Button19, Icon as Icon18, Input as Input7 } from "@repo/design-system";
import { inkOn as inkOn2 } from "@repo/design-tokens";
import { isNameTaken as isNameTaken4, nextFreeName as nextFreeName4 } from "@repo/front-end-utils";
import { Fragment as Fragment21, jsx as jsx42, jsxs as jsxs31 } from "react/jsx-runtime";
var ALREADY_USED = "Already used on this twin.";
var renameLabel = function(name) {
    return "Rename ".concat(name);
};
var Coral = styled34.span(_templateObject147(), inkOn2.error);
var ErrorGlyph = styled34.span(_templateObject148(), inkOn2.error);
function useNameEditor(param) {
    var selectionKey = param.selectionKey, name = param.name, title = param.title, nameIndex = param.nameIndex, nameSelf = param.nameSelf, onCommit = param.onCommit, announce = param.announce, _param_busy = param.busy, busy = _param_busy === void 0 ? false : _param_busy, disabledReason = param.disabledReason, standing = param.standing, onOpen = param.onOpen;
    var ids = useId4();
    var subId = "".concat(ids, "-name-sub");
    var reasonId = "".concat(ids, "-name-reason");
    var _useState36 = _sliced_to_array(useState36(null), 2), state = _useState36[0], setState = _useState36[1];
    var _useState361 = _sliced_to_array(useState36(null), 2), pendingKey = _useState361[0], setPendingKey = _useState361[1];
    var pendingFor = useRef33(null);
    var liveKey = useRef33(selectionKey);
    liveKey.current = selectionKey;
    var penRef = useRef33(null);
    var inputRef = useRef33(null);
    var closing = useRef33(false);
    var focusNext = useRef33(null);
    var current2 = state && state.key === selectionKey ? state : null;
    var isOpen = current2 !== null;
    useEffect34(function() {
        var what = focusNext.current;
        if (!what) return;
        focusNext.current = null;
        if (what === "pen") {
            var _penRef_current;
            (_penRef_current = penRef.current) === null || _penRef_current === void 0 ? void 0 : _penRef_current.focus();
        } else {
            var _inputRef_current, _inputRef_current1;
            (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
            (_inputRef_current1 = inputRef.current) === null || _inputRef_current1 === void 0 ? void 0 : _inputRef_current1.select();
        }
    });
    var open = function(prefill) {
        onOpen === null || onOpen === void 0 ? void 0 : onOpen();
        closing.current = false;
        focusNext.current = "select";
        setState({
            key: selectionKey,
            draft: prefill !== null && prefill !== void 0 ? prefill : name,
            refused: null
        });
    };
    var close = function() {
        var refocus = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        closing.current = true;
        if (refocus) focusNext.current = "pen";
        setState(null);
    };
    var focusLost = function() {
        var active = document.activeElement;
        return !active || active === document.body || active === inputRef.current;
    };
    var settle = function(outcome, forKey, late) {
        if (outcome === "landed" || outcome === "unchanged") {
            close(!late || focusLost());
            if (outcome === "landed") announce.polite(SAVED);
            return;
        }
        setState(function(s) {
            return s && s.key === forKey ? _object_spread_props(_object_spread({}, s), {
                refused: {
                    text: outcome.refused,
                    offer: outcome.offer,
                    draft: s.draft
                }
            }) : s;
        });
        announce.alert(outcome.refused);
    };
    var commit = function(value) {
        var forKey = selectionKey;
        if (busy || pendingFor.current === forKey) return;
        var typed2 = value.trim();
        if (typed2 === name.trim()) {
            close();
            return;
        }
        var outcome = onCommit(typed2);
        if (outcome && typeof outcome.then === "function") {
            pendingFor.current = forKey;
            setPendingKey(forKey);
            var done = function() {
                if (pendingFor.current === forKey) pendingFor.current = null;
                setPendingKey(function(k) {
                    return k === forKey ? null : k;
                });
            };
            outcome.then(function(result) {
                done();
                if (liveKey.current !== forKey) return;
                settle(result, forKey, true);
            }, done);
            return;
        }
        settle(outcome, forKey, false);
    };
    var _current2_draft;
    var draft = (_current2_draft = current2 === null || current2 === void 0 ? void 0 : current2.draft) !== null && _current2_draft !== void 0 ? _current2_draft : "";
    var typed = draft.trim();
    var changed = typed !== "" && typed !== name.trim();
    var taken = changed && isNameTaken4(typed, nameIndex, nameSelf);
    var refusal = (current2 === null || current2 === void 0 ? void 0 : current2.refused) && current2.refused.draft === draft ? current2.refused : null;
    var offer = refusal ? refusal.offer : taken ? nextFreeName4(typed, nameIndex) : void 0;
    var coral = !!refusal || taken;
    var readOnly = busy || pendingKey !== null && pendingKey === selectionKey;
    var useOffer = function(free) {
        return /* @__PURE__ */ jsx42(Button19, {
            type: "button",
            variant: "text",
            tone: "destructive",
            size: "xs",
            onMouseDown: function(e) {
                return e.preventDefault();
            },
            onClick: function() {
                setState(function(s) {
                    return s ? _object_spread_props(_object_spread({}, s), {
                        draft: free
                    }) : s;
                });
                commit(free);
            },
            children: freeNameButtonLabel(free)
        });
    };
    var showStanding = !isOpen && !!standing;
    var alert = announce.alert;
    useEffect34(function() {
        if (showStanding && standing) alert(standing);
    }, [
        showStanding,
        standing,
        selectionKey,
        alert
    ]);
    var sub = isOpen ? /* @__PURE__ */ jsx42("span", {
        id: subId,
        children: coral ? /* @__PURE__ */ jsx42(Coral, {
            "data-tone": "error",
            children: offer !== void 0 ? /* @__PURE__ */ jsxs31(Fragment21, {
                children: [
                    "".concat(ALREADY_USED, " "),
                    useOffer(offer)
                ]
            }) : refusal === null || refusal === void 0 ? void 0 : refusal.text
        }) : NAME_MUST_BE_UNIQUE
    }) : showStanding ? /* @__PURE__ */ jsx42("span", {
        id: subId,
        children: /* @__PURE__ */ jsx42(Coral, {
            "data-tone": "error",
            children: standing
        })
    }) : void 0;
    var editor = isOpen ? /* @__PURE__ */ jsx42(Input7, {
        ref: inputRef,
        size: "sm",
        "aria-label": "Name",
        "aria-describedby": subId,
        "aria-busy": readOnly || void 0,
        value: draft,
        readOnly: readOnly,
        valid: changed && !taken && !refusal,
        validLabel: "Name is free",
        invalid: coral,
        trail: coral ? /* @__PURE__ */ jsx42(ErrorGlyph, {
            children: /* @__PURE__ */ jsx42(Icon18, {
                name: "circle-xmark",
                size: "sm"
            })
        }) : void 0,
        onChange: function(e) {
            var next = e.target.value;
            setState(function(s) {
                return s && s.key === selectionKey ? _object_spread_props(_object_spread({}, s), {
                    draft: next
                }) : s;
            });
        },
        onKeyDown: function(e) {
            if (e.key === "Enter") {
                e.preventDefault();
                commit(draft);
            } else if (e.key === "Escape") {
                e.preventDefault();
                e.stopPropagation();
                close();
            }
        },
        onBlur: function() {
            if (closing.current) return;
            if (refusal) return;
            commit(draft);
        }
    }) : void 0;
    var pen = /* @__PURE__ */ jsxs31(Fragment21, {
        children: [
            /* @__PURE__ */ jsx42(Button19, {
                ref: penRef,
                type: "button",
                variant: "text",
                size: "xs",
                iconOnly: true,
                circle: true,
                "aria-label": renameLabel(title),
                iconLeft: /* @__PURE__ */ jsx42(Icon18, {
                    name: "pen",
                    size: "xs"
                }),
                disabled: !!disabledReason,
                "aria-describedby": disabledReason ? reasonId : void 0,
                onClick: function() {
                    return open();
                }
            }),
            disabledReason && /* @__PURE__ */ jsx42("span", {
                id: reasonId,
                style: visuallyHidden,
                children: disabledReason
            })
        ]
    });
    return {
        open: open,
        isOpen: isOpen,
        pen: pen,
        editor: editor,
        sub: sub,
        penRef: penRef
    };
}
// src/components/Planner/itemCard/useCardAnnouncer.tsx
import { useCallback as useCallback17, useMemo as useMemo23, useState as useState37 } from "react";
import { Fragment as Fragment22, jsx as jsx43, jsxs as jsxs32 } from "react/jsx-runtime";
var NOTHING2 = {
    n: 0,
    text: "",
    at: 0
};
var JOIN_WITHIN_MS = 1e3;
var joined = function(last, text2) {
    var now = Date.now();
    var join = last.text !== "" && now - last.at < JOIN_WITHIN_MS && last.text !== text2;
    return {
        n: last.n + 1,
        text: join ? "".concat(last.text, ". ").concat(text2) : text2,
        at: now
    };
};
function useCardAnnouncer() {
    var _useState37 = _sliced_to_array(useState37(NOTHING2), 2), polite = _useState37[0], setPolite = _useState37[1];
    var _useState371 = _sliced_to_array(useState37(NOTHING2), 2), alert = _useState371[0], setAlert = _useState371[1];
    var sayPolite = useCallback17(function(text2) {
        return setPolite(function(s) {
            return joined(s, text2);
        });
    }, []);
    var sayAlert = useCallback17(function(text2) {
        return setAlert(function(s) {
            return {
                n: s.n + 1,
                text: text2,
                at: Date.now()
            };
        });
    }, []);
    var regions = useMemo23(function() {
        return /* @__PURE__ */ jsxs32(Fragment22, {
            children: [
                /* @__PURE__ */ jsx43("div", {
                    role: "status",
                    "aria-live": "polite",
                    style: visuallyHidden,
                    "data-card-region": "polite",
                    children: polite.text && /* @__PURE__ */ jsx43("span", {
                        children: polite.text
                    }, polite.n)
                }),
                /* @__PURE__ */ jsx43("div", {
                    role: "alert",
                    style: visuallyHidden,
                    "data-card-region": "alert",
                    children: alert.text && /* @__PURE__ */ jsx43("span", {
                        children: alert.text
                    }, alert.n)
                })
            ]
        });
    }, [
        polite,
        alert
    ]);
    return {
        polite: sayPolite,
        alert: sayAlert,
        regions: regions
    };
}
// src/components/Planner/itemCard/useHeldEntityChecks.ts
import { useState as useState38 } from "react";
var NONE = [];
var sameChecks = function(a, b) {
    return a === b || a.length === b.length && a.every(function(c, i) {
        return c.id === b[i].id && c.sentence === b[i].sentence && c.name === b[i].name && JSON.stringify(c.fix) === JSON.stringify(b[i].fix) && JSON.stringify(c.holders) === JSON.stringify(b[i].holders);
    });
};
function useHeldEntityChecks(floorId, entity, refid, selectionKey) {
    var model = usePlanChecksContext();
    var settled = usePlanChecksSettled();
    var _useState38 = _sliced_to_array(useState38({
        key: selectionKey,
        checks: NONE,
        settled: false
    }), 2), held = _useState38[0], setHeld = _useState38[1];
    var next = held.key === selectionKey ? held : {
        key: selectionKey,
        checks: NONE,
        settled: false
    };
    if (settled && model && (model.known || model.failed) && refid !== null) {
        var fresh = model.checksFor(floorId, entity, refid);
        if (!next.settled || !sameChecks(next.checks, fresh)) {
            next = {
                key: selectionKey,
                checks: fresh,
                settled: true
            };
        }
    }
    if (next !== held) setHeld(next);
    var _model_failed, _model_registerKnown;
    return {
        checks: next.checks,
        held: next.settled ? "settled" : "never",
        failed: (_model_failed = model === null || model === void 0 ? void 0 : model.failed) !== null && _model_failed !== void 0 ? _model_failed : false,
        registerKnown: (_model_registerKnown = model === null || model === void 0 ? void 0 : model.registerKnown) !== null && _model_registerKnown !== void 0 ? _model_registerKnown : false
    };
}
// src/components/Planner/itemCard/itemIssueLines.ts
import { CHECK_LEVELS } from "@repo/front-end-utils";
var numberOr = function(value) {
    return typeof value === "number" ? value : null;
};
var sentenceOf = function(check, names) {
    if (check.code === "parent-chosen-differs" && check.fix.type === "parent") {
        var drawn = check.fix.drawn;
        return parentDiffersSentence(drawn === null ? null : names.parentName(drawn));
    }
    if (check.code === "capacity-contents-changed") {
        var _names_capacity, _names_capacity1, _names_capacity2;
        var fixContents = check.fix.type === "capacity" ? check.fix.contents : void 0;
        var _names_capacity_contents;
        return contentsChangedSentence((_names_capacity = names.capacity) === null || _names_capacity === void 0 ? void 0 : _names_capacity.value, (_names_capacity1 = names.capacity) === null || _names_capacity1 === void 0 ? void 0 : _names_capacity1.reviewedContents, (_names_capacity_contents = (_names_capacity2 = names.capacity) === null || _names_capacity2 === void 0 ? void 0 : _names_capacity2.contents) !== null && _names_capacity_contents !== void 0 ? _names_capacity_contents : fixContents, check.sentence);
    }
    return check.sentence;
};
var fixesOf = function(check, names) {
    var fix = check.fix;
    switch(fix.type){
        case "link-or-add":
            return [
                {
                    kind: "link-or-add",
                    label: ADD_TO_REGISTER
                }
            ];
        case "rename":
            return [
                {
                    kind: "rename",
                    label: RENAME,
                    suggestion: fix.suggestion
                }
            ];
        case "parent":
            {
                var name = names.parentName(names.chosenParent);
                return [
                    {
                        kind: "keep-parent",
                        label: keepLabel(name),
                        name: name
                    },
                    {
                        kind: "use-drawing",
                        label: USE_THE_DRAWING
                    }
                ];
            }
        case "capacity":
            {
                var _names_capacity, _names_capacity1;
                var _names_capacity_contents;
                var contents = numberOr((_names_capacity_contents = (_names_capacity = names.capacity) === null || _names_capacity === void 0 ? void 0 : _names_capacity.contents) !== null && _names_capacity_contents !== void 0 ? _names_capacity_contents : fix.contents);
                var useCalculated = {
                    kind: "use-calculated",
                    label: useCalculatedFixLabel(contents),
                    contents: contents
                };
                var kept = numberOr((_names_capacity1 = names.capacity) === null || _names_capacity1 === void 0 ? void 0 : _names_capacity1.value);
                return fix.keep && kept !== null ? [
                    {
                        kind: "keep-capacity",
                        label: keepLabel(kept),
                        value: kept
                    },
                    useCalculated
                ] : [
                    useCalculated
                ];
            }
        case "choose-parent":
            return [
                {
                    kind: "change-parent",
                    label: CHANGE_PARENT
                }
            ];
        case "machine-capacity":
            return names.rowHasProduct ? [
                {
                    kind: "set-capacity",
                    label: SET_BY_HAND
                }
            ] : [
                {
                    kind: "set-capacity",
                    label: SET_BY_HAND
                },
                {
                    kind: "identify",
                    label: IDENTIFY
                }
            ];
        case "reissue-bid":
            if (check.entity !== "surface") return [];
            return names.placeKind ? [
                {
                    kind: "reissue-bid",
                    label: reissueBidLabel(names.placeKind),
                    placeKind: names.placeKind
                }
            ] : [
                {
                    kind: "change-kind",
                    label: CHANGE_KIND
                }
            ];
        case "open":
        case "none":
        case "place":
        default:
            return [];
    }
};
var identifyLine = function(identify) {
    var fixes = identify.state === "to_identify" ? [
        {
            kind: "identify",
            label: IDENTIFY
        }
    ] : identify.state === "to_confirm" ? _to_consumable_array(identify.proposalReferenceId ? [
        {
            kind: "confirm-product",
            label: CONFIRM,
            referenceId: identify.proposalReferenceId
        }
    ] : []).concat([
        {
            kind: "change-product",
            label: CHANGE_PRODUCT
        }
    ]) : [
        {
            kind: "change-product",
            label: CHANGE_PRODUCT
        }
    ];
    return {
        key: "identify",
        kind: "identify",
        words: LEVEL_WORDS.identify,
        sentence: IDENTIFY_SENTENCES[identify.state],
        fixes: fixes
    };
};
var itemIssueLines = function(checks, identify, names) {
    var seen = /* @__PURE__ */ new Map();
    var lines = checks.map(function(check) {
        var _CHECK_LEVELS_check_code;
        var level = (_CHECK_LEVELS_check_code = CHECK_LEVELS[check.code]) !== null && _CHECK_LEVELS_check_code !== void 0 ? _CHECK_LEVELS_check_code : check.kind;
        var kind = level === "error" ? "error" : "check";
        var known = check.code in CHECK_LEVELS;
        var _seen_get;
        var n = ((_seen_get = seen.get(check.code)) !== null && _seen_get !== void 0 ? _seen_get : 0) + 1;
        seen.set(check.code, n);
        var holder = known ? linkableHolder(check) : null;
        return _object_spread_props(_object_spread({
            key: n === 1 ? check.code : "".concat(check.code, ":").concat(n),
            kind: kind,
            words: LEVEL_WORDS[kind],
            sentence: known ? sentenceOf(check, names) : check.sentence
        }, holder ? {
            holder: holder
        } : {}), {
            fixes: known ? fixesOf(check, names) : []
        });
    });
    if (identify) lines.push(identifyLine(identify));
    return lines;
};
// src/components/Planner/itemCard/insideOf.ts
import { asArray as asArray10, firstLiveSurfaces, isLive as isLive11, resolvePlanHierarchy as resolvePlanHierarchy6, resolvePlanParentage as resolvePlanParentage7, surfaceName as surfaceName2 } from "@repo/front-end-utils";
var collator2 = new Intl.Collator(void 0, {
    numeric: true
});
var insideOf = function(design, refid) {
    var parentage = resolvePlanParentage7(design);
    var hierarchy = resolvePlanHierarchy6(design);
    var children = [];
    firstLiveSurfaces(design === null || design === void 0 ? void 0 : design.surfaces).forEach(function(s) {
        var _parentage_surface, _hierarchy_surface;
        if (s.refid === refid || ((_parentage_surface = parentage.surface(s.refid)) === null || _parentage_surface === void 0 ? void 0 : _parentage_surface.effectiveParent) !== refid) return;
        var _hierarchy_surface_kind;
        children.push({
            refid: s.refid,
            name: surfaceName2(s) || "Space",
            kind: (_hierarchy_surface_kind = (_hierarchy_surface = hierarchy.surface(s.refid)) === null || _hierarchy_surface === void 0 ? void 0 : _hierarchy_surface.kind) !== null && _hierarchy_surface_kind !== void 0 ? _hierarchy_surface_kind : "area"
        });
    });
    var seen = /* @__PURE__ */ new Set();
    asArray10(design === null || design === void 0 ? void 0 : design.items).forEach(function(it) {
        var _parentage_item, _it_name;
        if (!isLive11(it) || typeof it.refid !== "string" || it.refid === "") return;
        if (seen.has(it.refid)) return;
        if (((_parentage_item = parentage.item(it)) === null || _parentage_item === void 0 ? void 0 : _parentage_item.effectiveParent) !== refid) return;
        seen.add(it.refid);
        children.push({
            refid: it.refid,
            name: ((_it_name = it.name) === null || _it_name === void 0 ? void 0 : _it_name.trim()) || "Machine",
            kind: "machine"
        });
    });
    return children.sort(function(a, b) {
        return collator2.compare(a.name, b.name);
    });
};
var ORDER = [
    "zone",
    "section",
    "area",
    "machine"
];
var insideCountPhrase = function(children) {
    return ORDER.map(function(kind) {
        var n = children.filter(function(c) {
            return c.kind === kind;
        }).length;
        return n === 0 ? "" : "".concat(n, " ").concat(kind).concat(n === 1 ? "" : "s");
    }).filter(Boolean).join(" \xB7 ");
};
// src/components/Planner/itemCard/subLine.ts
var article = function(word) {
    return /^[aeiou]/i.test(word) ? "An" : "A";
};
var place = function(param) {
    var parentName2 = param.parentName, floorName = param.floorName, onFloor = param.onFloor;
    var _this;
    var name = (_this = onFloor ? floorName : parentName2) === null || _this === void 0 ? void 0 : _this.trim();
    return name ? " ".concat(onFloor ? "on" : "in", " ").concat(name) : "";
};
var machineSubLine = function(param) {
    var variation = param.variation, parentName2 = param.parentName, floorName = param.floorName, onFloor = param.onFloor;
    var what = (variation === null || variation === void 0 ? void 0 : variation.trim()) || "machine";
    return "".concat(article(what), " ").concat(what).concat(place({
        parentName: parentName2,
        floorName: floorName,
        onFloor: onFloor
    }));
};
var spaceSubLine = function(param) {
    var kind = param.kind, parentName2 = param.parentName, floorName = param.floorName, onFloor = param.onFloor;
    var what = kind ? kindTitle(kind) : "space";
    return "".concat(article(what), " ").concat(what).concat(place({
        parentName: parentName2,
        floorName: floorName,
        onFloor: onFloor
    }));
};
// src/components/Planner/itemCard/ParentRow.tsx
import styled35 from "styled-components";
import { Button as Button20, Select as Select4 } from "@repo/design-system";
import { Fragment as Fragment23, jsx as jsx44, jsxs as jsxs33 } from "react/jsx-runtime";
var ParentEditor = styled35.div(_templateObject149());
function parentLineRow(param) {
    var id = param.id, editing = param.editing, chosenByHand = param.chosenByHand, shown2 = param.shown, options = param.options, current2 = param.current, helpId = param.helpId, onOpen = param.onOpen, onClose = param.onClose, onChoose = param.onChoose, onUseDrawing = param.onUseDrawing;
    if (!editing) {
        return {
            id: id,
            label: "Parent",
            value: shown2.text,
            muted: shown2.unnamed,
            source: chosenByHand ? BY_HAND : void 0,
            action: {
                icon: "pen",
                "aria-label": CHANGE_PARENT,
                onAction: onOpen
            }
        };
    }
    var onEscape = function(e) {
        if (e.key !== "Escape") return;
        e.preventDefault();
        e.stopPropagation();
        onClose(true);
    };
    var onBlur = function(e) {
        var _e_currentTarget_closest;
        var next = e.relatedTarget;
        if (next && ((_e_currentTarget_closest = e.currentTarget.closest(".tl-override-row")) === null || _e_currentTarget_closest === void 0 ? void 0 : _e_currentTarget_closest.contains(next))) return;
        onClose(false);
    };
    return {
        id: id,
        label: "Parent",
        editing: /* @__PURE__ */ jsx44(ParentEditor, {
            onBlur: onBlur,
            onKeyDown: onEscape,
            children: /* @__PURE__ */ jsx44(Select4, {
                defaultOpen: true,
                size: "sm",
                options: options,
                value: current2 !== null && current2 !== void 0 ? current2 : "",
                ariaLabel: "Parent",
                ariaDescribedBy: chosenByHand ? helpId : void 0,
                onChange: function(value) {
                    onChoose(value);
                    onClose(true);
                }
            })
        }),
        help: chosenByHand ? {
            id: helpId,
            tone: "neutral",
            text: /* @__PURE__ */ jsxs33(Fragment23, {
                children: [
                    "".concat(CHOSEN_BY_HAND_HELP, " "),
                    /* @__PURE__ */ jsx44(Button20, {
                        type: "button",
                        variant: "text",
                        tone: "brand",
                        size: "xs",
                        onMouseDown: function(e) {
                            return e.preventDefault();
                        },
                        onBlur: onBlur,
                        onKeyDown: onEscape,
                        onClick: onUseDrawing,
                        children: USE_THE_DRAWING
                    })
                ]
            })
        } : void 0
    };
}
// src/components/Planner/itemCard/parentNames.ts
import { firstLiveSurfaces as firstLiveSurfaces2, surfaceName as surfaceName3 } from "@repo/front-end-utils";
var floorLabel = function(floorName) {
    return (floorName === null || floorName === void 0 ? void 0 : floorName.trim()) || "This floor";
};
var unnamedLabel = function(kind) {
    return "Unnamed ".concat(kind !== null && kind !== void 0 ? kind : "space");
};
var candidates = function(design) {
    return firstLiveSurfaces2(design === null || design === void 0 ? void 0 : design.surfaces);
};
var parentOwnName = function(design, refid) {
    if (refid === null) return null;
    var surface11 = candidates(design).find(function(s) {
        return s.refid === refid;
    });
    return surface11 && surfaceName3(surface11) || null;
};
var kindOf = function(hierarchy, refid) {
    var answer = hierarchy === null || hierarchy === void 0 ? void 0 : hierarchy.surface(refid);
    var _answer_kind, _ref;
    return answer ? (_ref = (_answer_kind = answer.kind) !== null && _answer_kind !== void 0 ? _answer_kind : answer.placeKind) !== null && _ref !== void 0 ? _ref : null : null;
};
var parentName = function(param) {
    var design = param.design, hierarchy = param.hierarchy, floorName = param.floorName, refid = param.refid;
    if (refid === null) return {
        text: floorLabel(floorName),
        unnamed: false
    };
    var surface11 = candidates(design).find(function(s) {
        return s.refid === refid;
    });
    var name = surface11 ? surfaceName3(surface11) : "";
    return name ? {
        text: name,
        unnamed: false
    } : {
        text: unnamedLabel(kindOf(hierarchy, refid)),
        unnamed: true
    };
};
var nameOnlyParentOptions = function(param) {
    var options = param.options, design = param.design, hierarchy = param.hierarchy, floorName = param.floorName;
    var nameOf2 = /* @__PURE__ */ new Map();
    var counts = /* @__PURE__ */ new Map();
    var nth = /* @__PURE__ */ new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = candidates(design)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var s = _step.value;
            var name = surfaceName3(s) || unnamedLabel(kindOf(hierarchy, s.refid));
            nameOf2.set(s.refid, name);
            var _counts_get;
            var n = ((_counts_get = counts.get(name)) !== null && _counts_get !== void 0 ? _counts_get : 0) + 1;
            counts.set(name, n);
            nth.set(s.refid, n);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return options.map(function(option) {
        if (option.value === "") return {
            value: "",
            label: floorLabel(floorName)
        };
        var name = nameOf2.get(option.value);
        if (name === void 0) return option;
        var _counts_get;
        var label = ((_counts_get = counts.get(name)) !== null && _counts_get !== void 0 ? _counts_get : 0) > 1 ? "".concat(name, " (").concat(nth.get(option.value), ")") : name;
        return {
            value: option.value,
            label: label
        };
    });
};
// src/components/Planner/spaceCard/SpaceCard.tsx
import { Fragment as Fragment24, jsx as jsx45, jsxs as jsxs34 } from "react/jsx-runtime";
var PLAN_PANE = "[data-plan-pane]";
var FIRST_CONTROL = "button:not([disabled])";
var KIND_ROW = "kind";
var PARENT_ROW = "parent";
var INSIDE_ROW = "inside";
var Body5 = styled36.div(_templateObject150(), space22[3]);
var Foot = styled36.div(_templateObject151());
var InsideList = styled36.ul(_templateObject152(), weight7.regular, typeScale6.caption1.fontSize, typeScale6.caption1.lineHeight, fontSans4, ink8[2]);
var SpaceCard = function(param) {
    var twinBid = param.twinBid, twinId = param.twinId, toastRegion = param.toastRegion, live = param.live;
    var _model_capacity;
    var model = useSpaceCardModel(twinBid, twinId);
    var surface11 = model.surface, selectionKey = model.selectionKey, answer = model.answer;
    var checksModel = usePlanChecksContext();
    var _surface11_refid;
    var held = useHeldEntityChecks(model.floorId, "surface", (_surface11_refid = surface11 === null || surface11 === void 0 ? void 0 : surface11.refid) !== null && _surface11_refid !== void 0 ? _surface11_refid : null, selectionKey);
    var registerRead = useEquipmentCatalogStore20(function(s) {
        return registerReadState9(s, {
            twinId: twinId !== null && twinId !== void 0 ? twinId : void 0
        });
    });
    var updateSurface = useFloorplanStore45(function(s) {
        return s.updateSurface;
    });
    var pushSnapshot = useEditorStore37(function(s) {
        return s.pushSnapshot;
    });
    var markEntityModified = useEditorStore37(function(s) {
        return s.markEntityModified;
    });
    var chooseParent = useParentChoice({
        surface: surface11,
        item: null,
        selectionKey: selectionKey,
        floorIndex: model.floorIndex
    });
    var show = useRegionToast(toastRegion);
    var announcer = useCardAnnouncer();
    var ids = useId5();
    var reshapePreview = useReshapePreview(useReshapeStore());
    var registerCapacityOf = useRegisterCapacityOf(twinId);
    var reshaping = reshapePreview && surface11 && reshapePreview.state.refid === surface11.refid && reshapePreview.state.floorIndex === model.floorIndex ? reshapePreview : null;
    var reshapeNote = useMemo24(function() {
        return reshaping ? reshapeNoteSentences(reshaping.impact) : [];
    }, [
        reshaping
    ]);
    var startDesign = reshaping === null || reshaping === void 0 ? void 0 : reshaping.state.startDesign;
    var reshapeFloor = reshaping === null || reshaping === void 0 ? void 0 : reshaping.state.floorIndex;
    var reshapeRefid = reshaping === null || reshaping === void 0 ? void 0 : reshaping.state.refid;
    var capacityBefore = useMemo24(function() {
        return startDesign && reshapeFloor !== void 0 && reshapeRefid ? capacityWithDesign({
            design: startDesign,
            floorIndex: reshapeFloor,
            refid: reshapeRefid,
            twinBid: twinBid,
            twinId: twinId,
            registerCapacityOf: registerCapacityOf
        }) : void 0;
    }, [
        startDesign,
        reshapeFloor,
        reshapeRefid,
        twinBid,
        twinId,
        registerCapacityOf
    ]);
    var reshapeCapacity = useMemo24(function() {
        return reshaping ? {
            before: capacityBefore,
            after: capacityWithDesign({
                design: reshaping.impact.after,
                floorIndex: reshaping.state.floorIndex,
                refid: reshaping.state.refid,
                twinBid: twinBid,
                twinId: twinId,
                registerCapacityOf: registerCapacityOf
            })
        } : void 0;
    }, [
        reshaping,
        capacityBefore,
        twinBid,
        twinId,
        registerCapacityOf
    ]);
    var _useState39 = _sliced_to_array(useState39(null), 2), editingRow = _useState39[0], setEditingRow = _useState39[1];
    var _useState391 = _sliced_to_array(useState39(null), 2), insideOpenFor = _useState391[0], setInsideOpenFor = _useState391[1];
    var _useState392 = _sliced_to_array(useState39(null), 2), changingKind = _useState392[0], setChangingKind = _useState392[1];
    var editing = (editingRow === null || editingRow === void 0 ? void 0 : editingRow.key) === selectionKey ? editingRow.row : null;
    var insideOpen = !!selectionKey && insideOpenFor === selectionKey;
    var kindModal = (changingKind === null || changingKind === void 0 ? void 0 : changingKind.key) === selectionKey ? changingKind : null;
    var setEditing = function(row) {
        return setEditingRow(row && selectionKey ? {
            key: selectionKey,
            row: row
        } : null);
    };
    var cardRef = useRef34(null);
    var bodyRef = useRef34(null);
    var issuesRef = useRef34(null);
    var copyRef = useRef34(null);
    var focusAfter = useRef34(null);
    var kindButton = useMemo24(function() {
        return {
            get current () {
                var _bodyRef_current;
                var _bodyRef_current_querySelector;
                return (_bodyRef_current_querySelector = (_bodyRef_current = bodyRef.current) === null || _bodyRef_current === void 0 ? void 0 : _bodyRef_current.querySelector('button[data-override-row="'.concat(KIND_ROW, '"]'))) !== null && _bodyRef_current_querySelector !== void 0 ? _bodyRef_current_querySelector : null;
            }
        };
    }, []);
    var opener = useRef34(null);
    var returnFocusTo = useMemo24(function() {
        return {
            get current () {
                var _opener_current;
                if ((_opener_current = opener.current) === null || _opener_current === void 0 ? void 0 : _opener_current.isConnected) return opener.current;
                return document.querySelector(PLAN_PANE);
            }
        };
    }, []);
    useEffect35(function() {
        var _cardRef_current, _bodyRef_current_querySelector, _bodyRef_current;
        if (!selectionKey) return;
        var active = document.activeElement;
        if (!active || active === document.body) return;
        if ((_cardRef_current = cardRef.current) === null || _cardRef_current === void 0 ? void 0 : _cardRef_current.contains(active)) return;
        opener.current = _instanceof(active, HTMLElement) ? active : null;
        if (active.closest(PLAN_PANE)) return;
        (_bodyRef_current = bodyRef.current) === null || _bodyRef_current === void 0 ? void 0 : (_bodyRef_current_querySelector = _bodyRef_current.querySelector(FIRST_CONTROL)) === null || _bodyRef_current_querySelector === void 0 ? void 0 : _bodyRef_current_querySelector.focus();
    }, [
        selectionKey
    ]);
    useEffect35(function() {
        var _bodyRef_current, _cardRef_current;
        var after = focusAfter.current;
        if (!after) return;
        focusAfter.current = null;
        var rowAction = after.row ? (_bodyRef_current = bodyRef.current) === null || _bodyRef_current === void 0 ? void 0 : _bodyRef_current.querySelector('button[data-override-row="'.concat(after.row, '"]:not([disabled])')) : null;
        var _after_next, _ref, _ref1, _ref2;
        var target = (_ref2 = (_ref1 = (_ref = rowAction !== null && rowAction !== void 0 ? rowAction : firstFixAfter(issuesRef.current, (_after_next = after.next) !== null && _after_next !== void 0 ? _after_next : [])) !== null && _ref !== void 0 ? _ref : copyRef.current) !== null && _ref1 !== void 0 ? _ref1 : (_cardRef_current = cardRef.current) === null || _cardRef_current === void 0 ? void 0 : _cardRef_current.querySelector("[data-card-done]")) !== null && _ref2 !== void 0 ? _ref2 : null;
        target === null || target === void 0 ? void 0 : target.focus();
    });
    var _model_floorName;
    var parent = surface11 ? parentChoices({
        design: model.design,
        floorName: (_model_floorName = model.floorName) !== null && _model_floorName !== void 0 ? _model_floorName : void 0,
        parentage: model.parentage,
        hierarchy: model.hierarchy,
        surface: surface11,
        item: null,
        // A coded space keeps its kind: only its kind's own parents (`space-card-hierarchy`, R17–R18).
        keepKind: true
    }) : null;
    var placeName = function(refid) {
        return parentName({
            design: model.design,
            hierarchy: model.hierarchy,
            floorName: model.floorName,
            refid: refid
        }).text;
    };
    var _parent_current, _answer_placeKind;
    var lines = surface11 ? itemIssueLines(held.checks, null, {
        parentName: placeName,
        chosenParent: (_parent_current = parent === null || parent === void 0 ? void 0 : parent.current) !== null && _parent_current !== void 0 ? _parent_current : null,
        capacity: model.capacity ? {
            value: model.capacity.value,
            reviewedContents: model.capacity.reviewedContents,
            contents: model.capacity.contents
        } : void 0,
        placeKind: (_answer_placeKind = answer === null || answer === void 0 ? void 0 : answer.placeKind) !== null && _answer_placeKind !== void 0 ? _answer_placeKind : null
    }) : [];
    var issueCount = lines.length;
    var lastCount = useRef34({
        key: null,
        n: null
    });
    var polite = announcer.polite;
    var showHolderFromCard = useCallback18(function(holder) {
        var said = showHolder(holder);
        if (said) polite(said);
    }, [
        polite
    ]);
    useEffect35(function() {
        if (held.held !== "settled" || held.failed) return;
        var last = lastCount.current;
        if (last.key === selectionKey && last.n !== null && last.n !== issueCount) {
            polite(issueCountTag(issueCount));
        }
        lastCount.current = {
            key: selectionKey,
            n: issueCount
        };
    }, [
        held.held,
        held.failed,
        issueCount,
        selectionKey,
        polite
    ]);
    var _surface11_name;
    var storedName = (_surface11_name = surface11 === null || surface11 === void 0 ? void 0 : surface11.name) !== null && _surface11_name !== void 0 ? _surface11_name : "";
    var title = storedName.trim() || "Space";
    var snapshot = function() {
        var layout = useFloorplanStore45.getState().layout;
        if (layout) pushSnapshot(layout);
    };
    var commitName = function(typed) {
        if (!surface11) return "unchanged";
        if (typed === "") return {
            refused: SPACE_NAME_BLANK
        };
        if (isNameTaken5(typed, model.nameIndex, model.nameSelf)) {
            var offer = nextFreeName5(typed, model.nameIndex);
            return {
                refused: takenNameMessage(offer),
                offer: offer
            };
        }
        snapshot();
        updateSurface(surface11.refid, {
            name: typed
        }, {
            floorIndex: model.floorIndex
        });
        markEntityModified(surface11.refid);
        return "landed";
    };
    var nameEditor = useNameEditor({
        selectionKey: selectionKey,
        name: storedName,
        title: title,
        nameIndex: model.nameIndex,
        nameSelf: model.nameSelf,
        onCommit: commitName,
        announce: announcer
    });
    var _surface11_refid1;
    var capacityTarget = {
        entity: "surface",
        floorIndex: model.floorIndex,
        refid: (_surface11_refid1 = surface11 === null || surface11 === void 0 ? void 0 : surface11.refid) !== null && _surface11_refid1 !== void 0 ? _surface11_refid1 : "",
        // On the card's floor without showing it: a held card stays held (`plan-fly-to`, R4.4).
        inPlace: true
    };
    var capacityRow = useSpaceCapacityRow({
        target: capacityTarget,
        capacity: model.capacity,
        selectionKey: selectionKey !== null && selectionKey !== void 0 ? selectionKey : "",
        preview: reshapeCapacity,
        editing: editing === CAPACITY_ROW,
        onEditingChange: function(open) {
            return setEditing(open ? CAPACITY_ROW : null);
        },
        announce: announcer,
        helpId: "".concat(ids, "-capacity-help"),
        container: bodyRef
    });
    var _surface11_refid2;
    var surfaceRefid = (_surface11_refid2 = surface11 === null || surface11 === void 0 ? void 0 : surface11.refid) !== null && _surface11_refid2 !== void 0 ? _surface11_refid2 : null;
    var inside2 = useMemo24(function() {
        return surfaceRefid && model.design ? insideOf(model.design, surfaceRefid) : [];
    }, [
        model.design,
        surfaceRefid
    ]);
    if (!surface11 || !selectionKey || !parent) return null;
    var close = function() {
        return useEditorStore37.getState().clearSelection();
    };
    var _answer_kind;
    var kind = (_answer_kind = answer === null || answer === void 0 ? void 0 : answer.kind) !== null && _answer_kind !== void 0 ? _answer_kind : null;
    var contents = ((_model_capacity = model.capacity) === null || _model_capacity === void 0 ? void 0 : _model_capacity.contents) === void 0 ? "unknown" : model.capacity.contents;
    var chosenByHand = !!surface11.parentChosen;
    var shownParent = parentName({
        design: model.design,
        hierarchy: model.hierarchy,
        floorName: model.floorName,
        refid: parent.current
    });
    var parentHelpId = "".concat(ids, "-parent-help");
    var closeParent = function(refocus) {
        setEditing(null);
        if (refocus) focusAfter.current = {
            row: PARENT_ROW
        };
    };
    var applyDrawnParent = function() {
        restoreDrawnParentFor({
            surface: surface11,
            floorIndex: model.floorIndex
        }, parent.spatialParent);
        announcer.polite(SAVED);
        closeParent(true);
    };
    var parentRow = parentLineRow({
        id: PARENT_ROW,
        editing: editing === PARENT_ROW,
        chosenByHand: chosenByHand,
        shown: shownParent,
        options: nameOnlyParentOptions({
            options: parent.options,
            design: model.design,
            hierarchy: model.hierarchy,
            floorName: model.floorName
        }),
        current: parent.current,
        helpId: parentHelpId,
        onOpen: function() {
            return setEditing(PARENT_ROW);
        },
        onClose: closeParent,
        onChoose: function(value) {
            var _parent_current;
            if (value === ((_parent_current = parent.current) !== null && _parent_current !== void 0 ? _parent_current : "")) return;
            chooseParent({
                value: value,
                current: parent.current,
                snapshot: snapshot
            });
            announcer.polite(SAVED);
        },
        onUseDrawing: applyDrawnParent
    });
    var launched = model.bid === "" ? false : checksModel ? checksModel.launched(surface11) : "unknown";
    var kindBlocked = live.status === "loading" || live.status === "idle" ? CHECKING_LIVE : live.status === "failed" ? LIVE_FAILED : registerRead === "loading" ? READING_REGISTER : registerRead !== "ready" ? REGISTER_FAILED : null;
    var kindHelpId = "".concat(ids, "-kind-help");
    var kindRow = {
        id: KIND_ROW,
        label: "Kind",
        value: kindTitle(kind),
        action: {
            label: CHANGE_KIND,
            icon: "shapes",
            "aria-label": CHANGE_KIND,
            disabled: !!kindBlocked,
            "aria-describedby": kindBlocked ? kindHelpId : void 0,
            onAction: function() {
                return setChangingKind({
                    key: selectionKey
                });
            }
        },
        help: kindBlocked ? {
            id: kindHelpId,
            tone: "neutral",
            text: kindBlocked
        } : void 0
    };
    var confirmKind = function(chosen, code) {
        var _store_layout, _kindButton_current;
        setChangingKind(null);
        snapshot();
        updateSurface(surface11.refid, {
            entityCode: code
        }, {
            floorIndex: model.floorIndex
        });
        var store = useFloorplanStore45.getState();
        store.setEntityCodeChanges(recordCodeChange((_store_layout = store.layout) === null || _store_layout === void 0 ? void 0 : _store_layout.entityCodeChanges, {
            refid: surface11.refid,
            from: surface11.entityCode,
            to: code,
            live: launched,
            twinBid: twinBid
        }));
        markEntityModified(surface11.refid);
        var undo = guardedUndo(show);
        show(_object_spread_props(_object_spread({}, kindChangedToast(title, chosen, code)), {
            icon: /* @__PURE__ */ jsx45(Icon19, {
                name: KIND_ICON[chosen]
            }),
            inlineAction: {
                label: "Undo",
                onAction: undo
            }
        }));
        (_kindButton_current = kindButton.current) === null || _kindButton_current === void 0 ? void 0 : _kindButton_current.focus();
    };
    var phrase = insideCountPhrase(inside2);
    var insideListId = "".concat(ids, "-inside");
    var insideRow = inside2.length === 0 ? {
        id: INSIDE_ROW,
        label: "Inside",
        value: NOTHING_INSIDE
    } : {
        id: INSIDE_ROW,
        label: "Inside",
        value: phrase,
        action: {
            label: insideOpen ? "Hide" : "Show",
            "aria-label": insideToggleLabel(insideOpen, phrase, title),
            "aria-expanded": insideOpen,
            "aria-controls": insideOpen ? insideListId : void 0,
            onAction: function() {
                return setInsideOpenFor(insideOpen ? null : selectionKey);
            }
        },
        // Rendered only while open (the Launch step's `LaunchDetail` shape).
        detail: insideOpen ? /* @__PURE__ */ jsx45(InsideList, {
            id: insideListId,
            children: inside2.map(function(child) {
                return /* @__PURE__ */ jsx45("li", {
                    title: child.name,
                    children: child.name
                }, child.refid);
            })
        }) : void 0
    };
    var onFix = function(fix, line3) {
        switch(fix.kind){
            case "rename":
                nameEditor.open(fix.suggestion);
                return;
            case "keep-parent":
                keepChosenFor({
                    surface: surface11,
                    floorIndex: model.floorIndex
                }, parent.spatialParent);
                announcer.polite(SAVED);
                focusAfter.current = {
                    row: PARENT_ROW,
                    next: issueKeysAfter(issuesRef.current, line3.key)
                };
                return;
            case "use-drawing":
                restoreDrawnParentFor({
                    surface: surface11,
                    floorIndex: model.floorIndex
                }, parent.spatialParent);
                announcer.polite(SAVED);
                focusAfter.current = {
                    row: PARENT_ROW,
                    next: issueKeysAfter(issuesRef.current, line3.key)
                };
                return;
            case "keep-capacity":
            case "use-calculated":
                {
                    var outcome = applyCapacity(capacityTarget, fix.kind === "keep-capacity" ? fix.value : void 0, contents);
                    if (outcome === "changed") announcer.polite(SAVED);
                    focusAfter.current = {
                        row: CAPACITY_ROW,
                        next: issueKeysAfter(issuesRef.current, line3.key)
                    };
                    return;
                }
            case "change-parent":
                setEditing(PARENT_ROW);
                return;
            case "reissue-bid":
                setChangingKind({
                    key: selectionKey,
                    kind: fix.placeKind
                });
                return;
            case "change-kind":
                setChangingKind({
                    key: selectionKey
                });
                return;
            default:
                focusAfter.current = {
                    next: issueKeysAfter(issuesRef.current, line3.key)
                };
        }
    };
    var footer = /* @__PURE__ */ jsxs34(Foot, {
        children: [
            /* @__PURE__ */ jsx45(Button21, {
                variant: "text",
                tone: "destructive",
                iconLeft: /* @__PURE__ */ jsx45(Icon19, {
                    name: "trash-can"
                }),
                onClick: function() {
                    return useEditorStore37.getState().requestItemDelete(surface11.refid, {
                        floorIndex: model.floorIndex
                    });
                },
                children: "Delete ".concat(kindTitle(kind))
            }),
            /* @__PURE__ */ jsx45(Button21, {
                variant: "primary",
                size: "inline",
                "data-card-done": true,
                onClick: close,
                children: "Done"
            })
        ]
    });
    var _nameEditor_sub, _surface11_entityCode;
    return /* @__PURE__ */ jsxs34(Fragment24, {
        children: [
            /* @__PURE__ */ jsx45(DockedCard, {
                ref: cardRef,
                "data-planner-shortcuts": "off",
                "data-testid": "space-card",
                tone: "butter",
                placement: "inset",
                headingLevel: 3,
                icon: /* @__PURE__ */ jsx45(Icon19, {
                    name: kindGlyphName("surface")
                }),
                title: title,
                titleAction: nameEditor.pen,
                titleEditor: nameEditor.editor,
                sub: (_nameEditor_sub = nameEditor.sub) !== null && _nameEditor_sub !== void 0 ? _nameEditor_sub : spaceSubLine({
                    kind: kind,
                    parentName: parentOwnName(model.design, parent.current),
                    floorName: model.floorName,
                    onFloor: parent.current === null
                }),
                onClose: close,
                closeLabel: "Close",
                returnFocusTo: returnFocusTo,
                footer: footer,
                children: /* @__PURE__ */ jsxs34(Body5, {
                    ref: bodyRef,
                    children: [
                        reshapeNote.length > 0 && /* @__PURE__ */ jsx45(Note2, {
                            tone: "butter",
                            icon: /* @__PURE__ */ jsx45(Icon19, {
                                name: "triangle-exclamation",
                                size: "xs"
                            }),
                            "data-testid": "reshape-note",
                            children: reshapeNote.join(" ")
                        }),
                        /* @__PURE__ */ jsx45(BidRow, {
                            bid: model.bid,
                            copyRef: copyRef,
                            announce: announcer.polite,
                            tag: bidRowTag({
                                hasModel: !!checksModel,
                                held: held.held,
                                failed: held.failed,
                                count: issueCount
                            })
                        }),
                        /* @__PURE__ */ jsx45(ItemIssues, {
                            lines: lines,
                            name: title,
                            onFix: onFix,
                            listRef: issuesRef,
                            onShowHolder: showHolderFromCard
                        }),
                        /* @__PURE__ */ jsx45(OverrideRows, {
                            density: "line",
                            rows: [
                                kindRow,
                                parentRow,
                                capacityRow,
                                insideRow
                            ]
                        }),
                        announcer.regions
                    ]
                })
            }),
            kindModal && /* @__PURE__ */ jsx45(ChangeKindModal, {
                name: title,
                refid: surface11.refid,
                code: (_surface11_entityCode = surface11.entityCode) !== null && _surface11_entityCode !== void 0 ? _surface11_entityCode : "",
                answer: answer,
                twinBid: twinBid,
                layout: model.layout,
                design: model.design,
                liveBids: live.bids,
                launched: launched,
                blocked: kindBlocked,
                initialKind: kindModal.kind,
                returnFocusTo: kindButton,
                onCancel: function() {
                    var _kindButton_current;
                    setChangingKind(null);
                    (_kindButton_current = kindButton.current) === null || _kindButton_current === void 0 ? void 0 : _kindButton_current.focus();
                },
                onConfirm: confirmKind
            })
        ]
    });
};
// src/components/Planner/canvas/EquipmentDragCard.tsx
import React12 from "react";
import { createPortal as createPortal2 } from "react-dom";
import styled37 from "styled-components";
import { Icon as Icon20 } from "@repo/design-system";
import { brand as brand2, ink as ink9, inset as inset6, radius as radius9, rgba as rgba3, shadow as shadow5, space as space23, surface as surface4, typeRole as typeRole14, zIndex as zIndex4 } from "@repo/design-tokens";
import { jsx as jsx46, jsxs as jsxs35 } from "react/jsx-runtime";
var Card4 = styled37.div(_templateObject153(), zIndex4.tooltip, space23[2], space23[2], space23[3], space23[2], space23[2], radius9.lg, rgba3(surface4[0], 0.85), surface4[0], inset6[4], rgba3(brand2.frost, 0.9), shadow5.inkGlassRgb);
var Lines = styled37.span(_templateObject154());
var Title = styled37.span(_templateObject155(), typeRole14.body2, ink9[1]);
var Sub = styled37.span(_templateObject156(), typeRole14.caption1, ink9[3]);
var EquipmentDragCard = function(param) {
    var store = param.store;
    var _useEquipmentDragState = useEquipmentDragState(store), drag = _useEquipmentDragState.drag, hint = _useEquipmentDragState.hint;
    useEndEquipmentDragOnDrop(store);
    if (!drag || typeof document === "undefined" || isCarriedDrag(store, drag)) return null;
    return createPortal2(/* @__PURE__ */ jsxs35(FollowingCard, {
        start: drag.start,
        children: [
            /* @__PURE__ */ jsx46(IconDisc_default, {
                tone: "selected",
                size: ICON_DISC_ROW_SIZE,
                children: /* @__PURE__ */ jsx46(Icon20, {
                    name: drag.glyph,
                    size: "sm"
                })
            }),
            /* @__PURE__ */ jsxs35(Lines, {
                children: [
                    /* @__PURE__ */ jsx46(Title, {
                        children: drag.title
                    }),
                    /* @__PURE__ */ jsx46(Sub, {
                        children: dragCardSub(drag.moving, hint)
                    })
                ]
            })
        ]
    }), document.body);
};
var FollowingCard = function(param) {
    var start = param.start, children = param.children;
    var ref = React12.useRef(null);
    React12.useLayoutEffect(function() {
        var node = ref.current;
        if (!node) return;
        node.style.transform = feedDragCardTransform(start.x, start.y);
        var follow = function(e) {
            node.style.visibility = "visible";
            node.style.transform = feedDragCardTransform(e.clientX, e.clientY);
        };
        var isOutside = function(e) {
            return e.clientX <= 0 || e.clientY <= 0 || e.clientX >= window.innerWidth || e.clientY >= window.innerHeight;
        };
        var leave = function(e) {
            if (isOutside(e)) node.style.visibility = "hidden";
        };
        var pointer = function(e) {
            node.style.visibility = isOutside(e) ? "hidden" : "visible";
            node.style.transform = feedDragCardTransform(e.clientX, e.clientY);
        };
        document.addEventListener("dragover", follow, true);
        document.addEventListener("dragleave", leave, true);
        document.addEventListener("pointermove", pointer, true);
        return function() {
            document.removeEventListener("dragover", follow, true);
            document.removeEventListener("dragleave", leave, true);
            document.removeEventListener("pointermove", pointer, true);
        };
    }, []);
    return /* @__PURE__ */ jsx46(Card4, {
        ref: ref,
        "aria-hidden": "true",
        "data-testid": "equipment-drag-card",
        children: children
    });
};
// src/components/Planner/canvas/EquipmentPointerDrag.tsx
import { useEffect as useEffect36, useRef as useRef35 } from "react";
import { createGlobalStyle } from "styled-components";
import { Fragment as Fragment25, jsx as jsx47, jsxs as jsxs36 } from "react/jsx-runtime";
var PointerDragCursor = createGlobalStyle(_templateObject157(), POINTER_DRAG_COPY_CLASS, POINTER_DRAG_COPY_CLASS, POINTER_DRAG_NO_DROP_CLASS, POINTER_DRAG_NO_DROP_CLASS, POINTER_DRAG_CARRYING_CLASS, POINTER_DRAG_CARRYING_CLASS);
var EquipmentPointerDrag = function(param) {
    var store = param.store;
    var node = useRef35(null);
    useEffect36(function() {
        if (!node.current) return void 0;
        return attachEquipmentPointerDrag(store, node.current);
    }, [
        store
    ]);
    return /* @__PURE__ */ jsxs36(Fragment25, {
        children: [
            /* @__PURE__ */ jsx47(PointerDragCursor, {}),
            /* @__PURE__ */ jsx47("div", {
                ref: node,
                "aria-hidden": "true",
                "data-equipment-pointer-capture": "",
                style: {
                    position: "fixed",
                    top: 0,
                    left: -10,
                    width: 1,
                    height: 1
                }
            })
        ]
    });
};
// src/components/Planner/canvas/SpaceDrawnToaster.tsx
import { useEffect as useEffect37 } from "react";
import { Icon as Icon21 } from "@repo/design-system";
import { useFloorplanStore as useFloorplanStore46 } from "@repo/front-end-state";
import { resolvePlanHierarchy as resolvePlanHierarchy7 } from "@repo/front-end-utils";
import { jsx as jsx48 } from "react/jsx-runtime";
var SpaceDrawnToaster = function(param) {
    var into = param.into, region = param.region, twinBid = param.twinBid, twinId = param.twinId;
    var show = useRegionToast(region);
    var registerCapacityOf = useRegisterCapacityOf(twinId);
    useEffect37(function() {
        into.current = function(report) {
            var undo = guardedUndo(show);
            var design = useFloorplanStore46.getState().getActiveDesign();
            var answer = resolvePlanHierarchy7(design).surface(report.refid);
            var resolved = report.floorId !== null ? planCapacityNow(twinBid, twinId, registerCapacityOf).surface(report.refid, report.floorId) : void 0;
            var capacity = resolved ? capacityPhrase(resolved.value, resolved.missing) : capacityPhrase("unknown", 0);
            var _answer_kind;
            show({
                tone: "success",
                icon: /* @__PURE__ */ jsx48(Icon21, {
                    name: "sitemap"
                }),
                title: spaceDrawnTitle((_answer_kind = answer === null || answer === void 0 ? void 0 : answer.kind) !== null && _answer_kind !== void 0 ? _answer_kind : null),
                sub: spaceDrawnSub({
                    machines: report.filed.machines.length,
                    spaces: report.filed.spaces
                }, capacity),
                inlineAction: {
                    label: "Undo",
                    onAction: undo
                }
            });
        };
        return function() {
            into.current = null;
        };
    }, [
        into,
        show,
        twinBid,
        twinId,
        registerCapacityOf
    ]);
    return null;
};
// src/components/Planner/machineCard/itemEditingContext.ts
import { createContext as createContext12, useContext as useContext16 } from "react";
var PlannerItemEditingContext = createContext12("panel");
var PlannerItemEditingProvider = PlannerItemEditingContext.Provider;
var usePlannerItemEditing = function() {
    return useContext16(PlannerItemEditingContext);
};
// src/components/Planner/TwinPlanner.tsx
import { Fragment as Fragment26, jsx as jsx49, jsxs as jsxs37 } from "react/jsx-runtime";
var NO_TOKEN = function() {
    return Promise.reject(new Error("useLiveEntityIdentities: no token getter for this planner host"));
};
var PlannerContainer = styled38.div(_templateObject159(), function(param) {
    var $fullscreen = param.$fullscreen, t = param.theme;
    return $fullscreen && css4(_templateObject158(), t.colors.neutral[50]);
});
var Toolbar = styled38.div(_templateObject160());
var ToolbarButton = styled38.button(_templateObject161(), function(param) {
    var t = param.theme;
    return t.colors.neutral[300];
}, function(param) {
    var t = param.theme;
    return t.colors.white;
}, function(param) {
    var t = param.theme;
    return t.colors.neutral[800];
}, function(param) {
    var t = param.theme;
    return t.colors.neutral[100];
});
var PlanNameInput = styled38.input(_templateObject162(), function(param) {
    var t = param.theme;
    return t.colors.neutral[300];
}, function(param) {
    var t = param.theme;
    return t.colors.white;
}, function(param) {
    var t = param.theme;
    return t.colors.neutral[800];
}, function(param) {
    var t = param.theme;
    return t.colors.brand.DEFAULT;
});
var CanvasArea = styled38.div(_templateObject163());
var SidePanelSlot = styled38.div(_templateObject164(), function(param) {
    var theme2 = param.theme;
    return theme2.zIndex.sticky;
});
var SidePanelTabsHost = styled38.div(_templateObject165());
var CanvasStage = styled38.div(_templateObject166());
var LegendSlot = styled38.div(_templateObject167(), space24[3], space24[3]);
var FloorSelectorSlot = styled38.div(_templateObject168(), space24[3], function(param) {
    var theme2 = param.theme;
    return theme2.zIndex.sticky;
});
var CanvasOverlaySlot = styled38.div(_templateObject169(), function(param) {
    var theme2 = param.theme, $railClear = param.$railClear;
    return $railClear ? RAIL_CLEARANCE(theme2) : "0";
}, function(param) {
    var theme2 = param.theme;
    return theme2.zIndex.sticky;
});
function PlanChecksReporter(param) {
    var onPlanChecks = param.onPlanChecks;
    var checks = usePlanChecksContext();
    var report = useRef36(onPlanChecks);
    report.current = onPlanChecks;
    useEffect38(function() {
        report.current(checks);
    }, [
        checks
    ]);
    return null;
}
var ModeBar = styled38.div(_templateObject170(), space24[3]);
function ManageFloorsInListPanel(param) {
    var query = param.query;
    var requestAddFloor = useFloorActions().requestAddFloor;
    var listPanelHeader = useMemo25(function() {
        return {
            onAddFloor: function() {
                return void requestAddFloor();
            }
        };
    }, [
        requestAddFloor
    ]);
    return /* @__PURE__ */ jsx49(AlignFloorsPanel, {
        listPanelHeader: listPanelHeader,
        query: query
    });
}
function CheckedFloorTabs(props) {
    var checks = usePlanChecksContext();
    var problemCounts = useMemo25(function() {
        return floorErrorCounts(checks);
    }, [
        checks
    ]);
    return /* @__PURE__ */ jsx49(FloorTabs, _object_spread_props(_object_spread({}, props), {
        problemCounts: problemCounts
    }));
}
var FullscreenButton = styled38.button(_templateObject171(), glassSurface, function(param) {
    var t = param.theme;
    return t.spacing[2];
}, function(param) {
    var t = param.theme;
    return t.spacing[4];
}, function(param) {
    var t = param.theme;
    return t.borderRadius.DEFAULT;
}, function(param) {
    var t = param.theme;
    return t.colors.neutral[700];
}, function(param) {
    var t = param.theme;
    return t.colors.neutral[300];
}, function(param) {
    var t = param.theme;
    return t.zIndex.sticky;
}, function(param) {
    var t = param.theme;
    return t.transitions.fast;
}, glassSurfaceHover, function(param) {
    var t = param.theme;
    return t.colors.brand.DEFAULT;
});
var FieldError = styled38.span(_templateObject172(), function(param) {
    var t = param.theme;
    return t.colors.error.DEFAULT;
});
var UnlinkRow = styled38.div(_templateObject173());
var machineCapacityValue = function(resolved) {
    return typeof (resolved === null || resolved === void 0 ? void 0 : resolved.value) === "number" ? resolved.value : "";
};
var machineCapacityNote = function(resolved, registerRead) {
    if ((resolved === null || resolved === void 0 ? void 0 : resolved.value) === "unknown") {
        if (registerRead === "error") return "The register could not be read";
        if (registerRead === "no-twin") return "No twin chosen, so the register is not read";
        return "Checking\u2026";
    }
    if ((resolved === null || resolved === void 0 ? void 0 : resolved.value) === void 0) return "Not set";
    return resolved.source === "plan-copy" ? "Not in the register \u2014 the plan\u2019s own number" : "From the register";
};
function CapacitySourceSort(props) {
    var unsorted = useFloorplanStore47(function(s) {
        return !!s.layout && s.layout.capacitySources !== 1;
    });
    return unsorted ? /* @__PURE__ */ jsx49(CapacitySourceSortRunner, _object_spread({}, props)) : null;
}
function CapacitySourceSortRunner(param) {
    var twinBid = param.twinBid, twinId = param.twinId, layoutScope = param.layoutScope;
    useCapacitySort(twinBid, twinId, layoutScope);
    return null;
}
function PropertiesPanel(param) {
    var boundsRef = param.boundsRef, twinBid = param.twinBid, twinId = param.twinId, _param_itemEditing = param.itemEditing, itemEditing = _param_itemEditing === void 0 ? "panel" : _param_itemEditing, _param_spaceCardDocked = param.spaceCardDocked, spaceCardDocked = _param_spaceCardDocked === void 0 ? false : _param_spaceCardDocked;
    var layout = useFloorplanStore47(function(s) {
        return s.layout;
    });
    var activeFloorIndex = useFloorplanStore47(function(s) {
        return s.activeFloorIndex;
    });
    var updateSurface = useFloorplanStore47(function(s) {
        return s.updateSurface;
    });
    var updateItem = useFloorplanStore47(function(s) {
        return s.updateItem;
    });
    var selectedIds = useEditorStore38(selectionOnFloorShown8);
    var markEntityModified = useEditorStore38(function(s) {
        return s.markEntityModified;
    });
    var pushSnapshot = useEditorStore38(function(s) {
        return s.pushSnapshot;
    });
    var registerRows = useEquipmentCatalogStore21(function(s) {
        return s.registerRows;
    });
    var registerContext = useEquipmentCatalogStore21(function(s) {
        return s.registerContext;
    });
    var registerRead = useEquipmentCatalogStore21(function(s) {
        var _s_registerContext;
        return registerReadState10(s, {
            twinId: (_s_registerContext = s.registerContext) === null || _s_registerContext === void 0 ? void 0 : _s_registerContext.twinId
        });
    });
    var hostRegisterRead = useEquipmentCatalogStore21(function(s) {
        return registerReadState10(s, {
            twinId: twinId !== null && twinId !== void 0 ? twinId : void 0
        });
    });
    var _useState40 = _sliced_to_array(useState40(false), 2), isHeaderHovered = _useState40[0], setIsHeaderHovered = _useState40[1];
    var panelId = useId6();
    var nameErrorId = "".concat(panelId, "-name-error");
    var fieldNoteId = "".concat(panelId, "-name-note");
    var nameTakenId = "".concat(panelId, "-name-taken");
    var modelLabelId = "".concat(panelId, "-model-label");
    var modelErrorId = "".concat(panelId, "-model-error");
    var modelSourceId = "".concat(panelId, "-model-source");
    var codeErrorId = "".concat(panelId, "-code-error");
    var letterErrorId = "".concat(panelId, "-letter-error");
    var parentLabelId = "".concat(panelId, "-parent-label");
    var parentNoteId = "".concat(panelId, "-parent-note");
    var selectedId = selectedIds.length === 1 ? selectedIds[0] : null;
    var repairedLayout = useMemo25(function() {
        return joinRegisterOntoPlan4(layout, registerRows, twinBid, {
            repairStaleLinks: registerRead === "ready"
        });
    }, [
        layout,
        registerRows,
        twinBid,
        registerRead
    ]);
    var registerCapacityOf = useRegisterCapacityOf(twinId);
    var capacityNoteId = useId6();
    var floor = repairedLayout === null || repairedLayout === void 0 ? void 0 : repairedLayout.floors[activeFloorIndex];
    var design = floor ? findLatestDesign17(floor.designs) : null;
    var _design_surfaces_find;
    var surface11 = selectedId ? (_design_surfaces_find = design === null || design === void 0 ? void 0 : design.surfaces.find(function(s) {
        return s.refid === selectedId;
    })) !== null && _design_surfaces_find !== void 0 ? _design_surfaces_find : null : null;
    var _design_items_find;
    var item = selectedId && !surface11 ? (_design_items_find = design === null || design === void 0 ? void 0 : design.items.find(function(i) {
        return i.refid === selectedId;
    })) !== null && _design_items_find !== void 0 ? _design_items_find : null : null;
    var entity = surface11 !== null && surface11 !== void 0 ? surface11 : item;
    var itemRegister = useMemo25(function() {
        return resolveItemRegisterState(item, registerRows, registerRead);
    }, [
        item,
        registerRows,
        registerRead
    ]);
    var registerBackedRow = itemRegister.kind === "backed" ? itemRegister.row : null;
    var nameSignature = useMemo25(function() {
        return twinNameSignature2(repairedLayout);
    }, [
        repairedLayout
    ]);
    var layoutForNames = useRef36(repairedLayout);
    layoutForNames.current = repairedLayout;
    var nameIndex = useMemo25(function() {
        return buildTwinNameIndex5(layoutForNames.current, registerRows);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- geometry-only layout writes must not rebuild the register half
    [
        nameSignature,
        registerRows
    ]);
    var nameSelf = surface11 ? twinNameEntryFor2(surface11, "space") : item ? twinNameEntryFor2(item, "machine") : void 0;
    var registerLink = useRegisterLink({
        item: item,
        itemRegister: itemRegister,
        registerRead: registerRead,
        registerRows: registerRows,
        layout: repairedLayout,
        twinBid: twinBid,
        selectionKey: selectedId
    });
    var canOfferRegisterLink = registerLink.canOffer;
    var _useState401 = _sliced_to_array(useState40(null), 2), letterError = _useState401[0], setLetterError = _useState401[1];
    var codeOnFocus = useRef36("");
    var editSuspendedFor = useRef36(null);
    var registerWrite = useItemRegisterWrite({
        item: item,
        row: registerBackedRow,
        selectionKey: selectedId
    });
    var nameCommit = useItemNameCommit({
        entity: entity,
        itemRegister: itemRegister,
        nameIndex: nameIndex,
        nameSelf: nameSelf,
        selectionKey: selectedId,
        registerWrite: registerWrite
    });
    var chooseParent = useParentChoice({
        surface: surface11,
        item: item,
        selectionKey: selectedId
    });
    var backedOffer = nameCommit.backedOffer, unbackedOffer = nameCommit.unbackedOffer, nameWriteError = nameCommit.nameWriteError;
    var _useState402 = _sliced_to_array(useState40(null), 2), returnedToCatalogueFor = _useState402[0], setReturnedToCatalogueFor = _useState402[1];
    var nameInputRef = useRef36(null);
    var focusNameAfterLink = useRef36(false);
    var focusNameAfterOffer = useRef36(null);
    var refocusingName = useRef36(false);
    var _useState403 = _sliced_to_array(useState40(null), 2), draftFor = _useState403[0], setDraftFor = _useState403[1];
    if (draftFor !== selectedId) {
        setDraftFor(selectedId);
        if (returnedToCatalogueFor !== null) setReturnedToCatalogueFor(null);
    }
    var writeError = registerWrite.failure;
    var retainedPlanModel = itemRegister.kind === "backed" && !(registerBackedRow === null || registerBackedRow === void 0 ? void 0 : registerBackedRow.model_3d) && (item === null || item === void 0 ? void 0 : item.modelFile) ? item.modelFile : null;
    var sourceNote = itemRegister.kind === "backed" && retainedPlanModel === null ? modelSourceNote(registerBackedRow === null || registerBackedRow === void 0 ? void 0 : registerBackedRow.model_3d_source, namesCatalogueProduct(registerBackedRow === null || registerBackedRow === void 0 ? void 0 : registerBackedRow.reference_id)) : null;
    var modelWriteError = (writeError === null || writeError === void 0 ? void 0 : writeError.field) === "model" ? writeError.message : null;
    var isWriting = registerWrite.isWriting;
    var _useState404 = _sliced_to_array(useState40(null), 2), modelFiles = _useState404[0], setModelFiles = _useState404[1];
    var _useState405 = _sliced_to_array(useState40(null), 2), modelFilesError = _useState405[0], setModelFilesError = _useState405[1];
    var _useState406 = _sliced_to_array(useState40(0), 2), modelAttempt = _useState406[0], setModelAttempt = _useState406[1];
    var startedForAttempt = useRef36(null);
    var registerContextRef = useRef36(registerContext);
    useEffect38(function() {
        registerContextRef.current = registerContext;
    }, [
        registerContext
    ]);
    var canReadModelStore = registerContext !== null;
    var needsModelListing = !!item && canReadModelStore;
    useEffect38(function() {
        if (!needsModelListing) return;
        if (startedForAttempt.current === modelAttempt) return;
        var context = registerContextRef.current;
        if (!context) return;
        startedForAttempt.current = modelAttempt;
        var unmounted = false;
        var settled = false;
        void _async_to_generator(function() {
            var files, _tmp, readError;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        _tmp = [
                            context.baseUrl
                        ];
                        return [
                            4,
                            context.getAccessToken()
                        ];
                    case 1:
                        return [
                            4,
                            getModelFiles.apply(void 0, _tmp.concat([
                                _state.sent()
                            ]))
                        ];
                    case 2:
                        files = _state.sent();
                        settled = true;
                        if (unmounted) return [
                            2
                        ];
                        setModelFiles(files);
                        setModelFilesError(null);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        readError = _state.sent();
                        settled = true;
                        if (unmounted) return [
                            2
                        ];
                        setModelFilesError(_instanceof(readError, Error) && readError.message ? readError.message : "The model store could not be read.");
                        setModelFiles(null);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
        return function() {
            unmounted = true;
            if (!settled) startedForAttempt.current = null;
        };
    }, [
        needsModelListing,
        modelAttempt
    ]);
    var modelOptions = useModelPickerOptions(modelFiles, "planner");
    useLayoutEffect2(function() {
        var _nameInputRef_current;
        if (!focusNameAfterLink.current) return;
        focusNameAfterLink.current = false;
        (_nameInputRef_current = nameInputRef.current) === null || _nameInputRef_current === void 0 ? void 0 : _nameInputRef_current.focus();
    });
    useEffect38(function() {
        var _nameInputRef_current;
        var pending = focusNameAfterOffer.current;
        if (pending === null) return;
        if (pending !== selectedId) {
            focusNameAfterOffer.current = null;
            return;
        }
        if (isWriting) return;
        focusNameAfterOffer.current = null;
        var active = document.activeElement;
        if (active && active !== document.body) return;
        refocusingName.current = true;
        (_nameInputRef_current = nameInputRef.current) === null || _nameInputRef_current === void 0 ? void 0 : _nameInputRef_current.focus();
        refocusingName.current = false;
    });
    if (!entity) return null;
    var snapshot = function() {
        if (layout) pushSnapshot(layout);
    };
    var registerLinkControl = canOfferRegisterLink && item ? /* @__PURE__ */ jsx49(RegisterLinkPicker, {
        candidates: registerLink.candidates,
        registerIsEmpty: registerRows.length === 0,
        itemName: item === null || item === void 0 ? void 0 : item.name,
        onChoose: function(chosen) {
            if (registerLink.link(chosen)) focusNameAfterLink.current = true;
        }
    }, item.refid) : item && itemRegister.kind === "legacy" && registerRead !== "ready" ? /* @__PURE__ */ jsx49(FieldNote, {
        children: REGISTER_LINK_UNAVAILABLE_REASON[registerRead]
    }) : null;
    if (itemEditing === "host" && (item || surface11 && spaceCardDocked)) return null;
    var duplicateCode = findDuplicateEntityCodes2(layout, twinBid).byRefid.get(entity.refid);
    var bidPrefix = entityIdentityKey5(twinBid) ? "".concat(entityIdentityKey5(twinBid), "-") : "";
    var parentage = design ? resolvePlanParentage8(design) : null;
    var hierarchy = design ? resolvePlanHierarchy8(design) : null;
    var surfaceAnswer = surface11 ? hierarchy === null || hierarchy === void 0 ? void 0 : hierarchy.surface(surface11.refid) : void 0;
    var _surfaceAnswer_kind, _ref;
    var titleKind = surfaceAnswer ? (_ref = (_surfaceAnswer_kind = surfaceAnswer.kind) !== null && _surfaceAnswer_kind !== void 0 ? _surfaceAnswer_kind : (entity === null || entity === void 0 ? void 0 : entity.entityCode) ? null : surfaceAnswer.placeKind) !== null && _ref !== void 0 ? _ref : "space" : "space";
    var _surfaceAnswer_placeKind;
    var placeLabel = surface11 ? (_surfaceAnswer_placeKind = surfaceAnswer === null || surfaceAnswer === void 0 ? void 0 : surfaceAnswer.placeKind) !== null && _surfaceAnswer_placeKind !== void 0 ? _surfaceAnswer_placeKind : "space" : "machine";
    var allowedLetter = allowedLetterFor(hierarchy, surface11 ? {
        surfaceRefid: surface11.refid
    } : {
        item: true
    });
    var _entity_entityCode;
    var letterErrorText = letterError && letterError.refid === entity.refid && letterError.code === ((_entity_entityCode = entity.entityCode) !== null && _entity_entityCode !== void 0 ? _entity_entityCode : "") && letterError.letter === allowedLetter && letterError.label === placeLabel ? letterError.text : null;
    var parent = parentChoices({
        design: design,
        floorName: floor === null || floor === void 0 ? void 0 : floor.name,
        parentage: parentage,
        hierarchy: hierarchy,
        surface: surface11,
        item: item
    });
    var commit = function(updates) {
        if (surface11) {
            var _planCapacityNow_surface;
            updateSurface(surface11.refid, "capacity" in updates ? _object_spread({}, updates, withCapacityReview3(updates.capacity, (_planCapacityNow_surface = planCapacityNow(twinBid, twinId, registerCapacityOf).surface(surface11.refid, floor === null || floor === void 0 ? void 0 : floor.id)) === null || _planCapacityNow_surface === void 0 ? void 0 : _planCapacityNow_surface.contents)) : updates);
        } else if (item) updateItem(item.refid, updates);
        if (selectedId) markEntityModified(selectedId);
    };
    var _registerBackedRow_model_3d, _item_modelFile;
    var committedModel = (itemRegister.kind === "backed" ? (_registerBackedRow_model_3d = registerBackedRow === null || registerBackedRow === void 0 ? void 0 : registerBackedRow.model_3d) !== null && _registerBackedRow_model_3d !== void 0 ? _registerBackedRow_model_3d : "" : (_item_modelFile = item === null || item === void 0 ? void 0 : item.modelFile) !== null && _item_modelFile !== void 0 ? _item_modelFile : "").trim();
    var modelNoteState = modelPickerNoteState(modelFiles, committedModel);
    var notInListNote = modelNoteState === "retiring" ? /* @__PURE__ */ jsx49(Fragment26, {
        children: MODEL_RETIRING_NOTE
    }) : modelNoteState === "absent" ? /* @__PURE__ */ jsxs37(Fragment26, {
        children: [
            "Not in the model store \u2014 ",
            /* @__PURE__ */ jsx49("code", {
                children: committedModel
            }),
            " is not one of the files it lists, so this item renders without a model."
        ]
    }) : void 0;
    var _nameCommit_draft, _entity_name, _entity_entityCode1, _parent_current, _entity_capacity, _item_rotation, _item_modelFile1;
    return /* @__PURE__ */ jsx49(PropertiesPanelDraggable, {
        boundsRef: boundsRef,
        isHeaderHovered: isHeaderHovered,
        headerElement: /* @__PURE__ */ jsx49(PropertiesDragHeader, {
            onMouseEnter: function() {
                return setIsHeaderHovered(true);
            },
            onMouseLeave: function() {
                return setIsHeaderHovered(false);
            },
            children: /* @__PURE__ */ jsx49(PanelTitle, {
                children: surface11 ? titleKind.charAt(0).toUpperCase() + titleKind.slice(1) : "Equipment"
            })
        }),
        children: /* @__PURE__ */ jsxs37(PropertiesBody, {
            children: [
                /* @__PURE__ */ jsxs37(FieldBlock, {
                    children: [
                        /* @__PURE__ */ jsxs37(Field, {
                            children: [
                                "Name",
                                itemRegister.kind === "backed" ? /*
               * A register-backed item's name IS its register row's `asset_name`
               * (`plan-item-register-sync`, architecture decision 4). So this field is a draft that
               * commits on blur or Enter, not a keystroke-by-keystroke write into the plan: the plan
               * is written only from the server's response, which is what keeps "plan name =
               * asset_name" true even across a save the server rejects.
               */ /* @__PURE__ */ jsx49(FieldInput, {
                                    ref: nameInputRef,
                                    type: "text",
                                    value: (_nameCommit_draft = nameCommit.draft) !== null && _nameCommit_draft !== void 0 ? _nameCommit_draft : nameCommit.storedName,
                                    placeholder: "e.g. Leg Press",
                                    disabled: isWriting,
                                    $invalid: !!nameWriteError,
                                    "aria-invalid": !!nameWriteError || void 0,
                                    "aria-describedby": nameWriteError ? nameErrorId : void 0,
                                    onChange: function(e) {
                                        nameCommit.setDraft(e.target.value);
                                        if (nameWriteError) registerWrite.clearFailure();
                                    },
                                    onBlur: function() {
                                        return void nameCommit.commit();
                                    },
                                    onKeyDown: function(e) {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                            void nameCommit.commit();
                                        }
                                    }
                                }) : /* @__PURE__ */ jsx49(FieldInput, {
                                    ref: nameInputRef,
                                    type: "text",
                                    value: (_entity_name = entity.name) !== null && _entity_name !== void 0 ? _entity_name : "",
                                    placeholder: "e.g. Free weights",
                                    readOnly: itemRegister.kind === "unknown",
                                    "aria-disabled": itemRegister.kind === "unknown" || void 0,
                                    "data-muted": itemRegister.kind === "unknown" || void 0,
                                    "aria-describedby": unbackedOffer ? "".concat(fieldNoteId, " ").concat(nameTakenId) : fieldNoteId,
                                    onFocus: function() {
                                        if (!refocusingName.current) snapshot();
                                    },
                                    onChange: function(e) {
                                        if (itemRegister.kind === "unknown") return;
                                        commit({
                                            name: e.target.value
                                        });
                                    }
                                })
                            ]
                        }),
                        itemRegister.kind === "unknown" && /* @__PURE__ */ jsx49(FieldNote, {
                            id: fieldNoteId,
                            role: "status",
                            children: UNKNOWN_REGISTER_REASON[itemRegister.reason]
                        }),
                        /* @__PURE__ */ jsx49(FieldNote, {
                            id: nameTakenId,
                            role: "status",
                            style: unbackedOffer ? void 0 : visuallyHidden,
                            children: unbackedOffer ? takenNameMessage(unbackedOffer) : ""
                        }),
                        unbackedOffer && /* @__PURE__ */ jsx49(UnlinkRow, {
                            children: /* @__PURE__ */ jsx49(Button22, {
                                variant: "ghost",
                                size: "xs",
                                onClick: function() {
                                    snapshot();
                                    commit({
                                        name: unbackedOffer
                                    });
                                    focusNameAfterOffer.current = selectedId;
                                },
                                children: freeNameButtonLabel(unbackedOffer)
                            })
                        }),
                        itemRegister.kind === "orphan" && /* @__PURE__ */ jsxs37(Fragment26, {
                            children: [
                                /* @__PURE__ */ jsx49(FieldNote, {
                                    id: fieldNoteId,
                                    children: itemRegister.hasIdentity ? ORPHAN_REGISTER_NOTE : ORPHAN_NO_IDENTITY_NOTE
                                }),
                                /* @__PURE__ */ jsx49(UnlinkRow, {
                                    children: /* @__PURE__ */ jsx49(Button22, {
                                        variant: "ghost",
                                        size: "xs",
                                        "aria-label": unlinkAccessibleName(item === null || item === void 0 ? void 0 : item.name),
                                        onClick: registerLink.unlink,
                                        children: UNLINK_BUTTON_LABEL
                                    })
                                })
                            ]
                        }),
                        registerLinkControl,
                        itemRegister.kind !== "unknown" && /* @__PURE__ */ jsx49(FieldNote, {
                            role: "status",
                            "aria-live": "polite",
                            children: registerLink.announcement
                        }),
                        nameWriteError && /* @__PURE__ */ jsx49(FieldError, {
                            id: nameErrorId,
                            role: "alert",
                            children: backedOffer ? takenNameMessage(backedOffer) : nameWriteError
                        }),
                        backedOffer && /* @__PURE__ */ jsx49(UnlinkRow, {
                            children: /* @__PURE__ */ jsx49(Button22, {
                                variant: "ghost",
                                size: "xs",
                                onClick: function() {
                                    nameCommit.setDraft(backedOffer);
                                    focusNameAfterOffer.current = selectedId;
                                    void nameCommit.commit(backedOffer);
                                },
                                children: freeNameButtonLabel(backedOffer)
                            })
                        })
                    ]
                }),
                /* @__PURE__ */ jsxs37(FieldBlock, {
                    children: [
                        /* @__PURE__ */ jsxs37(Field, {
                            children: [
                                "BID",
                                /* @__PURE__ */ jsx49(FieldInput, {
                                    type: "text",
                                    value: (_entity_entityCode1 = entity.entityCode) !== null && _entity_entityCode1 !== void 0 ? _entity_entityCode1 : "",
                                    placeholder: "e.g. ".concat(bidPrefix).concat(allowedLetter, "001"),
                                    $invalid: !!duplicateCode || !!letterErrorText,
                                    "aria-invalid": !!duplicateCode || !!letterErrorText || void 0,
                                    "aria-describedby": [
                                        duplicateCode ? codeErrorId : "",
                                        letterErrorText ? letterErrorId : ""
                                    ].filter(Boolean).join(" ") || void 0,
                                    onFocus: function() {
                                        var resuming = editSuspendedFor.current === entity.refid;
                                        editSuspendedFor.current = null;
                                        if (resuming) return;
                                        var _entity_entityCode;
                                        codeOnFocus.current = (_entity_entityCode = entity.entityCode) !== null && _entity_entityCode !== void 0 ? _entity_entityCode : "";
                                        snapshot();
                                    },
                                    onChange: function(e) {
                                        var typed = e.target.value.toUpperCase();
                                        var text2 = isCompleteWrongLetter(typed, allowedLetter) ? checkTypedEntityCode(typed, allowedLetter, placeLabel, twinBid) : null;
                                        setLetterError(text2 ? {
                                            refid: entity.refid,
                                            code: typed,
                                            letter: allowedLetter,
                                            label: placeLabel,
                                            text: text2
                                        } : null);
                                        commit({
                                            entityCode: typed
                                        });
                                    },
                                    onBlur: function(e) {
                                        if (e.relatedTarget === null && typeof document !== "undefined" && !document.hasFocus()) {
                                            editSuspendedFor.current = entity.refid;
                                            return;
                                        }
                                        var raw = e.target.value.trim().toUpperCase();
                                        var next = entityIdentityFor5(twinBid, e.target.value);
                                        var untouched = next === entityIdentityFor5(twinBid, codeOnFocus.current) || raw === codeOnFocus.current.trim().toUpperCase();
                                        var refused = !untouched && checkTypedEntityCode(next, allowedLetter, placeLabel, twinBid);
                                        if (refused) {
                                            var _checkTypedEntityCode;
                                            var text2 = (_checkTypedEntityCode = checkTypedEntityCode(raw, allowedLetter, placeLabel, twinBid)) !== null && _checkTypedEntityCode !== void 0 ? _checkTypedEntityCode : refused;
                                            setLetterError({
                                                refid: entity.refid,
                                                code: codeOnFocus.current,
                                                letter: allowedLetter,
                                                label: placeLabel,
                                                text: text2
                                            });
                                            var _entity_entityCode;
                                            if (codeOnFocus.current !== ((_entity_entityCode = entity.entityCode) !== null && _entity_entityCode !== void 0 ? _entity_entityCode : "")) {
                                                commit({
                                                    entityCode: codeOnFocus.current
                                                });
                                            }
                                            return;
                                        }
                                        setLetterError(null);
                                        var _entity_entityCode1;
                                        if (next !== ((_entity_entityCode1 = entity.entityCode) !== null && _entity_entityCode1 !== void 0 ? _entity_entityCode1 : "")) commit({
                                            entityCode: next
                                        });
                                    }
                                })
                            ]
                        }),
                        letterErrorText && /* @__PURE__ */ jsx49(FieldError, {
                            id: letterErrorId,
                            role: "alert",
                            children: letterErrorText
                        }),
                        duplicateCode && /* @__PURE__ */ jsxs37(FieldError, {
                            id: codeErrorId,
                            role: "alert",
                            children: [
                                /* @__PURE__ */ jsx49("strong", {
                                    children: duplicateCode
                                }),
                                " is already used by another zone or item. A BID must be unique across the whole plan \u2014 two entities sharing one would merge into a single entity when the twin goes live."
                            ]
                        })
                    ]
                }),
                /* @__PURE__ */ jsxs37(FieldBlock, {
                    children: [
                        /* @__PURE__ */ jsxs37(Field, {
                            as: "div",
                            children: [
                                /* @__PURE__ */ jsx49("span", {
                                    id: parentLabelId,
                                    children: "Parent"
                                }),
                                /* @__PURE__ */ jsx49(Select5, {
                                    options: parent.options,
                                    value: (_parent_current = parent.current) !== null && _parent_current !== void 0 ? _parent_current : "",
                                    onChange: function(value) {
                                        return chooseParent({
                                            value: value,
                                            current: parent.current,
                                            snapshot: snapshot
                                        });
                                    },
                                    ariaLabelledBy: parentLabelId,
                                    ariaDescribedBy: parent.disagrees ? parentNoteId : void 0
                                })
                            ]
                        }),
                        /* @__PURE__ */ jsx49("div", {
                            role: "status",
                            id: parentNoteId,
                            children: parent.disagrees && /* @__PURE__ */ jsxs37(Note3, {
                                tone: "butter",
                                icon: /* @__PURE__ */ jsx49(Icon22, {
                                    name: "triangle-exclamation",
                                    size: "xs"
                                }),
                                children: [
                                    "Double-check the parent \u2014 it appears different in the plan. The drawing puts it in",
                                    " ",
                                    parent.nameOf(parent.spatialParent),
                                    "."
                                ]
                            })
                        })
                    ]
                }),
                item ? /*
           * A machine's capacity is the REGISTER's (Rob, 2026-10-12: "the register's value
           * everywhere", `floor-plan-page-capacity-source`) — what the Hierarchy tab shows and Launch
           * writes — so it is shown, not edited. Read-only rather than disabled, so it stays in the tab
           * order and the note says where the number comes from.
           */ /* @__PURE__ */ jsxs37(FieldBlock, {
                    children: [
                        /* @__PURE__ */ jsxs37(Field, {
                            children: [
                                "Capacity",
                                /* @__PURE__ */ jsx49(FieldInput, {
                                    type: "number",
                                    readOnly: true,
                                    "data-muted": "true",
                                    value: machineCapacityValue(resolveMachineCapacity(item, registerCapacityOf)),
                                    "aria-describedby": capacityNoteId
                                })
                            ]
                        }),
                        /* @__PURE__ */ jsx49(FieldNote, {
                            id: capacityNoteId,
                            children: machineCapacityNote(resolveMachineCapacity(item, registerCapacityOf), hostRegisterRead)
                        })
                    ]
                }) : /* @__PURE__ */ jsxs37(Field, {
                    children: [
                        "Capacity",
                        /* @__PURE__ */ jsx49(FieldInput, {
                            type: "number",
                            min: 0,
                            step: 1,
                            value: (_entity_capacity = entity.capacity) !== null && _entity_capacity !== void 0 ? _entity_capacity : "",
                            placeholder: "0",
                            onFocus: snapshot,
                            onChange: function(e) {
                                var next = capacityFromInput(e.target);
                                if (next) commit(next);
                            }
                        })
                    ]
                }),
                item && /* @__PURE__ */ jsxs37(Field, {
                    children: [
                        "Rotation (\xB0)",
                        /* @__PURE__ */ jsx49(FieldInput, {
                            type: "number",
                            min: 0,
                            max: 359,
                            value: Math.round(normaliseRotation2((_item_rotation = item.rotation) !== null && _item_rotation !== void 0 ? _item_rotation : 0)),
                            onFocus: snapshot,
                            onChange: function(e) {
                                var deg = Number(e.target.value);
                                updateItem(item.refid, {
                                    rotation: Number.isFinite(deg) ? normaliseRotation2(deg) : 0
                                });
                                markEntityModified(item.refid);
                            }
                        })
                    ]
                }),
                item && registerContext && /* @__PURE__ */ jsxs37(Field, {
                    as: "div",
                    children: [
                        /* @__PURE__ */ jsx49("span", {
                            id: modelLabelId,
                            children: "3D model"
                        }),
                        /* @__PURE__ */ jsx49(Combobox2, {
                            maxResults: Infinity,
                            "aria-labelledby": modelLabelId,
                            labelId: modelLabelId,
                            options: modelOptions,
                            value: (itemRegister.kind === "backed" ? (registerBackedRow === null || registerBackedRow === void 0 ? void 0 : registerBackedRow.model_3d) || retainedPlanModel || "" : (_item_modelFile1 = item.modelFile) !== null && _item_modelFile1 !== void 0 ? _item_modelFile1 : "") || void 0,
                            disabled: itemRegister.kind === "unknown" || isWriting,
                            placeholder: "Select a model\u2026",
                            loading: modelFiles === null && modelFilesError === null,
                            loadingText: "Reading the model store\u2026",
                            emptyText: modelPickerEmptyText(modelFiles, modelOptions.length),
                            error: modelFilesError !== null && modelFilesError !== void 0 ? modelFilesError : void 0,
                            onRetry: function() {
                                setModelFilesError(null);
                                setModelAttempt(function(n) {
                                    return n + 1;
                                });
                            },
                            clearLabel: // A register row with a product: clearing returns it to the catalogue's model
                            // (Rob, 2026-10-06), so the button says so.
                            itemRegister.kind === "backed" && namesCatalogueProduct(registerBackedRow === null || registerBackedRow === void 0 ? void 0 : registerBackedRow.reference_id) ? "Use the catalogue's 3D model" : "Clear the 3D model",
                            notInListNote: notInListNote,
                            "aria-describedby": [
                                itemRegister.kind === "backed" && sourceNote !== null ? modelSourceId : null,
                                modelWriteError ? modelErrorId : null
                            ].filter(Boolean).join(" ") || void 0,
                            filter: MODEL_PICKER_FILTER,
                            isExactMatch: MODEL_PICKER_EXACT_MATCH,
                            refusedText: function(typed) {
                                return /* @__PURE__ */ jsxs37(Fragment26, {
                                    children: [
                                        /* @__PURE__ */ jsx49("code", {
                                            children: typed
                                        }),
                                        " ",
                                        modelPickerRefusalTail(modelOptions, typed, "changed")
                                    ]
                                });
                            },
                            onChange: function(next) {
                                if (itemRegister.kind === "backed") {
                                    var forRefid = item.refid;
                                    var forFloor = activeFloorIndex;
                                    var linked = namesCatalogueProduct(registerBackedRow === null || registerBackedRow === void 0 ? void 0 : registerBackedRow.reference_id);
                                    setReturnedToCatalogueFor(null);
                                    void registerWrite.write("model", {
                                        model_3d: next !== null && next !== void 0 ? next : null
                                    }).then(function(ok) {
                                        if (!ok || next != null) return;
                                        if (linked) {
                                            setReturnedToCatalogueFor(forRefid);
                                            return;
                                        }
                                        var now = useFloorplanStore47.getState();
                                        if (now.activeFloorIndex !== forFloor) return;
                                        updateItem(forRefid, {
                                            modelFile: null
                                        });
                                        markEntityModified(forRefid);
                                    });
                                    return;
                                }
                                snapshot();
                                updateItem(item.refid, {
                                    modelFile: next ? flatShareFilename5(next) : null
                                });
                                markEntityModified(item.refid);
                            }
                        }),
                        itemRegister.kind === "backed" && sourceNote !== null && /*
           * Where this model comes from (`onboarding-polish-model-source`, R6), read with the
           * picker through `aria-describedby`. A STATEMENT of state, so not a live region:
           * selecting another machine must not read it out.
           */ /* @__PURE__ */ jsx49(FieldNote, {
                            id: modelSourceId,
                            children: sourceNote
                        }),
                        itemRegister.kind === "backed" && /*
           * The one-off announcement that a clear returned the model to the catalogue. Empty
           * whenever there is nothing to say, so it speaks only on that event — never on a
           * selection change. `aria-live` without `role="status"`: the panel's one status
           * region is the link announcement above, and a second would make it ambiguous.
           */ /* @__PURE__ */ jsx49("span", {
                            "aria-live": "polite",
                            "aria-atomic": "true",
                            style: visuallyHidden,
                            children: returnedToCatalogueFor === item.refid ? MODEL_SOURCE_NOTES.returned : ""
                        }),
                        modelWriteError && /* @__PURE__ */ jsx49(FieldError, {
                            id: modelErrorId,
                            role: "alert",
                            children: modelWriteError
                        })
                    ]
                })
            ]
        })
    });
}
function TwinPlanner(param) {
    var _param_showToolbar = param.showToolbar, showToolbar = _param_showToolbar === void 0 ? true : _param_showToolbar, _param_showFloorTabs = param.showFloorTabs, showFloorTabs = _param_showFloorTabs === void 0 ? true : _param_showFloorTabs, planName = param.planName, onPlanNameChange = param.onPlanNameChange, onSave = param.onSave, _param_isSaving = param.isSaving, isSaving = _param_isSaving === void 0 ? false : _param_isSaving, onNewBlankPlan = param.onNewBlankPlan, underlayImages = param.underlayImages, equipmentPanel = param.equipmentPanel, _param_toolset = param.toolset, toolset = _param_toolset === void 0 ? "full" : _param_toolset, _param_showPlanModeSwitch = param.showPlanModeSwitch, showPlanModeSwitch = _param_showPlanModeSwitch === void 0 ? false : _param_showPlanModeSwitch, _param_showFullscreenButton = param.showFullscreenButton, showFullscreenButton = _param_showFullscreenButton === void 0 ? true : _param_showFullscreenButton, _param_showPropertiesPanel = param.showPropertiesPanel, showPropertiesPanel = _param_showPropertiesPanel === void 0 ? true : _param_showPropertiesPanel, _param_itemEditing = param.itemEditing, itemEditing = _param_itemEditing === void 0 ? "panel" : _param_itemEditing, planToastRegion = param.planToastRegion, spaceCardSlot = param.spaceCardSlot, twinBid = param.twinBid, layoutScope = param.layoutScope, onStreamClaim = param.onStreamClaim, onStreamLinked = param.onStreamLinked, activeStreamDrag = param.activeStreamDrag, onStreamClaimCheck = param.onStreamClaimCheck, onObserversRemoved = param.onObserversRemoved, onCameraEdited = param.onCameraEdited, litCameraRefid = param.litCameraRefid, unlinkedCamerasAreWork = param.unlinkedCamerasAreWork, _param_floorDialogs = param.floorDialogs, floorDialogs = _param_floorDialogs === void 0 ? "classic" : _param_floorDialogs, entityMarks = param.entityMarks, floorCounts = param.floorCounts, floorTabsTrailing = param.floorTabsTrailing, _param_planChecks = param.planChecks, planChecks = _param_planChecks === void 0 ? false : _param_planChecks, onPlanChecks = param.onPlanChecks, canvasLegend = param.canvasLegend, _param_legendLook = param.legendLook, legendLook = _param_legendLook === void 0 ? "plain" : _param_legendLook, legendInset = param.legendInset, afterFloorSelector = param.afterFloorSelector, _param_showMapSwitch = param.showMapSwitch, showMapSwitch = _param_showMapSwitch === void 0 ? false : _param_showMapSwitch, _param_floorSelector = param.floorSelector, floorSelector = _param_floorSelector === void 0 ? "strip" : _param_floorSelector, floorSelectorSlot = param.floorSelectorSlot, controlsInset = param.controlsInset, canvasOverlay = param.canvasOverlay, wrapSpaceCard = param.wrapSpaceCard, sidePanel = param.sidePanel;
    var checksTab = !!(equipmentPanel === null || equipmentPanel === void 0 ? void 0 : equipmentPanel.showChecks) && planChecks;
    var _useState40 = _sliced_to_array(useState40(createReshapeStore), 1), reshapeStore = _useState40[0];
    var reshapeOn = itemEditing === "host" && !!planToastRegion;
    var _useState401 = _sliced_to_array(useState40(createEquipmentDragStore), 1), equipmentDragStoreAlways = _useState401[0];
    var equipmentDragStore = (equipmentPanel === null || equipmentPanel === void 0 ? void 0 : equipmentPanel.assetsLook) === "rows" ? equipmentDragStoreAlways : null;
    var spaceDrawnToast = useRef36(null);
    var drawToastRegion = itemEditing === "host" ? planToastRegion : void 0;
    var onSpaceDrawn = useCallback19(function(report) {
        var _spaceDrawnToast_current;
        (_spaceDrawnToast_current = spaceDrawnToast.current) === null || _spaceDrawnToast_current === void 0 ? void 0 : _spaceDrawnToast_current.call(spaceDrawnToast, report);
    }, []);
    var storePlanMode = useEditorStore38(function(s) {
        return s.planMode;
    });
    var rendererSupport = usePlannerRendererSupport();
    var modeSwitchOffered = showPlanModeSwitch && toolset === "full" && showFloorTabs;
    var planMode = modeSwitchOffered ? storePlanMode : "edit";
    var storeShowMap = useEditorStore38(function(s) {
        return s.showMap;
    });
    var setShowMap = useEditorStore38(function(s) {
        return s.setShowMap;
    });
    var showMap = modeSwitchOffered || showMapSwitch ? storeShowMap : true;
    var _legendInset_right;
    var floatingLegendStyle = legendInset ? {
        left: legendInset.left,
        bottom: legendInset.bottom,
        maxWidth: "calc(100% - (".concat(legendInset.left, ") - (").concat((_legendInset_right = legendInset.right) !== null && _legendInset_right !== void 0 ? _legendInset_right : space24[3], "))")
    } : void 0;
    var caps = resolvePlannerCapabilities(toolset, planMode, rendererSupport);
    var aligning = caps.allFloors;
    var modeAnnouncement = usePlanModeAnnouncement(modeSwitchOffered);
    useHeldFloorAnnouncement();
    var _useState402 = _sliced_to_array(useState40(null), 2), sidePanelTabsHost = _useState402[0], setSidePanelTabsHost = _useState402[1];
    var _useState403 = _sliced_to_array(useState40(""), 2), manageQuery = _useState403[0], setManageQuery = _useState403[1];
    useEffect38(function() {
        if (!aligning) setManageQuery("");
    }, [
        aligning
    ]);
    var _useState404 = _sliced_to_array(useState40(null), 2), pendingDelete = _useState404[0], setPendingDelete = _useState404[1];
    var _useAnnouncer = _sliced_to_array(useAnnouncer(), 2), deletedSaid = _useAnnouncer[0], announceDeleted = _useAnnouncer[1];
    var camerasOnly = historyScopeFor(caps.mutableKinds).camerasOnly;
    var heldSelectionRef = useRef36([]);
    var _useState405 = _sliced_to_array(useState40(false), 2), deleteWarned = _useState405[0], setDeleteWarned = _useState405[1];
    var _useState406 = _sliced_to_array(useState40(null), 2), toAnnounce = _useState406[0], setToAnnounce = _useState406[1];
    useEffect38(function() {
        if (toAnnounce === null) return;
        announceDeleted(toAnnounce);
        setToAnnounce(null);
    }, [
        toAnnounce,
        announceDeleted
    ]);
    var requestOriginRef = useRef36(null);
    var requestDelete = useCallback19(function(request, opts) {
        heldSelectionRef.current = _to_consumable_array(selectionOnFloorShown8(useEditorStore38.getState()));
        if (!(opts === null || opts === void 0 ? void 0 : opts.keepSelection)) {
            useEditorStore38.getState().clearSelection();
            requestOriginRef.current = null;
        }
        setDeleteWarned(true);
        setPendingDelete(request);
    }, []);
    useKeyboardShortcuts(_object_spread({
        disableDrawWall: !caps.tools.drawWall,
        disableDrawSpace: !caps.tools.drawSpace,
        disableCameraTool: !caps.tools.camera,
        mutableKinds: caps.mutableKinds,
        onConfirmDelete: requestDelete,
        onObserversRemoved: onObserversRemoved,
        onCameraEdited: onCameraEdited
    }, itemEditing === "host" && caps.mutableKinds === "all" ? {
        itemDeleteRequests: true
    } : {}));
    var cancelPendingDelete = function() {
        useEditorStore38.setState({
            selectedEntityIds: heldSelectionRef.current,
            heldSelectionFloor: null
        });
        setPendingDelete(null);
    };
    var confirmPendingDelete = function() {
        if (!pendingDelete) return;
        var fresh = planPlannerDeletion(pendingDelete.ids, camerasOnly);
        if (fresh.cameraObserverCount === 0) {
            cancelPendingDelete();
            return;
        }
        if (!sameObserversRemoved(fresh, pendingDelete)) {
            setPendingDelete(fresh);
            return;
        }
        var sentence = cameraDeletedSentence(useFloorplanStore47.getState().layout, fresh);
        applyPlannerDeletion(fresh, {
            camerasOnly: camerasOnly,
            onObserversRemoved: onObserversRemoved,
            onCameraEdited: onCameraEdited
        });
        setPendingDelete(null);
        setToAnnounce(sentence);
    };
    var deleteFocusFallback = useMemo25(function() {
        return {
            get current () {
                var _canvasStageRef_current;
                var origin = requestOriginRef.current;
                if (origin === null || origin === void 0 ? void 0 : origin.isConnected) return origin;
                var _canvasStageRef_current_querySelector;
                return (_canvasStageRef_current_querySelector = (_canvasStageRef_current = canvasStageRef.current) === null || _canvasStageRef_current === void 0 ? void 0 : _canvasStageRef_current.querySelector("[data-plan-pane]")) !== null && _canvasStageRef_current_querySelector !== void 0 ? _canvasStageRef_current_querySelector : null;
            }
        };
    }, []);
    var cameraDeleteRequest = useEditorStore38(function(s) {
        return s.cameraDeleteRequest;
    });
    useEffect38(function() {
        if (!cameraDeleteRequest) return;
        useEditorStore38.getState().clearCameraDeleteRequest();
        var plan = planPlannerDeletion([
            cameraDeleteRequest.refid
        ], camerasOnly);
        if (plan.cameraRefids.length === 0) return;
        var active = document.activeElement;
        requestOriginRef.current = _instanceof(active, HTMLElement) && active !== document.body ? active : null;
        if (plan.cameraObserverCount > 0) {
            requestDelete(plan, {
                keepSelection: true
            });
            return;
        }
        var sentence = cameraDeletedSentence(useFloorplanStore47.getState().layout, plan);
        applyPlannerDeletion(plan, {
            camerasOnly: camerasOnly,
            onObserversRemoved: onObserversRemoved,
            onCameraEdited: onCameraEdited
        });
        setToAnnounce(sentence);
    }, [
        cameraDeleteRequest
    ]);
    var resetPlanView = useEditorStore38(function(s) {
        return s.resetPlanView;
    });
    useEffect38(function() {
        resetPlanView();
        return function() {
            return resetPlanView();
        };
    }, [
        resetPlanView
    ]);
    var _useState407 = _sliced_to_array(useState40(false), 2), isFullscreen = _useState407[0], setIsFullscreen = _useState407[1];
    var canvasStageRef = useRef36(null);
    useRegisterPlanSync({
        twinBid: twinBid,
        twinId: equipmentPanel === null || equipmentPanel === void 0 ? void 0 : equipmentPanel.twinId,
        layoutScope: layoutScope
    });
    var identityReadEnabled = Boolean((equipmentPanel === null || equipmentPanel === void 0 ? void 0 : equipmentPanel.apiBaseUrl) && (equipmentPanel === null || equipmentPanel === void 0 ? void 0 : equipmentPanel.getAccessToken) && twinBid);
    var _equipmentPanel_apiBaseUrl, _equipmentPanel_getAccessToken;
    var twinOrg = useTwinOrgBid({
        middlewareApi: (_equipmentPanel_apiBaseUrl = equipmentPanel === null || equipmentPanel === void 0 ? void 0 : equipmentPanel.apiBaseUrl) !== null && _equipmentPanel_apiBaseUrl !== void 0 ? _equipmentPanel_apiBaseUrl : "",
        getAccessToken: (_equipmentPanel_getAccessToken = equipmentPanel === null || equipmentPanel === void 0 ? void 0 : equipmentPanel.getAccessToken) !== null && _equipmentPanel_getAccessToken !== void 0 ? _equipmentPanel_getAccessToken : NO_TOKEN,
        twinBid: twinBid,
        enabled: identityReadEnabled
    });
    var _equipmentPanel_apiBaseUrl1, _equipmentPanel_getAccessToken1;
    var liveIdentities = useLiveEntityIdentities({
        middlewareApi: (_equipmentPanel_apiBaseUrl1 = equipmentPanel === null || equipmentPanel === void 0 ? void 0 : equipmentPanel.apiBaseUrl) !== null && _equipmentPanel_apiBaseUrl1 !== void 0 ? _equipmentPanel_apiBaseUrl1 : "",
        getAccessToken: (_equipmentPanel_getAccessToken1 = equipmentPanel === null || equipmentPanel === void 0 ? void 0 : equipmentPanel.getAccessToken) !== null && _equipmentPanel_getAccessToken1 !== void 0 ? _equipmentPanel_getAccessToken1 : NO_TOKEN,
        orgBid: twinOrg.orgBid,
        orgPending: twinOrg.pending,
        twinBid: twinBid,
        enabled: identityReadEnabled
    });
    var liveStatus = liveIdentities.status;
    var liveBids = liveIdentities.bids;
    var floorLaunched = useCallback19(function(floor) {
        return isFloorLaunched(floor, twinBid, {
            status: liveStatus,
            bids: liveBids
        });
    }, [
        twinBid,
        liveStatus,
        liveBids
    ]);
    var settleUnverifiedMints = useFloorplanStore47(function(s) {
        return s.settleUnverifiedMints;
    });
    useEffect38(function() {
        if (liveIdentities.status === "ready") settleUnverifiedMints(liveIdentities.bids);
    }, [
        liveIdentities.status,
        liveIdentities.bids,
        settleUnverifiedMints
    ]);
    useEffect38(function() {
        var apiBaseUrl = equipmentPanel === null || equipmentPanel === void 0 ? void 0 : equipmentPanel.apiBaseUrl;
        var getAccessToken = equipmentPanel === null || equipmentPanel === void 0 ? void 0 : equipmentPanel.getAccessToken;
        if (!apiBaseUrl || !getAccessToken) return;
        var cancelled = false;
        void _async_to_generator(function() {
            var token, err;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            getAccessToken()
                        ];
                    case 1:
                        token = _state.sent();
                        if (!!cancelled) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            useCameraCatalogStore.getState().fetchCameras(apiBaseUrl, token)
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            3,
                            5
                        ];
                    case 4:
                        err = _state.sent();
                        if (cancelled) return [
                            2
                        ];
                        console.error("Error loading the camera catalogue:", err);
                        useCameraCatalogStore.setState({
                            error: "The camera list could not be loaded. Reload the page to try again.",
                            isLoading: false
                        });
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        })();
        return function() {
            cancelled = true;
        };
    }, [
        equipmentPanel === null || equipmentPanel === void 0 ? void 0 : equipmentPanel.apiBaseUrl,
        equipmentPanel === null || equipmentPanel === void 0 ? void 0 : equipmentPanel.getAccessToken
    ]);
    var equipmentSidebar = equipmentPanel && /* @__PURE__ */ jsx49(PlannerJoinedLayout, {
        twinBid: twinBid,
        twinId: equipmentPanel.twinId,
        children: /* @__PURE__ */ jsx49(EquipmentSidebar, _object_spread({
            apiBaseUrl: equipmentPanel.apiBaseUrl,
            getAccessToken: equipmentPanel.getAccessToken,
            twinId: equipmentPanel.twinId,
            twinBid: twinBid,
            stepHierarchy: checksTab && itemEditing === "host",
            showSearch: equipmentPanel.showSearch,
            showChecks: checksTab,
            initialMode: equipmentPanel.initialMode,
            onModeChange: equipmentPanel.onModeChange,
            onIdentifyGroup: equipmentPanel.onIdentifyGroup,
            identifyOpenKey: equipmentPanel.identifyOpenKey,
            assetsLook: equipmentPanel.assetsLook
        }, sidePanel ? {
            tabsLook: "top-tabs",
            tabsLabel: sidePanel.regionLabel,
            frame: function(param) {
                var tabs = param.tabs, body = param.body;
                return /* @__PURE__ */ jsxs37(Fragment26, {
                    children: [
                        sidePanelTabsHost && createPortal3(tabs, sidePanelTabsHost),
                        body
                    ]
                });
            }
        } : {}))
    });
    return /* @__PURE__ */ jsx49(ThemeProvider, {
        theme: theme_default,
        children: /* @__PURE__ */ jsx49(PlannerItemEditingProvider, {
            value: itemEditing,
            children: /* @__PURE__ */ jsx49(FloorActionsProvider, {
                toastRegion: itemEditing === "host" ? planToastRegion : void 0,
                onObserversRemoved: onObserversRemoved,
                floorDialogs: floorDialogs,
                floorLaunched: floorLaunched,
                children: /* @__PURE__ */ jsx49(CameraEditedProvider, {
                    onCameraEdited: onCameraEdited,
                    children: /* @__PURE__ */ jsxs37(PlannerContainer, {
                        $fullscreen: isFullscreen,
                        children: [
                            showToolbar && /* @__PURE__ */ jsxs37(Toolbar, {
                                children: [
                                    /* @__PURE__ */ jsx49(ToolbarButton, {
                                        onClick: onNewBlankPlan,
                                        disabled: !onNewBlankPlan,
                                        children: "New blank plan"
                                    }),
                                    /* @__PURE__ */ jsx49(PlanNameInput, {
                                        type: "text",
                                        value: planName !== null && planName !== void 0 ? planName : "",
                                        placeholder: "Plan name",
                                        disabled: !onPlanNameChange,
                                        onChange: function(e) {
                                            return onPlanNameChange === null || onPlanNameChange === void 0 ? void 0 : onPlanNameChange(e.target.value);
                                        }
                                    }),
                                    /* @__PURE__ */ jsxs37(ToolbarButton, {
                                        onClick: onSave,
                                        disabled: isSaving || !onSave,
                                        children: [
                                            /* @__PURE__ */ jsx49(Save16Regular, {}),
                                            isSaving ? "Saving\u2026" : "Save"
                                        ]
                                    })
                                ]
                            }),
                            /* @__PURE__ */ jsx49(PlannerPlanChecks, {
                                enabled: planChecks,
                                twinBid: twinBid,
                                twinId: equipmentPanel === null || equipmentPanel === void 0 ? void 0 : equipmentPanel.twinId,
                                layoutScope: layoutScope,
                                liveIdentities: liveIdentities,
                                children: /* @__PURE__ */ jsxs37(ReshapeStoreContext.Provider, {
                                    value: reshapeOn ? reshapeStore : null,
                                    children: [
                                        showFloorTabs && floorSelector === "strip" && /* @__PURE__ */ jsx49(CheckedFloorTabs, {
                                            editable: caps.floorStructure,
                                            trailing: modeSwitchOffered ? /* @__PURE__ */ jsxs37(ModeBar, {
                                                children: [
                                                    /* @__PURE__ */ jsx49(Switch3, {
                                                        surface: "on-solid",
                                                        checked: storeShowMap,
                                                        onChange: function(e) {
                                                            return setShowMap(e.target.checked);
                                                        },
                                                        children: "Show map"
                                                    }),
                                                    /* @__PURE__ */ jsx49(PlanModeSwitch, {})
                                                ]
                                            }) : floorTabsTrailing,
                                            counts: floorCounts,
                                            announcement: modeAnnouncement
                                        }),
                                        onPlanChecks && /* @__PURE__ */ jsx49(PlanChecksReporter, {
                                            onPlanChecks: onPlanChecks
                                        }),
                                        /* @__PURE__ */ jsx49(PlannerHoverProvider, {
                                            enabled: checksTab,
                                            children: /* @__PURE__ */ jsxs37(EquipmentDragContext.Provider, {
                                                value: equipmentDragStore,
                                                children: [
                                                    equipmentDragStore && /* @__PURE__ */ jsx49(EquipmentDragCard, {
                                                        store: equipmentDragStore
                                                    }),
                                                    equipmentDragStore && /* @__PURE__ */ jsx49(EquipmentPointerDrag, {
                                                        store: equipmentDragStore
                                                    }),
                                                    drawToastRegion && /* @__PURE__ */ jsx49(SpaceDrawnToaster, {
                                                        into: spaceDrawnToast,
                                                        region: drawToastRegion,
                                                        twinBid: twinBid,
                                                        twinId: equipmentPanel === null || equipmentPanel === void 0 ? void 0 : equipmentPanel.twinId
                                                    }),
                                                    /* @__PURE__ */ jsxs37(UnderlayImagesContext.Provider, {
                                                        value: underlayImages !== null && underlayImages !== void 0 ? underlayImages : null,
                                                        children: [
                                                            /* @__PURE__ */ jsx49(CapacitySourceSort, {
                                                                twinBid: twinBid,
                                                                twinId: equipmentPanel === null || equipmentPanel === void 0 ? void 0 : equipmentPanel.twinId,
                                                                layoutScope: layoutScope
                                                            }),
                                                            /* @__PURE__ */ jsxs37(CanvasArea, {
                                                                children: [
                                                                    sidePanel ? /* @__PURE__ */ jsxs37(SidePanelSlot, {
                                                                        "data-testid": "planner-side-panel-slot",
                                                                        "data-plan-cover": "left",
                                                                        style: sidePanel.inset,
                                                                        children: [
                                                                            /* @__PURE__ */ jsx49(ListPanel, {
                                                                                name: sidePanel.foldedName,
                                                                                summary: sidePanel.foldedSummary,
                                                                                "aria-label": sidePanel.regionLabel,
                                                                                foldLabel: sidePanel.foldLabel,
                                                                                openLabel: sidePanel.openLabel,
                                                                                width: sidePanel.width,
                                                                                open: sidePanel.open,
                                                                                onOpenChange: sidePanel.onOpenChange,
                                                                                shortcutEnabled: sidePanel.shortcutEnabled,
                                                                                searchSlot: aligning ? void 0 : sidePanel.searchSlot,
                                                                                searchLabel: sidePanel.searchLabel,
                                                                                search: aligning ? {
                                                                                    value: manageQuery,
                                                                                    onChange: setManageQuery,
                                                                                    placeholder: "Search floors and references\u2026",
                                                                                    label: "Search floors and references"
                                                                                } : void 0,
                                                                                foldedLead: modeSwitchOffered ? /* @__PURE__ */ jsx49(PlanModeSwitch, {
                                                                                    iconsOnly: true
                                                                                }) : void 0,
                                                                                foldedTrail: sidePanel.foldedTrail,
                                                                                header: /* @__PURE__ */ jsxs37(Fragment26, {
                                                                                    children: [
                                                                                        modeSwitchOffered && /* @__PURE__ */ jsx49(PlanModeSwitch, {
                                                                                            fullWidth: true
                                                                                        }),
                                                                                        /* @__PURE__ */ jsx49(SidePanelTabsHost, {
                                                                                            ref: setSidePanelTabsHost
                                                                                        }),
                                                                                        sidePanel.notices
                                                                                    ]
                                                                                }),
                                                                                children: aligning ? /* @__PURE__ */ jsx49(ManageFloorsInListPanel, {
                                                                                    query: manageQuery
                                                                                }) : equipmentSidebar
                                                                            }),
                                                                            modeSwitchOffered && /* @__PURE__ */ jsx49("span", {
                                                                                role: "status",
                                                                                "aria-live": "polite",
                                                                                "aria-atomic": "true",
                                                                                style: visuallyHidden,
                                                                                children: modeAnnouncement
                                                                            })
                                                                        ]
                                                                    }) : /* @__PURE__ */ jsxs37(Fragment26, {
                                                                        children: [
                                                                            aligning && /* @__PURE__ */ jsx49(AlignFloorsPanel, {}),
                                                                            !aligning && equipmentSidebar
                                                                        ]
                                                                    }),
                                                                    /* @__PURE__ */ jsxs37(CanvasStage, {
                                                                        ref: canvasStageRef,
                                                                        children: [
                                                                            showFloorTabs && floorSelector === "floating" && !aligning && /* @__PURE__ */ jsx49(FloorSelectorSlot, {
                                                                                "data-testid": "planner-floor-selector-slot",
                                                                                style: floorSelectorSlot,
                                                                                children: /* @__PURE__ */ jsx49(CheckedFloorTabs, {
                                                                                    look: "floating",
                                                                                    editable: caps.floorStructure,
                                                                                    counts: floorCounts
                                                                                })
                                                                            }),
                                                                            afterFloorSelector,
                                                                            (canvasLegend || showMapSwitch) && (!aligning || showMapSwitch) && legendLook === "floating" && /* @__PURE__ */ jsx49(PlanLegendBar, {
                                                                                "data-testid": "planner-floating-legend",
                                                                                style: floatingLegendStyle,
                                                                                showMap: showMapSwitch ? {
                                                                                    checked: storeShowMap,
                                                                                    onChange: setShowMap
                                                                                } : void 0,
                                                                                children: !aligning && canvasLegend
                                                                            }),
                                                                            /* @__PURE__ */ jsx49(PlannerCanvas, {
                                                                                toolset: toolset,
                                                                                capabilities: caps,
                                                                                twinBid: twinBid,
                                                                                liveIdentities: liveIdentities,
                                                                                onStreamClaim: onStreamClaim,
                                                                                onStreamLinked: onStreamLinked,
                                                                                activeStreamDrag: activeStreamDrag,
                                                                                onStreamClaimCheck: onStreamClaimCheck,
                                                                                litCameraRefid: litCameraRefid,
                                                                                unlinkedCamerasAreWork: unlinkedCamerasAreWork,
                                                                                entityMarks: entityMarks,
                                                                                referenceOffered: modeSwitchOffered,
                                                                                showMap: showMap,
                                                                                onSpaceDrawn: drawToastRegion ? onSpaceDrawn : void 0,
                                                                                controlsInset: controlsInset
                                                                            }),
                                                                            canvasLegend && !aligning && legendLook === "plain" && /* @__PURE__ */ jsx49(LegendSlot, {
                                                                                children: canvasLegend
                                                                            }),
                                                                            canvasOverlay && /* @__PURE__ */ jsx49(CanvasOverlaySlot, {
                                                                                "data-testid": "planner-canvas-overlay",
                                                                                hidden: aligning,
                                                                                $railClear: !controlsInset,
                                                                                children: canvasOverlay
                                                                            }),
                                                                            showPropertiesPanel && !aligning && /* @__PURE__ */ jsx49(PropertiesPanel, {
                                                                                boundsRef: canvasStageRef,
                                                                                twinBid: twinBid,
                                                                                twinId: equipmentPanel === null || equipmentPanel === void 0 ? void 0 : equipmentPanel.twinId,
                                                                                itemEditing: itemEditing,
                                                                                spaceCardDocked: spaceCardSlot !== void 0
                                                                            }),
                                                                            showPropertiesPanel && !aligning && /* @__PURE__ */ jsx49(FloorDetailsPanel, {
                                                                                boundsRef: canvasStageRef,
                                                                                twinBid: twinBid,
                                                                                twinId: equipmentPanel === null || equipmentPanel === void 0 ? void 0 : equipmentPanel.twinId
                                                                            }),
                                                                            itemEditing === "host" && /* @__PURE__ */ jsx49(MachineDeleteFlow, {
                                                                                twinBid: twinBid,
                                                                                twinId: equipmentPanel === null || equipmentPanel === void 0 ? void 0 : equipmentPanel.twinId,
                                                                                toastRegion: planToastRegion,
                                                                                onObserversRemoved: onObserversRemoved,
                                                                                live: liveIdentities
                                                                            }),
                                                                            pendingDelete && /* @__PURE__ */ jsx49(CameraDeleteWarning, {
                                                                                request: pendingDelete,
                                                                                undoable: !camerasOnly,
                                                                                onCancel: cancelPendingDelete,
                                                                                onConfirm: confirmPendingDelete,
                                                                                returnFocusTo: deleteFocusFallback
                                                                            }),
                                                                            (deleteWarned || camerasOnly) && /* @__PURE__ */ jsx49("span", {
                                                                                role: "status",
                                                                                "aria-live": "polite",
                                                                                "aria-atomic": "true",
                                                                                style: visuallyHidden,
                                                                                children: deletedSaid
                                                                            }),
                                                                            showFullscreenButton && /* @__PURE__ */ jsx49(FullscreenButton, {
                                                                                onClick: function() {
                                                                                    return setIsFullscreen(function(f) {
                                                                                        return !f;
                                                                                    });
                                                                                },
                                                                                title: isFullscreen ? "Exit full screen" : "Full screen",
                                                                                "aria-label": isFullscreen ? "Exit full screen" : "Full screen",
                                                                                children: isFullscreen ? /* @__PURE__ */ jsx49(ArrowMinimize20Regular, {}) : /* @__PURE__ */ jsx49(ArrowMaximize20Regular, {})
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        itemEditing === "host" && spaceCardSlot && createPortal3((wrapSpaceCard !== null && wrapSpaceCard !== void 0 ? wrapSpaceCard : function(card) {
                                            return card;
                                        })(/* @__PURE__ */ jsx49(SpaceCard, {
                                            twinBid: twinBid,
                                            twinId: equipmentPanel === null || equipmentPanel === void 0 ? void 0 : equipmentPanel.twinId,
                                            toastRegion: planToastRegion,
                                            live: {
                                                status: liveStatus,
                                                bids: liveBids
                                            }
                                        })), spaceCardSlot),
                                        reshapeOn && /* @__PURE__ */ jsx49(ReshapeReport, {
                                            store: reshapeStore,
                                            toastRegion: planToastRegion,
                                            twinBid: twinBid,
                                            twinId: equipmentPanel === null || equipmentPanel === void 0 ? void 0 : equipmentPanel.twinId
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
}
// src/components/Planner/canvas/planCameraStyles.ts
import { brand as brand3, ink as ink10, rgba as rgba4, semantic as semantic13, shadow as shadow6 } from "@repo/design-tokens";
// src/components/Planner/canvas/planSelectionColour.ts
import { ramp } from "@repo/design-tokens";
var PLAN_SELECTION_COLOUR = ramp.selected[6];
// src/components/Planner/canvas/planCameraStyles.ts
var roles = semantic13.status.roles;
var SLATE = ink10[1];
var CONE_STYLES = {
    selected: {
        fill: rgba4(PLAN_SELECTION_COLOUR, 0.28),
        stroke: PLAN_SELECTION_COLOUR,
        strokeWidth: 2
    },
    other: {
        fill: rgba4(SLATE, 0.08),
        stroke: rgba4(SLATE, 0.55),
        strokeWidth: 1.25
    },
    /** Hover (its wall tile is hovered): dashed, in the plan's selection colour. */ lit: {
        fill: rgba4(PLAN_SELECTION_COLOUR, 0.14),
        stroke: PLAN_SELECTION_COLOUR,
        strokeWidth: 1.5,
        dash: [
            5,
            3
        ]
    },
    noStream: {
        fill: rgba4(SLATE, 0.03),
        stroke: rgba4(SLATE, 0.38),
        strokeWidth: 1.25,
        dash: [
            3,
            4
        ]
    }
};
var DROP_PREVIEW_CONE_STYLE = {
    fill: rgba4(roles.beingEdited.mark, 0.12),
    stroke: roles.beingEdited.mark,
    strokeWidth: 1.5,
    dash: [
        5,
        4
    ]
};
var inkDrop = function(alpha) {
    return "rgba(".concat(shadow6.inkGlassRgb, ", ").concat(alpha, ")");
};
var PLAN_CAMERA_SHADOWS = {
    /** `.pc-mark` — every marker's drop. */ marker: "0 1px 3px ".concat(inkDrop(0.35)),
    /** A selected marker: the plan's selection glow round its ring, and the drop. */ markerSelected: "0 0 0 3px ".concat(rgba4(PLAN_SELECTION_COLOUR, 0.7), ", 0 2px 5px ").concat(inkDrop(0.35)),
    /** `.pc-mark.is-target` — the butter ring's halo while a stream is dragged. */ markerTarget: "0 0 0 4px ".concat(rgba4(roles.beingEdited.mark, 0.45), ", 0 0 14px 4px ").concat(rgba4(roles.beingEdited.mark, 0.55)),
    /** `.pc-h` — a handle's frost halo and drop (decoration, not a status). */ handle: "0 0 8px 2px ".concat(rgba4(brand3.frost, 0.95), ", 0 1px 3px ").concat(inkDrop(0.3)),
    /** `.pc-h:hover`. */ handleHover: "0 0 0 4px ".concat(rgba4(PLAN_SELECTION_COLOUR, 0.18), ", 0 0 10px 3px ").concat(brand3.frost, ", 0 1px 3px ").concat(inkDrop(0.3))
};
var PLAN_CAMERA_MARKER_LOOKS = {
    target: {
        ring: roles.beingEdited.mark,
        ringStyle: "solid",
        shadow: PLAN_CAMERA_SHADOWS.markerTarget
    },
    selected: {
        ring: PLAN_SELECTION_COLOUR,
        ringStyle: "solid",
        shadow: PLAN_CAMERA_SHADOWS.markerSelected
    },
    lit: {
        ring: PLAN_SELECTION_COLOUR,
        ringStyle: "dashed",
        shadow: PLAN_CAMERA_SHADOWS.marker
    },
    unlinkedWork: {
        ring: roles.workToDo.mark,
        ringStyle: "solid",
        shadow: PLAN_CAMERA_SHADOWS.marker
    },
    other: {
        ring: ink10[3],
        ringStyle: "solid",
        shadow: PLAN_CAMERA_SHADOWS.marker
    }
};
var PLAN_CAMERA_GLYPH = {
    work: roles.workToDo.ink,
    plain: ink10[2]
};
var PLAN_CAMERA_HANDLE_DRAGGING = {
    fill: roles.beingEdited.mark,
    glyph: roles.beingEdited.ink
};
// src/components/Planner/canvas/planCameraPreview.ts
import { useSyncExternalStore as useSyncExternalStore5 } from "react";
var applyCameraPreview = function(camera, preview) {
    return preview && preview.refid === camera.refid ? _object_spread({}, camera, preview.patch) : camera;
};
var createCameraPreviewStore = function() {
    var initial = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    var current2 = initial;
    var listeners2 = /* @__PURE__ */ new Set();
    return {
        get: function() {
            return current2;
        },
        set: function(next) {
            if (next === current2) return;
            current2 = next;
            listeners2.forEach(function(l) {
                return l();
            });
        },
        subscribe: function(listener) {
            listeners2.add(listener);
            return function() {
                return listeners2.delete(listener);
            };
        }
    };
};
var useCameraPreview = function(store) {
    var _store_subscribe, _store_get, _store_get1;
    return useSyncExternalStore5((_store_subscribe = store === null || store === void 0 ? void 0 : store.subscribe) !== null && _store_subscribe !== void 0 ? _store_subscribe : NO_SUBSCRIBE3, (_store_get = store === null || store === void 0 ? void 0 : store.get) !== null && _store_get !== void 0 ? _store_get : NO_PREVIEW, (_store_get1 = store === null || store === void 0 ? void 0 : store.get) !== null && _store_get1 !== void 0 ? _store_get1 : NO_PREVIEW);
};
var NO_SUBSCRIBE3 = function() {
    return function() {
        return void 0;
    };
};
var NO_PREVIEW = function() {
    return null;
};
// src/components/Planner/gestures/useRotateGesture.ts
import { useCallback as useCallback20, useEffect as useEffect39, useRef as useRef37, useState as useState41 } from "react";
import { normaliseRotation as normaliseRotation3, rotationFromLocalOffset, snapRotationDrag as snapRotationDrag2 } from "@repo/front-end-utils";
var DEAD_ZONE_LAYER_PX = 2;
var useRotateGesture = function(param) {
    var enabled = param.enabled, _param_facing = param.facing, facing = _param_facing === void 0 ? "+y" : _param_facing, getFrame = param.getFrame, claimClick = param.claimClick, onPress = param.onPress, onPreview = param.onPreview, onCommit = param.onCommit, snap = param.snap;
    var _useState41 = _sliced_to_array(useState41(null), 2), dragAngle = _useState41[0], setDragAngle = _useState41[1];
    var _useState411 = _sliced_to_array(useState41(false), 2), isDragging = _useState411[0], setIsDragging = _useState411[1];
    var stopRef = useRef37(null);
    useEffect39(function() {
        return function() {
            var _stopRef_current;
            return (_stopRef_current = stopRef.current) === null || _stopRef_current === void 0 ? void 0 : _stopRef_current.call(stopRef);
        };
    }, []);
    var latest = useRef37({
        getFrame: getFrame,
        claimClick: claimClick,
        onPress: onPress,
        onPreview: onPreview,
        onCommit: onCommit,
        snap: snap
    });
    latest.current = {
        getFrame: getFrame,
        claimClick: claimClick,
        onPress: onPress,
        onPreview: onPreview,
        onCommit: onCommit,
        snap: snap
    };
    var onPointerDown = useCallback20(function(press) {
        var _latest_current_onPress, _latest_current;
        if (!enabled) return;
        var native = press.native;
        if (native.button !== void 0 && native.button !== 0) return;
        var frame = latest.current.getFrame();
        if (!frame) return;
        press.stopBubble();
        if (stopRef.current) return;
        (_latest_current_onPress = (_latest_current = latest.current).onPress) === null || _latest_current_onPress === void 0 ? void 0 : _latest_current_onPress.call(_latest_current);
        var pane = frame.pane, pivot = frame.pivot;
        var start = normaliseRotation3(frame.rotation);
        var current2 = start;
        var angleFor = function(pointer, shift) {
            var local = frame.toLocal(pointer);
            var dx = local.x - pivot.x;
            var dy = local.y - pivot.y;
            if (Math.hypot(dx, dy) < DEAD_ZONE_LAYER_PX) return null;
            var raw = rotationFromLocalOffset(dx, dy, facing);
            var custom = latest.current.snap;
            return custom ? custom(raw, {
                shift: shift
            }) : snapRotationDrag2(raw);
        };
        var finish2 = function() {
            stopRef.current = null;
            setDragAngle(null);
            setIsDragging(false);
        };
        stopRef.current = startPaneGesture({
            native: native,
            pane: pane,
            claimClick: function() {
                return latest.current.claimClick();
            },
            cursor: "grabbing",
            onMove: function(pointer, evt) {
                var angle = angleFor(pointer, !!(evt === null || evt === void 0 ? void 0 : evt.shiftKey));
                if (angle === null || angle === current2) return false;
                current2 = angle;
                latest.current.onPreview(angle);
                setDragAngle(angle);
                return true;
            },
            onRelease: function() {
                finish2();
                if (current2 === start) {
                    latest.current.onPreview(null);
                    return;
                }
                latest.current.onCommit(current2);
            },
            onCancel: function() {
                finish2();
                latest.current.onPreview(null);
            }
        });
        setIsDragging(true);
    }, [
        enabled,
        facing
    ]);
    var cancel = useCallback20(function() {
        var stop = stopRef.current;
        if (!stop) return;
        stop();
        stopRef.current = null;
        setDragAngle(null);
        setIsDragging(false);
        latest.current.onPreview(null);
    }, []);
    return {
        onPointerDown: onPointerDown,
        dragAngle: dragAngle,
        isDragging: isDragging,
        cancel: cancel
    };
};
// src/components/Planner/driver/planHandles.ts
import { findLatestDesign as findLatestDesign18, floorDrawState as floorDrawState4, floorOutline, floorPixelsToWorld, normaliseRotation as normaliseRotation4, pixelsToMeters as pixelsToMeters2, underlayPixelsToWorld } from "@repo/front-end-utils";
// src/components/Planner/canvas/planEntityStyles.ts
import { accent, brand as brand4, ink as ink11, inkOn as inkOn3, inset as inset7, ramp as ramp2, rgba as rgba5, semantic as semantic14, support, surface as surface5 } from "@repo/design-tokens";
var SPACE_TONE = ramp2.selected[6];
var CORAL = semantic14.feedback.error;
var BUTTER = accent.butter;
var MINT = support.mint;
var INK = ink11[1];
var WHITE = surface5[0];
var SPACE_STYLES = {
    neutral: {
        fill: rgba5(SPACE_TONE, 0.12),
        stroke: rgba5(SPACE_TONE, 0.55),
        strokeWidth: 1
    },
    selected: {
        fill: rgba5(PLAN_SELECTION_COLOUR, 0.25),
        stroke: PLAN_SELECTION_COLOUR,
        strokeWidth: 2
    },
    error: {
        fill: rgba5(CORAL, 0.1),
        stroke: CORAL,
        strokeWidth: 1.5,
        dash: [
            5,
            4
        ]
    },
    check: {
        fill: rgba5(BUTTER, 0.22),
        stroke: BUTTER,
        strokeWidth: 1
    },
    mint: {
        fill: rgba5(MINT, 0.25),
        stroke: MINT,
        strokeWidth: 1
    },
    drawing: {
        fill: rgba5(SPACE_TONE, 0.1),
        stroke: SPACE_TONE,
        strokeWidth: 2,
        dash: [
            6,
            4
        ]
    },
    // Faint is the neutral outline under the faint floor's group opacity
    // (`AlignFloorsLayer`, `FAINT_FLOOR_OPACITY`) — one alpha, never two.
    faint: {
        fill: rgba5(SPACE_TONE, 0.12),
        stroke: rgba5(SPACE_TONE, 0.55),
        strokeWidth: 1
    }
};
var STATUS = semantic14.status;
var ROLES = STATUS.roles;
var PLAN_SPACE_OUTLINES = {
    neutral: {
        stroke: ROLES.neutral.mark,
        strokeWidth: 1
    },
    problem: {
        stroke: ROLES.problem.mark,
        strokeWidth: 2
    },
    beingEdited: {
        stroke: ROLES.beingEdited.mark,
        strokeWidth: 2
    },
    deadEnd: {
        stroke: ROLES.deadEnd.mark,
        strokeWidth: 2,
        dash: [
            5,
            4
        ]
    },
    justChanged: {
        stroke: ROLES.justChanged.mark,
        strokeWidth: 2
    },
    // Drawn under the faint floor's group opacity (`FAINT_FLOOR_OPACITY`).
    faint: {
        stroke: ROLES.neutral.mark,
        strokeWidth: 1
    },
    drawing: {
        stroke: ROLES.beingEdited.mark,
        strokeWidth: 2,
        dash: [
            6,
            4
        ]
    }
};
var PLAN_SPACE_FILL_OPACITY = 0.5;
var planSpaceFill = function(level, status) {
    return status === "drawing" ? rgba5(ROLES.beingEdited.mark, 0.1) : rgba5(STATUS.spaceLevel[level !== null && level !== void 0 ? level : "area"], PLAN_SPACE_FILL_OPACITY);
};
var PLAN_SPACE_SELECTION = {
    stroke: PLAN_SELECTION_COLOUR,
    opacity: 0.7,
    strokeWidth: 8
};
var PLAN_SPACE_HOVER = {
    stroke: PLAN_SELECTION_COLOUR,
    strokeWidth: parseFloat(STATUS.hover.width),
    dash: [
        6,
        4
    ]
};
var markOuterDiameter = function(style) {
    return style.dotRadius * 2 + style.dotStrokeWidth;
};
var DOT_RADIUS = 4.5;
var RING = 2;
var PLAN_MACHINE_MARKS = {
    problem: {
        dotFill: ROLES.problem.mark,
        dotStroke: WHITE,
        dotStrokeWidth: RING,
        dotRadius: DOT_RADIUS
    },
    beingEdited: {
        dotFill: ROLES.beingEdited.mark,
        dotStroke: WHITE,
        dotStrokeWidth: RING,
        dotRadius: DOT_RADIUS + 1
    },
    justChanged: {
        dotFill: ROLES.justChanged.mark,
        dotStroke: WHITE,
        dotStrokeWidth: RING,
        dotRadius: DOT_RADIUS
    }
};
var PLAN_MACHINE_OUTLINE = {
    gap: 0.07,
    smoothing: 0.22
};
var PLAN_MACHINE_SELECTION = {
    stroke: PLAN_SELECTION_COLOUR,
    linePx: 3,
    glowPx: 12,
    glowOpacity: 0.6
};
var PLAN_MACHINE_HOVER = {
    stroke: PLAN_SELECTION_COLOUR,
    strokeWidth: 3,
    dash: [
        6,
        3
    ],
    glowPx: 10,
    glowOpacity: 0.3
};
var PLAN_MACHINE_TURN_RING = {
    gapM: 0.18,
    minRadiusPx: 34,
    linePx: 7,
    arcDeg: 140,
    headsAtDeg: 70,
    taper: 0.6,
    fade: 1.6,
    head: {
        lengthPx: 10,
        widthPx: 18,
        open: true
    },
    glow: {
        px: 14,
        strength: 0.55
    },
    headColour: PLAN_SELECTION_COLOUR,
    tailColour: brand4.aqua,
    bandPx: 12,
    hover: {
        liftPx: 1,
        glowFactor: 1.5
    },
    ticks: {
        minor: {
            lengthPx: 5,
            widthPx: 1.2,
            opacity: 0.55
        },
        major: {
            lengthPx: 9,
            widthPx: 1.8,
            opacity: 0.9
        },
        outPx: 4,
        inMs: 150,
        outMs: 200
    },
    appear: {
        ms: 200,
        from: 0.94
    },
    returnMs: 150
};
var PLAN_MACHINE_FADING_GLOW = {
    halo: rgba5(ROLES.justChanged.mark, 0.55),
    haloSpread: 6,
    ring: rgba5(ROLES.justChanged.mark, 0.95),
    ringWidth: 2
};
var PLAN_SPACE_JUMP_GLOW = {
    stroke: rgba5(ROLES.justChanged.mark, 0.7),
    opacity: 1,
    strokeWidth: PLAN_SPACE_SELECTION.strokeWidth
};
var FAINT_FOOTPRINT = {
    stroke: rgba5(INK, 0.3),
    strokeWidth: 1
};
var HANDLE_STYLES = {
    /** A space's corner (frame 10 note 1): 22 px across, ring included. */ corner: {
        radius: 10,
        fill: WHITE,
        stroke: PLAN_SELECTION_COLOUR,
        strokeWidth: 2
    },
    /**
   * A whole edge armed for moving (frame 10 note 3, `floor-plan-page-reshape` R4): the selection
   * cyan, 6 px — the frame's `edge` look (`stroke: '#1BB6D9', sw: 6`). Screen px.
   */ edge: {
        stroke: PLAN_SELECTION_COLOUR,
        strokeWidth: 6
    },
    /** The edge's grab band around the line, screen px — the corners' own `hitStrokeWidth` + 2. */ edgeHit: 12,
    /**
   * The disc behind a glyph — add-a-corner, edge, rotate, move. Card 24's handle look (`.pc-h`):
   * 20 px across ring included, a 2 px cyan ring, the glyph in `--tl-ink-on-aqua` (frame 07 reads
   * 005F69), and the camera handle's own halo, so the two handle families stay one look.
   */ glyphDisc: {
        size: 20,
        fill: WHITE,
        ring: PLAN_SELECTION_COLOUR,
        ringWidth: 2,
        glyph: inkOn3.aqua,
        halo: PLAN_CAMERA_SHADOWS.handle
    }
};
var glyphDiscRadius = (HANDLE_STYLES.glyphDisc.size - HANDLE_STYLES.glyphDisc.ringWidth) / 2;
var NAME_TAG = {
    background: rgba5(WHITE, 0.95),
    name: ink11[2],
    /** The tag's edge takes its space's tone (frame 02: coral on Z004, butter on S006). */ border: {
        neutral: rgba5(SPACE_TONE, 0.4),
        selected: rgba5(PLAN_SELECTION_COLOUR, 0.4),
        error: rgba5(CORAL, 0.5),
        check: rgba5(BUTTER, 0.6),
        mint: rgba5(MINT, 0.6),
        drawing: rgba5(SPACE_TONE, 0.4),
        faint: rgba5(SPACE_TONE, 0.4)
    },
    /** Inset from the outline's top-left vertex, as frame 02 draws it. */ offset: {
        x: parseFloat(inset7[2]),
        y: parseFloat(inset7[1])
    }
};
// src/components/Planner/driver/planHandles.ts
var ROTATE_HIT_RADIUS_SCREEN_PX = 10;
var machineTurnReach = function(outline, box) {
    var loops = (outline !== null && outline !== void 0 ? outline : []).filter(function(loop) {
        return loop.length >= 3;
    });
    if (loops.length > 0) {
        var far = 0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator = loops[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                var loop = _step.value;
                try {
                    for(var _iterator1 = loop[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                        var p = _step1.value;
                        far = Math.max(far, Math.hypot(p.x, p.y));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        if (Number.isFinite(far)) return far;
    }
    if (!box) return null;
    var width = box.width, depth = box.depth, offsetX = box.offsetX, offsetY = box.offsetY;
    var reach = Math.hypot(Math.abs(offsetX) + width / 2, Math.abs(offsetY) + depth / 2);
    return Number.isFinite(reach) ? reach : null;
};
var machineTurnRing = function(item, reach, zoom) {
    var _item_rotation;
    var rotation = (_item_rotation = item.rotation) !== null && _item_rotation !== void 0 ? _item_rotation : 0;
    if (reach === null || ![
        item.x,
        item.y,
        rotation,
        reach
    ].every(Number.isFinite) || !(zoom > 0)) {
        return null;
    }
    var radius13 = Math.max(reach + PLAN_MACHINE_TURN_RING.gapM, pixelsToMeters2(PLAN_MACHINE_TURN_RING.minRadiusPx / zoom));
    var turn = normaliseRotation4(rotation) * Math.PI / 180;
    return {
        centre: {
            x: item.x,
            y: item.y
        },
        radius: radius13,
        front: {
            x: item.x - radius13 * Math.sin(turn),
            y: item.y + radius13 * Math.cos(turn)
        }
    };
};
var KNOB_GAP_SCREEN_PX = 24;
var underlayTurnHandle = function(underlay, zoom, placement) {
    var top = underlayPixelsToWorld(underlay, {
        x: underlay.widthPx / 2,
        y: 0
    });
    var rad = underlay.rotation * Math.PI / 180;
    var gap = KNOB_GAP_SCREEN_PX / (zoom || 1);
    var onFloor = {
        x: top.x - Math.sin(rad) * gap,
        y: top.y + Math.cos(rad) * gap
    };
    var world = floorPixelsToWorld(onFloor, placement);
    return {
        top: top,
        onFloor: onFloor,
        world: world,
        metres: {
            x: pixelsToMeters2(world.x),
            y: pixelsToMeters2(world.y)
        }
    };
};
var underlayKnobOwner = function(param) {
    var aligning = param.aligning, toolMode = param.toolMode, selected2 = param.selected;
    return aligning && toolMode === "select" && (selected2 === null || selected2 === void 0 ? void 0 : selected2.onScreen) && !selected2.underlay.locked ? selected2.underlay.id : null;
};
var cornersShownFor = function(param) {
    var selectedIds = param.selectedIds, editable = param.editable, toolMode = param.toolMode;
    return editable && toolMode === "select" ? _to_consumable_array(selectedIds) : [];
};
var cornerSurfaceFor = function(param) {
    var aligning = param.aligning, editable = param.editable, toolMode = param.toolMode, selectedIds = param.selectedIds, surfaces = param.surfaces;
    var _surfaces_find;
    return !aligning && editable && toolMode === "select" && selectedIds.length === 1 ? (_surfaces_find = surfaces.find(function(s) {
        return s.refid === selectedIds[0];
    })) !== null && _surfaces_find !== void 0 ? _surfaces_find : null : null;
};
var edgesShownFor = function(param) {
    var reshapeOn = param.reshapeOn, aligning = param.aligning, cornerSurface = param.cornerSurface;
    return reshapeOn && !aligning ? cornerSurface : null;
};
var wallEndsShownFor = function(param) {
    var selectedIds = param.selectedIds, editable = param.editable, toolMode = param.toolMode, walls2 = param.walls;
    if (!editable || toolMode !== "select") return [];
    var order = new Map(walls2.map(function(wall, i) {
        return [
            wall.id,
            i
        ];
    }));
    return selectedIds.filter(function(id) {
        return order.has(id);
    }).sort(function(a, b) {
        var _order_get, _order_get1;
        return ((_order_get = order.get(a)) !== null && _order_get !== void 0 ? _order_get : 0) - ((_order_get1 = order.get(b)) !== null && _order_get1 !== void 0 ? _order_get1 : 0);
    });
};
var singleSelectedCamera = function(cameras, selectedIds) {
    var selected2 = cameras.filter(function(c) {
        return selectedIds.includes(c.camera.refid);
    });
    return selected2.length === 1 ? selected2[0] : null;
};
var floorHandlePoint = function(onFloor, placement) {
    var world = floorPixelsToWorld(onFloor, placement);
    return {
        onFloor: onFloor,
        world: world,
        metres: {
            x: pixelsToMeters2(world.x),
            y: pixelsToMeters2(world.y)
        }
    };
};
var floorHandles = function(design, placement, zoom, footprintOf) {
    return floorHandlesOf(floorOutline(design, footprintOf), placement, zoom);
};
var floorHandlesOf = function(outline, placement, zoom) {
    if (!outline) return null;
    var midX = (outline.minX + outline.maxX) / 2;
    var at3 = function(p) {
        return floorHandlePoint(p, placement);
    };
    return {
        corners: [
            {
                x: outline.minX,
                y: outline.minY
            },
            {
                x: outline.maxX,
                y: outline.minY
            },
            {
                x: outline.maxX,
                y: outline.maxY
            },
            {
                x: outline.minX,
                y: outline.maxY
            }
        ].map(at3),
        top: at3({
            x: midX,
            y: outline.maxY
        }),
        knob: at3({
            x: midX,
            y: outline.maxY + KNOB_GAP_SCREEN_PX / (zoom || 1)
        }),
        centre: at3({
            x: midX,
            y: (outline.minY + outline.maxY) / 2
        })
    };
};
var floorHandleOwner = function(param) {
    var aligning = param.aligning, toolMode = param.toolMode, floors = param.floors, activeFloorIndex = param.activeFloorIndex, visibility = param.visibility, footprintOf = param.footprintOf, _param_outlineOf = param.outlineOf, outlineOf = _param_outlineOf === void 0 ? function(floor) {
        return floorOutline(findLatestDesign18(floor.designs), footprintOf);
    } : _param_outlineOf;
    if (!aligning || toolMode !== "select" && toolMode !== "scale_underlay") return null;
    var floor = floors[activeFloorIndex];
    if (!floor) return null;
    if (floorDrawState4(floors, activeFloorIndex, activeFloorIndex, visibility) === "hidden") return null;
    return outlineOf(floor) ? floor.id : null;
};
// src/components/Planner/machineCard/itemNudge.ts
import { useEditorStore as useEditorStore39, useFloorplanStore as useFloorplanStore48, selectionOnFloorShown as selectionOnFloorShown9 } from "@repo/front-end-state";
import { isLive as isLive12, normaliseRotation as normaliseRotation5, stepRotation as stepRotation3, screenDirectionToPlanDelta } from "@repo/front-end-utils";
var NUDGE_METRES = 0.1;
var NUDGE_RUN_MS = 1e3;
var ARROWS = {
    ArrowRight: {
        x: 1,
        y: 0
    },
    ArrowLeft: {
        x: -1,
        y: 0
    },
    ArrowUp: {
        x: 0,
        y: -1
    },
    ArrowDown: {
        x: 0,
        y: 1
    }
};
var isNudgeKey = function(key) {
    return key in ARROWS;
};
var lastNudge = null;
var nudgeSelectedItem = function(key, shift, viewRotation) {
    var now = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Date.now();
    var _floorplan_getActiveDesign;
    var direction = ARROWS[key];
    if (!direction) return null;
    var editor = useEditorStore39.getState();
    var selected2 = selectionOnFloorShown9(editor);
    if (selected2.length !== 1) return null;
    var refid = selected2[0];
    var floorplan = useFloorplanStore48.getState();
    var item = (_floorplan_getActiveDesign = floorplan.getActiveDesign()) === null || _floorplan_getActiveDesign === void 0 ? void 0 : _floorplan_getActiveDesign.items.find(function(i) {
        return i.refid === refid && isLive12(i);
    });
    if (!item) return null;
    var turning = shift && (key === "ArrowLeft" || key === "ArrowRight");
    if (shift && !turning) return null;
    var layout = floorplan.layout;
    var continuing = !!lastNudge && lastNudge.refid === refid && now - lastNudge.at <= NUDGE_RUN_MS && lastNudge.layout === layout;
    if (!continuing && layout) editor.pushSnapshot(layout);
    editor.storeOriginalPosition(refid, item.x, item.y);
    var result;
    if (turning) {
        var _item_name;
        var rotation = stepRotation3(normaliseRotation5(item.rotation), key === "ArrowLeft" ? 1 : -1, true);
        floorplan.updateItem(refid, {
            rotation: rotation
        });
        result = {
            kind: "rotated",
            refid: refid,
            name: ((_item_name = item.name) === null || _item_name === void 0 ? void 0 : _item_name.trim()) || "Machine",
            rotation: rotation
        };
    } else {
        var _item_name1;
        var delta = screenDirectionToPlanDelta(direction, NUDGE_METRES, {
            rotation: viewRotation
        });
        var round = function(v) {
            return Math.round(v * 1e3) / 1e3;
        };
        floorplan.updateItem(refid, {
            x: round(item.x + delta.x),
            y: round(item.y + delta.y)
        });
        result = {
            kind: "moved",
            refid: refid,
            name: ((_item_name1 = item.name) === null || _item_name1 === void 0 ? void 0 : _item_name1.trim()) || "Machine"
        };
    }
    editor.markEntityModified(refid);
    lastNudge = {
        refid: refid,
        at: now,
        layout: useFloorplanStore48.getState().layout
    };
    return result;
};
var nudgeAnnouncement = function(result) {
    return result.kind === "moved" ? "Moved ".concat(result.name) : "Rotated ".concat(result.name, " to ").concat(result.rotation, "\xb0");
};
// src/components/Planner/machineCommits.ts
import { useEditorStore as useEditorStore40, useFloorplanStore as useFloorplanStore49 } from "@repo/front-end-state";
import { normaliseRotation as normaliseRotation6, snapPlannerPoint as snapPlannerPoint2 } from "@repo/front-end-utils";
var commitMachineMove = function(refid, start, released, param) {
    var free = param.free;
    var editor = useEditorStore40.getState();
    var _snapPlannerPoint2 = snapPlannerPoint2(released, {
        gridSnap: editor.gridSnap,
        gridSizeCm: editor.gridSize,
        free: free
    }), x = _snapPlannerPoint2.x, y = _snapPlannerPoint2.y;
    if (x === start.x && y === start.y) return false;
    var floorplan = useFloorplanStore49.getState();
    if (floorplan.layout) editor.pushSnapshot(floorplan.layout);
    editor.storeOriginalPosition(refid, start.x, start.y);
    floorplan.updateItem(refid, {
        x: x,
        y: y
    });
    editor.markEntityModified(refid);
    return true;
};
var toTenthMillimetre = function(metres) {
    return Math.round(metres * 1e4) / 1e4;
};
var commitMachinesMove = function(starts, pressed, released, param) {
    var free = param.free;
    var from = starts.find(function(s) {
        return s.refid === pressed;
    });
    if (!from) return false;
    var editor = useEditorStore40.getState();
    var landed = snapPlannerPoint2(released, {
        gridSnap: editor.gridSnap,
        gridSizeCm: editor.gridSize,
        free: free
    });
    var dx = landed.x - from.x;
    var dy = landed.y - from.y;
    if (dx === 0 && dy === 0) return false;
    var floorplan = useFloorplanStore49.getState();
    if (floorplan.layout) editor.pushSnapshot(floorplan.layout);
    starts.forEach(function(start) {
        var point = start.refid === pressed ? landed : {
            x: toTenthMillimetre(start.x + dx),
            y: toTenthMillimetre(start.y + dy)
        };
        editor.storeOriginalPosition(start.refid, start.x, start.y);
        floorplan.updateItem(start.refid, point);
        editor.markEntityModified(start.refid);
    });
    return true;
};
var commitMachineTurn = function(refid, startRotation, angle) {
    var _floorplan_getActiveDesign;
    var rotation = Math.round(normaliseRotation6(angle)) % 360;
    if (rotation === Math.round(normaliseRotation6(startRotation)) % 360) return false;
    var floorplan = useFloorplanStore49.getState();
    var item = (_floorplan_getActiveDesign = floorplan.getActiveDesign()) === null || _floorplan_getActiveDesign === void 0 ? void 0 : _floorplan_getActiveDesign.items.find(function(i) {
        return i.refid === refid && !i._deleted;
    });
    if (!item) return false;
    var editor = useEditorStore40.getState();
    if (floorplan.layout) editor.pushSnapshot(floorplan.layout);
    editor.storeOriginalPosition(refid, item.x, item.y);
    floorplan.updateItem(refid, {
        rotation: rotation
    });
    editor.markEntityModified(refid);
    return true;
};
var toTenthDegree = function(degrees) {
    return Math.round(degrees * 10) / 10;
};
var commitMachinesTurn = function(starts, pressed, angle) {
    var _floorplan_getActiveDesign;
    var from = starts.find(function(s) {
        return s.refid === pressed;
    });
    if (!from) return false;
    var rotation = Math.round(normaliseRotation6(angle)) % 360;
    if (rotation === Math.round(normaliseRotation6(from.rotation)) % 360) return false;
    var change = rotation - from.rotation;
    var floorplan = useFloorplanStore49.getState();
    var _floorplan_getActiveDesign_items;
    var items = (_floorplan_getActiveDesign_items = (_floorplan_getActiveDesign = floorplan.getActiveDesign()) === null || _floorplan_getActiveDesign === void 0 ? void 0 : _floorplan_getActiveDesign.items) !== null && _floorplan_getActiveDesign_items !== void 0 ? _floorplan_getActiveDesign_items : [];
    var live = starts.filter(function(s) {
        return items.some(function(i) {
            return i.refid === s.refid && !i._deleted;
        });
    });
    if (live.length !== starts.length) return false;
    var editor = useEditorStore40.getState();
    if (floorplan.layout) editor.pushSnapshot(floorplan.layout);
    live.forEach(function(start) {
        var item = items.find(function(i) {
            return i.refid === start.refid;
        });
        var turned = start.refid === pressed ? rotation : toTenthDegree(normaliseRotation6(start.rotation + change)) % 360;
        editor.storeOriginalPosition(start.refid, item.x, item.y);
        floorplan.updateItem(start.refid, {
            rotation: turned
        });
        editor.markEntityModified(start.refid);
    });
    return true;
};
// src/components/Planner/drawTools/useWallDraw.ts
import { useState as useState42, useCallback as useCallback21, useEffect as useEffect40, useLayoutEffect as useLayoutEffect3, useRef as useRef38 } from "react";
import { distance, newWallId, snapWallPoint, wallRunCurrent, wallRunPresentIds as wallRunPresentIds2 } from "@repo/front-end-utils";
import { useFloorplanStore as useFloorplanStore50 } from "@repo/front-end-state";
import { useEditorStore as useEditorStore42 } from "@repo/front-end-state";
// src/components/Planner/drawTools/wallSnapContextFor.ts
import { PIXELS_PER_METER as PIXELS_PER_METER2 } from "@repo/front-end-utils";
import { useEditorStore as useEditorStore41 } from "@repo/front-end-state";
function wallSnapContextFor(scale, walls2, opts) {
    var _useEditorStore41_getState = useEditorStore41.getState(), gridSnap = _useEditorStore41_getState.gridSnap, gridSize = _useEditorStore41_getState.gridSize;
    return _object_spread({
        walls: walls2,
        metresPerScreenPx: 1 / (PIXELS_PER_METER2 * scale),
        gridSnap: gridSnap,
        gridSizeCm: gridSize
    }, opts);
}
// src/components/Planner/drawTools/useWallDraw.ts
var DEFAULT_THICKNESS = 0.2;
var MIN_WALL_LENGTH_M = 0.01;
var samePoint2 = function(p, q) {
    return p.x === q.x && p.y === q.y;
};
var sameSnap = function(p, q) {
    return !!p && p.snap.kind === q.snap.kind && samePoint2(p.point, q.point) && p.scale === q.scale && ("wallIndex" in p.snap ? p.snap.wallIndex : -1) === ("wallIndex" in q.snap ? q.snap.wallIndex : -1);
};
function useWallDraw() {
    var toolMode = useEditorStore42(function(s) {
        return s.toolMode;
    });
    var wallRun = useEditorStore42(function(s) {
        return s.wallRun;
    });
    var activeFloorIndex = useFloorplanStore50(function(s) {
        return s.activeFloorIndex;
    });
    var activeFloorId = useFloorplanStore50(function(s) {
        var _s_layout_floors_s_activeFloorIndex, _s_layout;
        return (_s_layout = s.layout) === null || _s_layout === void 0 ? void 0 : (_s_layout_floors_s_activeFloorIndex = _s_layout.floors[s.activeFloorIndex]) === null || _s_layout_floors_s_activeFloorIndex === void 0 ? void 0 : _s_layout_floors_s_activeFloorIndex.id;
    });
    var walls2 = useFloorplanStore50(function(s) {
        var _s_getActiveDesign;
        return (_s_getActiveDesign = s.getActiveDesign()) === null || _s_getActiveDesign === void 0 ? void 0 : _s_getActiveDesign.walls;
    });
    var _useState42 = _sliced_to_array(useState42(null), 2), cursorPos = _useState42[0], setCursorPos = _useState42[1];
    var _useState421 = _sliced_to_array(useState42(null), 2), snap = _useState421[0], setSnap = _useState421[1];
    useEffect40(function() {
        if (toolMode !== "draw_wall") {
            setCursorPos(null);
            setSnap(null);
        }
    }, [
        toolMode
    ]);
    useLayoutEffect3(function() {
        return function() {
            if (useEditorStore42.getState().wallRun) useEditorStore42.getState().setWallRun(null);
            setCursorPos(null);
            setSnap(null);
        };
    }, [
        activeFloorIndex,
        activeFloorId
    ]);
    useEffect40(function() {
        setSnap(null);
        if (!wallRun) setCursorPos(null);
    }, [
        walls2,
        wallRun
    ]);
    var menuPressRef = useRef38(false);
    var resolvePointer = useCallback21(function(pointer, free) {
        var _useFloorplanStore50_getState_getActiveDesign;
        var raw = pointer.plan();
        if (!raw) return null;
        var _useFloorplanStore50_getState_getActiveDesign_walls;
        var currentWalls = (_useFloorplanStore50_getState_getActiveDesign_walls = (_useFloorplanStore50_getState_getActiveDesign = useFloorplanStore50.getState().getActiveDesign()) === null || _useFloorplanStore50_getState_getActiveDesign === void 0 ? void 0 : _useFloorplanStore50_getState_getActiveDesign.walls) !== null && _useFloorplanStore50_getState_getActiveDesign_walls !== void 0 ? _useFloorplanStore50_getState_getActiveDesign_walls : [];
        var run = useEditorStore42.getState().wallRun;
        var anchor = run ? wallRunCurrent(run, currentWalls) : null;
        return snapWallPoint(raw, wallSnapContextFor(pointer.zoom, currentWalls, {
            free: free,
            anchor: anchor
        }));
    }, []);
    var onClick = useCallback21(function(pointer) {
        var _floorplan_getActiveDesign;
        if (useEditorStore42.getState().toolMode !== "draw_wall") return;
        if (pointer.button !== 0) return;
        if (menuPressRef.current) {
            menuPressRef.current = false;
            return;
        }
        var resolved = resolvePointer(pointer, pointer.shiftKey);
        if (!resolved) return;
        var pos = resolved.point;
        var editor = useEditorStore42.getState();
        var run = editor.wallRun;
        editor.clearSelection();
        if (!run) {
            editor.setWallRun({
                start: pos,
                committed: []
            });
            return;
        }
        var floorplan = useFloorplanStore50.getState();
        var _floorplan_getActiveDesign_walls;
        var currentWalls = (_floorplan_getActiveDesign_walls = (_floorplan_getActiveDesign = floorplan.getActiveDesign()) === null || _floorplan_getActiveDesign === void 0 ? void 0 : _floorplan_getActiveDesign.walls) !== null && _floorplan_getActiveDesign_walls !== void 0 ? _floorplan_getActiveDesign_walls : [];
        var from = wallRunCurrent(run, currentWalls);
        if (distance(from, pos) < MIN_WALL_LENGTH_M) return;
        if (floorplan.layout) editor.pushSnapshot(floorplan.layout);
        var id = newWallId();
        floorplan.addWall({
            id: id,
            // A copy of the previous wall's end, so the shared corner is the same value (R1.6).
            a: {
                x: from.x,
                y: from.y
            },
            b: pos,
            thickness: DEFAULT_THICKNESS,
            openings: []
        });
        editor.markEntityModified(id);
        editor.setWallRun({
            start: run.start,
            committed: _to_consumable_array(wallRunPresentIds2(run, currentWalls)).concat([
                id
            ])
        });
    }, [
        resolvePointer
    ]);
    var onContextMenu = useCallback21(function(pointer) {
        if (useEditorStore42.getState().toolMode !== "draw_wall") return;
        pointer.preventDefault();
        menuPressRef.current = true;
        if (finishWallRun()) setCursorPos(null);
    }, []);
    var onPress = useCallback21(function() {
        menuPressRef.current = false;
    }, []);
    var onLeave = useCallback21(function() {
        setSnap(null);
        setCursorPos(null);
    }, []);
    var onMove = useCallback21(function(pointer) {
        if (useEditorStore42.getState().toolMode !== "draw_wall") return;
        var resolved = resolvePointer(pointer, pointer.shiftKey);
        if (!resolved) return;
        var next = _object_spread_props(_object_spread({}, resolved), {
            scale: pointer.zoom
        });
        setSnap(function(prev) {
            return sameSnap(prev, next) ? prev : next;
        });
        if (useEditorStore42.getState().wallRun) {
            setCursorPos(function(prev) {
                return prev && samePoint2(prev, resolved.point) ? prev : resolved.point;
            });
        }
    }, [
        resolvePointer
    ]);
    return {
        toolMode: toolMode,
        wallRun: wallRun,
        walls: walls2,
        cursorPos: cursorPos,
        snap: snap,
        onClick: onClick,
        onContextMenu: onContextMenu,
        onPress: onPress,
        onLeave: onLeave,
        onMove: onMove
    };
}
// src/components/Planner/canvas/wallsCenter.ts
var wallsCenterOf = function(walls2) {
    if (walls2.length === 0) return null;
    var sx = 0;
    var sy = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = walls2[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var w = _step.value;
            sx += w.a.x + w.b.x;
            sy += w.a.y + w.b.y;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var n = walls2.length * 2;
    return {
        x: sx / n,
        y: sy / n
    };
};
// src/components/Planner/canvas/planDriverMarks.ts
import { useLayoutEffect as useLayoutEffect4 } from "react";
var createPlanDriverMarkStore = function() {
    var byId = /* @__PURE__ */ new Map();
    var snapshot = [];
    var rebuild = function() {
        snapshot = Array.from(byId.values()).flat();
    };
    return {
        set: function(id, marks) {
            byId.set(id, marks);
            rebuild();
        },
        remove: function(id) {
            if (byId.delete(id)) rebuild();
        },
        getSnapshot: function() {
            return snapshot;
        }
    };
};
var wallSnapMarks = function(snap, walls2) {
    var wall = function(index) {
        var w = walls2[index];
        return w ? [
            {
                kind: "snap-wall",
                x: (w.a.x + w.b.x) / 2,
                y: (w.a.y + w.b.y) / 2,
                wallIndex: index
            }
        ] : [];
    };
    var at3 = function(kind, p) {
        return {
            kind: kind,
            x: p.x,
            y: p.y
        };
    };
    var guide = function(from, axis) {
        return {
            kind: "snap-guide",
            x: from.x,
            y: from.y,
            axis: axis
        };
    };
    switch(snap.kind){
        case "corner":
            return [
                at3("snap-corner", snap.at)
            ];
        case "wall":
            return _to_consumable_array(wall(snap.wallIndex)).concat([
                at3("snap-dot", snap.at)
            ]);
        case "axis":
            return [
                guide(snap.from, snap.axis)
            ];
        case "axis-wall":
            return [
                guide(snap.from, snap.axis)
            ].concat(_to_consumable_array(wall(snap.wallIndex)), [
                at3("snap-dot", snap.at)
            ]);
        default:
            return [];
    }
};
var usePublishWallSnap = function(store, id, snap, walls2) {
    useLayoutEffect4(function() {
        if (!store) return;
        if (snap) store.set(id, wallSnapMarks(snap, walls2));
        else store.remove(id);
    }, [
        store,
        id,
        snap,
        walls2
    ]);
    useLayoutEffect4(function() {
        return function() {
            return store === null || store === void 0 ? void 0 : store.remove(id);
        };
    }, [
        store,
        id
    ]);
};
// src/components/Planner/wallCommits.ts
import { useEditorStore as useEditorStore43, useFloorplanStore as useFloorplanStore51 } from "@repo/front-end-state";
import { jointEndsAt } from "@repo/front-end-utils";
var wallEndJoint = function(walls2, id, end) {
    var pressed = walls2.find(function(wall) {
        return wall.id === id;
    });
    if (!pressed) return [
        {
            id: id,
            end: end
        }
    ];
    var joint = jointEndsAt(walls2, pressed[end]).flatMap(function(e) {
        var wallId = walls2[e.index].id;
        return wallId === void 0 ? [] : [
            {
                id: wallId,
                end: e.end
            }
        ];
    }).filter(function(e) {
        return e.id !== id || e.end === end;
    });
    if (!joint.some(function(e) {
        return e.id === id && e.end === end;
    })) joint.push({
        id: id,
        end: end
    });
    return joint;
};
var commitWallEndMove = function(joint, from, to) {
    if (to.x === from.x && to.y === from.y) return false;
    var editor = useEditorStore43.getState();
    var floorplan = useFloorplanStore51.getState();
    if (floorplan.layout) editor.pushSnapshot(floorplan.layout);
    new Set(joint.map(function(e) {
        return e.id;
    })).forEach(function(id) {
        return editor.markEntityModified(id);
    });
    floorplan.moveWallEnds(joint, to);
    return true;
};
// src/components/Planner/drawTools/usePolygonDraw.ts
import { useState as useState43, useCallback as useCallback22, useEffect as useEffect41, useRef as useRef40 } from "react";
import { kindOfNewSpace, metersToPixels as metersToPixels2, newClientId, snapPlannerPoint as snapPlannerPoint3 } from "@repo/front-end-utils";
import { useFloorplanStore as useFloorplanStore52 } from "@repo/front-end-state";
import { useEditorStore as useEditorStore44 } from "@repo/front-end-state";
import { filedByDrawing, nameForNewcomer as nameForNewcomer3 } from "@repo/front-end-utils";
// src/components/Planner/canvas/DrawRefusalBanner.tsx
import { useRef as useRef39 } from "react";
import { Banner as Banner3 } from "@repo/design-system";
import { jsx as jsx50 } from "react/jsx-runtime";
var DRAW_INSIDE_AREA_REFUSAL = "Areas can't hold other spaces. Draw this inside a zone or a section, or on the floor.";
function DrawRefusalBanner(param) {
    var message = param.message, onDismiss = param.onDismiss, onReturnFocus = param.onReturnFocus;
    var heldFocus = useRef39(false);
    if (!message) return null;
    return /* @__PURE__ */ jsx50("div", {
        onFocus: function() {
            heldFocus.current = true;
        },
        onBlur: function() {
            heldFocus.current = false;
        },
        children: /* @__PURE__ */ jsx50(Banner3, {
            tone: "error",
            surface: "on-solid",
            role: "alert",
            title: "Nothing was drawn",
            onDismiss: function() {
                var returnFocus = heldFocus.current;
                heldFocus.current = false;
                onDismiss();
                if (returnFocus) onReturnFocus === null || onReturnFocus === void 0 ? void 0 : onReturnFocus();
            },
            dismissLabel: "Dismiss this message",
            children: message
        })
    });
}
// src/components/Planner/drawTools/usePolygonDraw.ts
var CLOSE_THRESHOLD_PX = 12;
var NEW_SPACE_NAME = {
    zone: "New Zone",
    section: "New Section",
    area: "New Area"
};
function usePolygonDraw() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, onRefuse = _ref.onRefuse, onDrawn = _ref.onDrawn;
    var toolMode = useEditorStore44(function(s) {
        return s.toolMode;
    });
    var setToolMode = useEditorStore44(function(s) {
        return s.setToolMode;
    });
    var gridSnap = useEditorStore44(function(s) {
        return s.gridSnap;
    });
    var gridSize = useEditorStore44(function(s) {
        return s.gridSize;
    });
    var pushSnapshot = useEditorStore44(function(s) {
        return s.pushSnapshot;
    });
    var markEntityModified = useEditorStore44(function(s) {
        return s.markEntityModified;
    });
    var selectEntity = useEditorStore44(function(s) {
        return s.selectEntity;
    });
    var addSurface = useFloorplanStore52(function(s) {
        return s.addSurface;
    });
    var _useState43 = _sliced_to_array(useState43([]), 2), points = _useState43[0], setPoints = _useState43[1];
    var _useState431 = _sliced_to_array(useState43(null), 2), cursorPos = _useState431[0], setCursorPos = _useState431[1];
    var isPolyMode = toolMode === "draw_space";
    useEffect41(function() {
        if (!isPolyMode) {
            setPoints([]);
            setCursorPos(null);
        }
    }, [
        isPolyMode
    ]);
    var getWorldPos = useCallback22(/** `free` is Shift held on the event asking — it leaves the point off the grid. */ function(pointer, free) {
        var raw = pointer.plan();
        if (!raw) return null;
        return snapPlannerPoint3(raw, {
            gridSnap: gridSnap,
            gridSizeCm: gridSize,
            free: free
        });
    }, [
        gridSnap,
        gridSize
    ]);
    var lastFinished = useRef40(null);
    var finishPolygon = useCallback22(function(finalPoints) {
        if (finalPoints.length < 3) return;
        if (lastFinished.current === finalPoints) return;
        lastFinished.current = finalPoints;
        var design = useFloorplanStore52.getState().getActiveDesign();
        var kind = kindOfNewSpace(design, finalPoints);
        if (kind === null) {
            onRefuse === null || onRefuse === void 0 ? void 0 : onRefuse(DRAW_INSIDE_AREA_REFUSAL);
            setPoints([]);
            setCursorPos(null);
            return;
        }
        onRefuse === null || onRefuse === void 0 ? void 0 : onRefuse(null);
        var newcomer = nameForNewcomer3(NEW_SPACE_NAME[kind], "space", currentTwinNameIndex());
        applyHolderRename(newcomer.renameHolder);
        var layout = useFloorplanStore52.getState().layout;
        if (layout) pushSnapshot(layout);
        var refid = newClientId({
            uuidPrefix: "space-",
            fallbackPrefix: "space-"
        });
        var before = onDrawn ? useFloorplanStore52.getState().getActiveDesign() : null;
        addSurface({
            refid: refid,
            name: newcomer.name,
            customName: "",
            poly: finalPoints
        });
        markEntityModified(refid);
        selectEntity(refid);
        setPoints([]);
        setCursorPos(null);
        setToolMode("select");
        if (onDrawn) {
            var _plan_layout_floors_plan_activeFloorIndex, _plan_layout;
            var plan = useFloorplanStore52.getState();
            var after = plan.getActiveDesign();
            var floorId = (_plan_layout = plan.layout) === null || _plan_layout === void 0 ? void 0 : (_plan_layout_floors_plan_activeFloorIndex = _plan_layout.floors[plan.activeFloorIndex]) === null || _plan_layout_floors_plan_activeFloorIndex === void 0 ? void 0 : _plan_layout_floors_plan_activeFloorIndex.id;
            onDrawn({
                refid: refid,
                floorId: typeof floorId === "number" ? floorId : null,
                filed: filedByDrawing(before, after, refid)
            });
        }
    }, [
        addSurface,
        pushSnapshot,
        markEntityModified,
        selectEntity,
        setToolMode,
        onRefuse,
        onDrawn
    ]);
    var onClick = useCallback22(function(pointer) {
        if (!isPolyMode) return;
        var pos = getWorldPos(pointer, pointer.shiftKey);
        if (!pos) return;
        if (points.length >= 3) {
            var firstPx = {
                x: metersToPixels2(points[0].x),
                y: metersToPixels2(points[0].y)
            };
            var clickPx = {
                x: metersToPixels2(pos.x),
                y: metersToPixels2(pos.y)
            };
            var dist = Math.sqrt(Math.pow(clickPx.x - firstPx.x, 2) + Math.pow(clickPx.y - firstPx.y, 2));
            if (dist < CLOSE_THRESHOLD_PX) {
                finishPolygon(points);
                return;
            }
        }
        var last = points[points.length - 1];
        if (last && last.x === pos.x && last.y === pos.y) return;
        if (points.length === 0) onRefuse === null || onRefuse === void 0 ? void 0 : onRefuse(null);
        setPoints(function(prev) {
            return _to_consumable_array(prev).concat([
                pos
            ]);
        });
    }, [
        isPolyMode,
        getWorldPos,
        points,
        finishPolygon,
        onRefuse
    ]);
    var onDoubleClick = useCallback22(function() {
        if (!isPolyMode) return;
        if (points.length >= 3) {
            finishPolygon(points);
        }
    }, [
        isPolyMode,
        points,
        finishPolygon
    ]);
    var onMove = useCallback22(function(pointer) {
        if (!isPolyMode || points.length === 0) return;
        var pos = getWorldPos(pointer, pointer.shiftKey);
        if (pos) setCursorPos(pos);
    }, [
        isPolyMode,
        points.length,
        getWorldPos
    ]);
    return {
        isPolyMode: isPolyMode,
        points: points,
        cursorPos: cursorPos,
        onClick: onClick,
        onDoubleClick: onDoubleClick,
        onMove: onMove
    };
}
// src/components/Planner/canvas/insertCorner.ts
import { useEditorStore as useEditorStore45, useFloorplanStore as useFloorplanStore53 } from "@repo/front-end-state";
var insertCornerAtMidpoint = function(surface11, afterIndex) {
    if (afterIndex < 0 || afterIndex >= surface11.poly.length) return false;
    var _useFloorplanStore53_getState = useFloorplanStore53.getState(), layout = _useFloorplanStore53_getState.layout, updateSurface = _useFloorplanStore53_getState.updateSurface;
    var editor = useEditorStore45.getState();
    if (layout) editor.pushSnapshot(layout);
    var a = surface11.poly[afterIndex];
    var b = surface11.poly[(afterIndex + 1) % surface11.poly.length];
    var midpoint = {
        x: (a.x + b.x) / 2,
        y: (a.y + b.y) / 2
    };
    var newPoly = _to_consumable_array(surface11.poly);
    newPoly.splice(afterIndex + 1, 0, midpoint);
    updateSurface(surface11.refid, {
        poly: newPoly
    });
    editor.markEntityModified(surface11.refid);
    return true;
};
// src/components/Planner/spaceCommits.ts
import { useEditorStore as useEditorStore46, useFloorplanStore as useFloorplanStore54 } from "@repo/front-end-state";
var samePoly = function(a, b) {
    return a.length === b.length && a.every(function(p, i) {
        return p.x === b[i].x && p.y === b[i].y;
    });
};
var latestStep = function() {
    var stack = useEditorStore46.getState().undoStack;
    return stack[stack.length - 1];
};
var commitSpaceCornerMove = function(param) {
    var refid = param.refid, store = param.store, startDesign = param.startDesign, floorIndex = param.floorIndex, startPoly = param.startPoly, poly = param.poly;
    var ended = {
        refid: refid,
        floorIndex: floorIndex,
        startDesign: startDesign,
        gesture: "corner"
    };
    if (samePoly(startPoly, poly)) {
        store === null || store === void 0 ? void 0 : store.end(_object_spread_props(_object_spread({}, ended), {
            committed: false
        }));
        return false;
    }
    var editor = useEditorStore46.getState();
    var floorplan = useFloorplanStore54.getState();
    if (floorplan.layout) editor.pushSnapshot(floorplan.layout);
    var step = latestStep();
    floorplan.updateSurface(refid, {
        poly: poly
    });
    editor.markEntityModified(refid);
    store === null || store === void 0 ? void 0 : store.end(_object_spread_props(_object_spread({}, ended), {
        committed: true,
        step: step
    }));
    return true;
};
var removeSpaceCorner = function(surface11, index, store) {
    if (store === null || store === void 0 ? void 0 : store.getSnapshot()) return false;
    if (surface11.poly.length <= 3) return false;
    if (index < 0 || index >= surface11.poly.length) return false;
    var editor = useEditorStore46.getState();
    var floorplan = useFloorplanStore54.getState();
    if (floorplan.layout) editor.pushSnapshot(floorplan.layout);
    var startDesign = floorplan.getActiveDesign();
    var step = latestStep();
    floorplan.updateSurface(surface11.refid, {
        poly: surface11.poly.filter(function(_, i) {
            return i !== index;
        })
    });
    editor.markEntityModified(surface11.refid);
    if (store && startDesign) {
        store.end({
            refid: surface11.refid,
            floorIndex: floorplan.activeFloorIndex,
            startDesign: startDesign,
            gesture: "corner",
            committed: true,
            step: step
        });
    }
    return true;
};
// src/components/Planner/gestures/edgeDrag.ts
import { useEditorStore as useEditorStore47, useFloorplanStore as useFloorplanStore55 } from "@repo/front-end-state";
import { snapPlannerDistance } from "@repo/front-end-utils";
// src/components/Planner/reshape/edgeGeometry.ts
var MIN_SPACE_AREA_M2 = 0.01;
var signedArea = function(poly) {
    var twice = 0;
    for(var i = 0; i < poly.length; i++){
        var a = poly[i];
        var b = poly[(i + 1) % poly.length];
        twice += a.x * b.y - b.x * a.y;
    }
    return twice / 2;
};
var edgeNormal = function(poly, i) {
    var a = poly[i];
    var b = poly[(i + 1) % poly.length];
    var dx = b.x - a.x;
    var dy = b.y - a.y;
    var length = Math.hypot(dx, dy);
    if (!(length > 0)) return null;
    var sign = signedArea(poly) >= 0 ? 1 : -1;
    return {
        x: sign * dy / length + 0,
        y: sign * -dx / length + 0
    };
};
var projectOnNormal = function(delta, normal) {
    return delta.x * normal.x + delta.y * normal.y;
};
var cross = function(o, a, b) {
    return (a.x - o.x) * (b.y - o.y) - (a.y - o.y) * (b.x - o.x);
};
var onSegment = function(p, q, r) {
    return Math.min(p.x, r.x) <= q.x && q.x <= Math.max(p.x, r.x) && Math.min(p.y, r.y) <= q.y && q.y <= Math.max(p.y, r.y);
};
var segmentsMeet = function(p1, p2, q1, q2) {
    var d1 = cross(q1, q2, p1);
    var d2 = cross(q1, q2, p2);
    var d3 = cross(p1, p2, q1);
    var d4 = cross(p1, p2, q2);
    if ((d1 > 0 && d2 < 0 || d1 < 0 && d2 > 0) && (d3 > 0 && d4 < 0 || d3 < 0 && d4 > 0)) {
        return true;
    }
    return d1 === 0 && onSegment(q1, p1, q2) || d2 === 0 && onSegment(q1, p2, q2) || d3 === 0 && onSegment(p1, q1, p2) || d4 === 0 && onSegment(p1, q2, p2);
};
var selfIntersects = function(poly) {
    var n = poly.length;
    for(var i = 0; i < n; i++){
        for(var j = i + 1; j < n; j++){
            if (j === i + 1 || i === 0 && j === n - 1) continue;
            if (segmentsMeet(poly[i], poly[(i + 1) % n], poly[j], poly[(j + 1) % n])) return true;
        }
    }
    return false;
};
var tidy = function(metres) {
    var v = Math.round(metres * 1e6) / 1e6;
    return v === 0 ? 0 : v;
};
var moveEdge = function(poly, i, d) {
    var normal = edgeNormal(poly, i);
    if (!normal || poly.length < 3) return {
        ok: false
    };
    var j = (i + 1) % poly.length;
    var next = poly.map(function(p, k) {
        return k === i || k === j ? {
            x: tidy(p.x + normal.x * d),
            y: tidy(p.y + normal.y * d)
        } : p;
    });
    if (selfIntersects(next)) return {
        ok: false
    };
    if (Math.abs(signedArea(next)) < MIN_SPACE_AREA_M2) return {
        ok: false
    };
    if (Math.sign(signedArea(next)) !== Math.sign(signedArea(poly))) return {
        ok: false
    };
    return {
        ok: true,
        poly: next
    };
};
// src/components/Planner/gestures/edgeDrag.ts
function startPaneEdgeDrag(param) {
    var store = param.store, native = param.native, pane = param.pane, claimClick = param.claimClick, toPlan = param.toPlan, refid = param.refid, edgeIndex = param.edgeIndex, cursor = param.cursor;
    var plan = useFloorplanStore55.getState();
    var design = plan.getActiveDesign();
    var surface11 = design === null || design === void 0 ? void 0 : design.surfaces.find(function(s) {
        return s.refid === refid && !s._deleted;
    });
    if (!design || !surface11) return null;
    var startPoly = surface11.poly;
    var normal = edgeNormal(startPoly, edgeIndex);
    if (!normal) return null;
    var pressPointer = pane.pointAt(native);
    if (!pressPointer) return null;
    var pressAt = toPlan(pressPointer);
    var floorIndex = plan.activeFloorIndex;
    var latest = startPoly;
    var lastD = 0;
    var base2 = {
        refid: refid,
        floorIndex: floorIndex,
        startDesign: design,
        startPoly: startPoly,
        gesture: "edge"
    };
    store.set(_object_spread_props(_object_spread({}, base2), {
        latestPoly: startPoly,
        edge: {
            index: edgeIndex,
            d: 0,
            snapped: false,
            limited: false,
            pointer: pressPointer
        }
    }));
    var done = false;
    var finish2 = function(committed) {
        var cancelled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, step = arguments.length > 2 ? arguments[2] : void 0;
        if (done) return;
        done = true;
        store.end(_object_spread(_object_spread_props(_object_spread({}, base2), {
            committed: committed
        }), cancelled ? {
            cancelled: cancelled
        } : {}, step !== void 0 ? {
            step: step
        } : {}));
    };
    var stillThere = function() {
        var _now_getActiveDesign;
        var now = useFloorplanStore55.getState();
        if (now.activeFloorIndex !== floorIndex) return false;
        var live = (_now_getActiveDesign = now.getActiveDesign()) === null || _now_getActiveDesign === void 0 ? void 0 : _now_getActiveDesign.surfaces.find(function(s) {
            return s.refid === refid && !s._deleted;
        });
        return !!live && live.poly === startPoly;
    };
    var warned = false;
    var gone = function() {
        if (!warned) {
            warned = true;
            console.warn("[reshape] layout gone mid-gesture", {
                refid: refid
            });
        }
        stopGesture();
        finish2(false, true);
    };
    var stopGesture = startPaneGesture({
        native: native,
        pane: pane,
        claimClick: claimClick,
        cursor: cursor,
        onMove: function(pointer, evt) {
            if (!stillThere()) {
                gone();
                return false;
            }
            var at3 = toPlan(pointer);
            var raw = projectOnNormal({
                x: at3.x - pressAt.x,
                y: at3.y - pressAt.y
            }, normal);
            var _useEditorStore47_getState = useEditorStore47.getState(), gridSnap = _useEditorStore47_getState.gridSnap, gridSize = _useEditorStore47_getState.gridSize;
            var free = !!evt.shiftKey;
            var d = snapPlannerDistance(raw, {
                gridSnap: gridSnap,
                gridSizeCm: gridSize,
                free: free
            });
            var snapped = !free && gridSnap && gridSize > 0;
            var previous = lastD;
            var limited = false;
            if (d === 0) {
                latest = startPoly;
                lastD = 0;
            } else {
                var moved = moveEdge(startPoly, edgeIndex, d);
                if (moved.ok) {
                    latest = moved.poly;
                    lastD = d;
                } else {
                    limited = true;
                }
            }
            store.set(_object_spread_props(_object_spread({}, base2), {
                latestPoly: latest,
                edge: {
                    index: edgeIndex,
                    d: lastD,
                    snapped: snapped,
                    limited: limited,
                    pointer: pointer
                }
            }));
            return lastD !== previous;
        },
        onRelease: function() {
            if (lastD === 0) {
                finish2(false);
                return;
            }
            if (!stillThere()) {
                gone();
                return;
            }
            var layout = useFloorplanStore55.getState().layout;
            var editor = useEditorStore47.getState();
            if (layout) editor.pushSnapshot(layout);
            var stack = useEditorStore47.getState().undoStack;
            useFloorplanStore55.getState().updateSurface(refid, {
                poly: latest
            });
            editor.markEntityModified(refid);
            finish2(true, false, stack[stack.length - 1]);
        },
        onCancel: function() {
            return finish2(false, true);
        }
    });
    return function() {
        if (done) return;
        stopGesture();
        finish2(false, true);
    };
}
// src/components/Planner/reshape/platform.ts
var isApplePlatform = function() {
    var _nav_userAgentData;
    if (typeof navigator === "undefined") return false;
    var nav = navigator;
    var platform = ((_nav_userAgentData = nav.userAgentData) === null || _nav_userAgentData === void 0 ? void 0 : _nav_userAgentData.platform) || nav.platform || "";
    return /mac|iphone|ipad|ipod/i.test(platform);
};
var reshapeModifierHeld = function(evt) {
    return isApplePlatform() ? evt.metaKey : evt.ctrlKey;
};
var reshapeModifierName = function() {
    return isApplePlatform() ? "Cmd" : "Ctrl";
};
var isReshapeModifierKey = function(key) {
    return key === (isApplePlatform() ? "Meta" : "Control");
};
// src/components/Planner/reshape/edgeCursorFor.ts
var edgeCursorFor = function(poly, index, rotationDeg) {
    var normal = edgeNormal(poly, index);
    if (!normal) return null;
    var sx = normal.x;
    var sy = -normal.y;
    var rad = rotationDeg * Math.PI / 180;
    var x = sx * Math.cos(rad) - sy * Math.sin(rad);
    var y = sx * Math.sin(rad) + sy * Math.cos(rad);
    var deg = (Math.atan2(y, x) * 180 / Math.PI % 180 + 180) % 180;
    if (deg < 22.5 || deg >= 157.5) return "ew-resize";
    if (deg < 67.5) return "nwse-resize";
    if (deg < 112.5) return "ns-resize";
    return "nesw-resize";
};
// src/components/Planner/canvas/planEntityLooks.ts
var combineEntityMarks = function(host, model) {
    if (!host) return model;
    if (!model) return host;
    var _host_machines, _host_spaces, _host_lit, _host_searchMatched, _host_identifying, _host_jumped, _host_arrived, _host_drawn, _host_changes;
    return {
        machines: (_host_machines = host.machines) !== null && _host_machines !== void 0 ? _host_machines : model.machines,
        spaces: (_host_spaces = host.spaces) !== null && _host_spaces !== void 0 ? _host_spaces : model.spaces,
        lit: (_host_lit = host.lit) !== null && _host_lit !== void 0 ? _host_lit : model.lit,
        searchMatched: (_host_searchMatched = host.searchMatched) !== null && _host_searchMatched !== void 0 ? _host_searchMatched : model.searchMatched,
        identifying: (_host_identifying = host.identifying) !== null && _host_identifying !== void 0 ? _host_identifying : model.identifying,
        jumped: (_host_jumped = host.jumped) !== null && _host_jumped !== void 0 ? _host_jumped : model.jumped,
        arrived: (_host_arrived = host.arrived) !== null && _host_arrived !== void 0 ? _host_arrived : model.arrived,
        drawn: (_host_drawn = host.drawn) !== null && _host_drawn !== void 0 ? _host_drawn : model.drawn,
        changes: (_host_changes = host.changes) !== null && _host_changes !== void 0 ? _host_changes : model.changes
    };
};
var withDeletePreview = function(marks, preview) {
    if (!preview) return marks;
    var _marks_moving;
    var moving = new Set((_marks_moving = marks === null || marks === void 0 ? void 0 : marks.moving) !== null && _marks_moving !== void 0 ? _marks_moving : []);
    preview.changing.forEach(function(id) {
        return moving.add(id);
    });
    return _object_spread_props(_object_spread({}, marks), {
        moving: moving,
        deleting: new Set(preview.deleting)
    });
};
var EMPTY3 = /* @__PURE__ */ new Set();
var FAINT_FLOOR_OPACITY = 0.3;
var ALIGN_LOOK_CONTEXT = {
    selected: /* @__PURE__ */ new Set(),
    hovered: null,
    marks: void 0,
    glowing: /* @__PURE__ */ new Set()
};
var spaceLook = function(id, ctx) {
    var _ctx_marks, _ctx_marks1, _ctx_marks2, _ctx_marks_spaces, _ctx_marks3;
    if (ctx.faint) return "faint";
    var _ctx_marks_deleting;
    if (((_ctx_marks_deleting = (_ctx_marks = ctx.marks) === null || _ctx_marks === void 0 ? void 0 : _ctx_marks.deleting) !== null && _ctx_marks_deleting !== void 0 ? _ctx_marks_deleting : EMPTY3).has(id)) return "error";
    if (ctx.selected.has(id)) return "selected";
    var _ctx_marks_moving;
    if (((_ctx_marks_moving = (_ctx_marks1 = ctx.marks) === null || _ctx_marks1 === void 0 ? void 0 : _ctx_marks1.moving) !== null && _ctx_marks_moving !== void 0 ? _ctx_marks_moving : EMPTY3).has(id)) return "check";
    var _ctx_marks_drawn;
    var drawn = (_ctx_marks_drawn = (_ctx_marks2 = ctx.marks) === null || _ctx_marks2 === void 0 ? void 0 : _ctx_marks2.drawn) !== null && _ctx_marks_drawn !== void 0 ? _ctx_marks_drawn : EMPTY3;
    if (drawn.has(id) && ctx.glowing.has(id)) return "mint";
    var _ctx_marks_spaces_get;
    return (_ctx_marks_spaces_get = (_ctx_marks3 = ctx.marks) === null || _ctx_marks3 === void 0 ? void 0 : (_ctx_marks_spaces = _ctx_marks3.spaces) === null || _ctx_marks_spaces === void 0 ? void 0 : _ctx_marks_spaces.get(id)) !== null && _ctx_marks_spaces_get !== void 0 ? _ctx_marks_spaces_get : "neutral";
};
var isSelected = function(id, ctx) {
    var _ctx_marks, _ctx_marks1;
    var _ctx_marks_searchMatched, _ctx_marks_lit;
    return ctx.selected.has(id) || ((_ctx_marks_searchMatched = (_ctx_marks = ctx.marks) === null || _ctx_marks === void 0 ? void 0 : _ctx_marks.searchMatched) !== null && _ctx_marks_searchMatched !== void 0 ? _ctx_marks_searchMatched : EMPTY3).has(id) || ((_ctx_marks_lit = (_ctx_marks1 = ctx.marks) === null || _ctx_marks1 === void 0 ? void 0 : _ctx_marks1.lit) !== null && _ctx_marks_lit !== void 0 ? _ctx_marks_lit : EMPTY3).has(id);
};
var planSpaceAppearance = function(id, ctx) {
    var _ctx_marks_changes, _ctx_marks, _ctx_marks1;
    if (ctx.faint) {
        return {
            status: "faint",
            selected: false,
            hovered: false,
            glowing: false,
            change: null
        };
    }
    var _ctx_marks_changes_get;
    var change = (_ctx_marks_changes_get = (_ctx_marks = ctx.marks) === null || _ctx_marks === void 0 ? void 0 : (_ctx_marks_changes = _ctx_marks.changes) === null || _ctx_marks_changes === void 0 ? void 0 : _ctx_marks_changes.get(id)) !== null && _ctx_marks_changes_get !== void 0 ? _ctx_marks_changes_get : null;
    var status = function() {
        var _ctx_marks, _ctx_marks1, _ctx_marks_spaces, _ctx_marks2, _ctx_marks3;
        var _ctx_marks_deleting;
        if (((_ctx_marks_deleting = (_ctx_marks = ctx.marks) === null || _ctx_marks === void 0 ? void 0 : _ctx_marks.deleting) !== null && _ctx_marks_deleting !== void 0 ? _ctx_marks_deleting : EMPTY3).has(id)) return "deadEnd";
        var _ctx_marks_moving;
        if (((_ctx_marks_moving = (_ctx_marks1 = ctx.marks) === null || _ctx_marks1 === void 0 ? void 0 : _ctx_marks1.moving) !== null && _ctx_marks_moving !== void 0 ? _ctx_marks_moving : EMPTY3).has(id)) return "beingEdited";
        if ((_ctx_marks2 = ctx.marks) === null || _ctx_marks2 === void 0 ? void 0 : (_ctx_marks_spaces = _ctx_marks2.spaces) === null || _ctx_marks_spaces === void 0 ? void 0 : _ctx_marks_spaces.has(id)) return "problem";
        var _ctx_marks_drawn;
        if (((_ctx_marks_drawn = (_ctx_marks3 = ctx.marks) === null || _ctx_marks3 === void 0 ? void 0 : _ctx_marks3.drawn) !== null && _ctx_marks_drawn !== void 0 ? _ctx_marks_drawn : EMPTY3).has(id) && ctx.glowing.has(id) || change) {
            return "justChanged";
        }
        return "neutral";
    }();
    var selected2 = isSelected(id, ctx);
    var _ctx_marks_jumped;
    return {
        status: status,
        selected: selected2,
        hovered: !selected2 && ctx.hovered === id,
        glowing: ((_ctx_marks_jumped = (_ctx_marks1 = ctx.marks) === null || _ctx_marks1 === void 0 ? void 0 : _ctx_marks1.jumped) !== null && _ctx_marks_jumped !== void 0 ? _ctx_marks_jumped : EMPTY3).has(id) && ctx.glowing.has(id),
        change: change
    };
};
var MACHINE_PROBLEMS = /* @__PURE__ */ new Set([
    "error",
    "check",
    "identify"
]);
var planMachineAppearance = function(id, ctx) {
    var _ctx_marks_changes, _ctx_marks, _ctx_marks1, _ctx_marks2;
    var _ctx_marks_changes_get;
    var change = (_ctx_marks_changes_get = (_ctx_marks = ctx.marks) === null || _ctx_marks === void 0 ? void 0 : (_ctx_marks_changes = _ctx_marks.changes) === null || _ctx_marks_changes === void 0 ? void 0 : _ctx_marks_changes.get(id)) !== null && _ctx_marks_changes_get !== void 0 ? _ctx_marks_changes_get : null;
    var status = function() {
        var _ctx_marks, _ctx_marks1, _ctx_marks_machines, _ctx_marks2;
        var _ctx_marks_moving, _ctx_marks_identifying;
        if (((_ctx_marks_moving = (_ctx_marks = ctx.marks) === null || _ctx_marks === void 0 ? void 0 : _ctx_marks.moving) !== null && _ctx_marks_moving !== void 0 ? _ctx_marks_moving : EMPTY3).has(id) || ((_ctx_marks_identifying = (_ctx_marks1 = ctx.marks) === null || _ctx_marks1 === void 0 ? void 0 : _ctx_marks1.identifying) !== null && _ctx_marks_identifying !== void 0 ? _ctx_marks_identifying : EMPTY3).has(id)) {
            return "beingEdited";
        }
        var state = (_ctx_marks2 = ctx.marks) === null || _ctx_marks2 === void 0 ? void 0 : (_ctx_marks_machines = _ctx_marks2.machines) === null || _ctx_marks_machines === void 0 ? void 0 : _ctx_marks_machines.get(id);
        if (state !== void 0 && MACHINE_PROBLEMS.has(state)) return "problem";
        if (change) return "justChanged";
        return "neutral";
    }();
    var selected2 = isSelected(id, ctx);
    var _ctx_marks_arrived, _ctx_marks_jumped;
    var arrivedOrJumped = ((_ctx_marks_arrived = (_ctx_marks1 = ctx.marks) === null || _ctx_marks1 === void 0 ? void 0 : _ctx_marks1.arrived) !== null && _ctx_marks_arrived !== void 0 ? _ctx_marks_arrived : EMPTY3).has(id) || ((_ctx_marks_jumped = (_ctx_marks2 = ctx.marks) === null || _ctx_marks2 === void 0 ? void 0 : _ctx_marks2.jumped) !== null && _ctx_marks_jumped !== void 0 ? _ctx_marks_jumped : EMPTY3).has(id);
    return {
        status: status,
        selected: selected2,
        hovered: !selected2 && ctx.hovered === id,
        glowing: arrivedOrJumped && ctx.glowing.has(id),
        change: change
    };
};
var TAGGED_LOOKS = /* @__PURE__ */ new Set([
    "error",
    "check",
    "mint"
]);
var showsNameTag = function(id, look, ctx) {
    var _ctx_marks, _ctx_marks1;
    if (look === "faint" || look === "drawing") return false;
    if (TAGGED_LOOKS.has(look)) return true;
    var _ctx_marks_lit, _ctx_marks_searchMatched;
    return ctx.hovered === id || ((_ctx_marks_lit = (_ctx_marks = ctx.marks) === null || _ctx_marks === void 0 ? void 0 : _ctx_marks.lit) !== null && _ctx_marks_lit !== void 0 ? _ctx_marks_lit : EMPTY3).has(id) || ((_ctx_marks_searchMatched = (_ctx_marks1 = ctx.marks) === null || _ctx_marks1 === void 0 ? void 0 : _ctx_marks1.searchMatched) !== null && _ctx_marks_searchMatched !== void 0 ? _ctx_marks_searchMatched : EMPTY3).has(id);
};
var nameTagCode = function(entityCode) {
    var code = entityCode === null || entityCode === void 0 ? void 0 : entityCode.trim();
    return code ? code.slice(-4) : null;
};
// src/components/Planner/plannerCanvas/usePlannerCanvasModel.ts
import { useRef as useRef42, useCallback as useCallback23, useContext as useContext17, useMemo as useMemo26, useState as useState46, useEffect as useEffect46, useLayoutEffect as useLayoutEffect7 } from "react";
import { EDITOR_MAX_ZOOM, EDITOR_MIN_ZOOM, useEditorStore as useEditorStore49, selectionOnFloorShown as selectionOnFloorShown10 } from "@repo/front-end-state";
import { useFloorplanStore as useFloorplanStore56 } from "@repo/front-end-state";
import { cameraDisplayName as cameraDisplayName2, centreViewOn, drawnUnderlaysInOrder, entitiesWorldBounds, entityWorldCentre as entityWorldCentre2, findLatestDesign as findLatestDesign19, fitViewToBounds as fitViewToBounds2, pixelsToMeters as pixelsToMeters3, placementOf as placementOf5, planDrawingOutline, planScrollBounds, planScrollBoundsForDesigns, scrollPlanByKey, snapPlannerPoint as snapPlannerPoint4, visibleFloors } from "@repo/front-end-utils";
// src/components/Planner/hooks/usePlanEntitySettle.ts
import { useEffect as useEffect42, useRef as useRef41, useState as useState44 } from "react";
var NONE2 = /* @__PURE__ */ new Set();
var usePlanEntitySettle = function(arrived, drawn, jumped) {
    var durationMs = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ARRIVED_MS;
    var _useState44 = _sliced_to_array(useState44(NONE2), 2), glowing = _useState44[0], setGlowing = _useState44[1];
    var seen = useRef41(/* @__PURE__ */ new Map());
    var lastJumped = useRef41(void 0);
    var lastSteady = useRef41(NONE2);
    useEffect42(function() {
        var steady = /* @__PURE__ */ new Set();
        (arrived !== null && arrived !== void 0 ? arrived : NONE2).forEach(function(id) {
            return steady.add(id);
        });
        (drawn !== null && drawn !== void 0 ? drawn : NONE2).forEach(function(id) {
            return steady.add(id);
        });
        var present = new Set(steady);
        (jumped !== null && jumped !== void 0 ? jumped : NONE2).forEach(function(id) {
            return present.add(id);
        });
        var steadyBefore = lastSteady.current;
        lastSteady.current = steady;
        var newPick = jumped !== lastJumped.current ? jumped : void 0;
        lastJumped.current = jumped;
        var entered = [];
        var left = [];
        present.forEach(function(id) {
            var newlySteady = steady.has(id) && !steadyBefore.has(id);
            if (!seen.current.has(id) || (newPick === null || newPick === void 0 ? void 0 : newPick.has(id)) || newlySteady) entered.push(id);
        });
        seen.current.forEach(function(_timer, id) {
            if (!present.has(id)) left.push(id);
        });
        if (entered.length === 0 && left.length === 0) return;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = left[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var id = _step.value;
                clearTimeout(seen.current.get(id));
                seen.current.delete(id);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            var _loop = function() {
                var id = _step1.value;
                clearTimeout(seen.current.get(id));
                seen.current.set(id, setTimeout(function() {
                    setGlowing(function(prev) {
                        if (!prev.has(id)) return prev;
                        var next = new Set(prev);
                        next.delete(id);
                        return next;
                    });
                }, durationMs));
            };
            for(var _iterator1 = entered[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_loop();
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        setGlowing(function(prev) {
            var next = new Set(prev);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = left[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var id = _step.value;
                    next.delete(id);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = entered[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var id1 = _step1.value;
                    next.add(id1);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            return next;
        });
    }, [
        arrived,
        drawn,
        jumped,
        durationMs
    ]);
    useEffect42(function() {
        var timers = seen.current;
        return function() {
            timers.forEach(function(timer) {
                return clearTimeout(timer);
            });
            timers.clear();
        };
    }, []);
    return glowing;
};
// src/components/Planner/canvas/planHandleAnchors.ts
import { useLayoutEffect as useLayoutEffect5 } from "react";
var createPlanHandleAnchorStore = function() {
    var snapshot = /* @__PURE__ */ new Map();
    var listeners2 = /* @__PURE__ */ new Set();
    var notify = function() {
        return listeners2.forEach(function(l) {
            return l();
        });
    };
    return {
        set: function(id, anchor) {
            var prev = snapshot.get(id);
            if (prev && prev.x === anchor.x && prev.y === anchor.y && prev.glyph === anchor.glyph) return;
            var next = new Map(snapshot);
            next.set(id, anchor);
            snapshot = next;
            notify();
        },
        remove: function(id) {
            if (!snapshot.has(id)) return;
            var next = new Map(snapshot);
            next.delete(id);
            snapshot = next;
            notify();
        },
        subscribe: function(listener) {
            listeners2.add(listener);
            return function() {
                listeners2.delete(listener);
            };
        },
        getSnapshot: function() {
            return snapshot;
        }
    };
};
// src/components/Planner/reshape/useReshapeModifierKeys.ts
import { useEffect as useEffect43 } from "react";
var useReshapeModifierKeys = function(store) {
    useEffect43(function() {
        if (!store) return;
        var onKey = function(e) {
            if (isReshapeModifierKey(e.key)) store.setModifier(e.type === "keydown");
            else store.setModifier(reshapeModifierHeld(e));
        };
        var drop = function() {
            return store.setModifier(false);
        };
        var onVisibility = function() {
            if (document.visibilityState === "hidden") drop();
        };
        window.addEventListener("keydown", onKey);
        window.addEventListener("keyup", onKey);
        window.addEventListener("blur", drop);
        document.addEventListener("visibilitychange", onVisibility);
        return function() {
            window.removeEventListener("keydown", onKey);
            window.removeEventListener("keyup", onKey);
            window.removeEventListener("blur", drop);
            document.removeEventListener("visibilitychange", onVisibility);
            drop();
        };
    }, [
        store
    ]);
};
// src/components/Planner/reshape/useReshapeAnnouncements.ts
import { useEffect as useEffect44 } from "react";
import { surfaceDisplayName as surfaceDisplayName4 } from "@repo/front-end-utils";
var useReshapeAnnouncements = function(store, announce) {
    useEffect44(function() {
        if (!store) return;
        var live = null;
        var nameOf2 = function() {
            var state = store.getSnapshot();
            var surface11 = state === null || state === void 0 ? void 0 : state.startDesign.surfaces.find(function(s) {
                return s.refid === state.refid;
            });
            return surface11 ? surfaceDisplayName4(surface11) : "the space";
        };
        var offState = store.subscribe(function() {
            var _state_edge;
            var state = store.getSnapshot();
            if ((state === null || state === void 0 ? void 0 : state.gesture) !== "edge") return;
            if (!live || live.refid !== state.refid) {
                live = {
                    refid: state.refid,
                    refused: false
                };
                announce(movingEdgeOf(nameOf2()));
            }
            if (((_state_edge = state.edge) === null || _state_edge === void 0 ? void 0 : _state_edge.limited) && !live.refused) {
                live.refused = true;
                announce(edgeCannotGoFurther(nameOf2()));
            }
        });
        var offEnded = store.onEnded(function(ended) {
            if (ended.gesture === "edge" && ended.cancelled) announce(EDGE_PUT_BACK);
            live = null;
        });
        return function() {
            offState();
            offEnded();
        };
    }, [
        store,
        announce
    ]);
};
// src/components/Planner/canvas/floorGroup.ts
import { normaliseRotation as normaliseRotation7 } from "@repo/front-end-utils";
var effectiveViewRotation = function(viewRotation, placement) {
    return normaliseRotation7(viewRotation - placement.rotation);
};
// src/components/Planner/readOnlyPlan/readOnlyPlanGeometry.ts
import { typeScale as typeScale8 } from "@repo/design-tokens";
import { fitViewToBounds, metersToPixels as metersToPixels3, worldPxToPane } from "@repo/front-end-utils";
// src/components/Planner/PointMarker.tsx
import React13 from "react";
import styled39 from "styled-components";
import { focus as focus3, fontSans as fontSans5, ink as ink12, rgba as rgba6, semantic as semantic15, surface as surface6, typeScale as typeScale7, weight as weight8 } from "@repo/design-tokens";
import { jsx as jsx51 } from "react/jsx-runtime";
var POINT_MARKER_SIZE = 24;
var POINT_MARKER_RIM = 2;
var _semantic15_status = semantic15.status, roles2 = _semantic15_status.roles, selected = _semantic15_status.selected;
var POINT_MARKER_LOOK = {
    // The neutral role's own ink is about 3:1 on its mark, too faint for a 12 px number.
    placed: {
        fill: roles2.neutral.mark,
        rim: surface6[0],
        dashed: false,
        ink: ink12[1],
        halo: null
    },
    pending: {
        fill: rgba6(ink12[1], 0.6),
        rim: roles2.beingEdited.mark,
        dashed: true,
        ink: roles2.beingEdited.mark,
        halo: null
    },
    proposed: {
        fill: rgba6(surface6[0], 0.92),
        rim: roles2.information.mark,
        dashed: false,
        ink: roles2.information.ink,
        halo: null
    },
    bad: {
        fill: roles2.problem.mark,
        rim: surface6[0],
        dashed: false,
        // The problem role's own ink is about 3.8:1 on its mark, too faint for a 12 px number.
        ink: ink12[1],
        halo: null
    },
    selected: {
        fill: selected.fill,
        rim: surface6[0],
        dashed: false,
        ink: selected.ink,
        halo: rgba6(selected.edge, 0.7)
    },
    crosshair: {
        fill: "transparent",
        rim: roles2.beingEdited.mark,
        dashed: false,
        ink: roles2.beingEdited.mark,
        halo: null
    }
};
var PLAN_POINT_MARKER_LOOK = _object_spread_props(_object_spread({}, POINT_MARKER_LOOK), {
    // A white disc with a turquoise ring and glow, as the plan camera draws its selected marker.
    selected: {
        fill: surface6[0],
        rim: PLAN_SELECTION_COLOUR,
        dashed: false,
        ink: ink12[1],
        halo: rgba6(PLAN_SELECTION_COLOUR, 0.35)
    }
});
var PointMarker = React13.forwardRef(function PointMarker2(_param, ref) {
    var state = _param.state, label = _param.label, x = _param.x, y = _param.y, style = _param.style, rest = _object_without_properties(_param, [
        "state",
        "label",
        "x",
        "y",
        "style"
    ]);
    return /* @__PURE__ */ jsx51(Disc, _object_spread_props(_object_spread({
        ref: ref,
        type: "button",
        "data-state": state,
        $look: POINT_MARKER_LOOK[state],
        style: _object_spread_props(_object_spread({}, style), {
            left: x,
            top: y
        })
    }, rest), {
        children: label
    }));
});
var Disc = styled39.button(_templateObject174(), POINT_MARKER_SIZE, POINT_MARKER_SIZE, POINT_MARKER_RIM, function(param) {
    var $look = param.$look;
    return $look.dashed ? "dashed" : "solid";
}, function(param) {
    var $look = param.$look;
    return $look.rim;
}, function(param) {
    var $look = param.$look;
    return $look.fill;
}, function(param) {
    var $look = param.$look;
    return $look.ink;
}, weight8.semibold, typeScale7.caption1.fontSize, fontSans5, function(param) {
    var $look = param.$look;
    return [
        $look.halo ? "0 0 0 3px ".concat($look.halo) : null,
        "0 0 0 ".concat($look.halo ? 5 : 2, "px ").concat(rgba6(ink12[1], 0.25)),
        "0 2px 6px ".concat(rgba6(ink12[1], 0.35))
    ].filter(Boolean).join(", ");
}, focus3.ring);
// src/components/Planner/readOnlyPlan/readOnlyPlanGeometry.ts
var MIN_ZOOM = 0.05;
var MAX_ZOOM = 5;
var PLAN_VIEW_PADDING_PX = 60;
var resolveFitPadding = function(padding) {
    return typeof padding === "number" && Number.isFinite(padding) && padding >= 0 ? padding : PLAN_VIEW_PADDING_PX;
};
var planViewFit = function(bounds, rotation, size) {
    var padding = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : PLAN_VIEW_PADDING_PX;
    var fit = fitViewToBounds(_object_spread_props(_object_spread({}, bounds), {
        maxX: bounds.maxX > bounds.minX ? bounds.maxX : bounds.minX + 1,
        maxY: bounds.maxY > bounds.minY ? bounds.maxY : bounds.minY + 1
    }), {
        rotation: rotation,
        viewport: size,
        padding: resolveFitPadding(padding),
        zoomRange: {
            min: MIN_ZOOM,
            max: MAX_ZOOM
        }
    });
    return {
        zoom: fit.zoom,
        pan: fit.pan,
        rotation: rotation
    };
};
var REVEAL_MARGIN_PX = 24;
var revealShift = function(extent, view, size) {
    var margin = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : REVEAL_MARGIN_PX;
    var _Math, _Math1, _Math2, _Math3;
    var points = [];
    if ("x" in extent) {
        points.push(extent);
    } else {
        for(var i = 0; i + 1 < extent.length; i += 2)points.push({
            x: extent[i],
            y: extent[i + 1]
        });
    }
    var drawn = points.map(function(p) {
        return worldPxToPane(p, view);
    });
    if (drawn.length === 0 || drawn.some(function(p) {
        return !Number.isFinite(p.x) || !Number.isFinite(p.y);
    })) {
        return {
            dx: 0,
            dy: 0
        };
    }
    var axis = function(lo, hi, span) {
        var from = margin;
        var to = span - margin;
        if (hi - lo > to - from) return (from + to) / 2 - (lo + hi) / 2;
        if (lo < from) return from - lo;
        if (hi > to) return to - hi;
        return 0;
    };
    var xs = drawn.map(function(p) {
        return p.x;
    });
    var ys = drawn.map(function(p) {
        return p.y;
    });
    return {
        dx: axis((_Math = Math).min.apply(_Math, _to_consumable_array(xs)), (_Math1 = Math).max.apply(_Math1, _to_consumable_array(xs)), size.width),
        dy: axis((_Math2 = Math).min.apply(_Math2, _to_consumable_array(ys)), (_Math3 = Math).max.apply(_Math3, _to_consumable_array(ys)), size.height)
    };
};
var isUsablePlanView = function(view) {
    return !!view && Number.isFinite(view.zoom) && view.zoom > 0 && Number.isFinite(view.pan.x) && Number.isFinite(view.pan.y) && Number.isFinite(view.rotation);
};
var clampViewZoom = function(view, pane, min, max) {
    var about = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
        x: pane.width / 2,
        y: pane.height / 2
    };
    var zoom = Math.min(max, Math.max(min, view.zoom));
    if (zoom === view.zoom) return view;
    var k = zoom / view.zoom;
    return _object_spread_props(_object_spread({}, view), {
        zoom: zoom,
        pan: {
            x: about.x - k * (about.x - view.pan.x),
            y: about.y - k * (about.y - view.pan.y)
        }
    });
};
var WHEEL_STEP = 1.05;
var KEY_STEP = 1.2;
var MARKER_RADIUS = 6;
var MARKER_RADIUS_EMPHASISED = 8;
var MARKER_RING_RADIUS = 13;
var MARKER_RING_OPACITY = 0.45;
var MARKER_STROKE = 2;
var OUTLINE_STROKE = 2;
var OUTLINE_STROKE_EMPHASISED = 3;
var POINT_RADIUS = POINT_MARKER_SIZE / 2;
var POINT_LABEL_SIZE = parseFloat(typeScale8.caption1.fontSize);
var POINT_HALO = 3;
var POINT_DASH = [
    4,
    3
];
var FOCUS_HALF_SPAN_M = 6;
function centroidPx(poly) {
    return {
        x: poly.reduce(function(acc, p) {
            return acc + metersToPixels3(p.x);
        }, 0) / poly.length,
        y: poly.reduce(function(acc, p) {
            return acc + metersToPixels3(p.y);
        }, 0) / poly.length
    };
}
var entityPointsPx = function(design) {
    var points = /* @__PURE__ */ new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = design.surfaces[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var s = _step.value;
            if (!s._deleted && s.poly.length > 0) points.set(s.refid, centroidPx(s.poly));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = design.items[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var i = _step1.value;
            if (!i._deleted) points.set(i.refid, {
                x: metersToPixels3(i.x),
                y: metersToPixels3(i.y)
            });
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return points;
};
var surfaceOutlinesPx = function(design) {
    var itemIds = new Set(design.items.filter(function(i) {
        return !i._deleted;
    }).map(function(i) {
        return i.refid;
    }));
    var outlines = /* @__PURE__ */ new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = design.surfaces[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var s = _step.value;
            if (s._deleted || s.poly.length < 3 || itemIds.has(s.refid)) continue;
            outlines.set(s.refid, s.poly.flatMap(function(p) {
                return [
                    metersToPixels3(p.x),
                    metersToPixels3(p.y)
                ];
            }));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return outlines;
};
var hostViewKey = function(rotation, bounds) {
    return JSON.stringify([
        rotation !== null && rotation !== void 0 ? rotation : null,
        bounds ? [
            bounds.minX,
            bounds.maxX,
            bounds.minY,
            bounds.maxY
        ] : null
    ]);
};
// src/components/Planner/floors/useFloorPlacementView.ts
import { useEditorStore as useEditorStore48 } from "@repo/front-end-state";
import { placementOf as placementOf4 } from "@repo/front-end-utils";
function useFloorPlacementView(floor) {
    var id = floor === null || floor === void 0 ? void 0 : floor.id;
    var preview = useEditorStore48(function(s) {
        var _s_floorPlacementPreview;
        return id !== void 0 && ((_s_floorPlacementPreview = s.floorPlacementPreview) === null || _s_floorPlacementPreview === void 0 ? void 0 : _s_floorPlacementPreview.floorId) === id ? s.floorPlacementPreview.placement : null;
    });
    return preview !== null && preview !== void 0 ? preview : placementOf4(floor);
}
// src/components/Planner/plannerCanvas/usePlannerCanvasModel.ts
import { useScaleCalibrationStore } from "@repo/front-end-state";
// src/components/Planner/plannerCanvas/plannerCanvasProps.ts
var or = function(value, fallback) {
    return value === void 0 ? fallback : value;
};
var withPlannerCanvasDefaults = function(props) {
    return _object_spread_props(_object_spread({}, props), {
        toolset: or(props.toolset, "full"),
        litCameraRefid: or(props.litCameraRefid, null),
        unlinkedCamerasAreWork: or(props.unlinkedCamerasAreWork, false),
        referenceOffered: or(props.referenceOffered, false),
        showMap: or(props.showMap, true)
    });
};
// src/components/Planner/hooks/usePaneSize.ts
import { useEffect as useEffect45, useLayoutEffect as useLayoutEffect6, useState as useState45 } from "react";
var measuredAs = function(width, height) {
    return function(prev) {
        return prev.measured && prev.width === width && prev.height === height ? prev : {
            width: width,
            height: height,
            measured: true
        };
    };
};
function usePaneSize(ref) {
    var _useState45 = _sliced_to_array(useState45(function() {
        return {
            width: typeof window === "undefined" ? 0 : window.innerWidth,
            height: typeof window === "undefined" ? 0 : window.innerHeight,
            measured: false
        };
    }), 2), size = _useState45[0], setSize = _useState45[1];
    useLayoutEffect6(function() {
        var el = ref.current;
        if (!el) return;
        var _el_getBoundingClientRect = el.getBoundingClientRect(), width = _el_getBoundingClientRect.width, height = _el_getBoundingClientRect.height;
        if (width > 0 && height > 0) {
            setSize(measuredAs(width, height));
        }
    }, [
        ref
    ]);
    useEffect45(function() {
        var el = ref.current;
        if (!el || typeof ResizeObserver === "undefined") return;
        var ro = new ResizeObserver(function(entries) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var entry = _step.value;
                    var _entry_contentRect = entry.contentRect, width = _entry_contentRect.width, height = _entry_contentRect.height;
                    setSize(measuredAs(width, height));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
        ro.observe(el);
        return function() {
            return ro.disconnect();
        };
    }, [
        ref
    ]);
    return size;
}
// src/components/Planner/plannerCanvas/clearArea.ts
var FLY_IF_HIDDEN_INSET_PX = 40;
var edge = function(value) {
    return typeof value === "number" && Number.isFinite(value) && value > 0 ? value : 0;
};
function clearAreaOf(pane, insets) {
    var left = edge(insets === null || insets === void 0 ? void 0 : insets.left);
    var right = edge(insets === null || insets === void 0 ? void 0 : insets.right);
    var top = edge(insets === null || insets === void 0 ? void 0 : insets.top);
    var bottom = edge(insets === null || insets === void 0 ? void 0 : insets.bottom);
    if (left + right >= pane.width || top + bottom >= pane.height) {
        left = right = top = bottom = 0;
    }
    var r = pane.width - right;
    var b = pane.height - bottom;
    return {
        left: left,
        top: top,
        right: r,
        bottom: b,
        centre: {
            x: (left + r) / 2,
            y: (top + b) / 2
        }
    };
}
function isInsideClearArea(point, area) {
    var inset12 = FLY_IF_HIDDEN_INSET_PX;
    return point.x >= area.left + inset12 && point.x <= area.right - inset12 && point.y >= area.top + inset12 && point.y <= area.bottom - inset12;
}
// src/components/Planner/plannerCanvas/usePlannerCanvasModel.ts
var FLY_DURATION_MS = 450;
var FLY_PANE_WAIT_FRAMES = 120;
var SEARCH_FRAME_MAX_ZOOM = 2;
var NO_HANDLE_OWNERS = {
    rotate: [],
    corners: [],
    edges: null,
    wallEnds: [],
    camera: null
};
var usePlannerCanvasModel = function(props, stage) {
    var _layout_floors_activeFloorIndex;
    var stageHandleRef = useRef42(stage);
    stageHandleRef.current = stage;
    var _withPlannerCanvasDefaults = withPlannerCanvasDefaults(props), toolset = _withPlannerCanvasDefaults.toolset, capabilities = _withPlannerCanvasDefaults.capabilities, twinBid = _withPlannerCanvasDefaults.twinBid, liveIdentities = _withPlannerCanvasDefaults.liveIdentities, onStreamClaim = _withPlannerCanvasDefaults.onStreamClaim, onStreamLinked = _withPlannerCanvasDefaults.onStreamLinked, litCameraRefid = _withPlannerCanvasDefaults.litCameraRefid, unlinkedCamerasAreWork = _withPlannerCanvasDefaults.unlinkedCamerasAreWork, activeStreamDrag = _withPlannerCanvasDefaults.activeStreamDrag, onStreamClaimCheck = _withPlannerCanvasDefaults.onStreamClaimCheck, entityMarksProp = _withPlannerCanvasDefaults.entityMarks, onSpaceDrawn = _withPlannerCanvasDefaults.onSpaceDrawn, referenceOffered = _withPlannerCanvasDefaults.referenceOffered, showMap = _withPlannerCanvasDefaults.showMap, initialView = _withPlannerCanvasDefaults.initialView, controlsInset = _withPlannerCanvasDefaults.controlsInset;
    var paneRef = useRef42(null);
    var zoom = useEditorStore49(function(s) {
        return s.zoom;
    });
    var setZoom = useEditorStore49(function(s) {
        return s.setZoom;
    });
    var panOffset = useEditorStore49(function(s) {
        return s.panOffset;
    });
    var setPanOffset = useEditorStore49(function(s) {
        return s.setPanOffset;
    });
    var viewRotation = useEditorStore49(function(s) {
        return s.viewRotation;
    });
    var setViewRotation = useEditorStore49(function(s) {
        return s.setViewRotation;
    });
    var clearSelection = useEditorStore49(function(s) {
        return s.clearSelection;
    });
    var selectEntity = useEditorStore49(function(s) {
        return s.selectEntity;
    });
    var setToolMode = useEditorStore49(function(s) {
        return s.setToolMode;
    });
    var markEntityModified = useEditorStore49(function(s) {
        return s.markEntityModified;
    });
    var cameraEdited = useCameraEdited();
    var gridSnap = useEditorStore49(function(s) {
        return s.gridSnap;
    });
    var gridSize = useEditorStore49(function(s) {
        return s.gridSize;
    });
    var pushSnapshot = useEditorStore49(function(s) {
        return s.pushSnapshot;
    });
    var setMousePosition = useEditorStore49(function(s) {
        return s.setMousePosition;
    });
    var toolMode = useEditorStore49(function(s) {
        return s.toolMode;
    });
    var rendererSupport = usePlannerRendererSupport();
    var _useState46 = _sliced_to_array(useState46(null), 2), drawRefusal = _useState46[0], setDrawRefusal = _useState46[1];
    useEffect46(function() {
        if (toolMode !== "draw_space") setDrawRefusal(null);
    }, [
        toolMode
    ]);
    var selectedIds = useEditorStore49(selectionOnFloorShown10);
    var floorVisibility = useFloorVisibility();
    var layout = useFloorplanStore56(function(s) {
        return s.layout;
    });
    var activeFloorIndex = useFloorplanStore56(function(s) {
        return s.activeFloorIndex;
    });
    var addCamera = useFloorplanStore56(function(s) {
        return s.addCamera;
    });
    var planChecks = usePlanChecksContext();
    var shownFloorId = layout === null || layout === void 0 ? void 0 : (_layout_floors_activeFloorIndex = layout.floors[activeFloorIndex]) === null || _layout_floors_activeFloorIndex === void 0 ? void 0 : _layout_floors_activeFloorIndex.id;
    var modelMarks = floorMarks(planChecks, shownFloorId);
    var _useState461 = _sliced_to_array(useState46(null), 2), filedArrived = _useState461[0], setFiledArrived = _useState461[1];
    var filedTimer = useRef42(null);
    useEffect46(function() {
        return function() {
            if (filedTimer.current) clearTimeout(filedTimer.current);
        };
    }, []);
    var handleSpaceDrawn = useCallback23(function(report) {
        if (filedTimer.current) clearTimeout(filedTimer.current);
        setFiledArrived(new Set(report.filed.machines));
        filedTimer.current = setTimeout(function() {
            return setFiledArrived(null);
        }, ARRIVED_MS);
        onSpaceDrawn === null || onSpaceDrawn === void 0 ? void 0 : onSpaceDrawn(report);
    }, [
        onSpaceDrawn
    ]);
    var reshapeStore = useReshapeStore();
    var reshapeOn = reshapeStore !== null;
    var reshapePreview = useReshapePreview(reshapeOn ? reshapeStore : null);
    var movingIds = useMemo26(function() {
        if (!reshapePreview) return void 0;
        var ids = reshapePreview.impact.entries.map(function(e) {
            return e.id;
        }).filter(function(id) {
            return id !== reshapePreview.state.refid;
        });
        return ids.length ? new Set(ids) : void 0;
    }, [
        reshapePreview
    ]);
    var deletePreview = useEditorStore49(function(s) {
        return s.deletePreview;
    });
    var entityMarks = useMemo26(function() {
        var combined = combineEntityMarks(entityMarksProp, modelMarks);
        var marks = combined;
        if (filedArrived && filedArrived.size > 0) {
            var _combined_arrived;
            var arrived = /* @__PURE__ */ new Set();
            combined === null || combined === void 0 ? void 0 : (_combined_arrived = combined.arrived) === null || _combined_arrived === void 0 ? void 0 : _combined_arrived.forEach(function(id) {
                return arrived.add(id);
            });
            filedArrived.forEach(function(id) {
                return arrived.add(id);
            });
            marks = _object_spread_props(_object_spread({}, combined), {
                arrived: arrived
            });
        }
        if (movingIds) marks = _object_spread_props(_object_spread({}, marks), {
            moving: movingIds
        });
        return withDeletePreview(marks, deletePreview);
    }, [
        entityMarksProp,
        modelMarks,
        filedArrived,
        movingIds,
        deletePreview
    ]);
    var paneSize = usePaneSize(paneRef);
    var caps = capabilities !== null && capabilities !== void 0 ? capabilities : resolvePlannerCapabilities(toolset, "edit", rendererSupport);
    var _useState462 = _sliced_to_array(useState46(null), 2), pointerHoverId = _useState462[0], setPointerHoverId = _useState462[1];
    var pointerHoverRef = useRef42(null);
    var sharedHover = usePlannerHover();
    var tellSharedHoverRef = useRef42(sharedHover === null || sharedHover === void 0 ? void 0 : sharedHover.setHovered);
    tellSharedHoverRef.current = sharedHover === null || sharedHover === void 0 ? void 0 : sharedHover.setHovered;
    var _sharedHover_hoveredId;
    var outsideHoverId = (_sharedHover_hoveredId = sharedHover === null || sharedHover === void 0 ? void 0 : sharedHover.hoveredId) !== null && _sharedHover_hoveredId !== void 0 ? _sharedHover_hoveredId : null;
    var handleEntityHover = useCallback23(function(id, over) {
        var _tellSharedHoverRef_current;
        var next = over ? id : pointerHoverRef.current === id ? null : pointerHoverRef.current;
        if (next !== null && useEditorStore49.getState().toolMode !== "select") return;
        if (next === pointerHoverRef.current) return;
        pointerHoverRef.current = next;
        setPointerHoverId(next);
        (_tellSharedHoverRef_current = tellSharedHoverRef.current) === null || _tellSharedHoverRef_current === void 0 ? void 0 : _tellSharedHoverRef_current.call(tellSharedHoverRef, next);
    }, []);
    var glowing = usePlanEntitySettle(entityMarks === null || entityMarks === void 0 ? void 0 : entityMarks.arrived, entityMarks === null || entityMarks === void 0 ? void 0 : entityMarks.drawn, entityMarks === null || entityMarks === void 0 ? void 0 : entityMarks.jumped);
    var selectedSet = useMemo26(function() {
        return new Set(selectedIds);
    }, [
        selectedIds
    ]);
    var lookContext = useMemo26(function() {
        return {
            selected: selectedSet,
            hovered: pointerHoverId !== null && pointerHoverId !== void 0 ? pointerHoverId : outsideHoverId,
            marks: entityMarks,
            glowing: glowing
        };
    }, [
        selectedSet,
        pointerHoverId,
        outsideHoverId,
        entityMarks,
        glowing
    ]);
    var entitiesEditable = caps.mutableKinds === "all";
    var aligning = caps.allFloors;
    var _useAnnouncer = _sliced_to_array(useAnnouncer(), 2), rotationAnnouncement = _useAnnouncer[0], announce = _useAnnouncer[1];
    var itemEditing = usePlannerItemEditing();
    var nudgeSettle = useRef42(null);
    useEffect46(function() {
        return function() {
            if (nudgeSettle.current) clearTimeout(nudgeSettle.current);
        };
    }, []);
    var announceScaleSet = useCallback23(function(name) {
        return announce("Scale set for ".concat(name, "."));
    }, [
        announce
    ]);
    var scaleTarget = useSelectedUnderlay();
    var scaleTargetDrawn = !!(scaleTarget === null || scaleTarget === void 0 ? void 0 : scaleTarget.drawn);
    var scaleTargetLocked = scaleTargetDrawn && !!(scaleTarget === null || scaleTarget === void 0 ? void 0 : scaleTarget.underlay.locked);
    var resetCalibration = useScaleCalibrationStore(function(s) {
        return s.reset;
    });
    var scaleTargetName = scaleTarget === null || scaleTarget === void 0 ? void 0 : scaleTarget.underlay.name;
    useEffect46(function() {
        if (scaleTargetDrawn && !scaleTargetLocked) return;
        var why = scaleTargetLocked ? "".concat(scaleTargetName, " is locked.") : "the PDF is no longer on the plan.";
        if (toolMode === "calibrate_scale") {
            resetCalibration();
            setToolMode("select");
            announce("Set scale cancelled: ".concat(why));
        } else if (toolMode === "scale_underlay") {
            setToolMode("select");
            announce("Scale PDF cancelled: ".concat(why));
        }
    }, [
        toolMode,
        scaleTargetDrawn,
        scaleTargetLocked,
        scaleTargetName,
        resetCalibration,
        setToolMode,
        announce
    ]);
    var floor = layout === null || layout === void 0 ? void 0 : layout.floors[activeFloorIndex];
    var design = floor ? findLatestDesign19(floor.designs) : null;
    var footprintOf = usePlanMachineFootprints();
    var _useState463 = _sliced_to_array(useState46(createPlanHandleAnchorStore), 1), handleAnchors = _useState463[0];
    var entityLayerRef = useRef42(null);
    var armedEdge = useArmedEdge(reshapeOn ? reshapeStore : null);
    var reshapeModifierHeld2 = useReshapeModifier(reshapeOn ? reshapeStore : null);
    var previewState = reshapePreview === null || reshapePreview === void 0 ? void 0 : reshapePreview.state;
    var previewedSpace = (previewState === null || previewState === void 0 ? void 0 : previewState.gesture) === "corner" ? design === null || design === void 0 ? void 0 : design.surfaces.find(function(x) {
        return x.refid === previewState.refid;
    }) : null;
    var previewing = ((previewState === null || previewState === void 0 ? void 0 : previewState.gesture) === "edge" || (previewState === null || previewState === void 0 ? void 0 : previewState.gesture) === "corner" && (previewedSpace === null || previewedSpace === void 0 ? void 0 : previewedSpace.poly) === previewState.startPoly) && previewState.floorIndex === activeFloorIndex ? previewState : null;
    useReshapeModifierKeys(reshapeOn ? reshapeStore : null);
    useReshapeAnnouncements(reshapeOn ? reshapeStore : null, announce);
    var shownSurfaces = useMemo26(function() {
        var _design_surfaces;
        return ((_design_surfaces = design === null || design === void 0 ? void 0 : design.surfaces) !== null && _design_surfaces !== void 0 ? _design_surfaces : []).map(function(x) {
            return (previewing === null || previewing === void 0 ? void 0 : previewing.refid) === x.refid ? _object_spread_props(_object_spread({}, x), {
                poly: previewing.latestPoly
            }) : x;
        });
    }, [
        design,
        previewing
    ]);
    var liveSurfaces = useMemo26(function() {
        return shownSurfaces.filter(function(x) {
            return !x._deleted;
        });
    }, [
        shownSurfaces
    ]);
    var announceDesignRef = useRef42(design);
    announceDesignRef.current = design;
    var announceItemRotated = useCallback23(function(refid, rotation) {
        var _announceDesignRef_current;
        var item = (_announceDesignRef_current = announceDesignRef.current) === null || _announceDesignRef_current === void 0 ? void 0 : _announceDesignRef_current.items.find(function(i) {
            return i.refid === refid;
        });
        var _item_name;
        announce("Rotated ".concat((_item_name = item === null || item === void 0 ? void 0 : item.name) !== null && _item_name !== void 0 ? _item_name : refid, " to ").concat(rotation, "\xb0"));
    }, [
        announce
    ]);
    var announceItemsRotated = useCallback23(function(count) {
        return announce("Rotated ".concat(count, " machines"));
    }, [
        announce
    ]);
    useEffect46(function() {
        var _tellSharedHoverRef_current;
        var id = pointerHoverRef.current;
        if (id === null) return;
        var _design_items;
        var drawn = liveSurfaces.some(function(x) {
            return x.refid === id;
        }) || ((_design_items = design === null || design === void 0 ? void 0 : design.items) !== null && _design_items !== void 0 ? _design_items : []).some(function(i) {
            return i.refid === id && !i._deleted;
        });
        if (toolMode === "select" && drawn) return;
        pointerHoverRef.current = null;
        setPointerHoverId(null);
        (_tellSharedHoverRef_current = tellSharedHoverRef.current) === null || _tellSharedHoverRef_current === void 0 ? void 0 : _tellSharedHoverRef_current.call(tellSharedHoverRef, null);
    }, [
        toolMode,
        liveSurfaces,
        design
    ]);
    useEffect46(function() {
        return function() {
            var _tellSharedHoverRef_current;
            if (pointerHoverRef.current !== null) (_tellSharedHoverRef_current = tellSharedHoverRef.current) === null || _tellSharedHoverRef_current === void 0 ? void 0 : _tellSharedHoverRef_current.call(tellSharedHoverRef, null);
        };
    }, []);
    var surfaceTagLook = useCallback23(function(surface11) {
        var look = spaceLook(surface11.refid, lookContext);
        return showsNameTag(surface11.refid, look, lookContext) ? look : null;
    }, [
        lookContext
    ]);
    var cornerSurface = cornerSurfaceFor({
        aligning: aligning,
        editable: entitiesEditable,
        toolMode: toolMode,
        selectedIds: selectedIds,
        surfaces: liveSurfaces
    });
    var _cornerSurface_refid;
    var edgeSurface = edgesShownFor({
        reshapeOn: reshapeOn,
        aligning: aligning,
        cornerSurface: (_cornerSurface_refid = cornerSurface === null || cornerSurface === void 0 ? void 0 : cornerSurface.refid) !== null && _cornerSurface_refid !== void 0 ? _cornerSurface_refid : null
    });
    var facingBounds = useMemo26(function() {
        var box = planScrollBounds(design, {
            underlays: caps.tools.background ? "untilDrawn" : "none",
            includeCameras: false,
            footprintOf: footprintOf
        });
        return box ? {
            minX: pixelsToMeters3(box.minX),
            minY: pixelsToMeters3(box.minY),
            maxX: pixelsToMeters3(box.maxX),
            maxY: pixelsToMeters3(box.maxY)
        } : null;
    }, [
        design,
        caps.tools.background,
        footprintOf
    ]);
    var equipmentDragStore = useEquipmentDragStore();
    var equipmentDragActive = useEquipmentDragActive(equipmentDragStore);
    var drawnCameras = useMemo26(function() {
        var _design_cameras;
        return ((_design_cameras = design === null || design === void 0 ? void 0 : design.cameras) !== null && _design_cameras !== void 0 ? _design_cameras : []).filter(function(c) {
            return !c._deleted;
        }).map(function(camera, index) {
            return {
                camera: camera,
                index: index
            };
        });
    }, [
        design
    ]);
    var drawnCameraList = useMemo26(function() {
        return drawnCameras.map(function(d) {
            return d.camera;
        });
    }, [
        drawnCameras
    ]);
    var _useState464 = _sliced_to_array(useState46(createCameraPreviewStore), 1), cameraPreview = _useState464[0];
    var answerFor = useCallback23(function(point, onThrow) {
        return activeStreamDrag ? streamDropAnswer({
            point: point,
            drag: activeStreamDrag,
            cameras: drawnCameraList,
            check: onStreamClaimCheck,
            hit: function(cameras, at3) {
                return cameraAtPoint(cameras, at3, zoom);
            },
            shape: function(at3) {
                return _object_spread({
                    refid: "drop-preview"
                }, newCameraShape(at3.x, at3.y, facingPlanCentre(at3, facingBounds)));
            },
            nameOf: function(refid) {
                var drawn = drawnCameras.find(function(c) {
                    return c.camera.refid === refid;
                });
                return drawn ? cameraDisplayName2(drawn.camera, drawn.index) : "the camera";
            },
            onThrow: onThrow
        }) : null;
    }, [
        activeStreamDrag,
        drawnCameraList,
        drawnCameras,
        onStreamClaimCheck,
        zoom,
        facingBounds
    ]);
    var streamDragActive = useEditorStore49(function(s) {
        return s.streamDragActive;
    });
    var setStreamDragActive = useEditorStore49(function(s) {
        return s.setStreamDragActive;
    });
    var followsStreamDrag = activeStreamDrag !== void 0;
    var streamDragOn = activeStreamDrag != null;
    useEffect46(function() {
        if (!followsStreamDrag) return;
        setStreamDragActive(streamDragOn);
        return function() {
            return setStreamDragActive(false);
        };
    }, [
        followsStreamDrag,
        streamDragOn,
        setStreamDragActive
    ]);
    var floorView = useFloorPlacementView(aligning ? null : floor);
    var stageRotation = aligning ? viewRotation : effectiveViewRotation(viewRotation, floorView);
    var stageRotationRef = useRef42(stageRotation);
    stageRotationRef.current = stageRotation;
    var activeUnderlays = useMemo26(function() {
        var _design_underlays;
        return caps.tools.background && !aligning ? (_design_underlays = design === null || design === void 0 ? void 0 : design.underlays) !== null && _design_underlays !== void 0 ? _design_underlays : NO_UNDERLAYS : NO_UNDERLAYS;
    }, [
        caps.tools.background,
        aligning,
        design === null || design === void 0 ? void 0 : design.underlays
    ]);
    var alignUnderlays = useMemo26(function() {
        var _layout_floors;
        return aligning ? visibleFloors((_layout_floors = layout === null || layout === void 0 ? void 0 : layout.floors) !== null && _layout_floors !== void 0 ? _layout_floors : [], activeFloorIndex, floorVisibility).flatMap(function(f) {
            var _findLatestDesign19;
            var _findLatestDesign19_underlays;
            return (_findLatestDesign19_underlays = (_findLatestDesign19 = findLatestDesign19(f.designs)) === null || _findLatestDesign19 === void 0 ? void 0 : _findLatestDesign19.underlays) !== null && _findLatestDesign19_underlays !== void 0 ? _findLatestDesign19_underlays : NO_UNDERLAYS;
        }) : NO_UNDERLAYS;
    }, [
        aligning,
        layout === null || layout === void 0 ? void 0 : layout.floors,
        activeFloorIndex,
        floorVisibility
    ]);
    var underlayViews = useUnderlayImages(aligning ? alignUnderlays : activeUnderlays);
    var underlayImages = useContext17(UnderlayImagesContext);
    var reportUndecodable = useCallback23(function(u) {
        if (!u.data && u.imageRef) underlayImages === null || underlayImages === void 0 ? void 0 : underlayImages.reportUndecodable(u.imageRef);
    }, [
        underlayImages
    ]);
    var _useMemo26 = useMemo26(function() {
        var visible = activeUnderlays.filter(function(u) {
            return u.visible;
        }).map(function(u) {
            return {
                u: u,
                view: underlayViews[u.id]
            };
        });
        return {
            statusItems: visible.map(function(param) {
                var u = param.u, view = param.view;
                var _view_status;
                return {
                    name: u.name,
                    status: (_view_status = view === null || view === void 0 ? void 0 : view.status) !== null && _view_status !== void 0 ? _view_status : "loading"
                };
            }),
            failedRetries: visible.map(function(param) {
                var view = param.view;
                return view === null || view === void 0 ? void 0 : view.retry;
            }).filter(function(r) {
                return !!r;
            })
        };
    }, [
        activeUnderlays,
        underlayViews
    ]), statusItems = _useMemo26.statusItems, failedRetries = _useMemo26.failedRetries;
    var decodedSrcs = useEditorStore49(function(s) {
        return s.decodedUnderlaySrcs;
    });
    var reportDecoded = useCallback23(function(u, src) {
        return useEditorStore49.getState().markUnderlayDecoded(u.id, src);
    }, []);
    var reportUndrawn = useCallback23(function(u, src) {
        return useEditorStore49.getState().forgetUnderlayDecoded(u.id, src);
    }, []);
    var underlaySrcs = useMemo26(function() {
        var srcs = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.entries(underlayViews)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = _sliced_to_array(_step.value, 2), id = _step_value[0], view = _step_value[1];
                if (view.src) srcs[id] = view.src;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return srcs;
    }, [
        underlayViews
    ]);
    var retryUnderlays = useMemo26(function() {
        return failedRetries.length > 0 ? function() {
            var _paneRef_current;
            (_paneRef_current = paneRef.current) === null || _paneRef_current === void 0 ? void 0 : _paneRef_current.focus();
            failedRetries.forEach(function(retry) {
                return retry();
            });
        } : void 0;
    }, [
        failedRetries
    ]);
    var wallsCenter = useMemo26(function() {
        var _design_walls;
        return wallsCenterOf((_design_walls = design === null || design === void 0 ? void 0 : design.walls) !== null && _design_walls !== void 0 ? _design_walls : []);
    }, [
        design === null || design === void 0 ? void 0 : design.walls
    ]);
    var _useState465 = _sliced_to_array(useState46(null), 2), dragPan = _useState465[0], setDragPan = _useState465[1];
    var livePan = dragPan !== null && dragPan !== void 0 ? dragPan : panOffset;
    var planView = {
        zoom: zoom,
        pan: panOffset,
        rotation: stageRotation
    };
    var livePlanView = {
        zoom: zoom,
        pan: livePan,
        rotation: stageRotation
    };
    var cameraLayerRef = useRef42(null);
    var panOffsetRef = useRef42(panOffset);
    panOffsetRef.current = panOffset;
    useLayoutEffect7(function() {
        if (cameraLayerRef.current) cameraLayerRef.current.style.transform = "";
        if (entityLayerRef.current) entityLayerRef.current.style.transform = "";
    }, [
        panOffset
    ]);
    var dragFrameRef = useRef42(null);
    var cancelFlightRef = useRef42(function() {});
    var dragPanLatest = useRef42(null);
    var dragPanTo = useCallback23(function(pan) {
        cancelFlightRef.current();
        var settled = panOffsetRef.current;
        for(var _i = 0, _iter = [
            cameraLayerRef.current,
            entityLayerRef.current
        ]; _i < _iter.length; _i++){
            var layer = _iter[_i];
            if (layer) layer.style.transform = "translate(".concat(pan.x - settled.x, "px, ").concat(pan.y - settled.y, "px)");
        }
        dragPanLatest.current = pan;
        if (dragFrameRef.current !== null) return;
        dragFrameRef.current = requestAnimationFrame(function() {
            dragFrameRef.current = null;
            var latest = dragPanLatest.current;
            if (latest) setDragPan({
                x: latest.x,
                y: latest.y
            });
        });
    }, []);
    var endDrag = useCallback23(function(pan) {
        if (dragFrameRef.current !== null) cancelAnimationFrame(dragFrameRef.current);
        dragFrameRef.current = null;
        setDragPan(null);
        setPanOffset({
            x: pan.x,
            y: pan.y
        });
    }, [
        setPanOffset
    ]);
    useEffect46(function() {
        return function() {
            if (dragFrameRef.current !== null) cancelAnimationFrame(dragFrameRef.current);
        };
    }, []);
    var placeCameraAt = function(panePoint, free) {
        var world = stageHandleRef.current.planPointAt(panePoint);
        if (!world) return null;
        var _snapPlannerPoint4 = snapPlannerPoint4({
            x: pixelsToMeters3(world.x),
            y: pixelsToMeters3(world.y)
        }, {
            gridSnap: gridSnap,
            gridSizeCm: gridSize,
            free: free
        }), mx = _snapPlannerPoint4.x, my = _snapPlannerPoint4.y;
        var camera = newCameraAt(mx, my);
        if (layout) pushSnapshot(layout);
        addCamera(camera);
        markEntityModified(camera.refid);
        setToolMode("select");
        selectEntity(camera.refid);
        cameraEdited();
        return camera.refid;
    };
    var paneViewport = useCallback23(function() {
        var pane = paneRef.current;
        var container = pane && pane.clientWidth > 0 ? pane : stageHandleRef.current.fallbackViewport();
        if (!container) return null;
        return {
            width: container.clientWidth,
            height: container.clientHeight
        };
    }, []);
    var paneRect2 = useCallback23(function() {
        var _paneRef_current;
        var rect = (_paneRef_current = paneRef.current) === null || _paneRef_current === void 0 ? void 0 : _paneRef_current.getBoundingClientRect();
        if (rect && rect.width > 0 && rect.height > 0) {
            return {
                left: rect.left,
                top: rect.top,
                width: rect.width,
                height: rect.height
            };
        }
        var _paneViewport;
        var viewport = (_paneViewport = paneViewport()) !== null && _paneViewport !== void 0 ? _paneViewport : {
            width: 0,
            height: 0
        };
        return _object_spread({
            left: 0,
            top: 0
        }, viewport);
    }, [
        paneViewport
    ]);
    var fitToWorldBounds = useCallback23(function(minX, minY, maxX, maxY) {
        var maxZoom = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 5;
        var viewport = paneViewport();
        if (!viewport) return;
        var viewWidth = viewport.width;
        var viewHeight = viewport.height;
        if (maxX - minX <= 0 || maxY - minY <= 0) return;
        var next = fitViewToBounds2({
            minX: minX,
            minY: minY,
            maxX: maxX,
            maxY: maxY
        }, {
            rotation: stageRotationRef.current,
            viewport: {
                width: viewWidth,
                height: viewHeight
            },
            padding: 60,
            zoomRange: {
                min: 0.1,
                max: maxZoom
            }
        });
        setZoom(next.zoom);
        setPanOffset(next.pan);
    }, [
        setZoom,
        setPanOffset,
        paneViewport
    ]);
    var shownFloors = useMemo26(function() {
        var _layout_floors;
        return aligning ? visibleFloors((_layout_floors = layout === null || layout === void 0 ? void 0 : layout.floors) !== null && _layout_floors !== void 0 ? _layout_floors : [], activeFloorIndex, floorVisibility) : null;
    }, [
        aligning,
        layout === null || layout === void 0 ? void 0 : layout.floors,
        activeFloorIndex,
        floorVisibility
    ]);
    var visibleDesigns = useMemo26(function() {
        var _shownFloors_map;
        return (_shownFloors_map = shownFloors === null || shownFloors === void 0 ? void 0 : shownFloors.map(function(f) {
            return findLatestDesign19(f.designs);
        })) !== null && _shownFloors_map !== void 0 ? _shownFloors_map : null;
    }, [
        shownFloors
    ]);
    var scrollBounds = useMemo26(function() {
        return visibleDesigns ? planScrollBoundsForDesigns(visibleDesigns, {
            // Lining PDFs up is what Align floors is for, so each visible PDF counts even on a
            // floor that has walls (`underlay-layers`).
            underlays: "always",
            includeCameras: false,
            footprintOf: footprintOf
        }, // Each floor where it is drawn — at its placement (`floor-placement`).
        shownFloors === null || shownFloors === void 0 ? void 0 : shownFloors.map(function(f) {
            return f.placement;
        })) : planScrollBounds(design, {
            underlays: caps.tools.background ? "untilDrawn" : "none",
            footprintOf: footprintOf
        });
    }, [
        visibleDesigns,
        shownFloors,
        design,
        caps.tools.background,
        footprintOf
    ]);
    var handleFitToScreen = useCallback23(function() {
        if (!scrollBounds) return;
        fitToWorldBounds(scrollBounds.minX, scrollBounds.minY, scrollBounds.maxX, scrollBounds.maxY);
    }, [
        scrollBounds,
        fitToWorldBounds
    ]);
    var handleFitRef = useRef42(handleFitToScreen);
    handleFitRef.current = handleFitToScreen;
    var drawingOutline = useMemo26(function() {
        return aligning ? null : planDrawingOutline(design, footprintOf);
    }, [
        aligning,
        design,
        footprintOf
    ]);
    var openingRef = useRef42({
        drawingOutline: drawingOutline,
        placementView: floorView
    });
    openingRef.current = {
        drawingOutline: drawingOutline,
        placementView: floorView
    };
    var floorKey = !floor ? null : aligning ? "".concat(layout === null || layout === void 0 ? void 0 : layout.name, ":align") : "".concat(layout === null || layout === void 0 ? void 0 : layout.name, ":").concat(activeFloorIndex, ":").concat(floor.name);
    var prevFloorKeyRef = useRef42(null);
    var initialViewRef = useRef42(initialView);
    var openedAtRef = useRef42(null);
    var rememberOpening = useCallback23(function(reopen) {
        var _useEditorStore49_getState = useEditorStore49.getState(), zoom2 = _useEditorStore49_getState.zoom, panOffset2 = _useEditorStore49_getState.panOffset, rotation = _useEditorStore49_getState.viewRotation;
        var pane = paneRect2();
        openedAtRef.current = {
            reopen: reopen,
            width: pane.width,
            height: pane.height,
            zoom: zoom2,
            pan: {
                x: panOffset2.x,
                y: panOffset2.y
            },
            rotation: rotation
        };
    }, [
        paneRect2
    ]);
    var viewIsOpening = useCallback23(function() {
        var opened = openedAtRef.current;
        if (!opened) return false;
        var _useEditorStore49_getState = useEditorStore49.getState(), zoom2 = _useEditorStore49_getState.zoom, panOffset2 = _useEditorStore49_getState.panOffset, rotation = _useEditorStore49_getState.viewRotation;
        return zoom2 === opened.zoom && panOffset2.x === opened.pan.x && panOffset2.y === opened.pan.y && rotation === opened.rotation;
    }, []);
    var applyOpening = useCallback23(function(resolve, placementRotation) {
        var pane = paneRect2();
        var asked = resolve(pane);
        if (!isUsablePlanView(asked)) return false;
        var handed = clampViewZoom(asked, pane, EDITOR_MIN_ZOOM, EDITOR_MAX_ZOOM);
        setViewRotation(handed.rotation + placementRotation);
        setZoom(handed.zoom);
        setPanOffset(handed.pan);
        rememberOpening(function() {
            return applyOpening(resolve, placementRotation);
        });
        return true;
    }, [
        paneRect2,
        rememberOpening,
        setPanOffset,
        setViewRotation,
        setZoom
    ]);
    var fitOpening = useCallback23(function(outline, rotation) {
        var viewport = paneViewport();
        if (!viewport || viewport.width <= 0 || viewport.height <= 0) return false;
        var fit = clampViewZoom(planViewFit(outline, rotation, viewport), viewport, EDITOR_MIN_ZOOM, EDITOR_MAX_ZOOM);
        setZoom(fit.zoom);
        setPanOffset(fit.pan);
        rememberOpening(function() {
            return fitOpening(outline, rotation);
        });
        return true;
    }, [
        paneViewport,
        rememberOpening,
        setPanOffset,
        setZoom
    ]);
    useEffect46(function() {
        if (!floorKey || floorKey === prevFloorKeyRef.current) return;
        var mounting = prevFloorKeyRef.current === null;
        prevFloorKeyRef.current = floorKey;
        openedAtRef.current = null;
        var _openingRef_current = openingRef.current, outline = _openingRef_current.drawingOutline, placementView = _openingRef_current.placementView;
        var resolveInitial = mounting && !aligning ? initialViewRef.current : void 0;
        if (resolveInitial && applyOpening(resolveInitial, placementView.rotation)) return;
        if (aligning || !outline) {
            handleFitRef.current();
            return;
        }
        var viewport = paneViewport();
        if (!viewport || viewport.width <= 0 || viewport.height <= 0) return;
        var rotation = stageRotationRef.current;
        if (mounting) {
            setViewRotation(0);
            rotation = effectiveViewRotation(0, placementView);
        }
        fitOpening(outline, rotation);
    }, [
        floorKey
    ]);
    useEffect46(function() {
        var opened = openedAtRef.current;
        if (!opened || !paneSize.measured) return;
        var pane = paneRect2();
        if (pane.width === opened.width && pane.height === opened.height) return;
        if (!viewIsOpening() || !opened.reopen()) openedAtRef.current = null;
    }, [
        paneSize.width,
        paneSize.height,
        paneSize.measured,
        paneRect2,
        viewIsOpening
    ]);
    var flyRequest = useEditorStore49(function(s) {
        return s.flyRequest;
    });
    var clearFlyRequest = useEditorStore49(function(s) {
        return s.clearFlyRequest;
    });
    var flightFrameRef = useRef42(null);
    var cancelFlight = useCallback23(function() {
        if (flightFrameRef.current !== null) cancelAnimationFrame(flightFrameRef.current);
        flightFrameRef.current = null;
    }, []);
    cancelFlightRef.current = cancelFlight;
    useEffect46(function() {
        return cancelFlight;
    }, [
        cancelFlight
    ]);
    var setZoomByOperator = useCallback23(function(next) {
        cancelFlight();
        setZoom(next);
    }, [
        cancelFlight,
        setZoom
    ]);
    var setPanByOperator = useCallback23(function(next) {
        cancelFlight();
        setPanOffset(next);
    }, [
        cancelFlight,
        setPanOffset
    ]);
    var designRef = useRef42(design);
    designRef.current = design;
    useEffect46(function() {
        if (!flyRequest) return void 0;
        var request = flyRequest;
        var aim = function() {
            var point = entityWorldCentre2(designRef.current, request.id);
            var viewport = paneViewport();
            if (!point || !viewport || viewport.width <= 0 || viewport.height <= 0) return null;
            var _useEditorStore49_getState = useEditorStore49.getState(), zoomNow = _useEditorStore49_getState.zoom, pan = _useEditorStore49_getState.panOffset, planViewInsets = _useEditorStore49_getState.planViewInsets;
            var centred = centreViewOn(point, {
                zoom: zoomNow,
                rotation: stageRotationRef.current,
                viewport: viewport
            });
            var area = clearAreaOf(viewport, planViewInsets);
            var target = {
                x: centred.x + area.centre.x - viewport.width / 2,
                y: centred.y + area.centre.y - viewport.height / 2
            };
            var drawnAt = {
                x: viewport.width / 2 + pan.x - centred.x,
                y: viewport.height / 2 + pan.y - centred.y
            };
            return {
                target: target,
                drawnAt: drawnAt,
                area: area
            };
        };
        var waited = 0;
        var frame = requestAnimationFrame(function start() {
            var pane = paneViewport();
            var measured = !!pane && pane.width > 0 && pane.height > 0;
            if (!measured && waited++ < FLY_PANE_WAIT_FRAMES) {
                frame = requestAnimationFrame(start);
                return;
            }
            clearFlyRequest();
            cancelFlight();
            var first = aim();
            if (!first) return;
            if (request.onlyIfHidden && isInsideClearArea(first.drawnAt, first.area)) return;
            var setPan = useEditorStore49.getState().setPanOffset;
            if (prefersReducedMotion()) {
                setPan(first.target);
                return;
            }
            var from = _object_spread({}, useEditorStore49.getState().panOffset);
            var _useEditorStore49_getState = useEditorStore49.getState(), startZoom = _useEditorStore49_getState.zoom, startRotation = _useEditorStore49_getState.viewRotation;
            var wrote = from;
            var startedAt = null;
            var step = function(now) {
                flightFrameRef.current = null;
                var view = useEditorStore49.getState();
                if (view.zoom !== startZoom || view.viewRotation !== startRotation || view.panOffset.x !== wrote.x || view.panOffset.y !== wrote.y) {
                    return;
                }
                var goal = aim();
                if (!goal) return;
                if (startedAt === null) startedAt = now;
                var t = Math.min(1, (now - startedAt) / FLY_DURATION_MS);
                var e = hermiteEase(0, 0, t);
                wrote = t >= 1 ? goal.target : {
                    x: from.x + (goal.target.x - from.x) * e,
                    y: from.y + (goal.target.y - from.y) * e
                };
                setPan(wrote);
                if (t < 1) flightFrameRef.current = requestAnimationFrame(step);
            };
            flightFrameRef.current = requestAnimationFrame(step);
        });
        return function() {
            return cancelAnimationFrame(frame);
        };
    }, [
        flyRequest
    ]);
    var frameRequest = useEditorStore49(function(s) {
        return s.frameRequest;
    });
    var clearFrameRequest = useEditorStore49(function(s) {
        return s.clearFrameRequest;
    });
    var fitToWorldBoundsRef = useRef42(fitToWorldBounds);
    fitToWorldBoundsRef.current = fitToWorldBounds;
    useEffect46(function() {
        if (!frameRequest) return;
        var frame = requestAnimationFrame(function() {
            var box = entitiesWorldBounds(designRef.current, frameRequest.ids);
            if (box) fitToWorldBoundsRef.current(box.minX, box.minY, box.maxX, box.maxY, SEARCH_FRAME_MAX_ZOOM);
            clearFrameRequest();
        });
        return function() {
            return cancelAnimationFrame(frame);
        };
    }, [
        frameRequest,
        clearFrameRequest
    ]);
    var prevToolModeRef = useRef42(toolMode);
    useEffect46(function() {
        if (toolMode === "calibrate_scale" && prevToolModeRef.current !== "calibrate_scale") {
            handleFitRef.current();
        }
        prevToolModeRef.current = toolMode;
    }, [
        toolMode
    ]);
    var drawOrder = useMemo26(function() {
        var _design_items;
        var items = (_design_items = design === null || design === void 0 ? void 0 : design.items) !== null && _design_items !== void 0 ? _design_items : [];
        var selected2 = new Set(selectedIds);
        return _to_consumable_array(items).sort(function(a, b) {
            return Number(selected2.has(a.refid)) - Number(selected2.has(b.refid));
        });
    }, [
        design,
        selectedIds
    ]);
    var handlePaneKeyDown = function(e) {
        if (e.target !== e.currentTarget) return;
        if (e.key === "Enter" && toolMode === "place_camera" && !aligning) {
            e.preventDefault();
            if (paneSize.width <= 0 || paneSize.height <= 0) {
                announce("The plan isn\u2019t ready to place a camera yet.");
                return;
            }
            var refid = placeCameraAt({
                x: paneSize.width / 2,
                y: paneSize.height / 2
            }, e.shiftKey);
            if (!refid) return;
            announce("Camera placed at the centre of the view. Use the arrow keys to move it.");
            window.requestAnimationFrame(function() {
                var _cameraLayerRef_current_querySelector, _cameraLayerRef_current;
                (_cameraLayerRef_current = cameraLayerRef.current) === null || _cameraLayerRef_current === void 0 ? void 0 : (_cameraLayerRef_current_querySelector = _cameraLayerRef_current.querySelector('[data-camera-refid="'.concat(CSS.escape(refid), '"]'))) === null || _cameraLayerRef_current_querySelector === void 0 ? void 0 : _cameraLayerRef_current_querySelector.focus();
            });
            return;
        }
        var modified = e.ctrlKey || e.metaKey || e.altKey;
        if (itemEditing === "host" && entitiesEditable && !aligning && !modified && isNudgeKey(e.key)) {
            var nudged = nudgeSelectedItem(e.key, e.shiftKey, stageRotation);
            if (nudged) {
                e.preventDefault();
                if (nudgeSettle.current) clearTimeout(nudgeSettle.current);
                nudgeSettle.current = setTimeout(function() {
                    return announce(nudgeAnnouncement(nudged));
                }, NUDGE_RUN_MS);
                return;
            }
        }
        var next = scrollPlanByKey(e, {
            bounds: scrollBounds,
            zoom: zoom,
            rotation: stageRotation,
            pan: panOffset,
            viewport: paneSize
        });
        if (!next) return;
        e.preventDefault();
        setPanOffset(next);
    };
    var driverFloors = useMemo26(function() {
        return shownFloors ? shownFloors.map(function(f) {
            return {
                floorId: f.id,
                design: findLatestDesign19(f.designs),
                placement: placementOf5(f)
            };
        }) : floor && design ? [
            {
                floorId: floor.id,
                // The space a reshape is moving, at its previewed outline, as it is drawn.
                design: previewing ? _object_spread_props(_object_spread({}, design), {
                    surfaces: shownSurfaces
                }) : design,
                placement: null
            }
        ] : [];
    }, [
        shownFloors,
        floor,
        design,
        previewing,
        shownSurfaces
    ]);
    var pdfDecoded = function(u) {
        return !!underlaySrcs[u.id] && decodedSrcs[u.id] === underlaySrcs[u.id];
    };
    var handleOwners = useMemo26(function() {
        if (process.env.NODE_ENV === "production") return NO_HANDLE_OWNERS;
        var single = singleSelectedCamera(drawnCameras, selectedIds);
        var camera = !aligning && caps.cameraControls !== "none" && toolMode === "select" && single ? {
            refid: single.camera.refid,
            controls: caps.cameraControls
        } : null;
        var _design_walls;
        return {
            // `plan-machine-rotate-ring` R12: the 3D editor reports its turn rings' owners over this;
            // nothing else draws a machine's turn handle.
            rotate: [],
            corners: aligning ? [] : cornersShownFor({
                selectedIds: selectedIds,
                editable: entitiesEditable,
                toolMode: toolMode
            }),
            edges: edgeSurface,
            wallEnds: aligning ? [] : wallEndsShownFor({
                selectedIds: selectedIds,
                editable: entitiesEditable,
                toolMode: toolMode,
                walls: (_design_walls = design === null || design === void 0 ? void 0 : design.walls) !== null && _design_walls !== void 0 ? _design_walls : []
            }),
            camera: camera,
            // `edit-pdf-stack` R7.2: the selected PDF's knob, as `UnderlaySelectionHandles` shows it.
            underlay: underlayKnobOwner({
                aligning: aligning,
                toolMode: toolMode,
                selected: scaleTarget ? {
                    underlay: scaleTarget.underlay,
                    onScreen: scaleTarget.drawn && pdfDecoded(scaleTarget.underlay)
                } : null
            }),
            // `edit-build-floors` R6.1: the selected floor's move handle and knob, by the one rule both
            // renderers mount them with.
            floor: aligning && layout ? floorHandleOwner({
                aligning: aligning,
                toolMode: toolMode,
                floors: layout.floors,
                activeFloorIndex: activeFloorIndex,
                visibility: floorVisibility,
                footprintOf: footprintOf
            }) : null
        };
    }, [
        scaleTarget,
        underlaySrcs,
        decodedSrcs,
        aligning,
        caps.cameraControls,
        toolMode,
        selectedIds,
        drawnCameras,
        design,
        entitiesEditable,
        edgeSurface,
        layout,
        activeFloorIndex,
        floorVisibility
    ]);
    var _useState466 = _sliced_to_array(useState46(function() {
        return process.env.NODE_ENV === "production" ? void 0 : createPlanDriverMarkStore();
    }), 1), driverMarks = _useState466[0];
    var _floor_id, _scaleTarget_underlay_id;
    var driver = {
        name: "plan",
        element: paneRef,
        view: planView,
        live: livePlanView,
        floors: driverFloors,
        activeFloorId: (_floor_id = floor === null || floor === void 0 ? void 0 : floor.id) !== null && _floor_id !== void 0 ? _floor_id : null,
        selectedIds: selectedIds,
        drawsCameras: !aligning,
        select: function(refid, shift, kind) {
            var _useFloorplanStore56_getState_layout;
            if (kind !== "underlay") return selectEntity(refid, shift);
            var found = findUnderlay((_useFloorplanStore56_getState_layout = useFloorplanStore56.getState().layout) === null || _useFloorplanStore56_getState_layout === void 0 ? void 0 : _useFloorplanStore56_getState_layout.floors, refid);
            if (found) selectUnderlayOnFloor(refid, found.floorIndex);
        },
        selectedUnderlayId: (_scaleTarget_underlay_id = scaleTarget === null || scaleTarget === void 0 ? void 0 : scaleTarget.underlay.id) !== null && _scaleTarget_underlay_id !== void 0 ? _scaleTarget_underlay_id : null,
        /*
     * `edit-pdf-stack` R7.1: the PDFs this canvas draws, as drawn now: Build floors draws every drawn
     * floor's, Edit floor the active floor's. Only those whose image is on screen.
     */ underlays: function() {
            var _layout_floors;
            var floors = (_layout_floors = layout === null || layout === void 0 ? void 0 : layout.floors) !== null && _layout_floors !== void 0 ? _layout_floors : [];
            var preview = useEditorStore49.getState().underlayPreview;
            var drawn = aligning ? drawnUnderlaysInOrder(floors, activeFloorIndex, floorVisibility, pdfDecoded) : activeUnderlays.filter(function(u) {
                return u.visible && pdfDecoded(u);
            }).map(function(underlay) {
                return {
                    underlay: underlay,
                    floorIndex: activeFloorIndex
                };
            });
            return drawn.flatMap(function(param) {
                var underlay = param.underlay, floorIndex = param.floorIndex;
                var _findLatestDesign19;
                var f = floors[floorIndex];
                if (!f) return [];
                var _findLatestDesign19_underlays;
                var stack = (_findLatestDesign19_underlays = (_findLatestDesign19 = findLatestDesign19(f.designs)) === null || _findLatestDesign19 === void 0 ? void 0 : _findLatestDesign19.underlays) !== null && _findLatestDesign19_underlays !== void 0 ? _findLatestDesign19_underlays : [];
                return [
                    {
                        underlay: applyUnderlayPreview(underlay, preview),
                        floorId: f.id,
                        stackIndex: stack.findIndex(function(x) {
                            return x.id === underlay.id;
                        })
                    }
                ];
            });
        },
        toolMode: toolMode,
        editable: entitiesEditable,
        lookOf: function(kind, refid, floorId) {
            if (kind === "camera") {
                var camera = drawnCameraList.find(function(c) {
                    return c.refid === refid;
                });
                return camera ? coneLook(camera, {
                    selectedIds: selectedIds,
                    litRefid: litCameraRefid
                }) : null;
            }
            if (aligning) {
                if (kind === "machine") return "neutral";
                if (kind === "space") {
                    return spaceLook(refid, _object_spread_props(_object_spread({}, ALIGN_LOOK_CONTEXT), {
                        faint: floorId !== (floor === null || floor === void 0 ? void 0 : floor.id)
                    }));
                }
                return null;
            }
            if (kind === "machine") return planMachineAppearance(refid, lookContext).status;
            if (kind === "space") return spaceLook(refid, lookContext);
            return null;
        },
        cameraShown: function(camera) {
            return applyCameraPreview(camera, cameraPreview.get());
        },
        contentBounds: scrollBounds,
        handleOwners: handleOwners,
        // `edit-build-floors` R6.2: Build floors' floors, each at its placement as drawn.
        buildFloors: aligning && layout ? {
            floors: layout.floors,
            activeFloorIndex: activeFloorIndex,
            visibility: floorVisibility,
            footprintOf: footprintOf
        } : null,
        floorPlacementShown: function(floorId) {
            var preview = useEditorStore49.getState().floorPlacementPreview;
            return (preview === null || preview === void 0 ? void 0 : preview.floorId) === floorId ? preview.placement : null;
        },
        armedEdge: armedEdge,
        drawnSize: paneSize,
        marks: function() {
            var _driverMarks_getSnapshot;
            return (_driverMarks_getSnapshot = driverMarks === null || driverMarks === void 0 ? void 0 : driverMarks.getSnapshot()) !== null && _driverMarks_getSnapshot !== void 0 ? _driverMarks_getSnapshot : [];
        }
    };
    var forwardWheel = useCallback23(function(evt) {
        return stageHandleRef.current.forwardWheel(evt);
    }, []);
    return {
        driver: driver,
        driverMarks: driverMarks,
        viewIsOpening: viewIsOpening,
        edgeSurface: edgeSurface,
        /** The drawing's wheel hand-off, for the overlays over it. */ forwardWheel: forwardWheel,
        activeFloorIndex: activeFloorIndex,
        activeStreamDrag: activeStreamDrag,
        activeUnderlays: activeUnderlays,
        /** Build floors: every drawn floor's PDFs, bottom of each stack first (`edit-pdf-stack`). */ alignUnderlays: alignUnderlays,
        aligning: aligning,
        announce: announce,
        announceItemRotated: announceItemRotated,
        announceItemsRotated: announceItemsRotated,
        announceScaleSet: announceScaleSet,
        answerFor: answerFor,
        armedEdge: armedEdge,
        cameraEdited: cameraEdited,
        cameraLayerRef: cameraLayerRef,
        cameraPreview: cameraPreview,
        caps: caps,
        clearSelection: clearSelection,
        cornerSurface: cornerSurface,
        decodedSrcs: decodedSrcs,
        design: design,
        dragPanTo: dragPanTo,
        drawOrder: drawOrder,
        drawRefusal: drawRefusal,
        drawnCameraList: drawnCameraList,
        drawnCameras: drawnCameras,
        endDrag: endDrag,
        entitiesEditable: entitiesEditable,
        entityLayerRef: entityLayerRef,
        equipmentDragActive: equipmentDragActive,
        equipmentDragStore: equipmentDragStore,
        facingBounds: facingBounds,
        floor: floor,
        floorVisibility: floorVisibility,
        handleAnchors: handleAnchors,
        handleEntityHover: handleEntityHover,
        handleFitToScreen: handleFitToScreen,
        handlePaneKeyDown: handlePaneKeyDown,
        handleSpaceDrawn: handleSpaceDrawn,
        itemEditing: itemEditing,
        layout: layout,
        litCameraRefid: litCameraRefid,
        unlinkedCamerasAreWork: unlinkedCamerasAreWork,
        liveIdentities: liveIdentities,
        livePlanView: livePlanView,
        liveSurfaces: liveSurfaces,
        lookContext: lookContext,
        onSpaceDrawn: onSpaceDrawn,
        onStreamClaim: onStreamClaim,
        onStreamLinked: onStreamLinked,
        panOffset: panOffset,
        paneRef: paneRef,
        paneSize: paneSize,
        placeCameraAt: placeCameraAt,
        planView: planView,
        pointerHoverId: pointerHoverId,
        referenceOffered: referenceOffered,
        controlsInset: controlsInset,
        reportDecoded: reportDecoded,
        reportUndecodable: reportUndecodable,
        reportUndrawn: reportUndrawn,
        reshapeModifierHeld: reshapeModifierHeld2,
        reshapeOn: reshapeOn,
        reshapeStore: reshapeStore,
        retryUnderlays: retryUnderlays,
        rotationAnnouncement: rotationAnnouncement,
        scaleTarget: scaleTarget,
        scrollBounds: scrollBounds,
        selectedIds: selectedIds,
        selectedSet: selectedSet,
        setDrawRefusal: setDrawRefusal,
        setMousePosition: setMousePosition,
        setPanOffset: setPanByOperator,
        setZoom: setZoomByOperator,
        showMap: showMap,
        shownSurfaces: shownSurfaces,
        stageRotation: stageRotation,
        statusItems: statusItems,
        streamDragActive: streamDragActive,
        surfaceTagLook: surfaceTagLook,
        toolMode: toolMode,
        twinBid: twinBid,
        underlaySrcs: underlaySrcs,
        wallsCenter: wallsCenter,
        zoom: zoom
    };
};
// src/components/Planner/plannerCanvas/PlannerCanvasFrame.tsx
import { useCallback as useCallback25, useEffect as useEffect53, useRef as useRef47 } from "react";
import styled48 from "styled-components";
import { useScaleCalibrationStore as useScaleCalibrationStore3 } from "@repo/front-end-state";
// src/components/Planner/canvas/BuildFloorDragTag.tsx
import { useMemo as useMemo28 } from "react";
import styled40 from "styled-components";
import { Icon as Icon23, Tooltip } from "@repo/design-system";
import { useEditorStore as useEditorStore50, useFloorplanStore as useFloorplanStore57 } from "@repo/front-end-state";
import { findLatestDesign as findLatestDesign20, floorOutlineCentre as floorOutlineCentre2, floorPlaceLabel as floorPlaceLabel2, floorToWorld, planPointToPane } from "@repo/front-end-utils";
// src/components/Planner/planView/PlanViewContext.tsx
import { createContext as createContext13, useContext as useContext18, useMemo as useMemo27 } from "react";
import { jsx as jsx52 } from "react/jsx-runtime";
var PlanViewContext = createContext13(null);
var useStableView = function(param) {
    var zoom = param.zoom, _param_pan = param.pan, x = _param_pan.x, y = _param_pan.y, rotation = param.rotation;
    return useMemo27(function() {
        return {
            zoom: zoom,
            pan: {
                x: x,
                y: y
            },
            rotation: rotation
        };
    }, [
        zoom,
        x,
        y,
        rotation
    ]);
};
var PlanViewProvider = function(param) {
    var view = param.view, _param_live = param.live, live = _param_live === void 0 ? view : _param_live, children = param.children;
    var settled = useStableView(view);
    var current2 = useStableView(live);
    var value = useMemo27(function() {
        return {
            view: settled,
            live: current2
        };
    }, [
        settled,
        current2
    ]);
    return /* @__PURE__ */ jsx52(PlanViewContext.Provider, {
        value: value,
        children: children
    });
};
var usePlanViewValue = function(hook) {
    var value = useContext18(PlanViewContext);
    if (!value) throw new Error("".concat(hook, " must be used inside a PlanViewProvider"));
    return value;
};
var usePlanView = function() {
    return usePlanViewValue("usePlanView").view;
};
var useLivePlanView = function() {
    return usePlanViewValue("useLivePlanView").live;
};
// src/components/Planner/canvas/BuildFloorDragTag.tsx
import { jsx as jsx53 } from "react/jsx-runtime";
var BuildFloorDragTag = function() {
    var view = usePlanView();
    var preview = useEditorStore50(function(s) {
        return s.floorPlacementPreview;
    });
    var floor = useFloorplanStore57(function(s) {
        var _s_layout;
        return preview ? (_s_layout = s.layout) === null || _s_layout === void 0 ? void 0 : _s_layout.floors.find(function(f) {
            return f.id === preview.floorId;
        }) : void 0;
    });
    var design = floor ? findLatestDesign20(floor.designs) : null;
    var footprintOf = usePlanMachineFootprints();
    var centre = useMemo28(function() {
        return floorOutlineCentre2(design, footprintOf);
    }, [
        design,
        footprintOf
    ]);
    if (!preview || !floor) return null;
    var pane = planPointToPane(floorToWorld(centre, preview.placement), view);
    return /* @__PURE__ */ jsx53(Overlay, {
        "aria-hidden": "true",
        children: /* @__PURE__ */ jsx53(Tooltip, {
            open: true,
            anchor: {
                x: pane.x,
                y: pane.y + HANDLE_STYLES.glyphDisc.size / 2
            },
            placement: "bottom",
            arrow: false,
            tone: "cyan",
            icon: /* @__PURE__ */ jsx53(Icon23, {
                name: "layer-group",
                variant: "solid"
            }),
            title: "".concat(floor.name, " \xb7 ").concat(floorPlaceLabel2(preview.placement))
        })
    });
};
var Overlay = styled40.div(_templateObject175());
// src/components/Planner/canvas/CanvasBannerHost.tsx
import styled41 from "styled-components";
var CanvasBannerHost = styled41.div(_templateObject176(), function(param) {
    var theme2 = param.theme;
    return theme2.spacing[3];
}, function(param) {
    var theme2 = param.theme;
    return theme2.zIndex.sticky;
}, function(param) {
    var theme2 = param.theme;
    return theme2.spacing[8];
}, function(param) {
    var theme2 = param.theme;
    return theme2.spacing[2];
});
// src/components/Planner/canvas/DropStatusBanner.tsx
import { useEffect as useEffect47, useRef as useRef43, useState as useState47 } from "react";
import styled42 from "styled-components";
import { Banner as Banner4, Button as Button23 } from "@repo/design-system";
import { Fragment as Fragment27, jsx as jsx54, jsxs as jsxs38 } from "react/jsx-runtime";
var RetryRow4 = styled42.div(_templateObject177(), function(param) {
    var theme2 = param.theme;
    return theme2.spacing[2];
});
var RecoveredFocusTarget = styled42.div(_templateObject178());
function DropStatusBanner(param) {
    var status = param.status, onDismiss = param.onDismiss;
    var _useState47 = _sliced_to_array(useState47(false), 2), recovered = _useState47[0], setRecovered = _useState47[1];
    var previousKind = useRef43(status.kind);
    var retryRef = useRef43(null);
    var recoveredRef = useRef43(null);
    var retryHeldFocus = useRef43(false);
    useEffect47(function() {
        var was = previousKind.current;
        previousKind.current = status.kind;
        if (was === "degraded" && status.kind === "idle") setRecovered(true);
        if (status.kind === "degraded") setRecovered(false);
    }, [
        status.kind
    ]);
    useEffect47(function() {
        var _recoveredRef_current;
        if (recovered && retryHeldFocus.current) (_recoveredRef_current = recoveredRef.current) === null || _recoveredRef_current === void 0 ? void 0 : _recoveredRef_current.focus();
    }, [
        recovered
    ]);
    if (status.kind === "idle" && recovered) {
        return /* @__PURE__ */ jsx54(Fragment27, {
            children: /* @__PURE__ */ jsx54(Banner4, {
                tone: "success",
                surface: "on-solid",
                role: "status",
                title: "This twin\u2019s current model was read.",
                onDismiss: function() {
                    return setRecovered(false);
                },
                dismissLabel: "Dismiss this message",
                children: /* @__PURE__ */ jsx54(RecoveredFocusTarget, {
                    ref: recoveredRef,
                    tabIndex: -1,
                    children: "New equipment now gets an identity the model does not already hold, so this plan can be saved."
                })
            }, "recovered")
        });
    }
    if (status.kind === "idle") return null;
    if (status.kind === "pending") {
        return /* @__PURE__ */ jsx54(Fragment27, {
            children: /* @__PURE__ */ jsx54(Banner4, {
                tone: "info",
                surface: "on-solid",
                title: "Adding to the Asset Register\u2026",
                children: "Every placement is recorded as an asset, so it appears in this twin\u2019s Equipment list."
            }, "pending")
        });
    }
    if (status.kind === "degraded") {
        return /* @__PURE__ */ jsx54(Fragment27, {
            children: /* @__PURE__ */ jsxs38(Banner4, {
                tone: "warning",
                surface: "on-solid",
                role: "alert",
                title: "This twin\u2019s current model could not be read.",
                children: [
                    status.message,
                    /* @__PURE__ */ jsx54(RetryRow4, {
                        children: /* @__PURE__ */ jsx54(Button23, {
                            ref: retryRef,
                            variant: "ghost",
                            size: "xs",
                            "aria-label": status.retryLabel,
                            onClick: status.onRetry,
                            onFocus: function() {
                                retryHeldFocus.current = true;
                            },
                            onBlur: function() {
                                retryHeldFocus.current = false;
                            },
                            loading: status.busy,
                            children: status.busy ? "Retrying\u2026" : "Retry"
                        })
                    })
                ]
            }, "degraded")
        });
    }
    var _status_title;
    return /* @__PURE__ */ jsx54(Fragment27, {
        children: /* @__PURE__ */ jsx54(Banner4, {
            tone: "error",
            surface: "on-solid",
            title: (_status_title = status.title) !== null && _status_title !== void 0 ? _status_title : "Nothing was placed",
            onDismiss: onDismiss,
            dismissLabel: "Dismiss this message",
            children: status.message
        }, "error")
    });
}
// src/components/Planner/canvas/EquipmentDropOverlay.tsx
import { useEffect as useEffect49, useMemo as useMemo30 } from "react";
import { Icon as Icon25, Tooltip as Tooltip3 } from "@repo/design-system";
import { useFloorplanStore as useFloorplanStore58 } from "@repo/front-end-state";
import { equipmentDropHint } from "@repo/front-end-utils";
// src/components/Planner/canvas/StreamDropOverlay.tsx
import { useEffect as useEffect48, useMemo as useMemo29, useRef as useRef44 } from "react";
import styled43 from "styled-components";
import { Icon as Icon24, Tooltip as Tooltip2 } from "@repo/design-system";
import { ink as ink13, inset as inset8, surface as surface7 } from "@repo/design-tokens";
import { cameraDisplayName as cameraDisplayName3, planPointToPane as planPointToPane2 } from "@repo/front-end-utils";
import { jsx as jsx55, jsxs as jsxs39 } from "react/jsx-runtime";
var CROSSHAIR_HALF_PX = 11;
var OVERLAY_Z = 4;
var Layer = styled43.div(_templateObject179(), OVERLAY_Z);
var Crosshair = styled43.span(_templateObject180(), inset8[6], inset8[6], ink13[1], inset8[1], surface7[0], inset8[1], surface7[0]);
var DropOverlayLayer = Layer;
var HINT_ICON = {
    plus: /* @__PURE__ */ jsx55(Icon24, {
        name: "plus",
        variant: "solid"
    }),
    "arrow-right-arrow-left": /* @__PURE__ */ jsx55(Icon24, {
        name: "arrow-right-arrow-left",
        variant: "solid"
    }),
    link: /* @__PURE__ */ jsx55(Icon24, {
        name: "link",
        variant: "solid"
    }),
    "circle-exclamation": /* @__PURE__ */ jsx55(Icon24, {
        name: "circle-exclamation",
        variant: "solid"
    })
};
var opposite = function(side) {
    return side === "left" ? "right" : "left";
};
var StreamDropOverlay = function(param) {
    var store = param.store, answerFor = param.answerFor, drag = param.drag, cameras = param.cameras, paneSize = param.paneSize, selectedIds = param.selectedIds;
    var view = usePlanView();
    var point = useStreamDragPoint(store);
    var reportedThrow = useRef44(false);
    useEffect48(function() {
        reportedThrow.current = false;
    }, [
        drag
    ]);
    var answer = useMemo29(function() {
        return point ? answerFor(point, function(error) {
            if (reportedThrow.current) return;
            reportedThrow.current = true;
            console.error("[StreamDropOverlay] onStreamClaimCheck threw; no hint is shown.", error);
        }) : null;
    }, [
        point,
        answerFor
    ]);
    if (!point || !drag || !answer) return null;
    var hintSide = sideLabelPlacement(point.pane.x, paneSize.width, "left", DROP_LABEL_ROOM_PX);
    var link = answer.link;
    var linkCentre = link ? planPointToPane2(link, view) : null;
    var markerHalf = CAMERA_MARKER_SIZE_PX / 2;
    var linkSelected = !!link && selectedIds.length === 1 && selectedIds[0] === link.refid;
    var linkSide = !linkCentre ? "right" : linkSelected ? opposite(sideLabelPlacement(linkCentre.x, paneSize.width, "right")) : sideLabelPlacement(linkCentre.x, paneSize.width, "right", DROP_LABEL_ROOM_PX);
    var preview = answer.preview;
    var _preview_fovAngle, _preview_detectionDistance;
    return /* @__PURE__ */ jsxs39(Layer, {
        "aria-hidden": "true",
        "data-testid": "stream-drop-overlay",
        children: [
            /* @__PURE__ */ jsx55(Crosshair, {
                className: "tl-plan-cam-cross",
                "data-testid": "stream-drop-crosshair",
                "data-x": preview === null || preview === void 0 ? void 0 : preview.x,
                "data-y": preview === null || preview === void 0 ? void 0 : preview.y,
                "data-rotation": preview === null || preview === void 0 ? void 0 : preview.rotation,
                "data-fov": (_preview_fovAngle = preview === null || preview === void 0 ? void 0 : preview.fovAngle) !== null && _preview_fovAngle !== void 0 ? _preview_fovAngle : void 0,
                "data-distance": (_preview_detectionDistance = preview === null || preview === void 0 ? void 0 : preview.detectionDistance) !== null && _preview_detectionDistance !== void 0 ? _preview_detectionDistance : void 0,
                style: {
                    left: point.pane.x,
                    top: point.pane.y
                },
                children: /* @__PURE__ */ jsx55(Icon24, {
                    name: "crosshairs",
                    variant: "solid"
                })
            }),
            answer.hint ? /* @__PURE__ */ jsx55(Tooltip2, {
                open: true,
                anchor: {
                    x: hintSide === "left" ? point.pane.x - CROSSHAIR_HALF_PX : point.pane.x + CROSSHAIR_HALF_PX,
                    y: point.pane.y
                },
                placement: hintSide,
                arrow: false,
                tone: answer.hint.tone,
                icon: answer.hint.icon ? HINT_ICON[answer.hint.icon] : void 0,
                title: answer.hint.text,
                className: "stream-drop-hint"
            }) : null,
            link && linkCentre ? /* @__PURE__ */ jsx55(Tooltip2, {
                open: true,
                anchor: {
                    x: linkSide === "right" ? linkCentre.x + markerHalf : linkCentre.x - markerHalf,
                    y: linkCentre.y
                },
                placement: linkSide,
                arrow: false,
                tone: "butter",
                icon: HINT_ICON.link,
                title: "Or drop on ".concat(nameOf(cameras, link.refid), " to link it"),
                className: "stream-drop-link"
            }) : null
        ]
    });
};
var nameOf = function(cameras, refid) {
    var drawn = cameras.find(function(c) {
        return c.camera.refid === refid;
    });
    return drawn ? cameraDisplayName3(drawn.camera, drawn.index) : "the camera";
};
// src/components/Planner/canvas/EquipmentDropOverlay.tsx
import { Fragment as Fragment28, jsx as jsx56, jsxs as jsxs40 } from "react/jsx-runtime";
var EquipmentDropOverlay = function(param) {
    var pointStore = param.point, drag = param.drag, paneSize = param.paneSize;
    var point = useStreamDragPoint(pointStore);
    var hint = useMemo30(function() {
        return point ? equipmentDropHint(point.snapped, useFloorplanStore58.getState().getActiveDesign()) : null;
    }, [
        point
    ]);
    useEffect49(function() {
        return drag.setHint(hint);
    }, [
        hint,
        drag
    ]);
    var onFloor = (hint === null || hint === void 0 ? void 0 : hint.floor) === true;
    var carried = isCarriedDrag(drag, useEquipmentDragState(drag).drag);
    var side = point ? sideLabelPlacement(point.pane.x, paneSize.width, "right", DROP_LABEL_ROOM_PX) : "right";
    return /* @__PURE__ */ jsxs40(Fragment28, {
        children: [
            /* @__PURE__ */ jsx56("span", {
                role: "status",
                style: visuallyHidden,
                children: point && onFloor ? FLOOR_WARNING : ""
            }),
            point && !carried ? /* @__PURE__ */ jsxs40(DropOverlayLayer, {
                "aria-hidden": "true",
                "data-testid": "equipment-drop-overlay",
                children: [
                    /* @__PURE__ */ jsx56(Crosshair, {
                        className: "tl-plan-cam-cross tl-plan-equipment-cross",
                        "data-testid": "equipment-drop-crosshair",
                        style: {
                            left: point.pane.x,
                            top: point.pane.y
                        },
                        children: /* @__PURE__ */ jsx56(Icon25, {
                            name: "crosshairs",
                            variant: "solid"
                        })
                    }),
                    onFloor ? /* @__PURE__ */ jsx56(Tooltip3, {
                        open: true,
                        anchor: {
                            x: point.pane.x + (side === "right" ? CROSSHAIR_HALF_PX : -CROSSHAIR_HALF_PX),
                            y: point.pane.y
                        },
                        placement: side,
                        arrow: false,
                        tone: "butter",
                        icon: /* @__PURE__ */ jsx56(Icon25, {
                            name: "triangle-exclamation",
                            variant: "solid"
                        }),
                        title: FLOOR_WARNING,
                        className: "equipment-drop-floor"
                    }) : null
                ]
            }) : null
        ]
    });
};
// src/components/Planner/canvas/modelReadNotice.ts
var MODEL_READ_FAILED_NOTICE = "New equipment may reuse an identity that already exists, so this plan cannot be saved yet. Retry, then save.";
var MODEL_READ_RETRY_LABEL = "Retry reading the twin's current model";
// src/components/Planner/canvas/PlanCameraLayer.tsx
import { Fragment as Fragment29, useCallback as useCallback24, useEffect as useEffect50, useRef as useRef45, useState as useState48, useSyncExternalStore as useSyncExternalStore6 } from "react";
import styled44, { css as css5 } from "styled-components";
import { cameraDisplayName as cameraDisplayName4, CAMERA_DISTANCE_MIN as CAMERA_DISTANCE_MIN2, effectiveCoverage as effectiveCoverage2, findLatestDesign as findLatestDesign21, normaliseRotation as normaliseRotation8, snapPlannerPoint as snapPlannerPoint5, panePointToPlan, planPointToPane as planPointToPane3, screenDirectionToPlanDelta as screenDirectionToPlanDelta2 } from "@repo/front-end-utils";
import { useEditorStore as useEditorStore51, useFloorplanStore as useFloorplanStore59, selectionOnFloorShown as selectionOnFloorShown11 } from "@repo/front-end-state";
import { Icon as Icon26, Tooltip as Tooltip4 } from "@repo/design-system";
import { focus as focus4, inkOn as inkOn4, radius as radius10, surface as surface8 } from "@repo/design-tokens";
import { jsx as jsx57, jsxs as jsxs41 } from "react/jsx-runtime";
var NO_DRAG_POINT = createStreamDragPointStore();
var DRAG_THRESHOLD_PX = 3;
var HANDLE_SIZE_PX = 20;
var WIDEN_SHIFT_STEP_DEG = 5;
var ARROWS2 = {
    ArrowLeft: {
        x: -1,
        y: 0
    },
    ArrowRight: {
        x: 1,
        y: 0
    },
    ArrowUp: {
        x: 0,
        y: -1
    },
    ArrowDown: {
        x: 0,
        y: 1
    }
};
var Layer2 = styled44.div(_templateObject181());
var markerLook = function(look) {
    var style = PLAN_CAMERA_MARKER_LOOKS[look];
    return css5(_templateObject182(), style.ring, style.ringStyle, style.shadow);
};
var Marker = styled44.button(_templateObject184(), CAMERA_MARKER_SIZE_PX, CAMERA_MARKER_SIZE_PX, radius10.pill, surface8[0], function(param) {
    var $glyph = param.$glyph;
    return $glyph;
}, function(param) {
    var $interactive = param.$interactive;
    return $interactive ? "auto" : "none";
}, function(param) {
    var $look = param.$look;
    return markerLook($look);
}, function(param) {
    var $selected = param.$selected;
    return $selected && css5(_templateObject183(), CAMERA_MARKER_SELECTED_SIZE_PX, CAMERA_MARKER_SELECTED_SIZE_PX);
}, focus4.ring);
var Handle = styled44.button(_templateObject186(), HANDLE_SIZE_PX, HANDLE_SIZE_PX, radius10.pill, surface8[0], PLAN_SELECTION_COLOUR, inkOn4.aqua, PLAN_CAMERA_SHADOWS.handle, function(param) {
    var $interactive = param.$interactive;
    return $interactive ? "auto" : "none";
}, PLAN_CAMERA_SHADOWS.handleHover, function(param) {
    var $dragging = param.$dragging;
    return $dragging && css5(_templateObject185(), PLAN_CAMERA_HANDLE_DRAGGING.fill, PLAN_CAMERA_HANDLE_DRAGGING.glyph);
}, focus4.ring);
var at = function(p) {
    return {
        transform: "translate(".concat(p.x, "px, ").concat(p.y, "px) translate(-50%, -50%)")
    };
};
var screenAngle = function(from, to, view) {
    var a = planPointToPane3(from, view);
    var b = planPointToPane3(to, view);
    return Math.atan2(b.y - a.y, b.x - a.x) * 180 / Math.PI;
};
var clientPoint = function(native) {
    var _native_changedTouches;
    if ("changedTouches" in native && ((_native_changedTouches = native.changedTouches) === null || _native_changedTouches === void 0 ? void 0 : _native_changedTouches.length)) {
        var t = native.changedTouches[0];
        return {
            x: t.clientX,
            y: t.clientY
        };
    }
    var m = native;
    return {
        x: m.clientX,
        y: m.clientY
    };
};
var PlanCameraLayer = function(param) {
    var cameras = param.cameras, paneSize = param.paneSize, caps = param.caps, litRefid = param.litRefid, _param_unlinkedIsWork = param.unlinkedIsWork, unlinkedIsWork = _param_unlinkedIsWork === void 0 ? false : _param_unlinkedIsWork, _param_streamDragActive = param.streamDragActive, streamDragActive = _param_streamDragActive === void 0 ? false : _param_streamDragActive, streamDragPointStore = param.streamDragPointStore, streamDropAnswerFor = param.streamDropAnswerFor, previewStore = param.previewStore, announce = param.announce, undoEnabled = param.undoEnabled, paneRef = param.paneRef, onWheel = param.onWheel, hostLayerRef = param.layerRef;
    var ownLayerRef = useRef45(null);
    var layerRef = hostLayerRef !== null && hostLayerRef !== void 0 ? hostLayerRef : ownLayerRef;
    var preview = useCameraPreview(previewStore);
    var onPreview = previewStore.set;
    var dragStore = streamDragPointStore !== null && streamDragPointStore !== void 0 ? streamDragPointStore : NO_DRAG_POINT;
    var replaceTargetRefid = useSyncExternalStore6(dragStore.subscribe, function() {
        var _answer_target;
        var point = dragStore.get();
        if (!streamDragActive || !point || !streamDropAnswerFor) return null;
        var answer = streamDropAnswerFor(point, function() {
            return void 0;
        });
        var _answer_target_refid;
        return (answer === null || answer === void 0 ? void 0 : answer.replace) ? (_answer_target_refid = (_answer_target = answer.target) === null || _answer_target === void 0 ? void 0 : _answer_target.refid) !== null && _answer_target_refid !== void 0 ? _answer_target_refid : null : null;
    }, // The admin planner renders on the server too: no drag there, so no target (Copilot review).
    function() {
        return null;
    });
    var view = usePlanView();
    var viewRef = useRef45(view);
    viewRef.current = view;
    var selectedIds = useEditorStore51(selectionOnFloorShown11);
    var toolMode = useEditorStore51(function(s) {
        return s.toolMode;
    });
    var selectEntity = useEditorStore51(function(s) {
        return s.selectEntity;
    });
    var setToolMode = useEditorStore51(function(s) {
        return s.setToolMode;
    });
    var cameraEdited = useCameraEdited();
    var _useState48 = _sliced_to_array(useState48(null), 2), dragging = _useState48[0], setDragging = _useState48[1];
    var stopGestureRef = useRef45(null);
    useEffect50(function() {
        return function() {
            var _stopGestureRef_current;
            (_stopGestureRef_current = stopGestureRef.current) === null || _stopGestureRef_current === void 0 ? void 0 : _stopGestureRef_current.call(stopGestureRef);
            previewStore.set(null);
        };
    }, [
        previewStore
    ]);
    var editable = caps.mutableKinds === "all" || caps.mutableKinds === "cameras";
    var pointerLive = editable && toolMode === "select";
    var single = singleSelectedCamera(cameras, selectedIds);
    var commitCameraEdit = useCallback24(function(refid, patch, message) {
        var _plan_layout, _findLatestDesign21_cameras;
        var editor = useEditorStore51.getState();
        var plan = useFloorplanStore59.getState();
        var floor = (_plan_layout = plan.layout) === null || _plan_layout === void 0 ? void 0 : _plan_layout.floors[plan.activeFloorIndex];
        var current2 = floor ? (_findLatestDesign21_cameras = findLatestDesign21(floor.designs).cameras) === null || _findLatestDesign21_cameras === void 0 ? void 0 : _findLatestDesign21_cameras.find(function(c) {
            return c.refid === refid;
        }) : void 0;
        if (!current2) return;
        if (undoEnabled && plan.layout) editor.pushSnapshot(plan.layout);
        editor.storeOriginalPosition(refid, current2.x, current2.y);
        plan.updateCamera(refid, patch);
        editor.markEntityModified(refid);
        cameraEdited();
        announce(message);
    }, [
        undoEnabled,
        cameraEdited,
        announce
    ]);
    var toPlan = useCallback24(function(client) {
        var _layerRef_current;
        var rect = (_layerRef_current = layerRef.current) === null || _layerRef_current === void 0 ? void 0 : _layerRef_current.getBoundingClientRect();
        var _rect_left, _rect_top;
        return panePointToPlan({
            x: client.x - ((_rect_left = rect === null || rect === void 0 ? void 0 : rect.left) !== null && _rect_left !== void 0 ? _rect_left : 0),
            y: client.y - ((_rect_top = rect === null || rect === void 0 ? void 0 : rect.top) !== null && _rect_top !== void 0 ? _rect_top : 0)
        }, viewRef.current);
    }, []);
    var endGesture = useCallback24(function() {
        stopGestureRef.current = null;
        setDragging(null);
        onPreview(null);
    }, [
        onPreview
    ]);
    var pressMarker = function(dc, native, shift) {
        if (!pointerLive || stopGestureRef.current) return;
        if (!("changedTouches" in native) && native.button !== 0) return;
        var camera = dc.camera, index = dc.index;
        if (!shift && !selectionOnFloorShown11(useEditorStore51.getState()).includes(camera.refid)) {
            selectEntity(camera.refid, false);
        }
        var start = clientPoint(native);
        if (!start) return;
        var startPlan = toPlan(start);
        var latest = null;
        var name = cameraDisplayName4(camera, index);
        stopGestureRef.current = startPointerGesture({
            page: true,
            native: native,
            onMove: function(pointer) {
                if (!latest && Math.hypot(pointer.x - start.x, pointer.y - start.y) < DRAG_THRESHOLD_PX) {
                    return false;
                }
                var p = toPlan(pointer);
                if (!latest) setDragging({
                    refid: camera.refid,
                    kind: "move"
                });
                latest = {
                    x: camera.x + p.x - startPlan.x,
                    y: camera.y + p.y - startPlan.y
                };
                onPreview({
                    refid: camera.refid,
                    patch: latest
                });
                return true;
            },
            onRelease: function(evt) {
                var moved = latest;
                if (moved) {
                    var _useEditorStore51_getState = useEditorStore51.getState(), gridSnap = _useEditorStore51_getState.gridSnap, gridSize = _useEditorStore51_getState.gridSize;
                    var free = (evt === null || evt === void 0 ? void 0 : evt.shiftKey) === true;
                    var to = snapPlannerPoint5(moved, {
                        gridSnap: gridSnap,
                        gridSizeCm: gridSize,
                        free: free
                    });
                    if (to.x !== camera.x || to.y !== camera.y) {
                        commitCameraEdit(camera.refid, to, "Moved ".concat(name));
                    }
                }
                endGesture();
            },
            onCancel: function() {
                if (latest) announce("Cancelled");
                endGesture();
            }
        });
    };
    var pressHandle = function(dc, kind, native) {
        var _native_preventDefault;
        if (!pointerLive || stopGestureRef.current) return;
        if (!("changedTouches" in native) && native.button !== 0) return;
        (_native_preventDefault = native.preventDefault) === null || _native_preventDefault === void 0 ? void 0 : _native_preventDefault.call(native);
        var camera = dc.camera, index = dc.index;
        var name = cameraDisplayName4(camera, index);
        var start = clientPoint(native);
        if (!start) return;
        var startPlan = toPlan(start);
        var latest = null;
        setDragging({
            refid: camera.refid,
            kind: kind
        });
        stopGestureRef.current = startPointerGesture({
            page: true,
            native: native,
            onMove: function(pointer) {
                if (!latest && Math.hypot(pointer.x - start.x, pointer.y - start.y) < DRAG_THRESHOLD_PX) {
                    return false;
                }
                latest = dragHandleValue(camera, kind, startPlan, toPlan(pointer));
                onPreview({
                    refid: camera.refid,
                    patch: latest
                });
                return true;
            },
            onRelease: function() {
                var patch = latest;
                var _effectiveCoverage2 = effectiveCoverage2(camera), fovAngle = _effectiveCoverage2.fovAngle, detectionDistance = _effectiveCoverage2.detectionDistance;
                if (patch) {
                    if (kind === "turn" && patch.rotation !== camera.rotation) {
                        commitCameraEdit(camera.refid, patch, "Turned ".concat(name, " to ").concat(turnReadout(patch.rotation)));
                    } else if (kind === "widen" && patch.fovAngle !== fovAngle) {
                        commitCameraEdit(camera.refid, patch, "Widened ".concat(name, " to ").concat(widenReadout(patch.fovAngle)));
                    } else if (kind === "reach" && patch.detectionDistance !== detectionDistance) {
                        commitCameraEdit(camera.refid, patch, "".concat(name, " reaches ").concat(reachReadout(patch.detectionDistance)));
                    }
                }
                endGesture();
            },
            onCancel: function() {
                if (latest) announce("Cancelled");
                endGesture();
            }
        });
    };
    var markerKeyDown = function(dc, e) {
        var camera = dc.camera, index = dc.index;
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            selectEntity(camera.refid, e.shiftKey);
            if (useEditorStore51.getState().toolMode !== "select") setToolMode("select");
            return;
        }
        var dir = ARROWS2[e.key];
        if (!dir) return;
        e.preventDefault();
        if (caps.cameraControls !== "all" || useEditorStore51.getState().toolMode !== "select") return;
        if (!selectionOnFloorShown11(useEditorStore51.getState()).includes(camera.refid)) return;
        var name = cameraDisplayName4(camera, index);
        if (e.shiftKey) {
            var rotation = turnByKey(camera.rotation, e.key === "ArrowRight" || e.key === "ArrowDown");
            commitCameraEdit(camera.refid, {
                rotation: rotation
            }, "Turned ".concat(name, " to ").concat(turnReadout(rotation)));
            return;
        }
        var delta = screenDirectionToPlanDelta2(dir, NUDGE_M, viewRef.current);
        commitCameraEdit(camera.refid, {
            x: camera.x + delta.x,
            y: camera.y + delta.y
        }, "Moved ".concat(name));
    };
    var handleKeyDown = function(dc, kind, e) {
        var step = e.key === "ArrowRight" || e.key === "ArrowUp" ? 1 : e.key === "ArrowLeft" || e.key === "ArrowDown" ? -1 : 0;
        if (step === 0) return;
        e.preventDefault();
        var camera = dc.camera, index = dc.index;
        var name = cameraDisplayName4(camera, index);
        var _effectiveCoverage2 = effectiveCoverage2(camera), fovAngle = _effectiveCoverage2.fovAngle, detectionDistance = _effectiveCoverage2.detectionDistance;
        if (kind === "turn") {
            var rotation = normaliseRotation8(Math.round(camera.rotation) + step * KEY_TURN_DEG);
            commitCameraEdit(camera.refid, {
                rotation: rotation
            }, "Turned ".concat(name, " to ").concat(turnReadout(rotation)));
        } else if (kind === "widen") {
            var next = Math.min(WIDEN_MAX_DEG, Math.max(WIDEN_MIN_DEG, fovAngle + step * (e.shiftKey ? WIDEN_SHIFT_STEP_DEG : 1)));
            if (next === fovAngle) return;
            commitCameraEdit(camera.refid, {
                fovAngle: next
            }, "Widened ".concat(name, " to ").concat(widenReadout(next)));
        } else {
            var next1 = Math.max(CAMERA_DISTANCE_MIN2, detectionDistance + step);
            if (next1 === detectionDistance) return;
            commitCameraEdit(camera.refid, {
                detectionDistance: next1
            }, "".concat(name, " reaches ").concat(reachReadout(next1)));
        }
    };
    var hadFocus = useRef45(false);
    var _single_camera_refid;
    var singleRefid = (_single_camera_refid = single === null || single === void 0 ? void 0 : single.camera.refid) !== null && _single_camera_refid !== void 0 ? _single_camera_refid : null;
    useEffect50(function() {
        var _this;
        if (!hadFocus.current) return;
        var active = document.activeElement;
        var layer = layerRef.current;
        if (layer && active && layer.contains(active)) return;
        if (active && active !== document.body) {
            hadFocus.current = false;
            return;
        }
        hadFocus.current = false;
        var marker = singleRefid ? layer === null || layer === void 0 ? void 0 : layer.querySelector('[data-camera-refid="'.concat(CSS.escape(singleRefid), '"]')) : null;
        (_this = marker !== null && marker !== void 0 ? marker : paneRef.current) === null || _this === void 0 ? void 0 : _this.focus();
    });
    var onWheelRef = useRef45(onWheel);
    onWheelRef.current = onWheel;
    useEffect50(function() {
        var layer = layerRef.current;
        if (!layer) return;
        var forward = function(evt) {
            if (!onWheelRef.current) return;
            evt.preventDefault();
            onWheelRef.current(evt);
        };
        layer.addEventListener("wheel", forward, {
            passive: false
        });
        return function() {
            return layer.removeEventListener("wheel", forward);
        };
    }, []);
    var handleControls = caps.cameraControls;
    var renderHandles = function(dc) {
        if (handleControls === "none" || toolMode !== "select") return null;
        var camera = applyCameraPreview(dc.camera, preview);
        var name = cameraDisplayName4(camera, dc.index);
        var _effectiveCoverage2 = effectiveCoverage2(camera), fovAngle = _effectiveCoverage2.fovAngle, detectionDistance = _effectiveCoverage2.detectionDistance;
        var h = handlePositions(camera, view.zoom);
        var centre = {
            x: camera.x,
            y: camera.y
        };
        var kinds = [];
        if (h.turn) kinds.push({
            kind: "turn",
            at: h.turn
        });
        if (handleControls === "all" && h.widen) kinds.push({
            kind: "widen",
            at: h.widen
        });
        if (handleControls === "all") kinds.push({
            kind: "reach",
            at: h.reach
        });
        return kinds.map(function(param) {
            var kind = param.kind, plan = param.at;
            var pane = planPointToPane3(plan, view);
            var isDragging = (dragging === null || dragging === void 0 ? void 0 : dragging.refid) === camera.refid && dragging.kind === kind;
            var glyphAngle = kind === "reach" ? screenAngle(centre, h.reach, view) : kind === "widen" ? screenAngle(centre, plan, view) + 90 : 0;
            var label = kind === "turn" ? "Turn ".concat(name) : kind === "widen" ? "Widen ".concat(name) : "Reach ".concat(name);
            var aria = kind === "turn" ? {
                role: "slider",
                "aria-valuemin": 0,
                "aria-valuemax": 359,
                "aria-valuenow": Math.round(normaliseRotation8(camera.rotation)) % 360,
                "aria-valuetext": turnReadout(camera.rotation)
            } : kind === "widen" ? {
                role: "slider",
                "aria-valuemin": WIDEN_MIN_DEG,
                "aria-valuemax": WIDEN_MAX_DEG,
                "aria-valuenow": fovAngle,
                "aria-valuetext": widenReadout(fovAngle)
            } : {
                role: "spinbutton",
                "aria-valuemin": CAMERA_DISTANCE_MIN2,
                "aria-valuenow": detectionDistance,
                "aria-valuetext": reachReadout(detectionDistance)
            };
            var readout = kind === "turn" ? turnReadout(camera.rotation) : kind === "widen" ? widenReadout(fovAngle) : reachReadout(detectionDistance);
            return /* @__PURE__ */ jsxs41(Fragment29, {
                children: [
                    /* @__PURE__ */ jsx57(Handle, _object_spread_props(_object_spread({
                        type: "button",
                        "data-handle": kind,
                        "data-camera-refid-handle": camera.refid,
                        "aria-label": label
                    }, aria), {
                        $dragging: isDragging,
                        $interactive: pointerLive,
                        style: at(pane),
                        onMouseDown: function(e) {
                            return pressHandle(dc, kind, e.nativeEvent);
                        },
                        onTouchStart: function(e) {
                            return pressHandle(dc, kind, e.nativeEvent);
                        },
                        onKeyDown: function(e) {
                            return handleKeyDown(dc, kind, e);
                        },
                        children: /* @__PURE__ */ jsx57("span", {
                            className: "tl-plan-cam-handle",
                            style: {
                                transform: "rotate(".concat(glyphAngle, "deg)")
                            },
                            children: /* @__PURE__ */ jsx57(Icon26, {
                                name: kind === "turn" ? "rotate" : "arrows-left-right",
                                variant: "solid",
                                size: "xs"
                            })
                        })
                    })),
                    isDragging ? /* @__PURE__ */ jsx57(Tooltip4, {
                        open: true,
                        anchor: {
                            x: pane.x,
                            y: pane.y + HANDLE_SIZE_PX / 2
                        },
                        placement: "bottom",
                        arrow: false,
                        tone: "butter",
                        icon: kind === "turn" ? /* @__PURE__ */ jsx57(Icon26, {
                            name: "rotate",
                            variant: "solid"
                        }) : kind === "reach" ? /* @__PURE__ */ jsx57(Icon26, {
                            name: "arrows-left-right-to-line",
                            variant: "solid"
                        }) : void 0,
                        title: readout
                    }) : null
                ]
            }, "".concat(camera.refid, "-").concat(kind));
        });
    };
    return /* @__PURE__ */ jsx57(Layer2, {
        ref: layerRef,
        role: "group",
        "aria-label": "Cameras on the plan",
        "data-plan-camera-layer": true,
        onFocus: function() {
            hadFocus.current = true;
        },
        onBlur: function(e) {
            if (!e.currentTarget.contains(e.relatedTarget)) hadFocus.current = false;
        },
        children: cameras.map(function(dc) {
            var camera = applyCameraPreview(dc.camera, preview);
            var isSelected2 = selectedIds.includes(camera.refid);
            var hasStream2 = cameraHasStream(camera);
            var isTarget = streamDragActive && !hasStream2 || camera.refid === replaceTargetRefid;
            var isLit = litRefid != null && litRefid === camera.refid;
            var unlinkedWork = unlinkedIsWork && !hasStream2;
            var ringLook = isTarget ? "target" : isSelected2 ? "selected" : isLit ? "lit" : unlinkedWork ? "unlinkedWork" : "other";
            var look = ringLook === "unlinkedWork" ? "other" : ringLook;
            var name = cameraDisplayName4(camera, dc.index);
            var centre = planPointToPane3(camera, view);
            var showName = (single === null || single === void 0 ? void 0 : single.camera.refid) === camera.refid;
            var flip = sideLabelPlacement(centre.x, paneSize.width, "right") === "left";
            var half = CAMERA_MARKER_SELECTED_SIZE_PX / 2;
            return /* @__PURE__ */ jsxs41(Fragment29, {
                children: [
                    /* @__PURE__ */ jsx57(Marker, {
                        type: "button",
                        className: isSelected2 ? "tl-plan-cam-mark is-selected" : "tl-plan-cam-mark",
                        "data-camera-refid": camera.refid,
                        "data-x": camera.x,
                        "data-y": camera.y,
                        "data-rotation": camera.rotation,
                        "data-fov": effectiveCoverage2(camera).fovAngle,
                        "data-look": look,
                        "data-nostream": hasStream2 ? void 0 : "",
                        "aria-label": hasStream2 ? name : "".concat(name, ", no stream"),
                        "aria-roledescription": "camera",
                        "aria-pressed": isSelected2,
                        tabIndex: editable ? 0 : -1,
                        $look: ringLook,
                        $selected: isSelected2,
                        $glyph: unlinkedWork ? PLAN_CAMERA_GLYPH.work : PLAN_CAMERA_GLYPH.plain,
                        $interactive: pointerLive,
                        style: at(centre),
                        onMouseDown: function(e) {
                            return pressMarker(dc, e.nativeEvent, e.shiftKey);
                        },
                        onTouchStart: function(e) {
                            return pressMarker(dc, e.nativeEvent, false);
                        },
                        onClick: function(e) {
                            if (e.detail === 0) return;
                            selectEntity(camera.refid, e.shiftKey);
                        },
                        onKeyDown: function(e) {
                            return markerKeyDown(dc, e);
                        },
                        onKeyUp: function(e) {
                            if (e.key === " ") e.preventDefault();
                        },
                        children: /* @__PURE__ */ jsx57(Icon26, {
                            name: "video",
                            variant: hasStream2 ? "solid" : "regular",
                            size: "xs"
                        })
                    }),
                    showName ? /* @__PURE__ */ jsx57(Tooltip4, {
                        open: true,
                        anchor: {
                            x: flip ? centre.x - half : centre.x + half,
                            y: centre.y
                        },
                        placement: flip ? "left" : "right",
                        arrow: false,
                        title: name
                    }) : null,
                    (single === null || single === void 0 ? void 0 : single.camera.refid) === camera.refid ? renderHandles(dc) : null
                ]
            }, camera.refid);
        })
    });
};
// src/components/Planner/canvas/PlanEntityLayer.tsx
import { useEffect as useEffect51, useRef as useRef46, useSyncExternalStore as useSyncExternalStore7 } from "react";
import styled45 from "styled-components";
import { Icon as Icon27, Tag as Tag6 } from "@repo/design-system";
import { focus as focus5, inset as inset9, radius as radius11, shadow as shadow7, space as space25, typeRole as typeRole15 } from "@repo/design-tokens";
import { pixelsToMeters as pixelsToMeters4, surfaceName as surfaceName4, planPointToPane as planPointToPane4 } from "@repo/front-end-utils";
import { jsx as jsx58, jsxs as jsxs42 } from "react/jsx-runtime";
var Layer3 = styled45.div(_templateObject187());
var at2 = function(p) {
    var centre = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return {
        transform: centre ? "translate(".concat(p.x, "px, ").concat(p.y, "px) translate(-50%, -50%)") : "translate(".concat(p.x, "px, ").concat(p.y, "px)")
    };
};
var TagPill = styled45.div(_templateObject188(), space25[1], space25[1], inset9[3], space25[1], space25[1], radius11.pill, NAME_TAG.background, shadow7.glassSm, typeRole15.captionCompact, NAME_TAG.name);
var PlanNameTag = function(param) {
    var code = param.code, name = param.name, look = param.look, style = param.style;
    return /* @__PURE__ */ jsxs42(TagPill, {
        "data-plan-name-tag": true,
        "data-look": look,
        style: _object_spread_props(_object_spread({}, style), _define_property({}, "--plan-tag-border", NAME_TAG.border[look])),
        children: [
            code && /* @__PURE__ */ jsx58(Tag6, {
                surface: "on-solid",
                tone: "code",
                children: code
            }),
            name && /* @__PURE__ */ jsx58("span", {
                className: "plan-tag-name",
                children: name
            })
        ]
    });
};
var discCss = "\n  position: absolute;\n  left: 0;\n  top: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: ".concat(HANDLE_STYLES.glyphDisc.size, "px;\n  height: ").concat(HANDLE_STYLES.glyphDisc.size, "px;\n  padding: 0;\n  border-radius: 50%;\n  box-sizing: border-box;\n  background: ").concat(HANDLE_STYLES.glyphDisc.fill, ";\n  border: ").concat(HANDLE_STYLES.glyphDisc.ringWidth, "px solid ").concat(HANDLE_STYLES.glyphDisc.ring, ";\n  color: ").concat(HANDLE_STYLES.glyphDisc.glyph, ";\n  box-shadow: ").concat(HANDLE_STYLES.glyphDisc.halo, ";\n");
var GlyphDisc = styled45.span(_templateObject189(), discCss);
var AddCornerButton = styled45.button(_templateObject190(), discCss, focus5.ring);
var PlanGlyphDisc = function(param) {
    var glyph = param.glyph, style = param.style;
    return /* @__PURE__ */ jsx58(GlyphDisc, {
        "aria-hidden": "true",
        "data-plan-glyph": glyph,
        style: style,
        children: /* @__PURE__ */ jsx58(Icon27, {
            name: glyph,
            variant: "solid",
            size: "xs"
        })
    });
};
var PlanEdgeHandle = function(param) {
    var style = param.style;
    return /* @__PURE__ */ jsx58(PlanGlyphDisc, {
        glyph: "left-right",
        style: style
    });
};
var PlanAddCornerHandle = function(param) {
    var surface11 = param.surface, edgeIndex = param.edgeIndex, style = param.style, _param_passThrough = param.passThrough, passThrough = _param_passThrough === void 0 ? false : _param_passThrough, onAdded = param.onAdded;
    var space29 = surfaceName4(surface11);
    return /* @__PURE__ */ jsx58(AddCornerButton, {
        type: "button",
        "aria-label": "Add a corner here, edge ".concat(edgeIndex + 1, " of ").concat(surface11.poly.length).concat(space29 ? " of ".concat(space29) : ""),
        "data-plan-add-corner": edgeIndex,
        style: passThrough ? _object_spread_props(_object_spread({}, style), {
            pointerEvents: "none"
        }) : style,
        onClick: function() {
            if (insertCornerAtMidpoint(surface11, edgeIndex)) onAdded === null || onAdded === void 0 ? void 0 : onAdded();
        },
        children: /* @__PURE__ */ jsx58(Icon27, {
            name: "plus",
            variant: "solid",
            size: "xs"
        })
    });
};
var tagAnchor = function(surface11, view) {
    var best = null;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = surface11.poly[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var p = _step.value;
            var pane = planPointToPane4(p, view);
            if (!best || pane.x + pane.y < best.x + best.y) best = pane;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return best;
};
var NO_ANCHORS = /* @__PURE__ */ new Map();
var noAnchors = function() {
    return NO_ANCHORS;
};
var noSubscribe = function() {
    return function() {
        return void 0;
    };
};
var PlanEntityLayer = function(param) {
    var surfaces = param.surfaces, tagLook = param.tagLook, cornerSurface = param.cornerSurface, _param_hiddenCornerEdge = param.hiddenCornerEdge, hiddenCornerEdge = _param_hiddenCornerEdge === void 0 ? null : _param_hiddenCornerEdge, _param_cornerPassThrough = param.cornerPassThrough, cornerPassThrough = _param_cornerPassThrough === void 0 ? false : _param_cornerPassThrough, onCornerAdded = param.onCornerAdded, anchors = param.anchors, hostLayerRef = param.layerRef, onWheel = param.onWheel, paneRef = param.paneRef;
    var view = usePlanView();
    var ownLayerRef = useRef46(null);
    var layerRef = hostLayerRef !== null && hostLayerRef !== void 0 ? hostLayerRef : ownLayerRef;
    var _anchors_subscribe, _anchors_getSnapshot;
    var anchorMap = useSyncExternalStore7((_anchors_subscribe = anchors === null || anchors === void 0 ? void 0 : anchors.subscribe) !== null && _anchors_subscribe !== void 0 ? _anchors_subscribe : noSubscribe, (_anchors_getSnapshot = anchors === null || anchors === void 0 ? void 0 : anchors.getSnapshot) !== null && _anchors_getSnapshot !== void 0 ? _anchors_getSnapshot : noAnchors);
    var onWheelRef = useRef46(onWheel);
    onWheelRef.current = onWheel;
    useEffect51(function() {
        var layer = layerRef.current;
        if (!layer) return;
        var forward = function(evt) {
            if (!onWheelRef.current) return;
            evt.preventDefault();
            onWheelRef.current(evt);
        };
        layer.addEventListener("wheel", forward, {
            passive: false
        });
        return function() {
            return layer.removeEventListener("wheel", forward);
        };
    }, [
        layerRef
    ]);
    var hadFocus = useRef46(false);
    useEffect51(function() {
        var _paneRef_current;
        if (!hadFocus.current) return;
        var active = document.activeElement;
        var layer = layerRef.current;
        if (layer && active && layer.contains(active)) return;
        hadFocus.current = false;
        if (active && active !== document.body) return;
        paneRef === null || paneRef === void 0 ? void 0 : (_paneRef_current = paneRef.current) === null || _paneRef_current === void 0 ? void 0 : _paneRef_current.focus();
    });
    return /* @__PURE__ */ jsxs42(Layer3, {
        ref: layerRef,
        "data-plan-entity-layer": true,
        onFocus: function() {
            hadFocus.current = true;
        },
        children: [
            surfaces.map(function(surface11) {
                var look = tagLook(surface11);
                var anchor = look ? tagAnchor(surface11, view) : null;
                if (!look || !anchor) return null;
                return /* @__PURE__ */ jsx58(PlanNameTag, {
                    code: nameTagCode(surface11.entityCode),
                    name: surfaceName4(surface11),
                    look: look,
                    style: at2({
                        x: anchor.x + NAME_TAG.offset.x,
                        y: anchor.y + NAME_TAG.offset.y
                    })
                }, "tag-".concat(surface11.refid));
            }),
            cornerSurface === null || cornerSurface === void 0 ? void 0 : cornerSurface.poly.map(function(a, i) {
                var _document_activeElement;
                if (i === hiddenCornerEdge && ((_document_activeElement = document.activeElement) === null || _document_activeElement === void 0 ? void 0 : _document_activeElement.getAttribute("data-plan-add-corner")) !== String(i)) {
                    return null;
                }
                var b = cornerSurface.poly[(i + 1) % cornerSurface.poly.length];
                var mid = planPointToPane4({
                    x: (a.x + b.x) / 2,
                    y: (a.y + b.y) / 2
                }, view);
                return /* @__PURE__ */ jsx58(PlanAddCornerHandle, {
                    surface: cornerSurface,
                    edgeIndex: i,
                    style: at2(mid, true),
                    passThrough: cornerPassThrough,
                    onAdded: onCornerAdded
                }, "corner-".concat(cornerSurface.refid, "-").concat(i));
            }),
            Array.from(anchorMap.entries()).map(function(param) {
                var _param = _sliced_to_array(param, 2), id = _param[0], anchor = _param[1];
                var style = at2(planPointToPane4({
                    x: pixelsToMeters4(anchor.x),
                    y: pixelsToMeters4(anchor.y)
                }, view), true);
                return anchor.glyph === "left-right" ? /* @__PURE__ */ jsx58(PlanEdgeHandle, {
                    style: style
                }, "glyph-".concat(id)) : /* @__PURE__ */ jsx58(PlanGlyphDisc, {
                    glyph: anchor.glyph,
                    style: style
                }, "glyph-".concat(id));
            })
        ]
    });
};
// src/components/Planner/canvas/PlanPaneScrollbars.tsx
import { useMemo as useMemo31, useState as useState49 } from "react";
import { ScrollbarTrack } from "@repo/design-system";
import { panForOffset, planScrollAxes } from "@repo/front-end-utils";
import { Fragment as Fragment30, jsx as jsx59, jsxs as jsxs43 } from "react/jsx-runtime";
var PLAN_PANE_SCROLL_LANE = 20;
var EDGE_INSET = 4;
var END_INSET = 8;
var PlanPaneScrollbars = function(param) {
    var bounds = param.bounds, viewport = param.viewport, onPan = param.onPan;
    var _useLivePlanView = useLivePlanView(), zoom = _useLivePlanView.zoom, rotation = _useLivePlanView.rotation, pan = _useLivePlanView.pan;
    var axes = useMemo31(function() {
        return planScrollAxes({
            bounds: bounds,
            zoom: zoom,
            rotation: rotation,
            pan: pan,
            viewport: viewport
        });
    }, [
        bounds,
        zoom,
        rotation,
        pan,
        viewport
    ]);
    var _useState49 = _sliced_to_array(useState49(null), 2), drag = _useState49[0], setDrag = _useState49[1];
    var shownX = axes.x.overflows || (drag === null || drag === void 0 ? void 0 : drag.axis) === "x";
    var shownY = axes.y.overflows || (drag === null || drag === void 0 ? void 0 : drag.axis) === "y";
    var both = shownX && shownY;
    var trackFor = function(axis) {
        var live = axes[axis];
        var dragging = (drag === null || drag === void 0 ? void 0 : drag.axis) === axis ? drag : null;
        if (!live.overflows && !dragging) return null;
        var model = dragging ? dragging.from : live;
        var offset = dragging ? dragging.offset : live.offset;
        var vertical = axis === "y";
        var style = vertical ? {
            right: EDGE_INSET,
            top: END_INSET,
            bottom: both ? PLAN_PANE_SCROLL_LANE : END_INSET
        } : {
            bottom: EDGE_INSET,
            left: END_INSET,
            right: both ? PLAN_PANE_SCROLL_LANE : END_INSET
        };
        return /* @__PURE__ */ jsx59(ScrollbarTrack, {
            orientation: vertical ? "vertical" : "horizontal",
            variant: "onSolid",
            viewportSize: model.viewport,
            contentSize: model.extent,
            offset: offset,
            style: style,
            onDragStart: function() {
                return setDrag({
                    axis: axis,
                    from: live,
                    pan: pan,
                    zoom: zoom,
                    rotation: rotation,
                    offset: live.offset
                });
            },
            onDragEnd: function() {
                return setDrag(null);
            },
            onOffsetChange: function(next) {
                if (dragging) {
                    if (dragging.zoom !== zoom || dragging.rotation !== rotation) return;
                    setDrag(_object_spread_props(_object_spread({}, dragging), {
                        offset: next
                    }));
                    var moved = panForOffset(dragging.pan, axis, dragging.from, next);
                    onPan(_object_spread_props(_object_spread({}, pan), _define_property({}, axis, moved[axis])));
                } else {
                    onPan(panForOffset(pan, axis, live, next));
                }
            }
        }, axis);
    };
    return /* @__PURE__ */ jsxs43(Fragment30, {
        children: [
            trackFor("y"),
            trackFor("x")
        ]
    });
};
// src/components/Planner/canvas/planPaneFocus.ts
import { css as css6 } from "styled-components";
import { CYAN_DEEP, surface as surface9 } from "@repo/design-tokens";
var planPaneFocusRing = css6(_templateObject191(), CYAN_DEEP, surface9[0]);
var PLAN_PANE_SCROLL_KEYS = "ArrowUp ArrowDown ArrowLeft ArrowRight";
// src/components/Planner/canvas/scaleDialogs.tsx
import { useState as useState50 } from "react";
import { Button as Button24, Field as Field6, Input as Input8, Modal as Modal7 } from "@repo/design-system";
import { useEditorStore as useEditorStore52 } from "@repo/front-end-state";
import { useFloorplanStore as useFloorplanStore60 } from "@repo/front-end-state";
import { useScaleCalibrationStore as useScaleCalibrationStore2 } from "@repo/front-end-state";
import { placementOf as placementOf6, worldPixelsToFloor, worldToUnderlayPixels } from "@repo/front-end-utils";
import { Fragment as Fragment31, jsx as jsx60, jsxs as jsxs44 } from "react/jsx-runtime";
var ScalePromptDialog = function(param) {
    var name = param.name, onStartCalibration = param.onStartCalibration, onSkip = param.onSkip, returnFocusTo = param.returnFocusTo;
    return /* @__PURE__ */ jsxs44(Modal7, {
        open: true,
        onClose: onSkip,
        title: "Set plan scale",
        width: "md",
        returnFocusTo: returnFocusTo,
        actions: /* @__PURE__ */ jsxs44(Fragment31, {
            children: [
                /* @__PURE__ */ jsx60(Button24, {
                    variant: "frosted",
                    size: "inline",
                    onClick: onSkip,
                    children: "Skip for now"
                }),
                /* @__PURE__ */ jsx60(Button24, {
                    variant: "primary",
                    size: "inline",
                    onClick: onStartCalibration,
                    children: "Set scale"
                })
            ]
        }),
        children: [
            /* @__PURE__ */ jsxs44("p", {
                children: [
                    name,
                    " has been added to the plan. To ensure accurate dimensions, set its scale by drawing a line between two points with a known distance."
                ]
            }),
            /* @__PURE__ */ jsxs44("p", {
                children: [
                    "Choose ",
                    /* @__PURE__ */ jsx60("strong", {
                        children: "Set scale"
                    }),
                    ", then click two points on the PDF whose distance you know (e.g. a wall length or room dimension)."
                ]
            })
        ]
    });
};
var ScaleDistanceDialog = function(param) {
    var name = param.name, onConfirm = param.onConfirm, onRedraw = param.onRedraw, onCancel = param.onCancel, returnFocusTo = param.returnFocusTo;
    var _useState50 = _sliced_to_array(useState50(""), 2), meters = _useState50[0], setMeters = _useState50[1];
    var value = parseFloat(meters);
    var valid = Number.isFinite(value) && value > 0;
    var handleSubmit = function(e) {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        if (valid) onConfirm(value);
    };
    return /* @__PURE__ */ jsxs44(Modal7, {
        open: true,
        onClose: onCancel,
        title: "Enter distance",
        width: "md",
        returnFocusTo: returnFocusTo,
        actions: /* @__PURE__ */ jsxs44(Fragment31, {
            children: [
                /* @__PURE__ */ jsx60(Button24, {
                    variant: "frosted",
                    size: "inline",
                    onClick: onCancel,
                    children: "Cancel"
                }),
                /* @__PURE__ */ jsx60(Button24, {
                    variant: "frosted",
                    size: "inline",
                    onClick: onRedraw,
                    children: "Redraw line"
                }),
                /* @__PURE__ */ jsx60(Button24, {
                    variant: "primary",
                    size: "inline",
                    disabled: !valid,
                    onClick: function() {
                        return handleSubmit();
                    },
                    children: "Apply scale"
                })
            ]
        }),
        children: [
            /* @__PURE__ */ jsxs44("p", {
                children: [
                    "You have marked two points on ",
                    name,
                    ". Enter the real-world distance between them in metres, then choose ",
                    /* @__PURE__ */ jsx60("strong", {
                        children: "Apply scale"
                    }),
                    "."
                ]
            }),
            /* @__PURE__ */ jsx60("form", {
                onSubmit: handleSubmit,
                children: /* @__PURE__ */ jsx60(Field6, {
                    label: "Distance (metres)",
                    children: function(wiring) {
                        return /* @__PURE__ */ jsx60(Input8, _object_spread_props(_object_spread({}, wiring), {
                            type: "number",
                            min: "0.01",
                            step: "0.01",
                            value: meters,
                            onChange: function(e) {
                                return setMeters(e.target.value);
                            },
                            placeholder: "e.g. 10.5",
                            autoFocus: true
                        }));
                    }
                })
            })
        ]
    });
};
var ScaleDistanceDialogHost = function(param) {
    var onScaleSet = param.onScaleSet, returnFocusTo = param.returnFocusTo;
    var setToolMode = useEditorStore52(function(s) {
        return s.setToolMode;
    });
    var selected2 = useSelectedUnderlay();
    var updateUnderlay = useFloorplanStore60(function(s) {
        return s.updateUnderlay;
    });
    var pointA = useScaleCalibrationStore2(function(s) {
        return s.pointA;
    });
    var pointB = useScaleCalibrationStore2(function(s) {
        return s.pointB;
    });
    var showDistanceDialog = useScaleCalibrationStore2(function(s) {
        return s.showDistanceDialog;
    });
    var setShowDistanceDialog = useScaleCalibrationStore2(function(s) {
        return s.setShowDistanceDialog;
    });
    var setPointA = useScaleCalibrationStore2(function(s) {
        return s.setPointA;
    });
    var setPointB = useScaleCalibrationStore2(function(s) {
        return s.setPointB;
    });
    var setCursorPos = useScaleCalibrationStore2(function(s) {
        return s.setCursorPos;
    });
    var resetCalibration = useScaleCalibrationStore2(function(s) {
        return s.reset;
    });
    if (!showDistanceDialog || !pointA || !pointB || !(selected2 === null || selected2 === void 0 ? void 0 : selected2.drawn)) return null;
    var underlay = selected2.underlay;
    var handleConfirmDistance = function(meters) {
        var _useFloorplanStore60_getState_layout;
        var floorPlacement = placementOf6((_useFloorplanStore60_getState_layout = useFloorplanStore60.getState().layout) === null || _useFloorplanStore60_getState_layout === void 0 ? void 0 : _useFloorplanStore60_getState_layout.floors[selected2.floorIndex]);
        var a = worldToUnderlayPixels(underlay, worldPixelsToFloor(pointA, floorPlacement));
        var b = worldToUnderlayPixels(underlay, worldPixelsToFloor(pointB, floorPlacement));
        var imagePixels = Math.hypot(b.x - a.x, b.y - a.y);
        if (imagePixels > 0) {
            runUnderlayEdit(function() {
                return updateUnderlay(underlay.id, {
                    scale: imagePixels / meters,
                    scaleFromM: meters
                });
            });
            onScaleSet === null || onScaleSet === void 0 ? void 0 : onScaleSet(underlay.name);
        }
        resetCalibration();
        setToolMode("select");
    };
    var handleRedraw = function() {
        setPointA(null);
        setPointB(null);
        setCursorPos(null);
        setShowDistanceDialog(false);
    };
    var handleCancel = function() {
        resetCalibration();
        setToolMode("select");
    };
    return /* @__PURE__ */ jsx60(ScaleDistanceDialog, {
        name: underlay.name,
        returnFocusTo: returnFocusTo,
        onConfirm: handleConfirmDistance,
        onRedraw: handleRedraw,
        onCancel: handleCancel
    });
};
// src/components/Planner/canvas/ScalePromptGate.tsx
import { useEditorStore as useEditorStore53, useFloorplanStore as useFloorplanStore61 } from "@repo/front-end-state";
import { jsx as jsx61 } from "react/jsx-runtime";
var ScalePromptGate = function() {
    var returnFocusTo = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).returnFocusTo;
    var promptId = useEditorStore53(function(s) {
        return s.scalePromptUnderlayId;
    });
    var floors = useFloorplanStore61(function(s) {
        var _s_layout;
        return (_s_layout = s.layout) === null || _s_layout === void 0 ? void 0 : _s_layout.floors;
    });
    var target = findUnderlay(floors, promptId);
    var _target_underlay_scale;
    if (!target || ((_target_underlay_scale = target.underlay.scale) !== null && _target_underlay_scale !== void 0 ? _target_underlay_scale : 0) > 0) return null;
    var clear = function() {
        return useEditorStore53.getState().setScalePromptUnderlay(null);
    };
    return /* @__PURE__ */ jsx61(ScalePromptDialog, {
        name: target.underlay.name,
        returnFocusTo: returnFocusTo,
        onStartCalibration: function() {
            var _useFloorplanStore61_getState_layout_floors_target_floorIndex, _useFloorplanStore61_getState_layout;
            var editor = useEditorStore53.getState();
            if (editor.planMode !== "align") editor.setPlanMode("align");
            var floorId = (_useFloorplanStore61_getState_layout = useFloorplanStore61.getState().layout) === null || _useFloorplanStore61_getState_layout === void 0 ? void 0 : (_useFloorplanStore61_getState_layout_floors_target_floorIndex = _useFloorplanStore61_getState_layout.floors[target.floorIndex]) === null || _useFloorplanStore61_getState_layout_floors_target_floorIndex === void 0 ? void 0 : _useFloorplanStore61_getState_layout_floors_target_floorIndex.id;
            if (floorId !== void 0 && useEditorStore53.getState().hiddenFloorIds.includes(floorId)) useEditorStore53.getState().setFloorVisible(floorId, true, true);
            useFloorplanStore61.getState().setActiveFloor(target.floorIndex);
            var after = useEditorStore53.getState();
            after.selectUnderlay(target.underlay.id);
            after.setToolMode("calibrate_scale");
            clear();
        },
        onSkip: clear
    });
};
// src/components/Planner/canvas/UnderlayStatusBanner.tsx
import styled46 from "styled-components";
import { Banner as Banner5, Button as Button25 } from "@repo/design-system";
import { jsx as jsx62, jsxs as jsxs45 } from "react/jsx-runtime";
function underlayStatusView(items) {
    var failed = items.filter(function(i) {
        return i.status === "failed";
    });
    var missing = items.filter(function(i) {
        return i.status === "missing";
    });
    var loading = items.filter(function(i) {
        return i.status === "loading";
    });
    if (failed.length > 0) return {
        tone: "error",
        role: "alert",
        title: failed.length === 1 ? "".concat(failed[0].name, " could not be loaded.") : "".concat(failed.length, " of this floor’s PDFs could not be loaded."),
        body: "The plan itself is unchanged.",
        retryLabel: failed.length === 1 ? "Retry loading ".concat(failed[0].name) : "Retry loading this floor\u2019s PDFs"
    };
    if (missing.length > 0) return {
        tone: "warning",
        role: "status",
        title: missing.length === 1 ? "".concat(missing[0].name, " is not in storage.") : "".concat(missing.length, " of this floor’s PDFs are not in storage."),
        body: "The plan itself is unchanged \u2014 import the PDF again to show it."
    };
    if (loading.length > 0) return {
        tone: "info",
        role: "status",
        title: loading.length === 1 ? "Loading the floor plan PDF\u2026" : "Loading this floor\u2019s PDFs\u2026"
    };
    return null;
}
var BannerHost = styled46.div(_templateObject192(), PLAN_PANE_SCROLL_LANE, function(param) {
    var theme2 = param.theme;
    return theme2.spacing[3];
}, function(param) {
    var theme2 = param.theme;
    return theme2.zIndex.sticky;
}, function(param) {
    var theme2 = param.theme;
    return theme2.spacing[8];
});
var RetryRow5 = styled46.div(_templateObject193(), function(param) {
    var theme2 = param.theme;
    return theme2.spacing[2];
});
function UnderlayStatusBanner(param) {
    var items = param.items, onRetry = param.onRetry;
    var view = underlayStatusView(items);
    if (!view) return null;
    return /* @__PURE__ */ jsx62(BannerHost, {
        children: /* @__PURE__ */ jsxs45(Banner5, {
            tone: view.tone,
            surface: "on-solid",
            role: view.role,
            title: view.title,
            "data-testid": "underlay-status",
            children: [
                view.body,
                view.retryLabel && onRetry && /* @__PURE__ */ jsx62(RetryRow5, {
                    children: /* @__PURE__ */ jsx62(Button25, {
                        variant: "ghost",
                        size: "xs",
                        "aria-label": view.retryLabel,
                        onClick: onRetry,
                        children: "Retry"
                    })
                })
            ]
        }, "".concat(view.tone, ":").concat(view.title))
    });
}
// src/components/Planner/machineCard/MachineHoverCard.tsx
import { useEffect as useEffect52, useMemo as useMemo32, useState as useState51 } from "react";
import { HoverCard } from "@repo/design-system";
import { registerReadState as registerReadState11, useEquipmentCatalogStore as useEquipmentCatalogStore22 } from "@repo/front-end-state";
import { findLatestDesign as findLatestDesign22, isLive as isLive13, joinRegisterOntoPlan as joinRegisterOntoPlan5, resolveItemRegisterState as resolveItemRegisterState3, resolvePlanParentage as resolvePlanParentage9, planPointToPane as planPointToPane5 } from "@repo/front-end-utils";
// src/components/Planner/machineCard/machineHoverDetails.ts
import { toDisplayManufacturer as toDisplayManufacturer3 } from "@repo/front-end-utils";
var CODE_LABELS = {
    "machine-not-in-register": "Not in the register",
    "machine-register-row-gone": "Register row gone"
};
var MARK_STATUS = {
    error: {
        label: "Error",
        tone: "error"
    },
    check: {
        label: "To check",
        tone: "butter"
    },
    identify: {
        label: "Identify",
        tone: "peri"
    }
};
var text = function(value) {
    return typeof value === "string" && value.trim() !== "" ? value.trim() : null;
};
var machineHoverDetails = function(param) {
    var item = param.item, bid = param.bid, row = param.row, parent = param.parent, checks = param.checks, mark = param.mark;
    var maker = text(row === null || row === void 0 ? void 0 : row.manufacturer);
    var capacity = typeof (row === null || row === void 0 ? void 0 : row.capacity) === "number" ? String(row.capacity) : typeof item.capacity === "number" ? String(item.capacity) : null;
    var parentTail = (parent === null || parent === void 0 ? void 0 : parent.bid) ? parent.bid.slice(-4) : "";
    var details = [
        {
            label: "Type",
            value: text(row === null || row === void 0 ? void 0 : row.category_raw)
        },
        {
            label: "Manufacturer",
            value: maker ? toDisplayManufacturer3(maker) : text(row === null || row === void 0 ? void 0 : row.manufacturer_raw)
        },
        {
            label: "Product",
            value: text(row === null || row === void 0 ? void 0 : row.product)
        },
        {
            label: "Customer ID",
            value: text(row === null || row === void 0 ? void 0 : row.customer_asset_identifier)
        },
        {
            label: "Source ID",
            value: text(row === null || row === void 0 ? void 0 : row.source_asset_id)
        },
        {
            label: "Capacity",
            value: capacity
        },
        {
            label: "In",
            value: parent ? [
                text(parent.name),
                parentTail || null
            ].filter(Boolean).join(" \xB7 ") || null : null
        }
    ];
    var status;
    if (mark) {
        var worded = checks.find(function(check) {
            return CODE_LABELS[check.code];
        });
        status = mark === "error" && worded ? {
            label: CODE_LABELS[worded.code],
            tone: "error"
        } : MARK_STATUS[mark];
    }
    var _text;
    return _object_spread(_object_spread_props(_object_spread({
        title: (_text = text(item.name)) !== null && _text !== void 0 ? _text : "Machine"
    }, bid ? {
        code: bid
    } : {}), {
        details: details
    }), status ? {
        status: status
    } : {});
};
// src/components/Planner/machineCard/MachineHoverCard.tsx
import { jsx as jsx63 } from "react/jsx-runtime";
var MachineHoverCard = function(param) {
    var hoveredId = param.hoveredId, layout = param.layout, activeFloorIndex = param.activeFloorIndex, design = param.design, twinBid = param.twinBid;
    var view = useLivePlanView();
    var checks = usePlanChecksContext();
    var registerRows = useEquipmentCatalogStore22(function(s) {
        return s.registerRows;
    });
    var registerRead = useEquipmentCatalogStore22(function(s) {
        var _s_registerContext;
        return registerReadState11(s, {
            twinId: (_s_registerContext = s.registerContext) === null || _s_registerContext === void 0 ? void 0 : _s_registerContext.twinId
        });
    });
    var _useState51 = _sliced_to_array(useState51(false), 2), pressing = _useState51[0], setPressing = _useState51[1];
    useEffect52(function() {
        var down = function() {
            return setPressing(true);
        };
        var up = function() {
            return setPressing(false);
        };
        window.addEventListener("pointerdown", down, true);
        window.addEventListener("pointerup", up, true);
        window.addEventListener("pointercancel", up, true);
        return function() {
            window.removeEventListener("pointerdown", down, true);
            window.removeEventListener("pointerup", up, true);
            window.removeEventListener("pointercancel", up, true);
        };
    }, []);
    var _design_items_find;
    var item = hoveredId ? (_design_items_find = design === null || design === void 0 ? void 0 : design.items.find(function(i) {
        return i.refid === hoveredId && isLive13(i);
    })) !== null && _design_items_find !== void 0 ? _design_items_find : null : null;
    var text2 = useMemo32(function() {
        var _resolvePlanParentage9_item, _layout_floors_activeFloorIndex, _checks_marks_machines;
        if (!item || !design) return null;
        var joined2 = joinRegisterOntoPlan5(layout, registerRows, twinBid, {
            repairStaleLinks: registerRead === "ready"
        });
        var joinedFloor = joined2 === null || joined2 === void 0 ? void 0 : joined2.floors[activeFloorIndex];
        var _ref;
        var joinedItem = (_ref = joinedFloor ? findLatestDesign22(joinedFloor.designs).items.find(function(i) {
            return i.refid === item.refid;
        }) : void 0) !== null && _ref !== void 0 ? _ref : item;
        var state = resolveItemRegisterState3(joinedItem, registerRows, registerRead);
        var rowId = state.kind === "backed" ? state.row.id : null;
        var _registerRows_find;
        var row = rowId === null ? null : (_registerRows_find = registerRows.find(function(r) {
            return r.id === rowId;
        })) !== null && _registerRows_find !== void 0 ? _registerRows_find : null;
        var _resolvePlanParentage9_item_effectiveParent;
        var parentRefid = (_resolvePlanParentage9_item_effectiveParent = (_resolvePlanParentage9_item = resolvePlanParentage9(design).item(item)) === null || _resolvePlanParentage9_item === void 0 ? void 0 : _resolvePlanParentage9_item.effectiveParent) !== null && _resolvePlanParentage9_item_effectiveParent !== void 0 ? _resolvePlanParentage9_item_effectiveParent : null;
        var space29 = parentRefid ? design.surfaces.find(function(s) {
            return s.refid === parentRefid;
        }) : void 0;
        var bidOf = function(code) {
            return displayBid(twinBid, code);
        };
        var _layout_floors_activeFloorIndex_id;
        var floorId = (_layout_floors_activeFloorIndex_id = layout === null || layout === void 0 ? void 0 : (_layout_floors_activeFloorIndex = layout.floors[activeFloorIndex]) === null || _layout_floors_activeFloorIndex === void 0 ? void 0 : _layout_floors_activeFloorIndex.id) !== null && _layout_floors_activeFloorIndex_id !== void 0 ? _layout_floors_activeFloorIndex_id : null;
        var _space29_name;
        return machineHoverDetails({
            item: item,
            bid: bidOf(item.entityCode),
            row: row,
            parent: space29 ? {
                name: (_space29_name = space29.name) !== null && _space29_name !== void 0 ? _space29_name : "",
                bid: bidOf(space29.entityCode)
            } : null,
            checks: checks && floorId !== null ? checks.checksFor(floorId, "item", item.refid) : [],
            mark: checks && floorId !== null ? (_checks_marks_machines = checks.marks(floorId).machines) === null || _checks_marks_machines === void 0 ? void 0 : _checks_marks_machines.get(item.refid) : void 0
        });
    }, [
        item,
        design,
        layout,
        registerRows,
        registerRead,
        twinBid,
        activeFloorIndex,
        checks
    ]);
    if (!item || !text2) return null;
    var anchor = planPointToPane5({
        x: item.x,
        y: item.y
    }, view);
    return /* @__PURE__ */ jsx63("div", {
        "aria-hidden": "true",
        "data-testid": "machine-hover-card",
        children: /* @__PURE__ */ jsx63(HoverCard, {
            open: !pressing,
            anchor: anchor,
            title: text2.title,
            code: text2.code,
            details: text2.details,
            status: text2.status,
            hint: {
                label: "Click to edit",
                icon: "pen"
            }
        })
    });
};
// src/components/Planner/reshape/EdgeDragTip.tsx
import styled47 from "styled-components";
import { Icon as Icon28, Tooltip as Tooltip5 } from "@repo/design-system";
import { jsx as jsx64 } from "react/jsx-runtime";
var POINTER_GAP = 14;
var EdgeDragTip = function(param) {
    var store = param.store;
    var reshape = useReshapeState(store);
    var edge2 = (reshape === null || reshape === void 0 ? void 0 : reshape.gesture) === "edge" ? reshape.edge : void 0;
    if (!edge2) return null;
    return /* @__PURE__ */ jsx64(Overlay2, {
        "aria-hidden": "true",
        children: /* @__PURE__ */ jsx64(Tooltip5, {
            open: true,
            anchor: {
                x: edge2.pointer.x,
                y: edge2.pointer.y + POINTER_GAP
            },
            placement: "bottom",
            arrow: false,
            tone: "cyan",
            icon: /* @__PURE__ */ jsx64(Icon28, {
                name: "left-right",
                variant: "solid"
            }),
            title: edgeTipText(_object_spread({
                key: reshapeModifierName()
            }, edge2))
        })
    });
};
var Overlay2 = styled47.div(_templateObject194());
// src/components/Planner/plannerCanvas/PlannerCanvasFrame.tsx
import { jsx as jsx65, jsxs as jsxs46 } from "react/jsx-runtime";
var CanvasWrapper = styled48.div(_templateObject195(), function(param) {
    var theme2 = param.theme;
    return theme2.colors.white;
}, function(param) {
    var $calibrating = param.$calibrating;
    return $calibrating ? "crosshair" : "default";
}, planPaneFocusRing);
var CalibrateBanner = styled48.div(_templateObject196(), function(param) {
    var theme2 = param.theme;
    return theme2.spacing[3];
}, function(param) {
    var theme2 = param.theme;
    return theme2.zIndex.sticky;
}, function(param) {
    var theme2 = param.theme;
    return "".concat(theme2.spacing[1.5], " ").concat(theme2.spacing[4]);
}, function(param) {
    var theme2 = param.theme;
    return theme2.borderRadius.full;
}, function(param) {
    var theme2 = param.theme;
    return theme2.fontSize.sm.size;
}, function(param) {
    var theme2 = param.theme;
    return theme2.fontWeight.semibold;
}, function(param) {
    var theme2 = param.theme;
    return theme2.shadows.DEFAULT;
});
var CalibrateBannerHost = function() {
    var pointA = useScaleCalibrationStore3(function(s) {
        return s.pointA;
    });
    return /* @__PURE__ */ jsx65(CalibrateBanner, {
        children: pointA ? "Now click the second point" : "Set scale: click two points a known distance apart on the plan"
    });
};
var NO_SURFACES = [];
var IDLE3 = {
    kind: "idle"
};
var noop = function() {
    return void 0;
};
var PlannerCanvasFrame = function(param) {
    var model = param.model, drops = param.drops, children = param.children;
    var activeFloorIndex = model.activeFloorIndex, activeStreamDrag = model.activeStreamDrag, aligning = model.aligning, announce = model.announce, announceScaleSet = model.announceScaleSet, answerFor = model.answerFor, armedEdge = model.armedEdge, cameraLayerRef = model.cameraLayerRef, cameraPreview = model.cameraPreview, caps = model.caps, cornerSurface = model.cornerSurface, design = model.design, drawRefusal = model.drawRefusal, drawnCameras = model.drawnCameras, entityLayerRef = model.entityLayerRef, equipmentDragStore = model.equipmentDragStore, forwardWheel = model.forwardWheel, handleAnchors = model.handleAnchors, handleFitToScreen = model.handleFitToScreen, handlePaneKeyDown = model.handlePaneKeyDown, itemEditing = model.itemEditing, layout = model.layout, litCameraRefid = model.litCameraRefid, unlinkedCamerasAreWork = model.unlinkedCamerasAreWork, liveIdentities = model.liveIdentities, livePlanView = model.livePlanView, liveSurfaces = model.liveSurfaces, paneRef = model.paneRef, paneSize = model.paneSize, planView = model.planView, pointerHoverId = model.pointerHoverId, referenceOffered = model.referenceOffered, controlsInset = model.controlsInset, reshapeModifierHeld2 = model.reshapeModifierHeld, reshapeOn = model.reshapeOn, reshapeStore = model.reshapeStore, retryUnderlays = model.retryUnderlays, rotationAnnouncement = model.rotationAnnouncement, scrollBounds = model.scrollBounds, selectedIds = model.selectedIds, selectedSet = model.selectedSet, setDrawRefusal = model.setDrawRefusal, setPanOffset = model.setPanOffset, statusItems = model.statusItems, streamDragActive = model.streamDragActive, surfaceTagLook = model.surfaceTagLook, toolMode = model.toolMode, twinBid = model.twinBid;
    var announceCornerAdded = useCallback25(function() {
        return announce("Corner added.");
    }, [
        announce
    ]);
    var _drops_dropStatus;
    var dropStatus = (_drops_dropStatus = drops === null || drops === void 0 ? void 0 : drops.dropStatus) !== null && _drops_dropStatus !== void 0 ? _drops_dropStatus : IDLE3;
    var dropsRef = useRef47(drops);
    dropsRef.current = drops;
    var acceptsDrops = !!drops && !aligning;
    useEffect53(function() {
        var element = paneRef.current;
        if (!equipmentDragStore || !acceptsDrops || !element) return void 0;
        var target = {
            element: element,
            preview: function(x, y, free) {
                var _dropsRef_current;
                return (_dropsRef_current = dropsRef.current) === null || _dropsRef_current === void 0 ? void 0 : _dropsRef_current.previewEquipmentAt(x, y, free);
            },
            clear: function() {
                var _dropsRef_current;
                return (_dropsRef_current = dropsRef.current) === null || _dropsRef_current === void 0 ? void 0 : _dropsRef_current.clearEquipmentDragPoint();
            },
            place: /*#__PURE__*/ function() {
                var _ref = _async_to_generator(function(payload, x, y, free) {
                    var _dropsRef_current;
                    return _ts_generator(this, function(_state) {
                        return [
                            2,
                            (_dropsRef_current = dropsRef.current) === null || _dropsRef_current === void 0 ? void 0 : _dropsRef_current.placeEquipmentPayload(payload, x, y, free)
                        ];
                    });
                });
                return function(payload, x, y, free) {
                    return _ref.apply(this, arguments);
                };
            }(),
            report: function(error) {
                var _dropsRef_current;
                return (_dropsRef_current = dropsRef.current) === null || _dropsRef_current === void 0 ? void 0 : _dropsRef_current.reportDropFailure(error);
            },
            landing: function(x, y, free) {
                var _dropsRef_current_equipmentLandingAt, _dropsRef_current;
                var _dropsRef_current_equipmentLandingAt1;
                return (_dropsRef_current_equipmentLandingAt1 = (_dropsRef_current = dropsRef.current) === null || _dropsRef_current === void 0 ? void 0 : (_dropsRef_current_equipmentLandingAt = _dropsRef_current.equipmentLandingAt) === null || _dropsRef_current_equipmentLandingAt === void 0 ? void 0 : _dropsRef_current_equipmentLandingAt.call(_dropsRef_current, x, y, free)) !== null && _dropsRef_current_equipmentLandingAt1 !== void 0 ? _dropsRef_current_equipmentLandingAt1 : null;
            }
        };
        equipmentDragStore.setTarget(target);
        return function() {
            target.clear();
            if (equipmentDragStore.getTarget() === target) equipmentDragStore.setTarget(null);
        };
    }, [
        equipmentDragStore,
        acceptsDrops,
        paneRef
    ]);
    var _drops_clearDropStatus;
    return /* @__PURE__ */ jsxs46(CanvasWrapper, {
        ref: paneRef,
        tabIndex: 0,
        role: "region",
        "aria-label": "Floor plan",
        "data-plan-pane": "",
        "aria-keyshortcuts": PLAN_PANE_SCROLL_KEYS,
        onKeyDown: handlePaneKeyDown,
        onDragOver: aligning ? void 0 : drops === null || drops === void 0 ? void 0 : drops.onDragOver,
        onDragLeave: aligning ? void 0 : drops === null || drops === void 0 ? void 0 : drops.onDragLeave,
        onDrop: // Nothing can be placed in Align floors — its panel holds no Library to drag from, and a
        // drop arriving anyway must not write a register row the mode cannot show.
        aligning || !drops ? void 0 : function(e) {
            drops.onDrop(e).catch(drops.reportDropFailure);
        },
        $calibrating: toolMode === "calibrate_scale",
        children: [
            children,
            /* @__PURE__ */ jsxs46(PlanViewProvider, {
                view: planView,
                live: livePlanView,
                children: [
                    /* @__PURE__ */ jsx65(PlanEntityLayer, {
                        surfaces: aligning ? NO_SURFACES : liveSurfaces,
                        tagLook: surfaceTagLook,
                        cornerSurface: cornerSurface,
                        onCornerAdded: announceCornerAdded,
                        hiddenCornerEdge: armedEdge && armedEdge.refid === (cornerSurface === null || cornerSurface === void 0 ? void 0 : cornerSurface.refid) ? armedEdge.index : null,
                        cornerPassThrough: reshapeModifierHeld2,
                        anchors: handleAnchors,
                        layerRef: entityLayerRef,
                        onWheel: forwardWheel,
                        paneRef: paneRef
                    }),
                    itemEditing === "host" && !aligning && toolMode === "select" && pointerHoverId !== null && !selectedSet.has(pointerHoverId) && /* @__PURE__ */ jsx65(MachineHoverCard, {
                        hoveredId: pointerHoverId,
                        layout: layout,
                        activeFloorIndex: activeFloorIndex,
                        design: design,
                        twinBid: twinBid
                    }),
                    aligning && /* @__PURE__ */ jsx65(BuildFloorDragTag, {}),
                    !aligning && reshapeOn && /* @__PURE__ */ jsx65(EdgeDragTip, {
                        store: reshapeStore
                    }),
                    !aligning && /* @__PURE__ */ jsx65(PlanCameraLayer, {
                        cameras: drawnCameras,
                        layerRef: cameraLayerRef,
                        paneSize: paneSize,
                        caps: caps,
                        litRefid: litCameraRefid,
                        unlinkedIsWork: unlinkedCamerasAreWork,
                        streamDragActive: streamDragActive,
                        streamDragPointStore: drops === null || drops === void 0 ? void 0 : drops.streamDragPointStore,
                        streamDropAnswerFor: answerFor,
                        previewStore: cameraPreview,
                        announce: announce,
                        undoEnabled: caps.mutableKinds === "all",
                        paneRef: paneRef,
                        onWheel: forwardWheel
                    }),
                    !aligning && drops && /* @__PURE__ */ jsx65(StreamDropOverlay, {
                        store: drops.streamDragPointStore,
                        answerFor: answerFor,
                        drag: activeStreamDrag !== null && activeStreamDrag !== void 0 ? activeStreamDrag : null,
                        cameras: drawnCameras,
                        paneSize: paneSize,
                        selectedIds: selectedIds
                    }),
                    !aligning && drops && equipmentDragStore && /* @__PURE__ */ jsx65(EquipmentDropOverlay, {
                        point: drops.equipmentDragPointStore,
                        drag: equipmentDragStore,
                        paneSize: paneSize
                    }),
                    /* @__PURE__ */ jsx65(PlanPaneScrollbars, {
                        bounds: scrollBounds,
                        viewport: paneSize,
                        onPan: setPanOffset
                    })
                ]
            }),
            toolMode === "calibrate_scale" && /* @__PURE__ */ jsx65(CalibrateBannerHost, {}),
            /* @__PURE__ */ jsx65("span", {
                role: "status",
                "aria-live": "polite",
                "aria-atomic": "true",
                style: visuallyHidden,
                children: rotationAnnouncement
            }),
            /* @__PURE__ */ jsxs46(CanvasBannerHost, {
                children: [
                    /* @__PURE__ */ jsx65(DropStatusBanner, {
                        status: dropStatus.kind === "idle" && liveIdentities && (liveIdentities.status === "failed" || liveIdentities.retrying) ? {
                            kind: "degraded",
                            message: MODEL_READ_FAILED_NOTICE,
                            retryLabel: MODEL_READ_RETRY_LABEL,
                            onRetry: liveIdentities.retry,
                            busy: liveIdentities.retrying
                        } : dropStatus,
                        onDismiss: (_drops_clearDropStatus = drops === null || drops === void 0 ? void 0 : drops.clearDropStatus) !== null && _drops_clearDropStatus !== void 0 ? _drops_clearDropStatus : noop
                    }),
                    /* @__PURE__ */ jsx65(DrawRefusalBanner, {
                        message: drawRefusal,
                        onDismiss: function() {
                            return setDrawRefusal(null);
                        },
                        onReturnFocus: function() {
                            var _paneRef_current;
                            return (_paneRef_current = paneRef.current) === null || _paneRef_current === void 0 ? void 0 : _paneRef_current.focus();
                        }
                    })
                ]
            }),
            caps.tools.background && !aligning && /* @__PURE__ */ jsx65(UnderlayStatusBanner, {
                items: statusItems,
                onRetry: retryUnderlays
            }),
            /* @__PURE__ */ jsx65(CanvasControls, {
                onFitToScreen: handleFitToScreen,
                capabilities: caps,
                referenceOffered: referenceOffered,
                inset: controlsInset
            }),
            /* @__PURE__ */ jsx65(ScalePromptGate, {
                returnFocusTo: paneRef
            }),
            /* @__PURE__ */ jsx65(ScaleDistanceDialogHost, {
                onScaleSet: announceScaleSet,
                returnFocusTo: paneRef
            })
        ]
    });
};
// src/components/Planner/carry/carrySettings.ts
var CARRY_SETTINGS = Object.freeze({
    /** One full swing there and back, seconds. */ period: 0.8,
    /** To about 2 % of the swing, seconds: damping ratio `min(0.98, 4 / (settle × ω₀))`. */ settle: 1.4,
    /** How hard a change of hand speed throws it. At 1, `G_PX` holds it at one radian. */ inertia: 1.85,
    /** Lean while the hand keeps moving. At 1, `TRAIL_PX` holds it at one radian. */ trail: 0.65,
    /** Soft limit on the shown tilt, degrees: `M·tanh(|φ|/M)`. */ maxTilt: 60,
    /** Hand to the top of the machine, metres. */ rope: 0.35,
    /** Time constant of the pointer's velocity and acceleration filters, milliseconds. */ smooth: 22,
    /** The machine's base above the floor while carried, metres. */ lift: 0.6,
    /** Lift and unflatten, milliseconds. */ pick: 140,
    /** The fall, milliseconds. */ drop: 180,
    /** Full height back to the flat look after landing, milliseconds. */ flatten: 200,
    /** Share of the tilt it lands with. */ rock: 0,
    /** Width up and height down on landing, percent, over `SQUASH_S`. */ squash: 3.5,
    /** Scale while lifted, about the hand, percent. */ depth: 10,
    /** The lifted shadow's strength. */ shadowStrength: 0.22,
    /** The shadow's offset down the screen, metres per metre of lift. */ shadowOffset: 0.5,
    /** Group carries: each other machine's period is `period × (1 + variety/100 × seed)`. */ variety: 11,
    /** Group carries: the gap between machines lifting and between them dropping, milliseconds. */ stagger: 15
});
var G_PX = 4e4;
var TRAIL_PX = 9e3;
var MAX_HAND_ACCELERATION = 9e4;
var MAX_FRAME_S = 0.05;
var GO_BACK_S = 0.26;
var SHRINK_S = 0.14;
var SQUASH_S = 0.18;
var GROUP_STAGGER_CAP_MS = 150;
var SHADOW_RING_GROWTH = 0.045;
var SHADOW_RING_SHARES = Object.freeze([
    0.55,
    0.3,
    0.15
]);
var SHADOW_DIR = Object.freeze({
    x: 0.35,
    z: 0.94
});
// src/components/Planner/carry/swing.ts
var createKinematics = function() {
    return {
        px: 0,
        py: 0,
        vx: 0,
        vy: 0,
        ax: 0,
        ay: 0,
        ready: false
    };
};
var clampAcceleration = function(v) {
    return Math.max(-MAX_HAND_ACCELERATION, Math.min(MAX_HAND_ACCELERATION, v));
};
var stepKinematics = function(kin, point, dt, settings) {
    if (!kin.ready) {
        kin.px = point.x;
        kin.py = point.y;
        kin.ready = true;
        return;
    }
    var tau = settings.smooth / 1e3;
    var a = tau > 0 ? 1 - Math.exp(-dt / tau) : 1;
    var vxr = (point.x - kin.px) / dt;
    var vyr = (point.y - kin.py) / dt;
    kin.px = point.x;
    kin.py = point.y;
    var nvx = kin.vx + (vxr - kin.vx) * a;
    var nvy = kin.vy + (vyr - kin.vy) * a;
    var axr = clampAcceleration((nvx - kin.vx) / dt);
    var ayr = clampAcceleration((nvy - kin.vy) / dt);
    kin.vx = nvx;
    kin.vy = nvy;
    kin.ax += (axr - kin.ax) * a;
    kin.ay += (ayr - kin.ay) * a;
};
var radians = function(degrees) {
    return degrees * Math.PI / 180;
};
var swingConsts = function(settings) {
    var scale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    var w0 = 2 * Math.PI / (settings.period * scale);
    var zeta = Math.min(0.98, 4 / (settings.settle * w0));
    return {
        w0: w0,
        zeta: zeta,
        kA: settings.inertia * w0 * w0 / G_PX,
        kV: settings.trail * w0 * w0 / TRAIL_PX
    };
};
var stepSwing = function(swing, dt, kin, drive, settings) {
    var _swingConsts = swingConsts(settings, swing.periodScale), w0 = _swingConsts.w0, zeta = _swingConsts.zeta, kA = _swingConsts.kA, kV = _swingConsts.kV;
    var ax = drive ? kin.ax : 0;
    var az = drive ? kin.ay : 0;
    var vx = drive ? kin.vx : 0;
    var vz = drive ? kin.vy : 0;
    var n = 4;
    var h = dt / n;
    var phi = swing.phi, w = swing.w;
    for(var i = 0; i < n; i++){
        var accx = -w0 * w0 * phi.x - 2 * zeta * w0 * w.x - kA * ax - kV * vx;
        var accz = -w0 * w0 * phi.z - 2 * zeta * w0 * w.z - kA * az - kV * vz;
        w.x += accx * h;
        w.z += accz * h;
        phi.x += w.x * h;
        phi.z += w.z * h;
    }
    var bound = radians(settings.maxTilt) * 2.5;
    var mag = Math.hypot(phi.x, phi.z);
    if (mag > bound) {
        phi.x *= bound / mag;
        phi.z *= bound / mag;
    }
};
var shownTilt = function(phi, settings) {
    var M = radians(settings.maxTilt);
    var mag = Math.hypot(phi.x, phi.z);
    if (mag < 1e-7) return {
        x: 0,
        z: 0
    };
    var k = M * Math.tanh(mag / M) / mag;
    return {
        x: phi.x * k,
        z: phi.z * k
    };
};
// src/components/Planner/carry/carryEngine.ts
var ease = {
    outCubic: function(t) {
        return 1 - Math.pow(1 - t, 3);
    },
    inOutCubic: function(t) {
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    },
    outBack: function(t) {
        var c1 = 1.4;
        var c3 = c1 + 1;
        return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2);
    },
    inOutSine: function(t) {
        return -(Math.cos(Math.PI * t) - 1) / 2;
    }
};
var lerp = function(a, b, t) {
    return a + (b - a) * t;
};
var clamp01 = function(t) {
    return Math.max(0, Math.min(1, t));
};
var progress = function(t, dur) {
    return dur > 0 ? clamp01(t / dur) : 1;
};
var centreOf = function(at3, yaw, box) {
    var c = box.centre;
    var cs = Math.cos(yaw);
    var sn = Math.sin(yaw);
    return {
        x: at3.x + c.x * cs + c.z * sn,
        z: at3.z - c.x * sn + c.z * cs
    };
};
var staggerGapMs = function(n) {
    var stagger = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CARRY_SETTINGS.stagger;
    return n > 1 ? Math.min(stagger, GROUP_STAGGER_CAP_MS / (n - 1)) : 0;
};
var seedFor = function(refid) {
    var h = 2166136261;
    for(var i = 0; i < refid.length; i++){
        h ^= refid.charCodeAt(i);
        h = Math.imul(h, 16777619);
    }
    return (h >>> 0) / 4294967295 * 2 - 1;
};
var rotateByTilt = function(v, t) {
    var cz = Math.cos(t.x);
    var sz = Math.sin(t.x);
    var x1 = v.x * cz - v.y * sz;
    var y1 = v.x * sz + v.y * cz;
    var z1 = v.z;
    var a = -t.z;
    var cx = Math.cos(a);
    var sx = Math.sin(a);
    return {
        x: x1,
        y: y1 * cx - z1 * sx,
        z: y1 * sx + z1 * cx
    };
};
var createCarry = function(start, options) {
    var _options_settings;
    var S = (_options_settings = options.settings) !== null && _options_settings !== void 0 ? _options_settings : CARRY_SETTINGS;
    var reduced = options.reduced === true;
    var rest = options.restHeight;
    var pickS = reduced ? 0 : S.pick / 1e3;
    var dropS = reduced ? 0 : S.drop / 1e3;
    var flattenS = reduced ? 0 : S.flatten / 1e3;
    var shrinkS = reduced ? 0 : SHRINK_S;
    var backS = reduced ? 0 : GO_BACK_S;
    var squashPct = reduced ? 0 : S.squash;
    var kin = createKinematics();
    var pointer = _object_spread({}, start.hand.client);
    var handAt = _object_spread({}, start.hand.at);
    var _start_members = _to_array(start.members), first = _start_members[0], others = _start_members.slice(1);
    var _start_grab;
    var grab = (_start_grab = start.grab) !== null && _start_grab !== void 0 ? _start_grab : first ? centreOf(first.at, first.yaw, first.box) : handAt;
    var attachOf = function(m, i) {
        return i === 0 ? grab : centreOf(m.at, m.yaw, m.box);
    };
    var ordered = first ? [
        first
    ].concat(_to_consumable_array(_to_consumable_array(others).sort(function(a, b) {
        var ca = centreOf(a.at, a.yaw, a.box);
        var cb = centreOf(b.at, b.yaw, b.box);
        return Math.hypot(ca.x - grab.x, ca.z - grab.z) - Math.hypot(cb.x - grab.x, cb.z - grab.z);
    }))) : [];
    var gap = reduced ? 0 : staggerGapMs(ordered.length, S.stagger) / 1e3;
    var members = ordered.map(function(m, i) {
        var attach = attachOf(m, i);
        return {
            refid: m.refid,
            src: start.src,
            state: "pickup",
            yaw: m.yaw,
            box: m.box,
            from: _object_spread({}, m.at),
            o: {
                x: attach.x - m.at.x,
                z: attach.z - m.at.z
            },
            d: {
                x: attach.x - grab.x,
                z: attach.z - grab.z
            },
            centred: i > 0 || start.grab === void 0,
            t: 0,
            delay: i * gap,
            wait: 0,
            phi: {
                x: 0,
                z: 0
            },
            w: {
                x: 0,
                z: 0
            },
            periodScale: i === 0 ? 1 : 1 + S.variety / 100 * m.seed,
            pivot: {
                x: 0,
                y: 0,
                z: 0
            },
            position: {
                x: m.at.x,
                y: 0,
                z: m.at.z
            },
            tilt: {
                x: 0,
                z: 0
            },
            k: 1,
            lift: 0,
            heightScale: start.src === "plan" ? rest : 1,
            squash: 0,
            appear: start.src === "plan" ? 1 : 0,
            shadow: {
                at: _object_spread({}, m.at),
                strength: 0,
                spread: 1
            },
            landing: _object_spread({}, m.at),
            fallFrom: {
                x: m.at.x,
                y: 0,
                z: m.at.z
            },
            fallDur: 0,
            rockShare: 0,
            tilt0: {
                x: 0,
                z: 0
            },
            k0: 1,
            hs0: 1,
            shadow0: 0,
            rock: {
                x: 0,
                z: 0
            },
            rockW: {
                x: 0,
                z: 0
            }
        };
    });
    var landed = [];
    var depthScale = function(lift) {
        return 1 + S.depth / 100 * clamp01(lift / Math.max(0.05, S.lift));
    };
    var poseInHand = function(c) {
        var b = rotateByTilt({
            x: -c.o.x,
            y: -(c.box.top + S.rope),
            z: -c.o.z
        }, c.tilt);
        c.position = {
            x: c.pivot.x + b.x * c.k,
            y: c.pivot.y + b.y * c.k,
            z: c.pivot.z + b.z * c.k
        };
    };
    var liftedShadow = function(c) {
        var strengthScale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        var by = Math.max(0, c.position.y);
        var off = S.shadowOffset * by;
        c.shadow = {
            at: {
                x: c.position.x + off * SHADOW_DIR.x,
                z: c.position.z + off * SHADOW_DIR.z
            },
            strength: S.shadowStrength * (1 - 0.4 * clamp01(by / 1.5)) * strengthScale,
            spread: 1 + by * 1.5
        };
    };
    var updateHeld = function(c, dt) {
        c.t += dt;
        var started = c.t >= c.delay;
        var u = progress(c.t - c.delay, pickS);
        if (c.src === "plan") {
            c.heightScale = lerp(rest, 1, ease.outCubic(u));
            c.lift = S.lift * ease.outBack(u);
            c.appear = 1;
        } else {
            c.heightScale = 1;
            c.lift = S.lift;
            c.appear = ease.outBack(u);
        }
        if (u >= 1) c.state = "held";
        var pivotY = c.lift + c.box.top + S.rope;
        c.pivot = {
            x: handAt.x + c.d.x,
            y: pivotY,
            z: handAt.z + c.d.z
        };
        if (started && !reduced) stepSwing(c, dt, kin, true, S);
        c.tilt = shownTilt(c.phi, S);
        c.k = depthScale(c.lift) * Math.max(1e-3, c.appear);
        poseInHand(c);
        liftedShadow(c, c.appear);
    };
    var beginFall = function(c, to, dur, rockShare) {
        c.state = c.state === "back" ? "back" : "fall";
        c.t = 0;
        c.fallDur = dur;
        c.rockShare = rockShare;
        c.landing = _object_spread({}, to);
        c.fallFrom = _object_spread({}, c.position);
        c.tilt0 = _object_spread({}, c.tilt);
        c.k0 = c.k;
        c.hs0 = c.heightScale;
    };
    var toRest = function(c) {
        c.state = "rest";
        c.t = 0;
        c.position = {
            x: c.landing.x,
            y: 0,
            z: c.landing.z
        };
        c.tilt = {
            x: 0,
            z: 0
        };
        c.k = 1;
        c.squash = 0;
        c.heightScale = rest;
        c.shadow = {
            at: _object_spread({}, c.landing),
            strength: 0,
            spread: 1
        };
        landed.push(c.refid);
    };
    var stepReleased = function(c, dt) {
        c.t += dt;
        if (c.state === "vanish") {
            var u = progress(c.t, shrinkS);
            c.k = c.k0 * (1 - ease.outCubic(u));
            c.shadow = _object_spread_props(_object_spread({}, c.shadow), {
                strength: c.shadow0 * (1 - u)
            });
            return u >= 1;
        }
        if (c.state === "rest") return false;
        if (c.state === "hold") {
            if (!reduced) stepSwing(c, dt, kin, false, S);
            c.tilt = shownTilt(c.phi, S);
            poseInHand(c);
            liftedShadow(c);
            if (c.t >= c.wait) beginFall(c, c.landing, dropS, S.rock);
            else return false;
            if (c.fallDur > 0) return false;
            c.t = 0;
        }
        if (c.state === "fall" || c.state === "back") {
            var u1 = progress(c.t, c.fallDur);
            var e = ease.inOutSine(u1);
            var g = u1 * u1;
            var share = lerp(1, c.rockShare, e);
            c.tilt = {
                x: c.tilt0.x * share,
                z: c.tilt0.z * share
            };
            var reach = Math.max(c.box.half.x, c.box.half.z);
            var clearance = reach * Math.sin(Math.hypot(c.tilt.x, c.tilt.z));
            c.position = {
                x: lerp(c.fallFrom.x, c.landing.x, e),
                y: Math.max(0, c.fallFrom.y * (1 - g)) + clearance * 0.6 * g,
                z: lerp(c.fallFrom.z, c.landing.z, e)
            };
            c.k = lerp(c.k0, 1, g);
            liftedShadow(c);
            if (u1 < 1) return false;
            c.state = "land";
            c.t = 0;
            c.shadow0 = c.shadow.strength;
            c.rock = {
                x: c.tilt.x,
                z: c.tilt.z
            };
            c.rockW = {
                x: 0,
                z: 0
            };
        }
        if (c.state === "land") {
            var wr = 2 * Math.PI / 0.3;
            var zr = 0.3;
            var n = 4;
            var h = dt / n;
            for(var i = 0; i < n; i++){
                c.rockW.x += (-wr * wr * c.rock.x - 2 * zr * wr * c.rockW.x) * h;
                c.rockW.z += (-wr * wr * c.rock.z - 2 * zr * wr * c.rockW.z) * h;
                c.rock.x += c.rockW.x * h;
                c.rock.z += c.rockW.z * h;
            }
            var reach1 = Math.max(c.box.half.x, c.box.half.z);
            var mag = Math.hypot(c.rock.x, c.rock.z);
            c.position = {
                x: c.landing.x,
                y: reach1 * Math.sin(mag) * 0.6,
                z: c.landing.z
            };
            c.tilt = _object_spread({}, c.rock);
            c.k = 1;
            c.squash = c.t < SQUASH_S ? squashPct / 100 * Math.sin(Math.PI * c.t / SQUASH_S) : 0;
            var fu = progress(c.t, flattenS);
            c.heightScale = lerp(c.hs0, rest, ease.inOutCubic(fu));
            c.shadow = {
                at: _object_spread({}, c.landing),
                strength: c.shadow0 * (1 - progress(c.t, reduced ? 0 : 0.12)),
                spread: 1
            };
            var squashDone = reduced || c.t >= SQUASH_S;
            if (fu >= 1 && squashDone && mag < 2e-3 && Math.hypot(c.rockW.x, c.rockW.z) < 0.02) {
                toRest(c);
            }
        }
        return false;
    };
    var startVanish = function(c) {
        c.state = "vanish";
        c.t = 0;
        c.k0 = c.k;
        c.shadow0 = c.shadow.strength;
    };
    members.forEach(function(c) {
        c.t = -1e-9;
        updateHeld(c, 1e-9);
    });
    return {
        point: function(client, at3) {
            pointer = _object_spread({}, client);
            handAt = _object_spread({}, at3);
        },
        step: function(dt) {
            if (!(dt > 0)) return;
            var h = Math.min(MAX_FRAME_S, dt);
            stepKinematics(kin, pointer, h, S);
            for(var i = members.length - 1; i >= 0; i--){
                var c = members[i];
                if (c.state === "pickup" || c.state === "held") updateHeld(c, h);
                else if (stepReleased(c, h)) members.splice(i, 1);
            }
        },
        poses: function() {
            return members.map(function(c) {
                return {
                    refid: c.refid,
                    state: c.state,
                    position: _object_spread({}, c.position),
                    tilt: _object_spread({}, c.tilt),
                    scale: c.k,
                    heightScale: c.heightScale,
                    squash: {
                        xz: 1 + c.squash,
                        y: 1 - c.squash
                    },
                    yaw: c.yaw,
                    box: c.box,
                    shadow: {
                        at: _object_spread({}, c.shadow.at),
                        strength: c.shadow.strength,
                        spread: c.shadow.spread
                    }
                };
            });
        },
        release: function(landings) {
            members.forEach(function(c) {
                if (c.state !== "pickup" && c.state !== "held") return;
                var below = {
                    x: c.pivot.x - c.o.x,
                    z: c.pivot.z - c.o.z
                };
                var _landings_get;
                c.landing = (_landings_get = landings.get(c.refid)) !== null && _landings_get !== void 0 ? _landings_get : below;
                c.state = "hold";
                c.t = 0;
                c.wait = c.delay;
            });
        },
        cancel: function() {
            members.forEach(function(c) {
                if (c.state !== "pickup" && c.state !== "held" && c.state !== "hold") return;
                if (c.src === "plan") {
                    c.state = "back";
                    beginFall(c, c.from, backS, 0);
                } else {
                    startVanish(c);
                }
            });
        },
        takeLanded: function() {
            var out = landed;
            landed = [];
            return out;
        },
        remove: function(refid) {
            var i = members.findIndex(function(c) {
                return c.refid === refid;
            });
            if (i >= 0) members.splice(i, 1);
        },
        vanish: function(refid) {
            var c = members.find(function(m) {
                return m.refid === refid;
            });
            if (c) startVanish(c);
        },
        setBox: function(refid, box) {
            var c = members.find(function(m) {
                return m.refid === refid;
            });
            if (!c) return;
            c.box = box;
            if (!c.centred || c.state !== "pickup" && c.state !== "held") return;
            var centre = centreOf(c.from, c.yaw, box);
            var o = {
                x: centre.x - c.from.x,
                z: centre.z - c.from.z
            };
            if (c !== members[0]) c.d = {
                x: c.d.x + o.x - c.o.x,
                z: c.d.z + o.z - c.o.z
            };
            c.o = o;
        },
        idle: function() {
            return members.length === 0;
        },
        finishNow: function() {
            members.length = 0;
            landed = [];
        }
    };
};
// src/components/Planner/readOnlyPlan/ReadOnlyCanvas.tsx
import { createContext as createContext14, createElement as createElement2, useContext as useContext19 } from "react";
import { jsx as jsx66 } from "react/jsx-runtime";
var warnedNoRenderer2 = false;
var NoRenderer2 = function() {
    if (!warnedNoRenderer2) {
        warnedNoRenderer2 = true;
        console.error("[ReadOnlyCanvas] no renderer provided");
    }
    return null;
};
var ReadOnlyCanvasRendererContext = createContext14(NoRenderer2);
var ReadOnlyCanvasRendererProvider = function(param) {
    var renderer = param.renderer, children = param.children;
    return /* @__PURE__ */ jsx66(ReadOnlyCanvasRendererContext.Provider, {
        value: renderer,
        children: children
    });
};
var ReadOnlyCanvas = function(props) {
    var Renderer = useContext19(ReadOnlyCanvasRendererContext);
    return createElement2(Renderer, props);
};
// src/components/Planner/readOnlyPlan/useReadOnlyPlanView.ts
import { useCallback as useCallback26, useEffect as useEffect54, useLayoutEffect as useLayoutEffect9, useMemo as useMemo33, useRef as useRef49, useState as useState52 } from "react";
import { findLatestDesign as findLatestDesign24, metersToPixels as metersToPixels4, panePointToPlan as panePointToPlan3, planDrawingOutline as planDrawingOutline2, placementOf as placementOf8, scrollPlanByKey as scrollPlanByKey2, zoomAboutPoint, worldPxToPane as worldPxToPane2 } from "@repo/front-end-utils";
// src/components/Planner/driver/usePlanSceneDriver.ts
import { useLayoutEffect as useLayoutEffect8, useRef as useRef48 } from "react";
// src/components/Planner/driver/planSceneDriver.ts
import { alignFloorDrawOrder, cameraVisibilityPolygon, findLatestDesign as findLatestDesign23, floorDrawState as floorDrawState5, floorElevationM, placementOf as placementOf7, PIXELS_PER_METER as PIXELS_PER_METER3, underlayWorldCorners, floorToWorld as floorToWorld2, panePointToPlan as panePointToPlan2, pixelsToMeters as pixelsToMeters5, planPointToPane as planPointToPane6, polygonCentroid, surfaceName as surfaceName5, worldToFloor } from "@repo/front-end-utils";
var NO_RECT = {
    left: 0,
    top: 0,
    width: 0,
    height: 0
};
var paneRect = function(source) {
    var el = source.element.current;
    if (!el) return NO_RECT;
    var r = el.getBoundingClientRect();
    return {
        left: r.left,
        top: r.top,
        width: r.width,
        height: r.height
    };
};
var floorOf = function(source, floorId) {
    var id = floorId !== null && floorId !== void 0 ? floorId : source.activeFloorId;
    var floor = source.floors.find(function(f) {
        return f.floorId === id;
    });
    if (!floor) {
        throw new Error("__planScene: floor ".concat(String(id), ' is not drawn on pane "').concat(source.name, '" — drawn: ').concat(source.floors.map(function(f) {
            return f.floorId;
        }).join(", ") || "none"));
    }
    return floor;
};
var planToClient = function(source, p) {
    var opts = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, rect = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : paneRect(source);
    var placement = floorOf(source, opts.floorId).placement;
    var world = placement ? floorToWorld2(p, placement) : p;
    var pane = planPointToPane6(world, opts.live ? source.live : source.view);
    return {
        x: pane.x + rect.left,
        y: pane.y + rect.top
    };
};
var clientToPlan = function(source, c) {
    var opts = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, rect = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : paneRect(source);
    var placement = floorOf(source, opts.floorId).placement;
    var world = panePointToPlan2({
        x: c.x - rect.left,
        y: c.y - rect.top
    }, opts.live ? source.live : source.view);
    return placement ? worldToFloor(world, placement) : world;
};
var boxOf = function(points) {
    var _Math, _Math1, _Math2, _Math3;
    var xs = points.map(function(p) {
        return p.x;
    });
    var ys = points.map(function(p) {
        return p.y;
    });
    var x = (_Math = Math).min.apply(_Math, _to_consumable_array(xs));
    var y = (_Math1 = Math).min.apply(_Math1, _to_consumable_array(ys));
    return {
        x: x,
        y: y,
        width: (_Math2 = Math).max.apply(_Math2, _to_consumable_array(xs)) - x,
        height: (_Math3 = Math).max.apply(_Math3, _to_consumable_array(ys)) - y
    };
};
var placedOutline = function(item, loops) {
    if (!loops || loops.length === 0) return null;
    var _item_rotation;
    var turn = ((_item_rotation = item.rotation) !== null && _item_rotation !== void 0 ? _item_rotation : 0) * Math.PI / 180;
    var cos = Math.cos(turn);
    var sin = Math.sin(turn);
    return loops.map(function(loop) {
        return loop.map(function(p) {
            return {
                x: item.x + p.x * cos - p.y * sin,
                y: item.y + p.x * sin + p.y * cos
            };
        });
    });
};
var footprintBox = function(source, item, f, floorId, rect) {
    var turn = item.rotation * Math.PI / 180;
    var cos = Math.cos(turn);
    var sin = Math.sin(turn);
    var corners = [
        [
            -1,
            -1
        ],
        [
            1,
            -1
        ],
        [
            1,
            1
        ],
        [
            -1,
            1
        ]
    ].map(function(param) {
        var _param = _sliced_to_array(param, 2), sx = _param[0], sy = _param[1];
        var lx = sx * f.width / 2 + f.offsetX;
        var ly = sy * f.depth / 2 + f.offsetY;
        return planToClient(source, {
            x: item.x + lx * cos - ly * sin,
            y: item.y + lx * sin + ly * cos
        }, {
            floorId: floorId
        }, rect);
    });
    return boxOf(corners);
};
var buildEntities = function(source) {
    var rect = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : paneRect(source);
    var _source_underlays;
    var selected2 = new Set(source.selectedIds);
    var out = [];
    var _source_underlays1;
    var drawnUnderlays = (_source_underlays1 = (_source_underlays = source.underlays) === null || _source_underlays === void 0 ? void 0 : _source_underlays.call(source)) !== null && _source_underlays1 !== void 0 ? _source_underlays1 : [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = _step.value, floorId = _step_value.floorId, design = _step_value.design;
            var _source_wallsShown;
            var at3 = function(refid, kind, p, rotation) {
                var _source_lookOf;
                var _source_lookOf1;
                return {
                    refid: refid,
                    kind: kind,
                    floorId: floorId,
                    x: p.x,
                    y: p.y,
                    rotation: rotation,
                    client: planToClient(source, p, {
                        floorId: floorId
                    }, rect),
                    selected: selected2.has(refid) && (kind !== "wall" || floorId === source.activeFloorId),
                    look: (_source_lookOf1 = (_source_lookOf = source.lookOf) === null || _source_lookOf === void 0 ? void 0 : _source_lookOf.call(source, kind, refid, floorId)) !== null && _source_lookOf1 !== void 0 ? _source_lookOf1 : null
                };
            };
            var _design_items;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = ((_design_items = design.items) !== null && _design_items !== void 0 ? _design_items : [])[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var stored = _step1.value;
                    var _source_itemShown, _source_footprintOf;
                    if (stored._deleted) continue;
                    var _source_itemShown1;
                    var item = (_source_itemShown1 = (_source_itemShown = source.itemShown) === null || _source_itemShown === void 0 ? void 0 : _source_itemShown.call(source, stored)) !== null && _source_itemShown1 !== void 0 ? _source_itemShown1 : stored;
                    var _source_footprintOf1;
                    var footprint = (_source_footprintOf1 = (_source_footprintOf = source.footprintOf) === null || _source_footprintOf === void 0 ? void 0 : _source_footprintOf.call(source, item)) !== null && _source_footprintOf1 !== void 0 ? _source_footprintOf1 : null;
                    out.push(_object_spread(_object_spread_props(_object_spread({}, at3(item.refid, "machine", item, item.rotation)), {
                        footprint: footprint,
                        box: footprint ? footprintBox(source, item, footprint, floorId, rect) : null
                    }), source.outlineOf ? {
                        outlineLoops: placedOutline(item, source.outlineOf(item))
                    } : {}));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var _design_surfaces;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = ((_design_surfaces = design.surfaces) !== null && _design_surfaces !== void 0 ? _design_surfaces : [])[Symbol.iterator](), _step2; !(_iteratorNormalCompletion1 = (_step2 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var surface11 = _step2.value;
                    if (surface11._deleted || surface11.poly.length < 3) continue;
                    out.push(_object_spread_props(_object_spread({}, at3(surface11.refid, "space", polygonCentroid(surface11.poly), null)), {
                        outline: surface11.poly.map(function(p) {
                            return {
                                x: p.x,
                                y: p.y
                            };
                        }),
                        name: surfaceName5(surface11) || null
                    }));
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            var _design_walls;
            var walls2 = (_design_walls = design.walls) !== null && _design_walls !== void 0 ? _design_walls : [];
            var _source_wallsShown1;
            ((_source_wallsShown1 = (_source_wallsShown = source.wallsShown) === null || _source_wallsShown === void 0 ? void 0 : _source_wallsShown.call(source, walls2, floorId)) !== null && _source_wallsShown1 !== void 0 ? _source_wallsShown1 : walls2).forEach(function(wall) {
                if (wall.id === void 0) return;
                var mid = {
                    x: (wall.a.x + wall.b.x) / 2,
                    y: (wall.a.y + wall.b.y) / 2
                };
                out.push(_object_spread_props(_object_spread({}, at3(wall.id, "wall", mid, null)), {
                    a: {
                        x: wall.a.x,
                        y: wall.a.y
                    },
                    b: {
                        x: wall.b.x,
                        y: wall.b.y
                    }
                }));
            });
            if (source.drawsCameras) {
                var _design_cameras;
                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                try {
                    for(var _iterator2 = ((_design_cameras = design.cameras) !== null && _design_cameras !== void 0 ? _design_cameras : [])[Symbol.iterator](), _step3; !(_iteratorNormalCompletion2 = (_step3 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                        var stored1 = _step3.value;
                        var _source_cameraShown;
                        if (stored1._deleted) continue;
                        var _source_cameraShown1;
                        var camera = (_source_cameraShown1 = (_source_cameraShown = source.cameraShown) === null || _source_cameraShown === void 0 ? void 0 : _source_cameraShown.call(source, stored1)) !== null && _source_cameraShown1 !== void 0 ? _source_cameraShown1 : stored1;
                        var _design_walls1;
                        out.push(_object_spread_props(_object_spread({}, at3(camera.refid, "camera", camera, camera.rotation)), {
                            // The call the cones layer draws (`PlanCameraCones`), with this floor's walls.
                            cone: cameraVisibilityPolygon(camera, (_design_walls1 = design.walls) !== null && _design_walls1 !== void 0 ? _design_walls1 : []).map(function(p) {
                                return {
                                    x: p.x,
                                    y: p.y
                                };
                            })
                        }));
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                            _iterator2.return();
                        }
                    } finally{
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }
            var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
            try {
                for(var _iterator3 = drawnUnderlays.filter(function(d) {
                    return d.floorId === floorId;
                })[Symbol.iterator](), _step4; !(_iteratorNormalCompletion3 = (_step4 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                    var _step_value1 = _step4.value, u = _step_value1.underlay, stackIndex = _step_value1.stackIndex;
                    out.push(_object_spread_props(_object_spread({}, at3(u.id, "underlay", {
                        x: u.x,
                        y: u.y
                    }, u.rotation)), {
                        selected: u.id === source.selectedUnderlayId,
                        corners: underlayWorldCorners(u).map(function(c) {
                            return {
                                x: c.x / PIXELS_PER_METER3,
                                y: c.y / PIXELS_PER_METER3
                            };
                        }),
                        stackIndex: stackIndex,
                        locked: !!u.locked
                    }));
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                        _iterator3.return();
                    }
                } finally{
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
        };
        for(var _iterator = source.floors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return out;
};
var entitiesWith = function(source, refid, floorId) {
    return buildEntities(source).filter(function(e) {
        return e.refid === refid && (floorId === void 0 || e.floorId === floorId);
    });
};
var floorsOf = function(found) {
    return Array.from(new Set(found.map(function(e) {
        return e.floorId;
    })));
};
var severalFloorsError = function(source, refid, floors) {
    return new Error('__planScene: "'.concat(refid, '" is drawn on floors ').concat(floors.join(", "), ' of pane "').concat(source.name, '" — name a floorId'));
};
var findEntity = function(source, refid, floorId) {
    var found = entitiesWith(source, refid, floorId);
    if (found.length > 1) {
        var floors = floorsOf(found);
        if (floors.length > 1) throw severalFloorsError(source, refid, floors);
        throw new Error('__planScene: "'.concat(refid, '" is drawn ').concat(found.length, " times on floor ").concat(floors[0], ' of pane "').concat(source.name, '" — read entities({ refid }) for every copy'));
    }
    var _found_;
    return (_found_ = found[0]) !== null && _found_ !== void 0 ? _found_ : null;
};
var buildHandles = function(source) {
    var rect = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : paneRect(source);
    var _source_wallsShown;
    var owners = source.handleOwners;
    var floorId = source.activeFloorId;
    var floor = source.floors.find(function(f) {
        return f.floorId === floorId;
    });
    if (!owners || !floor || floorId === null) return [];
    var design = floor.design;
    var out = [];
    var push = function(kind, refid, index, p, armed) {
        return out.push(_object_spread({
            kind: kind,
            refid: refid,
            index: index,
            floorId: floorId,
            x: p.x,
            y: p.y,
            client: planToClient(source, p, {
                floorId: floorId
            }, rect)
        }, armed === void 0 ? {} : {
            armed: armed
        }));
    };
    var rotating = new Set(owners.rotate);
    var _design_items;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = ((_design_items = design.items) !== null && _design_items !== void 0 ? _design_items : [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var stored = _step.value;
            var _source_itemShown, _source_footprintOf, _source_turnReachOf, _source_outlineOf;
            if (stored._deleted || !rotating.has(stored.refid)) continue;
            var _source_itemShown1;
            var item = (_source_itemShown1 = (_source_itemShown = source.itemShown) === null || _source_itemShown === void 0 ? void 0 : _source_itemShown.call(source, stored)) !== null && _source_itemShown1 !== void 0 ? _source_itemShown1 : stored;
            var footprint = (_source_footprintOf = source.footprintOf) === null || _source_footprintOf === void 0 ? void 0 : _source_footprintOf.call(source, item);
            if (!footprint) continue;
            var _source_turnReachOf1;
            var ring = machineTurnRing(item, (_source_turnReachOf1 = (_source_turnReachOf = source.turnReachOf) === null || _source_turnReachOf === void 0 ? void 0 : _source_turnReachOf.call(source, item.refid)) !== null && _source_turnReachOf1 !== void 0 ? _source_turnReachOf1 : machineTurnReach((_source_outlineOf = source.outlineOf) === null || _source_outlineOf === void 0 ? void 0 : _source_outlineOf.call(source, item), footprint), source.view.zoom);
            if (!ring) continue;
            push("rotate", item.refid, null, ring.front);
            out[out.length - 1].ring = {
                centre: ring.centre,
                radius: ring.radius
            };
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var cornered = new Set(owners.corners);
    var _design_surfaces;
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        var _loop = function() {
            var surface11 = _step1.value;
            if (surface11._deleted || !cornered.has(surface11.refid)) return "continue";
            surface11.poly.forEach(function(p, i) {
                return push("corner", surface11.refid, i, {
                    x: p.x,
                    y: p.y
                });
            });
        };
        for(var _iterator1 = ((_design_surfaces = design.surfaces) !== null && _design_surfaces !== void 0 ? _design_surfaces : [])[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_loop();
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    if (owners.edges !== null) {
        var _design_surfaces_find, _design_surfaces1, _source_armedEdge;
        var refid = owners.edges;
        var _design_surfaces_find_poly;
        var poly = (_design_surfaces_find_poly = (_design_surfaces1 = design.surfaces) === null || _design_surfaces1 === void 0 ? void 0 : (_design_surfaces_find = _design_surfaces1.find(function(x) {
            return x.refid === refid && !x._deleted;
        })) === null || _design_surfaces_find === void 0 ? void 0 : _design_surfaces_find.poly) !== null && _design_surfaces_find_poly !== void 0 ? _design_surfaces_find_poly : [];
        var armed = ((_source_armedEdge = source.armedEdge) === null || _source_armedEdge === void 0 ? void 0 : _source_armedEdge.refid) === refid ? source.armedEdge.index : null;
        poly.forEach(function(a, i) {
            var b = poly[(i + 1) % poly.length];
            push("edge", refid, i, {
                x: (a.x + b.x) / 2,
                y: (a.y + b.y) / 2
            }, i === armed);
        });
    }
    var _design_walls;
    var storedWalls = (_design_walls = design.walls) !== null && _design_walls !== void 0 ? _design_walls : [];
    var _source_wallsShown1;
    var walls2 = (_source_wallsShown1 = (_source_wallsShown = source.wallsShown) === null || _source_wallsShown === void 0 ? void 0 : _source_wallsShown.call(source, storedWalls, floorId)) !== null && _source_wallsShown1 !== void 0 ? _source_wallsShown1 : storedWalls;
    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
    try {
        var _loop1 = function() {
            var refid = _step2.value;
            var wall = walls2.find(function(w) {
                return w.id === refid;
            });
            if (!wall) return "continue";
            push("wall-end", refid, 0, {
                x: wall.a.x,
                y: wall.a.y
            });
            push("wall-end", refid, 1, {
                x: wall.b.x,
                y: wall.b.y
            });
        };
        for(var _iterator2 = owners.wallEnds[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true)_loop1();
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
            }
        } finally{
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
    if (owners.camera) {
        var _design_cameras, _source_cameraShown;
        var _owners_camera = owners.camera, refid1 = _owners_camera.refid, controls = _owners_camera.controls;
        var stored1 = (_design_cameras = design.cameras) === null || _design_cameras === void 0 ? void 0 : _design_cameras.find(function(c) {
            return c.refid === refid1 && !c._deleted;
        });
        var _source_cameraShown1;
        var camera = stored1 && ((_source_cameraShown1 = (_source_cameraShown = source.cameraShown) === null || _source_cameraShown === void 0 ? void 0 : _source_cameraShown.call(source, stored1)) !== null && _source_cameraShown1 !== void 0 ? _source_cameraShown1 : stored1);
        if (camera) {
            var h = handlePositions(camera, source.view.zoom);
            if (h.turn) push("camera-turn", refid1, null, h.turn);
            if (controls === "all" && h.widen) push("camera-widen", refid1, null, h.widen);
            if (controls === "all") push("camera-reach", refid1, null, h.reach);
        }
    }
    if (owners.underlay) {
        var _source_underlays;
        var knobbed = (_source_underlays = source.underlays) === null || _source_underlays === void 0 ? void 0 : _source_underlays.call(source).find(function(d) {
            return d.floorId === floorId && d.underlay.id === owners.underlay;
        });
        if (knobbed) {
            var knob = underlayTurnHandle(knobbed.underlay, source.view.zoom, {
                x: 0,
                y: 0,
                rotation: 0
            });
            push("underlay-rotate", knobbed.underlay.id, null, {
                x: knob.onFloor.x / PIXELS_PER_METER3,
                y: knob.onFloor.y / PIXELS_PER_METER3
            });
        }
    }
    var built = source.buildFloors;
    var _owners_floor;
    var owner = (_owners_floor = owners.floor) !== null && _owners_floor !== void 0 ? _owners_floor : null;
    var owned = owner === null ? void 0 : built === null || built === void 0 ? void 0 : built.floors.find(function(f) {
        return f.id === owner;
    });
    if (built && owned) {
        var _source_floorPlacementShown;
        var _source_floorPlacementShown1;
        var placement = (_source_floorPlacementShown1 = (_source_floorPlacementShown = source.floorPlacementShown) === null || _source_floorPlacementShown === void 0 ? void 0 : _source_floorPlacementShown.call(source, owned.id)) !== null && _source_floorPlacementShown1 !== void 0 ? _source_floorPlacementShown1 : placementOf7(owned);
        var h1 = floorHandles(findLatestDesign23(owned.designs), placement, source.view.zoom, built.footprintOf);
        var refid2 = "floor-".concat(owned.id);
        var at3 = function(kind, p) {
            var pane = planPointToPane6(p.metres, source.view);
            out.push({
                kind: kind,
                refid: refid2,
                index: null,
                floorId: owned.id,
                x: p.onFloor.x / PIXELS_PER_METER3,
                y: p.onFloor.y / PIXELS_PER_METER3,
                client: {
                    x: pane.x + rect.left,
                    y: pane.y + rect.top
                }
            });
        };
        if (h1) {
            at3("floor-move", h1.centre);
            at3("floor-rotate", h1.knob);
        }
    }
    return out;
};
var buildFloorStates = function(source) {
    var built = source.buildFloors;
    if (!built) return [];
    var floors = built.floors, activeFloorIndex = built.activeFloorIndex, visibility = built.visibility;
    return alignFloorDrawOrder(floors, activeFloorIndex, visibility).flatMap(function(param) {
        var floor = param.floor, index = param.index;
        var _source_floorPlacementShown;
        var state = floorDrawState5(floors, index, activeFloorIndex, visibility);
        if (state === "hidden") return [];
        var _source_floorPlacementShown1;
        return [
            {
                floorId: floor.id,
                name: floor.name,
                state: state,
                placement: _object_spread({}, (_source_floorPlacementShown1 = (_source_floorPlacementShown = source.floorPlacementShown) === null || _source_floorPlacementShown === void 0 ? void 0 : _source_floorPlacementShown.call(source, floor.id)) !== null && _source_floorPlacementShown1 !== void 0 ? _source_floorPlacementShown1 : placementOf7(floor)),
                heightM: floorElevationM(index)
            }
        ];
    });
};
var buildBounds = function(source) {
    var rect = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : paneRect(source);
    var b = source.contentBounds;
    if (!b || ![
        b.minX,
        b.minY,
        b.maxX,
        b.maxY
    ].every(Number.isFinite)) return null;
    if (b.maxX < b.minX || b.maxY < b.minY) return null;
    var plan = {
        minX: pixelsToMeters5(b.minX),
        minY: pixelsToMeters5(b.minY),
        maxX: pixelsToMeters5(b.maxX),
        maxY: pixelsToMeters5(b.maxY)
    };
    var corners = [
        {
            x: plan.minX,
            y: plan.minY
        },
        {
            x: plan.maxX,
            y: plan.minY
        },
        {
            x: plan.maxX,
            y: plan.maxY
        },
        {
            x: plan.minX,
            y: plan.maxY
        }
    ].map(function(p) {
        var pane = planPointToPane6(p, source.view);
        return {
            x: pane.x + rect.left,
            y: pane.y + rect.top
        };
    });
    return {
        plan: plan,
        client: boxOf(corners)
    };
};
var hitAtClient = function(source, c) {
    var rect = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : paneRect(source);
    if (!source.hitAt) return void 0;
    var x = c.x - rect.left;
    var y = c.y - rect.top;
    if (!(x >= 0 && y >= 0 && x <= rect.width && y <= rect.height)) return null;
    return source.hitAt({
        x: x,
        y: y
    });
};
var EMPTY_SPOT_INSET = 16;
var findEmptySpot = function(source, size) {
    var rect = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : paneRect(source), doc = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : document;
    var _source_surface;
    var width = size.width, height = size.height;
    var inner = {
        width: rect.width - 2 * EMPTY_SPOT_INSET,
        height: rect.height - 2 * EMPTY_SPOT_INSET
    };
    if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0 || width > inner.width || height > inner.height) {
        throw new Error("__planScene: emptySpot needs a positive size that fits the pane (asked ".concat(width, " \xd7 ").concat(height, ', pane "').concat(source.name, '" has ').concat(Math.max(inner.width, 0), " \xd7 ").concat(Math.max(inner.height, 0), " inside its ").concat(EMPTY_SPOT_INSET, "px inset)"));
    }
    var hitAt = source.hitAt;
    var _source_surface_current;
    var surface11 = (_source_surface_current = (_source_surface = source.surface) === null || _source_surface === void 0 ? void 0 : _source_surface.current) !== null && _source_surface_current !== void 0 ? _source_surface_current : null;
    if (!hitAt || !surface11) {
        throw new Error('__planScene: pane "'.concat(source.name, '" cannot find an empty spot — it passes no ').concat(!hitAt ? "hitAt" : "surface"));
    }
    var step = Math.min(8, width / 4, height / 4);
    var offsets = function(side) {
        var out = [];
        for(var k = 0; k * step < side; k++)out.push(k * step);
        out.push(side);
        return out;
    };
    var starts = function(side, room) {
        var out = [];
        for(var k = 0; k * step + side <= room + 1e-9; k++)out.push(k * step);
        return out;
    };
    var across = offsets(width);
    var down = offsets(height);
    var clear = /* @__PURE__ */ new Map();
    var clearAt = function(x, y) {
        var key = "".concat(x, ",").concat(y);
        var ok = clear.get(key);
        if (ok === void 0) {
            var top = doc.elementFromPoint(rect.left + x, rect.top + y);
            ok = hitAt({
                x: x,
                y: y
            }) === null && !!top && surface11.contains(top);
            clear.set(key, ok);
        }
        return ok;
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = starts(height, inner.height)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var y0 = _step.value;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = starts(width, inner.width)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var x0 = _step1.value;
                    var ok = true;
                    for(var v = 0; v < down.length && ok; v++){
                        for(var u = 0; u < across.length && ok; u++){
                            ok = clearAt(EMPTY_SPOT_INSET + x0 + across[u], EMPTY_SPOT_INSET + y0 + down[v]);
                        }
                    }
                    if (ok) {
                        return {
                            x: rect.left + EMPTY_SPOT_INSET + x0 + width / 2,
                            y: rect.top + EMPTY_SPOT_INSET + y0 + height / 2
                        };
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
};
var PLAN_SCENE_KEY = "__planScene";
var createRegistry = function(win) {
    var entries = [];
    var names = function() {
        return entries.map(function(e) {
            return e.name;
        });
    };
    var resolve = function() {
        var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var listed = function() {
            return names().join(", ") || "none";
        };
        var named2 = function(name) {
            var found = entries.filter(function(e) {
                return e.name === name;
            });
            if (found.length > 1) {
                throw new Error('__planScene: pane "'.concat(name, '" is registered ').concat(found.length, " times"));
            }
            return found[0];
        };
        if (opts.pane !== void 0) {
            var entry = named2(opts.pane);
            if (!entry) throw new Error('__planScene: no pane "'.concat(opts.pane, '" — registered: ').concat(listed()));
            return entry.ref.current;
        }
        var plan = named2("plan");
        if (plan) return plan.ref.current;
        if (entries.length === 1) return entries[0].ref.current;
        throw new Error("__planScene: name a pane — registered: ".concat(listed()));
    };
    var driver = {
        version: 4,
        panes: names,
        ready: function(opts) {
            var source = resolve(opts);
            var el = source.element.current;
            if (!el || !el.isConnected) return false;
            var rect = paneRect(source);
            return rect.width > 0 && rect.height > 0 && source.floors.length > 0;
        },
        element: function(opts) {
            return resolve(opts).element.current;
        },
        view: function(opts) {
            var source = resolve(opts);
            var _source_view = source.view, zoom = _source_view.zoom, pan = _source_view.pan, rotation = _source_view.rotation;
            var live = source.live;
            return {
                zoom: zoom,
                pan: _object_spread({}, pan),
                rotation: rotation,
                live: {
                    zoom: live.zoom,
                    pan: _object_spread({}, live.pan),
                    rotation: live.rotation
                },
                rect: paneRect(source)
            };
        },
        planToClient: function(p, opts) {
            return planToClient(resolve(opts), p, opts);
        },
        clientToPlan: function(c, opts) {
            return clientToPlan(resolve(opts), c, opts);
        },
        entities: function() {
            var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return buildEntities(resolve(opts)).filter(function(e) {
                return (opts.kind === void 0 || e.kind === opts.kind) && (opts.floorId === void 0 || e.floorId === opts.floorId) && (opts.refid === void 0 || e.refid === opts.refid);
            });
        },
        entity: function(refid) {
            var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return findEntity(resolve(opts), refid, opts.floorId);
        },
        select: function(refid) {
            var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            var source = resolve(opts);
            var found = entitiesWith(source, refid, opts.floorId);
            var floors = floorsOf(found);
            if (floors.length > 1) throw severalFloorsError(source, refid, floors);
            var entity = found[0];
            if (!entity) throw new Error('__planScene: "'.concat(refid, '" is not drawn on pane "').concat(source.name, '"'));
            if (!source.select) throw new Error('__planScene: pane "'.concat(source.name, '" does not select'));
            if (entity.floorId !== source.activeFloorId) {
                throw new Error('__planScene: "'.concat(refid, '" is on floor ').concat(entity.floorId, ", not the active floor ").concat(String(source.activeFloorId), ' of pane "').concat(source.name, '" — a click selects on the active floor only'));
            }
            var _opts_shift;
            source.select(refid, (_opts_shift = opts.shift) !== null && _opts_shift !== void 0 ? _opts_shift : false, entity.kind);
        },
        handles: function() {
            var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return buildHandles(resolve(opts)).filter(function(h) {
                return (opts.kind === void 0 || h.kind === opts.kind) && (opts.refid === void 0 || h.refid === opts.refid);
            });
        },
        floors: function(opts) {
            return buildFloorStates(resolve(opts));
        },
        bounds: function(opts) {
            return buildBounds(resolve(opts));
        },
        hitAt: function(c, opts) {
            return hitAtClient(resolve(opts), c);
        },
        emptySpot: function(size, opts) {
            return findEmptySpot(resolve(opts), size);
        },
        pane: function(opts) {
            var source = resolve(opts);
            var size = source.drawnSize;
            return {
                cursor: source.cursor ? source.cursor() : null,
                drawnSize: size ? {
                    width: size.width,
                    height: size.height
                } : null
            };
        },
        marks: function() {
            var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            var _source_marks;
            var source = resolve(opts);
            var _source_marks1;
            var marks = (_source_marks1 = (_source_marks = source.marks) === null || _source_marks === void 0 ? void 0 : _source_marks.call(source)) !== null && _source_marks1 !== void 0 ? _source_marks1 : [];
            if (marks.length === 0 || !source.floors.some(function(f) {
                return f.floorId === source.activeFloorId;
            })) {
                return [];
            }
            var rect = paneRect(source);
            return marks.filter(function(m) {
                return opts.kind === void 0 || m.kind === opts.kind;
            }).map(function(m) {
                return _object_spread_props(_object_spread({}, m), {
                    client: planToClient(source, m, {}, rect)
                });
            });
        }
    };
    return {
        register: function register(name, ref) {
            var entry = {
                name: name,
                ref: ref
            };
            entries.push(entry);
            win[PLAN_SCENE_KEY] = driver;
            return function() {
                var i = entries.indexOf(entry);
                if (i >= 0) entries.splice(i, 1);
                if (entries.length === 0 && win[PLAN_SCENE_KEY] === driver) delete win[PLAN_SCENE_KEY];
            };
        }
    };
};
// src/components/Planner/driver/usePlanSceneDriver.ts
var REGISTRY = Symbol.for("twinlabs.planSceneRegistry");
var registryFor = function(win) {
    var holder = win;
    if (!holder[REGISTRY]) holder[REGISTRY] = createRegistry(holder);
    return holder[REGISTRY];
};
function usePlanSceneDriver(source) {
    var ref = useRef48(source);
    useLayoutEffect8(function() {
        ref.current = source;
    });
    var name = source.name;
    useLayoutEffect8(function() {
        if (process.env.NODE_ENV === "production" || typeof window === "undefined") return void 0;
        return registryFor(window).register(name, ref);
    }, [
        name
    ]);
}
// src/components/Planner/readOnlyPlan/readOnlyCanvasProps.ts
var withReadOnlyCanvasDefaults = function(props) {
    var _props_floorIndex, _props_selectedId, _props_focusId, _props_fitBounds, _props_keepViewOnResize, _props_interactive, _props_pickable, _props_ariaLabel, _props_ariaRole;
    return _object_spread_props(_object_spread({}, props), {
        floorIndex: (_props_floorIndex = props.floorIndex) !== null && _props_floorIndex !== void 0 ? _props_floorIndex : 0,
        selectedId: (_props_selectedId = props.selectedId) !== null && _props_selectedId !== void 0 ? _props_selectedId : null,
        focusId: (_props_focusId = props.focusId) !== null && _props_focusId !== void 0 ? _props_focusId : null,
        fitBounds: (_props_fitBounds = props.fitBounds) !== null && _props_fitBounds !== void 0 ? _props_fitBounds : null,
        fitPadding: resolveFitPadding(props.fitPadding),
        revealId: props.revealId ? props.revealId : null,
        keepViewOnResize: (_props_keepViewOnResize = props.keepViewOnResize) !== null && _props_keepViewOnResize !== void 0 ? _props_keepViewOnResize : false,
        interactive: (_props_interactive = props.interactive) !== null && _props_interactive !== void 0 ? _props_interactive : true,
        pickable: (_props_pickable = props.pickable) !== null && _props_pickable !== void 0 ? _props_pickable : false,
        ariaLabel: (_props_ariaLabel = props.ariaLabel) !== null && _props_ariaLabel !== void 0 ? _props_ariaLabel : "Floor plan",
        ariaRole: (_props_ariaRole = props.ariaRole) !== null && _props_ariaRole !== void 0 ? _props_ariaRole : "region"
    });
};
// src/components/Planner/readOnlyPlan/useReadOnlyPlanView.ts
var useReadOnlyPlanView = function(canvasProps) {
    var driverRenderer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var props = withReadOnlyCanvasDefaults(canvasProps);
    var layout = props.layout, floorIndex = props.floorIndex, onSelectEntity = props.onSelectEntity, onHoverEntity = props.onHoverEntity, recentreSignal = props.recentreSignal, onZoomChange = props.onZoomChange, focusId = props.focusId, viewRotationProp = props.viewRotation, fitBounds = props.fitBounds, fitPadding = props.fitPadding, revealId = props.revealId, keepViewOnResize = props.keepViewOnResize, active = props.interactive, pickable = props.pickable, onBackgroundClick = props.onBackgroundClick, initialView = props.initialView;
    var picks = active || pickable;
    var selects = picks && !!onSelectEntity;
    var hovers = picks && !!onHoverEntity;
    var backgroundClick = pickable ? void 0 : onBackgroundClick;
    var entitiesListen = selects || hovers;
    var wrapperRef = useRef49(null);
    var size = usePaneSize(wrapperRef);
    var _useState52 = _sliced_to_array(useState52({
        zoom: 0.5,
        x: 0,
        y: 0
    }), 2), view = _useState52[0], setView = _useState52[1];
    var touchedRef = useRef49(false);
    var fittedFloorRef = useRef49(null);
    var fitZoomRef = useRef49(null);
    var recentreRef = useRef49(recentreSignal);
    var hostViewRef = useRef49(hostViewKey(viewRotationProp, fitBounds));
    var focusRef = useRef49(focusId);
    var revealRef = useRef49(revealId);
    var paneRef = useRef49(null);
    var keptForRef = useRef49(null);
    var initialViewRef = useRef49(focusId || fitBounds || viewRotationProp !== void 0 ? void 0 : initialView);
    var _useState521 = _sliced_to_array(useState52(null), 2), rotationOverride = _useState521[0], setRotationOverride = _useState521[1];
    var openedAtRef = useRef49(null);
    var floor = layout.floors[floorIndex];
    var design = floor ? findLatestDesign24(floor.designs) : null;
    var footprintOf = usePlanMachineFootprints();
    var footprintOfRef = useRef49(footprintOf);
    footprintOfRef.current = footprintOf;
    var pointsPx = useMemo33(function() {
        return design ? entityPointsPx(design) : null;
    }, [
        design
    ]);
    var outlinesPx = useMemo33(function() {
        return design ? surfaceOutlinesPx(design) : null;
    }, [
        design
    ]);
    var ownRotation = effectiveViewRotation(0, placementOf8(floor));
    var _ref;
    var viewRotation = (_ref = viewRotationProp !== null && viewRotationProp !== void 0 ? viewRotationProp : rotationOverride) !== null && _ref !== void 0 ? _ref : ownRotation;
    var hostView = hostViewKey(viewRotationProp, fitBounds);
    useLayoutEffect9(function() {
        var _keptForRef_current, _keptForRef_current1, _onHoverEntityRef_current;
        if (!design) return;
        var floorChanged = fittedFloorRef.current !== floorIndex;
        var recentre = recentreSignal !== recentreRef.current;
        recentreRef.current = recentreSignal;
        var refocus = focusId !== focusRef.current;
        focusRef.current = focusId;
        var reviewed = hostView !== hostViewRef.current;
        hostViewRef.current = hostView;
        var revealed = revealId !== revealRef.current;
        revealRef.current = revealId;
        var sizeOnly = !floorChanged && !recentre && !refocus && !reviewed;
        var reveal = function(base2) {
            var _onHoverEntityRef_current;
            if (!revealId) return;
            var _outlinesPx_get;
            var extent = (_outlinesPx_get = outlinesPx === null || outlinesPx === void 0 ? void 0 : outlinesPx.get(revealId)) !== null && _outlinesPx_get !== void 0 ? _outlinesPx_get : pointsPx === null || pointsPx === void 0 ? void 0 : pointsPx.get(revealId);
            if (!extent) return;
            var _revealShift = revealShift(extent, base2, size), dx = _revealShift.dx, dy = _revealShift.dy;
            if (dx === 0 && dy === 0) return;
            touchedRef.current = true;
            openedAtRef.current = null;
            livePanRef.current = null;
            (_onHoverEntityRef_current = onHoverEntityRef.current) === null || _onHoverEntityRef_current === void 0 ? void 0 : _onHoverEntityRef_current.call(onHoverEntityRef, null, null);
            setView(function(v) {
                return _object_spread_props(_object_spread({}, v), {
                    x: v.x + dx,
                    y: v.y + dy
                });
            });
        };
        var lastPane = paneRef.current;
        var samePane = !!lastPane && lastPane.width === size.width && lastPane.height === size.height;
        var sameFloor = ((_keptForRef_current = keptForRef.current) === null || _keptForRef_current === void 0 ? void 0 : _keptForRef_current.points) === pointsPx && ((_keptForRef_current1 = keptForRef.current) === null || _keptForRef_current1 === void 0 ? void 0 : _keptForRef_current1.rotation) === viewRotation;
        if (revealed && sizeOnly && samePane && (sameFloor || touchedRef.current)) {
            reveal({
                zoom: view.zoom,
                pan: {
                    x: view.x,
                    y: view.y
                },
                rotation: viewRotation
            });
            return;
        }
        var askOpening = function(resolve) {
            var _wrapperRef_current;
            var box = (_wrapperRef_current = wrapperRef.current) === null || _wrapperRef_current === void 0 ? void 0 : _wrapperRef_current.getBoundingClientRect();
            var laidOut = !!box && box.width > 0 && box.height > 0;
            var handed = resolve({
                left: laidOut ? box.left : 0,
                top: laidOut ? box.top : 0,
                width: size.width,
                height: size.height
            });
            if (!isUsablePlanView(handed)) return null;
            var held = clampViewZoom(handed, size, MIN_ZOOM, MAX_ZOOM);
            return {
                handed: handed,
                view: {
                    zoom: held.zoom,
                    x: held.pan.x,
                    y: held.pan.y
                }
            };
        };
        var opened = openedAtRef.current;
        if (opened) {
            var openedFor = paneRef.current;
            var reshaped = !openedFor || openedFor.width !== size.width || openedFor.height !== size.height;
            if (!sizeOnly) {
                openedAtRef.current = null;
            } else if (size.measured && reshaped) {
                var again = askOpening(opened);
                if (again) {
                    paneRef.current = {
                        width: size.width,
                        height: size.height
                    };
                    livePanRef.current = null;
                    setView(again.view);
                    if (revealed) reveal({
                        zoom: again.view.zoom,
                        pan: {
                            x: again.view.x,
                            y: again.view.y
                        },
                        rotation: viewRotation
                    });
                    return;
                }
                openedAtRef.current = null;
            }
        }
        var kept = paneRef.current;
        var resized = !!kept && (kept.width !== size.width || kept.height !== size.height);
        var keepFloor = sameFloor || touchedRef.current;
        if (sizeOnly && keepViewOnResize && kept && size.measured && resized && keepFloor) {
            var _onHoverEntityRef_current1;
            var dx = (size.width - kept.width) / 2;
            var dy = (size.height - kept.height) / 2;
            paneRef.current = {
                width: size.width,
                height: size.height
            };
            keptForRef.current = {
                points: pointsPx,
                rotation: viewRotation
            };
            livePanRef.current = null;
            (_onHoverEntityRef_current1 = onHoverEntityRef.current) === null || _onHoverEntityRef_current1 === void 0 ? void 0 : _onHoverEntityRef_current1.call(onHoverEntityRef, null, null);
            setView(function(v) {
                return _object_spread_props(_object_spread({}, v), {
                    x: v.x + dx,
                    y: v.y + dy
                });
            });
            var keptPan = {
                x: view.x + dx,
                y: view.y + dy
            };
            if (revealed) reveal({
                zoom: view.zoom,
                pan: keptPan,
                rotation: viewRotation
            });
            return;
        }
        if (sizeOnly && touchedRef.current) {
            if (size.measured) paneRef.current = {
                width: size.width,
                height: size.height
            };
            if (revealed) reveal({
                zoom: view.zoom,
                pan: {
                    x: view.x,
                    y: view.y
                },
                rotation: viewRotation
            });
            return;
        }
        var _pointsPx_get;
        var focus6 = focusId ? (_pointsPx_get = pointsPx === null || pointsPx === void 0 ? void 0 : pointsPx.get(focusId)) !== null && _pointsPx_get !== void 0 ? _pointsPx_get : null : null;
        var span = metersToPixels4(FOCUS_HALF_SPAN_M);
        var bounds = focus6 ? {
            minX: focus6.x - span,
            maxX: focus6.x + span,
            minY: focus6.y - span,
            maxY: focus6.y + span
        } : fitBounds !== null && fitBounds !== void 0 ? fitBounds : planDrawingOutline2(design, footprintOfRef.current);
        if (!bounds) return;
        var fitRotation = viewRotationProp !== null && viewRotationProp !== void 0 ? viewRotationProp : ownRotation;
        var fit = planViewFit(bounds, fitRotation, size, fitPadding);
        var resolveInitial = initialViewRef.current;
        initialViewRef.current = void 0;
        var opening = resolveInitial && fittedFloorRef.current === null ? askOpening(resolveInitial) : null;
        if (resolveInitial && opening) {
            var _onHoverEntityRef_current2;
            var handed = opening.handed;
            var turn = (handed.rotation % 360 + 360) % 360;
            var own = (fitRotation % 360 + 360) % 360;
            fittedFloorRef.current = floorIndex;
            fitZoomRef.current = fit.zoom;
            touchedRef.current = true;
            paneRef.current = size.measured ? {
                width: size.width,
                height: size.height
            } : null;
            keptForRef.current = {
                points: pointsPx,
                rotation: Math.abs(turn - own) < 1e-9 ? fitRotation : turn
            };
            livePanRef.current = null;
            (_onHoverEntityRef_current2 = onHoverEntityRef.current) === null || _onHoverEntityRef_current2 === void 0 ? void 0 : _onHoverEntityRef_current2.call(onHoverEntityRef, null, null);
            setRotationOverride(Math.abs(turn - own) < 1e-9 ? null : turn);
            openedAtRef.current = resolveInitial;
            setView(opening.view);
            return;
        }
        setRotationOverride(null);
        fittedFloorRef.current = floorIndex;
        fitZoomRef.current = fit.zoom;
        touchedRef.current = false;
        paneRef.current = size.measured ? {
            width: size.width,
            height: size.height
        } : null;
        keptForRef.current = {
            points: pointsPx,
            rotation: fitRotation
        };
        livePanRef.current = null;
        (_onHoverEntityRef_current = onHoverEntityRef.current) === null || _onHoverEntityRef_current === void 0 ? void 0 : _onHoverEntityRef_current.call(onHoverEntityRef, null, null);
        openedAtRef.current = null;
        setView({
            zoom: fit.zoom,
            x: fit.pan.x,
            y: fit.pan.y
        });
        if (size.measured) reveal({
            zoom: fit.zoom,
            pan: fit.pan,
            rotation: fitRotation
        });
    }, [
        design,
        pointsPx,
        floorIndex,
        size.width,
        size.height,
        size.measured,
        viewRotation,
        recentreSignal,
        focusId,
        revealId,
        hostView,
        keepViewOnResize
    ]);
    var onZoomChangeRef = useRef49(onZoomChange);
    onZoomChangeRef.current = onZoomChange;
    useEffect54(function() {
        var _onZoomChangeRef_current;
        var fitZoom = fitZoomRef.current;
        if (fitZoom) (_onZoomChangeRef_current = onZoomChangeRef.current) === null || _onZoomChangeRef_current === void 0 ? void 0 : _onZoomChangeRef_current.call(onZoomChangeRef, Math.round(view.zoom / fitZoom * 100));
    }, [
        view.zoom
    ]);
    var onSelectEntityRef = useRef49(onSelectEntity);
    onSelectEntityRef.current = onSelectEntity;
    var onHoverEntityRef = useRef49(onHoverEntity);
    onHoverEntityRef.current = onHoverEntity;
    var scrollBounds = useMemo33(function() {
        return planDrawingOutline2(design, footprintOf);
    }, [
        design,
        footprintOf
    ]);
    var pan = useMemo33(function() {
        return {
            x: view.x,
            y: view.y
        };
    }, [
        view.x,
        view.y
    ]);
    var moveView = function(next) {
        var _onHoverEntityRef_current;
        touchedRef.current = true;
        openedAtRef.current = null;
        if (hovers) (_onHoverEntityRef_current = onHoverEntityRef.current) === null || _onHoverEntityRef_current === void 0 ? void 0 : _onHoverEntityRef_current.call(onHoverEntityRef, null, null);
        setView({
            zoom: next.zoom,
            x: next.pan.x,
            y: next.pan.y
        });
    };
    var zoomAt = function(panePoint, factor) {
        return moveView(zoomAboutPoint({
            zoom: view.zoom,
            rotation: viewRotation,
            pan: pan
        }, panePoint, factor, {
            min: MIN_ZOOM,
            max: MAX_ZOOM
        }));
    };
    var _useState522 = _sliced_to_array(useState52(null), 2), dragPan = _useState522[0], setDragPan = _useState522[1];
    var livePanRef = useRef49(null);
    var livePan = dragPan !== null && dragPan !== void 0 ? dragPan : pan;
    var planView = {
        zoom: view.zoom,
        pan: pan,
        rotation: viewRotation
    };
    var livePlanView = {
        zoom: view.zoom,
        pan: livePan,
        rotation: viewRotation
    };
    var dragFrameRef = useRef49(null);
    useEffect54(function() {
        return function() {
            if (dragFrameRef.current !== null) cancelAnimationFrame(dragFrameRef.current);
        };
    }, []);
    var dragPanTo = function(next) {
        livePanRef.current = next;
        if (dragFrameRef.current !== null) return;
        dragFrameRef.current = requestAnimationFrame(function() {
            dragFrameRef.current = null;
            setDragPan(livePanRef.current);
        });
    };
    var settleLivePanRef = useRef49(false);
    var endDrag = function(next) {
        if (dragFrameRef.current !== null) cancelAnimationFrame(dragFrameRef.current);
        dragFrameRef.current = null;
        livePanRef.current = next;
        settleLivePanRef.current = true;
        setDragPan(null);
        moveView({
            zoom: view.zoom,
            pan: next
        });
    };
    var planPointAt = function(panePoint) {
        return panePointToPlan3(panePoint, planView);
    };
    var pointsPxRef = useRef49(pointsPx);
    var currentViewRef = useRef49(planView);
    useLayoutEffect9(function() {
        pointsPxRef.current = pointsPx;
        currentViewRef.current = planView;
        if (settleLivePanRef.current) {
            settleLivePanRef.current = false;
            livePanRef.current = null;
        }
    });
    var hoverPoint = useCallback26(function(refid) {
        var _pointsPxRef_current;
        var at3 = (_pointsPxRef_current = pointsPxRef.current) === null || _pointsPxRef_current === void 0 ? void 0 : _pointsPxRef_current.get(refid);
        if (!at3) return null;
        var _currentViewRef_current = currentViewRef.current, zoom = _currentViewRef_current.zoom, rotation = _currentViewRef_current.rotation, settled = _currentViewRef_current.pan;
        var _livePanRef_current;
        return worldPxToPane2(at3, {
            zoom: zoom,
            rotation: rotation,
            pan: (_livePanRef_current = livePanRef.current) !== null && _livePanRef_current !== void 0 ? _livePanRef_current : settled
        });
    }, []);
    var _props_driverName;
    var driverName = (_props_driverName = props.driverName) !== null && _props_driverName !== void 0 ? _props_driverName : "read-only";
    var _floor_id;
    usePlanSceneDriver(_object_spread({
        name: driverName,
        element: wrapperRef,
        view: planView,
        live: livePlanView,
        floors: floor && design ? [
            {
                floorId: floor.id,
                design: design,
                placement: null
            }
        ] : [],
        activeFloorId: (_floor_id = floor === null || floor === void 0 ? void 0 : floor.id) !== null && _floor_id !== void 0 ? _floor_id : null,
        selectedIds: props.selectedId ? [
            props.selectedId
        ] : [],
        drawsCameras: false,
        select: selects ? function(refid, _shift, kind) {
            var _onSelectEntityRef_current;
            if (kind !== "machine" && kind !== "space") {
                throw new Error("__planScene: a ".concat(kind, ' is not selectable on pane "').concat(driverName, '"'));
            }
            (_onSelectEntityRef_current = onSelectEntityRef.current) === null || _onSelectEntityRef_current === void 0 ? void 0 : _onSelectEntityRef_current.call(onSelectEntityRef, refid, kind === "space" ? "surface" : "item");
        } : null,
        toolMode: "select",
        editable: false,
        contentBounds: scrollBounds,
        drawnSize: size
    }, driverRenderer));
    var onKeyDown = function(e) {
        if (!active || e.target !== e.currentTarget) return;
        if (!e.ctrlKey && !e.metaKey && !e.altKey && [
            "+",
            "=",
            "-"
        ].includes(e.key)) {
            e.preventDefault();
            zoomAt({
                x: size.width / 2,
                y: size.height / 2
            }, e.key === "-" ? 1 / KEY_STEP : KEY_STEP);
            return;
        }
        var next = scrollPlanByKey2(e, {
            bounds: scrollBounds,
            zoom: view.zoom,
            rotation: viewRotation,
            pan: pan,
            viewport: size
        });
        if (!next) return;
        e.preventDefault();
        moveView({
            zoom: view.zoom,
            pan: next
        });
    };
    return {
        props: props,
        wrapperRef: wrapperRef,
        size: size,
        design: design,
        pointsPx: pointsPx,
        outlinesPx: outlinesPx,
        scrollBounds: scrollBounds,
        viewRotation: viewRotation,
        view: planView,
        liveView: livePlanView,
        selects: selects,
        hovers: hovers,
        entitiesListen: entitiesListen,
        backgroundClick: backgroundClick,
        onSelectEntityRef: onSelectEntityRef,
        onHoverEntityRef: onHoverEntityRef,
        moveView: moveView,
        zoomAt: zoomAt,
        onKeyDown: onKeyDown,
        dragPanTo: dragPanTo,
        endDrag: endDrag,
        planPointAt: planPointAt,
        hoverPoint: hoverPoint
    };
};
// src/components/Planner/readOnlyPlan/ReadOnlyPlanFrame.tsx
import styled49 from "styled-components";
import { jsx as jsx67, jsxs as jsxs47 } from "react/jsx-runtime";
var Wrapper3 = styled49.div(_templateObject197(), function(param) {
    var theme2 = param.theme;
    return theme2.colors.white;
}, planPaneFocusRing);
var ReadOnlyPlanFrame = function(param) {
    var plan = param.plan, onPressCapture = param.onPressCapture, children = param.children;
    var _plan_props = plan.props, active = _plan_props.interactive, pickable = _plan_props.pickable, ariaRole = _plan_props.ariaRole, ariaLabel = _plan_props.ariaLabel, wrapperRef = plan.wrapperRef, design = plan.design, backgroundClick = plan.backgroundClick, view = plan.view;
    if (!design) {
        return /* @__PURE__ */ jsx67(Wrapper3, _object_spread_props(_object_spread({
            ref: wrapperRef
        }, active ? {
            role: ariaRole,
            "aria-label": ariaLabel
        } : _object_spread({
            "aria-hidden": true,
            onClick: backgroundClick
        }, pickable ? {} : {
            style: {
                cursor: "pointer"
            }
        })), {
            children: /* @__PURE__ */ jsx67("div", {
                style: {
                    padding: 24,
                    color: "#666",
                    textAlign: "center"
                },
                children: "This version has no floor data."
            })
        }));
    }
    return /* @__PURE__ */ jsxs47(Wrapper3, _object_spread_props(_object_spread({
        ref: wrapperRef,
        style: {
            cursor: active || pickable ? "default" : "pointer"
        }
    }, active ? {
        tabIndex: 0,
        role: ariaRole,
        "aria-label": ariaLabel,
        // ARIA's grammar: '+' joins a modifier to a key, so zoom-in is announced as '=' (see the
        // planner's shortcuts.ts for why).
        "aria-keyshortcuts": "".concat(PLAN_PANE_SCROLL_KEYS, " = -")
    } : {
        tabIndex: -1,
        "aria-hidden": true,
        onClick: backgroundClick
    }), {
        onKeyDown: plan.onKeyDown,
        onMouseDownCapture: onPressCapture,
        onTouchStartCapture: onPressCapture,
        children: [
            children,
            active && /* @__PURE__ */ jsx67(PlanViewProvider, {
                view: view,
                live: plan.liveView,
                children: /* @__PURE__ */ jsx67(PlanPaneScrollbars, {
                    bounds: plan.scrollBounds,
                    viewport: plan.size,
                    onPan: function(next) {
                        return plan.moveView({
                            zoom: view.zoom,
                            pan: next
                        });
                    }
                })
            })
        ]
    }));
};
// src/components/Planner/readOnlyPlan/ReadOnlyPlanMarkers.tsx
import styled51 from "styled-components";
import { surface as surfaceTone } from "@repo/design-tokens";
import { metersToPixels as metersToPixels5, worldPxToPane as worldPxToPane3 } from "@repo/front-end-utils";
// src/components/Planner/plannerCanvas/ChangeGlyphDisc.tsx
import styled50 from "styled-components";
import { CHANGE_GLYPH, Icon as Icon29 } from "@repo/design-system";
import { semantic as semantic16, surface as surface10 } from "@repo/design-tokens";
import { jsx as jsx68 } from "react/jsx-runtime";
var DISC = HANDLE_STYLES.glyphDisc.size;
var MARK = semantic16.status.lastingMark;
var Disc2 = styled50.div(_templateObject198(), DISC, DISC, -DISC / 2, -DISC / 2, surface10[0], MARK.width, MARK.style, MARK.edge, MARK.ink);
var ChangeGlyphDisc = function(_param) {
    var glyph = _param.glyph, at3 = _param.at, rest = _object_without_properties(_param, [
        "glyph",
        "at"
    ]);
    return /* @__PURE__ */ jsx68(Disc2, _object_spread_props(_object_spread({}, rest), {
        "data-glyph": glyph,
        style: {
            left: at3.x,
            top: at3.y
        },
        children: /* @__PURE__ */ jsx68(Icon29, {
            name: CHANGE_GLYPH[glyph],
            size: "xs"
        })
    }));
};
// src/components/Planner/readOnlyPlan/ReadOnlyPlanMarkers.tsx
import { Fragment as Fragment32, jsx as jsx69, jsxs as jsxs48 } from "react/jsx-runtime";
var DISC_STEP = Math.ceil((MARKER_RING_RADIUS + HANDLE_STYLES.glyphDisc.size / 2) / Math.SQRT2);
var MARKER_CHANGE_DISC_OFFSET = {
    x: DISC_STEP,
    y: -DISC_STEP
};
var DiscLayer = styled51.div(_templateObject199());
var outlinePath = function(flat, view) {
    var points = [];
    for(var i = 0; i + 1 < flat.length; i += 2){
        var at3 = worldPxToPane3({
            x: flat[i],
            y: flat[i + 1]
        }, view);
        points.push("".concat(at3.x, ",").concat(at3.y));
    }
    return "M".concat(points.join("L"), "Z");
};
var polygonPx = function(polygonM) {
    if (polygonM.length < 3) return null;
    var flat = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = polygonM[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var point = _step.value;
            if (!Array.isArray(point) || point.length !== 2) return null;
            var _point = _sliced_to_array(point, 2), x = _point[0], y = _point[1];
            if (!Number.isFinite(x) || !Number.isFinite(y)) return null;
            flat.push(metersToPixels5(x), metersToPixels5(y));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return flat;
};
var ReadOnlyPlanMarkers = function(param) {
    var markers = param.markers, pointsPx = param.pointsPx, outlinesPx = param.outlinesPx, view = param.view, size = param.size;
    var outlineOf = function(marker) {
        var own = marker.shape === "outline" && marker.polygonM ? polygonPx(marker.polygonM) : void 0;
        if (own === null) return null;
        return own !== null && own !== void 0 ? own : marker.shape === "outline" ? outlinesPx === null || outlinesPx === void 0 ? void 0 : outlinesPx.get(marker.id) : void 0;
    };
    var svg = /* @__PURE__ */ jsx69("svg", {
        "aria-hidden": "true",
        width: size.width,
        height: size.height,
        style: {
            position: "absolute",
            inset: 0,
            pointerEvents: "none",
            overflow: "visible"
        },
        children: markers.map(function(marker, i) {
            var outline = outlineOf(marker);
            if (outline === null) return null;
            if (outline) {
                var _marker_fill;
                return /* @__PURE__ */ jsx69("path", {
                    "data-marker": marker.id,
                    d: outlinePath(outline, view),
                    fill: (_marker_fill = marker.fill) !== null && _marker_fill !== void 0 ? _marker_fill : "none",
                    stroke: marker.color,
                    strokeWidth: marker.emphasised ? OUTLINE_STROKE_EMPHASISED : OUTLINE_STROKE
                }, "".concat(marker.id, ":").concat(i));
            }
            var point = pointsPx === null || pointsPx === void 0 ? void 0 : pointsPx.get(marker.id);
            if (!point) return null;
            var at3 = worldPxToPane3(point, view);
            if (marker.statusOnModel) {
                var _marker_ring;
                return marker.emphasised ? /* @__PURE__ */ jsx69("circle", {
                    "data-marker": marker.id,
                    "data-marker-part": "ring",
                    cx: at3.x,
                    cy: at3.y,
                    r: MARKER_RING_RADIUS,
                    fill: (_marker_ring = marker.ring) !== null && _marker_ring !== void 0 ? _marker_ring : marker.color,
                    opacity: MARKER_RING_OPACITY
                }, "".concat(marker.id, ":").concat(i)) : null;
            }
            var _marker_ring1;
            return /* @__PURE__ */ jsxs48("g", {
                children: [
                    marker.emphasised && /* @__PURE__ */ jsx69("circle", {
                        cx: at3.x,
                        cy: at3.y,
                        r: MARKER_RING_RADIUS,
                        fill: (_marker_ring1 = marker.ring) !== null && _marker_ring1 !== void 0 ? _marker_ring1 : marker.color,
                        opacity: MARKER_RING_OPACITY
                    }),
                    /* @__PURE__ */ jsx69("circle", {
                        "data-marker": marker.id,
                        cx: at3.x,
                        cy: at3.y,
                        r: marker.emphasised ? MARKER_RADIUS_EMPHASISED : MARKER_RADIUS,
                        fill: marker.color,
                        stroke: surfaceTone[0],
                        strokeWidth: MARKER_STROKE
                    })
                ]
            }, "".concat(marker.id, ":").concat(i));
        })
    });
    var changed = markers.filter(function(m) {
        return m.change;
    });
    if (changed.length === 0) return svg;
    return /* @__PURE__ */ jsxs48(Fragment32, {
        children: [
            svg,
            /* @__PURE__ */ jsx69(DiscLayer, {
                "aria-hidden": "true",
                "data-marker-changes": "",
                children: changed.map(function(marker, i) {
                    var outline = outlineOf(marker);
                    var point = pointsPx === null || pointsPx === void 0 ? void 0 : pointsPx.get(marker.id);
                    if (outline === null || !point) return null;
                    var at3 = worldPxToPane3(point, view);
                    var outlined = outline !== void 0;
                    return /* @__PURE__ */ jsx69(ChangeGlyphDisc, {
                        "data-marker-change": marker.id,
                        glyph: marker.change,
                        at: outlined ? at3 : {
                            x: at3.x + MARKER_CHANGE_DISC_OFFSET.x,
                            y: at3.y + MARKER_CHANGE_DISC_OFFSET.y
                        }
                    }, "".concat(marker.id, ":").concat(i));
                })
            })
        ]
    });
};
// src/components/Planner/readOnlyPlan/ReadOnlyPlanPointMarkers.tsx
import { fontSans as fontSans6, weight as weight9 } from "@repo/design-tokens";
import { metersToPixels as metersToPixels6, worldPxToPane as worldPxToPane4 } from "@repo/front-end-utils";
import { jsx as jsx70, jsxs as jsxs49 } from "react/jsx-runtime";
var ReadOnlyPlanPointMarkers = function(param) {
    var points = param.points, view = param.view, size = param.size;
    return /* @__PURE__ */ jsx70("svg", {
        "aria-hidden": "true",
        width: size.width,
        height: size.height,
        style: {
            position: "absolute",
            inset: 0,
            pointerEvents: "none",
            overflow: "visible"
        },
        children: points.map(function(point, i) {
            if (!Number.isFinite(point.x) || !Number.isFinite(point.y)) return null;
            var at3 = worldPxToPane4({
                x: metersToPixels6(point.x),
                y: metersToPixels6(point.y)
            }, view);
            var look = PLAN_POINT_MARKER_LOOK[point.state];
            return(// Two points may share an id, and both draw.
            /* @__PURE__ */ jsxs49("g", {
                "data-point-marker": point.id,
                "data-state": point.state,
                children: [
                    look.halo ? /* @__PURE__ */ jsx70("circle", {
                        cx: at3.x,
                        cy: at3.y,
                        r: POINT_RADIUS + POINT_HALO,
                        fill: look.halo
                    }) : null,
                    /* @__PURE__ */ jsx70("circle", {
                        cx: at3.x,
                        cy: at3.y,
                        r: POINT_RADIUS - POINT_MARKER_RIM / 2,
                        fill: look.fill,
                        stroke: look.rim,
                        strokeWidth: POINT_MARKER_RIM,
                        strokeDasharray: look.dashed ? POINT_DASH.join(" ") : void 0
                    }),
                    /* @__PURE__ */ jsx70("text", {
                        x: at3.x,
                        y: at3.y,
                        textAnchor: "middle",
                        dominantBaseline: "central",
                        fontFamily: fontSans6,
                        fontWeight: weight9.semibold,
                        fontSize: POINT_LABEL_SIZE,
                        fill: look.ink,
                        children: point.label
                    })
                ]
            }, "".concat(point.id, ":").concat(i)));
        })
    });
};
// src/components/Planner/readOnlyPlan/useDrawnReport.ts
import { useLayoutEffect as useLayoutEffect10, useRef as useRef50 } from "react";
var useDrawnReport = function(drawn, onDrawnChange) {
    var toldRef = useRef50(false);
    var onDrawnChangeRef = useRef50(onDrawnChange);
    onDrawnChangeRef.current = onDrawnChange;
    useLayoutEffect10(function() {
        var _onDrawnChangeRef_current;
        if (drawn === toldRef.current) return;
        toldRef.current = drawn;
        (_onDrawnChangeRef_current = onDrawnChangeRef.current) === null || _onDrawnChangeRef_current === void 0 ? void 0 : _onDrawnChangeRef_current.call(onDrawnChangeRef, drawn);
    }, [
        drawn
    ]);
};
// src/components/Planner/plannerCanvas/PlanMachineMarks.tsx
import styled52 from "styled-components";
import { worldPxToPane as worldPxToPane5 } from "@repo/front-end-utils";
import { Fragment as Fragment33, jsx as jsx71, jsxs as jsxs50 } from "react/jsx-runtime";
var LARGEST_DOT_RADIUS = (_Math = Math).max.apply(_Math, _to_consumable_array(Object.values(PLAN_MACHINE_MARKS).map(function(style) {
    return markOuterDiameter(style) / 2;
})));
var DISC_STEP2 = Math.ceil((LARGEST_DOT_RADIUS + HANDLE_STYLES.glyphDisc.size / 2) / Math.SQRT2);
var MACHINE_CHANGE_DISC_OFFSET = {
    x: DISC_STEP2,
    y: -DISC_STEP2
};
var BARE_OUTER_RADIUS = markOuterDiameter(PLAN_MACHINE_MARKS.problem) / 2;
var Layer4 = styled52.div(_templateObject200());
var PlanMachineMarks = function(param) {
    var marks = param.marks, view = param.view, size = param.size;
    if (size.width <= 0 || size.height <= 0) return null;
    var placed = marks.map(function(mark) {
        return {
            mark: mark,
            at: worldPxToPane5(mark.point, view)
        };
    });
    return /* @__PURE__ */ jsxs50(Layer4, {
        "aria-hidden": "true",
        "data-plan-machine-layer": "",
        children: [
            /* @__PURE__ */ jsx71("svg", {
                "aria-hidden": "true",
                "data-plan-machine-marks": "",
                width: size.width,
                height: size.height,
                style: {
                    position: "absolute",
                    inset: 0,
                    pointerEvents: "none",
                    overflow: "visible"
                },
                children: placed.map(function(param) {
                    var mark = param.mark, at3 = param.at;
                    var _mark_status;
                    return /* @__PURE__ */ jsx71("g", {
                        "data-mark": mark.id,
                        "data-look": (_mark_status = mark.status) !== null && _mark_status !== void 0 ? _mark_status : "none",
                        children: mark.glowing && /* @__PURE__ */ jsxs50(Fragment33, {
                            children: [
                                /* @__PURE__ */ jsx71("circle", {
                                    "data-mark-part": "fading-halo",
                                    cx: at3.x,
                                    cy: at3.y,
                                    r: BARE_OUTER_RADIUS + PLAN_MACHINE_FADING_GLOW.haloSpread,
                                    fill: PLAN_MACHINE_FADING_GLOW.halo
                                }),
                                /* @__PURE__ */ jsx71("circle", {
                                    "data-mark-part": "fading-ring",
                                    cx: at3.x,
                                    cy: at3.y,
                                    r: BARE_OUTER_RADIUS + PLAN_MACHINE_FADING_GLOW.ringWidth / 2,
                                    fill: "none",
                                    stroke: PLAN_MACHINE_FADING_GLOW.ring,
                                    strokeWidth: PLAN_MACHINE_FADING_GLOW.ringWidth
                                })
                            ]
                        })
                    }, mark.id);
                })
            }),
            placed.map(function(param) {
                var mark = param.mark, at3 = param.at;
                return mark.change ? /* @__PURE__ */ jsx71(ChangeGlyphDisc, {
                    "data-machine-change": mark.id,
                    glyph: mark.change,
                    at: {
                        x: at3.x + MACHINE_CHANGE_DISC_OFFSET.x,
                        y: at3.y + MACHINE_CHANGE_DISC_OFFSET.y
                    }
                }, mark.id) : null;
            })
        ]
    });
};
// src/components/Planner/plannerCanvas/planMachineMarkList.ts
import { metersToPixels as metersToPixels7 } from "@repo/front-end-utils";
var planMachineMarks = function(param) {
    var items = param.items, itemShown = param.itemShown, lookContext = param.lookContext, aligning = param.aligning;
    if (aligning) return [];
    var marks = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            if (item._deleted) continue;
            var _planMachineAppearance = planMachineAppearance(item.refid, lookContext), status = _planMachineAppearance.status, glowing = _planMachineAppearance.glowing, change = _planMachineAppearance.change;
            if (status === "neutral" && !glowing && !change) continue;
            var shown2 = itemShown(item);
            if (!Number.isFinite(shown2.x) || !Number.isFinite(shown2.y)) continue;
            marks.push({
                id: item.refid,
                point: {
                    x: metersToPixels7(shown2.x),
                    y: metersToPixels7(shown2.y)
                },
                status: status === "neutral" ? null : status,
                glowing: glowing,
                change: change
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return marks;
};
// src/components/Planner/plannerCanvas/PlanSpaceChangeMarks.tsx
import styled53 from "styled-components";
import { worldPxToPane as worldPxToPane6 } from "@repo/front-end-utils";
import { jsx as jsx72 } from "react/jsx-runtime";
var Layer5 = styled53.div(_templateObject201());
var PlanSpaceChangeMarks = function(param) {
    var marks = param.marks, view = param.view, size = param.size, lift = param.lift;
    if (size.width <= 0 || size.height <= 0 || view.zoom <= 0 || marks.length === 0) return null;
    var liftWorld = lift / view.zoom;
    return /* @__PURE__ */ jsx72(Layer5, {
        "aria-hidden": "true",
        "data-plan-space-change-marks": "",
        children: marks.map(function(mark) {
            var at3 = worldPxToPane6({
                x: mark.point.x,
                y: mark.point.y + liftWorld
            }, view);
            return /* @__PURE__ */ jsx72(ChangeGlyphDisc, {
                "data-space-mark": mark.id,
                glyph: mark.glyph,
                at: at3
            }, mark.id);
        })
    });
};
// src/components/Planner/plannerCanvas/planSpaceChangeMarkList.ts
var planSpaceChangeMarks = function(param) {
    var surfaces = param.surfaces, lookContext = param.lookContext, aligning = param.aligning;
    if (aligning) return [];
    var marks = [];
    var seen = /* @__PURE__ */ new Set();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = surfaces[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var surface11 = _step.value;
            var _surface11_poly;
            var _surface11_poly_length;
            if (surface11._deleted || ((_surface11_poly_length = (_surface11_poly = surface11.poly) === null || _surface11_poly === void 0 ? void 0 : _surface11_poly.length) !== null && _surface11_poly_length !== void 0 ? _surface11_poly_length : 0) < 3 || seen.has(surface11.refid)) continue;
            seen.add(surface11.refid);
            var change = planSpaceAppearance(surface11.refid, lookContext).change;
            if (!change) continue;
            var point = centroidPx(surface11.poly);
            if (!Number.isFinite(point.x) || !Number.isFinite(point.y)) continue;
            marks.push({
                id: surface11.refid,
                point: point,
                glyph: change
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return marks;
};
// src/components/Planner/PlanLegend.tsx
import styled56 from "styled-components";
import { Card as Card5 } from "@repo/design-system";
import { semantic as semantic17, space as space26, typeRole as typeRole16 } from "@repo/design-tokens";
// src/components/Planner/canvas/PlanConeSwatch.tsx
import styled54 from "styled-components";
import { radius as radius12 } from "@repo/design-tokens";
import { jsx as jsx73 } from "react/jsx-runtime";
var SWATCH_CONE = {
    selected: CONE_STYLES.selected,
    other: CONE_STYLES.other,
    noStream: CONE_STYLES.noStream
};
var Swatch = styled54.span(_templateObject202(), radius12.sm, function(param) {
    var $fill = param.$fill;
    return $fill;
}, function(param) {
    var $dashed = param.$dashed;
    return $dashed ? "dashed" : "solid";
}, function(param) {
    var $stroke = param.$stroke;
    return $stroke;
});
var PlanConeSwatch = function(param) {
    var look = param.look;
    var _cone_dash;
    var cone = SWATCH_CONE[look];
    return /* @__PURE__ */ jsx73(Swatch, {
        "aria-hidden": "true",
        "data-look": look,
        $fill: cone.fill,
        $stroke: cone.stroke,
        $dashed: !!((_cone_dash = cone.dash) === null || _cone_dash === void 0 ? void 0 : _cone_dash.length)
    });
};
// src/components/Planner/canvas/PlanMarkSwatch.tsx
import styled55, { css as css7 } from "styled-components";
import { rgba as rgba7 } from "@repo/design-tokens";
import { jsx as jsx74 } from "react/jsx-runtime";
var SIZE = markOuterDiameter(PLAN_MACHINE_MARKS.problem);
var DOT = PLAN_MACHINE_MARKS.problem;
var SELECTION = PLAN_MACHINE_SELECTION;
var Swatch2 = styled55.span(_templateObject205(), SIZE, SIZE, function(param) {
    var $selected = param.$selected;
    return $selected ? // The selected machine's outline: its band, with its glow as a blur of the glow's reach, at
    // its strength.
    css7(_templateObject203(), SELECTION.linePx, SELECTION.stroke, SELECTION.glowPx, rgba7(SELECTION.stroke, SELECTION.glowOpacity)) : css7(_templateObject204(), DOT.dotFill, DOT.dotStrokeWidth, DOT.dotStroke);
});
var PlanMarkSwatch = function(param) {
    var look = param.look;
    return /* @__PURE__ */ jsx74(Swatch2, {
        "aria-hidden": "true",
        "data-look": look,
        $selected: look === "selected"
    });
};
// src/components/Planner/PlanLegend.tsx
import { Fragment as Fragment34, jsx as jsx75, jsxs as jsxs51 } from "react/jsx-runtime";
var List2 = styled56.ul(_templateObject206(), function(param) {
    var $row = param.$row;
    return $row ? "row" : "column";
}, function(param) {
    var $row = param.$row;
    return $row ? "wrap" : "nowrap";
}, function(param) {
    var $row = param.$row;
    return $row ? "center" : "stretch";
}, function(param) {
    var $row = param.$row;
    return $row ? "".concat(space26[1], " ").concat(space26[3]) : space26[1];
}, typeRole16.caption1.fontSize, typeRole16.caption1.lineHeight, semantic17.text.secondary, space26[2]);
var Framed = styled56(Card5)(_templateObject207(), space26[1], space26[2]);
var PlanLegend = function(param) {
    var entries = param.entries, lead = param.lead, _param_direction = param.direction, direction = _param_direction === void 0 ? "column" : _param_direction, _param_framed = param.framed, framed = _param_framed === void 0 ? false : _param_framed, className = param.className;
    var list = /* @__PURE__ */ jsxs51(List2, {
        $row: direction === "row",
        children: [
            lead ? /* @__PURE__ */ jsx75("li", {
                children: lead
            }) : null,
            entries.map(function(entry) {
                return /* @__PURE__ */ jsx75("li", {
                    children: entry.node
                }, entry.key);
            })
        ]
    });
    return framed ? /* @__PURE__ */ jsx75(Framed, {
        surface: "on-scene",
        role: "group",
        "aria-label": "Legend",
        className: className,
        children: list
    }) : /* @__PURE__ */ jsx75("div", {
        role: "group",
        "aria-label": "Legend",
        className: className,
        children: list
    });
};
var PlanCameraLegendEntry = function(param) {
    var look = param.look, label = param.label;
    return /* @__PURE__ */ jsxs51(Fragment34, {
        children: [
            /* @__PURE__ */ jsx75(PlanConeSwatch, {
                look: look
            }),
            /* @__PURE__ */ jsx75("span", {
                children: label
            })
        ]
    });
};
var PLAN_CAMERA_LEGEND = [
    {
        key: "selected",
        node: /* @__PURE__ */ jsx75(PlanCameraLegendEntry, {
            look: "selected",
            label: "Selected"
        })
    },
    {
        key: "other",
        node: /* @__PURE__ */ jsx75(PlanCameraLegendEntry, {
            look: "other",
            label: "Other cameras"
        })
    },
    {
        key: "noStream",
        node: /* @__PURE__ */ jsx75(PlanCameraLegendEntry, {
            look: "noStream",
            label: "No stream"
        })
    }
];
var PlanEntityLegendEntry = function(param) {
    var look = param.look, label = param.label;
    return /* @__PURE__ */ jsxs51(Fragment34, {
        children: [
            /* @__PURE__ */ jsx75(PlanMarkSwatch, {
                look: look
            }),
            /* @__PURE__ */ jsx75("span", {
                children: label
            })
        ]
    });
};
var PLAN_ENTITY_LEGEND = [
    {
        key: "error",
        node: /* @__PURE__ */ jsx75(PlanEntityLegendEntry, {
            look: "error",
            label: "Error"
        })
    },
    {
        key: "check",
        node: /* @__PURE__ */ jsx75(PlanEntityLegendEntry, {
            look: "check",
            label: "To check"
        })
    },
    {
        key: "identify",
        node: /* @__PURE__ */ jsx75(PlanEntityLegendEntry, {
            look: "identify",
            label: "Identify"
        })
    },
    {
        key: "selected",
        node: /* @__PURE__ */ jsx75(PlanEntityLegendEntry, {
            look: "selected",
            label: "Selected"
        })
    }
];
// src/components/Planner/floors/floorDrag.ts
import { pixelsToMeters as pixelsToMeters6, placementOf as placementOf9, roundToMm as roundToMm3 } from "@repo/front-end-utils";
function startFloorDrag(param) {
    var floor = param.floor, startWorld = param.world, startClient = param.client;
    var start = placementOf9(floor);
    var travelled = false;
    var moved = null;
    return {
        move: function(world, client) {
            if (!travelled && isClickRelease({
                clientX: startClient.x,
                clientY: startClient.y
            }, {
                clientX: client.x,
                clientY: client.y
            })) return null;
            travelled = true;
            moved = {
                x: start.x + pixelsToMeters6(world.x - startWorld.x),
                y: start.y + pixelsToMeters6(world.y - startWorld.y)
            };
            return _object_spread({}, start, moved);
        },
        commit: function(storedFloors) {
            var committed = moved;
            if (!committed) return null;
            var write = _object_spread_props(_object_spread({}, start), {
                x: roundToMm3(committed.x),
                y: roundToMm3(committed.y)
            });
            if (write.x === start.x && write.y === start.y) return null;
            if (!(storedFloors === null || storedFloors === void 0 ? void 0 : storedFloors.some(function(f) {
                return f.id === floor.id;
            }))) return null;
            return {
                floorId: floor.id,
                write: write,
                announcement: floorMovedSentence(floor.name)
            };
        }
    };
}
// src/components/Planner/floors/useFloorTurn.ts
import { useEffect as useEffect55, useRef as useRef51 } from "react";
import { useEditorStore as useEditorStore54, useFloorplanStore as useFloorplanStore62 } from "@repo/front-end-state";
import { findLatestDesign as findLatestDesign25, floorOutlineCentre as floorOutlineCentre3, placementOf as placementOf10, rotatePlacementAbout as rotatePlacementAbout2, roundToMm as roundToMm4, snapBuildRotation } from "@repo/front-end-utils";
function useFloorTurn(param) {
    var pressed = param.pressed, onRotated = param.onRotated;
    var footprintOf = usePlanMachineFootprints();
    var turning = useRef51(null);
    useEffect55(function() {
        return function() {
            if (turning.current) useEditorStore54.getState().setFloorPlacementPreview(null);
        };
    }, []);
    return {
        snap: snapBuildRotation,
        onPress: function() {
            var floor = pressed();
            turning.current = floor ? {
                id: floor.id,
                name: floor.name,
                start: placementOf10(floor),
                pivot: floorOutlineCentre3(findLatestDesign25(floor.designs), footprintOf)
            } : null;
        },
        onPreview: function(angle) {
            var target = turning.current;
            if (angle === null || !target) {
                turning.current = null;
                useEditorStore54.getState().setFloorPlacementPreview(null);
                return;
            }
            useEditorStore54.getState().setFloorPlacementPreview({
                floorId: target.id,
                placement: rotatePlacementAbout2(target.start, target.pivot, angle)
            });
        },
        onCommit: function(angle) {
            var _useFloorplanStore62_getState_layout;
            var target = turning.current;
            turning.current = null;
            useEditorStore54.getState().setFloorPlacementPreview(null);
            var current2 = (_useFloorplanStore62_getState_layout = useFloorplanStore62.getState().layout) === null || _useFloorplanStore62_getState_layout === void 0 ? void 0 : _useFloorplanStore62_getState_layout.floors.find(function(f) {
                return f.id === (target === null || target === void 0 ? void 0 : target.id);
            });
            if (!target || !current2) return;
            var turned = rotatePlacementAbout2(placementOf10(current2), target.pivot, angle);
            runPlacementEdit(function() {
                return useFloorplanStore62.getState().setFloorPlacement(target.id, {
                    x: roundToMm4(turned.x),
                    y: roundToMm4(turned.y),
                    rotation: angle
                });
            });
            onRotated(target.name, angle);
        }
    };
}
// src/components/Planner/underlays/underlayDrag.ts
import { PIXELS_PER_METER as PIXELS_PER_METER4, pixelsToMeters as pixelsToMeters7, roundToMm as roundToMm5, UNDERLAY_WIDTH_MAX_M, UNDERLAY_WIDTH_MIN_M, underlayImageScale, underlayWidthMetres, worldPixelsToFloor as worldPixelsToFloor2 } from "@repo/front-end-utils";
function startUnderlayDrag(start) {
    var underlay = start.underlay, mode = start.mode, placement = start.placement;
    var startOnFloor = worldPixelsToFloor2(start.world, placement);
    var startScale = PIXELS_PER_METER4 / underlayImageScale(underlay);
    var travelled = false;
    var patch = null;
    return {
        move: function(world, client) {
            if (!travelled && isClickRelease({
                clientX: start.client.x,
                clientY: start.client.y
            }, {
                clientX: client.x,
                clientY: client.y
            })) return null;
            travelled = true;
            if (mode === "select") {
                var onFloor = worldPixelsToFloor2(world, placement);
                patch = {
                    x: underlay.x + pixelsToMeters7(onFloor.x - startOnFloor.x),
                    y: underlay.y + pixelsToMeters7(onFloor.y - startOnFloor.y)
                };
                return {
                    patch: patch,
                    readout: null
                };
            }
            var factor = Math.pow(2, (client.y - start.client.y) / 200);
            var scale = Math.min(underlay.widthPx / UNDERLAY_WIDTH_MIN_M, Math.max(underlay.widthPx / UNDERLAY_WIDTH_MAX_M, startScale / factor));
            patch = {
                scale: scale
            };
            return {
                patch: patch,
                readout: "".concat(underlayWidthMetres({
                    widthPx: underlay.widthPx,
                    scale: scale
                }).toFixed(1), " m wide")
            };
        },
        commit: function(stored) {
            var committed = patch;
            if (!committed || !stored) return null;
            var write = "scale" in committed ? {
                scale: committed.scale,
                scaleFromM: void 0
            } : {
                x: roundToMm5(committed.x),
                y: roundToMm5(committed.y)
            };
            var changed = "scale" in committed ? committed.scale !== PIXELS_PER_METER4 / underlayImageScale(stored) : committed.x !== stored.x || committed.y !== stored.y;
            if (!changed) return null;
            return {
                write: write,
                announcement: "scale" in write ? "".concat(underlay.name, " scaled to ").concat(underlayWidthMetres({
                    widthPx: underlay.widthPx,
                    scale: write.scale
                }).toFixed(1), " m wide.") : "".concat(underlay.name, " moved.")
            };
        }
    };
}
// src/components/Planner/underlays/useUnderlayTurn.ts
import { useEffect as useEffect56, useRef as useRef52 } from "react";
import { useEditorStore as useEditorStore55, useFloorplanStore as useFloorplanStore63 } from "@repo/front-end-state";
import { snapBuildRotation as snapBuildRotation2 } from "@repo/front-end-utils";
function useUnderlayTurn(param) {
    var pressed = param.pressed, onRotated = param.onRotated;
    var turning = useRef52(null);
    useEffect56(function() {
        return function() {
            if (turning.current) useEditorStore55.getState().setUnderlayPreview(null);
        };
    }, []);
    return {
        snap: snapBuildRotation2,
        onPress: function() {
            var u = pressed();
            turning.current = u ? {
                id: u.id,
                name: u.name
            } : null;
        },
        onPreview: function(angle) {
            var target = turning.current;
            if (angle === null || !target) {
                turning.current = null;
                useEditorStore55.getState().setUnderlayPreview(null);
                return;
            }
            useEditorStore55.getState().setUnderlayPreview({
                underlayId: target.id,
                patch: {
                    rotation: angle
                }
            });
        },
        onCommit: function(angle) {
            var _useFloorplanStore63_getState_layout;
            var target = turning.current;
            turning.current = null;
            useEditorStore55.getState().setUnderlayPreview(null);
            if (!target || !findUnderlay((_useFloorplanStore63_getState_layout = useFloorplanStore63.getState().layout) === null || _useFloorplanStore63_getState_layout === void 0 ? void 0 : _useFloorplanStore63_getState_layout.floors, target.id)) return;
            runUnderlayEdit(function() {
                return useFloorplanStore63.getState().updateUnderlay(target.id, {
                    rotation: angle
                });
            });
            onRotated(target.name, angle);
        }
    };
}
// src/components/Planner/underlays/scaleLineLook.ts
import { metersToPixels as metersToPixels8 } from "@repo/front-end-utils";
var SCALE_LINE_COLOR = "#F59E0B";
var scaleLineLabel = function(lengthWorldPx, gridSizeCm) {
    var gridStep = metersToPixels8(gridSizeCm / 100);
    var squares = gridStep > 0 ? lengthWorldPx / gridStep : 0;
    return squares > 0 ? "".concat(squares.toFixed(squares < 10 ? 1 : 0), " grid squares") : null;
};
// src/components/Planner/drawTools/useScaleLineDraw.ts
import { useCallback as useCallback27, useEffect as useEffect57, useRef as useRef53 } from "react";
import { useEditorStore as useEditorStore56 } from "@repo/front-end-state";
import { useScaleCalibrationStore as useScaleCalibrationStore4 } from "@repo/front-end-state";
import { metersToPixels as metersToPixels9, snapPlannerPoint as snapPlannerPoint6 } from "@repo/front-end-utils";
function useScaleLineDraw(pressRef) {
    var toolMode = useEditorStore56(function(s) {
        return s.toolMode;
    });
    var gridSnap = useEditorStore56(function(s) {
        return s.gridSnap;
    });
    var gridSize = useEditorStore56(function(s) {
        return s.gridSize;
    });
    var pointA = useScaleCalibrationStore4(function(s) {
        return s.pointA;
    });
    var pointB = useScaleCalibrationStore4(function(s) {
        return s.pointB;
    });
    var cursorPos = useScaleCalibrationStore4(function(s) {
        return s.cursorPos;
    });
    var setPointA = useScaleCalibrationStore4(function(s) {
        return s.setPointA;
    });
    var setPointB = useScaleCalibrationStore4(function(s) {
        return s.setPointB;
    });
    var setCursorPos = useScaleCalibrationStore4(function(s) {
        return s.setCursorPos;
    });
    var setShowDistanceDialog = useScaleCalibrationStore4(function(s) {
        return s.setShowDistanceDialog;
    });
    var resetCalibration = useScaleCalibrationStore4(function(s) {
        return s.reset;
    });
    var pointARef = useRef53(pointA);
    pointARef.current = pointA;
    var toolModeRef = useRef53(toolMode);
    toolModeRef.current = toolMode;
    var gridSnapRef = useRef53(gridSnap);
    gridSnapRef.current = gridSnap;
    var gridSizeRef = useRef53(gridSize);
    gridSizeRef.current = gridSize;
    useEffect57(function() {
        if (toolMode !== "calibrate_scale") {
            resetCalibration();
        }
    }, [
        toolMode,
        resetCalibration
    ]);
    var getWorldPos = useCallback27(function(pointer, free) {
        var raw = pointer.plan();
        if (!raw) return null;
        var placed = snapPlannerPoint6(raw, {
            gridSnap: gridSnapRef.current,
            gridSizeCm: gridSizeRef.current,
            free: free
        });
        return {
            x: metersToPixels9(placed.x),
            y: metersToPixels9(placed.y)
        };
    }, []);
    var onClick = useCallback27(function(pointer) {
        if (toolModeRef.current !== "calibrate_scale") return;
        if (!isClickRelease(pressRef.current, pointer)) return;
        var pos = getWorldPos(pointer, pointer.shiftKey);
        if (!pos) return;
        if (!pointARef.current) {
            setPointA(pos);
        } else {
            setPointB(pos);
            setShowDistanceDialog(true);
        }
    }, [
        pressRef,
        getWorldPos,
        setPointA,
        setPointB,
        setShowDistanceDialog
    ]);
    var onMove = useCallback27(function(pointer) {
        if (toolModeRef.current !== "calibrate_scale" || !pointARef.current) return;
        var pos = getWorldPos(pointer, pointer.shiftKey);
        if (pos) setCursorPos(pos);
    }, [
        getWorldPos,
        setCursorPos
    ]);
    return {
        isActive: toolMode === "calibrate_scale",
        pointA: pointA,
        pointB: pointB,
        cursorPos: cursorPos,
        onClick: onClick,
        onMove: onMove
    };
}
// src/components/Planner/hooks/useCameraNameCommit.ts
import { useCallback as useCallback28, useEffect as useEffect58, useRef as useRef54 } from "react";
function useCameraNameCommit(param) {
    var refid = param.refid, name = param.name, onChange = param.onChange, onFocusStart = param.onFocusStart, resolveOnLeave = param.resolveOnLeave, onResolved = param.onResolved;
    var nameAtFocus = useRef54(null);
    var inputEl = useRef54(null);
    var isFocused = function() {
        return !!inputEl.current && inputEl.current.isConnected && document.activeElement === inputEl.current;
    };
    var pending = useRef54({
        refid: refid,
        name: name,
        onChange: onChange,
        resolveOnLeave: resolveOnLeave,
        onResolved: onResolved
    });
    useEffect58(function() {
        pending.current = {
            refid: refid,
            name: name,
            onChange: onChange,
            resolveOnLeave: resolveOnLeave,
            onResolved: onResolved
        };
    });
    var commit = useCallback28(function(p) {
        var atFocus = nameAtFocus.current;
        if (atFocus === null) return;
        if (p.name === atFocus) return;
        var stored = p.name;
        if (p.resolveOnLeave) {
            var _p_onResolved;
            var resolved = p.resolveOnLeave(p.name);
            if (resolved === null) {
                var _p_onResolved1;
                if (p.name !== atFocus) p.onChange({
                    name: atFocus
                }, {
                    commit: false
                }, p.refid);
                (_p_onResolved1 = p.onResolved) === null || _p_onResolved1 === void 0 ? void 0 : _p_onResolved1.call(p, null);
                return;
            }
            if (resolved !== p.name) (_p_onResolved = p.onResolved) === null || _p_onResolved === void 0 ? void 0 : _p_onResolved.call(p, resolved);
            stored = resolved;
        }
        if (stored !== atFocus) p.onChange({
            name: stored
        }, {
            commit: true
        }, p.refid);
        else p.onChange({
            name: stored
        }, {
            commit: false
        }, p.refid);
    }, []);
    useEffect58(function() {
        return function() {
            commit(pending.current);
            nameAtFocus.current = null;
        };
    }, [
        refid,
        commit
    ]);
    useEffect58(function() {
        if (isFocused()) nameAtFocus.current = name;
    }, [
        refid
    ]);
    return {
        value: name,
        onFocus: function(e) {
            inputEl.current = e.currentTarget;
            nameAtFocus.current = name;
            onFocusStart === null || onFocusStart === void 0 ? void 0 : onFocusStart();
        },
        onChange: function(e) {
            return onChange({
                name: e.target.value
            }, {
                commit: false
            }, refid);
        },
        onBlur: function() {
            commit({
                refid: refid,
                name: name,
                onChange: onChange,
                resolveOnLeave: resolveOnLeave,
                onResolved: onResolved
            });
            nameAtFocus.current = null;
        }
    };
}
// src/components/Planner/machineCard/MachineCard.tsx
import { useCallback as useCallback30, useEffect as useEffect61, useId as useId8, useLayoutEffect as useLayoutEffect12, useMemo as useMemo35, useRef as useRef60, useState as useState56 } from "react";
import styled60 from "styled-components";
import { Button as Button27, Combobox as Combobox3, DockedCard as DockedCard2, Icon as Icon31, MenuTrailingLabel as MenuTrailingLabel2, Note as Note5, OverrideRows as OverrideRows2 } from "@repo/design-system";
import { inset as inset11, space as space28 } from "@repo/design-tokens";
import { useEditorStore as useEditorStore58, useEquipmentCatalogStore as useEquipmentCatalogStore25, useFloorplanStore as useFloorplanStore64, useManufacturerCatalogStore as useManufacturerCatalogStore2 } from "@repo/front-end-state";
import { isOutcomeUnconfirmed as isOutcomeUnconfirmed2 } from "@repo/front-end-services";
import { assetIdentityState, findLatestDesign as findLatestDesign27, isLive as isLive15, isNameTaken as isNameTaken6, nextFreeName as nextFreeName6 } from "@repo/front-end-utils";
import { normaliseAssetUid as normaliseAssetUid6 } from "@repo/frontend-types";
// src/components/Planner/machineCard/useMachineCardModel.ts
import { useMemo as useMemo34, useRef as useRef55 } from "react";
import { registerReadState as registerReadState12, useEditorStore as useEditorStore57, useEquipmentCatalogStore as useEquipmentCatalogStore23 } from "@repo/front-end-state";
import { buildTwinNameIndex as buildTwinNameIndex6, findLatestDesign as findLatestDesign26, firstLiveSurfaces as firstLiveSurfaces3, isLive as isLive14, resolvePlanHierarchy as resolvePlanHierarchy9, resolvePlanParentage as resolvePlanParentage10, twinNameEntryFor as twinNameEntryFor3, twinNameSignature as twinNameSignature3 } from "@repo/front-end-utils";
function useMachineCardModel(twinBid, twinId) {
    var layout = useJoinedLayout(twinBid, twinId);
    var floorIndex = useCardFloorIndex();
    var selectedIds = useEditorStore57(function(s) {
        return s.selectedEntityIds;
    });
    var registerRows = useEquipmentCatalogStore23(function(s) {
        return s.registerRows;
    });
    var registerRead = useEquipmentCatalogStore23(function(s) {
        return registerReadState12(s, {
            twinId: twinId !== null && twinId !== void 0 ? twinId : void 0
        });
    });
    var selectedId = selectedIds.length === 1 ? selectedIds[0] : null;
    var floor = layout === null || layout === void 0 ? void 0 : layout.floors[floorIndex];
    var design = floor ? findLatestDesign26(floor.designs) : null;
    var _design_items_find;
    var item = selectedId && design ? (_design_items_find = design.items.find(function(i) {
        return i.refid === selectedId && isLive14(i);
    })) !== null && _design_items_find !== void 0 ? _design_items_find : null : null;
    var itemRegister = useMemo34(function() {
        return resolveItemRegisterState(item, registerRows, registerRead);
    }, [
        item,
        registerRows,
        registerRead
    ]);
    var row = itemRegister.kind === "backed" ? itemRegister.row : null;
    var nameSignature = useMemo34(function() {
        return twinNameSignature3(layout);
    }, [
        layout
    ]);
    var layoutForNames = useRef55(layout);
    layoutForNames.current = layout;
    var nameIndex = useMemo34(function() {
        return buildTwinNameIndex6(layoutForNames.current, registerRows);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- geometry-only layout writes must not rebuild the register half
    [
        nameSignature,
        registerRows
    ]);
    var nameSelf = item ? twinNameEntryFor3(item, "machine") : void 0;
    var parent = null;
    if (item && design) {
        var _resolvePlanParentage10_item;
        var _resolvePlanParentage10_item_effectiveParent;
        var parentRefid = (_resolvePlanParentage10_item_effectiveParent = (_resolvePlanParentage10_item = resolvePlanParentage10(design).item(item)) === null || _resolvePlanParentage10_item === void 0 ? void 0 : _resolvePlanParentage10_item.effectiveParent) !== null && _resolvePlanParentage10_item_effectiveParent !== void 0 ? _resolvePlanParentage10_item_effectiveParent : null;
        var space29 = parentRefid ? firstLiveSurfaces3(design.surfaces).find(function(s) {
            return s.refid === parentRefid;
        }) : void 0;
        var _parentOwnName, _space29_entityCode;
        if (space29) parent = {
            name: (_parentOwnName = parentOwnName(design, parentRefid)) !== null && _parentOwnName !== void 0 ? _parentOwnName : "",
            code: (_space29_entityCode = space29.entityCode) !== null && _space29_entityCode !== void 0 ? _space29_entityCode : null
        };
    }
    var _floor_name, _floor_id;
    return {
        item: item,
        layout: layout,
        registerRows: registerRows,
        registerRead: registerRead,
        itemRegister: itemRegister,
        row: row,
        nameIndex: nameIndex,
        nameSelf: nameSelf,
        parent: parent,
        floorName: (_floor_name = floor === null || floor === void 0 ? void 0 : floor.name) !== null && _floor_name !== void 0 ? _floor_name : null,
        floorId: (_floor_id = floor === null || floor === void 0 ? void 0 : floor.id) !== null && _floor_id !== void 0 ? _floor_id : null,
        floorIndex: floorIndex,
        design: design !== null && design !== void 0 ? design : null,
        // Both memoised per design by their owners, so a render that changes no design re-derives nothing.
        parentage: design ? resolvePlanParentage10(design) : null,
        hierarchy: design ? resolvePlanHierarchy9(design) : null,
        selectionKey: item ? selectedId : null
    };
}
// src/components/Planner/machineCard/useRegisterFieldCommit.ts
import { useRef as useRef56, useState as useState53 } from "react";
function useRegisterFieldCommit(param) {
    var field = param.field, column = param.column, item = param.item, row = param.row, selectionKey = param.selectionKey;
    var _write_failure;
    var write = useItemRegisterWrite({
        item: item,
        row: row,
        selectionKey: selectionKey
    });
    var _useState53 = _sliced_to_array(useState53(null), 2), draft = _useState53[0], setDraftState = _useState53[1];
    var _useState531 = _sliced_to_array(useState53(null), 2), draftFor = _useState531[0], setDraftFor = _useState531[1];
    if (draftFor !== selectionKey) {
        setDraftFor(selectionKey);
        if (draft !== null) setDraftState(null);
    }
    var _row_column;
    var stored = ((_row_column = row === null || row === void 0 ? void 0 : row[column]) !== null && _row_column !== void 0 ? _row_column : "").trim();
    var showing = useRef56(selectionKey);
    showing.current = selectionKey;
    var inFlightFor = useRef56(null);
    var commit = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var next, forKey, saved;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (inFlightFor.current !== null && inFlightFor.current === selectionKey || draft === null || !row) return [
                            2,
                            false
                        ];
                        next = draft.trim();
                        if (next === stored) {
                            setDraftState(null);
                            write.clearFailure();
                            return [
                                2,
                                false
                            ];
                        }
                        forKey = selectionKey;
                        inFlightFor.current = forKey;
                        saved = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            write.write(field, _define_property({}, column, next === "" ? null : next))
                        ];
                    case 2:
                        saved = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        if (inFlightFor.current === forKey) inFlightFor.current = null;
                        return [
                            7
                        ];
                    case 4:
                        if (saved && showing.current === forKey) setDraftState(null);
                        return [
                            2,
                            saved
                        ];
                }
            });
        });
        return function commit() {
            return _ref.apply(this, arguments);
        };
    }();
    var _write_failure_message;
    return {
        value: draft !== null && draft !== void 0 ? draft : stored,
        setDraft: function(value) {
            setDraftState(value);
            if (write.failure) write.clearFailure();
        },
        commit: commit,
        error: (_write_failure_message = (_write_failure = write.failure) === null || _write_failure === void 0 ? void 0 : _write_failure.message) !== null && _write_failure_message !== void 0 ? _write_failure_message : null,
        isWriting: write.isWriting
    };
}
// src/components/Planner/machineCard/MachineCapacityRow.tsx
import { useEffect as useEffect59, useRef as useRef57, useState as useState54 } from "react";
import styled57 from "styled-components";
import { Input as Input9 } from "@repo/design-system";
import { fontSans as fontSans7, ink as ink14, typeScale as typeScale9 } from "@repo/design-tokens";
import { jsx as jsx76 } from "react/jsx-runtime";
var MACHINE_CAPACITY_ROW = "capacity";
var Unit2 = styled57.span(_templateObject208(), fontSans7, typeScale9.caption1.fontSize, ink14[3]);
function useMachineCapacityRow(param) {
    var item = param.item, row = param.row, selectionKey = param.selectionKey, editing = param.editing, onEditingChange = param.onEditingChange, announce = param.announce, helpId = param.helpId, reasonId = param.reasonId, container = param.container;
    var _write_failure;
    var write = useItemRegisterWrite({
        item: item,
        row: row,
        selectionKey: selectionKey
    });
    var key = selectionKey !== null && selectionKey !== void 0 ? selectionKey : "";
    var _useState54 = _sliced_to_array(useState54(null), 2), draft = _useState54[0], setDraft = _useState54[1];
    var _useState541 = _sliced_to_array(useState54(null), 2), refusal = _useState541[0], setRefusal = _useState541[1];
    var _useState542 = _sliced_to_array(useState54(null), 2), lastKind = _useState542[0], setLastKind = _useState542[1];
    var fieldRef = useRef57(null);
    var focusNext = useRef57(null);
    var closing = useRef57(false);
    var pending = useRef57(/* @__PURE__ */ new Set());
    var liveKey = useRef57(key);
    liveKey.current = key;
    useEffect59(function() {
        var what = focusNext.current;
        if (!what) return;
        focusNext.current = null;
        if (what === "select") {
            var _fieldRef_current, _fieldRef_current1;
            (_fieldRef_current = fieldRef.current) === null || _fieldRef_current === void 0 ? void 0 : _fieldRef_current.focus();
            (_fieldRef_current1 = fieldRef.current) === null || _fieldRef_current1 === void 0 ? void 0 : _fieldRef_current1.select();
        } else {
            var _container_current_querySelector, _container_current;
            (_container_current = container.current) === null || _container_current === void 0 ? void 0 : (_container_current_querySelector = _container_current.querySelector('button[data-override-row="'.concat(MACHINE_CAPACITY_ROW, '"]'))) === null || _container_current_querySelector === void 0 ? void 0 : _container_current_querySelector.focus();
        }
    });
    var currentDraft = (draft === null || draft === void 0 ? void 0 : draft.key) === key ? draft : null;
    var currentRefusal = (refusal === null || refusal === void 0 ? void 0 : refusal.key) === key ? refusal : null;
    var failure = ((_write_failure = write.failure) === null || _write_failure === void 0 ? void 0 : _write_failure.field) === "capacity" ? write.failure : null;
    var failedKind = (lastKind === null || lastKind === void 0 ? void 0 : lastKind.key) === key ? lastKind.kind : "set";
    var failureText = failure ? failure.unknownOutcome ? CAPACITY_MAYBE_SAVED : failedKind === "product" ? productCapacityFailed(failure.message) : failure.message : null;
    var alert = announce.alert;
    useEffect59(function() {
        if (failureText) alert(failureText);
    }, [
        failureText,
        alert
    ]);
    var close = function(refocus) {
        var forKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : key;
        if (liveKey.current === forKey) {
            closing.current = true;
            if (refocus) focusNext.current = "action";
        }
        setDraft(function(d) {
            return (d === null || d === void 0 ? void 0 : d.key) === forKey ? null : d;
        });
        setRefusal(function(r) {
            return (r === null || r === void 0 ? void 0 : r.key) === forKey ? null : r;
        });
        onEditingChange(false);
    };
    var stored = typeof (row === null || row === void 0 ? void 0 : row.capacity) === "number" ? row.capacity : null;
    var open = function() {
        if (!row) return;
        closing.current = false;
        focusNext.current = "select";
        setDraft({
            key: key,
            value: stored === null ? "" : String(stored),
            typed: false
        });
        setRefusal(null);
        write.clearFailure();
        onEditingChange(true);
    };
    var writeCapacity = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(forKey, capacity) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        pending.current.add(forKey);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            write.write("capacity", {
                                capacity: capacity
                            })
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 3:
                        pending.current.delete(forKey);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function writeCapacity(forKey, capacity) {
            return _ref.apply(this, arguments);
        };
    }();
    var commit = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(how) {
            var typed, refused, value, forKey;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!editing || currentDraft === null || closing.current || pending.current.has(key)) return [
                            2
                        ];
                        if (how === "blur" && (currentRefusal || failure)) return [
                            2
                        ];
                        typed = currentDraft.value.trim();
                        if (typed === "" || !currentDraft.typed) {
                            close(how === "enter");
                            return [
                                2
                            ];
                        }
                        refused = capacityRefusal(typed, "unknown");
                        if (refused) {
                            setRefusal({
                                key: key,
                                text: refused
                            });
                            announce.alert(refused);
                            return [
                                2
                            ];
                        }
                        value = Number(typed);
                        if (value === stored && (row === null || row === void 0 ? void 0 : row.capacity_source) === "override") {
                            close(how === "enter");
                            return [
                                2
                            ];
                        }
                        setLastKind({
                            key: key,
                            kind: "set"
                        });
                        forKey = key;
                        return [
                            4,
                            writeCapacity(forKey, value)
                        ];
                    case 1:
                        if (_state.sent()) {
                            close(how === "enter", forKey);
                            if (liveKey.current === forKey) announce.polite(SAVED);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function commit(how) {
            return _ref.apply(this, arguments);
        };
    }();
    var takeProductCapacity = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var forKey;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (pending.current.has(key)) return [
                            2
                        ];
                        setLastKind({
                            key: key,
                            kind: "product"
                        });
                        forKey = key;
                        return [
                            4,
                            writeCapacity(forKey, null)
                        ];
                    case 1:
                        if (_state.sent() && liveKey.current === forKey) {
                            focusNext.current = "action";
                            announce.polite(SAVED);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function takeProductCapacity() {
            return _ref.apply(this, arguments);
        };
    }();
    if (!row) {
        var own = typeof (item === null || item === void 0 ? void 0 : item.capacity) === "number" ? item.capacity : null;
        return {
            open: open,
            row: {
                id: MACHINE_CAPACITY_ROW,
                label: "Capacity",
                value: own === null ? NOT_SET : String(own),
                muted: own === null,
                action: {
                    label: SET_BY_HAND,
                    icon: "hand",
                    "aria-label": SET_BY_HAND,
                    disabled: true,
                    "aria-describedby": reasonId,
                    onAction: function() {
                        return void 0;
                    }
                }
            }
        };
    }
    if (editing && currentDraft) {
        var _currentRefusal_text;
        var errorText = (_currentRefusal_text = currentRefusal === null || currentRefusal === void 0 ? void 0 : currentRefusal.text) !== null && _currentRefusal_text !== void 0 ? _currentRefusal_text : failedKind === "set" ? failureText : null;
        var help = errorText ? {
            text: errorText,
            tone: "error",
            id: helpId
        } : {
            text: MACHINE_CAPACITY_HELP,
            tone: "neutral",
            id: helpId
        };
        return {
            open: open,
            row: {
                id: MACHINE_CAPACITY_ROW,
                label: "Capacity",
                help: help,
                editing: /* @__PURE__ */ jsx76(Input9, {
                    ref: fieldRef,
                    size: "sm",
                    "aria-label": "Capacity",
                    "aria-describedby": helpId,
                    "aria-busy": write.isWriting || void 0,
                    readOnly: write.isWriting,
                    inputMode: "numeric",
                    value: currentDraft.value,
                    invalid: help.tone === "error",
                    trail: /* @__PURE__ */ jsx76(Unit2, {
                        "aria-hidden": "true",
                        children: PEOPLE
                    }),
                    onChange: function(e) {
                        setDraft({
                            key: key,
                            value: e.target.value,
                            typed: true
                        });
                        if (currentRefusal) setRefusal(null);
                        if (failure) write.clearFailure();
                    },
                    onBlur: function() {
                        return void commit("blur");
                    },
                    onKeyDown: function(e) {
                        if (e.key === "Enter") {
                            e.preventDefault();
                            void commit("enter");
                        } else if (e.key === "Escape") {
                            e.preventDefault();
                            e.stopPropagation();
                            close(true);
                        }
                    }
                })
            }
        };
    }
    var handSet = row.capacity_source === "override";
    return {
        open: open,
        row: {
            id: MACHINE_CAPACITY_ROW,
            label: "Capacity",
            value: stored === null ? NOT_SET : String(stored),
            muted: stored === null,
            source: stored === null ? void 0 : handSet ? BY_HAND : FROM_PRODUCT,
            help: failureText ? {
                text: failureText,
                tone: "error",
                id: helpId
            } : void 0,
            action: handSet && stored !== null ? {
                label: productCapacityLabel(row.catalogue_capacity),
                icon: "box",
                "aria-label": productCapacityLabel(row.catalogue_capacity),
                loading: write.isWriting,
                "aria-describedby": failureText ? helpId : void 0,
                onAction: function() {
                    return void takeProductCapacity();
                }
            } : {
                label: SET_BY_HAND,
                icon: "hand",
                "aria-label": SET_BY_HAND,
                loading: write.isWriting,
                "aria-describedby": failureText ? helpId : void 0,
                onAction: open
            }
        }
    };
}
// src/components/Planner/machineCard/MachineIdRow.tsx
import { useEffect as useEffect60, useRef as useRef58 } from "react";
import styled58 from "styled-components";
import { Input as Input10 } from "@repo/design-system";
import { fontMono as fontMono6 } from "@repo/design-tokens";
import { jsx as jsx77 } from "react/jsx-runtime";
var MonoField = styled58.div(_templateObject209(), fontMono6);
function useRegisterIdRow(param) {
    var id = param.id, label = param.label, penLabel = param.penLabel, help = param.help, field = param.field, stored = param.stored, selectionKey = param.selectionKey, hasRow = param.hasRow, unreadValue = param.unreadValue, editing = param.editing, onEditingChange = param.onEditingChange, announce = param.announce, helpId = param.helpId, container = param.container;
    var fieldRef = useRef58(null);
    var focusNext = useRef58(null);
    var closing = useRef58(false);
    var liveKey = useRef58(selectionKey);
    liveKey.current = selectionKey;
    useEffect60(function() {
        var what = focusNext.current;
        if (!what) return;
        focusNext.current = null;
        if (what === "select") {
            var _fieldRef_current, _fieldRef_current1;
            (_fieldRef_current = fieldRef.current) === null || _fieldRef_current === void 0 ? void 0 : _fieldRef_current.focus();
            (_fieldRef_current1 = fieldRef.current) === null || _fieldRef_current1 === void 0 ? void 0 : _fieldRef_current1.select();
        } else {
            var _container_current_querySelector, _container_current;
            (_container_current = container.current) === null || _container_current === void 0 ? void 0 : (_container_current_querySelector = _container_current.querySelector('button[data-override-row="'.concat(id, '"]'))) === null || _container_current_querySelector === void 0 ? void 0 : _container_current_querySelector.focus();
        }
    });
    var alert = announce.alert;
    useEffect60(function() {
        if (field.error) alert(field.error);
    }, [
        field.error,
        alert
    ]);
    if (!hasRow) {
        return {
            id: id,
            label: label,
            value: unreadValue !== null && unreadValue !== void 0 ? unreadValue : NEEDS_REGISTER_ROW,
            muted: true
        };
    }
    var close = function(refocus) {
        closing.current = true;
        if (refocus) focusNext.current = "action";
        onEditingChange(false);
    };
    var commit = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(how) {
            var forKey, saved;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (closing.current) return [
                            2
                        ];
                        forKey = selectionKey;
                        return [
                            4,
                            field.commit()
                        ];
                    case 1:
                        saved = _state.sent();
                        if (liveKey.current !== forKey) {
                            if (saved) onEditingChange(false);
                            return [
                                2
                            ];
                        }
                        if (saved) {
                            close(how === "enter");
                            announce.polite(SAVED);
                            return [
                                2
                            ];
                        }
                        if (field.value.trim() === stored.trim()) close(how === "enter");
                        return [
                            2
                        ];
                }
            });
        });
        return function commit(how) {
            return _ref.apply(this, arguments);
        };
    }();
    if (editing) {
        return {
            id: id,
            label: label,
            help: field.error ? {
                text: field.error,
                tone: "error",
                id: helpId
            } : {
                text: help,
                tone: "neutral",
                id: helpId
            },
            editing: /* @__PURE__ */ jsx77(MonoField, {
                children: /* @__PURE__ */ jsx77(Input10, {
                    ref: fieldRef,
                    size: "sm",
                    "aria-label": label,
                    "aria-describedby": helpId,
                    "aria-busy": field.isWriting || void 0,
                    readOnly: field.isWriting,
                    value: field.value,
                    invalid: !!field.error,
                    onChange: function(e) {
                        return field.setDraft(e.target.value);
                    },
                    onBlur: function() {
                        return void commit("blur");
                    },
                    onKeyDown: function(e) {
                        if (e.key === "Enter") {
                            e.preventDefault();
                            void commit("enter");
                        } else if (e.key === "Escape") {
                            e.preventDefault();
                            e.stopPropagation();
                            field.setDraft(stored);
                            close(true);
                        }
                    }
                })
            })
        };
    }
    var value = stored.trim();
    return {
        id: id,
        label: label,
        value: value === "" ? NOT_SET : value,
        mono: value !== "",
        muted: value === "",
        help: field.error ? {
            text: field.error,
            tone: "error",
            id: helpId
        } : void 0,
        action: {
            icon: "pen",
            "aria-label": penLabel,
            "aria-describedby": field.error ? helpId : void 0,
            onAction: function() {
                closing.current = false;
                focusNext.current = "select";
                field.setDraft(stored);
                onEditingChange(true);
            }
        }
    };
}
// src/components/Planner/machineCard/MachineProductBlock.tsx
import { forwardRef as forwardRef3, useCallback as useCallback29, useId as useId7, useImperativeHandle, useLayoutEffect as useLayoutEffect11, useRef as useRef59, useState as useState55 } from "react";
import styled59 from "styled-components";
import { Button as Button26, Icon as Icon30, Note as Note4 } from "@repo/design-system";
import { fontSans as fontSans8, ink as ink15, inset as inset10, space as space27, typeRole as typeRole17, weight as weight10 } from "@repo/design-tokens";
import { useEquipmentCatalogStore as useEquipmentCatalogStore24 } from "@repo/front-end-state";
import { Fragment as Fragment35, jsx as jsx78, jsxs as jsxs52 } from "react/jsx-runtime";
var Strip = styled59.div(_templateObject210(), MODEL_SQUARE_PX, space27[3], inset10[1]);
var FallbackSquare = styled59(ModelSquare)(_templateObject211(), space27[1], typeRole17.caption2.fontFamily, typeRole17.caption2.fontSize, typeRole17.caption2.lineHeight, typeRole17.caption2.fontWeight, ink15[3]);
var What = styled59.div(_templateObject212());
var Name2 = styled59.p(_templateObject213(), function(param) {
    var $missing = param.$missing;
    return $missing ? "italic ".concat(weight10.regular) : weight10.semibold;
}, typeRole17.body1.fontSize, typeRole17.body1.lineHeight, fontSans8, function(param) {
    var $missing = param.$missing;
    return $missing ? ink15[3] : ink15[1];
});
var Maker = styled59.p(_templateObject214(), weight10.regular, typeRole17.caption1.fontSize, typeRole17.caption1.lineHeight, fontSans8, ink15[3]);
var StripActions = styled59.div(_templateObject215(), space27[2], inset10[2]);
var Picking = styled59.div(_templateObject216(), space27[2]);
var Actions4 = styled59.div(_templateObject217(), space27[2]);
var ModelSquareFallback = function() {
    return /* @__PURE__ */ jsxs52(FallbackSquare, {
        "aria-hidden": "true",
        "data-model-fallback": "",
        children: [
            /* @__PURE__ */ jsx78(Icon30, {
                name: "cube",
                size: "md"
            }),
            "3D model"
        ]
    });
};
var MachineProductBlock = forwardRef3(function MachineProductBlock2(param, ref) {
    var item = param.item, row = param.row, host = param.host, toastRegion = param.toastRegion, modelPreview = param.modelPreview;
    var _write_failure;
    var _useState55 = _sliced_to_array(useState55(false), 2), editing = _useState55[0], setEditing = _useState55[1];
    var _useState551 = _sliced_to_array(useState55(null), 2), chosen = _useState551[0], setChosen = _useState551[1];
    var write = useItemRegisterWrite({
        item: item,
        row: row,
        selectionKey: item.refid
    });
    var ids = useId7();
    var nameId = "".concat(ids, "-name");
    var makerId = "".concat(ids, "-maker");
    var toggleRef = useRef59(null);
    var wasEditing = useRef59(editing);
    useLayoutEffect11(function() {
        var _toggleRef_current;
        var closed = wasEditing.current && !editing;
        wasEditing.current = editing;
        if (!closed) return;
        var active = document.activeElement;
        if (active && active !== document.body) return;
        (_toggleRef_current = toggleRef.current) === null || _toggleRef_current === void 0 ? void 0 : _toggleRef_current.focus();
    }, [
        editing
    ]);
    var onChosenChange = useCallback29(function(referenceId, product) {
        return setChosen(referenceId ? {
            referenceId: referenceId,
            product: product
        } : null);
    }, []);
    var hasProduct = !!(row === null || row === void 0 ? void 0 : row.reference_id);
    var busy = write.isWriting || !!host && host.identifyBusy;
    var change = useRowProductChange({
        row: row,
        identifyRow: host === null || host === void 0 ? void 0 : host.identifyRow,
        write: function(fields, options) {
            return write.write("product", fields, options);
        },
        currentRow: function(rowId) {
            return useEquipmentCatalogStore24.getState().registerRows.find(function(r) {
                return r.id === rowId;
            });
        },
        toastRegion: toastRegion
    }).change;
    var take = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(referenceId, product) {
            var _row_asset_name, label, outcome;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!row || !host || busy) return [
                            2,
                            "unavailable"
                        ];
                        label = "“".concat(((_row_asset_name = row.asset_name) === null || _row_asset_name === void 0 ? void 0 : _row_asset_name.trim()) || item.name || row.name, "”");
                        return [
                            4,
                            change(referenceId, product, label)
                        ];
                    case 1:
                        outcome = _state.sent();
                        if (outcome === "moved" || outcome === "unchanged" || outcome === "changed") {
                            setEditing(false);
                        }
                        return [
                            2,
                            outcome
                        ];
                }
            });
        });
        return function take(referenceId, product) {
            return _ref.apply(this, arguments);
        };
    }();
    useImperativeHandle(ref, function() {
        return {
            openPicker: function() {
                if (row && host) setEditing(true);
            },
            take: take
        };
    });
    var failure = ((_write_failure = write.failure) === null || _write_failure === void 0 ? void 0 : _write_failure.field) === "product" ? write.failure.message : null;
    var failureNote = failure && /* @__PURE__ */ jsx78(Note4, {
        tone: "error",
        role: "alert",
        icon: /* @__PURE__ */ jsx78(Icon30, {
            name: "circle-exclamation",
            size: "xs"
        }),
        children: "".concat(PRODUCT_CHANGE_FAILED, " ").concat(failure)
    });
    if (editing && host && row) {
        var _row_asset_name;
        var _row_category_raw, _row_manufacturer_raw;
        var group = {
            key: "machine-card:".concat(row.id),
            label: ((_row_asset_name = row.asset_name) === null || _row_asset_name === void 0 ? void 0 : _row_asset_name.trim()) || row.name,
            count: 1,
            sampleAssetId: row.id,
            written: {
                category: (_row_category_raw = row.category_raw) !== null && _row_category_raw !== void 0 ? _row_category_raw : null,
                manufacturer: (_row_manufacturer_raw = row.manufacturer_raw) !== null && _row_manufacturer_raw !== void 0 ? _row_manufacturer_raw : null
            },
            proposal: row.match_proposal ? {
                manufacturer: row.match_proposal.manufacturer,
                reference_id: row.match_proposal.reference_id,
                reason: row.match_proposal.reason
            } : null
        };
        return /* @__PURE__ */ jsxs52(Picking, {
            children: [
                /* @__PURE__ */ jsx78(IdentifyPlanPicker, {
                    group: group,
                    fetchers: host.fetchers,
                    planFetchers: host.planFetchers,
                    busy: busy,
                    logContext: host.logContext,
                    onChosenChange: onChosenChange,
                    onTake: function(referenceId, product) {
                        return void take(referenceId, product);
                    }
                }),
                failureNote,
                /* @__PURE__ */ jsxs52(Actions4, {
                    children: [
                        /* @__PURE__ */ jsx78(Button26, {
                            variant: "text",
                            size: "xs",
                            disabled: busy,
                            onClick: function() {
                                return setEditing(false);
                            },
                            children: "Cancel"
                        }),
                        /* @__PURE__ */ jsx78(Button26, {
                            variant: "primary",
                            size: "xs",
                            loading: busy,
                            disabled: !chosen,
                            onClick: function() {
                                if (chosen) void take(chosen.referenceId, chosen.product);
                            },
                            children: (chosen === null || chosen === void 0 ? void 0 : chosen.product) ? "Use ".concat(chosen.product.product) : "Use"
                        })
                    ]
                })
            ]
        });
    }
    var name = row ? productName(row) : null;
    var second = row ? name ? productMakerLine(row) : null : LINK_OR_ADD_FIRST;
    var _item_modelFile;
    return /* @__PURE__ */ jsxs52(Fragment35, {
        children: [
            /* @__PURE__ */ jsxs52(Strip, {
                "data-testid": "product-strip",
                children: [
                    modelPreview ? modelPreview((_item_modelFile = item.modelFile) !== null && _item_modelFile !== void 0 ? _item_modelFile : null) : /* @__PURE__ */ jsx78(ModelSquareFallback, {}),
                    /* @__PURE__ */ jsxs52(What, {
                        children: [
                            /* @__PURE__ */ jsx78(Name2, {
                                id: nameId,
                                $missing: !name,
                                title: name !== null && name !== void 0 ? name : void 0,
                                children: name !== null && name !== void 0 ? name : NO_PRODUCT_YET
                            }),
                            second && /* @__PURE__ */ jsx78(Maker, {
                                id: makerId,
                                title: second,
                                children: second
                            }),
                            (host || !row) && /* @__PURE__ */ jsx78(StripActions, {
                                children: /* @__PURE__ */ jsx78(Button26, {
                                    ref: toggleRef,
                                    type: "button",
                                    variant: "frosted",
                                    size: "xs",
                                    iconLeft: /* @__PURE__ */ jsx78(Icon30, {
                                        name: "magnifying-glass",
                                        size: "xs"
                                    }),
                                    disabled: !row || !host,
                                    "aria-describedby": row ? void 0 : "".concat(nameId, " ").concat(makerId),
                                    onClick: function() {
                                        return setEditing(true);
                                    },
                                    children: !row || hasProduct ? CHANGE_PRODUCT : IDENTIFY
                                })
                            })
                        ]
                    })
                ]
            }),
            failureNote
        ]
    });
});
// src/components/Planner/machineCard/MachineCard.tsx
import { jsx as jsx79, jsxs as jsxs53 } from "react/jsx-runtime";
var PLAN_PANE2 = "[data-plan-pane]";
var liveFloorIndexOf = function(refid, floorId) {
    var _useFloorplanStore64_getState_layout;
    if (floorId === void 0) return null;
    var _useFloorplanStore64_getState_layout_floors;
    var floors = (_useFloorplanStore64_getState_layout_floors = (_useFloorplanStore64_getState_layout = useFloorplanStore64.getState().layout) === null || _useFloorplanStore64_getState_layout === void 0 ? void 0 : _useFloorplanStore64_getState_layout.floors) !== null && _useFloorplanStore64_getState_layout_floors !== void 0 ? _useFloorplanStore64_getState_layout_floors : [];
    var index = floors.findIndex(function(f) {
        return f.id === floorId;
    });
    if (index < 0) return null;
    var design = findLatestDesign27(floors[index].designs);
    return (design === null || design === void 0 ? void 0 : design.items.some(function(i) {
        return i.refid === refid && isLive15(i);
    })) ? index : null;
};
var FIRST_CONTROL2 = "button:not([disabled])";
var PARENT_ROW2 = "parent";
var CAPACITY_ROW2 = "capacity";
var CUSTOMER_ID_ROW = "customer-id";
var SOURCE_ID_ROW = "source-id";
var Body6 = styled60.div(_templateObject218(), space28[3]);
var Foot2 = styled60.div(_templateObject219());
var LinkOrAdd = styled60.div(_templateObject220(), inset11[2]);
var catalogueProduct = function(entry) {
    var _entry_product_line, _entry_manufacturer_name, _entry_model_file;
    return {
        referenceId: entry.entity_bid,
        product: entry.model_name,
        productLine: ((_entry_product_line = entry.product_line) === null || _entry_product_line === void 0 ? void 0 : _entry_product_line.trim()) || null,
        manufacturer: ((_entry_manufacturer_name = entry.manufacturer_name) === null || _entry_manufacturer_name === void 0 ? void 0 : _entry_manufacturer_name.trim()) || null,
        capacity: null,
        hasModel: !!((_entry_model_file = entry.model_file) === null || _entry_model_file === void 0 ? void 0 : _entry_model_file.trim())
    };
};
var identifyOf = function(row) {
    var _row_match_proposal;
    if (!row) return null;
    var state = assetIdentityState(row);
    if (state !== "to_identify" && state !== "to_confirm" && state !== "generic") return null;
    var _row_match_proposal_reference_id;
    return {
        state: state,
        proposalReferenceId: (_row_match_proposal_reference_id = (_row_match_proposal = row.match_proposal) === null || _row_match_proposal === void 0 ? void 0 : _row_match_proposal.reference_id) !== null && _row_match_proposal_reference_id !== void 0 ? _row_match_proposal_reference_id : null
    };
};
var MachineCard = function(param) {
    var twinBid = param.twinBid, twinId = param.twinId, product = param.product, toastRegion = param.toastRegion, modelPreview = param.modelPreview, variationOf = param.variationOf;
    var _item_name, _nameWrite_failure, _model_parent;
    var model = useMachineCardModel(twinBid, twinId);
    var item = model.item, itemRegister = model.itemRegister, row = model.row, registerRead = model.registerRead, registerRows = model.registerRows, selectionKey = model.selectionKey;
    var checksModel = usePlanChecksContext();
    var _item_refid;
    var held = useHeldEntityChecks(model.floorId, "item", (_item_refid = item === null || item === void 0 ? void 0 : item.refid) !== null && _item_refid !== void 0 ? _item_refid : null, selectionKey);
    var byReference = useManufacturerCatalogStore2(function(s) {
        return s.byReference;
    });
    var updateItem = useFloorplanStore64(function(s) {
        return s.updateItem;
    });
    var markEntityModified = useEditorStore58(function(s) {
        return s.markEntityModified;
    });
    var pushSnapshot = useEditorStore58(function(s) {
        return s.pushSnapshot;
    });
    var createRegisterAsset = useEquipmentCatalogStore25(function(s) {
        return s.createRegisterAsset;
    });
    var updateRegisterAsset = useEquipmentCatalogStore25(function(s) {
        return s.updateRegisterAsset;
    });
    var announcer = useCardAnnouncer();
    var ids = useId8();
    var nameWrite = useItemRegisterWrite({
        item: item,
        row: itemRegister.kind === "backed" ? itemRegister.row : null,
        selectionKey: selectionKey
    });
    var nameCommit = useItemNameCommit({
        entity: item,
        itemRegister: itemRegister,
        nameIndex: model.nameIndex,
        nameSelf: model.nameSelf,
        selectionKey: selectionKey,
        registerWrite: nameWrite
    });
    var customerId = useRegisterFieldCommit({
        field: "customerId",
        column: "customer_asset_identifier",
        item: item,
        row: row,
        selectionKey: selectionKey
    });
    var sourceId = useRegisterFieldCommit({
        field: "sourceId",
        column: "source_asset_id",
        item: item,
        row: row,
        selectionKey: selectionKey
    });
    var registerLink = useRegisterLink({
        item: item,
        itemRegister: itemRegister,
        registerRead: registerRead,
        registerRows: registerRows,
        layout: model.layout,
        twinBid: twinBid,
        selectionKey: selectionKey,
        floorIndex: model.floorIndex
    });
    var _useState56 = _sliced_to_array(useState56(null), 2), adding = _useState56[0], setAdding = _useState56[1];
    var _useState561 = _sliced_to_array(useState56(null), 2), addFailure = _useState561[0], setAddFailure = _useState561[1];
    var _useState562 = _sliced_to_array(useState56(null), 2), editingRow = _useState562[0], setEditingRow = _useState562[1];
    var editing = (editingRow === null || editingRow === void 0 ? void 0 : editingRow.key) === selectionKey ? editingRow.row : null;
    var editingFor = function(which) {
        return function(open) {
            return setEditingRow(function(current2) {
                return open ? selectionKey ? {
                    key: selectionKey,
                    row: which
                } : null : (current2 === null || current2 === void 0 ? void 0 : current2.row) === which && current2.key === selectionKey ? null : current2;
            });
        };
    };
    var unknownId = "".concat(ids, "-unknown");
    var addHelpId = "".concat(ids, "-add-help");
    var addErrorId = "".concat(ids, "-add-error");
    var needsRowId = "".concat(ids, "-needs-row");
    var notInCatalogueId = "".concat(ids, "-not-in-catalogue");
    var parentHelpId = "".concat(ids, "-parent-help");
    var _useMemo35 = useMemo35(function() {
        var options = registerLink.candidates.map(function(candidate) {
            return {
                value: candidate.assetUid,
                label: candidate.label,
                meta: [
                    candidate.customerId,
                    candidate.sourceId,
                    candidate.product
                ].map(function(part) {
                    return part !== null && part !== void 0 ? part : "\u2014";
                }).join(" \xB7 "),
                group: linkGroupLabel(registerLink.candidates.length),
                icon: /* @__PURE__ */ jsx79(Icon31, {
                    name: "dumbbell",
                    size: "xs"
                }),
                trailing: /* @__PURE__ */ jsx79(MenuTrailingLabel2, {
                    tone: "lav",
                    children: NOT_ON_PLAN
                }),
                trailingText: NOT_ON_PLAN
            };
        });
        var lookup = new Map(registerLink.candidates.map(function(c) {
            return [
                c.assetUid,
                c
            ];
        }));
        return {
            linkOptions: options,
            byUid: lookup
        };
    }, [
        registerLink.candidates
    ]), linkOptions = _useMemo35.linkOptions, byUid = _useMemo35.byUid;
    var linkFilter = useCallback30(function(option, query) {
        var candidate = byUid.get(option.value);
        return candidate ? linkCandidateMatches(candidate, query) : false;
    }, [
        byUid
    ]);
    var cardRef = useRef60(null);
    var bodyRef = useRef60(null);
    var issuesRef = useRef60(null);
    var copyRef = useRef60(null);
    var productRef = useRef60(null);
    var focusAfter = useRef60(null);
    var opener = useRef60(null);
    var returnFocusTo = useMemo35(function() {
        return {
            get current () {
                var _opener_current;
                if ((_opener_current = opener.current) === null || _opener_current === void 0 ? void 0 : _opener_current.isConnected) return opener.current;
                return document.querySelector(PLAN_PANE2);
            }
        };
    }, []);
    useEffect61(function() {
        var _cardRef_current, _bodyRef_current_querySelector, _bodyRef_current;
        if (!selectionKey) return;
        var active = document.activeElement;
        if (!active || active === document.body) return;
        if ((_cardRef_current = cardRef.current) === null || _cardRef_current === void 0 ? void 0 : _cardRef_current.contains(active)) return;
        opener.current = _instanceof(active, HTMLElement) ? active : null;
        if (active.closest(PLAN_PANE2)) return;
        (_bodyRef_current = bodyRef.current) === null || _bodyRef_current === void 0 ? void 0 : (_bodyRef_current_querySelector = _bodyRef_current.querySelector(FIRST_CONTROL2)) === null || _bodyRef_current_querySelector === void 0 ? void 0 : _bodyRef_current_querySelector.focus();
    }, [
        selectionKey
    ]);
    useEffect61(function() {
        var _bodyRef_current, _cardRef_current;
        var after = focusAfter.current;
        if (!after) return;
        focusAfter.current = null;
        var rowAction = after.row ? (_bodyRef_current = bodyRef.current) === null || _bodyRef_current === void 0 ? void 0 : _bodyRef_current.querySelector('button[data-override-row="'.concat(after.row, '"]:not([disabled])')) : null;
        var _after_next, _ref, _ref1, _ref2;
        var target = (_ref2 = (_ref1 = (_ref = rowAction !== null && rowAction !== void 0 ? rowAction : firstFixAfter(issuesRef.current, (_after_next = after.next) !== null && _after_next !== void 0 ? _after_next : [])) !== null && _ref !== void 0 ? _ref : copyRef.current) !== null && _ref1 !== void 0 ? _ref1 : (_cardRef_current = cardRef.current) === null || _cardRef_current === void 0 ? void 0 : _cardRef_current.querySelector("[data-card-done]")) !== null && _ref2 !== void 0 ? _ref2 : null;
        target === null || target === void 0 ? void 0 : target.focus();
    });
    var polite = announcer.polite;
    var showHolderFromCard = useCallback30(function(holder) {
        var said = showHolder(holder);
        if (said) polite(said);
    }, [
        polite
    ]);
    var linkSaid = registerLink.announcement;
    useEffect61(function() {
        if (linkSaid) polite(linkSaid);
    }, [
        linkSaid,
        polite
    ]);
    var backed = itemRegister.kind === "backed";
    var unknown = itemRegister.kind === "unknown";
    var _item_name1;
    var storedName = backed ? nameCommit.storedName : (_item_name1 = item === null || item === void 0 ? void 0 : item.name) !== null && _item_name1 !== void 0 ? _item_name1 : "";
    var title = (item === null || item === void 0 ? void 0 : (_item_name = item.name) === null || _item_name === void 0 ? void 0 : _item_name.trim()) || "Machine";
    var snapshot = function() {
        var layout = useFloorplanStore64.getState().layout;
        if (layout) pushSnapshot(layout);
    };
    var shownKey = useRef60(selectionKey);
    shownKey.current = selectionKey;
    var commitName = function(typed) {
        if (!item || unknown) return "unchanged";
        if (backed) {
            nameWrite.lastFailure.current = null;
            var forKey = selectionKey;
            return nameCommit.commit(typed).then(function() {
                var failed = nameWrite.lastFailure.current;
                if (!failed || failed.field !== "name") return "landed";
                if (shownKey.current === forKey) nameWrite.clearFailure();
                var offer = typed !== "" && isNameTaken6(typed, model.nameIndex, model.nameSelf) ? nextFreeName6(typed, model.nameIndex) : void 0;
                return {
                    refused: failed.message,
                    offer: offer
                };
            });
        }
        if (typed !== "" && isNameTaken6(typed, model.nameIndex, model.nameSelf)) {
            var offer = nextFreeName6(typed, model.nameIndex);
            return {
                refused: takenNameMessage(offer),
                offer: offer
            };
        }
        snapshot();
        updateItem(item.refid, {
            name: typed
        }, {
            floorIndex: model.floorIndex
        });
        markEntityModified(item.refid);
        return "landed";
    };
    var standingName = ((_nameWrite_failure = nameWrite.failure) === null || _nameWrite_failure === void 0 ? void 0 : _nameWrite_failure.field) === "name" ? nameWrite.failure.message : void 0;
    var nameEditor = useNameEditor({
        selectionKey: selectionKey,
        name: storedName,
        title: title,
        nameIndex: model.nameIndex,
        nameSelf: model.nameSelf,
        onCommit: commitName,
        announce: announcer,
        busy: nameWrite.isWriting,
        standing: standingName,
        onOpen: function() {
            if (standingName) nameWrite.clearFailure();
        },
        disabledReason: itemRegister.kind === "unknown" ? UNKNOWN_REGISTER_REASON[itemRegister.reason] : void 0
    });
    var kindFor = useRef60({
        key: null,
        kind: ""
    });
    var penRef = nameEditor.penRef;
    useLayoutEffect12(function() {
        var _cardRef_current, _penRef_current;
        var was = kindFor.current;
        kindFor.current = {
            key: selectionKey,
            kind: itemRegister.kind
        };
        if (was.key !== selectionKey || was.kind === itemRegister.kind) return;
        if (itemRegister.kind !== "backed") return;
        var active = document.activeElement;
        if (active && active !== document.body && ((_cardRef_current = cardRef.current) === null || _cardRef_current === void 0 ? void 0 : _cardRef_current.contains(active))) return;
        (_penRef_current = penRef.current) === null || _penRef_current === void 0 ? void 0 : _penRef_current.focus();
    });
    var noRow = itemRegister.kind === "legacy" || itemRegister.kind === "orphan";
    var registerUnread = unknown ? itemRegister.reason : noRow && registerRead !== "ready" ? registerRead : null;
    var unreadValue = registerUnread ? registerUnread === "loading" ? readingRegisterNote("loading") : NOT_SET : void 0;
    var noRowReasonId = registerUnread ? unknownId : needsRowId;
    var capacity = useMachineCapacityRow({
        item: item,
        row: row,
        selectionKey: selectionKey,
        editing: editing === CAPACITY_ROW2,
        onEditingChange: editingFor(CAPACITY_ROW2),
        announce: announcer,
        helpId: "".concat(ids, "-capacity-help"),
        reasonId: noRowReasonId,
        container: bodyRef
    });
    var _row_customer_asset_identifier;
    var customerRow = useRegisterIdRow({
        id: CUSTOMER_ID_ROW,
        label: "Customer asset ID",
        penLabel: EDIT_CUSTOMER_ID,
        help: CUSTOMER_ID_HELP,
        field: customerId,
        stored: (_row_customer_asset_identifier = row === null || row === void 0 ? void 0 : row.customer_asset_identifier) !== null && _row_customer_asset_identifier !== void 0 ? _row_customer_asset_identifier : "",
        selectionKey: selectionKey,
        hasRow: !!row,
        unreadValue: unreadValue,
        editing: editing === CUSTOMER_ID_ROW,
        onEditingChange: editingFor(CUSTOMER_ID_ROW),
        announce: announcer,
        helpId: "".concat(ids, "-customer-help"),
        container: bodyRef
    });
    var _row_source_asset_id;
    var sourceRow = useRegisterIdRow({
        id: SOURCE_ID_ROW,
        label: "Source asset ID",
        penLabel: EDIT_SOURCE_ID,
        help: SOURCE_ID_HELP,
        field: sourceId,
        stored: (_row_source_asset_id = row === null || row === void 0 ? void 0 : row.source_asset_id) !== null && _row_source_asset_id !== void 0 ? _row_source_asset_id : "",
        selectionKey: selectionKey,
        hasRow: !!row,
        unreadValue: unreadValue,
        editing: editing === SOURCE_ID_ROW,
        onEditingChange: editingFor(SOURCE_ID_ROW),
        announce: announcer,
        helpId: "".concat(ids, "-source-help"),
        container: bodyRef
    });
    var _model_floorName;
    var parent = item ? parentChoices({
        design: model.design,
        floorName: (_model_floorName = model.floorName) !== null && _model_floorName !== void 0 ? _model_floorName : void 0,
        parentage: model.parentage,
        hierarchy: model.hierarchy,
        surface: null,
        item: item,
        keepKind: true
    }) : null;
    var placeName = function(refid) {
        return parentName({
            design: model.design,
            hierarchy: model.hierarchy,
            floorName: model.floorName,
            refid: refid
        }).text;
    };
    var registerLine = unknown ? UNKNOWN_REGISTER_REASON[itemRegister.reason] : registerUnread ? readingRegisterNote(registerUnread) : null;
    var _parent_current;
    var lines = item ? itemIssueLines(held.checks, registerUnread ? null : identifyOf(row), {
        parentName: placeName,
        chosenParent: (_parent_current = parent === null || parent === void 0 ? void 0 : parent.current) !== null && _parent_current !== void 0 ? _parent_current : null,
        rowHasProduct: !!(row === null || row === void 0 ? void 0 : row.reference_id)
    }) : [];
    var issueCount = lines.length;
    var lastCount = useRef60({
        key: null,
        n: null
    });
    useEffect61(function() {
        if (held.held !== "settled" || held.failed || registerUnread) return;
        var last = lastCount.current;
        if (last.key === selectionKey && last.n !== null && last.n !== issueCount) {
            polite(issueCountTag(issueCount));
        }
        lastCount.current = {
            key: selectionKey,
            n: issueCount
        };
    }, [
        held.held,
        held.failed,
        registerUnread,
        issueCount,
        selectionKey,
        polite
    ]);
    if (!item || !selectionKey || !parent) return null;
    var close = function() {
        return useEditorStore58.getState().clearSelection();
    };
    var bid = displayBid(twinBid, item.entityCode);
    var addToRegister = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var _useFloorplanStore64_getState_layout_floors_model_floorIndex, _useFloorplanStore64_getState_layout, forRefid, forFloorId, modelFile, created, assetUid, forFloor, modelError, message, error, unknownOutcome, message1;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (adding) return [
                            2
                        ];
                        forRefid = item.refid;
                        forFloorId = (_useFloorplanStore64_getState_layout = useFloorplanStore64.getState().layout) === null || _useFloorplanStore64_getState_layout === void 0 ? void 0 : (_useFloorplanStore64_getState_layout_floors_model_floorIndex = _useFloorplanStore64_getState_layout.floors[model.floorIndex]) === null || _useFloorplanStore64_getState_layout_floors_model_floorIndex === void 0 ? void 0 : _useFloorplanStore64_getState_layout_floors_model_floorIndex.id;
                        modelFile = item.modelFile;
                        setAdding(forRefid);
                        setAddFailure(null);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            9
                        ]);
                        return [
                            4,
                            createRegisterAsset(_object_spread({
                                name: title
                            }, bid ? {
                                entityCode: bid
                            } : {}, modelFile ? {
                                modelFile: modelFile
                            } : {}))
                        ];
                    case 2:
                        created = _state.sent();
                        assetUid = normaliseAssetUid6(created.id);
                        forFloor = liveFloorIndexOf(forRefid, forFloorId);
                        if (assetUid !== void 0 && forFloor !== null) {
                            updateItem(forRefid, {
                                assetUid: assetUid
                            }, {
                                floorIndex: forFloor
                            });
                            markEntityModified(forRefid);
                        }
                        announcer.polite("Added to the register.");
                        if (!(!bid && modelFile && !created.model_3d)) return [
                            3,
                            6
                        ];
                        _state.label = 3;
                    case 3:
                        _state.trys.push([
                            3,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4,
                            updateRegisterAsset(created.id, {
                                model_3d: modelFile
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 5:
                        modelError = _state.sent();
                        message = "Added to the register, but its 3D model could not be set: ".concat(_instanceof(modelError, Error) && modelError.message ? modelError.message : "the change could not be saved.");
                        setAddFailure({
                            refid: forRefid,
                            unknownOutcome: false,
                            message: message
                        });
                        announcer.alert(message);
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            3,
                            9
                        ];
                    case 7:
                        error = _state.sent();
                        unknownOutcome = isOutcomeUnconfirmed2(error);
                        console.error("[machine-card] create failed", {
                            status: error === null || error === void 0 ? void 0 : error.status,
                            unknownOutcome: unknownOutcome
                        });
                        message1 = unknownOutcome ? bid ? "The request timed out. The row may already have been added; trying again cannot add a second one." : "The request timed out. The row may already have been added. Reload the page and check the register before trying again." : _instanceof(error, Error) && error.message ? error.message : "The row could not be added.";
                        setAddFailure({
                            refid: forRefid,
                            unknownOutcome: unknownOutcome,
                            message: message1
                        });
                        announcer.alert(message1);
                        return [
                            3,
                            9
                        ];
                    case 8:
                        setAdding(function(current2) {
                            return current2 === forRefid ? null : current2;
                        });
                        return [
                            7
                        ];
                    case 9:
                        return [
                            2
                        ];
                }
            });
        });
        return function addToRegister() {
            return _ref.apply(this, arguments);
        };
    }();
    var addError = (addFailure === null || addFailure === void 0 ? void 0 : addFailure.refid) === item.refid ? addFailure : null;
    var addBlocked = !!(addError === null || addError === void 0 ? void 0 : addError.unknownOutcome) && !bid;
    var registerKnown = registerRead === "ready";
    var renderLinkOrAdd = function() {
        return /* @__PURE__ */ jsxs53(LinkOrAdd, {
            children: [
                /* @__PURE__ */ jsx79(Combobox3, {
                    size: "sm",
                    searchGlyph: true,
                    "aria-label": LINK_TO_REGISTER_ROW,
                    options: linkOptions,
                    filter: linkFilter,
                    maxResults: Infinity,
                    commitOnClose: false,
                    emptyText: LINK_EMPTY,
                    placeholder: LINK_PLACEHOLDER,
                    disabled: !registerLink.canOffer,
                    "aria-describedby": unknown || !registerKnown ? unknownId : void 0,
                    onChange: function(value) {
                        var chosen = value ? byUid.get(value) : void 0;
                        if (chosen) registerLink.link(chosen);
                    }
                }, item.refid),
                /* @__PURE__ */ jsx79(Button27, {
                    type: "button",
                    variant: "frosted",
                    tone: "brand",
                    size: "xs",
                    iconLeft: /* @__PURE__ */ jsx79(Icon31, {
                        name: "plus",
                        size: "xs"
                    }),
                    "data-fix": "link-or-add",
                    loading: adding === item.refid,
                    disabled: unknown || addBlocked || !registerKnown,
                    "aria-describedby": [
                        addHelpId,
                        addError ? addErrorId : null,
                        unknown || !registerKnown ? unknownId : null
                    ].filter(Boolean).join(" "),
                    onClick: function() {
                        return void addToRegister();
                    },
                    children: ADD_TO_REGISTER
                }),
                /* @__PURE__ */ jsx79(Note5, {
                    tone: "neutral",
                    bare: true,
                    id: addHelpId,
                    children: ADD_TO_REGISTER_HELPER
                })
            ]
        });
    };
    var chosenByHand = !!item.parentChosen;
    var shownParent = parentName({
        design: model.design,
        hierarchy: model.hierarchy,
        floorName: model.floorName,
        refid: parent.current
    });
    var closeParent = function(refocus) {
        editingFor(PARENT_ROW2)(false);
        if (refocus) focusAfter.current = {
            row: PARENT_ROW2
        };
    };
    var applyDrawnParent = function() {
        restoreDrawnParentFor({
            item: item,
            floorIndex: model.floorIndex
        }, parent.spatialParent);
        announcer.polite(SAVED);
        closeParent(true);
    };
    var parentRow = parentLineRow({
        id: PARENT_ROW2,
        editing: editing === PARENT_ROW2,
        chosenByHand: chosenByHand,
        shown: shownParent,
        options: nameOnlyParentOptions({
            options: parent.options,
            design: model.design,
            hierarchy: model.hierarchy,
            floorName: model.floorName
        }),
        current: parent.current,
        helpId: parentHelpId,
        onOpen: function() {
            return editingFor(PARENT_ROW2)(true);
        },
        onClose: closeParent,
        onChoose: function(value) {
            if (chooseParentFor({
                item: item,
                floorIndex: model.floorIndex
            }, {
                value: value,
                current: parent.current
            })) announcer.polite(SAVED);
        },
        onUseDrawing: applyDrawnParent
    });
    var confirmable = function(referenceId) {
        return byReference.get(referenceId);
    };
    var fixState = function(fix) {
        switch(fix.kind){
            case "confirm-product":
                return confirmable(fix.referenceId) && product && row ? void 0 : {
                    disabled: true,
                    describedBy: confirmable(fix.referenceId) ? void 0 : notInCatalogueId
                };
            case "identify":
            case "change-product":
                return product && row ? void 0 : {
                    disabled: true
                };
            case "set-capacity":
                return row ? void 0 : {
                    disabled: true,
                    describedBy: noRowReasonId
                };
            default:
                return void 0;
        }
    };
    var onFix = function(fix, line3) {
        switch(fix.kind){
            case "rename":
                nameEditor.open(fix.suggestion);
                return;
            case "keep-parent":
                keepChosenFor({
                    item: item,
                    floorIndex: model.floorIndex
                }, parent.spatialParent);
                announcer.polite(SAVED);
                focusAfter.current = {
                    row: PARENT_ROW2,
                    next: issueKeysAfter(issuesRef.current, line3.key)
                };
                return;
            case "use-drawing":
                restoreDrawnParentFor({
                    item: item,
                    floorIndex: model.floorIndex
                }, parent.spatialParent);
                announcer.polite(SAVED);
                focusAfter.current = {
                    row: PARENT_ROW2,
                    next: issueKeysAfter(issuesRef.current, line3.key)
                };
                return;
            case "change-parent":
                editingFor(PARENT_ROW2)(true);
                return;
            case "set-capacity":
                capacity.open();
                return;
            case "identify":
            case "change-product":
                var _productRef_current;
                (_productRef_current = productRef.current) === null || _productRef_current === void 0 ? void 0 : _productRef_current.openPicker();
                return;
            case "confirm-product":
                {
                    var entry = confirmable(fix.referenceId);
                    if (!entry || !productRef.current) return;
                    var next = issueKeysAfter(issuesRef.current, line3.key);
                    void productRef.current.take(fix.referenceId, catalogueProduct(entry)).then(function(outcome) {
                        if (outcome !== "changed" && outcome !== "moved") return;
                        announcer.polite(SAVED);
                        focusAfter.current = {
                            next: next
                        };
                    });
                    return;
                }
            default:
                focusAfter.current = {
                    next: issueKeysAfter(issuesRef.current, line3.key)
                };
        }
    };
    var tag = registerUnread === "loading" ? {
        kind: "checking"
    } : registerUnread ? {
        kind: "unavailable"
    } : bidRowTag({
        hasModel: !!checksModel,
        held: held.held,
        failed: held.failed,
        count: issueCount
    });
    var footer = /* @__PURE__ */ jsxs53(Foot2, {
        children: [
            /* @__PURE__ */ jsx79(Button27, {
                variant: "text",
                tone: "destructive",
                iconLeft: /* @__PURE__ */ jsx79(Icon31, {
                    name: "trash-can"
                }),
                onClick: function() {
                    return useEditorStore58.getState().requestItemDelete(item.refid, {
                        floorIndex: model.floorIndex
                    });
                },
                children: "Delete Machine"
            }),
            /* @__PURE__ */ jsx79(Button27, {
                variant: "primary",
                size: "inline",
                "data-card-done": true,
                onClick: close,
                children: "Done"
            })
        ]
    });
    var variation = (row === null || row === void 0 ? void 0 : row.reference_id) ? variationOf === null || variationOf === void 0 ? void 0 : variationOf(row.reference_id) : void 0;
    var _model_parent_name, _nameEditor_sub;
    return /* @__PURE__ */ jsx79(DockedCard2, {
        ref: cardRef,
        "data-planner-shortcuts": "off",
        "data-testid": "machine-card",
        tone: "butter",
        placement: "inset",
        headingLevel: 3,
        icon: /* @__PURE__ */ jsx79(Icon31, {
            name: "dumbbell"
        }),
        title: title,
        titleAction: nameEditor.pen,
        titleEditor: nameEditor.editor,
        sub: (_nameEditor_sub = nameEditor.sub) !== null && _nameEditor_sub !== void 0 ? _nameEditor_sub : machineSubLine({
            variation: variation,
            parentName: (_model_parent_name = (_model_parent = model.parent) === null || _model_parent === void 0 ? void 0 : _model_parent.name) !== null && _model_parent_name !== void 0 ? _model_parent_name : null,
            floorName: model.floorName,
            onFloor: model.parent === null
        }),
        onClose: close,
        closeLabel: "Close",
        returnFocusTo: returnFocusTo,
        footer: footer,
        children: /* @__PURE__ */ jsxs53(Body6, {
            ref: bodyRef,
            children: [
                /* @__PURE__ */ jsx79(BidRow, {
                    bid: bid,
                    copyRef: copyRef,
                    announce: announcer.polite,
                    tag: tag
                }),
                /* @__PURE__ */ jsx79(ItemIssues, {
                    lines: lines,
                    name: title,
                    onFix: onFix,
                    fixState: fixState,
                    renderLinkOrAdd: renderLinkOrAdd,
                    listRef: issuesRef,
                    onShowHolder: showHolderFromCard
                }),
                registerLine && /* @__PURE__ */ jsx79(Note5, {
                    tone: "neutral",
                    id: unknownId,
                    "data-testid": "register-line",
                    children: registerLine
                }),
                addError && /* @__PURE__ */ jsx79(Note5, {
                    tone: "error",
                    id: addErrorId,
                    children: addError.message
                }),
                /* @__PURE__ */ jsx79(MachineProductBlock, {
                    ref: productRef,
                    item: item,
                    row: row,
                    host: product,
                    toastRegion: toastRegion,
                    modelPreview: modelPreview
                }, item.refid),
                /* @__PURE__ */ jsx79(OverrideRows2, {
                    density: "line",
                    rows: [
                        parentRow,
                        capacity.row,
                        customerRow,
                        sourceRow
                    ]
                }),
                /* @__PURE__ */ jsxs53("span", {
                    hidden: true,
                    children: [
                        /* @__PURE__ */ jsx79("span", {
                            id: needsRowId,
                            children: NEEDS_REGISTER_ROW
                        }),
                        /* @__PURE__ */ jsx79("span", {
                            id: notInCatalogueId,
                            children: PRODUCT_NOT_IN_CATALOGUE
                        })
                    ]
                }),
                announcer.regions
            ]
        })
    });
};
export { CARRY_SETTINGS, CONE_STYLES, DEFAULT_THICKNESS, DRAG_DISTANCE, DROP_PREVIEW_CONE_STYLE, EquipmentCategoryList, EquipmentSidebar, FAINT_FLOOR_OPACITY, FULL_RENDERER_SUPPORT, FloorTabs, HANDLE_STYLES, KNOB_GAP_SCREEN_PX, MAX_ZOOM, MIN_ZOOM, MachineCard, NAME_TAG, NO_PLAN_MACHINE_FOOTPRINTS, PLAN_CAMERA_LEGEND, PLAN_ENTITY_LEGEND, PLAN_MACHINE_FADING_GLOW, PLAN_MACHINE_HOVER, PLAN_MACHINE_MARKS, PLAN_MACHINE_OUTLINE, PLAN_MACHINE_SELECTION, PLAN_MACHINE_TURN_RING, PLAN_PANE_SCROLL_LANE, PLAN_SELECTION_COLOUR, PLAN_SPACE_HOVER, PLAN_SPACE_JUMP_GLOW, PLAN_SPACE_OUTLINES, PLAN_SPACE_SELECTION, PLAN_VIEW_PADDING_PX, POINTER_DRAG_CARRYING_CLASS, POINT_MARKER_LOOK, POINT_MARKER_SIZE, PRESS_CLICK_TOLERANCE_PX, PlanCameraLegendEntry, PlanConeSwatch, PlanEdgeHandle, PlanEntityLegendEntry, PlanGlyphDisc, PlanLegend, PlanLegendBar, PlanMachineFootprintsProvider, PlanMachineMarks, PlanMarkSwatch, PlanSpaceChangeMarks, PlanViewProvider, PlannerCanvasFrame, PlannerCanvasRendererProvider, PointMarker, REVEAL_MARGIN_PX, ROTATE_HIT_RADIUS_SCREEN_PX, ReadOnlyCanvas, ReadOnlyCanvasRendererProvider, ReadOnlyPlanFrame, ReadOnlyPlanMarkers, ReadOnlyPlanPointMarkers, SCALE_LINE_COLOR, SHADOW_RING_GROWTH, SHADOW_RING_SHARES, SHRINK_S, SMALL_GLASS_PADDING, SPACE_STYLES, STREAM_DRAG_TYPE, TwinPlanner, WHEEL_STEP, applyCameraPreview, centroidPx, checksToDo, clampViewZoom, commitMachineMove, commitMachineTurn, commitMachinesMove, commitMachinesTurn, commitSpaceCornerMove, commitWallEndMove, coneLook, createCarry, domGesturePane, edgeCursorFor, effectiveViewRotation, findUnderlay, floorHandleOwner, floorHandles, floorHandlesOf, floorMovedSentence, floorRotatedSentence, glassSurface, glassSurfaceHover, insertCornerAtMidpoint, isClickRelease, isUsablePlanView, linkCandidateMatches, machineTurnReach, machineTurnRing, nudgeAnnouncement, orderCones, planMachineAppearance, planMachineMarks, planSpaceAppearance, planSpaceChangeMarks, planSpaceFill, planViewFit, theme_default as plannerTheme, pressPans, pressTargetAt, reachReadout, removeSpaceCorner, reshapeModifierHeld, revealShift, runPlacementEdit, runUnderlayEdit, scaleLineLabel, seedFor, selectUnderlayOnFloor, smallGlassCss, spaceLook, staggerGapMs, startFloorDrag, startPaneEdgeDrag, startPaneGesture, startUnderlayDrag, turnReadout, underlayKnobOwner, underlayTurnHandle, useArmedEdge, useCameraNameCommit, useCameraPreview, useDrawnReport, useFloorPlacementView, useFloorTurn, useLivePlanView, usePdfImport, usePlanDrops, usePlanMachineFootprints, usePlanSceneDriver, usePlanView, usePlannerCanvasModel, useKeyboardShortcuts as usePlannerKeyboardShortcuts, usePlannerRendererSupport, usePolygonDraw, usePublishWallSnap, useReadOnlyPlanView, useRegisterPlanSync, useReshapeModifier, useRotateGesture, useScaleLineDraw, useSelectedUnderlay, useStreamDragPoint, useUnderlayTurn, useUnderlayView, useWallDraw, wallEndJoint, wallEndsShownFor, wallSnapContextFor, wallsCenterOf };
